(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire72c9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire72c9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aD5QK", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $7bd215913159ea08$export$882461b6382ed46c; }, function (v) { return $7bd215913159ea08$export$882461b6382ed46c = v; });
var $7bd215913159ea08$export$882461b6382ed46c;
var $7bd215913159ea08$export$757ceba2d55c277e;
"use strict";

var $d2lNW = parcelRequire("d2lNW");
var $7bd215913159ea08$var$i;
$7bd215913159ea08$export$882461b6382ed46c = $d2lNW.createRoot;
$7bd215913159ea08$export$757ceba2d55c277e = $d2lNW.hydrateRoot;

});
parcelRegister("d2lNW", function(module, exports) {
"use strict";
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

module.exports = (parcelRequire("h8vP0"));

});
parcelRegister("h8vP0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c79bde28d689cb05$export$ae55be85d98224ed; }, function (v) { return $c79bde28d689cb05$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c79bde28d689cb05$export$d39a5bbd09211389; }, function (v) { return $c79bde28d689cb05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c79bde28d689cb05$export$882461b6382ed46c; }, function (v) { return $c79bde28d689cb05$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c79bde28d689cb05$export$466bfc07425424d5; }, function (v) { return $c79bde28d689cb05$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c79bde28d689cb05$export$cd75ccfd720a3cd4; }, function (v) { return $c79bde28d689cb05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c79bde28d689cb05$export$fa8d919ba61d84db; }, function (v) { return $c79bde28d689cb05$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c79bde28d689cb05$export$757ceba2d55c277e; }, function (v) { return $c79bde28d689cb05$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c79bde28d689cb05$export$b3890eb0ae9dca99; }, function (v) { return $c79bde28d689cb05$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c79bde28d689cb05$export$502457920280e6be; }, function (v) { return $c79bde28d689cb05$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c79bde28d689cb05$export$c78a37762a8d58e1; }, function (v) { return $c79bde28d689cb05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c79bde28d689cb05$export$dc54d992c10e8a18; }, function (v) { return $c79bde28d689cb05$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c79bde28d689cb05$export$83d89fbfd8236492; }, function (v) { return $c79bde28d689cb05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c79bde28d689cb05$export$ae55be85d98224ed;
var $c79bde28d689cb05$export$d39a5bbd09211389;
var $c79bde28d689cb05$export$882461b6382ed46c;
var $c79bde28d689cb05$export$466bfc07425424d5;
var $c79bde28d689cb05$export$cd75ccfd720a3cd4;
var $c79bde28d689cb05$export$fa8d919ba61d84db;
var $c79bde28d689cb05$export$757ceba2d55c277e;
var $c79bde28d689cb05$export$b3890eb0ae9dca99;
var $c79bde28d689cb05$export$502457920280e6be;
var $c79bde28d689cb05$export$c78a37762a8d58e1;
var $c79bde28d689cb05$export$dc54d992c10e8a18;
var $c79bde28d689cb05$export$83d89fbfd8236492;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ibqfJ = parcelRequire("ibqfJ");
function $c79bde28d689cb05$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c79bde28d689cb05$var$da = new Set, $c79bde28d689cb05$var$ea = {};
function $c79bde28d689cb05$var$fa(a, b) {
    $c79bde28d689cb05$var$ha(a, b);
    $c79bde28d689cb05$var$ha(a + "Capture", b);
}
function $c79bde28d689cb05$var$ha(a, b) {
    $c79bde28d689cb05$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$da.add(b[a]);
}
var $c79bde28d689cb05$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c79bde28d689cb05$var$ja = Object.prototype.hasOwnProperty, $c79bde28d689cb05$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c79bde28d689cb05$var$la = {}, $c79bde28d689cb05$var$ma = {};
function $c79bde28d689cb05$var$oa(a) {
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$ma, a)) return !0;
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$la, a)) return !1;
    if ($c79bde28d689cb05$var$ka.test(a)) return $c79bde28d689cb05$var$ma[a] = !0;
    $c79bde28d689cb05$var$la[a] = !0;
    return !1;
}
function $c79bde28d689cb05$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c79bde28d689cb05$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c79bde28d689cb05$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c79bde28d689cb05$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c79bde28d689cb05$var$ra = /[\-:]([a-z])/g;
function $c79bde28d689cb05$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c79bde28d689cb05$var$z.xlinkHref = new $c79bde28d689cb05$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c79bde28d689cb05$var$ta(a, b, c, d) {
    var e = $c79bde28d689cb05$var$z.hasOwnProperty(b) ? $c79bde28d689cb05$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c79bde28d689cb05$var$qa(b, c, e, d) && (c = null), d || null === e ? $c79bde28d689cb05$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c79bde28d689cb05$var$ua = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c79bde28d689cb05$var$va = Symbol.for("react.element"), $c79bde28d689cb05$var$wa = Symbol.for("react.portal"), $c79bde28d689cb05$var$ya = Symbol.for("react.fragment"), $c79bde28d689cb05$var$za = Symbol.for("react.strict_mode"), $c79bde28d689cb05$var$Aa = Symbol.for("react.profiler"), $c79bde28d689cb05$var$Ba = Symbol.for("react.provider"), $c79bde28d689cb05$var$Ca = Symbol.for("react.context"), $c79bde28d689cb05$var$Da = Symbol.for("react.forward_ref"), $c79bde28d689cb05$var$Ea = Symbol.for("react.suspense"), $c79bde28d689cb05$var$Fa = Symbol.for("react.suspense_list"), $c79bde28d689cb05$var$Ga = Symbol.for("react.memo"), $c79bde28d689cb05$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c79bde28d689cb05$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c79bde28d689cb05$var$Ja = Symbol.iterator;
function $c79bde28d689cb05$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c79bde28d689cb05$var$Ja && a[$c79bde28d689cb05$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c79bde28d689cb05$var$A = Object.assign, $c79bde28d689cb05$var$La;
function $c79bde28d689cb05$var$Ma(a) {
    if (void 0 === $c79bde28d689cb05$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c79bde28d689cb05$var$La = b && b[1] || "";
    }
    return "\n" + $c79bde28d689cb05$var$La + a;
}
var $c79bde28d689cb05$var$Na = !1;
function $c79bde28d689cb05$var$Oa(a, b) {
    if (!a || $c79bde28d689cb05$var$Na) return "";
    $c79bde28d689cb05$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c79bde28d689cb05$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c79bde28d689cb05$var$Ma(a) : "";
}
function $c79bde28d689cb05$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c79bde28d689cb05$var$Ma(a.type);
        case 16:
            return $c79bde28d689cb05$var$Ma("Lazy");
        case 13:
            return $c79bde28d689cb05$var$Ma("Suspense");
        case 19:
            return $c79bde28d689cb05$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c79bde28d689cb05$var$Oa(a.type, !1), a;
        case 11:
            return a = $c79bde28d689cb05$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c79bde28d689cb05$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c79bde28d689cb05$var$ya:
            return "Fragment";
        case $c79bde28d689cb05$var$wa:
            return "Portal";
        case $c79bde28d689cb05$var$Aa:
            return "Profiler";
        case $c79bde28d689cb05$var$za:
            return "StrictMode";
        case $c79bde28d689cb05$var$Ea:
            return "Suspense";
        case $c79bde28d689cb05$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c79bde28d689cb05$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c79bde28d689cb05$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c79bde28d689cb05$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c79bde28d689cb05$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c79bde28d689cb05$var$Qa(a.type) || "Memo";
        case $c79bde28d689cb05$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c79bde28d689cb05$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c79bde28d689cb05$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c79bde28d689cb05$var$Qa(b);
        case 8:
            return b === $c79bde28d689cb05$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c79bde28d689cb05$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c79bde28d689cb05$var$Ua(a) {
    var b = $c79bde28d689cb05$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c79bde28d689cb05$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c79bde28d689cb05$var$Ua(a));
}
function $c79bde28d689cb05$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c79bde28d689cb05$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c79bde28d689cb05$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c79bde28d689cb05$var$Ya(a, b) {
    var c = b.checked;
    return $c79bde28d689cb05$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c79bde28d689cb05$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c79bde28d689cb05$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c79bde28d689cb05$var$ab(a, b) {
    b = b.checked;
    null != b && $c79bde28d689cb05$var$ta(a, "checked", b, !1);
}
function $c79bde28d689cb05$var$bb(a, b) {
    $c79bde28d689cb05$var$ab(a, b);
    var c = $c79bde28d689cb05$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c79bde28d689cb05$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c79bde28d689cb05$var$cb(a, b.type, $c79bde28d689cb05$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c79bde28d689cb05$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c79bde28d689cb05$var$cb(a, b, c) {
    if ("number" !== b || $c79bde28d689cb05$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c79bde28d689cb05$var$eb = Array.isArray;
function $c79bde28d689cb05$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c79bde28d689cb05$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c79bde28d689cb05$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c79bde28d689cb05$var$p(91));
    return $c79bde28d689cb05$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c79bde28d689cb05$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c79bde28d689cb05$var$p(92));
            if ($c79bde28d689cb05$var$eb(c)) {
                if (1 < c.length) throw Error($c79bde28d689cb05$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c79bde28d689cb05$var$Sa(c)
    };
}
function $c79bde28d689cb05$var$ib(a, b) {
    var c = $c79bde28d689cb05$var$Sa(b.value), d = $c79bde28d689cb05$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c79bde28d689cb05$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c79bde28d689cb05$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c79bde28d689cb05$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c79bde28d689cb05$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c79bde28d689cb05$var$mb, $c79bde28d689cb05$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c79bde28d689cb05$var$mb = $c79bde28d689cb05$var$mb || document.createElement("div");
        $c79bde28d689cb05$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c79bde28d689cb05$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c79bde28d689cb05$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c79bde28d689cb05$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c79bde28d689cb05$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c79bde28d689cb05$var$pb).forEach(function(a) {
    $c79bde28d689cb05$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c79bde28d689cb05$var$pb[b] = $c79bde28d689cb05$var$pb[a];
    });
});
function $c79bde28d689cb05$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c79bde28d689cb05$var$pb.hasOwnProperty(a) && $c79bde28d689cb05$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c79bde28d689cb05$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c79bde28d689cb05$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c79bde28d689cb05$var$tb = $c79bde28d689cb05$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c79bde28d689cb05$var$ub(a, b) {
    if (b) {
        if ($c79bde28d689cb05$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c79bde28d689cb05$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c79bde28d689cb05$var$p(62));
    }
}
function $c79bde28d689cb05$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c79bde28d689cb05$var$wb = null;
function $c79bde28d689cb05$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c79bde28d689cb05$var$yb = null, $c79bde28d689cb05$var$zb = null, $c79bde28d689cb05$var$Ab = null;
function $c79bde28d689cb05$var$Bb(a) {
    if (a = $c79bde28d689cb05$var$Cb(a)) {
        if ("function" !== typeof $c79bde28d689cb05$var$yb) throw Error($c79bde28d689cb05$var$p(280));
        var b = a.stateNode;
        b && (b = $c79bde28d689cb05$var$Db(b), $c79bde28d689cb05$var$yb(a.stateNode, a.type, b));
    }
}
function $c79bde28d689cb05$var$Eb(a) {
    $c79bde28d689cb05$var$zb ? $c79bde28d689cb05$var$Ab ? $c79bde28d689cb05$var$Ab.push(a) : $c79bde28d689cb05$var$Ab = [
        a
    ] : $c79bde28d689cb05$var$zb = a;
}
function $c79bde28d689cb05$var$Fb() {
    if ($c79bde28d689cb05$var$zb) {
        var a = $c79bde28d689cb05$var$zb, b = $c79bde28d689cb05$var$Ab;
        $c79bde28d689cb05$var$Ab = $c79bde28d689cb05$var$zb = null;
        $c79bde28d689cb05$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$Bb(b[a]);
    }
}
function $c79bde28d689cb05$var$Gb(a, b) {
    return a(b);
}
function $c79bde28d689cb05$var$Hb() {}
var $c79bde28d689cb05$var$Ib = !1;
function $c79bde28d689cb05$var$Jb(a, b, c) {
    if ($c79bde28d689cb05$var$Ib) return a(b, c);
    $c79bde28d689cb05$var$Ib = !0;
    try {
        return $c79bde28d689cb05$var$Gb(a, b, c);
    } finally{
        if ($c79bde28d689cb05$var$Ib = !1, null !== $c79bde28d689cb05$var$zb || null !== $c79bde28d689cb05$var$Ab) $c79bde28d689cb05$var$Hb(), $c79bde28d689cb05$var$Fb();
    }
}
function $c79bde28d689cb05$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c79bde28d689cb05$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c79bde28d689cb05$var$p(231, b, typeof c));
    return c;
}
var $c79bde28d689cb05$var$Lb = !1;
if ($c79bde28d689cb05$var$ia) try {
    var $c79bde28d689cb05$var$Mb = {};
    Object.defineProperty($c79bde28d689cb05$var$Mb, "passive", {
        get: function() {
            $c79bde28d689cb05$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
    window.removeEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
} catch (a) {
    $c79bde28d689cb05$var$Lb = !1;
}
function $c79bde28d689cb05$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c79bde28d689cb05$var$Ob = !1, $c79bde28d689cb05$var$Pb = null, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, $c79bde28d689cb05$var$Sb = {
    onError: function(a) {
        $c79bde28d689cb05$var$Ob = !0;
        $c79bde28d689cb05$var$Pb = a;
    }
};
function $c79bde28d689cb05$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Ob = !1;
    $c79bde28d689cb05$var$Pb = null;
    $c79bde28d689cb05$var$Nb.apply($c79bde28d689cb05$var$Sb, arguments);
}
function $c79bde28d689cb05$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Tb.apply(this, arguments);
    if ($c79bde28d689cb05$var$Ob) {
        if ($c79bde28d689cb05$var$Ob) {
            var l = $c79bde28d689cb05$var$Pb;
            $c79bde28d689cb05$var$Ob = !1;
            $c79bde28d689cb05$var$Pb = null;
        } else throw Error($c79bde28d689cb05$var$p(198));
        $c79bde28d689cb05$var$Qb || ($c79bde28d689cb05$var$Qb = !0, $c79bde28d689cb05$var$Rb = l);
    }
}
function $c79bde28d689cb05$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c79bde28d689cb05$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c79bde28d689cb05$var$Xb(a) {
    if ($c79bde28d689cb05$var$Vb(a) !== a) throw Error($c79bde28d689cb05$var$p(188));
}
function $c79bde28d689cb05$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c79bde28d689cb05$var$Vb(a);
        if (null === b) throw Error($c79bde28d689cb05$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c79bde28d689cb05$var$Xb(e), a;
                if (f === d) return $c79bde28d689cb05$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c79bde28d689cb05$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c79bde28d689cb05$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c79bde28d689cb05$var$p(190));
    }
    if (3 !== c.tag) throw Error($c79bde28d689cb05$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c79bde28d689cb05$var$Zb(a) {
    a = $c79bde28d689cb05$var$Yb(a);
    return null !== a ? $c79bde28d689cb05$var$$b(a) : null;
}
function $c79bde28d689cb05$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c79bde28d689cb05$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$ac = $ibqfJ.unstable_scheduleCallback, $c79bde28d689cb05$var$bc = $ibqfJ.unstable_cancelCallback, $c79bde28d689cb05$var$cc = $ibqfJ.unstable_shouldYield, $c79bde28d689cb05$var$dc = $ibqfJ.unstable_requestPaint, $c79bde28d689cb05$var$B = $ibqfJ.unstable_now, $c79bde28d689cb05$var$ec = $ibqfJ.unstable_getCurrentPriorityLevel, $c79bde28d689cb05$var$fc = $ibqfJ.unstable_ImmediatePriority, $c79bde28d689cb05$var$gc = $ibqfJ.unstable_UserBlockingPriority, $c79bde28d689cb05$var$hc = $ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$ic = $ibqfJ.unstable_LowPriority, $c79bde28d689cb05$var$jc = $ibqfJ.unstable_IdlePriority, $c79bde28d689cb05$var$kc = null, $c79bde28d689cb05$var$lc = null;
function $c79bde28d689cb05$var$mc(a) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberRoot) try {
        $c79bde28d689cb05$var$lc.onCommitFiberRoot($c79bde28d689cb05$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c79bde28d689cb05$var$oc = Math.clz32 ? Math.clz32 : $c79bde28d689cb05$var$nc, $c79bde28d689cb05$var$pc = Math.log, $c79bde28d689cb05$var$qc = Math.LN2;
function $c79bde28d689cb05$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c79bde28d689cb05$var$pc(a) / $c79bde28d689cb05$var$qc | 0) | 0;
}
var $c79bde28d689cb05$var$rc = 64, $c79bde28d689cb05$var$sc = 4194304;
function $c79bde28d689cb05$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c79bde28d689cb05$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c79bde28d689cb05$var$tc(h) : (f &= g, 0 !== f && (d = $c79bde28d689cb05$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c79bde28d689cb05$var$tc(g) : 0 !== f && (d = $c79bde28d689cb05$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c79bde28d689cb05$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c79bde28d689cb05$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c79bde28d689cb05$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c79bde28d689cb05$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c79bde28d689cb05$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c79bde28d689cb05$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c79bde28d689cb05$var$yc() {
    var a = $c79bde28d689cb05$var$rc;
    $c79bde28d689cb05$var$rc <<= 1;
    0 === ($c79bde28d689cb05$var$rc & 4194240) && ($c79bde28d689cb05$var$rc = 64);
    return a;
}
function $c79bde28d689cb05$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c79bde28d689cb05$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c79bde28d689cb05$var$oc(b);
    a[b] = c;
}
function $c79bde28d689cb05$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c79bde28d689cb05$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c79bde28d689cb05$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c79bde28d689cb05$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c79bde28d689cb05$var$C = 0;
function $c79bde28d689cb05$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c79bde28d689cb05$var$Ec, $c79bde28d689cb05$var$Fc, $c79bde28d689cb05$var$Gc, $c79bde28d689cb05$var$Hc, $c79bde28d689cb05$var$Ic, $c79bde28d689cb05$var$Jc = !1, $c79bde28d689cb05$var$Kc = [], $c79bde28d689cb05$var$Lc = null, $c79bde28d689cb05$var$Mc = null, $c79bde28d689cb05$var$Nc = null, $c79bde28d689cb05$var$Oc = new Map, $c79bde28d689cb05$var$Pc = new Map, $c79bde28d689cb05$var$Qc = [], $c79bde28d689cb05$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c79bde28d689cb05$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c79bde28d689cb05$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c79bde28d689cb05$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c79bde28d689cb05$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c79bde28d689cb05$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c79bde28d689cb05$var$Pc.delete(b.pointerId);
    }
}
function $c79bde28d689cb05$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c79bde28d689cb05$var$Cb(b), null !== b && $c79bde28d689cb05$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c79bde28d689cb05$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c79bde28d689cb05$var$Lc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c79bde28d689cb05$var$Mc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c79bde28d689cb05$var$Nc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c79bde28d689cb05$var$Oc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c79bde28d689cb05$var$Pc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c79bde28d689cb05$var$Vc(a) {
    var b = $c79bde28d689cb05$var$Wc(a.target);
    if (null !== b) {
        var c = $c79bde28d689cb05$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c79bde28d689cb05$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c79bde28d689cb05$var$Ic(a.priority, function() {
                        $c79bde28d689cb05$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c79bde28d689cb05$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c79bde28d689cb05$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c79bde28d689cb05$var$wb = d;
            c.target.dispatchEvent(d);
            $c79bde28d689cb05$var$wb = null;
        } else return b = $c79bde28d689cb05$var$Cb(c), null !== b && $c79bde28d689cb05$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c79bde28d689cb05$var$Zc(a, b, c) {
    $c79bde28d689cb05$var$Xc(a) && c.delete(b);
}
function $c79bde28d689cb05$var$$c() {
    $c79bde28d689cb05$var$Jc = !1;
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Lc) && ($c79bde28d689cb05$var$Lc = null);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Mc) && ($c79bde28d689cb05$var$Mc = null);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Nc) && ($c79bde28d689cb05$var$Nc = null);
    $c79bde28d689cb05$var$Oc.forEach($c79bde28d689cb05$var$Zc);
    $c79bde28d689cb05$var$Pc.forEach($c79bde28d689cb05$var$Zc);
}
function $c79bde28d689cb05$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c79bde28d689cb05$var$Jc || ($c79bde28d689cb05$var$Jc = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$$c)));
}
function $c79bde28d689cb05$var$bd(a) {
    function b(b) {
        return $c79bde28d689cb05$var$ad(b, a);
    }
    if (0 < $c79bde28d689cb05$var$Kc.length) {
        $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Kc[0], a);
        for(var c = 1; c < $c79bde28d689cb05$var$Kc.length; c++){
            var d = $c79bde28d689cb05$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Lc, a);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Mc, a);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Nc, a);
    $c79bde28d689cb05$var$Oc.forEach(b);
    $c79bde28d689cb05$var$Pc.forEach(b);
    for(c = 0; c < $c79bde28d689cb05$var$Qc.length; c++)d = $c79bde28d689cb05$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c79bde28d689cb05$var$Qc.length && (c = $c79bde28d689cb05$var$Qc[0], null === c.blockedOn);)$c79bde28d689cb05$var$Vc(c), null === c.blockedOn && $c79bde28d689cb05$var$Qc.shift();
}
var $c79bde28d689cb05$var$cd = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$dd = !0;
function $c79bde28d689cb05$var$ed(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$gd(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 4, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$fd(a, b, c, d) {
    if ($c79bde28d689cb05$var$dd) {
        var e = $c79bde28d689cb05$var$Yc(a, b, c, d);
        if (null === e) $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c), $c79bde28d689cb05$var$Sc(a, d);
        else if ($c79bde28d689cb05$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c79bde28d689cb05$var$Sc(a, d), b & 4 && -1 < $c79bde28d689cb05$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c79bde28d689cb05$var$Cb(e);
                null !== f && $c79bde28d689cb05$var$Ec(f);
                f = $c79bde28d689cb05$var$Yc(a, b, c, d);
                null === f && $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c79bde28d689cb05$var$hd(a, b, d, null, c);
    }
}
var $c79bde28d689cb05$var$id = null;
function $c79bde28d689cb05$var$Yc(a, b, c, d) {
    $c79bde28d689cb05$var$id = null;
    a = $c79bde28d689cb05$var$xb(d);
    a = $c79bde28d689cb05$var$Wc(a);
    if (null !== a) {
        if (b = $c79bde28d689cb05$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c79bde28d689cb05$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c79bde28d689cb05$var$id = a;
    return null;
}
function $c79bde28d689cb05$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c79bde28d689cb05$var$ec()){
                case $c79bde28d689cb05$var$fc:
                    return 1;
                case $c79bde28d689cb05$var$gc:
                    return 4;
                case $c79bde28d689cb05$var$hc:
                case $c79bde28d689cb05$var$ic:
                    return 16;
                case $c79bde28d689cb05$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ld = null, $c79bde28d689cb05$var$md = null;
function $c79bde28d689cb05$var$nd() {
    if ($c79bde28d689cb05$var$md) return $c79bde28d689cb05$var$md;
    var a, b = $c79bde28d689cb05$var$ld, c = b.length, d, e = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c79bde28d689cb05$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c79bde28d689cb05$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c79bde28d689cb05$var$pd() {
    return !0;
}
function $c79bde28d689cb05$var$qd() {
    return !1;
}
function $c79bde28d689cb05$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c79bde28d689cb05$var$pd : $c79bde28d689cb05$var$qd;
        this.isPropagationStopped = $c79bde28d689cb05$var$qd;
        return this;
    }
    $c79bde28d689cb05$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c79bde28d689cb05$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c79bde28d689cb05$var$pd);
        },
        persist: function() {},
        isPersistent: $c79bde28d689cb05$var$pd
    });
    return b;
}
var $c79bde28d689cb05$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c79bde28d689cb05$var$td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$sd), $c79bde28d689cb05$var$ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    view: 0,
    detail: 0
}), $c79bde28d689cb05$var$vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$ud), $c79bde28d689cb05$var$wd, $c79bde28d689cb05$var$xd, $c79bde28d689cb05$var$yd, $c79bde28d689cb05$var$Ad = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c79bde28d689cb05$var$yd && ($c79bde28d689cb05$var$yd && "mousemove" === a.type ? ($c79bde28d689cb05$var$wd = a.screenX - $c79bde28d689cb05$var$yd.screenX, $c79bde28d689cb05$var$xd = a.screenY - $c79bde28d689cb05$var$yd.screenY) : $c79bde28d689cb05$var$xd = $c79bde28d689cb05$var$wd = 0, $c79bde28d689cb05$var$yd = a);
        return $c79bde28d689cb05$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c79bde28d689cb05$var$xd;
    }
}), $c79bde28d689cb05$var$Bd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ad), $c79bde28d689cb05$var$Cd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    dataTransfer: 0
}), $c79bde28d689cb05$var$Dd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Cd), $c79bde28d689cb05$var$Ed = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    relatedTarget: 0
}), $c79bde28d689cb05$var$Fd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ed), $c79bde28d689cb05$var$Gd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Hd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Gd), $c79bde28d689cb05$var$Id = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c79bde28d689cb05$var$Jd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Id), $c79bde28d689cb05$var$Kd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    data: 0
}), $c79bde28d689cb05$var$Ld = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Kd), $c79bde28d689cb05$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c79bde28d689cb05$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c79bde28d689cb05$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c79bde28d689cb05$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c79bde28d689cb05$var$Od[a]) ? !!b[a] : !1;
}
function $c79bde28d689cb05$var$zd() {
    return $c79bde28d689cb05$var$Pd;
}
var $c79bde28d689cb05$var$Qd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c79bde28d689cb05$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c79bde28d689cb05$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c79bde28d689cb05$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c79bde28d689cb05$var$Rd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Qd), $c79bde28d689cb05$var$Sd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c79bde28d689cb05$var$Td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Sd), $c79bde28d689cb05$var$Ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd
}), $c79bde28d689cb05$var$Vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ud), $c79bde28d689cb05$var$Wd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Xd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Wd), $c79bde28d689cb05$var$Yd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c79bde28d689cb05$var$Zd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Yd), $c79bde28d689cb05$var$$d = [
    9,
    13,
    27,
    32
], $c79bde28d689cb05$var$ae = $c79bde28d689cb05$var$ia && "CompositionEvent" in window, $c79bde28d689cb05$var$be = null;
$c79bde28d689cb05$var$ia && "documentMode" in document && ($c79bde28d689cb05$var$be = document.documentMode);
var $c79bde28d689cb05$var$ce = $c79bde28d689cb05$var$ia && "TextEvent" in window && !$c79bde28d689cb05$var$be, $c79bde28d689cb05$var$de = $c79bde28d689cb05$var$ia && (!$c79bde28d689cb05$var$ae || $c79bde28d689cb05$var$be && 8 < $c79bde28d689cb05$var$be && 11 >= $c79bde28d689cb05$var$be), $c79bde28d689cb05$var$ee = String.fromCharCode(32), $c79bde28d689cb05$var$fe = !1;
function $c79bde28d689cb05$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c79bde28d689cb05$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c79bde28d689cb05$var$ie = !1;
function $c79bde28d689cb05$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c79bde28d689cb05$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c79bde28d689cb05$var$fe = !0;
            return $c79bde28d689cb05$var$ee;
        case "textInput":
            return a = b.data, a === $c79bde28d689cb05$var$ee && $c79bde28d689cb05$var$fe ? null : a;
        default:
            return null;
    }
}
function $c79bde28d689cb05$var$ke(a, b) {
    if ($c79bde28d689cb05$var$ie) return "compositionend" === a || !$c79bde28d689cb05$var$ae && $c79bde28d689cb05$var$ge(a, b) ? (a = $c79bde28d689cb05$var$nd(), $c79bde28d689cb05$var$md = $c79bde28d689cb05$var$ld = $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c79bde28d689cb05$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c79bde28d689cb05$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c79bde28d689cb05$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c79bde28d689cb05$var$ne(a, b, c, d) {
    $c79bde28d689cb05$var$Eb(d);
    b = $c79bde28d689cb05$var$oe(b, "onChange");
    0 < b.length && (c = new $c79bde28d689cb05$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c79bde28d689cb05$var$pe = null, $c79bde28d689cb05$var$qe = null;
function $c79bde28d689cb05$var$re(a) {
    $c79bde28d689cb05$var$se(a, 0);
}
function $c79bde28d689cb05$var$te(a) {
    var b = $c79bde28d689cb05$var$ue(a);
    if ($c79bde28d689cb05$var$Wa(b)) return a;
}
function $c79bde28d689cb05$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c79bde28d689cb05$var$we = !1;
if ($c79bde28d689cb05$var$ia) {
    var $c79bde28d689cb05$var$xe;
    if ($c79bde28d689cb05$var$ia) {
        var $c79bde28d689cb05$var$ye = "oninput" in document;
        if (!$c79bde28d689cb05$var$ye) {
            var $c79bde28d689cb05$var$ze = document.createElement("div");
            $c79bde28d689cb05$var$ze.setAttribute("oninput", "return;");
            $c79bde28d689cb05$var$ye = "function" === typeof $c79bde28d689cb05$var$ze.oninput;
        }
        $c79bde28d689cb05$var$xe = $c79bde28d689cb05$var$ye;
    } else $c79bde28d689cb05$var$xe = !1;
    $c79bde28d689cb05$var$we = $c79bde28d689cb05$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c79bde28d689cb05$var$Ae() {
    $c79bde28d689cb05$var$pe && ($c79bde28d689cb05$var$pe.detachEvent("onpropertychange", $c79bde28d689cb05$var$Be), $c79bde28d689cb05$var$qe = $c79bde28d689cb05$var$pe = null);
}
function $c79bde28d689cb05$var$Be(a) {
    if ("value" === a.propertyName && $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe)) {
        var b = [];
        $c79bde28d689cb05$var$ne(b, $c79bde28d689cb05$var$qe, a, $c79bde28d689cb05$var$xb(a));
        $c79bde28d689cb05$var$Jb($c79bde28d689cb05$var$re, b);
    }
}
function $c79bde28d689cb05$var$Ce(a, b, c) {
    "focusin" === a ? ($c79bde28d689cb05$var$Ae(), $c79bde28d689cb05$var$pe = b, $c79bde28d689cb05$var$qe = c, $c79bde28d689cb05$var$pe.attachEvent("onpropertychange", $c79bde28d689cb05$var$Be)) : "focusout" === a && $c79bde28d689cb05$var$Ae();
}
function $c79bde28d689cb05$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe);
}
function $c79bde28d689cb05$var$Ee(a, b) {
    if ("click" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c79bde28d689cb05$var$He = "function" === typeof Object.is ? Object.is : $c79bde28d689cb05$var$Ge;
function $c79bde28d689cb05$var$Ie(a, b) {
    if ($c79bde28d689cb05$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c79bde28d689cb05$var$ja.call(b, e) || !$c79bde28d689cb05$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c79bde28d689cb05$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c79bde28d689cb05$var$Ke(a, b) {
    var c = $c79bde28d689cb05$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c79bde28d689cb05$var$Je(c);
    }
}
function $c79bde28d689cb05$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c79bde28d689cb05$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c79bde28d689cb05$var$Me() {
    for(var a = window, b = $c79bde28d689cb05$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c79bde28d689cb05$var$Xa(a.document);
    }
    return b;
}
function $c79bde28d689cb05$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c79bde28d689cb05$var$Oe(a) {
    var b = $c79bde28d689cb05$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c79bde28d689cb05$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c79bde28d689cb05$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c79bde28d689cb05$var$Ke(c, f);
                var g = $c79bde28d689cb05$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c79bde28d689cb05$var$Pe = $c79bde28d689cb05$var$ia && "documentMode" in document && 11 >= document.documentMode, $c79bde28d689cb05$var$Qe = null, $c79bde28d689cb05$var$Re = null, $c79bde28d689cb05$var$Se = null, $c79bde28d689cb05$var$Te = !1;
function $c79bde28d689cb05$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c79bde28d689cb05$var$Te || null == $c79bde28d689cb05$var$Qe || $c79bde28d689cb05$var$Qe !== $c79bde28d689cb05$var$Xa(d) || (d = $c79bde28d689cb05$var$Qe, "selectionStart" in d && $c79bde28d689cb05$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c79bde28d689cb05$var$Se && $c79bde28d689cb05$var$Ie($c79bde28d689cb05$var$Se, d) || ($c79bde28d689cb05$var$Se = d, d = $c79bde28d689cb05$var$oe($c79bde28d689cb05$var$Re, "onSelect"), 0 < d.length && (b = new $c79bde28d689cb05$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c79bde28d689cb05$var$Qe)));
}
function $c79bde28d689cb05$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c79bde28d689cb05$var$We = {
    animationend: $c79bde28d689cb05$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c79bde28d689cb05$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c79bde28d689cb05$var$Ve("Animation", "AnimationStart"),
    transitionend: $c79bde28d689cb05$var$Ve("Transition", "TransitionEnd")
}, $c79bde28d689cb05$var$Xe = {}, $c79bde28d689cb05$var$Ye = {};
$c79bde28d689cb05$var$ia && ($c79bde28d689cb05$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c79bde28d689cb05$var$We.animationend.animation, delete $c79bde28d689cb05$var$We.animationiteration.animation, delete $c79bde28d689cb05$var$We.animationstart.animation), "TransitionEvent" in window || delete $c79bde28d689cb05$var$We.transitionend.transition);
function $c79bde28d689cb05$var$Ze(a) {
    if ($c79bde28d689cb05$var$Xe[a]) return $c79bde28d689cb05$var$Xe[a];
    if (!$c79bde28d689cb05$var$We[a]) return a;
    var b = $c79bde28d689cb05$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c79bde28d689cb05$var$Ye) return $c79bde28d689cb05$var$Xe[a] = b[c];
    return a;
}
var $c79bde28d689cb05$var$$e = $c79bde28d689cb05$var$Ze("animationend"), $c79bde28d689cb05$var$af = $c79bde28d689cb05$var$Ze("animationiteration"), $c79bde28d689cb05$var$bf = $c79bde28d689cb05$var$Ze("animationstart"), $c79bde28d689cb05$var$cf = $c79bde28d689cb05$var$Ze("transitionend"), $c79bde28d689cb05$var$df = new Map, $c79bde28d689cb05$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c79bde28d689cb05$var$ff(a, b) {
    $c79bde28d689cb05$var$df.set(a, b);
    $c79bde28d689cb05$var$fa(b, [
        a
    ]);
}
for(var $c79bde28d689cb05$var$gf = 0; $c79bde28d689cb05$var$gf < $c79bde28d689cb05$var$ef.length; $c79bde28d689cb05$var$gf++){
    var $c79bde28d689cb05$var$hf = $c79bde28d689cb05$var$ef[$c79bde28d689cb05$var$gf], $c79bde28d689cb05$var$jf = $c79bde28d689cb05$var$hf.toLowerCase(), $c79bde28d689cb05$var$kf = $c79bde28d689cb05$var$hf[0].toUpperCase() + $c79bde28d689cb05$var$hf.slice(1);
    $c79bde28d689cb05$var$ff($c79bde28d689cb05$var$jf, "on" + $c79bde28d689cb05$var$kf);
}
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$$e, "onAnimationEnd");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$af, "onAnimationIteration");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$bf, "onAnimationStart");
$c79bde28d689cb05$var$ff("dblclick", "onDoubleClick");
$c79bde28d689cb05$var$ff("focusin", "onFocus");
$c79bde28d689cb05$var$ff("focusout", "onBlur");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$cf, "onTransitionEnd");
$c79bde28d689cb05$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c79bde28d689cb05$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c79bde28d689cb05$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c79bde28d689cb05$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c79bde28d689cb05$var$lf));
function $c79bde28d689cb05$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c79bde28d689cb05$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c79bde28d689cb05$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c79bde28d689cb05$var$Qb) throw a = $c79bde28d689cb05$var$Rb, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, a;
}
function $c79bde28d689cb05$var$D(a, b) {
    var c = b[$c79bde28d689cb05$var$of];
    void 0 === c && (c = b[$c79bde28d689cb05$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c79bde28d689cb05$var$pf(b, a, 2, !1), c.add(d));
}
function $c79bde28d689cb05$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c79bde28d689cb05$var$pf(c, a, d, b);
}
var $c79bde28d689cb05$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c79bde28d689cb05$var$sf(a) {
    if (!a[$c79bde28d689cb05$var$rf]) {
        a[$c79bde28d689cb05$var$rf] = !0;
        $c79bde28d689cb05$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c79bde28d689cb05$var$mf.has(b) || $c79bde28d689cb05$var$qf(b, !1, a), $c79bde28d689cb05$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c79bde28d689cb05$var$rf] || (b[$c79bde28d689cb05$var$rf] = !0, $c79bde28d689cb05$var$qf("selectionchange", !1, b));
    }
}
function $c79bde28d689cb05$var$pf(a, b, c, d) {
    switch($c79bde28d689cb05$var$jd(b)){
        case 1:
            var e = $c79bde28d689cb05$var$ed;
            break;
        case 4:
            e = $c79bde28d689cb05$var$gd;
            break;
        default:
            e = $c79bde28d689cb05$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c79bde28d689cb05$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c79bde28d689cb05$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c79bde28d689cb05$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c79bde28d689cb05$var$Jb(function() {
        var d = f, e = $c79bde28d689cb05$var$xb(c), g = [];
        a: {
            var h = $c79bde28d689cb05$var$df.get(a);
            if (void 0 !== h) {
                var k = $c79bde28d689cb05$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c79bde28d689cb05$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c79bde28d689cb05$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c79bde28d689cb05$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c79bde28d689cb05$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c79bde28d689cb05$var$Vd;
                        break;
                    case $c79bde28d689cb05$var$$e:
                    case $c79bde28d689cb05$var$af:
                    case $c79bde28d689cb05$var$bf:
                        k = $c79bde28d689cb05$var$Hd;
                        break;
                    case $c79bde28d689cb05$var$cf:
                        k = $c79bde28d689cb05$var$Xd;
                        break;
                    case "scroll":
                        k = $c79bde28d689cb05$var$vd;
                        break;
                    case "wheel":
                        k = $c79bde28d689cb05$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c79bde28d689cb05$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c79bde28d689cb05$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c79bde28d689cb05$var$Kb(w, x), null != F && t.push($c79bde28d689cb05$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c79bde28d689cb05$var$wb && (n = c.relatedTarget || c.fromElement) && ($c79bde28d689cb05$var$Wc(n) || n[$c79bde28d689cb05$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c79bde28d689cb05$var$Wc(n) : null, null !== n && (J = $c79bde28d689cb05$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c79bde28d689cb05$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c79bde28d689cb05$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c79bde28d689cb05$var$ue(k);
                        u = null == n ? h : $c79bde28d689cb05$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c79bde28d689cb05$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c79bde28d689cb05$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c79bde28d689cb05$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c79bde28d689cb05$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c79bde28d689cb05$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c79bde28d689cb05$var$vf(t);
                                x = $c79bde28d689cb05$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c79bde28d689cb05$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c79bde28d689cb05$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c79bde28d689cb05$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c79bde28d689cb05$var$ve;
                else if ($c79bde28d689cb05$var$me(h)) {
                    if ($c79bde28d689cb05$var$we) na = $c79bde28d689cb05$var$Fe;
                    else {
                        na = $c79bde28d689cb05$var$De;
                        var xa = $c79bde28d689cb05$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c79bde28d689cb05$var$Ee);
                if (na && (na = na(a, d))) {
                    $c79bde28d689cb05$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c79bde28d689cb05$var$cb(h, "number", h.value);
            }
            xa = d ? $c79bde28d689cb05$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c79bde28d689cb05$var$me(xa) || "true" === xa.contentEditable) $c79bde28d689cb05$var$Qe = xa, $c79bde28d689cb05$var$Re = d, $c79bde28d689cb05$var$Se = null;
                    break;
                case "focusout":
                    $c79bde28d689cb05$var$Se = $c79bde28d689cb05$var$Re = $c79bde28d689cb05$var$Qe = null;
                    break;
                case "mousedown":
                    $c79bde28d689cb05$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c79bde28d689cb05$var$Te = !1;
                    $c79bde28d689cb05$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c79bde28d689cb05$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c79bde28d689cb05$var$Ue(g, c, e);
            }
            var $a;
            if ($c79bde28d689cb05$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c79bde28d689cb05$var$ie ? $c79bde28d689cb05$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c79bde28d689cb05$var$de && "ko" !== c.locale && ($c79bde28d689cb05$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c79bde28d689cb05$var$ie && ($a = $c79bde28d689cb05$var$nd()) : ($c79bde28d689cb05$var$kd = e, $c79bde28d689cb05$var$ld = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, $c79bde28d689cb05$var$ie = !0)), xa = $c79bde28d689cb05$var$oe(d, ba), 0 < xa.length && (ba = new $c79bde28d689cb05$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c79bde28d689cb05$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c79bde28d689cb05$var$ce ? $c79bde28d689cb05$var$je(a, c) : $c79bde28d689cb05$var$ke(a, c)) d = $c79bde28d689cb05$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c79bde28d689cb05$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c79bde28d689cb05$var$se(g, b);
    });
}
function $c79bde28d689cb05$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c79bde28d689cb05$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c79bde28d689cb05$var$Kb(a, c), null != f && d.unshift($c79bde28d689cb05$var$tf(a, f, e)), f = $c79bde28d689cb05$var$Kb(a, b), null != f && d.push($c79bde28d689cb05$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c79bde28d689cb05$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c79bde28d689cb05$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.unshift($c79bde28d689cb05$var$tf(c, k, h))) : e || (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.push($c79bde28d689cb05$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c79bde28d689cb05$var$xf = /\r\n?/g, $c79bde28d689cb05$var$yf = /\u0000|\uFFFD/g;
function $c79bde28d689cb05$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c79bde28d689cb05$var$xf, "\n").replace($c79bde28d689cb05$var$yf, "");
}
function $c79bde28d689cb05$var$Af(a, b, c) {
    b = $c79bde28d689cb05$var$zf(b);
    if ($c79bde28d689cb05$var$zf(a) !== b && c) throw Error($c79bde28d689cb05$var$p(425));
}
function $c79bde28d689cb05$var$Bf() {}
var $c79bde28d689cb05$var$Cf = null, $c79bde28d689cb05$var$Df = null;
function $c79bde28d689cb05$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c79bde28d689cb05$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c79bde28d689cb05$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c79bde28d689cb05$var$Hf = "function" === typeof Promise ? Promise : void 0, $c79bde28d689cb05$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c79bde28d689cb05$var$Hf ? function(a) {
    return $c79bde28d689cb05$var$Hf.resolve(null).then(a).catch($c79bde28d689cb05$var$If);
} : $c79bde28d689cb05$var$Ff;
function $c79bde28d689cb05$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c79bde28d689cb05$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c79bde28d689cb05$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c79bde28d689cb05$var$bd(b);
}
function $c79bde28d689cb05$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c79bde28d689cb05$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nf = Math.random().toString(36).slice(2), $c79bde28d689cb05$var$Of = "__reactFiber$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Pf = "__reactProps$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$uf = "__reactContainer$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$of = "__reactEvents$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Qf = "__reactListeners$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Rf = "__reactHandles$" + $c79bde28d689cb05$var$Nf;
function $c79bde28d689cb05$var$Wc(a) {
    var b = a[$c79bde28d689cb05$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c79bde28d689cb05$var$uf] || c[$c79bde28d689cb05$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c79bde28d689cb05$var$Mf(a); null !== a;){
                if (c = a[$c79bde28d689cb05$var$Of]) return c;
                a = $c79bde28d689cb05$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c79bde28d689cb05$var$Cb(a) {
    a = a[$c79bde28d689cb05$var$Of] || a[$c79bde28d689cb05$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c79bde28d689cb05$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c79bde28d689cb05$var$p(33));
}
function $c79bde28d689cb05$var$Db(a) {
    return a[$c79bde28d689cb05$var$Pf] || null;
}
var $c79bde28d689cb05$var$Sf = [], $c79bde28d689cb05$var$Tf = -1;
function $c79bde28d689cb05$var$Uf(a) {
    return {
        current: a
    };
}
function $c79bde28d689cb05$var$E(a) {
    0 > $c79bde28d689cb05$var$Tf || (a.current = $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf], $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = null, $c79bde28d689cb05$var$Tf--);
}
function $c79bde28d689cb05$var$G(a, b) {
    $c79bde28d689cb05$var$Tf++;
    $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = a.current;
    a.current = b;
}
var $c79bde28d689cb05$var$Vf = {}, $c79bde28d689cb05$var$H = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Vf), $c79bde28d689cb05$var$Wf = $c79bde28d689cb05$var$Uf(!1), $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$Vf;
function $c79bde28d689cb05$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c79bde28d689cb05$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c79bde28d689cb05$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c79bde28d689cb05$var$$f() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
}
function $c79bde28d689cb05$var$ag(a, b, c) {
    if ($c79bde28d689cb05$var$H.current !== $c79bde28d689cb05$var$Vf) throw Error($c79bde28d689cb05$var$p(168));
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
function $c79bde28d689cb05$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c79bde28d689cb05$var$p(108, $c79bde28d689cb05$var$Ra(a) || "Unknown", e));
    return $c79bde28d689cb05$var$A({}, c, d);
}
function $c79bde28d689cb05$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c79bde28d689cb05$var$Vf;
    $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$H.current;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, $c79bde28d689cb05$var$Wf.current);
    return !0;
}
function $c79bde28d689cb05$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c79bde28d689cb05$var$p(169));
    c ? (a = $c79bde28d689cb05$var$bg(a, b, $c79bde28d689cb05$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a)) : $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
var $c79bde28d689cb05$var$eg = null, $c79bde28d689cb05$var$fg = !1, $c79bde28d689cb05$var$gg = !1;
function $c79bde28d689cb05$var$hg(a) {
    null === $c79bde28d689cb05$var$eg ? $c79bde28d689cb05$var$eg = [
        a
    ] : $c79bde28d689cb05$var$eg.push(a);
}
function $c79bde28d689cb05$var$ig(a) {
    $c79bde28d689cb05$var$fg = !0;
    $c79bde28d689cb05$var$hg(a);
}
function $c79bde28d689cb05$var$jg() {
    if (!$c79bde28d689cb05$var$gg && null !== $c79bde28d689cb05$var$eg) {
        $c79bde28d689cb05$var$gg = !0;
        var a = 0, b = $c79bde28d689cb05$var$C;
        try {
            var c = $c79bde28d689cb05$var$eg;
            for($c79bde28d689cb05$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c79bde28d689cb05$var$eg = null;
            $c79bde28d689cb05$var$fg = !1;
        } catch (e) {
            throw null !== $c79bde28d689cb05$var$eg && ($c79bde28d689cb05$var$eg = $c79bde28d689cb05$var$eg.slice(a + 1)), $c79bde28d689cb05$var$ac($c79bde28d689cb05$var$fc, $c79bde28d689cb05$var$jg), e;
        } finally{
            $c79bde28d689cb05$var$C = b, $c79bde28d689cb05$var$gg = !1;
        }
    }
    return null;
}
var $c79bde28d689cb05$var$kg = [], $c79bde28d689cb05$var$lg = 0, $c79bde28d689cb05$var$mg = null, $c79bde28d689cb05$var$ng = 0, $c79bde28d689cb05$var$og = [], $c79bde28d689cb05$var$pg = 0, $c79bde28d689cb05$var$qg = null, $c79bde28d689cb05$var$rg = 1, $c79bde28d689cb05$var$sg = "";
function $c79bde28d689cb05$var$tg(a, b) {
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$ng;
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$mg;
    $c79bde28d689cb05$var$mg = a;
    $c79bde28d689cb05$var$ng = b;
}
function $c79bde28d689cb05$var$ug(a, b, c) {
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg;
    $c79bde28d689cb05$var$qg = a;
    var d = $c79bde28d689cb05$var$rg;
    a = $c79bde28d689cb05$var$sg;
    var e = 32 - $c79bde28d689cb05$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c79bde28d689cb05$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c79bde28d689cb05$var$rg = 1 << 32 - $c79bde28d689cb05$var$oc(b) + e | c << e | d;
        $c79bde28d689cb05$var$sg = f + a;
    } else $c79bde28d689cb05$var$rg = 1 << f | c << e | d, $c79bde28d689cb05$var$sg = a;
}
function $c79bde28d689cb05$var$vg(a) {
    null !== a.return && ($c79bde28d689cb05$var$tg(a, 1), $c79bde28d689cb05$var$ug(a, 1, 0));
}
function $c79bde28d689cb05$var$wg(a) {
    for(; a === $c79bde28d689cb05$var$mg;)$c79bde28d689cb05$var$mg = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null, $c79bde28d689cb05$var$ng = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null;
    for(; a === $c79bde28d689cb05$var$qg;)$c79bde28d689cb05$var$qg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$sg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$rg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null;
}
var $c79bde28d689cb05$var$xg = null, $c79bde28d689cb05$var$yg = null, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$zg = null;
function $c79bde28d689cb05$var$Ag(a, b) {
    var c = $c79bde28d689cb05$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c79bde28d689cb05$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c79bde28d689cb05$var$qg ? {
                id: $c79bde28d689cb05$var$rg,
                overflow: $c79bde28d689cb05$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c79bde28d689cb05$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c79bde28d689cb05$var$Eg(a) {
    if ($c79bde28d689cb05$var$I) {
        var b = $c79bde28d689cb05$var$yg;
        if (b) {
            var c = b;
            if (!$c79bde28d689cb05$var$Cg(a, b)) {
                if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
                b = $c79bde28d689cb05$var$Lf(c.nextSibling);
                var d = $c79bde28d689cb05$var$xg;
                b && $c79bde28d689cb05$var$Cg(a, b) ? $c79bde28d689cb05$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$xg = a);
            }
        } else {
            if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c79bde28d689cb05$var$I = !1;
            $c79bde28d689cb05$var$xg = a;
        }
    }
}
function $c79bde28d689cb05$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c79bde28d689cb05$var$xg = a;
}
function $c79bde28d689cb05$var$Gg(a) {
    if (a !== $c79bde28d689cb05$var$xg) return !1;
    if (!$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$Fg(a), $c79bde28d689cb05$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c79bde28d689cb05$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c79bde28d689cb05$var$yg)) {
        if ($c79bde28d689cb05$var$Dg(a)) throw $c79bde28d689cb05$var$Hg(), Error($c79bde28d689cb05$var$p(418));
        for(; b;)$c79bde28d689cb05$var$Ag(a, b), b = $c79bde28d689cb05$var$Lf(b.nextSibling);
    }
    $c79bde28d689cb05$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c79bde28d689cb05$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c79bde28d689cb05$var$yg = null;
        }
    } else $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg ? $c79bde28d689cb05$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c79bde28d689cb05$var$Hg() {
    for(var a = $c79bde28d689cb05$var$yg; a;)a = $c79bde28d689cb05$var$Lf(a.nextSibling);
}
function $c79bde28d689cb05$var$Ig() {
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg = null;
    $c79bde28d689cb05$var$I = !1;
}
function $c79bde28d689cb05$var$Jg(a) {
    null === $c79bde28d689cb05$var$zg ? $c79bde28d689cb05$var$zg = [
        a
    ] : $c79bde28d689cb05$var$zg.push(a);
}
var $c79bde28d689cb05$var$Kg = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig;
function $c79bde28d689cb05$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c79bde28d689cb05$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c79bde28d689cb05$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c79bde28d689cb05$var$p(284));
        if (!c._owner) throw Error($c79bde28d689cb05$var$p(290, a));
    }
    return a;
}
function $c79bde28d689cb05$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c79bde28d689cb05$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c79bde28d689cb05$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $c79bde28d689cb05$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c79bde28d689cb05$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c79bde28d689cb05$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c79bde28d689cb05$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $c79bde28d689cb05$var$Lg(a, b, c), d.return = a, d;
        d = $c79bde28d689cb05$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c79bde28d689cb05$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c79bde28d689cb05$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c79bde28d689cb05$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c79bde28d689cb05$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c = $c79bde28d689cb05$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $c79bde28d689cb05$var$Lg(a, null, b), c.return = a, c;
                case $c79bde28d689cb05$var$wa:
                    return b = $c79bde28d689cb05$var$Sg(b, a.mode, c), b.return = a, b;
                case $c79bde28d689cb05$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c79bde28d689cb05$var$eb(b) || $c79bde28d689cb05$var$Ka(b)) return b = $c79bde28d689cb05$var$Tg(b, a.mode, c, null), b.return = a, b;
            $c79bde28d689cb05$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c79bde28d689cb05$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c79bde28d689cb05$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c79bde28d689cb05$var$eb(c) || $c79bde28d689cb05$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c79bde28d689cb05$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c79bde28d689cb05$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c79bde28d689cb05$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c79bde28d689cb05$var$eb(d) || $c79bde28d689cb05$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c79bde28d689cb05$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c79bde28d689cb05$var$Ka(h);
        if ("function" !== typeof l) throw Error($c79bde28d689cb05$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c79bde28d689cb05$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c79bde28d689cb05$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c79bde28d689cb05$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c79bde28d689cb05$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c79bde28d689cb05$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c79bde28d689cb05$var$ya ? (d = $c79bde28d689cb05$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c79bde28d689cb05$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $c79bde28d689cb05$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c79bde28d689cb05$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c79bde28d689cb05$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c79bde28d689cb05$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c79bde28d689cb05$var$eb(f)) return n(a, d, f, h);
            if ($c79bde28d689cb05$var$Ka(f)) return t(a, d, f, h);
            $c79bde28d689cb05$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c79bde28d689cb05$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c79bde28d689cb05$var$Ug = $c79bde28d689cb05$var$Og(!0), $c79bde28d689cb05$var$Vg = $c79bde28d689cb05$var$Og(!1), $c79bde28d689cb05$var$Wg = $c79bde28d689cb05$var$Uf(null), $c79bde28d689cb05$var$Xg = null, $c79bde28d689cb05$var$Yg = null, $c79bde28d689cb05$var$Zg = null;
function $c79bde28d689cb05$var$$g() {
    $c79bde28d689cb05$var$Zg = $c79bde28d689cb05$var$Yg = $c79bde28d689cb05$var$Xg = null;
}
function $c79bde28d689cb05$var$ah(a) {
    var b = $c79bde28d689cb05$var$Wg.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wg);
    a._currentValue = b;
}
function $c79bde28d689cb05$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c79bde28d689cb05$var$ch(a, b) {
    $c79bde28d689cb05$var$Xg = a;
    $c79bde28d689cb05$var$Zg = $c79bde28d689cb05$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c79bde28d689cb05$var$dh = !0), a.firstContext = null);
}
function $c79bde28d689cb05$var$eh(a) {
    var b = a._currentValue;
    if ($c79bde28d689cb05$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c79bde28d689cb05$var$Yg) {
            if (null === $c79bde28d689cb05$var$Xg) throw Error($c79bde28d689cb05$var$p(308));
            $c79bde28d689cb05$var$Yg = a;
            $c79bde28d689cb05$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c79bde28d689cb05$var$Yg = $c79bde28d689cb05$var$Yg.next = a;
    }
    return b;
}
var $c79bde28d689cb05$var$fh = null;
function $c79bde28d689cb05$var$gh(a) {
    null === $c79bde28d689cb05$var$fh ? $c79bde28d689cb05$var$fh = [
        a
    ] : $c79bde28d689cb05$var$fh.push(a);
}
function $c79bde28d689cb05$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c79bde28d689cb05$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c79bde28d689cb05$var$ih(a, d);
}
function $c79bde28d689cb05$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c79bde28d689cb05$var$jh = !1;
function $c79bde28d689cb05$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c79bde28d689cb05$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c79bde28d689cb05$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c79bde28d689cb05$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c79bde28d689cb05$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c79bde28d689cb05$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c79bde28d689cb05$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c79bde28d689cb05$var$ih(a, c);
}
function $c79bde28d689cb05$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
function $c79bde28d689cb05$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c79bde28d689cb05$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $c79bde28d689cb05$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c79bde28d689cb05$var$A({}, q, r);
                            break a;
                        case 2:
                            $c79bde28d689cb05$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c79bde28d689cb05$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c79bde28d689cb05$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c79bde28d689cb05$var$p(191, e));
            e.call(d);
        }
    }
}
var $c79bde28d689cb05$var$th = {}, $c79bde28d689cb05$var$uh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$th), $c79bde28d689cb05$var$vh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$th), $c79bde28d689cb05$var$wh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$th);
function $c79bde28d689cb05$var$xh(a) {
    if (a === $c79bde28d689cb05$var$th) throw Error($c79bde28d689cb05$var$p(174));
    return a;
}
function $c79bde28d689cb05$var$yh(a, b) {
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$wh, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$vh, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$uh, $c79bde28d689cb05$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c79bde28d689cb05$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c79bde28d689cb05$var$lb(b, a);
    }
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$uh);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$uh, b);
}
function $c79bde28d689cb05$var$zh() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$uh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$vh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$wh);
}
function $c79bde28d689cb05$var$Ah(a) {
    $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$wh.current);
    var b = $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$uh.current);
    var c = $c79bde28d689cb05$var$lb(b, a.type);
    b !== c && ($c79bde28d689cb05$var$G($c79bde28d689cb05$var$vh, a), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$uh, c));
}
function $c79bde28d689cb05$var$Bh(a) {
    $c79bde28d689cb05$var$vh.current === a && ($c79bde28d689cb05$var$E($c79bde28d689cb05$var$uh), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$vh));
}
var $c79bde28d689cb05$var$L = $c79bde28d689cb05$var$Uf(0);
function $c79bde28d689cb05$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Dh = [];
function $c79bde28d689cb05$var$Eh() {
    for(var a = 0; a < $c79bde28d689cb05$var$Dh.length; a++)$c79bde28d689cb05$var$Dh[a]._workInProgressVersionPrimary = null;
    $c79bde28d689cb05$var$Dh.length = 0;
}
var $c79bde28d689cb05$var$Fh = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$Gh = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$Hh = 0, $c79bde28d689cb05$var$M = null, $c79bde28d689cb05$var$N = null, $c79bde28d689cb05$var$O = null, $c79bde28d689cb05$var$Ih = !1, $c79bde28d689cb05$var$Jh = !1, $c79bde28d689cb05$var$Kh = 0, $c79bde28d689cb05$var$Lh = 0;
function $c79bde28d689cb05$var$P() {
    throw Error($c79bde28d689cb05$var$p(321));
}
function $c79bde28d689cb05$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c79bde28d689cb05$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c79bde28d689cb05$var$Nh(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$Hh = f;
    $c79bde28d689cb05$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c79bde28d689cb05$var$Fh.current = null === a || null === a.memoizedState ? $c79bde28d689cb05$var$Oh : $c79bde28d689cb05$var$Ph;
    a = c(d, e);
    if ($c79bde28d689cb05$var$Jh) {
        f = 0;
        do {
            $c79bde28d689cb05$var$Jh = !1;
            $c79bde28d689cb05$var$Kh = 0;
            if (25 <= f) throw Error($c79bde28d689cb05$var$p(301));
            f += 1;
            $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
            b.updateQueue = null;
            $c79bde28d689cb05$var$Fh.current = $c79bde28d689cb05$var$Qh;
            a = c(d, e);
        }while ($c79bde28d689cb05$var$Jh);
    }
    $c79bde28d689cb05$var$Fh.current = $c79bde28d689cb05$var$Rh;
    b = null !== $c79bde28d689cb05$var$N && null !== $c79bde28d689cb05$var$N.next;
    $c79bde28d689cb05$var$Hh = 0;
    $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = $c79bde28d689cb05$var$M = null;
    $c79bde28d689cb05$var$Ih = !1;
    if (b) throw Error($c79bde28d689cb05$var$p(300));
    return a;
}
function $c79bde28d689cb05$var$Sh() {
    var a = 0 !== $c79bde28d689cb05$var$Kh;
    $c79bde28d689cb05$var$Kh = 0;
    return a;
}
function $c79bde28d689cb05$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c79bde28d689cb05$var$O ? $c79bde28d689cb05$var$M.memoizedState = $c79bde28d689cb05$var$O = a : $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$O.next = a;
    return $c79bde28d689cb05$var$O;
}
function $c79bde28d689cb05$var$Uh() {
    if (null === $c79bde28d689cb05$var$N) {
        var a = $c79bde28d689cb05$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c79bde28d689cb05$var$N.next;
    var b = null === $c79bde28d689cb05$var$O ? $c79bde28d689cb05$var$M.memoizedState : $c79bde28d689cb05$var$O.next;
    if (null !== b) $c79bde28d689cb05$var$O = b, $c79bde28d689cb05$var$N = a;
    else {
        if (null === a) throw Error($c79bde28d689cb05$var$p(310));
        $c79bde28d689cb05$var$N = a;
        a = {
            memoizedState: $c79bde28d689cb05$var$N.memoizedState,
            baseState: $c79bde28d689cb05$var$N.baseState,
            baseQueue: $c79bde28d689cb05$var$N.baseQueue,
            queue: $c79bde28d689cb05$var$N.queue,
            next: null
        };
        null === $c79bde28d689cb05$var$O ? $c79bde28d689cb05$var$M.memoizedState = $c79bde28d689cb05$var$O = a : $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$O.next = a;
    }
    return $c79bde28d689cb05$var$O;
}
function $c79bde28d689cb05$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c79bde28d689cb05$var$Wh(a) {
    var b = $c79bde28d689cb05$var$Uh(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c79bde28d689cb05$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c79bde28d689cb05$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c79bde28d689cb05$var$M.lanes |= m;
                $c79bde28d689cb05$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c79bde28d689cb05$var$He(d, b.memoizedState) || ($c79bde28d689cb05$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c79bde28d689cb05$var$M.lanes |= f, $c79bde28d689cb05$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c79bde28d689cb05$var$Xh(a) {
    var b = $c79bde28d689cb05$var$Uh(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c79bde28d689cb05$var$He(f, b.memoizedState) || ($c79bde28d689cb05$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c79bde28d689cb05$var$Yh() {}
function $c79bde28d689cb05$var$Zh(a, b) {
    var c = $c79bde28d689cb05$var$M, d = $c79bde28d689cb05$var$Uh(), e = b(), f = !$c79bde28d689cb05$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c79bde28d689cb05$var$dh = !0);
    d = d.queue;
    $c79bde28d689cb05$var$$h($c79bde28d689cb05$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c79bde28d689cb05$var$O && $c79bde28d689cb05$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c79bde28d689cb05$var$bi(9, $c79bde28d689cb05$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $c79bde28d689cb05$var$Q) throw Error($c79bde28d689cb05$var$p(349));
        0 !== ($c79bde28d689cb05$var$Hh & 30) || $c79bde28d689cb05$var$di(c, b, e);
    }
    return e;
}
function $c79bde28d689cb05$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c79bde28d689cb05$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c79bde28d689cb05$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c79bde28d689cb05$var$ei(b) && $c79bde28d689cb05$var$fi(a);
}
function $c79bde28d689cb05$var$ai(a, b, c) {
    return c(function() {
        $c79bde28d689cb05$var$ei(b) && $c79bde28d689cb05$var$fi(a);
    });
}
function $c79bde28d689cb05$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c79bde28d689cb05$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c79bde28d689cb05$var$fi(a) {
    var b = $c79bde28d689cb05$var$ih(a, 1);
    null !== b && $c79bde28d689cb05$var$gi(b, a, 1, -1);
}
function $c79bde28d689cb05$var$hi(a) {
    var b = $c79bde28d689cb05$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c79bde28d689cb05$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c79bde28d689cb05$var$ii.bind(null, $c79bde28d689cb05$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c79bde28d689cb05$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c79bde28d689cb05$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c79bde28d689cb05$var$ji() {
    return $c79bde28d689cb05$var$Uh().memoizedState;
}
function $c79bde28d689cb05$var$ki(a, b, c, d) {
    var e = $c79bde28d689cb05$var$Th();
    $c79bde28d689cb05$var$M.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c79bde28d689cb05$var$li(a, b, c, d) {
    var e = $c79bde28d689cb05$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c79bde28d689cb05$var$N) {
        var g = $c79bde28d689cb05$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $c79bde28d689cb05$var$Mh(d, g.deps)) {
            e.memoizedState = $c79bde28d689cb05$var$bi(b, c, f, d);
            return;
        }
    }
    $c79bde28d689cb05$var$M.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$bi(1 | b, c, f, d);
}
function $c79bde28d689cb05$var$mi(a, b) {
    return $c79bde28d689cb05$var$ki(8390656, 8, a, b);
}
function $c79bde28d689cb05$var$$h(a, b) {
    return $c79bde28d689cb05$var$li(2048, 8, a, b);
}
function $c79bde28d689cb05$var$ni(a, b) {
    return $c79bde28d689cb05$var$li(4, 2, a, b);
}
function $c79bde28d689cb05$var$oi(a, b) {
    return $c79bde28d689cb05$var$li(4, 4, a, b);
}
function $c79bde28d689cb05$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c79bde28d689cb05$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c79bde28d689cb05$var$li(4, 4, $c79bde28d689cb05$var$pi.bind(null, b, a), c);
}
function $c79bde28d689cb05$var$ri() {}
function $c79bde28d689cb05$var$si(a, b) {
    var c = $c79bde28d689cb05$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$ti(a, b) {
    var c = $c79bde28d689cb05$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$ui(a, b, c) {
    if (0 === ($c79bde28d689cb05$var$Hh & 21)) return a.baseState && (a.baseState = !1, $c79bde28d689cb05$var$dh = !0), a.memoizedState = c;
    $c79bde28d689cb05$var$He(c, b) || (c = $c79bde28d689cb05$var$yc(), $c79bde28d689cb05$var$M.lanes |= c, $c79bde28d689cb05$var$rh |= c, a.baseState = !0);
    return b;
}
function $c79bde28d689cb05$var$vi(a, b) {
    var c = $c79bde28d689cb05$var$C;
    $c79bde28d689cb05$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c79bde28d689cb05$var$Gh.transition;
    $c79bde28d689cb05$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$Gh.transition = d;
    }
}
function $c79bde28d689cb05$var$wi() {
    return $c79bde28d689cb05$var$Uh().memoizedState;
}
function $c79bde28d689cb05$var$xi(a, b, c) {
    var d = $c79bde28d689cb05$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$zi(a)) $c79bde28d689cb05$var$Ai(b, c);
    else if (c = $c79bde28d689cb05$var$hh(a, b, c, d), null !== c) {
        var e = $c79bde28d689cb05$var$R();
        $c79bde28d689cb05$var$gi(c, a, d, e);
        $c79bde28d689cb05$var$Bi(c, b, d);
    }
}
function $c79bde28d689cb05$var$ii(a, b, c) {
    var d = $c79bde28d689cb05$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$zi(a)) $c79bde28d689cb05$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c79bde28d689cb05$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c79bde28d689cb05$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c79bde28d689cb05$var$hh(a, b, e, d);
        null !== c && (e = $c79bde28d689cb05$var$R(), $c79bde28d689cb05$var$gi(c, a, d, e), $c79bde28d689cb05$var$Bi(c, b, d));
    }
}
function $c79bde28d689cb05$var$zi(a) {
    var b = a.alternate;
    return a === $c79bde28d689cb05$var$M || null !== b && b === $c79bde28d689cb05$var$M;
}
function $c79bde28d689cb05$var$Ai(a, b) {
    $c79bde28d689cb05$var$Jh = $c79bde28d689cb05$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c79bde28d689cb05$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
var $c79bde28d689cb05$var$Rh = {
    readContext: $c79bde28d689cb05$var$eh,
    useCallback: $c79bde28d689cb05$var$P,
    useContext: $c79bde28d689cb05$var$P,
    useEffect: $c79bde28d689cb05$var$P,
    useImperativeHandle: $c79bde28d689cb05$var$P,
    useInsertionEffect: $c79bde28d689cb05$var$P,
    useLayoutEffect: $c79bde28d689cb05$var$P,
    useMemo: $c79bde28d689cb05$var$P,
    useReducer: $c79bde28d689cb05$var$P,
    useRef: $c79bde28d689cb05$var$P,
    useState: $c79bde28d689cb05$var$P,
    useDebugValue: $c79bde28d689cb05$var$P,
    useDeferredValue: $c79bde28d689cb05$var$P,
    useTransition: $c79bde28d689cb05$var$P,
    useMutableSource: $c79bde28d689cb05$var$P,
    useSyncExternalStore: $c79bde28d689cb05$var$P,
    useId: $c79bde28d689cb05$var$P,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Oh = {
    readContext: $c79bde28d689cb05$var$eh,
    useCallback: function(a, b) {
        $c79bde28d689cb05$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c79bde28d689cb05$var$eh,
    useEffect: $c79bde28d689cb05$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c79bde28d689cb05$var$ki(4194308, 4, $c79bde28d689cb05$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c79bde28d689cb05$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c79bde28d689cb05$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c79bde28d689cb05$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c79bde28d689cb05$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c79bde28d689cb05$var$xi.bind(null, $c79bde28d689cb05$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c79bde28d689cb05$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c79bde28d689cb05$var$hi,
    useDebugValue: $c79bde28d689cb05$var$ri,
    useDeferredValue: function(a) {
        return $c79bde28d689cb05$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$hi(!1), b = a[0];
        a = $c79bde28d689cb05$var$vi.bind(null, a[1]);
        $c79bde28d689cb05$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c79bde28d689cb05$var$M, e = $c79bde28d689cb05$var$Th();
        if ($c79bde28d689cb05$var$I) {
            if (void 0 === c) throw Error($c79bde28d689cb05$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c79bde28d689cb05$var$Q) throw Error($c79bde28d689cb05$var$p(349));
            0 !== ($c79bde28d689cb05$var$Hh & 30) || $c79bde28d689cb05$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c79bde28d689cb05$var$mi($c79bde28d689cb05$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c79bde28d689cb05$var$bi(9, $c79bde28d689cb05$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c79bde28d689cb05$var$Th(), b = $c79bde28d689cb05$var$Q.identifierPrefix;
        if ($c79bde28d689cb05$var$I) {
            var c = $c79bde28d689cb05$var$sg;
            var d = $c79bde28d689cb05$var$rg;
            c = (d & ~(1 << 32 - $c79bde28d689cb05$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c79bde28d689cb05$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c79bde28d689cb05$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Ph = {
    readContext: $c79bde28d689cb05$var$eh,
    useCallback: $c79bde28d689cb05$var$si,
    useContext: $c79bde28d689cb05$var$eh,
    useEffect: $c79bde28d689cb05$var$$h,
    useImperativeHandle: $c79bde28d689cb05$var$qi,
    useInsertionEffect: $c79bde28d689cb05$var$ni,
    useLayoutEffect: $c79bde28d689cb05$var$oi,
    useMemo: $c79bde28d689cb05$var$ti,
    useReducer: $c79bde28d689cb05$var$Wh,
    useRef: $c79bde28d689cb05$var$ji,
    useState: function() {
        return $c79bde28d689cb05$var$Wh($c79bde28d689cb05$var$Vh);
    },
    useDebugValue: $c79bde28d689cb05$var$ri,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$Uh();
        return $c79bde28d689cb05$var$ui(b, $c79bde28d689cb05$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$Wh($c79bde28d689cb05$var$Vh)[0], b = $c79bde28d689cb05$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$Yh,
    useSyncExternalStore: $c79bde28d689cb05$var$Zh,
    useId: $c79bde28d689cb05$var$wi,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Qh = {
    readContext: $c79bde28d689cb05$var$eh,
    useCallback: $c79bde28d689cb05$var$si,
    useContext: $c79bde28d689cb05$var$eh,
    useEffect: $c79bde28d689cb05$var$$h,
    useImperativeHandle: $c79bde28d689cb05$var$qi,
    useInsertionEffect: $c79bde28d689cb05$var$ni,
    useLayoutEffect: $c79bde28d689cb05$var$oi,
    useMemo: $c79bde28d689cb05$var$ti,
    useReducer: $c79bde28d689cb05$var$Xh,
    useRef: $c79bde28d689cb05$var$ji,
    useState: function() {
        return $c79bde28d689cb05$var$Xh($c79bde28d689cb05$var$Vh);
    },
    useDebugValue: $c79bde28d689cb05$var$ri,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$Uh();
        return null === $c79bde28d689cb05$var$N ? b.memoizedState = a : $c79bde28d689cb05$var$ui(b, $c79bde28d689cb05$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$Xh($c79bde28d689cb05$var$Vh)[0], b = $c79bde28d689cb05$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$Yh,
    useSyncExternalStore: $c79bde28d689cb05$var$Zh,
    useId: $c79bde28d689cb05$var$wi,
    unstable_isNewReconciler: !1
};
function $c79bde28d689cb05$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $c79bde28d689cb05$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $c79bde28d689cb05$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c79bde28d689cb05$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c79bde28d689cb05$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c79bde28d689cb05$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$R(), e = $c79bde28d689cb05$var$yi(a), f = $c79bde28d689cb05$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$nh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$gi(b, a, e, d), $c79bde28d689cb05$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$R(), e = $c79bde28d689cb05$var$yi(a), f = $c79bde28d689cb05$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$nh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$gi(b, a, e, d), $c79bde28d689cb05$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c79bde28d689cb05$var$R(), d = $c79bde28d689cb05$var$yi(a), e = $c79bde28d689cb05$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c79bde28d689cb05$var$nh(a, e, d);
        null !== b && ($c79bde28d689cb05$var$gi(b, a, d, c), $c79bde28d689cb05$var$oh(b, a, d));
    }
};
function $c79bde28d689cb05$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c79bde28d689cb05$var$Ie(c, d) || !$c79bde28d689cb05$var$Ie(e, f) : !0;
}
function $c79bde28d689cb05$var$Gi(a, b, c) {
    var d = !1, e = $c79bde28d689cb05$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c79bde28d689cb05$var$eh(f) : (e = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c79bde28d689cb05$var$Yf(a, e) : $c79bde28d689cb05$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c79bde28d689cb05$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c79bde28d689cb05$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c79bde28d689cb05$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $c79bde28d689cb05$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $c79bde28d689cb05$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c79bde28d689cb05$var$eh(f) : (f = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, e.context = $c79bde28d689cb05$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c79bde28d689cb05$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c79bde28d689cb05$var$Ei.enqueueReplaceState(e, e.state, null), $c79bde28d689cb05$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c79bde28d689cb05$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $c79bde28d689cb05$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c79bde28d689cb05$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c79bde28d689cb05$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c79bde28d689cb05$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $c79bde28d689cb05$var$Ni(a, b, c) {
    c = $c79bde28d689cb05$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c79bde28d689cb05$var$Oi || ($c79bde28d689cb05$var$Oi = !0, $c79bde28d689cb05$var$Pi = d);
        $c79bde28d689cb05$var$Li(a, b);
    };
    return c;
}
function $c79bde28d689cb05$var$Qi(a, b, c) {
    c = $c79bde28d689cb05$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c79bde28d689cb05$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c79bde28d689cb05$var$Li(a, b);
        "function" !== typeof d && (null === $c79bde28d689cb05$var$Ri ? $c79bde28d689cb05$var$Ri = new Set([
            this
        ]) : $c79bde28d689cb05$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c79bde28d689cb05$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c79bde28d689cb05$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c79bde28d689cb05$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $c79bde28d689cb05$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c79bde28d689cb05$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c79bde28d689cb05$var$mh(-1, 1), b.tag = 2, $c79bde28d689cb05$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c79bde28d689cb05$var$Wi = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$dh = !1;
function $c79bde28d689cb05$var$Xi(a, b, c, d) {
    b.child = null === a ? $c79bde28d689cb05$var$Vg(b, null, c, d) : $c79bde28d689cb05$var$Ug(b, a.child, c, d);
}
function $c79bde28d689cb05$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c79bde28d689cb05$var$ch(b, e);
    d = $c79bde28d689cb05$var$Nh(a, b, c, d, f, e);
    c = $c79bde28d689cb05$var$Sh();
    if (null !== a && !$c79bde28d689cb05$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$Zi(a, b, e);
    $c79bde28d689cb05$var$I && c && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Xi(a, b, d, e);
    return b.child;
}
function $c79bde28d689cb05$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c79bde28d689cb05$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c79bde28d689cb05$var$bj(a, b, f, d, e);
        a = $c79bde28d689cb05$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c79bde28d689cb05$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c79bde28d689cb05$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $c79bde28d689cb05$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c79bde28d689cb05$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c79bde28d689cb05$var$Ie(f, d) && a.ref === b.ref) {
            if ($c79bde28d689cb05$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c79bde28d689cb05$var$dh = !0);
            else return b.lanes = a.lanes, $c79bde28d689cb05$var$Zi(a, b, e);
        }
    }
    return $c79bde28d689cb05$var$cj(a, b, c, d, e);
}
function $c79bde28d689cb05$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$ej, $c79bde28d689cb05$var$fj), $c79bde28d689cb05$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$ej, $c79bde28d689cb05$var$fj), $c79bde28d689cb05$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$ej, $c79bde28d689cb05$var$fj);
            $c79bde28d689cb05$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$ej, $c79bde28d689cb05$var$fj), $c79bde28d689cb05$var$fj |= d;
    $c79bde28d689cb05$var$Xi(a, b, e, c);
    return b.child;
}
function $c79bde28d689cb05$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c79bde28d689cb05$var$cj(a, b, c, d, e) {
    var f = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current;
    f = $c79bde28d689cb05$var$Yf(b, f);
    $c79bde28d689cb05$var$ch(b, e);
    c = $c79bde28d689cb05$var$Nh(a, b, c, d, f, e);
    d = $c79bde28d689cb05$var$Sh();
    if (null !== a && !$c79bde28d689cb05$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$Zi(a, b, e);
    $c79bde28d689cb05$var$I && d && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Xi(a, b, c, e);
    return b.child;
}
function $c79bde28d689cb05$var$hj(a, b, c, d, e) {
    if ($c79bde28d689cb05$var$Zf(c)) {
        var f = !0;
        $c79bde28d689cb05$var$cg(b);
    } else f = !1;
    $c79bde28d689cb05$var$ch(b, e);
    if (null === b.stateNode) $c79bde28d689cb05$var$ij(a, b), $c79bde28d689cb05$var$Gi(b, c, d), $c79bde28d689cb05$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c79bde28d689cb05$var$eh(l) : (l = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, l = $c79bde28d689cb05$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c79bde28d689cb05$var$Hi(b, g, d, l);
        $c79bde28d689cb05$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$jh ? ("function" === typeof m && ($c79bde28d689cb05$var$Di(b, c, m, d), k = b.memoizedState), (h = $c79bde28d689cb05$var$jh || $c79bde28d689cb05$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c79bde28d689cb05$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c79bde28d689cb05$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c79bde28d689cb05$var$eh(k) : (k = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, k = $c79bde28d689cb05$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c79bde28d689cb05$var$Hi(b, g, d, k);
        $c79bde28d689cb05$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$jh ? ("function" === typeof y && ($c79bde28d689cb05$var$Di(b, c, y, d), n = b.memoizedState), (l = $c79bde28d689cb05$var$jh || $c79bde28d689cb05$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c79bde28d689cb05$var$jj(a, b, c, d, f, e);
}
function $c79bde28d689cb05$var$jj(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c79bde28d689cb05$var$dg(b, c, !1), $c79bde28d689cb05$var$Zi(a, b, f);
    d = b.stateNode;
    $c79bde28d689cb05$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c79bde28d689cb05$var$Ug(b, a.child, null, f), b.child = $c79bde28d689cb05$var$Ug(b, null, h, f)) : $c79bde28d689cb05$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c79bde28d689cb05$var$dg(b, c, !0);
    return b.child;
}
function $c79bde28d689cb05$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c79bde28d689cb05$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c79bde28d689cb05$var$ag(a, b.context, !1);
    $c79bde28d689cb05$var$yh(a, b.containerInfo);
}
function $c79bde28d689cb05$var$lj(a, b, c, d, e) {
    $c79bde28d689cb05$var$Ig();
    $c79bde28d689cb05$var$Jg(e);
    b.flags |= 256;
    $c79bde28d689cb05$var$Xi(a, b, c, d);
    return b.child;
}
var $c79bde28d689cb05$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c79bde28d689cb05$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c79bde28d689cb05$var$oj(a, b, c) {
    var d = b.pendingProps, e = $c79bde28d689cb05$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, e & 1);
    if (null === a) {
        $c79bde28d689cb05$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c79bde28d689cb05$var$pj(g, d, 0, null), a = $c79bde28d689cb05$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c79bde28d689cb05$var$nj(c), b.memoizedState = $c79bde28d689cb05$var$mj, a) : $c79bde28d689cb05$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c79bde28d689cb05$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c79bde28d689cb05$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c79bde28d689cb05$var$Pg(h, f) : (f = $c79bde28d689cb05$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c79bde28d689cb05$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c79bde28d689cb05$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c79bde28d689cb05$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c79bde28d689cb05$var$qj(a, b) {
    b = $c79bde28d689cb05$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c79bde28d689cb05$var$sj(a, b, c, d) {
    null !== d && $c79bde28d689cb05$var$Jg(d);
    $c79bde28d689cb05$var$Ug(b, a.child, null, c);
    a = $c79bde28d689cb05$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c79bde28d689cb05$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(422))), $c79bde28d689cb05$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c79bde28d689cb05$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c79bde28d689cb05$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c79bde28d689cb05$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $c79bde28d689cb05$var$nj(g);
        b.memoizedState = $c79bde28d689cb05$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c79bde28d689cb05$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c79bde28d689cb05$var$p(419));
        d = $c79bde28d689cb05$var$Ki(f, d, void 0);
        return $c79bde28d689cb05$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c79bde28d689cb05$var$dh || h) {
        d = $c79bde28d689cb05$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c79bde28d689cb05$var$ih(a, e), $c79bde28d689cb05$var$gi(d, a, e, -1));
        }
        $c79bde28d689cb05$var$tj();
        d = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(421)));
        return $c79bde28d689cb05$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c79bde28d689cb05$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(e.nextSibling);
    $c79bde28d689cb05$var$xg = b;
    $c79bde28d689cb05$var$I = !0;
    $c79bde28d689cb05$var$zg = null;
    null !== a && ($c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg, $c79bde28d689cb05$var$rg = a.id, $c79bde28d689cb05$var$sg = a.overflow, $c79bde28d689cb05$var$qg = b);
    b = $c79bde28d689cb05$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c79bde28d689cb05$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c79bde28d689cb05$var$bh(a.return, b, c);
}
function $c79bde28d689cb05$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c79bde28d689cb05$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c79bde28d689cb05$var$Xi(a, b, d.children, c);
    d = $c79bde28d689cb05$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c79bde28d689cb05$var$vj(a, c, b);
            else if (19 === a.tag) $c79bde28d689cb05$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c79bde28d689cb05$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c79bde28d689cb05$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c79bde28d689cb05$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c79bde28d689cb05$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $c79bde28d689cb05$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c79bde28d689cb05$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c79bde28d689cb05$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c79bde28d689cb05$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c79bde28d689cb05$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c79bde28d689cb05$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $c79bde28d689cb05$var$kj(b);
            $c79bde28d689cb05$var$Ig();
            break;
        case 5:
            $c79bde28d689cb05$var$Ah(b);
            break;
        case 1:
            $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$cg(b);
            break;
        case 4:
            $c79bde28d689cb05$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c79bde28d689cb05$var$oj(a, b, c);
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current & 1);
                a = $c79bde28d689cb05$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c79bde28d689cb05$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c79bde28d689cb05$var$dj(a, b, c);
    }
    return $c79bde28d689cb05$var$Zi(a, b, c);
}
var $c79bde28d689cb05$var$zj, $c79bde28d689cb05$var$Aj, $c79bde28d689cb05$var$Bj, $c79bde28d689cb05$var$Cj;
$c79bde28d689cb05$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c79bde28d689cb05$var$Aj = function() {};
$c79bde28d689cb05$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c79bde28d689cb05$var$Ya(a, e);
                d = $c79bde28d689cb05$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c79bde28d689cb05$var$A({}, e, {
                    value: void 0
                });
                d = $c79bde28d689cb05$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c79bde28d689cb05$var$gb(a, e);
                d = $c79bde28d689cb05$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
        }
        $c79bde28d689cb05$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c79bde28d689cb05$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c79bde28d689cb05$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c79bde28d689cb05$var$Dj(a, b) {
    if (!$c79bde28d689cb05$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c79bde28d689cb05$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c79bde28d689cb05$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c79bde28d689cb05$var$S(b), null;
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c79bde28d689cb05$var$zh();
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
            $c79bde28d689cb05$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c79bde28d689cb05$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Fj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null));
            $c79bde28d689cb05$var$Aj(a, b);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 5:
            $c79bde28d689cb05$var$Bh(b);
            var e = $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c79bde28d689cb05$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                    $c79bde28d689cb05$var$S(b);
                    return null;
                }
                a = $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$uh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    d[$c79bde28d689cb05$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c79bde28d689cb05$var$D("cancel", d);
                            $c79bde28d689cb05$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], d);
                            break;
                        case "source":
                            $c79bde28d689cb05$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c79bde28d689cb05$var$D("error", d);
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "details":
                            $c79bde28d689cb05$var$D("toggle", d);
                            break;
                        case "input":
                            $c79bde28d689cb05$var$Za(d, f);
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$hb(d, f), $c79bde28d689cb05$var$D("invalid", d);
                    }
                    $c79bde28d689cb05$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c79bde28d689cb05$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c79bde28d689cb05$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c79bde28d689cb05$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c79bde28d689cb05$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c79bde28d689cb05$var$Of] = b;
                    a[$c79bde28d689cb05$var$Pf] = d;
                    $c79bde28d689cb05$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c79bde28d689cb05$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c79bde28d689cb05$var$D("cancel", a);
                                $c79bde28d689cb05$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c79bde28d689cb05$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c79bde28d689cb05$var$D("error", a);
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c79bde28d689cb05$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c79bde28d689cb05$var$Za(a, d);
                                e = $c79bde28d689cb05$var$Ya(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c79bde28d689cb05$var$A({}, d, {
                                    value: void 0
                                });
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$hb(a, d);
                                e = $c79bde28d689cb05$var$gb(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c79bde28d689cb05$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c79bde28d689cb05$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c79bde28d689cb05$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c79bde28d689cb05$var$ob(a, k) : "number" === typeof k && $c79bde28d689cb05$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c79bde28d689cb05$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c79bde28d689cb05$var$D("scroll", a) : null != k && $c79bde28d689cb05$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c79bde28d689cb05$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c79bde28d689cb05$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c79bde28d689cb05$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c79bde28d689cb05$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                c = $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$wh.current);
                $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$uh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c79bde28d689cb05$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c79bde28d689cb05$var$Of] = b, b.stateNode = d;
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c79bde28d689cb05$var$I && null !== $c79bde28d689cb05$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c79bde28d689cb05$var$Hg(), $c79bde28d689cb05$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c79bde28d689cb05$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c79bde28d689cb05$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c79bde28d689cb05$var$p(317));
                        f[$c79bde28d689cb05$var$Of] = b;
                    } else $c79bde28d689cb05$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c79bde28d689cb05$var$S(b);
                    f = !1;
                } else null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Fj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c79bde28d689cb05$var$L.current & 1) ? 0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 3) : $c79bde28d689cb05$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 4:
            return $c79bde28d689cb05$var$zh(), $c79bde28d689cb05$var$Aj(a, b), null === a && $c79bde28d689cb05$var$sf(b.stateNode.containerInfo), $c79bde28d689cb05$var$S(b), null;
        case 10:
            return $c79bde28d689cb05$var$ah(b.type._context), $c79bde28d689cb05$var$S(b), null;
        case 17:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 19:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
            f = b.memoizedState;
            if (null === f) return $c79bde28d689cb05$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c79bde28d689cb05$var$Dj(f, !1);
                else {
                    if (0 !== $c79bde28d689cb05$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c79bde28d689cb05$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c79bde28d689cb05$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c79bde28d689cb05$var$B() > $c79bde28d689cb05$var$Gj && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c79bde28d689cb05$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c79bde28d689cb05$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$S(b), null;
                    } else 2 * $c79bde28d689cb05$var$B() - f.renderingStartTime > $c79bde28d689cb05$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c79bde28d689cb05$var$B(), b.sibling = null, c = $c79bde28d689cb05$var$L.current, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, d ? c & 1 | 2 : c & 1), b;
            $c79bde28d689cb05$var$S(b);
            return null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c79bde28d689cb05$var$fj & 1073741824) && ($c79bde28d689cb05$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c79bde28d689cb05$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
}
function $c79bde28d689cb05$var$Ij(a, b) {
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c79bde28d689cb05$var$zh(), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c79bde28d689cb05$var$Bh(b), null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c79bde28d689cb05$var$p(340));
                $c79bde28d689cb05$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L), null;
        case 4:
            return $c79bde28d689cb05$var$zh(), null;
        case 10:
            return $c79bde28d689cb05$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$Jj = !1, $c79bde28d689cb05$var$U = !1, $c79bde28d689cb05$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $c79bde28d689cb05$var$V = null;
function $c79bde28d689cb05$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c79bde28d689cb05$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c79bde28d689cb05$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c79bde28d689cb05$var$W(a, b, d);
    }
}
var $c79bde28d689cb05$var$Nj = !1;
function $c79bde28d689cb05$var$Oj(a, b) {
    $c79bde28d689cb05$var$Cf = $c79bde28d689cb05$var$dd;
    a = $c79bde28d689cb05$var$Me();
    if ($c79bde28d689cb05$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c79bde28d689cb05$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c79bde28d689cb05$var$dd = !1;
    for($c79bde28d689cb05$var$V = b; null !== $c79bde28d689cb05$var$V;)if (b = $c79bde28d689cb05$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c79bde28d689cb05$var$V = a;
    else for(; null !== $c79bde28d689cb05$var$V;){
        b = $c79bde28d689cb05$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c79bde28d689cb05$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(163));
            }
        } catch (F) {
            $c79bde28d689cb05$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c79bde28d689cb05$var$V = a;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
    n = $c79bde28d689cb05$var$Nj;
    $c79bde28d689cb05$var$Nj = !1;
    return n;
}
function $c79bde28d689cb05$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c79bde28d689cb05$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c79bde28d689cb05$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c79bde28d689cb05$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c79bde28d689cb05$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c79bde28d689cb05$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c79bde28d689cb05$var$Of], delete b[$c79bde28d689cb05$var$Pf], delete b[$c79bde28d689cb05$var$of], delete b[$c79bde28d689cb05$var$Qf], delete b[$c79bde28d689cb05$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c79bde28d689cb05$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c79bde28d689cb05$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c79bde28d689cb05$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c79bde28d689cb05$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c79bde28d689cb05$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Vj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Vj(a, b, c), a = a.sibling;
}
function $c79bde28d689cb05$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling;
}
var $c79bde28d689cb05$var$X = null, $c79bde28d689cb05$var$Xj = !1;
function $c79bde28d689cb05$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$c79bde28d689cb05$var$Zj(a, b, c), c = c.sibling;
}
function $c79bde28d689cb05$var$Zj(a, b, c) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberUnmount) try {
        $c79bde28d689cb05$var$lc.onCommitFiberUnmount($c79bde28d689cb05$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Lj(c, b);
        case 6:
            var d = $c79bde28d689cb05$var$X, e = $c79bde28d689cb05$var$Xj;
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Yj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Xj = e;
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Xj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c79bde28d689cb05$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Xj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? $c79bde28d689cb05$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c79bde28d689cb05$var$Kf(a, c), $c79bde28d689cb05$var$bd(a)) : $c79bde28d689cb05$var$Kf($c79bde28d689cb05$var$X, c.stateNode));
            break;
        case 4:
            d = $c79bde28d689cb05$var$X;
            e = $c79bde28d689cb05$var$Xj;
            $c79bde28d689cb05$var$X = c.stateNode.containerInfo;
            $c79bde28d689cb05$var$Xj = !0;
            $c79bde28d689cb05$var$Yj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c79bde28d689cb05$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c79bde28d689cb05$var$Mj(c, b, g) : 0 !== (f & 4) && $c79bde28d689cb05$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c79bde28d689cb05$var$Yj(a, b, c);
            break;
        case 1:
            if (!$c79bde28d689cb05$var$U && ($c79bde28d689cb05$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c79bde28d689cb05$var$W(c, b, h);
            }
            $c79bde28d689cb05$var$Yj(a, b, c);
            break;
        case 21:
            $c79bde28d689cb05$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c79bde28d689cb05$var$U = (d = $c79bde28d689cb05$var$U) || null !== c.memoizedState, $c79bde28d689cb05$var$Yj(a, b, c), $c79bde28d689cb05$var$U = d) : $c79bde28d689cb05$var$Yj(a, b, c);
            break;
        default:
            $c79bde28d689cb05$var$Yj(a, b, c);
    }
}
function $c79bde28d689cb05$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c79bde28d689cb05$var$Kj);
        b.forEach(function(b) {
            var d = $c79bde28d689cb05$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c79bde28d689cb05$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c79bde28d689cb05$var$X = h.stateNode;
                        $c79bde28d689cb05$var$Xj = !1;
                        break a;
                    case 3:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Xj = !0;
                        break a;
                    case 4:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c79bde28d689cb05$var$X) throw Error($c79bde28d689cb05$var$p(160));
            $c79bde28d689cb05$var$Zj(f, g, e);
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c79bde28d689cb05$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c79bde28d689cb05$var$dk(b, a), b = b.sibling;
}
function $c79bde28d689cb05$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            if (d & 4) {
                try {
                    $c79bde28d689cb05$var$Pj(3, a, a.return), $c79bde28d689cb05$var$Qj(3, a);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
                try {
                    $c79bde28d689cb05$var$Pj(5, a, a.return);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Lj(c, c.return);
            break;
        case 5:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c79bde28d689cb05$var$ob(e, "");
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c79bde28d689cb05$var$ab(e, f);
                    $c79bde28d689cb05$var$vb(h, g);
                    var l = $c79bde28d689cb05$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c79bde28d689cb05$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c79bde28d689cb05$var$nb(e, q) : "children" === m ? $c79bde28d689cb05$var$ob(e, q) : $c79bde28d689cb05$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c79bde28d689cb05$var$bb(e, f);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c79bde28d689cb05$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c79bde28d689cb05$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c79bde28d689cb05$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c79bde28d689cb05$var$Pf] = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c79bde28d689cb05$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c79bde28d689cb05$var$bd(b.containerInfo);
            } catch (t) {
                $c79bde28d689cb05$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            break;
        case 13:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c79bde28d689cb05$var$fk = $c79bde28d689cb05$var$B()));
            d & 4 && $c79bde28d689cb05$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c79bde28d689cb05$var$U = (l = $c79bde28d689cb05$var$U) || m, $c79bde28d689cb05$var$ck(b, a), $c79bde28d689cb05$var$U = l) : $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c79bde28d689cb05$var$V = a, m = a.child; null !== m;){
                    for(q = $c79bde28d689cb05$var$V = m; null !== $c79bde28d689cb05$var$V;){
                        r = $c79bde28d689cb05$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c79bde28d689cb05$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $c79bde28d689cb05$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c79bde28d689cb05$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c79bde28d689cb05$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c79bde28d689cb05$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c79bde28d689cb05$var$V = y) : $c79bde28d689cb05$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c79bde28d689cb05$var$rb("display", g));
                            } catch (t) {
                                $c79bde28d689cb05$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c79bde28d689cb05$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            d & 4 && $c79bde28d689cb05$var$ak(a);
            break;
        case 21:
            break;
        default:
            $c79bde28d689cb05$var$ck(b, a), $c79bde28d689cb05$var$ek(a);
    }
}
function $c79bde28d689cb05$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c79bde28d689cb05$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c79bde28d689cb05$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c79bde28d689cb05$var$ob(e, ""), d.flags &= -33);
                    var f = $c79bde28d689cb05$var$Uj(a);
                    $c79bde28d689cb05$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c79bde28d689cb05$var$Uj(a);
                    $c79bde28d689cb05$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(161));
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c79bde28d689cb05$var$hk(a, b, c) {
    $c79bde28d689cb05$var$V = a;
    $c79bde28d689cb05$var$ik(a, b, c);
}
function $c79bde28d689cb05$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c79bde28d689cb05$var$V;){
        var e = $c79bde28d689cb05$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c79bde28d689cb05$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c79bde28d689cb05$var$U;
                h = $c79bde28d689cb05$var$Jj;
                var l = $c79bde28d689cb05$var$U;
                $c79bde28d689cb05$var$Jj = g;
                if (($c79bde28d689cb05$var$U = k) && !l) for($c79bde28d689cb05$var$V = e; null !== $c79bde28d689cb05$var$V;)g = $c79bde28d689cb05$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c79bde28d689cb05$var$jk(e) : null !== k ? (k.return = g, $c79bde28d689cb05$var$V = k) : $c79bde28d689cb05$var$jk(e);
                for(; null !== f;)$c79bde28d689cb05$var$V = f, $c79bde28d689cb05$var$ik(f, b, c), f = f.sibling;
                $c79bde28d689cb05$var$V = e;
                $c79bde28d689cb05$var$Jj = h;
                $c79bde28d689cb05$var$U = l;
            }
            $c79bde28d689cb05$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c79bde28d689cb05$var$V = f) : $c79bde28d689cb05$var$kk(a, b, c);
    }
}
function $c79bde28d689cb05$var$kk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c79bde28d689cb05$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c79bde28d689cb05$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c79bde28d689cb05$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c79bde28d689cb05$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c79bde28d689cb05$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c79bde28d689cb05$var$p(163));
                }
                $c79bde28d689cb05$var$U || b.flags & 512 && $c79bde28d689cb05$var$Rj(b);
            } catch (r) {
                $c79bde28d689cb05$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$gk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$jk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c79bde28d689cb05$var$Qj(4, b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c79bde28d689cb05$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(b, b.return, k);
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c79bde28d689cb05$var$V = h;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
var $c79bde28d689cb05$var$lk = Math.ceil, $c79bde28d689cb05$var$mk = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$nk = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$ok = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$K = 0, $c79bde28d689cb05$var$Q = null, $c79bde28d689cb05$var$Y = null, $c79bde28d689cb05$var$Z = 0, $c79bde28d689cb05$var$fj = 0, $c79bde28d689cb05$var$ej = $c79bde28d689cb05$var$Uf(0), $c79bde28d689cb05$var$T = 0, $c79bde28d689cb05$var$pk = null, $c79bde28d689cb05$var$rh = 0, $c79bde28d689cb05$var$qk = 0, $c79bde28d689cb05$var$rk = 0, $c79bde28d689cb05$var$sk = null, $c79bde28d689cb05$var$tk = null, $c79bde28d689cb05$var$fk = 0, $c79bde28d689cb05$var$Gj = Infinity, $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$Oi = !1, $c79bde28d689cb05$var$Pi = null, $c79bde28d689cb05$var$Ri = null, $c79bde28d689cb05$var$vk = !1, $c79bde28d689cb05$var$wk = null, $c79bde28d689cb05$var$xk = 0, $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = null, $c79bde28d689cb05$var$Ak = -1, $c79bde28d689cb05$var$Bk = 0;
function $c79bde28d689cb05$var$R() {
    return 0 !== ($c79bde28d689cb05$var$K & 6) ? $c79bde28d689cb05$var$B() : -1 !== $c79bde28d689cb05$var$Ak ? $c79bde28d689cb05$var$Ak : $c79bde28d689cb05$var$Ak = $c79bde28d689cb05$var$B();
}
function $c79bde28d689cb05$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c79bde28d689cb05$var$K & 2) && 0 !== $c79bde28d689cb05$var$Z) return $c79bde28d689cb05$var$Z & -$c79bde28d689cb05$var$Z;
    if (null !== $c79bde28d689cb05$var$Kg.transition) return 0 === $c79bde28d689cb05$var$Bk && ($c79bde28d689cb05$var$Bk = $c79bde28d689cb05$var$yc()), $c79bde28d689cb05$var$Bk;
    a = $c79bde28d689cb05$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c79bde28d689cb05$var$jd(a.type);
    return a;
}
function $c79bde28d689cb05$var$gi(a, b, c, d) {
    if (50 < $c79bde28d689cb05$var$yk) throw $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = null, Error($c79bde28d689cb05$var$p(185));
    $c79bde28d689cb05$var$Ac(a, c, d);
    if (0 === ($c79bde28d689cb05$var$K & 2) || a !== $c79bde28d689cb05$var$Q) a === $c79bde28d689cb05$var$Q && (0 === ($c79bde28d689cb05$var$K & 2) && ($c79bde28d689cb05$var$qk |= c), 4 === $c79bde28d689cb05$var$T && $c79bde28d689cb05$var$Ck(a, $c79bde28d689cb05$var$Z)), $c79bde28d689cb05$var$Dk(a, d), 1 === c && 0 === $c79bde28d689cb05$var$K && 0 === (b.mode & 1) && ($c79bde28d689cb05$var$Gj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
}
function $c79bde28d689cb05$var$Dk(a, b) {
    var c = a.callbackNode;
    $c79bde28d689cb05$var$wc(a, b);
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$Q ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) null !== c && $c79bde28d689cb05$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c79bde28d689cb05$var$bc(c);
        if (1 === b) 0 === a.tag ? $c79bde28d689cb05$var$ig($c79bde28d689cb05$var$Ek.bind(null, a)) : $c79bde28d689cb05$var$hg($c79bde28d689cb05$var$Ek.bind(null, a)), $c79bde28d689cb05$var$Jf(function() {
            0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
        }), c = null;
        else {
            switch($c79bde28d689cb05$var$Dc(d)){
                case 1:
                    c = $c79bde28d689cb05$var$fc;
                    break;
                case 4:
                    c = $c79bde28d689cb05$var$gc;
                    break;
                case 16:
                    c = $c79bde28d689cb05$var$hc;
                    break;
                case 536870912:
                    c = $c79bde28d689cb05$var$jc;
                    break;
                default:
                    c = $c79bde28d689cb05$var$hc;
            }
            c = $c79bde28d689cb05$var$Fk(c, $c79bde28d689cb05$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c79bde28d689cb05$var$Gk(a, b) {
    $c79bde28d689cb05$var$Ak = -1;
    $c79bde28d689cb05$var$Bk = 0;
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    var c = a.callbackNode;
    if ($c79bde28d689cb05$var$Hk() && a.callbackNode !== c) return null;
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$Q ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c79bde28d689cb05$var$Ik(a, d);
    else {
        b = d;
        var e = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 2;
        var f = $c79bde28d689cb05$var$Jk();
        if ($c79bde28d689cb05$var$Q !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$Gj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$Kk(a, b);
        for(;;)try {
            $c79bde28d689cb05$var$Lk();
            break;
        } catch (h) {
            $c79bde28d689cb05$var$Mk(a, h);
        }
        $c79bde28d689cb05$var$$g();
        $c79bde28d689cb05$var$mk.current = f;
        $c79bde28d689cb05$var$K = e;
        null !== $c79bde28d689cb05$var$Y ? b = 0 : ($c79bde28d689cb05$var$Q = null, $c79bde28d689cb05$var$Z = 0, b = $c79bde28d689cb05$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c79bde28d689cb05$var$xc(a), 0 !== e && (d = e, b = $c79bde28d689cb05$var$Nk(a, e)));
        if (1 === b) throw c = $c79bde28d689cb05$var$pk, $c79bde28d689cb05$var$Kk(a, 0), $c79bde28d689cb05$var$Ck(a, d), $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B()), c;
        if (6 === b) $c79bde28d689cb05$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c79bde28d689cb05$var$Ok(e) && (b = $c79bde28d689cb05$var$Ik(a, d), 2 === b && (f = $c79bde28d689cb05$var$xc(a), 0 !== f && (d = f, b = $c79bde28d689cb05$var$Nk(a, f))), 1 === b)) throw c = $c79bde28d689cb05$var$pk, $c79bde28d689cb05$var$Kk(a, 0), $c79bde28d689cb05$var$Ck(a, d), $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c79bde28d689cb05$var$p(345));
                case 2:
                    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
                    break;
                case 3:
                    $c79bde28d689cb05$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $c79bde28d689cb05$var$fk + 500 - $c79bde28d689cb05$var$B(), 10 < b)) {
                        if (0 !== $c79bde28d689cb05$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c79bde28d689cb05$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Pk.bind(null, a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk), b);
                        break;
                    }
                    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
                    break;
                case 4:
                    $c79bde28d689cb05$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c79bde28d689cb05$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c79bde28d689cb05$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c79bde28d689cb05$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Pk.bind(null, a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk), d);
                        break;
                    }
                    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
                    break;
                case 5:
                    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(329));
            }
        }
    }
    $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B());
    return a.callbackNode === c ? $c79bde28d689cb05$var$Gk.bind(null, a) : null;
}
function $c79bde28d689cb05$var$Nk(a, b) {
    var c = $c79bde28d689cb05$var$sk;
    a.current.memoizedState.isDehydrated && ($c79bde28d689cb05$var$Kk(a, b).flags |= 256);
    a = $c79bde28d689cb05$var$Ik(a, b);
    2 !== a && (b = $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$tk = c, null !== b && $c79bde28d689cb05$var$Fj(b));
    return a;
}
function $c79bde28d689cb05$var$Fj(a) {
    null === $c79bde28d689cb05$var$tk ? $c79bde28d689cb05$var$tk = a : $c79bde28d689cb05$var$tk.push.apply($c79bde28d689cb05$var$tk, a);
}
function $c79bde28d689cb05$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c79bde28d689cb05$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c79bde28d689cb05$var$Ck(a, b) {
    b &= ~$c79bde28d689cb05$var$rk;
    b &= ~$c79bde28d689cb05$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c79bde28d689cb05$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c79bde28d689cb05$var$Ek(a) {
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    $c79bde28d689cb05$var$Hk();
    var b = $c79bde28d689cb05$var$uc(a, 0);
    if (0 === (b & 1)) return $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B()), null;
    var c = $c79bde28d689cb05$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c79bde28d689cb05$var$xc(a);
        0 !== d && (b = d, c = $c79bde28d689cb05$var$Nk(a, d));
    }
    if (1 === c) throw c = $c79bde28d689cb05$var$pk, $c79bde28d689cb05$var$Kk(a, 0), $c79bde28d689cb05$var$Ck(a, b), $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B()), c;
    if (6 === c) throw Error($c79bde28d689cb05$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
    $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B());
    return null;
}
function $c79bde28d689cb05$var$Qk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c79bde28d689cb05$var$K = c, 0 === $c79bde28d689cb05$var$K && ($c79bde28d689cb05$var$Gj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
    }
}
function $c79bde28d689cb05$var$Rk(a) {
    null !== $c79bde28d689cb05$var$wk && 0 === $c79bde28d689cb05$var$wk.tag && 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$Hk();
    var b = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    var c = $c79bde28d689cb05$var$ok.transition, d = $c79bde28d689cb05$var$C;
    try {
        if ($c79bde28d689cb05$var$ok.transition = null, $c79bde28d689cb05$var$C = 1, a) return a();
    } finally{
        $c79bde28d689cb05$var$C = d, $c79bde28d689cb05$var$ok.transition = c, $c79bde28d689cb05$var$K = b, 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
    }
}
function $c79bde28d689cb05$var$Hj() {
    $c79bde28d689cb05$var$fj = $c79bde28d689cb05$var$ej.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$ej);
}
function $c79bde28d689cb05$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c79bde28d689cb05$var$Gf(c));
    if (null !== $c79bde28d689cb05$var$Y) for(c = $c79bde28d689cb05$var$Y.return; null !== c;){
        var d = c;
        $c79bde28d689cb05$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c79bde28d689cb05$var$$f();
                break;
            case 3:
                $c79bde28d689cb05$var$zh();
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
                $c79bde28d689cb05$var$Eh();
                break;
            case 5:
                $c79bde28d689cb05$var$Bh(d);
                break;
            case 4:
                $c79bde28d689cb05$var$zh();
                break;
            case 13:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
                break;
            case 19:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
                break;
            case 10:
                $c79bde28d689cb05$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $c79bde28d689cb05$var$Hj();
        }
        c = c.return;
    }
    $c79bde28d689cb05$var$Q = a;
    $c79bde28d689cb05$var$Y = a = $c79bde28d689cb05$var$Pg(a.current, null);
    $c79bde28d689cb05$var$Z = $c79bde28d689cb05$var$fj = b;
    $c79bde28d689cb05$var$T = 0;
    $c79bde28d689cb05$var$pk = null;
    $c79bde28d689cb05$var$rk = $c79bde28d689cb05$var$qk = $c79bde28d689cb05$var$rh = 0;
    $c79bde28d689cb05$var$tk = $c79bde28d689cb05$var$sk = null;
    if (null !== $c79bde28d689cb05$var$fh) {
        for(b = 0; b < $c79bde28d689cb05$var$fh.length; b++)if (c = $c79bde28d689cb05$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c79bde28d689cb05$var$fh = null;
    }
    return a;
}
function $c79bde28d689cb05$var$Mk(a, b) {
    do {
        var c = $c79bde28d689cb05$var$Y;
        try {
            $c79bde28d689cb05$var$$g();
            $c79bde28d689cb05$var$Fh.current = $c79bde28d689cb05$var$Rh;
            if ($c79bde28d689cb05$var$Ih) {
                for(var d = $c79bde28d689cb05$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c79bde28d689cb05$var$Ih = !1;
            }
            $c79bde28d689cb05$var$Hh = 0;
            $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = $c79bde28d689cb05$var$M = null;
            $c79bde28d689cb05$var$Jh = !1;
            $c79bde28d689cb05$var$Kh = 0;
            $c79bde28d689cb05$var$nk.current = null;
            if (null === c || null === c.return) {
                $c79bde28d689cb05$var$T = 1;
                $c79bde28d689cb05$var$pk = b;
                $c79bde28d689cb05$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c79bde28d689cb05$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c79bde28d689cb05$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c79bde28d689cb05$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $c79bde28d689cb05$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c79bde28d689cb05$var$Si(f, l, b);
                            $c79bde28d689cb05$var$tj();
                            break a;
                        }
                        k = Error($c79bde28d689cb05$var$p(426));
                    }
                } else if ($c79bde28d689cb05$var$I && h.mode & 1) {
                    var J = $c79bde28d689cb05$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c79bde28d689cb05$var$Vi(J, g, h, f, b);
                        $c79bde28d689cb05$var$Jg($c79bde28d689cb05$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $c79bde28d689cb05$var$Ji(k, h);
                4 !== $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 2);
                null === $c79bde28d689cb05$var$sk ? $c79bde28d689cb05$var$sk = [
                    f
                ] : $c79bde28d689cb05$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c79bde28d689cb05$var$Ni(f, k, b);
                            $c79bde28d689cb05$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c79bde28d689cb05$var$Ri || !$c79bde28d689cb05$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c79bde28d689cb05$var$Qi(f, h, b);
                                $c79bde28d689cb05$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c79bde28d689cb05$var$Sk(c);
        } catch (na) {
            b = na;
            $c79bde28d689cb05$var$Y === c && null !== c && ($c79bde28d689cb05$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c79bde28d689cb05$var$Jk() {
    var a = $c79bde28d689cb05$var$mk.current;
    $c79bde28d689cb05$var$mk.current = $c79bde28d689cb05$var$Rh;
    return null === a ? $c79bde28d689cb05$var$Rh : a;
}
function $c79bde28d689cb05$var$tj() {
    if (0 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T || 2 === $c79bde28d689cb05$var$T) $c79bde28d689cb05$var$T = 4;
    null === $c79bde28d689cb05$var$Q || 0 === ($c79bde28d689cb05$var$rh & 268435455) && 0 === ($c79bde28d689cb05$var$qk & 268435455) || $c79bde28d689cb05$var$Ck($c79bde28d689cb05$var$Q, $c79bde28d689cb05$var$Z);
}
function $c79bde28d689cb05$var$Ik(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 2;
    var d = $c79bde28d689cb05$var$Jk();
    if ($c79bde28d689cb05$var$Q !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$Kk(a, b);
    for(;;)try {
        $c79bde28d689cb05$var$Tk();
        break;
    } catch (e) {
        $c79bde28d689cb05$var$Mk(a, e);
    }
    $c79bde28d689cb05$var$$g();
    $c79bde28d689cb05$var$K = c;
    $c79bde28d689cb05$var$mk.current = d;
    if (null !== $c79bde28d689cb05$var$Y) throw Error($c79bde28d689cb05$var$p(261));
    $c79bde28d689cb05$var$Q = null;
    $c79bde28d689cb05$var$Z = 0;
    return $c79bde28d689cb05$var$T;
}
function $c79bde28d689cb05$var$Tk() {
    for(; null !== $c79bde28d689cb05$var$Y;)$c79bde28d689cb05$var$Uk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Lk() {
    for(; null !== $c79bde28d689cb05$var$Y && !$c79bde28d689cb05$var$cc();)$c79bde28d689cb05$var$Uk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Uk(a) {
    var b = $c79bde28d689cb05$var$Vk(a.alternate, a, $c79bde28d689cb05$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c79bde28d689cb05$var$Sk(a) : $c79bde28d689cb05$var$Y = b;
    $c79bde28d689cb05$var$nk.current = null;
}
function $c79bde28d689cb05$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c79bde28d689cb05$var$Ej(c, b, $c79bde28d689cb05$var$fj), null !== c) {
                $c79bde28d689cb05$var$Y = c;
                return;
            }
        } else {
            c = $c79bde28d689cb05$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c79bde28d689cb05$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c79bde28d689cb05$var$T = 6;
                $c79bde28d689cb05$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c79bde28d689cb05$var$Y = b;
            return;
        }
        $c79bde28d689cb05$var$Y = b = a;
    }while (null !== b);
    0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 5);
}
function $c79bde28d689cb05$var$Pk(a, b, c) {
    var d = $c79bde28d689cb05$var$C, e = $c79bde28d689cb05$var$ok.transition;
    try {
        $c79bde28d689cb05$var$ok.transition = null, $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$Wk(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$ok.transition = e, $c79bde28d689cb05$var$C = d;
    }
    return null;
}
function $c79bde28d689cb05$var$Wk(a, b, c, d) {
    do $c79bde28d689cb05$var$Hk();
    while (null !== $c79bde28d689cb05$var$wk);
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c79bde28d689cb05$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c79bde28d689cb05$var$Bc(a, f);
    a === $c79bde28d689cb05$var$Q && ($c79bde28d689cb05$var$Y = $c79bde28d689cb05$var$Q = null, $c79bde28d689cb05$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c79bde28d689cb05$var$vk || ($c79bde28d689cb05$var$vk = !0, $c79bde28d689cb05$var$Fk($c79bde28d689cb05$var$hc, function() {
        $c79bde28d689cb05$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c79bde28d689cb05$var$ok.transition;
        $c79bde28d689cb05$var$ok.transition = null;
        var g = $c79bde28d689cb05$var$C;
        $c79bde28d689cb05$var$C = 1;
        var h = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 4;
        $c79bde28d689cb05$var$nk.current = null;
        $c79bde28d689cb05$var$Oj(a, c);
        $c79bde28d689cb05$var$dk(c, a);
        $c79bde28d689cb05$var$Oe($c79bde28d689cb05$var$Df);
        $c79bde28d689cb05$var$dd = !!$c79bde28d689cb05$var$Cf;
        $c79bde28d689cb05$var$Df = $c79bde28d689cb05$var$Cf = null;
        a.current = c;
        $c79bde28d689cb05$var$hk(c, a, e);
        $c79bde28d689cb05$var$dc();
        $c79bde28d689cb05$var$K = h;
        $c79bde28d689cb05$var$C = g;
        $c79bde28d689cb05$var$ok.transition = f;
    } else a.current = c;
    $c79bde28d689cb05$var$vk && ($c79bde28d689cb05$var$vk = !1, $c79bde28d689cb05$var$wk = a, $c79bde28d689cb05$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($c79bde28d689cb05$var$Ri = null);
    $c79bde28d689cb05$var$mc(c.stateNode, d);
    $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c79bde28d689cb05$var$Oi) throw $c79bde28d689cb05$var$Oi = !1, a = $c79bde28d689cb05$var$Pi, $c79bde28d689cb05$var$Pi = null, a;
    0 !== ($c79bde28d689cb05$var$xk & 1) && 0 !== a.tag && $c79bde28d689cb05$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c79bde28d689cb05$var$zk ? $c79bde28d689cb05$var$yk++ : ($c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = a) : $c79bde28d689cb05$var$yk = 0;
    $c79bde28d689cb05$var$jg();
    return null;
}
function $c79bde28d689cb05$var$Hk() {
    if (null !== $c79bde28d689cb05$var$wk) {
        var a = $c79bde28d689cb05$var$Dc($c79bde28d689cb05$var$xk), b = $c79bde28d689cb05$var$ok.transition, c = $c79bde28d689cb05$var$C;
        try {
            $c79bde28d689cb05$var$ok.transition = null;
            $c79bde28d689cb05$var$C = 16 > a ? 16 : a;
            if (null === $c79bde28d689cb05$var$wk) var d = !1;
            else {
                a = $c79bde28d689cb05$var$wk;
                $c79bde28d689cb05$var$wk = null;
                $c79bde28d689cb05$var$xk = 0;
                if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(331));
                var e = $c79bde28d689cb05$var$K;
                $c79bde28d689cb05$var$K |= 4;
                for($c79bde28d689cb05$var$V = a.current; null !== $c79bde28d689cb05$var$V;){
                    var f = $c79bde28d689cb05$var$V, g = f.child;
                    if (0 !== ($c79bde28d689cb05$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c79bde28d689cb05$var$V = l; null !== $c79bde28d689cb05$var$V;){
                                    var m = $c79bde28d689cb05$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c79bde28d689cb05$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c79bde28d689cb05$var$V = q;
                                    else for(; null !== $c79bde28d689cb05$var$V;){
                                        m = $c79bde28d689cb05$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c79bde28d689cb05$var$Sj(m);
                                        if (m === l) {
                                            $c79bde28d689cb05$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c79bde28d689cb05$var$V = r;
                                            break;
                                        }
                                        $c79bde28d689cb05$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c79bde28d689cb05$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c79bde28d689cb05$var$V = g;
                    else b: for(; null !== $c79bde28d689cb05$var$V;){
                        f = $c79bde28d689cb05$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c79bde28d689cb05$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c79bde28d689cb05$var$V = x;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c79bde28d689cb05$var$V = w; null !== $c79bde28d689cb05$var$V;){
                    g = $c79bde28d689cb05$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c79bde28d689cb05$var$V = u;
                    else b: for(g = w; null !== $c79bde28d689cb05$var$V;){
                        h = $c79bde28d689cb05$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c79bde28d689cb05$var$Qj(9, h);
                            }
                        } catch (na) {
                            $c79bde28d689cb05$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c79bde28d689cb05$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c79bde28d689cb05$var$V = F;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = h.return;
                    }
                }
                $c79bde28d689cb05$var$K = e;
                $c79bde28d689cb05$var$jg();
                if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onPostCommitFiberRoot) try {
                    $c79bde28d689cb05$var$lc.onPostCommitFiberRoot($c79bde28d689cb05$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$ok.transition = b;
        }
    }
    return !1;
}
function $c79bde28d689cb05$var$Xk(a, b, c) {
    b = $c79bde28d689cb05$var$Ji(c, b);
    b = $c79bde28d689cb05$var$Ni(a, b, 1);
    a = $c79bde28d689cb05$var$nh(a, b, 1);
    b = $c79bde28d689cb05$var$R();
    null !== a && ($c79bde28d689cb05$var$Ac(a, 1, b), $c79bde28d689cb05$var$Dk(a, b));
}
function $c79bde28d689cb05$var$W(a, b, c) {
    if (3 === a.tag) $c79bde28d689cb05$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c79bde28d689cb05$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c79bde28d689cb05$var$Ri || !$c79bde28d689cb05$var$Ri.has(d))) {
                a = $c79bde28d689cb05$var$Ji(c, a);
                a = $c79bde28d689cb05$var$Qi(b, a, 1);
                b = $c79bde28d689cb05$var$nh(b, a, 1);
                a = $c79bde28d689cb05$var$R();
                null !== b && ($c79bde28d689cb05$var$Ac(b, 1, a), $c79bde28d689cb05$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c79bde28d689cb05$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c79bde28d689cb05$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $c79bde28d689cb05$var$Q === a && ($c79bde28d689cb05$var$Z & c) === c && (4 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$Z & 130023424) === $c79bde28d689cb05$var$Z && 500 > $c79bde28d689cb05$var$B() - $c79bde28d689cb05$var$fk ? $c79bde28d689cb05$var$Kk(a, 0) : $c79bde28d689cb05$var$rk |= c);
    $c79bde28d689cb05$var$Dk(a, b);
}
function $c79bde28d689cb05$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c79bde28d689cb05$var$sc, $c79bde28d689cb05$var$sc <<= 1, 0 === ($c79bde28d689cb05$var$sc & 130023424) && ($c79bde28d689cb05$var$sc = 4194304)));
    var c = $c79bde28d689cb05$var$R();
    a = $c79bde28d689cb05$var$ih(a, b);
    null !== a && ($c79bde28d689cb05$var$Ac(a, b, c), $c79bde28d689cb05$var$Dk(a, c));
}
function $c79bde28d689cb05$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c79bde28d689cb05$var$Yk(a, c);
}
function $c79bde28d689cb05$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c79bde28d689cb05$var$p(314));
    }
    null !== d && d.delete(b);
    $c79bde28d689cb05$var$Yk(a, c);
}
var $c79bde28d689cb05$var$Vk;
$c79bde28d689cb05$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c79bde28d689cb05$var$Wf.current) $c79bde28d689cb05$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c79bde28d689cb05$var$dh = !1, $c79bde28d689cb05$var$yj(a, b, c);
            $c79bde28d689cb05$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c79bde28d689cb05$var$dh = !1, $c79bde28d689cb05$var$I && 0 !== (b.flags & 1048576) && $c79bde28d689cb05$var$ug(b, $c79bde28d689cb05$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c79bde28d689cb05$var$ij(a, b);
            a = b.pendingProps;
            var e = $c79bde28d689cb05$var$Yf(b, $c79bde28d689cb05$var$H.current);
            $c79bde28d689cb05$var$ch(b, c);
            e = $c79bde28d689cb05$var$Nh(null, b, d, a, e, c);
            var f = $c79bde28d689cb05$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c79bde28d689cb05$var$Zf(d) ? (f = !0, $c79bde28d689cb05$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c79bde28d689cb05$var$kh(b), e.updater = $c79bde28d689cb05$var$Ei, b.stateNode = e, e._reactInternals = b, $c79bde28d689cb05$var$Ii(b, d, a, c), b = $c79bde28d689cb05$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $c79bde28d689cb05$var$I && f && $c79bde28d689cb05$var$vg(b), $c79bde28d689cb05$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c79bde28d689cb05$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c79bde28d689cb05$var$Zk(d);
                a = $c79bde28d689cb05$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $c79bde28d689cb05$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c79bde28d689cb05$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c79bde28d689cb05$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c79bde28d689cb05$var$$i(null, b, d, $c79bde28d689cb05$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($c79bde28d689cb05$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Ci(d, e), $c79bde28d689cb05$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Ci(d, e), $c79bde28d689cb05$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $c79bde28d689cb05$var$kj(b);
                if (null === a) throw Error($c79bde28d689cb05$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c79bde28d689cb05$var$lh(a, b);
                $c79bde28d689cb05$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c79bde28d689cb05$var$Ji(Error($c79bde28d689cb05$var$p(423)), b);
                        b = $c79bde28d689cb05$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c79bde28d689cb05$var$Ji(Error($c79bde28d689cb05$var$p(424)), b);
                        b = $c79bde28d689cb05$var$lj(a, b, d, c, e);
                        break a;
                    } else for($c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.stateNode.containerInfo.firstChild), $c79bde28d689cb05$var$xg = b, $c79bde28d689cb05$var$I = !0, $c79bde28d689cb05$var$zg = null, c = $c79bde28d689cb05$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c79bde28d689cb05$var$Ig();
                    if (d === e) {
                        b = $c79bde28d689cb05$var$Zi(a, b, c);
                        break a;
                    }
                    $c79bde28d689cb05$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c79bde28d689cb05$var$Ah(b), null === a && $c79bde28d689cb05$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c79bde28d689cb05$var$Ef(d, e) ? g = null : null !== f && $c79bde28d689cb05$var$Ef(d, f) && (b.flags |= 32), $c79bde28d689cb05$var$gj(a, b), $c79bde28d689cb05$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $c79bde28d689cb05$var$Eg(b), null;
        case 13:
            return $c79bde28d689cb05$var$oj(a, b, c);
        case 4:
            return $c79bde28d689cb05$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c79bde28d689cb05$var$Ug(b, null, d, c) : $c79bde28d689cb05$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Ci(d, e), $c79bde28d689cb05$var$Yi(a, b, d, e, c);
        case 7:
            return $c79bde28d689cb05$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c79bde28d689cb05$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c79bde28d689cb05$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c79bde28d689cb05$var$He(f.value, g)) {
                        if (f.children === e.children && !$c79bde28d689cb05$var$Wf.current) {
                            b = $c79bde28d689cb05$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c79bde28d689cb05$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c79bde28d689cb05$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c79bde28d689cb05$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c79bde28d689cb05$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c79bde28d689cb05$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c79bde28d689cb05$var$ch(b, c), e = $c79bde28d689cb05$var$eh(e), d = d(e), b.flags |= 1, $c79bde28d689cb05$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c79bde28d689cb05$var$Ci(d, b.pendingProps), e = $c79bde28d689cb05$var$Ci(d.type, e), $c79bde28d689cb05$var$$i(a, b, d, e, c);
        case 15:
            return $c79bde28d689cb05$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Ci(d, e), $c79bde28d689cb05$var$ij(a, b), b.tag = 1, $c79bde28d689cb05$var$Zf(d) ? (a = !0, $c79bde28d689cb05$var$cg(b)) : a = !1, $c79bde28d689cb05$var$ch(b, c), $c79bde28d689cb05$var$Gi(b, d, e), $c79bde28d689cb05$var$Ii(b, d, e, c), $c79bde28d689cb05$var$jj(null, b, d, !0, a, c);
        case 19:
            return $c79bde28d689cb05$var$xj(a, b, c);
        case 22:
            return $c79bde28d689cb05$var$dj(a, b, c);
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
};
function $c79bde28d689cb05$var$Fk(a, b) {
    return $c79bde28d689cb05$var$ac(a, b);
}
function $c79bde28d689cb05$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c79bde28d689cb05$var$Bg(a, b, c, d) {
    return new $c79bde28d689cb05$var$$k(a, b, c, d);
}
function $c79bde28d689cb05$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c79bde28d689cb05$var$Zk(a) {
    if ("function" === typeof a) return $c79bde28d689cb05$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c79bde28d689cb05$var$Da) return 11;
        if (a === $c79bde28d689cb05$var$Ga) return 14;
    }
    return 2;
}
function $c79bde28d689cb05$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $c79bde28d689cb05$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c79bde28d689cb05$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c79bde28d689cb05$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c79bde28d689cb05$var$ya:
            return $c79bde28d689cb05$var$Tg(c.children, e, f, b);
        case $c79bde28d689cb05$var$za:
            g = 8;
            e |= 8;
            break;
        case $c79bde28d689cb05$var$Aa:
            return a = $c79bde28d689cb05$var$Bg(12, c, b, e | 2), a.elementType = $c79bde28d689cb05$var$Aa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ea:
            return a = $c79bde28d689cb05$var$Bg(13, c, b, e), a.elementType = $c79bde28d689cb05$var$Ea, a.lanes = f, a;
        case $c79bde28d689cb05$var$Fa:
            return a = $c79bde28d689cb05$var$Bg(19, c, b, e), a.elementType = $c79bde28d689cb05$var$Fa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ia:
            return $c79bde28d689cb05$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c79bde28d689cb05$var$Ba:
                    g = 10;
                    break a;
                case $c79bde28d689cb05$var$Ca:
                    g = 9;
                    break a;
                case $c79bde28d689cb05$var$Da:
                    g = 11;
                    break a;
                case $c79bde28d689cb05$var$Ga:
                    g = 14;
                    break a;
                case $c79bde28d689cb05$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c79bde28d689cb05$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c79bde28d689cb05$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c79bde28d689cb05$var$Tg(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$pj(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(22, a, d, b);
    a.elementType = $c79bde28d689cb05$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c79bde28d689cb05$var$Qg(a, b, c) {
    a = $c79bde28d689cb05$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$Sg(a, b, c) {
    b = $c79bde28d689cb05$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c79bde28d689cb05$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c79bde28d689cb05$var$zc(0);
    this.expirationTimes = $c79bde28d689cb05$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c79bde28d689cb05$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c79bde28d689cb05$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $c79bde28d689cb05$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c79bde28d689cb05$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c79bde28d689cb05$var$kh(f);
    return a;
}
function $c79bde28d689cb05$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c79bde28d689cb05$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c79bde28d689cb05$var$dl(a) {
    if (!a) return $c79bde28d689cb05$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c79bde28d689cb05$var$Vb(a) !== a || 1 !== a.tag) throw Error($c79bde28d689cb05$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c79bde28d689cb05$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c79bde28d689cb05$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c79bde28d689cb05$var$Zf(c)) return $c79bde28d689cb05$var$bg(a, c, b);
    }
    return b;
}
function $c79bde28d689cb05$var$el(a, b, c, d, e, f, g, h, k) {
    a = $c79bde28d689cb05$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $c79bde28d689cb05$var$dl(null);
    c = a.current;
    d = $c79bde28d689cb05$var$R();
    e = $c79bde28d689cb05$var$yi(c);
    f = $c79bde28d689cb05$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c79bde28d689cb05$var$nh(c, f, e);
    a.current.lanes = e;
    $c79bde28d689cb05$var$Ac(a, e, d);
    $c79bde28d689cb05$var$Dk(a, d);
    return a;
}
function $c79bde28d689cb05$var$fl(a, b, c, d) {
    var e = b.current, f = $c79bde28d689cb05$var$R(), g = $c79bde28d689cb05$var$yi(e);
    c = $c79bde28d689cb05$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c79bde28d689cb05$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c79bde28d689cb05$var$nh(e, b, g);
    null !== a && ($c79bde28d689cb05$var$gi(a, e, g, f), $c79bde28d689cb05$var$oh(a, e, g));
    return g;
}
function $c79bde28d689cb05$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c79bde28d689cb05$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c79bde28d689cb05$var$il(a, b) {
    $c79bde28d689cb05$var$hl(a, b);
    (a = a.alternate) && $c79bde28d689cb05$var$hl(a, b);
}
function $c79bde28d689cb05$var$jl() {
    return null;
}
var $c79bde28d689cb05$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c79bde28d689cb05$var$ll(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$ml.prototype.render = $c79bde28d689cb05$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c79bde28d689cb05$var$p(409));
    $c79bde28d689cb05$var$fl(a, b, null, null);
};
$c79bde28d689cb05$var$ml.prototype.unmount = $c79bde28d689cb05$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c79bde28d689cb05$var$Rk(function() {
            $c79bde28d689cb05$var$fl(null, a, null, null);
        });
        b[$c79bde28d689cb05$var$uf] = null;
    }
};
function $c79bde28d689cb05$var$ml(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c79bde28d689cb05$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c79bde28d689cb05$var$Qc.length && 0 !== b && b < $c79bde28d689cb05$var$Qc[c].priority; c++);
        $c79bde28d689cb05$var$Qc.splice(c, 0, a);
        0 === c && $c79bde28d689cb05$var$Vc(a);
    }
};
function $c79bde28d689cb05$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c79bde28d689cb05$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c79bde28d689cb05$var$pl() {}
function $c79bde28d689cb05$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c79bde28d689cb05$var$gl(g);
                f.call(a);
            };
        }
        var g = $c79bde28d689cb05$var$el(b, d, a, 0, null, !1, !1, "", $c79bde28d689cb05$var$pl);
        a._reactRootContainer = g;
        a[$c79bde28d689cb05$var$uf] = g.current;
        $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c79bde28d689cb05$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c79bde28d689cb05$var$gl(k);
            h.call(a);
        };
    }
    var k = $c79bde28d689cb05$var$bl(a, 0, !1, null, null, !1, !1, "", $c79bde28d689cb05$var$pl);
    a._reactRootContainer = k;
    a[$c79bde28d689cb05$var$uf] = k.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c79bde28d689cb05$var$Rk(function() {
        $c79bde28d689cb05$var$fl(b, k, c, d);
    });
    return k;
}
function $c79bde28d689cb05$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c79bde28d689cb05$var$gl(g);
                h.call(a);
            };
        }
        $c79bde28d689cb05$var$fl(b, g, a, e);
    } else g = $c79bde28d689cb05$var$ql(c, b, a, e, d);
    return $c79bde28d689cb05$var$gl(g);
}
$c79bde28d689cb05$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c79bde28d689cb05$var$tc(b.pendingLanes);
                0 !== c && ($c79bde28d689cb05$var$Cc(b, c | 1), $c79bde28d689cb05$var$Dk(b, $c79bde28d689cb05$var$B()), 0 === ($c79bde28d689cb05$var$K & 6) && ($c79bde28d689cb05$var$Gj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$jg()));
            }
            break;
        case 13:
            $c79bde28d689cb05$var$Rk(function() {
                var b = $c79bde28d689cb05$var$ih(a, 1);
                if (null !== b) {
                    var c = $c79bde28d689cb05$var$R();
                    $c79bde28d689cb05$var$gi(b, a, 1, c);
                }
            }), $c79bde28d689cb05$var$il(a, 1);
    }
};
$c79bde28d689cb05$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$ih(a, 134217728);
        if (null !== b) {
            var c = $c79bde28d689cb05$var$R();
            $c79bde28d689cb05$var$gi(b, a, 134217728, c);
        }
        $c79bde28d689cb05$var$il(a, 134217728);
    }
};
$c79bde28d689cb05$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$yi(a), c = $c79bde28d689cb05$var$ih(a, b);
        if (null !== c) {
            var d = $c79bde28d689cb05$var$R();
            $c79bde28d689cb05$var$gi(c, a, b, d);
        }
        $c79bde28d689cb05$var$il(a, b);
    }
};
$c79bde28d689cb05$var$Hc = function() {
    return $c79bde28d689cb05$var$C;
};
$c79bde28d689cb05$var$Ic = function(a, b) {
    var c = $c79bde28d689cb05$var$C;
    try {
        return $c79bde28d689cb05$var$C = a, b();
    } finally{
        $c79bde28d689cb05$var$C = c;
    }
};
$c79bde28d689cb05$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c79bde28d689cb05$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c79bde28d689cb05$var$Db(d);
                        if (!e) throw Error($c79bde28d689cb05$var$p(90));
                        $c79bde28d689cb05$var$Wa(d);
                        $c79bde28d689cb05$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c79bde28d689cb05$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c79bde28d689cb05$var$fb(a, !!c.multiple, b, !1);
    }
};
$c79bde28d689cb05$var$Gb = $c79bde28d689cb05$var$Qk;
$c79bde28d689cb05$var$Hb = $c79bde28d689cb05$var$Rk;
var $c79bde28d689cb05$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $c79bde28d689cb05$var$Cb,
        $c79bde28d689cb05$var$ue,
        $c79bde28d689cb05$var$Db,
        $c79bde28d689cb05$var$Eb,
        $c79bde28d689cb05$var$Fb,
        $c79bde28d689cb05$var$Qk
    ]
}, $c79bde28d689cb05$var$tl = {
    findFiberByHostInstance: $c79bde28d689cb05$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $c79bde28d689cb05$var$ul = {
    bundleType: $c79bde28d689cb05$var$tl.bundleType,
    version: $c79bde28d689cb05$var$tl.version,
    rendererPackageName: $c79bde28d689cb05$var$tl.rendererPackageName,
    rendererConfig: $c79bde28d689cb05$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c79bde28d689cb05$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c79bde28d689cb05$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c79bde28d689cb05$var$tl.findFiberByHostInstance || $c79bde28d689cb05$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c79bde28d689cb05$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c79bde28d689cb05$var$vl.isDisabled && $c79bde28d689cb05$var$vl.supportsFiber) try {
        $c79bde28d689cb05$var$kc = $c79bde28d689cb05$var$vl.inject($c79bde28d689cb05$var$ul), $c79bde28d689cb05$var$lc = $c79bde28d689cb05$var$vl;
    } catch (a) {}
}
$c79bde28d689cb05$export$ae55be85d98224ed = $c79bde28d689cb05$var$sl;
$c79bde28d689cb05$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c79bde28d689cb05$var$nl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$cl(a, b, null, c);
};
$c79bde28d689cb05$export$882461b6382ed46c = function(a, b) {
    if (!$c79bde28d689cb05$var$nl(a)) throw Error($c79bde28d689cb05$var$p(299));
    var c = !1, d = "", e = $c79bde28d689cb05$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c79bde28d689cb05$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c79bde28d689cb05$var$ll(b);
};
$c79bde28d689cb05$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c79bde28d689cb05$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c79bde28d689cb05$var$p(268, a));
    }
    a = $c79bde28d689cb05$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c79bde28d689cb05$export$cd75ccfd720a3cd4 = function(a) {
    return $c79bde28d689cb05$var$Rk(a);
};
$c79bde28d689cb05$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$rl(null, a, b, !0, c);
};
$c79bde28d689cb05$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c79bde28d689cb05$var$nl(a)) throw Error($c79bde28d689cb05$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c79bde28d689cb05$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c79bde28d689cb05$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c79bde28d689cb05$var$ml(b);
};
$c79bde28d689cb05$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$rl(null, a, b, !1, c);
};
$c79bde28d689cb05$export$502457920280e6be = function(a) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(40));
    return a._reactRootContainer ? ($c79bde28d689cb05$var$Rk(function() {
        $c79bde28d689cb05$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c79bde28d689cb05$var$uf] = null;
        });
    }), !0) : !1;
};
$c79bde28d689cb05$export$c78a37762a8d58e1 = $c79bde28d689cb05$var$Qk;
$c79bde28d689cb05$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c79bde28d689cb05$var$ol(c)) throw Error($c79bde28d689cb05$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c79bde28d689cb05$var$p(38));
    return $c79bde28d689cb05$var$rl(a, b, c, !1, d);
};
$c79bde28d689cb05$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("exYeM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bzfnW"));

});
parcelRegister("bzfnW", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $86bee5c140ae1e47$export$dca3b0875bd9a954; }, function (v) { return $86bee5c140ae1e47$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $86bee5c140ae1e47$export$16fa2f45be04daa8; }, function (v) { return $86bee5c140ae1e47$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $86bee5c140ae1e47$export$ffb0004e005737fa; }, function (v) { return $86bee5c140ae1e47$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $86bee5c140ae1e47$export$e2c29f18771995cb; }, function (v) { return $86bee5c140ae1e47$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $86bee5c140ae1e47$export$221d75b3f55bb0bd; }, function (v) { return $86bee5c140ae1e47$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $86bee5c140ae1e47$export$5f8d39834fd61797; }, function (v) { return $86bee5c140ae1e47$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $86bee5c140ae1e47$export$74bf444e3cd11ea5; }, function (v) { return $86bee5c140ae1e47$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $86bee5c140ae1e47$export$ae55be85d98224ed; }, function (v) { return $86bee5c140ae1e47$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $86bee5c140ae1e47$export$3ba232387fd5d6dd; }, function (v) { return $86bee5c140ae1e47$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $86bee5c140ae1e47$export$e530037191fcd5d7; }, function (v) { return $86bee5c140ae1e47$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $86bee5c140ae1e47$export$fd42f52fd3ae1109; }, function (v) { return $86bee5c140ae1e47$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $86bee5c140ae1e47$export$c8a8987d4410bf2d; }, function (v) { return $86bee5c140ae1e47$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $86bee5c140ae1e47$export$d38cd72104c1f0e9; }, function (v) { return $86bee5c140ae1e47$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43; }, function (v) { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $86bee5c140ae1e47$export$257a8862b851cb5b; }, function (v) { return $86bee5c140ae1e47$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $86bee5c140ae1e47$export$a8257692ac88316c; }, function (v) { return $86bee5c140ae1e47$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $86bee5c140ae1e47$export$488013bae63b21da; }, function (v) { return $86bee5c140ae1e47$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $86bee5c140ae1e47$export$7c73462e0d25e514; }, function (v) { return $86bee5c140ae1e47$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $86bee5c140ae1e47$export$7568632d0d33d16d; }, function (v) { return $86bee5c140ae1e47$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $86bee5c140ae1e47$export$88948ce120ea2619; }, function (v) { return $86bee5c140ae1e47$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $86bee5c140ae1e47$export$35808ee640e87ca7; }, function (v) { return $86bee5c140ae1e47$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $86bee5c140ae1e47$export$fae74005e78b1a27; }, function (v) { return $86bee5c140ae1e47$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e; }, function (v) { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf; }, function (v) { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $86bee5c140ae1e47$export$6d9c69b0de29b591; }, function (v) { return $86bee5c140ae1e47$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $86bee5c140ae1e47$export$f680877a34711e37; }, function (v) { return $86bee5c140ae1e47$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $86bee5c140ae1e47$export$d5a552a76deda3c2; }, function (v) { return $86bee5c140ae1e47$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $86bee5c140ae1e47$export$aaabe4eda9ed9969; }, function (v) { return $86bee5c140ae1e47$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $86bee5c140ae1e47$export$e5c5a5f917a5871c; }, function (v) { return $86bee5c140ae1e47$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $86bee5c140ae1e47$export$1538c33de8887b59; }, function (v) { return $86bee5c140ae1e47$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $86bee5c140ae1e47$export$13e3392192263954; }, function (v) { return $86bee5c140ae1e47$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $86bee5c140ae1e47$export$b8f5890fc79d6aca; }, function (v) { return $86bee5c140ae1e47$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $86bee5c140ae1e47$export$60241385465d0a34; }, function (v) { return $86bee5c140ae1e47$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $86bee5c140ae1e47$export$306c0aa65ff9ec16; }, function (v) { return $86bee5c140ae1e47$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $86bee5c140ae1e47$export$7b286972b8d8ccbf; }, function (v) { return $86bee5c140ae1e47$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $86bee5c140ae1e47$export$83d89fbfd8236492; }, function (v) { return $86bee5c140ae1e47$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86bee5c140ae1e47$export$dca3b0875bd9a954;
var $86bee5c140ae1e47$export$16fa2f45be04daa8;
var $86bee5c140ae1e47$export$ffb0004e005737fa;
var $86bee5c140ae1e47$export$e2c29f18771995cb;
var $86bee5c140ae1e47$export$221d75b3f55bb0bd;
var $86bee5c140ae1e47$export$5f8d39834fd61797;
var $86bee5c140ae1e47$export$74bf444e3cd11ea5;
var $86bee5c140ae1e47$export$ae55be85d98224ed;
var $86bee5c140ae1e47$export$3ba232387fd5d6dd;
var $86bee5c140ae1e47$export$e530037191fcd5d7;
var $86bee5c140ae1e47$export$fd42f52fd3ae1109;
var $86bee5c140ae1e47$export$c8a8987d4410bf2d;
var $86bee5c140ae1e47$export$d38cd72104c1f0e9;
var $86bee5c140ae1e47$export$7d1e3a5e95ceca43;
var $86bee5c140ae1e47$export$257a8862b851cb5b;
var $86bee5c140ae1e47$export$a8257692ac88316c;
var $86bee5c140ae1e47$export$488013bae63b21da;
var $86bee5c140ae1e47$export$7c73462e0d25e514;
var $86bee5c140ae1e47$export$7568632d0d33d16d;
var $86bee5c140ae1e47$export$88948ce120ea2619;
var $86bee5c140ae1e47$export$35808ee640e87ca7;
var $86bee5c140ae1e47$export$fae74005e78b1a27;
var $86bee5c140ae1e47$export$dc8fbce3eb94dc1e;
var $86bee5c140ae1e47$export$6a7bc4e911dc01cf;
var $86bee5c140ae1e47$export$6d9c69b0de29b591;
var $86bee5c140ae1e47$export$f680877a34711e37;
var $86bee5c140ae1e47$export$d5a552a76deda3c2;
var $86bee5c140ae1e47$export$aaabe4eda9ed9969;
var $86bee5c140ae1e47$export$e5c5a5f917a5871c;
var $86bee5c140ae1e47$export$1538c33de8887b59;
var $86bee5c140ae1e47$export$13e3392192263954;
var $86bee5c140ae1e47$export$b8f5890fc79d6aca;
var $86bee5c140ae1e47$export$60241385465d0a34;
var $86bee5c140ae1e47$export$306c0aa65ff9ec16;
var $86bee5c140ae1e47$export$7b286972b8d8ccbf;
var $86bee5c140ae1e47$export$83d89fbfd8236492;
"use strict";
var $86bee5c140ae1e47$var$l = Symbol.for("react.element"), $86bee5c140ae1e47$var$n = Symbol.for("react.portal"), $86bee5c140ae1e47$var$p = Symbol.for("react.fragment"), $86bee5c140ae1e47$var$q = Symbol.for("react.strict_mode"), $86bee5c140ae1e47$var$r = Symbol.for("react.profiler"), $86bee5c140ae1e47$var$t = Symbol.for("react.provider"), $86bee5c140ae1e47$var$u = Symbol.for("react.context"), $86bee5c140ae1e47$var$v = Symbol.for("react.forward_ref"), $86bee5c140ae1e47$var$w = Symbol.for("react.suspense"), $86bee5c140ae1e47$var$x = Symbol.for("react.memo"), $86bee5c140ae1e47$var$y = Symbol.for("react.lazy"), $86bee5c140ae1e47$var$z = Symbol.iterator;
function $86bee5c140ae1e47$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $86bee5c140ae1e47$var$z && a[$86bee5c140ae1e47$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $86bee5c140ae1e47$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $86bee5c140ae1e47$var$C = Object.assign, $86bee5c140ae1e47$var$D = {};
function $86bee5c140ae1e47$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
$86bee5c140ae1e47$var$E.prototype.isReactComponent = {};
$86bee5c140ae1e47$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$86bee5c140ae1e47$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $86bee5c140ae1e47$var$F() {}
$86bee5c140ae1e47$var$F.prototype = $86bee5c140ae1e47$var$E.prototype;
function $86bee5c140ae1e47$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
var $86bee5c140ae1e47$var$H = $86bee5c140ae1e47$var$G.prototype = new $86bee5c140ae1e47$var$F;
$86bee5c140ae1e47$var$H.constructor = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$var$C($86bee5c140ae1e47$var$H, $86bee5c140ae1e47$var$E.prototype);
$86bee5c140ae1e47$var$H.isPureReactComponent = !0;
var $86bee5c140ae1e47$var$I = Array.isArray, $86bee5c140ae1e47$var$J = Object.prototype.hasOwnProperty, $86bee5c140ae1e47$var$K = {
    current: null
}, $86bee5c140ae1e47$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $86bee5c140ae1e47$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$86bee5c140ae1e47$var$J.call(b, d) && !$86bee5c140ae1e47$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $86bee5c140ae1e47$var$K.current
    };
}
function $86bee5c140ae1e47$var$N(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $86bee5c140ae1e47$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $86bee5c140ae1e47$var$l;
}
function $86bee5c140ae1e47$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $86bee5c140ae1e47$var$P = /\/+/g;
function $86bee5c140ae1e47$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $86bee5c140ae1e47$var$escape("" + a.key) : b.toString(36);
}
function $86bee5c140ae1e47$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $86bee5c140ae1e47$var$l:
                case $86bee5c140ae1e47$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $86bee5c140ae1e47$var$Q(h, 0) : d, $86bee5c140ae1e47$var$I(c) ? (e = "", null != a && (e = a.replace($86bee5c140ae1e47$var$P, "$&/") + "/"), $86bee5c140ae1e47$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($86bee5c140ae1e47$var$O(c) && (c = $86bee5c140ae1e47$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($86bee5c140ae1e47$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($86bee5c140ae1e47$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $86bee5c140ae1e47$var$Q(k, g);
        h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    }
    else if (f = $86bee5c140ae1e47$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $86bee5c140ae1e47$var$Q(k, g++), h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $86bee5c140ae1e47$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $86bee5c140ae1e47$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $86bee5c140ae1e47$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $86bee5c140ae1e47$var$U = {
    current: null
}, $86bee5c140ae1e47$var$V = {
    transition: null
}, $86bee5c140ae1e47$var$W = {
    ReactCurrentDispatcher: $86bee5c140ae1e47$var$U,
    ReactCurrentBatchConfig: $86bee5c140ae1e47$var$V,
    ReactCurrentOwner: $86bee5c140ae1e47$var$K
};
function $86bee5c140ae1e47$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$86bee5c140ae1e47$export$dca3b0875bd9a954 = {
    map: $86bee5c140ae1e47$var$S,
    forEach: function(a, b, e) {
        $86bee5c140ae1e47$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $86bee5c140ae1e47$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $86bee5c140ae1e47$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$86bee5c140ae1e47$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$86bee5c140ae1e47$export$16fa2f45be04daa8 = $86bee5c140ae1e47$var$E;
$86bee5c140ae1e47$export$ffb0004e005737fa = $86bee5c140ae1e47$var$p;
$86bee5c140ae1e47$export$e2c29f18771995cb = $86bee5c140ae1e47$var$r;
$86bee5c140ae1e47$export$221d75b3f55bb0bd = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$export$5f8d39834fd61797 = $86bee5c140ae1e47$var$q;
$86bee5c140ae1e47$export$74bf444e3cd11ea5 = $86bee5c140ae1e47$var$w;
$86bee5c140ae1e47$export$ae55be85d98224ed = $86bee5c140ae1e47$var$W;
$86bee5c140ae1e47$export$3ba232387fd5d6dd = $86bee5c140ae1e47$var$X;
$86bee5c140ae1e47$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $86bee5c140ae1e47$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $86bee5c140ae1e47$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$86bee5c140ae1e47$var$J.call(b, f) && !$86bee5c140ae1e47$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$86bee5c140ae1e47$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $86bee5c140ae1e47$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $86bee5c140ae1e47$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$86bee5c140ae1e47$export$c8a8987d4410bf2d = $86bee5c140ae1e47$var$M;
$86bee5c140ae1e47$export$d38cd72104c1f0e9 = function(a) {
    var b = $86bee5c140ae1e47$var$M.bind(null, a);
    b.type = a;
    return b;
};
$86bee5c140ae1e47$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$86bee5c140ae1e47$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$v,
        render: a
    };
};
$86bee5c140ae1e47$export$a8257692ac88316c = $86bee5c140ae1e47$var$O;
$86bee5c140ae1e47$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $86bee5c140ae1e47$var$T
    };
};
$86bee5c140ae1e47$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$86bee5c140ae1e47$export$7568632d0d33d16d = function(a) {
    var b = $86bee5c140ae1e47$var$V.transition;
    $86bee5c140ae1e47$var$V.transition = {};
    try {
        a();
    } finally{
        $86bee5c140ae1e47$var$V.transition = b;
    }
};
$86bee5c140ae1e47$export$88948ce120ea2619 = $86bee5c140ae1e47$var$X;
$86bee5c140ae1e47$export$35808ee640e87ca7 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useCallback(a, b);
};
$86bee5c140ae1e47$export$fae74005e78b1a27 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useContext(a);
};
$86bee5c140ae1e47$export$dc8fbce3eb94dc1e = function() {};
$86bee5c140ae1e47$export$6a7bc4e911dc01cf = function(a) {
    return $86bee5c140ae1e47$var$U.current.useDeferredValue(a);
};
$86bee5c140ae1e47$export$6d9c69b0de29b591 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useEffect(a, b);
};
$86bee5c140ae1e47$export$f680877a34711e37 = function() {
    return $86bee5c140ae1e47$var$U.current.useId();
};
$86bee5c140ae1e47$export$d5a552a76deda3c2 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useImperativeHandle(a, b, e);
};
$86bee5c140ae1e47$export$aaabe4eda9ed9969 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useInsertionEffect(a, b);
};
$86bee5c140ae1e47$export$e5c5a5f917a5871c = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useLayoutEffect(a, b);
};
$86bee5c140ae1e47$export$1538c33de8887b59 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useMemo(a, b);
};
$86bee5c140ae1e47$export$13e3392192263954 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useReducer(a, b, e);
};
$86bee5c140ae1e47$export$b8f5890fc79d6aca = function(a) {
    return $86bee5c140ae1e47$var$U.current.useRef(a);
};
$86bee5c140ae1e47$export$60241385465d0a34 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useState(a);
};
$86bee5c140ae1e47$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useSyncExternalStore(a, b, e);
};
$86bee5c140ae1e47$export$7b286972b8d8ccbf = function() {
    return $86bee5c140ae1e47$var$U.current.useTransition();
};
$86bee5c140ae1e47$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("ibqfJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dnqd8"));

});
parcelRegister("dnqd8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9bd1c1496009b220$export$c4744153514ff05d; }, function (v) { return $9bd1c1496009b220$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7; }, function (v) { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9bd1c1496009b220$export$e26fe2ed2fa76875; }, function (v) { return $9bd1c1496009b220$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9bd1c1496009b220$export$502329bbf4b505b1; }, function (v) { return $9bd1c1496009b220$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9bd1c1496009b220$export$6e3807111c4874c4; }, function (v) { return $9bd1c1496009b220$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9bd1c1496009b220$export$c27134553091fb3a; }, function (v) { return $9bd1c1496009b220$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9bd1c1496009b220$export$33ee1acdc04fd2a2; }, function (v) { return $9bd1c1496009b220$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9bd1c1496009b220$export$b00a404bbd5edef2; }, function (v) { return $9bd1c1496009b220$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9bd1c1496009b220$export$8352ce38b91d0c62; }, function (v) { return $9bd1c1496009b220$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9bd1c1496009b220$export$d66a1c1c77bd778b; }, function (v) { return $9bd1c1496009b220$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9bd1c1496009b220$export$d3dfb8e4810cb555; }, function (v) { return $9bd1c1496009b220$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9bd1c1496009b220$export$839f9183b0465a69; }, function (v) { return $9bd1c1496009b220$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9bd1c1496009b220$export$72fdf0e06517287b; }, function (v) { return $9bd1c1496009b220$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9bd1c1496009b220$export$4b844e58a3e414b4; }, function (v) { return $9bd1c1496009b220$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9bd1c1496009b220$export$816d2913ae6b83b1; }, function (v) { return $9bd1c1496009b220$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9bd1c1496009b220$export$61bcfe829111a1d0; }, function (v) { return $9bd1c1496009b220$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9bd1c1496009b220$export$7ee8c9beb337bc3f; }, function (v) { return $9bd1c1496009b220$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9bd1c1496009b220$export$b5836b71941fa3ed; }, function (v) { return $9bd1c1496009b220$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9bd1c1496009b220$export$cf845f2c119da08a; }, function (v) { return $9bd1c1496009b220$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bd1c1496009b220$export$c4744153514ff05d;
var $9bd1c1496009b220$export$3e506c1ccc9cc1a7;
var $9bd1c1496009b220$export$e26fe2ed2fa76875;
var $9bd1c1496009b220$export$502329bbf4b505b1;
var $9bd1c1496009b220$export$6e3807111c4874c4;
var $9bd1c1496009b220$export$c27134553091fb3a;
var $9bd1c1496009b220$export$33ee1acdc04fd2a2;
var $9bd1c1496009b220$export$b00a404bbd5edef2;
var $9bd1c1496009b220$export$8352ce38b91d0c62;
var $9bd1c1496009b220$export$d66a1c1c77bd778b;
var $9bd1c1496009b220$export$d3dfb8e4810cb555;
var $9bd1c1496009b220$export$839f9183b0465a69;
var $9bd1c1496009b220$export$72fdf0e06517287b;
var $9bd1c1496009b220$export$4b844e58a3e414b4;
var $9bd1c1496009b220$export$816d2913ae6b83b1;
var $9bd1c1496009b220$export$61bcfe829111a1d0;
var $9bd1c1496009b220$export$7ee8c9beb337bc3f;
var $9bd1c1496009b220$export$b5836b71941fa3ed;
var $9bd1c1496009b220$export$cf845f2c119da08a;
"use strict";
function $9bd1c1496009b220$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9bd1c1496009b220$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9bd1c1496009b220$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9bd1c1496009b220$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9bd1c1496009b220$var$g(C, c)) n < e && 0 > $9bd1c1496009b220$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9bd1c1496009b220$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9bd1c1496009b220$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9bd1c1496009b220$var$l = performance;
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$l.now();
    };
} else {
    var $9bd1c1496009b220$var$p = Date, $9bd1c1496009b220$var$q = $9bd1c1496009b220$var$p.now();
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$p.now() - $9bd1c1496009b220$var$q;
    };
}
var $9bd1c1496009b220$var$r = [], $9bd1c1496009b220$var$t = [], $9bd1c1496009b220$var$u = 1, $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = 3, $9bd1c1496009b220$var$z = !1, $9bd1c1496009b220$var$A = !1, $9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$D = "function" === typeof setTimeout ? setTimeout : null, $9bd1c1496009b220$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9bd1c1496009b220$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9bd1c1496009b220$var$G(a) {
    for(var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t); null !== b;){
        if (null === b.callback) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t);
        else if (b.startTime <= a) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t), b.sortIndex = b.expirationTime, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, b);
        else break;
        b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
    }
}
function $9bd1c1496009b220$var$H(a) {
    $9bd1c1496009b220$var$B = !1;
    $9bd1c1496009b220$var$G(a);
    if (!$9bd1c1496009b220$var$A) {
        if (null !== $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r)) $9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J);
        else {
            var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== b && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, b.startTime - a);
        }
    }
}
function $9bd1c1496009b220$var$J(a, b) {
    $9bd1c1496009b220$var$A = !1;
    $9bd1c1496009b220$var$B && ($9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1);
    $9bd1c1496009b220$var$z = !0;
    var c = $9bd1c1496009b220$var$y;
    try {
        $9bd1c1496009b220$var$G(b);
        for($9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r); null !== $9bd1c1496009b220$var$v && (!($9bd1c1496009b220$var$v.expirationTime > b) || a && !$9bd1c1496009b220$var$M());){
            var d = $9bd1c1496009b220$var$v.callback;
            if ("function" === typeof d) {
                $9bd1c1496009b220$var$v.callback = null;
                $9bd1c1496009b220$var$y = $9bd1c1496009b220$var$v.priorityLevel;
                var e = d($9bd1c1496009b220$var$v.expirationTime <= b);
                b = $9bd1c1496009b220$export$c4744153514ff05d();
                "function" === typeof e ? $9bd1c1496009b220$var$v.callback = e : $9bd1c1496009b220$var$v === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
                $9bd1c1496009b220$var$G(b);
            } else $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
            $9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
        }
        if (null !== $9bd1c1496009b220$var$v) var w = !0;
        else {
            var m = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== m && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = c, $9bd1c1496009b220$var$z = !1;
    }
}
var $9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null, $9bd1c1496009b220$var$L = -1, $9bd1c1496009b220$var$P = 5, $9bd1c1496009b220$var$Q = -1;
function $9bd1c1496009b220$var$M() {
    return $9bd1c1496009b220$export$c4744153514ff05d() - $9bd1c1496009b220$var$Q < $9bd1c1496009b220$var$P ? !1 : !0;
}
function $9bd1c1496009b220$var$R() {
    if (null !== $9bd1c1496009b220$var$O) {
        var a = $9bd1c1496009b220$export$c4744153514ff05d();
        $9bd1c1496009b220$var$Q = a;
        var b = !0;
        try {
            b = $9bd1c1496009b220$var$O(!0, a);
        } finally{
            b ? $9bd1c1496009b220$var$S() : ($9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null);
        }
    } else $9bd1c1496009b220$var$N = !1;
}
var $9bd1c1496009b220$var$S;
if ("function" === typeof $9bd1c1496009b220$var$F) $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$F($9bd1c1496009b220$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9bd1c1496009b220$var$T = new MessageChannel, $9bd1c1496009b220$var$U = $9bd1c1496009b220$var$T.port2;
    $9bd1c1496009b220$var$T.port1.onmessage = $9bd1c1496009b220$var$R;
    $9bd1c1496009b220$var$S = function() {
        $9bd1c1496009b220$var$U.postMessage(null);
    };
} else $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$D($9bd1c1496009b220$var$R, 0);
};
function $9bd1c1496009b220$var$I(a) {
    $9bd1c1496009b220$var$O = a;
    $9bd1c1496009b220$var$N || ($9bd1c1496009b220$var$N = !0, $9bd1c1496009b220$var$S());
}
function $9bd1c1496009b220$var$K(a, b) {
    $9bd1c1496009b220$var$L = $9bd1c1496009b220$var$D(function() {
        a($9bd1c1496009b220$export$c4744153514ff05d());
    }, b);
}
$9bd1c1496009b220$export$3e506c1ccc9cc1a7 = 5;
$9bd1c1496009b220$export$e26fe2ed2fa76875 = 1;
$9bd1c1496009b220$export$502329bbf4b505b1 = 4;
$9bd1c1496009b220$export$6e3807111c4874c4 = 3;
$9bd1c1496009b220$export$c27134553091fb3a = null;
$9bd1c1496009b220$export$33ee1acdc04fd2a2 = 2;
$9bd1c1496009b220$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9bd1c1496009b220$export$8352ce38b91d0c62 = function() {
    $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J));
};
$9bd1c1496009b220$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9bd1c1496009b220$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9bd1c1496009b220$export$d3dfb8e4810cb555 = function() {
    return $9bd1c1496009b220$var$y;
};
$9bd1c1496009b220$export$839f9183b0465a69 = function() {
    return $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
};
$9bd1c1496009b220$export$72fdf0e06517287b = function(a) {
    switch($9bd1c1496009b220$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9bd1c1496009b220$var$y;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = b;
    try {
        return a();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$4b844e58a3e414b4 = function() {};
$9bd1c1496009b220$export$816d2913ae6b83b1 = function() {};
$9bd1c1496009b220$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = a;
    try {
        return b();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9bd1c1496009b220$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9bd1c1496009b220$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$t, a), null === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && a === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t) && ($9bd1c1496009b220$var$B ? ($9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1) : $9bd1c1496009b220$var$B = !0, $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, c - d))) : (a.sortIndex = e, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, a), $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J)));
    return a;
};
$9bd1c1496009b220$export$b5836b71941fa3ed = $9bd1c1496009b220$var$M;
$9bd1c1496009b220$export$cf845f2c119da08a = function(a) {
    var b = $9bd1c1496009b220$var$y;
    return function() {
        var c = $9bd1c1496009b220$var$y;
        $9bd1c1496009b220$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9bd1c1496009b220$var$y = c;
        }
    };
};

});





parcelRegister("aSiaI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6ObR8"));

});
parcelRegister("6ObR8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4f509bf21ce2142e$export$ffb0004e005737fa; }, function (v) { return $4f509bf21ce2142e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4f509bf21ce2142e$export$34b9dba7ce09269b; }, function (v) { return $4f509bf21ce2142e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4f509bf21ce2142e$export$25062201e9e25d76; }, function (v) { return $4f509bf21ce2142e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4f509bf21ce2142e$export$ffb0004e005737fa;
var $4f509bf21ce2142e$export$34b9dba7ce09269b;
var $4f509bf21ce2142e$export$25062201e9e25d76;
"use strict";

var $exYeM = parcelRequire("exYeM");
var $4f509bf21ce2142e$var$k = Symbol.for("react.element"), $4f509bf21ce2142e$var$l = Symbol.for("react.fragment"), $4f509bf21ce2142e$var$m = Object.prototype.hasOwnProperty, $4f509bf21ce2142e$var$n = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4f509bf21ce2142e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4f509bf21ce2142e$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4f509bf21ce2142e$var$m.call(a, b) && !$4f509bf21ce2142e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4f509bf21ce2142e$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4f509bf21ce2142e$var$n.current
    };
}
$4f509bf21ce2142e$export$ffb0004e005737fa = $4f509bf21ce2142e$var$l;
$4f509bf21ce2142e$export$34b9dba7ce09269b = $4f509bf21ce2142e$var$q;
$4f509bf21ce2142e$export$25062201e9e25d76 = $4f509bf21ce2142e$var$q;

});


parcelRegister("lJ6o6", function(module, exports) {

$parcel$export(module.exports, "useProviderContext", function () { return $177a17ac1d04973c$export$f3632c8327428963; });

var $aC86g = parcelRequire("aC86g");
"use client";
var [$177a17ac1d04973c$export$b1da5abff9d0406, $177a17ac1d04973c$export$f3632c8327428963] = (0, $aC86g.createContext)({
    name: "ProviderContext",
    strict: false
});

});
parcelRegister("aC86g", function(module, exports) {

$parcel$export(module.exports, "createContext", function () { return $d3aa5cd4e49788f4$export$fd42f52fd3ae1109; });

var $exYeM = parcelRequire("exYeM");
"use client";
function $d3aa5cd4e49788f4$export$fd42f52fd3ae1109(options = {}) {
    const { strict: strict = true, errorMessage: errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider", name: name } = options;
    const Context = $exYeM.createContext(void 0);
    Context.displayName = name;
    function useContext2() {
        var _a;
        const context = $exYeM.useContext(Context);
        if (!context && strict) {
            const error = new Error(errorMessage);
            error.name = "ContextError";
            (_a = Error.captureStackTrace) == null || _a.call(Error, error, useContext2);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext2,
        Context
    ];
}

});


parcelRegister("k5F2B", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $ea041c2e85901869$export$80f3e147d781571c; });
$parcel$export(module.exports, "useFocusRing", function () { return $ea041c2e85901869$export$4e328f61c538687f; });
$parcel$export(module.exports, "useFocusable", function () { return $ea041c2e85901869$export$4c014de7c8940b4c; });

var $6Qamj = parcelRequire("6Qamj");
var $2ZDqh = parcelRequire("2ZDqh");
var $8vAG4 = parcelRequire("8vAG4");
var $jgteb = parcelRequire("jgteb");
var $71dP2 = parcelRequire("71dP2");
var $4g3pq = parcelRequire("4g3pq");
var $hbWr9 = parcelRequire("hbWr9");

var $exYeM = parcelRequire("exYeM");

var $1WOFx = parcelRequire("1WOFx");
var $inYxg = parcelRequire("inYxg");
var $itYo2 = parcelRequire("itYo2");
var $ikt5m = parcelRequire("ikt5m");

var $4qr5a = parcelRequire("4qr5a");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ea041c2e85901869$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $2ZDqh.getOwnerDocument)(element);
    if ((0, $1WOFx.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $jgteb.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $6Qamj.focusWithoutScrolling)(element);
        });
    } else (0, $6Qamj.focusWithoutScrolling)(element);
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ea041c2e85901869$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $ea041c2e85901869$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $ea041c2e85901869$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $ea041c2e85901869$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $ea041c2e85901869$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $ea041c2e85901869$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(element.parentElement, element));
}
const $ea041c2e85901869$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
let $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope = null;
function $ea041c2e85901869$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $exYeM.useRef)(null);
    let endRef = (0, $exYeM.useRef)(null);
    let scopeRef = (0, $exYeM.useRef)([]);
    let { parentNode: parentNode } = (0, $exYeM.useContext)($ea041c2e85901869$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $exYeM.useMemo)(()=>new $ea041c2e85901869$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.root;
        if ($ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope && !$ea041c2e85901869$var$$9bf71ea28793e738$var$isAncestorScope($ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        let node = $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $ea041c2e85901869$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $ea041c2e85901869$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $ea041c2e85901869$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $ea041c2e85901869$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $exYeM.useEffect)(()=>{
        const activeElement = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope || $ea041c2e85901869$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parentScope))) $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $exYeM.useMemo)(()=>$ea041c2e85901869$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $exYeM.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($ea041c2e85901869$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $ea041c2e85901869$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $exYeM.useContext)($ea041c2e85901869$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $ea041c2e85901869$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $ea041c2e85901869$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $ea041c2e85901869$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $ea041c2e85901869$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $ea041c2e85901869$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $ea041c2e85901869$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $ea041c2e85901869$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $ea041c2e85901869$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $ea041c2e85901869$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $ea041c2e85901869$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $ea041c2e85901869$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $ea041c2e85901869$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$ea041c2e85901869$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $ea041c2e85901869$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $ea041c2e85901869$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $ea041c2e85901869$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $ea041c2e85901869$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $ea041c2e85901869$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $exYeM.useRef)();
    let raf = (0, $exYeM.useRef)();
    (0, $71dP2.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$ea041c2e85901869$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $ea041c2e85901869$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $ea041c2e85901869$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope || $ea041c2e85901869$var$$9bf71ea28793e738$var$isAncestorScope($ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($ea041c2e85901869$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope && $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope.current) $ea041c2e85901869$var$$9bf71ea28793e738$var$focusFirstInScope($ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($ea041c2e85901869$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $ea041c2e85901869$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope.current) $ea041c2e85901869$var$$9bf71ea28793e738$var$focusFirstInScope($ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.traverse($ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $ea041c2e85901869$export$1258395f99bf9cbf(element) {
    return $ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInChildScope(element, $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope);
}
function $ea041c2e85901869$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        $ea041c2e85901869$export$80f3e147d781571c(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $ea041c2e85901869$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $ea041c2e85901869$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $ea041c2e85901869$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $ea041c2e85901869$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $ea041c2e85901869$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(nextNode);
}
function $ea041c2e85901869$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(autoFocus);
    (0, $exYeM.useEffect)(()=>{
        if (autoFocusRef.current) {
            $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $ea041c2e85901869$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $ea041c2e85901869$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $71dP2.useLayoutEffect)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $ea041c2e85901869$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $ea041c2e85901869$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $exYeM.useRef)(typeof document !== "undefined" ? (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $71dP2.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope || $ea041c2e85901869$var$$9bf71ea28793e738$var$isAncestorScope($ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $ea041c2e85901869$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$ea041c2e85901869$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $ea041c2e85901869$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $ea041c2e85901869$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $ea041c2e85901869$var$$9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $ea041c2e85901869$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $ea041c2e85901869$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $ea041c2e85901869$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $2ZDqh.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && $ea041c2e85901869$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(node) && (!scope || $ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $ea041c2e85901869$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(root).activeElement;
            let walker = $ea041c2e85901869$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(root).activeElement;
            let walker = $ea041c2e85901869$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $ea041c2e85901869$var$$9bf71ea28793e738$var$last(walker);
                if (next) $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $ea041c2e85901869$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $ea041c2e85901869$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $ea041c2e85901869$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $ea041c2e85901869$var$$9bf71ea28793e738$var$last(walker);
            if (next) $ea041c2e85901869$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $ea041c2e85901869$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $ea041c2e85901869$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $ea041c2e85901869$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $ea041c2e85901869$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $ea041c2e85901869$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $ea041c2e85901869$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $ea041c2e85901869$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $ea041c2e85901869$var$$9bf71ea28793e738$export$d06fae2ee68b101e = new $ea041c2e85901869$var$$9bf71ea28793e738$var$Tree();
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ea041c2e85901869$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $exYeM.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $1WOFx.isFocusVisible)()
    });
    let [isFocused, setFocused] = (0, $exYeM.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $exYeM.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $exYeM.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $1WOFx.useFocusVisibleListener)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $inYxg.useFocus)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $itYo2.useFocusWithin)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}
function $ea041c2e85901869$export$1a38b4ad7f578e1d(props) {
    let { children: children, focusClass: focusClass, focusRingClass: focusRingClass } = props;
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = $ea041c2e85901869$export$4e328f61c538687f(props);
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Children.only(children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).cloneElement(child, (0, $8vAG4.mergeProps)(child.props, {
        ...focusProps,
        className: (0, $4qr5a.default)({
            [focusClass || ""]: isFocused,
            [focusRingClass || ""]: isFocusVisible
        })
    }));
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $ea041c2e85901869$var$$e6afbd83fe6ebbd2$var$FocusableContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
function $ea041c2e85901869$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $exYeM.useContext)($ea041c2e85901869$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $hbWr9.useSyncRef)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $ea041c2e85901869$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $4g3pq.useObjectRef)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($ea041c2e85901869$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $ea041c2e85901869$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef($ea041c2e85901869$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $ea041c2e85901869$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $inYxg.useFocus)(props);
    let { keyboardProps: keyboardProps } = (0, $ikt5m.useKeyboard)(props);
    let interactions = (0, $8vAG4.mergeProps)(focusProps, keyboardProps);
    let domProps = $ea041c2e85901869$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $exYeM.useRef)(props.autoFocus);
    (0, $exYeM.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) $ea041c2e85901869$export$80f3e147d781571c(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $8vAG4.mergeProps)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ea041c2e85901869$export$eac1895992b9f3d6(ref, options) {
    let isDisabled = options === null || options === void 0 ? void 0 : options.isDisabled;
    let [hasTabbableChild, setHasTabbableChild] = (0, $exYeM.useState)(false);
    (0, $71dP2.useLayoutEffect)(()=>{
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && !isDisabled) {
            let update = ()=>{
                if (ref.current) {
                    let walker = $ea041c2e85901869$export$2d6ec8fc375ceafa(ref.current, {
                        tabbable: true
                    });
                    setHasTabbableChild(!!walker.nextNode());
                }
            };
            update();
            // Update when new elements are inserted, or the tabIndex/disabled attribute updates.
            let observer = new MutationObserver(update);
            observer.observe(ref.current, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: [
                    "tabIndex",
                    "disabled"
                ]
            });
            return ()=>{
                // Disconnect mutation observer when a React update occurs on the top-level component
                // so we update synchronously after re-rendering. Otherwise React will emit act warnings
                // in tests since mutation observers fire asynchronously. The mutation observer is necessary
                // so we also update if a child component re-renders and adds/removes something tabbable.
                observer.disconnect();
            };
        }
    });
    return isDisabled ? false : hasTabbableChild;
}

});
parcelRegister("6Qamj", function(module, exports) {

$parcel$export(module.exports, "focusWithoutScrolling", function () { return $4fafa273356437cf$export$de79e2c695e052f3; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4fafa273356437cf$export$de79e2c695e052f3(element) {
    if ($4fafa273356437cf$var$$7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $4fafa273356437cf$var$$7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $4fafa273356437cf$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $4fafa273356437cf$var$$7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $4fafa273356437cf$var$$7215afc6de606d6b$var$supportsPreventScroll() {
    if ($4fafa273356437cf$var$$7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $4fafa273356437cf$var$$7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            let focusElem = document.createElement("div");
            focusElem.focus({
                get preventScroll () {
                    $4fafa273356437cf$var$$7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $4fafa273356437cf$var$$7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $4fafa273356437cf$var$$7215afc6de606d6b$var$getScrollableElements(element) {
    let parent = element.parentNode;
    let scrollableElements = [];
    let rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $4fafa273356437cf$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}

});

parcelRegister("2ZDqh", function(module, exports) {

$parcel$export(module.exports, "getOwnerDocument", function () { return $22dfdbd1b46556c2$export$b204af158042fbac; });
$parcel$export(module.exports, "getOwnerWindow", function () { return $22dfdbd1b46556c2$export$f21a1ffae260145a; });
const $22dfdbd1b46556c2$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $22dfdbd1b46556c2$export$f21a1ffae260145a = (el)=>{
    if (el && "window" in el && el.window === el) return el;
    const doc = $22dfdbd1b46556c2$export$b204af158042fbac(el);
    return doc.defaultView || window;
};

});

parcelRegister("8vAG4", function(module, exports) {

$parcel$export(module.exports, "mergeProps", function () { return $631dab61dcd04b39$export$9d1611c77c2fe928; });

var $kdWpA = parcelRequire("kdWpA");

var $ezzQB = parcelRequire("ezzQB");

var $4qr5a = parcelRequire("4qr5a");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $631dab61dcd04b39$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
            key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = (0, $kdWpA.chain)(a, b);
            else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = (0, $4qr5a.default)(a, b);
            else if (key === "id" && a && b) result.id = (0, $ezzQB.mergeIds)(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}

});
parcelRegister("kdWpA", function(module, exports) {

$parcel$export(module.exports, "chain", function () { return $eb9254e15e5f66bc$export$e08e3b67e392101e; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $eb9254e15e5f66bc$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === "function") callback(...args);
    };
}

});

parcelRegister("ezzQB", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $a9c0242283f8e1a2$export$f680877a34711e37; });
$parcel$export(module.exports, "mergeIds", function () { return $a9c0242283f8e1a2$export$cd8c9cb68f842629; });
$parcel$export(module.exports, "useSlotId", function () { return $a9c0242283f8e1a2$export$b4cc09c592e8fdb8; });

var $71dP2 = parcelRequire("71dP2");

var $dXSmZ = parcelRequire("dXSmZ");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
let $a9c0242283f8e1a2$var$$bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $a9c0242283f8e1a2$var$$bdb11010cef70236$var$idsUpdaterMap = new Map();
function $a9c0242283f8e1a2$export$f680877a34711e37(defaultId) {
    let [value, setValue] = (0, $exYeM.useState)(defaultId);
    let nextId = (0, $exYeM.useRef)(null);
    let res = (0, $aVmq3.useSSRSafeId)(value);
    let updateValue = (0, $exYeM.useCallback)((val)=>{
        nextId.current = val;
    }, []);
    if ($a9c0242283f8e1a2$var$$bdb11010cef70236$var$canUseDOM) $a9c0242283f8e1a2$var$$bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
    (0, $71dP2.useLayoutEffect)(()=>{
        let r = res;
        return ()=>{
            $a9c0242283f8e1a2$var$$bdb11010cef70236$var$idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    (0, $exYeM.useEffect)(()=>{
        let newId = nextId.current;
        if (newId) {
            nextId.current = null;
            setValue(newId);
        }
    });
    return res;
}
function $a9c0242283f8e1a2$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdA = $a9c0242283f8e1a2$var$$bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    let setIdB = $a9c0242283f8e1a2$var$$bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}
function $a9c0242283f8e1a2$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $a9c0242283f8e1a2$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = (0, $dXSmZ.useValueEffect)(id);
    let updateId = (0, $exYeM.useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : undefined;
        });
    }, [
        id,
        setResolvedId
    ]);
    (0, $71dP2.useLayoutEffect)(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}

});
parcelRegister("71dP2", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $51c3592f61a78bd5$export$e5c5a5f917a5871c; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $51c3592f61a78bd5$export$e5c5a5f917a5871c = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useLayoutEffect : ()=>{};

});

parcelRegister("dXSmZ", function(module, exports) {

$parcel$export(module.exports, "useValueEffect", function () { return $a2aaf5bd05213161$export$14d238f342723f25; });

var $4sExG = parcelRequire("4sExG");

var $71dP2 = parcelRequire("71dP2");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a2aaf5bd05213161$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = (0, $exYeM.useState)(defaultValue);
    let effect = (0, $exYeM.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (0, $4sExG.useEffectEvent)(()=>{
        if (!effect.current) return;
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value === newValue.value) nextRef();
        else setValue(newValue.value);
    });
    (0, $71dP2.useLayoutEffect)(()=>{
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef();
    });
    let queue = (0, $4sExG.useEffectEvent)((fn)=>{
        effect.current = fn(value);
        nextRef();
    });
    return [
        value,
        queue
    ];
}

});
parcelRegister("4sExG", function(module, exports) {

$parcel$export(module.exports, "useEffectEvent", function () { return $33f939c87f603cbd$export$7f54fc3180508a52; });

var $71dP2 = parcelRequire("71dP2");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $33f939c87f603cbd$export$7f54fc3180508a52(fn) {
    const ref = (0, $exYeM.useRef)(null);
    (0, $71dP2.useLayoutEffect)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $exYeM.useCallback)((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}

});


parcelRegister("aVmq3", function(module, exports) {

$parcel$export(module.exports, "useIsSSR", function () { return $7f409e3bcbe2ba29$export$535bd6ca7f90a273; });
$parcel$export(module.exports, "useSSRSafeId", function () { return $7f409e3bcbe2ba29$export$619500959fc48b26; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext($7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$defaultContext);
const $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(false);
// This is only used in React < 18.
function $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $exYeM.useContext)($7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$useCounter(cur === $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $exYeM.useState)(true);
    let value = (0, $exYeM.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$defaultContext ? "" : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, $exYeM.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $7f409e3bcbe2ba29$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)))["useId"] === "function") {
        if (!$7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $exYeM.useContext)($7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $exYeM.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $exYeM.useContext)($7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$defaultContext && !$7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    let counter = $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useId();
    let [didSSR] = (0, $exYeM.useState)($7f409e3bcbe2ba29$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? "react-aria" : `react-aria${$7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $7f409e3bcbe2ba29$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)))["useId"] === "function" ? $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$useModernSSRSafeId : $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $7f409e3bcbe2ba29$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)))["useSyncExternalStore"] === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)))["useSyncExternalStore"]($7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$subscribe, $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$getSnapshot, $7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $exYeM.useContext)($7f409e3bcbe2ba29$var$$b5e257d569688ac6$var$IsSSRContext);
}

});


parcelRegister("4qr5a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fecb99b999628060$export$2e2bcd8739ae039; });
function $fecb99b999628060$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $fecb99b999628060$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $fecb99b999628060$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $fecb99b999628060$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fecb99b999628060$export$2e2bcd8739ae039 = $fecb99b999628060$export$4f5d2d50c9deca37;

});


parcelRegister("jgteb", function(module, exports) {

$parcel$export(module.exports, "runAfterTransition", function () { return $e0662efc2d7e22ca$export$24490316f764c430; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $e0662efc2d7e22ca$var$$bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $e0662efc2d7e22ca$var$$bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $e0662efc2d7e22ca$var$$bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === "undefined") return;
    function isTransitionEvent(event) {
        return "propertyName" in event;
    }
    let onTransitionStart = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Add the transitioning property to the list for this element.
        let transitions = $e0662efc2d7e22ca$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $e0662efc2d7e22ca$var$$bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener("transitioncancel", onTransitionEnd, {
                once: true
            });
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Remove property from list of transitioning properties.
        let properties = $e0662efc2d7e22ca$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener("transitioncancel", onTransitionEnd);
            $e0662efc2d7e22ca$var$$bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($e0662efc2d7e22ca$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            for (let cb of $e0662efc2d7e22ca$var$$bbed8b41f857bcc0$var$transitionCallbacks)cb();
            $e0662efc2d7e22ca$var$$bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener("transitionrun", onTransitionStart);
    document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $e0662efc2d7e22ca$var$$bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener("DOMContentLoaded", $e0662efc2d7e22ca$var$$bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $e0662efc2d7e22ca$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($e0662efc2d7e22ca$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $e0662efc2d7e22ca$var$$bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}

});

parcelRegister("4g3pq", function(module, exports) {

$parcel$export(module.exports, "useObjectRef", function () { return $319b4d0b65828c10$export$4338b53315abf666; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $319b4d0b65828c10$export$4338b53315abf666(forwardedRef) {
    const objRef = (0, $exYeM.useRef)(null);
    return (0, $exYeM.useMemo)(()=>({
            get current () {
                return objRef.current;
            },
            set current (value){
                objRef.current = value;
                if (typeof forwardedRef === "function") forwardedRef(value);
                else if (forwardedRef) forwardedRef.current = value;
            }
        }), [
        forwardedRef
    ]);
}

});

parcelRegister("hbWr9", function(module, exports) {

$parcel$export(module.exports, "useSyncRef", function () { return $c840cb14450b580f$export$4debdb1a3f0fa79e; });

var $71dP2 = parcelRequire("71dP2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c840cb14450b580f$export$4debdb1a3f0fa79e(context, ref) {
    (0, $71dP2.useLayoutEffect)(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                if (context.ref) context.ref.current = null;
            };
        }
    });
}

});

parcelRegister("1WOFx", function(module, exports) {

$parcel$export(module.exports, "isFocusVisible", function () { return $16b2830c6963ec5b$export$b9b3dfddab17db27; });
$parcel$export(module.exports, "getInteractionModality", function () { return $16b2830c6963ec5b$export$630ff653c5ada6a9; });
$parcel$export(module.exports, "useFocusVisibleListener", function () { return $16b2830c6963ec5b$export$ec71b4b83ac08ec3; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$currentModality = null;
let $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $16b2830c6963ec5b$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $gbqqi.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($16b2830c6963ec5b$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $87CgO.isVirtualClick)(e)) {
        $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$16b2830c6963ec5b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$16b2830c6963ec5b$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $16b2830c6963ec5b$export$d90243b58daecda7.get((0, $2ZDqh.getOwnerWindow)(element))) return;
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $16b2830c6963ec5b$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$16b2830c6963ec5b$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $16b2830c6963ec5b$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $16b2830c6963ec5b$export$d90243b58daecda7.delete(windowObject);
};
function $16b2830c6963ec5b$export$2f1888112f558a7d(element) {
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$16b2830c6963ec5b$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $16b2830c6963ec5b$export$2f1888112f558a7d();
function $16b2830c6963ec5b$export$b9b3dfddab17db27() {
    return $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $16b2830c6963ec5b$export$630ff653c5ada6a9() {
    return $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$currentModality;
}
function $16b2830c6963ec5b$export$8397ddfc504fdb9a(modality) {
    $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$currentModality = modality;
    $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $16b2830c6963ec5b$export$98e20ec92f614cfe() {
    $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $exYeM.useState)($16b2830c6963ec5b$var$$507fabe10e71c6fb$var$currentModality);
    (0, $exYeM.useEffect)(()=>{
        let handler = ()=>{
            setModality($16b2830c6963ec5b$var$$507fabe10e71c6fb$var$currentModality);
        };
        $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $aVmq3.useIsSSR)() ? null : modality;
}
const $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$16b2830c6963ec5b$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$16b2830c6963ec5b$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $16b2830c6963ec5b$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(autoFocus || $16b2830c6963ec5b$export$b9b3dfddab17db27());
    $16b2830c6963ec5b$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $16b2830c6963ec5b$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $exYeM.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$16b2830c6963ec5b$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($16b2830c6963ec5b$export$b9b3dfddab17db27());
        };
        $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $16b2830c6963ec5b$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});
parcelRegister("gbqqi", function(module, exports) {

$parcel$export(module.exports, "isMac", function () { return $bc822b7bfe7ba15c$export$9ac100e40613ea10; });
$parcel$export(module.exports, "isIPad", function () { return $bc822b7bfe7ba15c$export$7bef049ce92e4224; });
$parcel$export(module.exports, "isIOS", function () { return $bc822b7bfe7ba15c$export$fedb369cb70207f1; });
$parcel$export(module.exports, "isAppleDevice", function () { return $bc822b7bfe7ba15c$export$e1865c3bedcd822b; });
$parcel$export(module.exports, "isWebKit", function () { return $bc822b7bfe7ba15c$export$78551043582a6a98; });
$parcel$export(module.exports, "isAndroid", function () { return $bc822b7bfe7ba15c$export$a11b0059900ceec8; });
$parcel$export(module.exports, "isFirefox", function () { return $bc822b7bfe7ba15c$export$b7d78993b74f766d; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bc822b7bfe7ba15c$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $bc822b7bfe7ba15c$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $bc822b7bfe7ba15c$export$9ac100e40613ea10() {
    return $bc822b7bfe7ba15c$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $bc822b7bfe7ba15c$export$186c6964ca17d99() {
    return $bc822b7bfe7ba15c$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $bc822b7bfe7ba15c$export$7bef049ce92e4224() {
    return $bc822b7bfe7ba15c$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $bc822b7bfe7ba15c$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $bc822b7bfe7ba15c$export$fedb369cb70207f1() {
    return $bc822b7bfe7ba15c$export$186c6964ca17d99() || $bc822b7bfe7ba15c$export$7bef049ce92e4224();
}
function $bc822b7bfe7ba15c$export$e1865c3bedcd822b() {
    return $bc822b7bfe7ba15c$export$9ac100e40613ea10() || $bc822b7bfe7ba15c$export$fedb369cb70207f1();
}
function $bc822b7bfe7ba15c$export$78551043582a6a98() {
    return $bc822b7bfe7ba15c$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$bc822b7bfe7ba15c$export$6446a186d09e379e();
}
function $bc822b7bfe7ba15c$export$6446a186d09e379e() {
    return $bc822b7bfe7ba15c$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
}
function $bc822b7bfe7ba15c$export$a11b0059900ceec8() {
    return $bc822b7bfe7ba15c$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
}
function $bc822b7bfe7ba15c$export$b7d78993b74f766d() {
    return $bc822b7bfe7ba15c$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
}

});

parcelRegister("87CgO", function(module, exports) {

$parcel$export(module.exports, "isVirtualClick", function () { return $5e9ca9d3d45f0d5e$export$60278871457622de; });
$parcel$export(module.exports, "isVirtualPointerEvent", function () { return $5e9ca9d3d45f0d5e$export$29bf1b5f2c56cf63; });

var $gbqqi = parcelRequire("gbqqi");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5e9ca9d3d45f0d5e$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $gbqqi.isAndroid)() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $5e9ca9d3d45f0d5e$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $gbqqi.isAndroid)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}

});


parcelRegister("inYxg", function(module, exports) {

$parcel$export(module.exports, "useFocus", function () { return $d62955142d323753$export$f8168d8dd8fd66e6; });

var $4ZoGt = parcelRequire("4ZoGt");

var $exYeM = parcelRequire("exYeM");

var $2ZDqh = parcelRequire("2ZDqh");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $d62955142d323753$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $exYeM.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $4ZoGt.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $exYeM.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});
parcelRegister("4ZoGt", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $3a2001ac72ad3fe4$export$715c682d09d639cc; });

var $exYeM = parcelRequire("exYeM");

var $4sExG = parcelRequire("4sExG");
var $71dP2 = parcelRequire("71dP2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $3a2001ac72ad3fe4$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $3a2001ac72ad3fe4$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $exYeM.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $71dP2.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $4sExG.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $exYeM.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $3a2001ac72ad3fe4$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("itYo2", function(module, exports) {

$parcel$export(module.exports, "useFocusWithin", function () { return $d749c6fb3a213d99$export$420e68273165f4ec; });

var $4ZoGt = parcelRequire("4ZoGt");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $d749c6fb3a213d99$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $exYeM.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $exYeM.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, $4ZoGt.useSyntheticBlurEvent)(onBlur);
    let onFocus = (0, $exYeM.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

});

parcelRegister("ikt5m", function(module, exports) {

$parcel$export(module.exports, "useKeyboard", function () { return $d580a80af52e3ed8$export$8f71654801c2f7cd; });

var $di7mJ = parcelRequire("di7mJ");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d580a80af52e3ed8$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $di7mJ.createEventHandler)(props.onKeyDown),
            onKeyUp: (0, $di7mJ.createEventHandler)(props.onKeyUp)
        }
    };
}

});
parcelRegister("di7mJ", function(module, exports) {

$parcel$export(module.exports, "createEventHandler", function () { return $9ad2ab77f7b49f8a$export$48d1ea6320830260; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9ad2ab77f7b49f8a$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}

});



parcelRegister("a2Moz", function(module, exports) {

$parcel$export(module.exports, "tv", function () { return $97013b9b51937b99$export$984d890fc49ac622; });

var $2ltyO = parcelRequire("2ltyO");

var $bBhUq = parcelRequire("bBhUq");
var $97013b9b51937b99$export$984d890fc49ac622 = (options, config)=>{
    var _a, _b, _c;
    return (0, $bBhUq.tv)(options, {
        ...config,
        twMerge: (_a = config == null ? void 0 : config.twMerge) != null ? _a : true,
        twMergeConfig: {
            ...config == null ? void 0 : config.twMergeConfig,
            theme: {
                ...(_b = config == null ? void 0 : config.twMergeConfig) == null ? void 0 : _b.theme,
                ...(0, $2ltyO.twMergeConfig).theme
            },
            classGroups: {
                ...(_c = config == null ? void 0 : config.twMergeConfig) == null ? void 0 : _c.classGroups,
                ...(0, $2ltyO.twMergeConfig).classGroups
            }
        }
    });
};

});
parcelRegister("2ltyO", function(module, exports) {

$parcel$export(module.exports, "twMergeConfig", function () { return $19dec27533bf4eb8$export$c5ce76624eaef353; });
// src/utils/tw-merge-config.ts
var $19dec27533bf4eb8$export$7c071ef0138dc46e = [
    "small",
    "medium",
    "large"
];
var $19dec27533bf4eb8$export$c5ce76624eaef353 = {
    theme: {
        opacity: [
            "disabled"
        ],
        spacing: [
            "divider"
        ],
        borderWidth: $19dec27533bf4eb8$export$7c071ef0138dc46e,
        borderRadius: $19dec27533bf4eb8$export$7c071ef0138dc46e
    },
    classGroups: {
        shadow: [
            {
                shadow: $19dec27533bf4eb8$export$7c071ef0138dc46e
            }
        ],
        "font-size": [
            {
                text: [
                    "tiny",
                    ...$19dec27533bf4eb8$export$7c071ef0138dc46e
                ]
            }
        ],
        "bg-image": [
            "bg-stripe-gradient"
        ]
    }
};

});

parcelRegister("bBhUq", function(module, exports) {

$parcel$export(module.exports, "tv", function () { return $87210ac4cc7e84cb$export$984d890fc49ac622; });

var $cFEpI = parcelRequire("cFEpI");

var $dNTky = parcelRequire("dNTky");
var $f3Siq = parcelRequire("f3Siq");
var $87210ac4cc7e84cb$export$f84bd70098573c5c = {
    twMerge: !0,
    twMergeConfig: {},
    responsiveVariants: !1
}, $87210ac4cc7e84cb$export$b2b720306681cd4b = (s)=>s || void 0, $87210ac4cc7e84cb$export$bdb9d1405dbffd0f = (...s)=>$87210ac4cc7e84cb$export$b2b720306681cd4b((0, $cFEpI.e)(s).filter(Boolean).join(" ")), $87210ac4cc7e84cb$var$q = null, $87210ac4cc7e84cb$var$M = {}, $87210ac4cc7e84cb$var$F = !1, $87210ac4cc7e84cb$export$1343a74baacb0543 = (...s)=>(b$1)=>b$1.twMerge ? ((!$87210ac4cc7e84cb$var$q || $87210ac4cc7e84cb$var$F) && ($87210ac4cc7e84cb$var$F = !1, $87210ac4cc7e84cb$var$q = (0, $cFEpI.b)($87210ac4cc7e84cb$var$M) ? (0, $f3Siq.twMerge) : (0, $dNTky.extendTailwindMerge)($87210ac4cc7e84cb$var$M)), $87210ac4cc7e84cb$export$b2b720306681cd4b($87210ac4cc7e84cb$var$q($87210ac4cc7e84cb$export$bdb9d1405dbffd0f(s)))) : $87210ac4cc7e84cb$export$bdb9d1405dbffd0f(s), $87210ac4cc7e84cb$var$Z = (s, b)=>{
    for(let e in b)s.hasOwnProperty(e) ? s[e] = $87210ac4cc7e84cb$export$bdb9d1405dbffd0f(s[e], b[e]) : s[e] = b[e];
    return s;
}, $87210ac4cc7e84cb$export$984d890fc49ac622 = (s, b$1)=>{
    let { extend: e = null, slots: j = {}, variants: U = {}, compoundVariants: C = [], compoundSlots: V = [], defaultVariants: W = {} } = s, m = {
        ...$87210ac4cc7e84cb$export$f84bd70098573c5c,
        ...b$1
    }, S = e != null && e.base ? $87210ac4cc7e84cb$export$bdb9d1405dbffd0f(e.base, s == null ? void 0 : s.base) : s == null ? void 0 : s.base, g$1 = e != null && e.variants && !(0, $cFEpI.b)(e.variants) ? (0, $cFEpI.g)(U, e.variants) : U, A = e != null && e.defaultVariants && !(0, $cFEpI.b)(e.defaultVariants) ? {
        ...e.defaultVariants,
        ...W
    } : W;
    !(0, $cFEpI.b)(m.twMergeConfig) && !(0, $cFEpI.c)(m.twMergeConfig, $87210ac4cc7e84cb$var$M) && ($87210ac4cc7e84cb$var$F = !0, $87210ac4cc7e84cb$var$M = m.twMergeConfig);
    let O = (0, $cFEpI.b)(e == null ? void 0 : e.slots), $ = (0, $cFEpI.b)(j) ? {} : {
        base: $87210ac4cc7e84cb$export$bdb9d1405dbffd0f(s == null ? void 0 : s.base, O && (e == null ? void 0 : e.base)),
        ...j
    }, h$1 = O ? $ : $87210ac4cc7e84cb$var$Z({
        ...e == null ? void 0 : e.slots
    }, (0, $cFEpI.b)($) ? {
        base: s == null ? void 0 : s.base
    } : $), v = (l)=>{
        if ((0, $cFEpI.b)(g$1) && (0, $cFEpI.b)(j) && O) return $87210ac4cc7e84cb$export$1343a74baacb0543(S, l == null ? void 0 : l.class, l == null ? void 0 : l.className)(m);
        if (C && !Array.isArray(C)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof C}`);
        if (V && !Array.isArray(V)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof V}`);
        let K = (t, n, a = [], i)=>{
            let r = a;
            if (typeof n == "string") r = r.concat((0, $cFEpI.h)(n).split(" ").map((c)=>`${t}:${c}`));
            else if (Array.isArray(n)) r = r.concat(n.reduce((c, f)=>c.concat(`${t}:${f}`), []));
            else if (typeof n == "object" && typeof i == "string") {
                for(let c in n)if (n.hasOwnProperty(c) && c === i) {
                    let f = n[c];
                    if (f && typeof f == "string") {
                        let o = (0, $cFEpI.h)(f);
                        r[i] ? r[i] = r[i].concat(o.split(" ").map((u)=>`${t}:${u}`)) : r[i] = o.split(" ").map((u)=>`${t}:${u}`);
                    } else Array.isArray(f) && f.length > 0 && (r[i] = f.reduce((o, u)=>o.concat(`${t}:${u}`), []));
                }
            }
            return r;
        }, z = (t, n = g$1, a$1 = null, i = null)=>{
            var J;
            let r = n[t];
            if (!r || (0, $cFEpI.b)(r)) return null;
            let c = (J = i == null ? void 0 : i[t]) != null ? J : l == null ? void 0 : l[t];
            if (c === null) return null;
            let f = (0, $cFEpI.a)(c), o = Array.isArray(m.responsiveVariants) && m.responsiveVariants.length > 0 || m.responsiveVariants === !0, u = A == null ? void 0 : A[t], d = [];
            if (typeof f == "object" && o) for (let [k, L] of Object.entries(f)){
                let ae = r[L];
                if (k === "initial") {
                    u = L;
                    continue;
                }
                Array.isArray(m.responsiveVariants) && !m.responsiveVariants.includes(k) || (d = K(k, ae, d, a$1));
            }
            let T = r[f] || r[(0, $cFEpI.a)(u)];
            return typeof d == "object" && typeof a$1 == "string" && d[a$1] ? $87210ac4cc7e84cb$var$Z(d, T) : d.length > 0 ? (d.push(T), d) : T;
        }, P = ()=>g$1 ? Object.keys(g$1).map((t)=>z(t, g$1)) : null, p = (t, n)=>{
            if (!g$1 || typeof g$1 != "object") return null;
            let a = new Array;
            for(let i in g$1){
                let r = z(i, g$1, t, n), c = t === "base" && typeof r == "string" ? r : r && r[t];
                c && (a[a.length] = c);
            }
            return a;
        }, D = {};
        for(let t in l)l[t] !== void 0 && (D[t] = l[t]);
        let G = (t, n)=>{
            var i;
            let a = typeof (l == null ? void 0 : l[t]) == "object" ? {
                [t]: (i = l[t]) == null ? void 0 : i.initial
            } : {};
            return {
                ...A,
                ...D,
                ...a,
                ...n
            };
        }, H = (t = [], n)=>{
            let a = [];
            for (let { class: i, className: r, ...c } of t){
                let f = !0;
                for (let [o, u] of Object.entries(c)){
                    let d = G(o, n);
                    if (Array.isArray(u)) {
                        if (!u.includes(d[o])) {
                            f = !1;
                            break;
                        }
                    } else if (d[o] !== u) {
                        f = !1;
                        break;
                    }
                }
                f && (i && a.push(i), r && a.push(r));
            }
            return a;
        }, I = (t)=>{
            let n = H(C, t), a = H(e == null ? void 0 : e.compoundVariants, t);
            return (0, $cFEpI.f)(a, n);
        }, ee = (t)=>{
            let n = I(t);
            if (!Array.isArray(n)) return n;
            let a = {};
            for (let i of n)if (typeof i == "string" && (a.base = $87210ac4cc7e84cb$export$1343a74baacb0543(a.base, i)(m)), typeof i == "object") for (let [r, c] of Object.entries(i))a[r] = $87210ac4cc7e84cb$export$1343a74baacb0543(a[r], c)(m);
            return a;
        }, te = (t)=>{
            if (V.length < 1) return null;
            let n = {};
            for (let { slots: a = [], class: i, className: r, ...c } of V){
                if (!(0, $cFEpI.b)(c)) {
                    let f = !0;
                    for (let o of Object.keys(c)){
                        let u = G(o, t)[o];
                        if (u === void 0 || (Array.isArray(c[o]) ? !c[o].includes(u) : c[o] !== u)) {
                            f = !1;
                            break;
                        }
                    }
                    if (!f) continue;
                }
                for (let f of a)n[f] = n[f] || [], n[f].push([
                    i,
                    r
                ]);
            }
            return n;
        };
        if (!(0, $cFEpI.b)(j) || !O) {
            let t = {};
            if (typeof h$1 == "object" && !(0, $cFEpI.b)(h$1)) for (let n of Object.keys(h$1))t[n] = (a)=>{
                var i, r;
                return $87210ac4cc7e84cb$export$1343a74baacb0543(h$1[n], p(n, a), ((i = ee(a)) != null ? i : [])[n], ((r = te(a)) != null ? r : [])[n], a == null ? void 0 : a.class, a == null ? void 0 : a.className)(m);
            };
            return t;
        }
        return $87210ac4cc7e84cb$export$1343a74baacb0543(S, P(), I(), l == null ? void 0 : l.class, l == null ? void 0 : l.className)(m);
    }, x = ()=>{
        if (!(!g$1 || typeof g$1 != "object")) return Object.keys(g$1);
    };
    return v.variantKeys = x(), v.extend = e, v.base = S, v.slots = h$1, v.variants = g$1, v.defaultVariants = A, v.compoundSlots = V, v.compoundVariants = C, v;
}, $87210ac4cc7e84cb$export$cc73e0e70ed8b709 = (s)=>(b, e)=>$87210ac4cc7e84cb$export$984d890fc49ac622(b, e ? (0, $cFEpI.g)(s, e) : s);

});
parcelRegister("cFEpI", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $9398a9b2f3d70aa1$export$407448d2b89b1813; });
$parcel$export(module.exports, "b", function () { return $9398a9b2f3d70aa1$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "c", function () { return $9398a9b2f3d70aa1$export$db3b6bfb95261072; });
$parcel$export(module.exports, "e", function () { return $9398a9b2f3d70aa1$export$f1e1789686576879; });
$parcel$export(module.exports, "f", function () { return $9398a9b2f3d70aa1$export$2d1720544b23b823; });
$parcel$export(module.exports, "g", function () { return $9398a9b2f3d70aa1$export$39b482c5e57630a8; });
$parcel$export(module.exports, "h", function () { return $9398a9b2f3d70aa1$export$dda1d9f60106f0e9; });
var $9398a9b2f3d70aa1$export$407448d2b89b1813 = (e)=>typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, $9398a9b2f3d70aa1$export$8b22cf2602fb60ce = (e)=>!e || typeof e != "object" || Object.keys(e).length === 0, $9398a9b2f3d70aa1$export$db3b6bfb95261072 = (e, o)=>JSON.stringify(e) === JSON.stringify(o), $9398a9b2f3d70aa1$export$4368d992c4eafac0 = (e)=>typeof e == "boolean";
function $9398a9b2f3d70aa1$var$i(e, o) {
    e.forEach(function(r) {
        Array.isArray(r) ? $9398a9b2f3d70aa1$var$i(r, o) : o.push(r);
    });
}
function $9398a9b2f3d70aa1$export$f1e1789686576879(e) {
    let o = [];
    return $9398a9b2f3d70aa1$var$i(e, o), o;
}
var $9398a9b2f3d70aa1$export$2d1720544b23b823 = (...e)=>$9398a9b2f3d70aa1$export$f1e1789686576879(e).filter(Boolean), $9398a9b2f3d70aa1$export$39b482c5e57630a8 = (e, o)=>{
    let r = {}, c = Object.keys(e), f = Object.keys(o);
    for (let t of c)if (f.includes(t)) {
        let s = e[t], n = o[t];
        typeof s == "object" && typeof n == "object" ? r[t] = $9398a9b2f3d70aa1$export$39b482c5e57630a8(s, n) : Array.isArray(s) || Array.isArray(n) ? r[t] = $9398a9b2f3d70aa1$export$2d1720544b23b823(n, s) : r[t] = n + " " + s;
    } else r[t] = e[t];
    for (let t of f)c.includes(t) || (r[t] = o[t]);
    return r;
}, $9398a9b2f3d70aa1$export$dda1d9f60106f0e9 = (e)=>!e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim();

});

parcelRegister("dNTky", function(module, exports) {

$parcel$export(module.exports, "extendTailwindMerge", function () { return $cea7ea78a160fb57$export$c8d8406b6cd2243e; });

var $8odOT = parcelRequire("8odOT");

var $8YM4g = parcelRequire("8YM4g");

var $80CZy = parcelRequire("80CZy");
function $cea7ea78a160fb57$export$c8d8406b6cd2243e(configExtension) {
    for(var _len = arguments.length, createConfig = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)createConfig[_key - 1] = arguments[_key];
    return typeof configExtension === "function" ? (0, $8odOT.createTailwindMerge).apply(void 0, [
        (0, $8YM4g.getDefaultConfig),
        configExtension
    ].concat(createConfig)) : (0, $8odOT.createTailwindMerge).apply(void 0, [
        function() {
            return (0, $80CZy.mergeConfigs)((0, $8YM4g.getDefaultConfig)(), configExtension);
        }
    ].concat(createConfig));
}

});
parcelRegister("8odOT", function(module, exports) {

$parcel$export(module.exports, "createTailwindMerge", function () { return $977505d5900d4b4d$export$ea2d4fba4d1bd27f; });

var $acNaH = parcelRequire("acNaH");

var $dOKVh = parcelRequire("dOKVh");

var $hTa5E = parcelRequire("hTa5E");
function $977505d5900d4b4d$export$ea2d4fba4d1bd27f() {
    for(var _len = arguments.length, createConfig = new Array(_len), _key = 0; _key < _len; _key++)createConfig[_key] = arguments[_key];
    var configUtils;
    var cacheGet;
    var cacheSet;
    var functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        var firstCreateConfig = createConfig[0], restCreateConfig = createConfig.slice(1);
        var config = restCreateConfig.reduce(function(previousConfig, createConfigCurrent) {
            return createConfigCurrent(previousConfig);
        }, firstCreateConfig());
        configUtils = (0, $acNaH.createConfigUtils)(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        var cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        var result = (0, $dOKVh.mergeClassList)(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall((0, $hTa5E.twJoin).apply(null, arguments));
    };
}

});
parcelRegister("acNaH", function(module, exports) {

$parcel$export(module.exports, "createConfigUtils", function () { return $c5fbd87b6c24f0b3$export$56ab4ba5b0b25eb0; });

var $cb00w = parcelRequire("cb00w");

var $1IE9r = parcelRequire("1IE9r");

var $7cQWw = parcelRequire("7cQWw");
function $c5fbd87b6c24f0b3$export$56ab4ba5b0b25eb0(config) {
    return {
        cache: (0, $1IE9r.createLruCache)(config.cacheSize),
        splitModifiers: (0, $7cQWw.createSplitModifiers)(config),
        ...(0, $cb00w.createClassUtils)(config)
    };
}

});
parcelRegister("cb00w", function(module, exports) {

$parcel$export(module.exports, "createClassUtils", function () { return $550799e1245f55b5$export$e3a687438e51f555; });
var $550799e1245f55b5$var$CLASS_PART_SEPARATOR = "-";
function $550799e1245f55b5$export$e3a687438e51f555(config) {
    var classMap = $550799e1245f55b5$export$936eaf1f027937d7(config);
    var conflictingClassGroups = config.conflictingClassGroups, _config$conflictingCl = config.conflictingClassGroupModifiers, conflictingClassGroupModifiers = _config$conflictingCl === void 0 ? {} : _config$conflictingCl;
    function getClassGroupId(className) {
        var classParts = className.split($550799e1245f55b5$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
        return $550799e1245f55b5$var$getGroupRecursive(classParts, classMap) || $550799e1245f55b5$var$getGroupIdForArbitraryProperty(className);
    }
    function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
        var conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [].concat(conflicts, conflictingClassGroupModifiers[classGroupId]);
        return conflicts;
    }
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
}
function $550799e1245f55b5$var$getGroupRecursive(classParts, classPartObject) {
    if (classParts.length === 0) return classPartObject.classGroupId;
    var currentClassPart = classParts[0];
    var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    var classGroupFromNextClassPart = nextClassPartObject ? $550799e1245f55b5$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    var classRest = classParts.join($550799e1245f55b5$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(function(_ref) {
        var validator = _ref.validator;
        return validator(classRest);
    })?.classGroupId;
}
var $550799e1245f55b5$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
function $550799e1245f55b5$var$getGroupIdForArbitraryProperty(className) {
    if ($550799e1245f55b5$var$arbitraryPropertyRegex.test(className)) {
        var arbitraryPropertyClassName = $550799e1245f55b5$var$arbitraryPropertyRegex.exec(className)[1];
        var property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return "arbitrary.." + property;
    }
}
/**
 * Exported for testing only
 */ function $550799e1245f55b5$export$936eaf1f027937d7(config) {
    var theme = config.theme, prefix = config.prefix;
    var classMap = {
        nextPart: new Map(),
        validators: []
    };
    var prefixedClassGroupEntries = $550799e1245f55b5$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(function(_ref2) {
        var classGroupId = _ref2[0], classGroup = _ref2[1];
        $550799e1245f55b5$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
}
function $550799e1245f55b5$var$processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
    classGroup.forEach(function(classDefinition) {
        if (typeof classDefinition === "string") {
            var classPartObjectToEdit = classDefinition === "" ? classPartObject : $550799e1245f55b5$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === "function") {
            if ($550799e1245f55b5$var$isThemeGetter(classDefinition)) {
                $550799e1245f55b5$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(function(_ref3) {
            var key = _ref3[0], classGroup = _ref3[1];
            $550799e1245f55b5$var$processClassesRecursively(classGroup, $550799e1245f55b5$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
}
function $550799e1245f55b5$var$getPart(classPartObject, path) {
    var currentClassPartObject = classPartObject;
    path.split($550799e1245f55b5$var$CLASS_PART_SEPARATOR).forEach(function(pathPart) {
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
}
function $550799e1245f55b5$var$isThemeGetter(func) {
    return func.isThemeGetter;
}
function $550799e1245f55b5$var$getPrefixedClassGroupEntries(classGroupEntries, prefix) {
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(function(_ref4) {
        var classGroupId = _ref4[0], classGroup = _ref4[1];
        var prefixedClassGroup = classGroup.map(function(classDefinition) {
            if (typeof classDefinition === "string") return prefix + classDefinition;
            if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(function(_ref5) {
                var key = _ref5[0], value = _ref5[1];
                return [
                    prefix + key,
                    value
                ];
            }));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
}

});

parcelRegister("1IE9r", function(module, exports) {

$parcel$export(module.exports, "createLruCache", function () { return $83f7e2d4329bc780$export$cf6a7cbaa5f64437; });
// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function $83f7e2d4329bc780$export$cf6a7cbaa5f64437(maxCacheSize) {
    if (maxCacheSize < 1) return {
        get: function get() {
            return undefined;
        },
        set: function set() {}
    };
    var cacheSize = 0;
    var cache = new Map();
    var previousCache = new Map();
    function update(key, value) {
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    }
    return {
        get: function get(key) {
            var value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set: function set(key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
}

});

parcelRegister("7cQWw", function(module, exports) {

$parcel$export(module.exports, "IMPORTANT_MODIFIER", function () { return $0c28dbc97d0ab2b4$export$61823b46426d06fa; });
$parcel$export(module.exports, "createSplitModifiers", function () { return $0c28dbc97d0ab2b4$export$b5f40ac45a8dd583; });
$parcel$export(module.exports, "sortModifiers", function () { return $0c28dbc97d0ab2b4$export$4f247a60f8a83b3a; });
var $0c28dbc97d0ab2b4$export$61823b46426d06fa = "!";
function $0c28dbc97d0ab2b4$export$b5f40ac45a8dd583(config) {
    var separator = config.separator || ":";
    var isSeparatorSingleCharacter = separator.length === 1;
    var firstSeparatorCharacter = separator[0];
    var separatorLength = separator.length;
    // splitModifiers inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    return function splitModifiers(className) {
        var modifiers = [];
        var bracketDepth = 0;
        var modifierStart = 0;
        var postfixModifierPosition;
        for(var index = 0; index < className.length; index++){
            var currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
        }
        var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        var hasImportantModifier = baseClassNameWithImportantModifier.startsWith($0c28dbc97d0ab2b4$export$61823b46426d06fa);
        var baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        var maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ function $0c28dbc97d0ab2b4$export$4f247a60f8a83b3a(modifiers) {
    if (modifiers.length <= 1) return modifiers;
    var sortedModifiers = [];
    var unsortedModifiers = [];
    modifiers.forEach(function(modifier) {
        var isArbitraryVariant = modifier[0] === "[";
        if (isArbitraryVariant) {
            sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort().concat([
                modifier
            ]));
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort());
    return sortedModifiers;
}

});


parcelRegister("dOKVh", function(module, exports) {

$parcel$export(module.exports, "mergeClassList", function () { return $0a16bc22a487f600$export$b41084d9255a3248; });

var $7cQWw = parcelRequire("7cQWw");
var $0a16bc22a487f600$var$SPLIT_CLASSES_REGEX = /\s+/;
function $0a16bc22a487f600$export$b41084d9255a3248(classList, configUtils) {
    var splitModifiers = configUtils.splitModifiers, getClassGroupId = configUtils.getClassGroupId, getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ var classGroupsInConflict = new Set();
    return classList.trim().split($0a16bc22a487f600$var$SPLIT_CLASSES_REGEX).map(function(originalClassName) {
        var _splitModifiers = splitModifiers(originalClassName), modifiers = _splitModifiers.modifiers, hasImportantModifier = _splitModifiers.hasImportantModifier, baseClassName = _splitModifiers.baseClassName, maybePostfixModifierPosition = _splitModifiers.maybePostfixModifierPosition;
        var classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        var hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        if (!classGroupId) {
            if (!maybePostfixModifierPosition) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            hasPostfixModifier = false;
        }
        var variantModifier = (0, $7cQWw.sortModifiers)(modifiers).join(":");
        var modifierId = hasImportantModifier ? variantModifier + (0, $7cQWw.IMPORTANT_MODIFIER) : variantModifier;
        return {
            isTailwindClass: true,
            modifierId: modifierId,
            classGroupId: classGroupId,
            originalClassName: originalClassName,
            hasPostfixModifier: hasPostfixModifier
        };
    }).reverse()// Last class in conflict wins, so we need to filter conflicting classes in reverse order.
    .filter(function(parsed) {
        if (!parsed.isTailwindClass) return true;
        var modifierId = parsed.modifierId, classGroupId = parsed.classGroupId, hasPostfixModifier = parsed.hasPostfixModifier;
        var classId = modifierId + classGroupId;
        if (classGroupsInConflict.has(classId)) return false;
        classGroupsInConflict.add(classId);
        getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach(function(group) {
            return classGroupsInConflict.add(modifierId + group);
        });
        return true;
    }).reverse().map(function(parsed) {
        return parsed.originalClassName;
    }).join(" ");
}

});

parcelRegister("hTa5E", function(module, exports) {

$parcel$export(module.exports, "twJoin", function () { return $b33e0cf1caca0afa$export$a8bbfb445e1f163f; });
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $b33e0cf1caca0afa$export$a8bbfb445e1f163f() {
    var index = 0;
    var argument;
    var resolvedValue;
    var string = "";
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $b33e0cf1caca0afa$var$toValue(argument)) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $b33e0cf1caca0afa$var$toValue(mix) {
    if (typeof mix === "string") return mix;
    var resolvedValue;
    var string = "";
    for(var k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $b33e0cf1caca0afa$var$toValue(mix[k])) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}

});


parcelRegister("8YM4g", function(module, exports) {

$parcel$export(module.exports, "getDefaultConfig", function () { return $39e8cc7bc85c774b$export$ed30944e0fe6ae5c; });

var $5L59K = parcelRequire("5L59K");

var $39TAN = parcelRequire("39TAN");
function $39e8cc7bc85c774b$export$ed30944e0fe6ae5c() {
    var colors = (0, $5L59K.fromTheme)("colors");
    var spacing = (0, $5L59K.fromTheme)("spacing");
    var blur = (0, $5L59K.fromTheme)("blur");
    var brightness = (0, $5L59K.fromTheme)("brightness");
    var borderColor = (0, $5L59K.fromTheme)("borderColor");
    var borderRadius = (0, $5L59K.fromTheme)("borderRadius");
    var borderSpacing = (0, $5L59K.fromTheme)("borderSpacing");
    var borderWidth = (0, $5L59K.fromTheme)("borderWidth");
    var contrast = (0, $5L59K.fromTheme)("contrast");
    var grayscale = (0, $5L59K.fromTheme)("grayscale");
    var hueRotate = (0, $5L59K.fromTheme)("hueRotate");
    var invert = (0, $5L59K.fromTheme)("invert");
    var gap = (0, $5L59K.fromTheme)("gap");
    var gradientColorStops = (0, $5L59K.fromTheme)("gradientColorStops");
    var gradientColorStopPositions = (0, $5L59K.fromTheme)("gradientColorStopPositions");
    var inset = (0, $5L59K.fromTheme)("inset");
    var margin = (0, $5L59K.fromTheme)("margin");
    var opacity = (0, $5L59K.fromTheme)("opacity");
    var padding = (0, $5L59K.fromTheme)("padding");
    var saturate = (0, $5L59K.fromTheme)("saturate");
    var scale = (0, $5L59K.fromTheme)("scale");
    var sepia = (0, $5L59K.fromTheme)("sepia");
    var skew = (0, $5L59K.fromTheme)("skew");
    var space = (0, $5L59K.fromTheme)("space");
    var translate = (0, $5L59K.fromTheme)("translate");
    var getOverscroll = function getOverscroll() {
        return [
            "auto",
            "contain",
            "none"
        ];
    };
    var getOverflow = function getOverflow() {
        return [
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    };
    var getSpacingWithAutoAndArbitrary = function getSpacingWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $39TAN.isArbitraryValue),
            spacing
        ];
    };
    var getSpacingWithArbitrary = function getSpacingWithArbitrary() {
        return [
            (0, $39TAN.isArbitraryValue),
            spacing
        ];
    };
    var getLengthWithEmpty = function getLengthWithEmpty() {
        return [
            "",
            (0, $39TAN.isLength)
        ];
    };
    var getNumberWithAutoAndArbitrary = function getNumberWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $39TAN.isNumber),
            (0, $39TAN.isArbitraryValue)
        ];
    };
    var getPositions = function getPositions() {
        return [
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ];
    };
    var getLineStyles = function getLineStyles() {
        return [
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ];
    };
    var getBlendModes = function getBlendModes() {
        return [
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity",
            "plus-lighter"
        ];
    };
    var getAlign = function getAlign() {
        return [
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ];
    };
    var getZeroAndEmpty = function getZeroAndEmpty() {
        return [
            "",
            "0",
            (0, $39TAN.isArbitraryValue)
        ];
    };
    var getBreaks = function getBreaks() {
        return [
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    };
    var getNumber = function getNumber() {
        return [
            (0, $39TAN.isNumber),
            (0, $39TAN.isArbitraryNumber)
        ];
    };
    var getNumberAndArbitrary = function getNumberAndArbitrary() {
        return [
            (0, $39TAN.isNumber),
            (0, $39TAN.isArbitraryValue)
        ];
    };
    return {
        cacheSize: 500,
        theme: {
            colors: [
                (0, $39TAN.isAny)
            ],
            spacing: [
                (0, $39TAN.isLength)
            ],
            blur: [
                "none",
                "",
                (0, $39TAN.isTshirtSize),
                (0, $39TAN.isArbitraryValue)
            ],
            brightness: getNumber(),
            borderColor: [
                colors
            ],
            borderRadius: [
                "none",
                "",
                "full",
                (0, $39TAN.isTshirtSize),
                (0, $39TAN.isArbitraryValue)
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmpty(),
            contrast: getNumber(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                (0, $39TAN.isPercent),
                (0, $39TAN.isArbitraryLength)
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumber(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumber(),
            scale: getNumber(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        (0, $39TAN.isTshirtSize)
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ "float": [
                {
                    "float": [
                        "right",
                        "left",
                        "none"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [].concat(getPositions(), [
                        (0, $39TAN.isArbitraryValue)
                    ])
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        (0, $39TAN.isInteger)
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        (0, $39TAN.isInteger)
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        (0, $39TAN.isAny)
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                (0, $39TAN.isInteger)
                            ]
                        },
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        (0, $39TAN.isAny)
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                (0, $39TAN.isInteger)
                            ]
                        },
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal"
                    ].concat(getAlign())
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal"
                    ].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        (0, $39TAN.isArbitraryValue),
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        "min",
                        "max",
                        "fit",
                        (0, $39TAN.isArbitraryValue),
                        (0, $39TAN.isLength)
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        "0",
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                (0, $39TAN.isTshirtSize)
                            ]
                        },
                        (0, $39TAN.isTshirtSize),
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        (0, $39TAN.isArbitraryValue),
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        "min",
                        "max",
                        "fit",
                        (0, $39TAN.isArbitraryValue),
                        (0, $39TAN.isLength)
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        (0, $39TAN.isArbitraryValue),
                        spacing,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        (0, $39TAN.isTshirtSize),
                        (0, $39TAN.isArbitraryLength)
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        (0, $39TAN.isArbitraryNumber)
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        (0, $39TAN.isAny)
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        (0, $39TAN.isNumber),
                        (0, $39TAN.isArbitraryNumber)
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        (0, $39TAN.isArbitraryValue),
                        (0, $39TAN.isLength)
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [].concat(getLineStyles(), [
                        "wavy"
                    ])
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        (0, $39TAN.isLength)
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        (0, $39TAN.isArbitraryValue),
                        (0, $39TAN.isLength)
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ "break": [
                {
                    "break": [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [].concat(getPositions(), [
                        (0, $39TAN.isArbitraryPosition)
                    ])
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        (0, $39TAN.isArbitrarySize)
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        (0, $39TAN.isArbitraryUrl)
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [].concat(getLineStyles(), [
                        "hidden"
                    ])
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        ""
                    ].concat(getLineStyles())
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        (0, $39TAN.isArbitraryValue),
                        (0, $39TAN.isLength)
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        (0, $39TAN.isLength)
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: getLengthWithEmpty()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        (0, $39TAN.isLength)
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        (0, $39TAN.isTshirtSize),
                        (0, $39TAN.isArbitraryShadow)
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        (0, $39TAN.isAny)
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": getBlendModes()
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        (0, $39TAN.isTshirtSize),
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        (0, $39TAN.isInteger),
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                "appearance-none"
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "pinch-zoom",
                        "manipulation",
                        {
                            pan: [
                                "x",
                                "left",
                                "right",
                                "y",
                                "up",
                                "down"
                            ]
                        }
                    ]
                }
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        (0, $39TAN.isArbitraryValue)
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        (0, $39TAN.isLength),
                        (0, $39TAN.isArbitraryNumber)
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
}

});
parcelRegister("5L59K", function(module, exports) {

$parcel$export(module.exports, "fromTheme", function () { return $3a8335784d5b9630$export$e176af7b8eefe933; });
function $3a8335784d5b9630$export$e176af7b8eefe933(key) {
    var themeGetter = function themeGetter(theme) {
        return theme[key] || [];
    };
    themeGetter.isThemeGetter = true;
    return themeGetter;
}

});

parcelRegister("39TAN", function(module, exports) {

$parcel$export(module.exports, "isLength", function () { return $6e5479f743d57894$export$38db3d147cb3433; });
$parcel$export(module.exports, "isNumber", function () { return $6e5479f743d57894$export$7e4aa119212bc614; });
$parcel$export(module.exports, "isArbitraryLength", function () { return $6e5479f743d57894$export$f5e3af6d4c0fbe38; });
$parcel$export(module.exports, "isArbitrarySize", function () { return $6e5479f743d57894$export$92dbd3a305a7cb8b; });
$parcel$export(module.exports, "isArbitraryPosition", function () { return $6e5479f743d57894$export$57d00f225f425549; });
$parcel$export(module.exports, "isArbitraryUrl", function () { return $6e5479f743d57894$export$478a5386e985802b; });
$parcel$export(module.exports, "isArbitraryNumber", function () { return $6e5479f743d57894$export$ea45ce4f1b2d6088; });
$parcel$export(module.exports, "isPercent", function () { return $6e5479f743d57894$export$e50269385c77c348; });
$parcel$export(module.exports, "isInteger", function () { return $6e5479f743d57894$export$a287f47fed4544b8; });
$parcel$export(module.exports, "isArbitraryValue", function () { return $6e5479f743d57894$export$5534a8576501817d; });
$parcel$export(module.exports, "isAny", function () { return $6e5479f743d57894$export$ebb65efc98a3b5f7; });
$parcel$export(module.exports, "isTshirtSize", function () { return $6e5479f743d57894$export$a40791c6b7db5bcc; });
$parcel$export(module.exports, "isArbitraryShadow", function () { return $6e5479f743d57894$export$d01106465b385604; });
var $6e5479f743d57894$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
var $6e5479f743d57894$var$fractionRegex = /^\d+\/\d+$/;
var $6e5479f743d57894$var$stringLengths = /*#__PURE__*/ new Set([
    "px",
    "full",
    "screen"
]);
var $6e5479f743d57894$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var $6e5479f743d57894$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
// Shadow always begins with x and y offset separated by underscore
var $6e5479f743d57894$var$shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function $6e5479f743d57894$export$38db3d147cb3433(value) {
    return $6e5479f743d57894$export$7e4aa119212bc614(value) || $6e5479f743d57894$var$stringLengths.has(value) || $6e5479f743d57894$var$fractionRegex.test(value) || $6e5479f743d57894$export$f5e3af6d4c0fbe38(value);
}
function $6e5479f743d57894$export$f5e3af6d4c0fbe38(value) {
    return $6e5479f743d57894$var$getIsArbitraryValue(value, "length", $6e5479f743d57894$var$isLengthOnly);
}
function $6e5479f743d57894$export$92dbd3a305a7cb8b(value) {
    return $6e5479f743d57894$var$getIsArbitraryValue(value, "size", $6e5479f743d57894$var$isNever);
}
function $6e5479f743d57894$export$57d00f225f425549(value) {
    return $6e5479f743d57894$var$getIsArbitraryValue(value, "position", $6e5479f743d57894$var$isNever);
}
function $6e5479f743d57894$export$478a5386e985802b(value) {
    return $6e5479f743d57894$var$getIsArbitraryValue(value, "url", $6e5479f743d57894$var$isUrl);
}
function $6e5479f743d57894$export$ea45ce4f1b2d6088(value) {
    return $6e5479f743d57894$var$getIsArbitraryValue(value, "number", $6e5479f743d57894$export$7e4aa119212bc614);
}
/**
 * @deprecated Will be removed in next major version. Use `isArbitraryNumber` instead.
 */ var $6e5479f743d57894$export$cd3ce15f42623f06 = $6e5479f743d57894$export$ea45ce4f1b2d6088;
function $6e5479f743d57894$export$7e4aa119212bc614(value) {
    return !Number.isNaN(Number(value));
}
function $6e5479f743d57894$export$e50269385c77c348(value) {
    return value.endsWith("%") && $6e5479f743d57894$export$7e4aa119212bc614(value.slice(0, -1));
}
function $6e5479f743d57894$export$a287f47fed4544b8(value) {
    return $6e5479f743d57894$var$isIntegerOnly(value) || $6e5479f743d57894$var$getIsArbitraryValue(value, "number", $6e5479f743d57894$var$isIntegerOnly);
}
function $6e5479f743d57894$export$5534a8576501817d(value) {
    return $6e5479f743d57894$var$arbitraryValueRegex.test(value);
}
function $6e5479f743d57894$export$ebb65efc98a3b5f7() {
    return true;
}
function $6e5479f743d57894$export$a40791c6b7db5bcc(value) {
    return $6e5479f743d57894$var$tshirtUnitRegex.test(value);
}
function $6e5479f743d57894$export$d01106465b385604(value) {
    return $6e5479f743d57894$var$getIsArbitraryValue(value, "", $6e5479f743d57894$var$isShadow);
}
function $6e5479f743d57894$var$getIsArbitraryValue(value, label, testValue) {
    var result = $6e5479f743d57894$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return result[1] === label;
        return testValue(result[2]);
    }
    return false;
}
function $6e5479f743d57894$var$isLengthOnly(value) {
    return $6e5479f743d57894$var$lengthUnitRegex.test(value);
}
function $6e5479f743d57894$var$isNever() {
    return false;
}
function $6e5479f743d57894$var$isUrl(value) {
    return value.startsWith("url(");
}
function $6e5479f743d57894$var$isIntegerOnly(value) {
    return Number.isInteger(Number(value));
}
function $6e5479f743d57894$var$isShadow(value) {
    return $6e5479f743d57894$var$shadowRegex.test(value);
}

});


parcelRegister("80CZy", function(module, exports) {

$parcel$export(module.exports, "mergeConfigs", function () { return $dc7e7a7c43b15fca$export$5d86b86a654a7039; });
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ function $dc7e7a7c43b15fca$export$5d86b86a654a7039(baseConfig, configExtension) {
    for(var key in configExtension)$dc7e7a7c43b15fca$var$mergePropertyRecursively(baseConfig, key, configExtension[key]);
    return baseConfig;
}
var $dc7e7a7c43b15fca$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $dc7e7a7c43b15fca$var$overrideTypes = /*#__PURE__*/ new Set([
    "string",
    "number",
    "boolean"
]);
function $dc7e7a7c43b15fca$var$mergePropertyRecursively(baseObject, mergeKey, mergeValue) {
    if (!$dc7e7a7c43b15fca$var$hasOwnProperty.call(baseObject, mergeKey) || $dc7e7a7c43b15fca$var$overrideTypes.has(typeof mergeValue) || mergeValue === null) {
        baseObject[mergeKey] = mergeValue;
        return;
    }
    if (Array.isArray(mergeValue) && Array.isArray(baseObject[mergeKey])) {
        baseObject[mergeKey] = baseObject[mergeKey].concat(mergeValue);
        return;
    }
    if (typeof mergeValue === "object" && typeof baseObject[mergeKey] === "object") {
        if (baseObject[mergeKey] === null) {
            baseObject[mergeKey] = mergeValue;
            return;
        }
        for(var nextKey in mergeValue)$dc7e7a7c43b15fca$var$mergePropertyRecursively(baseObject[mergeKey], nextKey, mergeValue[nextKey]);
    }
}

});


parcelRegister("f3Siq", function(module, exports) {

$parcel$export(module.exports, "twMerge", function () { return $df5a6d793fd4ba06$export$b4660bb6000dfbc9; });

var $8odOT = parcelRequire("8odOT");

var $8YM4g = parcelRequire("8YM4g");
var $df5a6d793fd4ba06$export$b4660bb6000dfbc9 = /*#__PURE__*/ (0, $8odOT.createTailwindMerge)((0, $8YM4g.getDefaultConfig));

});



parcelRegister("9dwEN", function(module, exports) {

$parcel$export(module.exports, "dataFocusVisibleClasses", function () { return $55a360f2253c696f$export$13376dc9c57a19ba; });
$parcel$export(module.exports, "groupDataFocusVisibleClasses", function () { return $55a360f2253c696f$export$23b17e6367ab693; });
$parcel$export(module.exports, "collapseAdjacentVariantBorders", function () { return $55a360f2253c696f$export$be7ffb88629cefac; });
// src/utils/classes.ts
var $55a360f2253c696f$export$6a08aa478781aaec = (prefix)=>({
        color: `hsl(var(--${prefix}-foreground))`,
        backgroundColor: `hsl(var(--${prefix}-background))`
    });
var $55a360f2253c696f$export$ca6a30fd41be6708 = [
    "focus-visible:z-10",
    "focus-visible:outline-2",
    "focus-visible:outline-focus",
    "focus-visible:outline-offset-2"
];
var $55a360f2253c696f$export$13376dc9c57a19ba = [
    "outline-none",
    "data-[focus-visible=true]:z-10",
    "data-[focus-visible=true]:outline-2",
    "data-[focus-visible=true]:outline-focus",
    "data-[focus-visible=true]:outline-offset-2"
];
var $55a360f2253c696f$export$23b17e6367ab693 = [
    "outline-none",
    "group-data-[focus-visible=true]:z-10",
    "group-data-[focus-visible=true]:ring-2",
    "group-data-[focus-visible=true]:ring-focus",
    "group-data-[focus-visible=true]:ring-offset-2",
    "group-data-[focus-visible=true]:ring-offset-background"
];
var $55a360f2253c696f$export$e0ed6e3275f8955 = [
    "outline-none",
    "ring-2",
    "ring-focus",
    "ring-offset-2",
    "ring-offset-background"
];
var $55a360f2253c696f$export$99bb92cbe55f4b50 = [
    "absolute",
    "top-1/2",
    "left-1/2",
    "-translate-x-1/2",
    "-translate-y-1/2"
];
var $55a360f2253c696f$export$88a9566cd73b4303 = [
    "absolute",
    "inset-0"
];
var $55a360f2253c696f$export$be7ffb88629cefac = {
    default: [
        "[&+.border-medium.border-default]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    primary: [
        "[&+.border-medium.border-primary]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    secondary: [
        "[&+.border-medium.border-secondary]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    success: [
        "[&+.border-medium.border-success]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    warning: [
        "[&+.border-medium.border-warning]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    danger: [
        "[&+.border-medium.border-danger]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ]
};

});

parcelRegister("luNG9", function(module, exports) {

$parcel$export(module.exports, "capitalize", function () { return $b9c206e6be1ff3b7$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "callAllHandlers", function () { return $b9c206e6be1ff3b7$export$5bdd3f730ec2c47e; });
$parcel$export(module.exports, "getUniqueID", function () { return $b9c206e6be1ff3b7$export$b8ba5815f1bdad68; });
$parcel$export(module.exports, "removeEvents", function () { return $b9c206e6be1ff3b7$export$da5f6eb3bb522cd; });
$parcel$export(module.exports, "objectToDeps", function () { return $b9c206e6be1ff3b7$export$36eebbb473f6d2fe; });
// src/functions.ts
var $b9c206e6be1ff3b7$export$9a00dee1beb8f576 = (text)=>{
    return text.charAt(0).toUpperCase() + text.slice(1);
};
function $b9c206e6be1ff3b7$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $b9c206e6be1ff3b7$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}
function $b9c206e6be1ff3b7$export$bb64030b028b5009(key, defaultValue, ...objs) {
    let result = defaultValue;
    for (const obj of objs)if (obj && key in obj && !!obj[key]) result = obj[key];
    return result;
}
function $b9c206e6be1ff3b7$export$b8ba5815f1bdad68(prefix) {
    return `${prefix}-${Math.floor(Math.random() * 1e6)}`;
}
function $b9c206e6be1ff3b7$export$da5f6eb3bb522cd(input) {
    for(const key in input)if (key.startsWith("on")) delete input[key];
    return input;
}
function $b9c206e6be1ff3b7$export$36eebbb473f6d2fe(obj) {
    if (!obj || typeof obj !== "object") return "";
    try {
        return JSON.stringify(obj);
    } catch (e) {
        return "";
    }
}

});

parcelRegister("6pmNA", function(module, exports) {

$parcel$export(module.exports, "clsx", function () { return $73b1bf3b3faa8211$export$4f5d2d50c9deca37; });
// src/clsx.ts
function $73b1bf3b3faa8211$var$toVal(mix) {
    var k, y, str = "";
    if (typeof mix === "string" || typeof mix === "number") str += mix;
    else if (typeof mix === "object") {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $73b1bf3b3faa8211$var$toVal(mix[k])) {
                    str && (str += " ");
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += " ");
                str += k;
            }
        }
    }
    return str;
}
function $73b1bf3b3faa8211$export$4f5d2d50c9deca37(...args) {
    var i = 0, tmp, x, str = "";
    while(i < args.length){
        if (tmp = args[i++]) {
            if (x = $73b1bf3b3faa8211$var$toVal(tmp)) {
                str && (str += " ");
                str += x;
            }
        }
    }
    return str;
}

});

parcelRegister("jj4Oc", function(module, exports) {

$parcel$export(module.exports, "isEmpty", function () { return $3e28c5c197b619c4$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "isFunction", function () { return $3e28c5c197b619c4$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "dataAttr", function () { return $3e28c5c197b619c4$export$5cc3b7b83e34ade7; });
// src/assertion.ts
var $3e28c5c197b619c4$export$a866f231438cc228 = false;
var $3e28c5c197b619c4$export$61cb32cff9a99948 = false;
function $3e28c5c197b619c4$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $3e28c5c197b619c4$export$4c0262a4f954db45(value) {
    return $3e28c5c197b619c4$export$43bee75e5e14138e(value) && value.length === 0;
}
function $3e28c5c197b619c4$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !$3e28c5c197b619c4$export$43bee75e5e14138e(value);
}
function $3e28c5c197b619c4$export$83b788b1a3698c03(value) {
    return $3e28c5c197b619c4$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $3e28c5c197b619c4$export$dd1bc94b04021eeb(value) {
    if ($3e28c5c197b619c4$export$43bee75e5e14138e(value)) return $3e28c5c197b619c4$export$4c0262a4f954db45(value);
    if ($3e28c5c197b619c4$export$a6cdc56e425d0d0a(value)) return $3e28c5c197b619c4$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
function $3e28c5c197b619c4$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
var $3e28c5c197b619c4$export$5cc3b7b83e34ade7 = (condition)=>condition ? "true" : void 0;
var $3e28c5c197b619c4$export$e90fb89750dba83f = (value)=>value != null && parseInt(value.toString(), 10) > 0;

});

parcelRegister("LA3Ym", function(module, exports) {

$parcel$export(module.exports, "filterDOMProps", function () { return $ea2695be68372966$export$457c3d6518dd4c6f; });

var $65VXH = parcelRequire("65VXH");
// src/filter-dom-props.ts
var $ea2695be68372966$var$propRe = /^(data-.*)$/;
var $ea2695be68372966$var$ariaRe = /^(aria-.*)$/;
var $ea2695be68372966$var$funcRe = /^(on[A-Z].*)$/;
function $ea2695be68372966$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable = true, enabled: enabled = true, propNames: propNames, omitPropNames: omitPropNames, omitEventNames: omitEventNames, omitDataProps: omitDataProps, omitEventProps: omitEventProps } = opts;
    let filteredProps = {};
    if (!enabled) return props;
    for(const prop in props){
        if (omitPropNames == null ? void 0 : omitPropNames.has(prop)) continue;
        if ((omitEventNames == null ? void 0 : omitEventNames.has(prop)) && $ea2695be68372966$var$funcRe.test(prop)) continue;
        if ($ea2695be68372966$var$funcRe.test(prop) && !(0, $65VXH.DOMEventNames).has(prop)) continue;
        if (omitDataProps && $ea2695be68372966$var$propRe.test(prop)) continue;
        if (omitEventProps && $ea2695be68372966$var$funcRe.test(prop)) continue;
        if (Object.prototype.hasOwnProperty.call(props, prop) && ((0, $65VXH.DOMPropNames).has(prop) || labelable && $ea2695be68372966$var$ariaRe.test(prop) || (propNames == null ? void 0 : propNames.has(prop)) || $ea2695be68372966$var$propRe.test(prop)) || $ea2695be68372966$var$funcRe.test(prop)) filteredProps[prop] = props[prop];
    }
    return filteredProps;
}

});
parcelRegister("65VXH", function(module, exports) {

$parcel$export(module.exports, "DOMPropNames", function () { return $f7427a8d3e3776e1$export$5f28e08e1b07d392; });
$parcel$export(module.exports, "DOMEventNames", function () { return $f7427a8d3e3776e1$export$8519a64fe4099896; });
// src/dom-props.ts
var $f7427a8d3e3776e1$export$5f28e08e1b07d392 = /* @__PURE__ */ new Set([
    "id",
    "type",
    "style",
    "title",
    "role",
    "tabIndex",
    "htmlFor",
    "width",
    "height",
    "abbr",
    "accept",
    "acceptCharset",
    "accessKey",
    "action",
    "allowFullScreen",
    "allowTransparency",
    "alt",
    "async",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "challenge",
    "charset",
    "checked",
    "cite",
    "class",
    "className",
    "cols",
    "colSpan",
    "command",
    "content",
    "contentEditable",
    "contextMenu",
    "controls",
    "coords",
    "crossOrigin",
    "data",
    "dateTime",
    "default",
    "defer",
    "dir",
    "disabled",
    "download",
    "draggable",
    "dropzone",
    "encType",
    "enterKeyHint",
    "for",
    "form",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "headers",
    "hidden",
    "high",
    "href",
    "hrefLang",
    "httpEquiv",
    "icon",
    "inputMode",
    "isMap",
    "itemId",
    "itemProp",
    "itemRef",
    "itemScope",
    "itemType",
    "kind",
    "label",
    "lang",
    "list",
    "loop",
    "manifest",
    "max",
    "maxLength",
    "media",
    "mediaGroup",
    "method",
    "min",
    "minLength",
    "multiple",
    "muted",
    "name",
    "noValidate",
    "open",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "poster",
    "preload",
    "radioGroup",
    "referrerPolicy",
    "readOnly",
    "rel",
    "required",
    "rows",
    "rowSpan",
    "sandbox",
    "scope",
    "scoped",
    "scrolling",
    "seamless",
    "selected",
    "shape",
    "size",
    "sizes",
    "slot",
    "sortable",
    "span",
    "spellCheck",
    "src",
    "srcDoc",
    "srcSet",
    "start",
    "step",
    "target",
    "translate",
    "typeMustMatch",
    "useMap",
    "value",
    "wmode",
    "wrap"
]);
var $f7427a8d3e3776e1$export$8519a64fe4099896 = /* @__PURE__ */ new Set([
    "onCopy",
    "onCut",
    "onPaste",
    "onLoad",
    "onError",
    "onWheel",
    "onScroll",
    "onCompositionEnd",
    "onCompositionStart",
    "onCompositionUpdate",
    "onKeyDown",
    "onKeyPress",
    "onKeyUp",
    "onFocus",
    "onBlur",
    "onChange",
    "onInput",
    "onSubmit",
    "onClick",
    "onContextMenu",
    "onDoubleClick",
    "onDrag",
    "onDragEnd",
    "onDragEnter",
    "onDragExit",
    "onDragLeave",
    "onDragOver",
    "onDragStart",
    "onDrop",
    "onMouseDown",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseOut",
    "onMouseOver",
    "onMouseUp",
    "onPointerDown",
    "onPointerEnter",
    "onPointerLeave",
    "onPointerUp",
    "onSelect",
    "onTouchCancel",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "onAnimationStart",
    "onAnimationEnd",
    "onAnimationIteration",
    "onTransitionEnd"
]);

});


parcelRegister("lfs90", function(module, exports) {

$parcel$export(module.exports, "createDOMRef", function () { return $ed058f1357c037ec$export$a5795cc979dfae80; });
$parcel$export(module.exports, "useDOMRef", function () { return $ed058f1357c037ec$export$c2c55ef9111cafd8; });

var $exYeM = parcelRequire("exYeM");
"use client";
function $ed058f1357c037ec$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var $ed058f1357c037ec$export$4e09c449d6c407f7 = $ed058f1357c037ec$export$71594e8a50f746f4();
function $ed058f1357c037ec$export$6ffcd379b2770ab0(navigator) {
    const { userAgent: ua, vendor: vendor } = navigator;
    const android = /(android)/i.test(ua);
    switch(true){
        case /CriOS/.test(ua):
            return "Chrome for iOS";
        case /Edg\//.test(ua):
            return "Edge";
        case android && /Silk\//.test(ua):
            return "Silk";
        case /Chrome/.test(ua) && /Google Inc/.test(vendor):
            return "Chrome";
        case /Firefox\/\d+\.\d+$/.test(ua):
            return "Firefox";
        case android:
            return "AOSP";
        case /MSIE|Trident/.test(ua):
            return "IE";
        case /Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua):
            return "Safari";
        case /AppleWebKit/.test(ua):
            return "WebKit";
        default:
            return null;
    }
}
function $ed058f1357c037ec$export$54dee9623b75428b(navigator) {
    const { userAgent: ua, platform: platform } = navigator;
    switch(true){
        case /Android/.test(ua):
            return "Android";
        case /iPhone|iPad|iPod/.test(platform):
            return "iOS";
        case /Win/.test(platform):
            return "Windows";
        case /Mac/.test(platform):
            return "Mac";
        case /CrOS/.test(ua):
            return "Chrome OS";
        case /Firefox/.test(ua):
            return "Firefox OS";
        default:
            return null;
    }
}
function $ed058f1357c037ec$export$568a7d21694b4b32(navigator) {
    const { userAgent: ua } = navigator;
    if (/(tablet)|(iPad)|(Nexus 9)/i.test(ua)) return "tablet";
    if (/(mobi)/i.test(ua)) return "phone";
    return "desktop";
}
function $ed058f1357c037ec$export$3070bd282ec37ea8(os) {
    if (!$ed058f1357c037ec$export$4e09c449d6c407f7) return false;
    return $ed058f1357c037ec$export$54dee9623b75428b(window.navigator) === os;
}
function $ed058f1357c037ec$export$2d31490a0c05f094(browser) {
    if (!$ed058f1357c037ec$export$4e09c449d6c407f7) return false;
    return $ed058f1357c037ec$export$6ffcd379b2770ab0(window.navigator) === browser;
}
function $ed058f1357c037ec$export$8d04c8cf4d9e22d8() {
    if (!$ed058f1357c037ec$export$4e09c449d6c407f7) return false;
    return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
}
function $ed058f1357c037ec$export$a5795cc979dfae80(ref) {
    return {
        UNSAFE_getDOMNode () {
            return ref.current;
        }
    };
}
function $ed058f1357c037ec$export$79d69eee6ae4b329(domRef, focusableRef = domRef) {
    return {
        ...$ed058f1357c037ec$export$a5795cc979dfae80(domRef),
        focus () {
            if (focusableRef.current) focusableRef.current.focus();
        }
    };
}
function $ed058f1357c037ec$export$c2c55ef9111cafd8(ref) {
    const domRef = (0, $exYeM.useRef)(null);
    (0, $exYeM.useImperativeHandle)(ref, ()=>domRef.current);
    return domRef;
}
function $ed058f1357c037ec$export$96a734597687c040(ref, focusableRef) {
    const domRef = (0, $exYeM.useRef)(null);
    (0, $exYeM.useImperativeHandle)(ref, ()=>$ed058f1357c037ec$export$79d69eee6ae4b329(domRef, focusableRef));
    return domRef;
}
function $ed058f1357c037ec$export$4debdb1a3f0fa79e(context, ref) {
    (0, $exYeM.useLayoutEffect)(()=>{
        if (context && context.ref && ref && ref.current) {
            context.ref.current = ref.current;
            return ()=>{
                var _a;
                if ((_a = context.ref) == null ? void 0 : _a.current) context.ref.current = null;
            };
        }
    }, [
        context,
        ref
    ]);
}
function $ed058f1357c037ec$export$33e83fe63cd475d5(rect1, rect2) {
    return rect1 && rect2 && rect1.x < rect2.x + rect2.width && rect1.x + rect1.width > rect2.x && rect1.y < rect2.y + rect2.height && rect1.y + rect1.height > rect2.y;
}

});

parcelRegister("9cffb", function(module, exports) {

$parcel$export(module.exports, "filterDOMProps", function () { return $6b210f2faf0c4553$export$457c3d6518dd4c6f; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6b210f2faf0c4553$var$$65484d02dcb7eb3e$var$DOMPropNames = new Set([
    "id"
]);
const $6b210f2faf0c4553$var$$65484d02dcb7eb3e$var$labelablePropNames = new Set([
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-details"
]);
// See LinkDOMProps in dom.d.ts.
const $6b210f2faf0c4553$var$$65484d02dcb7eb3e$var$linkPropNames = new Set([
    "href",
    "hrefLang",
    "target",
    "rel",
    "download",
    "ping",
    "referrerPolicy"
]);
const $6b210f2faf0c4553$var$$65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $6b210f2faf0c4553$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable, isLink: isLink, propNames: propNames } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($6b210f2faf0c4553$var$$65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $6b210f2faf0c4553$var$$65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $6b210f2faf0c4553$var$$65484d02dcb7eb3e$var$linkPropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $6b210f2faf0c4553$var$$65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}

});

parcelRegister("29jGr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $190bb0c0b1d52a41$export$5a67b255b80ee4f2; });

var $dJpnk = parcelRequire("dJpnk");

var $gqIhi = parcelRequire("gqIhi");
function $190bb0c0b1d52a41$export$5a67b255b80ee4f2(receiver, privateMap) {
    var descriptor = (0, $gqIhi._class_extract_field_descriptor)(receiver, privateMap, "get");
    return (0, $dJpnk._class_apply_descriptor_get)(receiver, descriptor);
}

});
parcelRegister("dJpnk", function(module, exports) {

$parcel$export(module.exports, "_class_apply_descriptor_get", function () { return $9ff32953017c5856$export$184ff5d81c0e5775; });
function $9ff32953017c5856$export$184ff5d81c0e5775(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

});

parcelRegister("gqIhi", function(module, exports) {

$parcel$export(module.exports, "_class_extract_field_descriptor", function () { return $bf616bc1ae020d65$export$20c20a422940e173; });
function $bf616bc1ae020d65$export$20c20a422940e173(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

});


parcelRegister("6DVYY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4d635caf5261a471$export$e235798705076415; });

var $5qWMx = parcelRequire("5qWMx");
function $4d635caf5261a471$export$e235798705076415(obj, privateMap, value) {
    (0, $5qWMx._check_private_redeclaration)(obj, privateMap);
    privateMap.set(obj, value);
}

});
parcelRegister("5qWMx", function(module, exports) {

$parcel$export(module.exports, "_check_private_redeclaration", function () { return $3f4cfa4c4c8b2a05$export$6b10452b5ac97eba; });
function $3f4cfa4c4c8b2a05$export$6b10452b5ac97eba(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

});


parcelRegister("iAON1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d892fc8904c1d825$export$268446c9779b3a21; });

var $eYWzb = parcelRequire("eYWzb");

var $gqIhi = parcelRequire("gqIhi");
function $d892fc8904c1d825$export$268446c9779b3a21(receiver, privateMap, value) {
    var descriptor = (0, $gqIhi._class_extract_field_descriptor)(receiver, privateMap, "set");
    (0, $eYWzb._class_apply_descriptor_set)(receiver, descriptor, value);
    return value;
}

});
parcelRegister("eYWzb", function(module, exports) {

$parcel$export(module.exports, "_class_apply_descriptor_set", function () { return $ae841959f9ea44c7$export$b7b24cdba6bcb11c; });
function $ae841959f9ea44c7$export$b7b24cdba6bcb11c(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

});


parcelRegister("h6krv", function(module, exports) {

$parcel$export(module.exports, "shouldClientNavigate", function () { return $c732dab48176210c$export$efa8c9099e530235; });
$parcel$export(module.exports, "openLink", function () { return $c732dab48176210c$export$95185d699e05d4d7; });
$parcel$export(module.exports, "useRouter", function () { return $c732dab48176210c$export$9a302a45f65d0572; });
$parcel$export(module.exports, "useLinkProps", function () { return $c732dab48176210c$export$7e924b3091a3bd18; });

var $6Qamj = parcelRequire("6Qamj");

var $gbqqi = parcelRequire("gbqqi");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c732dab48176210c$var$$ea8dcbcb9ea1b556$var$RouterContext = (0, $exYeM.createContext)({
    isNative: true,
    open: $c732dab48176210c$var$$ea8dcbcb9ea1b556$var$openSyntheticLink,
    useHref: (href)=>href
});
function $c732dab48176210c$export$323e4fc2fa4753fb(props) {
    let { children: children, navigate: navigate, useHref: useHref } = props;
    let ctx = (0, $exYeM.useMemo)(()=>({
            isNative: false,
            open: (target, modifiers, href, routerOptions)=>{
                $c732dab48176210c$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>{
                    if ($c732dab48176210c$export$efa8c9099e530235(link, modifiers)) navigate(href, routerOptions);
                    else $c732dab48176210c$export$95185d699e05d4d7(link, modifiers);
                });
            },
            useHref: useHref || ((href)=>href)
        }), [
        navigate,
        useHref
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($c732dab48176210c$var$$ea8dcbcb9ea1b556$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $c732dab48176210c$export$9a302a45f65d0572() {
    return (0, $exYeM.useContext)($c732dab48176210c$var$$ea8dcbcb9ea1b556$var$RouterContext);
}
function $c732dab48176210c$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    let target = link.getAttribute("target");
    return (!target || target === "_self") && link.origin === location.origin && !link.hasAttribute("download") && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $c732dab48176210c$export$95185d699e05d4d7(target, modifiers, setOpening = true) {
    var _window_event_type, _window_event;
    let { metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey, shiftKey: shiftKey } = modifiers;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ((0, $gbqqi.isFirefox)() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith("key")) && target.target === "_blank") {
        if ((0, $gbqqi.isMac)()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    let event = (0, $gbqqi.isWebKit)() && (0, $gbqqi.isMac)() && !(0, $gbqqi.isIPad)() && true ? new KeyboardEvent("keydown", {
        keyIdentifier: "Enter",
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent("click", {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        bubbles: true,
        cancelable: true
    });
    $c732dab48176210c$export$95185d699e05d4d7.isOpening = setOpening;
    (0, $6Qamj.focusWithoutScrolling)(target);
    target.dispatchEvent(event);
    $c732dab48176210c$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$c732dab48176210c$export$95185d699e05d4d7.isOpening = false;
function $c732dab48176210c$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute("data-href")) {
        let link = document.createElement("a");
        link.href = target.getAttribute("data-href");
        if (target.hasAttribute("data-target")) link.target = target.getAttribute("data-target");
        if (target.hasAttribute("data-rel")) link.rel = target.getAttribute("data-rel");
        if (target.hasAttribute("data-download")) link.download = target.getAttribute("data-download");
        if (target.hasAttribute("data-ping")) link.ping = target.getAttribute("data-ping");
        if (target.hasAttribute("data-referrer-policy")) link.referrerPolicy = target.getAttribute("data-referrer-policy");
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $c732dab48176210c$var$$ea8dcbcb9ea1b556$var$openSyntheticLink(target, modifiers) {
    $c732dab48176210c$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>$c732dab48176210c$export$95185d699e05d4d7(link, modifiers));
}
function $c732dab48176210c$export$51437d503373d223(props) {
    return {
        "data-href": props.href,
        "data-target": props.target,
        "data-rel": props.rel,
        "data-download": props.download,
        "data-ping": props.ping,
        "data-referrer-policy": props.referrerPolicy
    };
}
function $c732dab48176210c$export$7e924b3091a3bd18(props) {
    let router = $c732dab48176210c$export$9a302a45f65d0572();
    return {
        href: (props === null || props === void 0 ? void 0 : props.href) ? router.useHref(props === null || props === void 0 ? void 0 : props.href) : undefined,
        target: props === null || props === void 0 ? void 0 : props.target,
        rel: props === null || props === void 0 ? void 0 : props.rel,
        download: props === null || props === void 0 ? void 0 : props.download,
        ping: props === null || props === void 0 ? void 0 : props.ping,
        referrerPolicy: props === null || props === void 0 ? void 0 : props.referrerPolicy
    };
}

});

parcelRegister("aGeuR", function(module, exports) {

$parcel$export(module.exports, "useGlobalListeners", function () { return $7c6912644cc0fedb$export$4eaf04e54aa8eed6; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7c6912644cc0fedb$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $exYeM.useRef)(new Map());
    let addGlobalListener = (0, $exYeM.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    let removeGlobalListener = (0, $exYeM.useCallback)((eventTarget, type, listener, options)=>{
        var _globalListeners_current_get;
        let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $exYeM.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, $exYeM.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}

});

parcelRegister("b6W9a", function(module, exports) {

$parcel$export(module.exports, "usePress", function () { return $816d5c02a7858c70$export$45712eceda6fad21; });
$parcel$export(module.exports, "setInteractionModality", function () { return $816d5c02a7858c70$export$8397ddfc504fdb9a; });
$parcel$export(module.exports, "useInteractionModality", function () { return $816d5c02a7858c70$export$98e20ec92f614cfe; });
$parcel$export(module.exports, "useFocusWithin", function () { return $816d5c02a7858c70$export$420e68273165f4ec; });
$parcel$export(module.exports, "useHover", function () { return $816d5c02a7858c70$export$ae780daf29e6d456; });

var $kdWpA = parcelRequire("kdWpA");
var $6Qamj = parcelRequire("6Qamj");
var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");
var $8vAG4 = parcelRequire("8vAG4");
var $h6krv = parcelRequire("h6krv");
var $jgteb = parcelRequire("jgteb");
var $6qwZD = parcelRequire("6qwZD");
var $4sExG = parcelRequire("4sExG");
var $aVei0 = parcelRequire("aVei0");
var $aGeuR = parcelRequire("aGeuR");
var $71dP2 = parcelRequire("71dP2");
var $4g3pq = parcelRequire("4g3pq");
var $hbWr9 = parcelRequire("hbWr9");

var $exYeM = parcelRequire("exYeM");

var $29jGr = parcelRequire("29jGr");

var $6DVYY = parcelRequire("6DVYY");

var $iAON1 = parcelRequire("iAON1");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $816d5c02a7858c70$var$$14c0b72509d70225$var$state = "default";
let $816d5c02a7858c70$var$$14c0b72509d70225$var$savedUserSelect = "";
let $816d5c02a7858c70$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $816d5c02a7858c70$var$$14c0b72509d70225$export$16a4697467175487(target) {
    if ((0, $gbqqi.isIOS)()) {
        if ($816d5c02a7858c70$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $2ZDqh.getOwnerDocument)(target);
            $816d5c02a7858c70$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $816d5c02a7858c70$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $816d5c02a7858c70$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $816d5c02a7858c70$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
    if ((0, $gbqqi.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($816d5c02a7858c70$var$$14c0b72509d70225$var$state !== "disabled") return;
        $816d5c02a7858c70$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $jgteb.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($816d5c02a7858c70$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $2ZDqh.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $816d5c02a7858c70$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $816d5c02a7858c70$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $816d5c02a7858c70$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $816d5c02a7858c70$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $816d5c02a7858c70$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $816d5c02a7858c70$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $816d5c02a7858c70$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({
    register: ()=>{}
});
$816d5c02a7858c70$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";
function $816d5c02a7858c70$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $exYeM.useContext)($816d5c02a7858c70$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $8vAG4.mergeProps)(contextProps, props);
        register();
    }
    (0, $hbWr9.useSyncRef)(context, props.ref);
    return props;
}
var $816d5c02a7858c70$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $816d5c02a7858c70$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $iAON1._)(this, $816d5c02a7858c70$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $29jGr._)(this, $816d5c02a7858c70$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $6DVYY._)(this, $816d5c02a7858c70$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $iAON1._)(this, $816d5c02a7858c70$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $816d5c02a7858c70$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $816d5c02a7858c70$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $816d5c02a7858c70$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $exYeM.useState)(false);
    let ref = (0, $exYeM.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $aGeuR.useGlobalListeners)();
    let triggerPressStart = (0, $4sExG.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $816d5c02a7858c70$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $4sExG.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $816d5c02a7858c70$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $816d5c02a7858c70$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $4sExG.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $816d5c02a7858c70$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $4sExG.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($816d5c02a7858c70$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) $816d5c02a7858c70$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
        }
    });
    let cancelOnPointerExit = (0, $4sExG.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $exYeM.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($816d5c02a7858c70$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($816d5c02a7858c70$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($816d5c02a7858c70$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($816d5c02a7858c70$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "keyup", (0, $kdWpA.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $gbqqi.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $h6krv.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $87CgO.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $816d5c02a7858c70$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($816d5c02a7858c70$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($816d5c02a7858c70$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $816d5c02a7858c70$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$816d5c02a7858c70$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$816d5c02a7858c70$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $h6krv.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $87CgO.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($816d5c02a7858c70$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) $816d5c02a7858c70$var$$14c0b72509d70225$export$16a4697467175487(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($816d5c02a7858c70$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $816d5c02a7858c70$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $816d5c02a7858c70$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($816d5c02a7858c70$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($816d5c02a7858c70$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($816d5c02a7858c70$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($816d5c02a7858c70$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($816d5c02a7858c70$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) $816d5c02a7858c70$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($816d5c02a7858c70$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $87CgO.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $816d5c02a7858c70$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($816d5c02a7858c70$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($816d5c02a7858c70$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $816d5c02a7858c70$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) $816d5c02a7858c70$var$$14c0b72509d70225$export$16a4697467175487(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $2ZDqh.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $816d5c02a7858c70$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $816d5c02a7858c70$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $816d5c02a7858c70$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $816d5c02a7858c70$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) $816d5c02a7858c70$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $exYeM.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) $816d5c02a7858c70$var$$14c0b72509d70225$export$b0d6fa1ab32e3295((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $8vAG4.mergeProps)(domProps, pressProps)
    };
}
function $816d5c02a7858c70$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $816d5c02a7858c70$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $2ZDqh.getOwnerWindow)(element).HTMLInputElement && !$816d5c02a7858c70$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $2ZDqh.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $816d5c02a7858c70$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $816d5c02a7858c70$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $816d5c02a7858c70$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $816d5c02a7858c70$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $816d5c02a7858c70$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $816d5c02a7858c70$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $816d5c02a7858c70$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $816d5c02a7858c70$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $816d5c02a7858c70$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $816d5c02a7858c70$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $816d5c02a7858c70$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$816d5c02a7858c70$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($816d5c02a7858c70$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $816d5c02a7858c70$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $816d5c02a7858c70$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $816d5c02a7858c70$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}
const $816d5c02a7858c70$export$27c701ed9e449e99 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ children: children, ...props }, ref)=>{
    ref = (0, $4g3pq.useObjectRef)(ref);
    let { pressProps: pressProps } = $816d5c02a7858c70$export$45712eceda6fad21({
        ...props,
        ref: ref
    });
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Children.only(children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).cloneElement(child, {
        ref: ref,
        ...(0, $8vAG4.mergeProps)(child.props, pressProps)
    });
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $816d5c02a7858c70$export$3351871ee4b288b8 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ children: children, ...props }, ref)=>{
    let isRegistered = (0, $exYeM.useRef)(false);
    let prevContext = (0, $exYeM.useContext)($816d5c02a7858c70$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    ref = (0, $4g3pq.useObjectRef)(ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref));
    let context = (0, $8vAG4.mergeProps)(prevContext || {}, {
        ...props,
        ref: ref,
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    (0, $hbWr9.useSyncRef)(prevContext, ref);
    (0, $exYeM.useEffect)(()=>{
        if (!isRegistered.current) {
            console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
            isRegistered.current = true; // only warn once in strict mode.
        }
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($816d5c02a7858c70$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
        value: context
    }, children);
});
function $816d5c02a7858c70$export$cf75428e0b9ed1ea({ children: children }) {
    let context = (0, $exYeM.useMemo)(()=>({
            register: ()=>{}
        }), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($816d5c02a7858c70$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
        value: context
    }, children);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $816d5c02a7858c70$var$$8a9cb279dc87e130$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $816d5c02a7858c70$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $exYeM.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $71dP2.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $4sExG.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $exYeM.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $816d5c02a7858c70$var$$8a9cb279dc87e130$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}
function $816d5c02a7858c70$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $exYeM.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = $816d5c02a7858c70$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    const onFocus = (0, $exYeM.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (e.target === e.currentTarget && document.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $816d5c02a7858c70$var$$507fabe10e71c6fb$var$currentModality = null;
let $816d5c02a7858c70$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $816d5c02a7858c70$var$$507fabe10e71c6fb$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $816d5c02a7858c70$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $816d5c02a7858c70$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $816d5c02a7858c70$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $816d5c02a7858c70$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $816d5c02a7858c70$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $816d5c02a7858c70$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $gbqqi.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $816d5c02a7858c70$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($816d5c02a7858c70$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $816d5c02a7858c70$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $816d5c02a7858c70$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $816d5c02a7858c70$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $816d5c02a7858c70$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $816d5c02a7858c70$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $87CgO.isVirtualClick)(e)) {
        $816d5c02a7858c70$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $816d5c02a7858c70$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$816d5c02a7858c70$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$816d5c02a7858c70$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $816d5c02a7858c70$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $816d5c02a7858c70$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $816d5c02a7858c70$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $816d5c02a7858c70$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $816d5c02a7858c70$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $816d5c02a7858c70$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $816d5c02a7858c70$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $816d5c02a7858c70$var$$507fabe10e71c6fb$export$d90243b58daecda7.get((0, $2ZDqh.getOwnerWindow)(element))) return;
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $816d5c02a7858c70$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $816d5c02a7858c70$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $816d5c02a7858c70$var$$507fabe10e71c6fb$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $816d5c02a7858c70$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$816d5c02a7858c70$var$$507fabe10e71c6fb$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $816d5c02a7858c70$var$$507fabe10e71c6fb$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $816d5c02a7858c70$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $816d5c02a7858c70$var$$507fabe10e71c6fb$export$d90243b58daecda7.delete(windowObject);
};
function $816d5c02a7858c70$export$2f1888112f558a7d(element) {
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $816d5c02a7858c70$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $816d5c02a7858c70$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$816d5c02a7858c70$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $816d5c02a7858c70$export$2f1888112f558a7d();
function $816d5c02a7858c70$export$b9b3dfddab17db27() {
    return $816d5c02a7858c70$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $816d5c02a7858c70$export$630ff653c5ada6a9() {
    return $816d5c02a7858c70$var$$507fabe10e71c6fb$var$currentModality;
}
function $816d5c02a7858c70$export$8397ddfc504fdb9a(modality) {
    $816d5c02a7858c70$var$$507fabe10e71c6fb$var$currentModality = modality;
    $816d5c02a7858c70$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $816d5c02a7858c70$export$98e20ec92f614cfe() {
    $816d5c02a7858c70$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $exYeM.useState)($816d5c02a7858c70$var$$507fabe10e71c6fb$var$currentModality);
    (0, $exYeM.useEffect)(()=>{
        let handler = ()=>{
            setModality($816d5c02a7858c70$var$$507fabe10e71c6fb$var$currentModality);
        };
        $816d5c02a7858c70$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $816d5c02a7858c70$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $aVmq3.useIsSSR)() ? null : modality;
}
const $816d5c02a7858c70$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $816d5c02a7858c70$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$816d5c02a7858c70$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$816d5c02a7858c70$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $816d5c02a7858c70$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(autoFocus || $816d5c02a7858c70$export$b9b3dfddab17db27());
    $816d5c02a7858c70$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $816d5c02a7858c70$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $816d5c02a7858c70$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $exYeM.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$816d5c02a7858c70$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($816d5c02a7858c70$export$b9b3dfddab17db27());
        };
        $816d5c02a7858c70$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $816d5c02a7858c70$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $816d5c02a7858c70$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $exYeM.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $exYeM.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = $816d5c02a7858c70$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    let onFocus = (0, $exYeM.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $816d5c02a7858c70$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $816d5c02a7858c70$var$$6179b936705e76d3$var$hoverCount = 0;
function $816d5c02a7858c70$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $816d5c02a7858c70$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $816d5c02a7858c70$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $816d5c02a7858c70$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $816d5c02a7858c70$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $816d5c02a7858c70$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $816d5c02a7858c70$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $816d5c02a7858c70$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $816d5c02a7858c70$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $816d5c02a7858c70$var$$6179b936705e76d3$var$hoverCount--;
        if ($816d5c02a7858c70$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $816d5c02a7858c70$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $816d5c02a7858c70$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $816d5c02a7858c70$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $exYeM.useState)(false);
    let state = (0, $exYeM.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, $exYeM.useEffect)($816d5c02a7858c70$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $exYeM.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($816d5c02a7858c70$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$816d5c02a7858c70$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $exYeM.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $816d5c02a7858c70$export$872b660ac5a1ff98(props) {
    let { ref: ref, onInteractOutside: onInteractOutside, isDisabled: isDisabled, onInteractOutsideStart: onInteractOutsideStart } = props;
    let stateRef = (0, $exYeM.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    let onPointerDown = (0, $4sExG.useEffectEvent)((e)=>{
        if (onInteractOutside && $816d5c02a7858c70$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
            if (onInteractOutsideStart) onInteractOutsideStart(e);
            stateRef.current.isPointerDown = true;
        }
    });
    let triggerInteractOutside = (0, $4sExG.useEffectEvent)((e)=>{
        if (onInteractOutside) onInteractOutside(e);
    });
    (0, $exYeM.useEffect)(()=>{
        let state = stateRef.current;
        if (isDisabled) return;
        const element = ref.current;
        const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== "undefined") {
            let onPointerUp = (e)=>{
                if (state.isPointerDown && $816d5c02a7858c70$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            // changing these to capture phase fixed combobox
            documentObject.addEventListener("pointerdown", onPointerDown, true);
            documentObject.addEventListener("pointerup", onPointerUp, true);
            return ()=>{
                documentObject.removeEventListener("pointerdown", onPointerDown, true);
                documentObject.removeEventListener("pointerup", onPointerUp, true);
            };
        } else {
            let onMouseUp = (e)=>{
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && $816d5c02a7858c70$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            let onTouchEnd = (e)=>{
                state.ignoreEmulatedMouseEvents = true;
                if (state.isPointerDown && $816d5c02a7858c70$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            documentObject.addEventListener("mousedown", onPointerDown, true);
            documentObject.addEventListener("mouseup", onMouseUp, true);
            documentObject.addEventListener("touchstart", onPointerDown, true);
            documentObject.addEventListener("touchend", onTouchEnd, true);
            return ()=>{
                documentObject.removeEventListener("mousedown", onPointerDown, true);
                documentObject.removeEventListener("mouseup", onMouseUp, true);
                documentObject.removeEventListener("touchstart", onPointerDown, true);
                documentObject.removeEventListener("touchend", onTouchEnd, true);
            };
        }
    }, [
        ref,
        isDisabled,
        onPointerDown,
        triggerInteractOutside
    ]);
}
function $816d5c02a7858c70$var$$e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    if (event.target) {
        // if the event target is no longer in the document, ignore
        const ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
        // If the target is within a top layer element (e.g. toasts), ignore.
        if (event.target.closest("[data-react-aria-top-layer]")) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $816d5c02a7858c70$var$$93925083ecbb358c$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}
function $816d5c02a7858c70$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: $816d5c02a7858c70$var$$93925083ecbb358c$export$48d1ea6320830260(props.onKeyDown),
            onKeyUp: $816d5c02a7858c70$var$$93925083ecbb358c$export$48d1ea6320830260(props.onKeyUp)
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $816d5c02a7858c70$export$36da96379f79f245(props) {
    let { onMoveStart: onMoveStart, onMove: onMove, onMoveEnd: onMoveEnd } = props;
    let state = (0, $exYeM.useRef)({
        didMove: false,
        lastPosition: null,
        id: null
    });
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $aGeuR.useGlobalListeners)();
    let move = (0, $4sExG.useEffectEvent)((originalEvent, pointerType, deltaX, deltaY)=>{
        if (deltaX === 0 && deltaY === 0) return;
        if (!state.current.didMove) {
            state.current.didMove = true;
            onMoveStart === null || onMoveStart === void 0 || onMoveStart({
                type: "movestart",
                pointerType: pointerType,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        }
        onMove === null || onMove === void 0 || onMove({
            type: "move",
            pointerType: pointerType,
            deltaX: deltaX,
            deltaY: deltaY,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    });
    let end = (0, $4sExG.useEffectEvent)((originalEvent, pointerType)=>{
        $816d5c02a7858c70$var$$14c0b72509d70225$export$b0d6fa1ab32e3295();
        if (state.current.didMove) onMoveEnd === null || onMoveEnd === void 0 || onMoveEnd({
            type: "moveend",
            pointerType: pointerType,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    });
    let moveProps = (0, $exYeM.useMemo)(()=>{
        let moveProps = {};
        let start = ()=>{
            $816d5c02a7858c70$var$$14c0b72509d70225$export$16a4697467175487();
            state.current.didMove = false;
        };
        if (typeof PointerEvent === "undefined") {
            let onMouseMove = (e)=>{
                if (e.button === 0) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    move(e, "mouse", e.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onMouseUp = (e)=>{
                if (e.button === 0) {
                    end(e, "mouse");
                    removeGlobalListener(window, "mousemove", onMouseMove, false);
                    removeGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            moveProps.onMouseDown = (e)=>{
                if (e.button === 0) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    addGlobalListener(window, "mousemove", onMouseMove, false);
                    addGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            let onTouchMove = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier: identifier })=>identifier === state.current.id);
                if (touch >= 0) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    let { pageX: pageX, pageY: pageY } = e.changedTouches[touch];
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    move(e, "touch", pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: pageX,
                        pageY: pageY
                    };
                }
            };
            let onTouchEnd = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier: identifier })=>identifier === state.current.id);
                if (touch >= 0) {
                    end(e, "touch");
                    state.current.id = null;
                    removeGlobalListener(window, "touchmove", onTouchMove);
                    removeGlobalListener(window, "touchend", onTouchEnd);
                    removeGlobalListener(window, "touchcancel", onTouchEnd);
                }
            };
            moveProps.onTouchStart = (e)=>{
                if (e.changedTouches.length === 0 || state.current.id != null) return;
                let { pageX: pageX, pageY: pageY, identifier: identifier } = e.changedTouches[0];
                start();
                e.stopPropagation();
                e.preventDefault();
                state.current.lastPosition = {
                    pageX: pageX,
                    pageY: pageY
                };
                state.current.id = identifier;
                addGlobalListener(window, "touchmove", onTouchMove, false);
                addGlobalListener(window, "touchend", onTouchEnd, false);
                addGlobalListener(window, "touchcancel", onTouchEnd, false);
            };
        } else {
            let onPointerMove = (e)=>{
                if (e.pointerId === state.current.id) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    let pointerType = e.pointerType || "mouse";
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    // Problems with PointerEvent#movementX/movementY:
                    // 1. it is always 0 on macOS Safari.
                    // 2. On Chrome Android, it's scaled by devicePixelRatio, but not on Chrome macOS
                    move(e, pointerType, e.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || "mouse";
                    end(e, pointerType);
                    state.current.id = null;
                    removeGlobalListener(window, "pointermove", onPointerMove, false);
                    removeGlobalListener(window, "pointerup", onPointerUp, false);
                    removeGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
            moveProps.onPointerDown = (e)=>{
                if (e.button === 0 && state.current.id == null) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    state.current.id = e.pointerId;
                    addGlobalListener(window, "pointermove", onPointerMove, false);
                    addGlobalListener(window, "pointerup", onPointerUp, false);
                    addGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
        }
        let triggerKeyboardMove = (e, deltaX, deltaY)=>{
            start();
            move(e, "keyboard", deltaX, deltaY);
            end(e, "keyboard");
        };
        moveProps.onKeyDown = (e)=>{
            switch(e.key){
                case "Left":
                case "ArrowLeft":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, -1, 0);
                    break;
                case "Right":
                case "ArrowRight":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 1, 0);
                    break;
                case "Up":
                case "ArrowUp":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, -1);
                    break;
                case "Down":
                case "ArrowDown":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, 1);
                    break;
            }
        };
        return moveProps;
    }, [
        state,
        addGlobalListener,
        removeGlobalListener,
        move,
        end
    ]);
    return {
        moveProps: moveProps
    };
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $816d5c02a7858c70$export$2123ff2b87c81ca(props, ref) {
    let { onScroll: onScroll, isDisabled: isDisabled } = props;
    let onScrollHandler = (0, $exYeM.useCallback)((e)=>{
        // If the ctrlKey is pressed, this is a zoom event, do nothing.
        if (e.ctrlKey) return;
        // stop scrolling the page
        e.preventDefault();
        e.stopPropagation();
        if (onScroll) onScroll({
            deltaX: e.deltaX,
            deltaY: e.deltaY
        });
    }, [
        onScroll
    ]);
    (0, $aVei0.useEvent)(ref, "wheel", isDisabled ? undefined : onScrollHandler);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $816d5c02a7858c70$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $816d5c02a7858c70$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $816d5c02a7858c70$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $exYeM.useRef)();
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $aGeuR.useGlobalListeners)();
    let { pressProps: pressProps } = $816d5c02a7858c70$export$45712eceda6fad21({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, $6qwZD.useDescription)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $8vAG4.mergeProps)(pressProps, descriptionProps)
    };
}

});
parcelRegister("6qwZD", function(module, exports) {

$parcel$export(module.exports, "useDescription", function () { return $4adec38d632435de$export$f8aeda7b10753fa1; });

var $71dP2 = parcelRequire("71dP2");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $4adec38d632435de$var$$ef06256079686ba0$var$descriptionId = 0;
const $4adec38d632435de$var$$ef06256079686ba0$var$descriptionNodes = new Map();
function $4adec38d632435de$export$f8aeda7b10753fa1(description) {
    let [id, setId] = (0, $exYeM.useState)();
    (0, $71dP2.useLayoutEffect)(()=>{
        if (!description) return;
        let desc = $4adec38d632435de$var$$ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${$4adec38d632435de$var$$ef06256079686ba0$var$descriptionId++}`;
            setId(id);
            let node = document.createElement("div");
            node.id = id;
            node.style.display = "none";
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $4adec38d632435de$var$$ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (desc && --desc.refCount === 0) {
                desc.element.remove();
                $4adec38d632435de$var$$ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        "aria-describedby": description ? id : undefined
    };
}

});

parcelRegister("aVei0", function(module, exports) {

$parcel$export(module.exports, "useEvent", function () { return $7f3a4fd6534e948c$export$90fc3a17d93f704c; });

var $4sExG = parcelRequire("4sExG");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7f3a4fd6534e948c$export$90fc3a17d93f704c(ref, event, handler, options) {
    let handleEvent = (0, $4sExG.useEffectEvent)(handler);
    let isDisabled = handler == null;
    (0, $exYeM.useEffect)(()=>{
        if (isDisabled || !ref.current) return;
        let element = ref.current;
        element.addEventListener(event, handleEvent, options);
        return ()=>{
            element.removeEventListener(event, handleEvent, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled,
        handleEvent
    ]);
}

});


parcelRegister("8Oq4a", function(module, exports) {

$parcel$export(module.exports, "forwardRef", function () { return $b73ce7eb4b1568b2$export$257a8862b851cb5b; });
$parcel$export(module.exports, "mapPropsVariants", function () { return $b73ce7eb4b1568b2$export$9f203ede2b8cf905; });
// src/utils.ts

var $exYeM = parcelRequire("exYeM");
function $b73ce7eb4b1568b2$export$257a8862b851cb5b(component) {
    return (0, $exYeM.forwardRef)(component);
}
var $b73ce7eb4b1568b2$export$21e0669b7bd01bb4 = (obj)=>{
    return {
        ...obj,
        [Symbol.iterator]: function() {
            const keys = Object.keys(this);
            let index = 0;
            return {
                next: ()=>{
                    if (index >= keys.length) return {
                        done: true
                    };
                    const key = keys[index];
                    const value = this[key];
                    index++;
                    return {
                        value: {
                            key: key,
                            value: value
                        },
                        done: false
                    };
                }
            };
        }
    };
};
var $b73ce7eb4b1568b2$export$9f203ede2b8cf905 = (props, variantKeys, removeVariantProps = true)=>{
    if (!variantKeys) return [
        props,
        {}
    ];
    const picked = variantKeys.reduce((acc, key)=>{
        if (key in props) return {
            ...acc,
            [key]: props[key]
        };
        else return acc;
    }, {});
    if (removeVariantProps) {
        const omitted = Object.keys(props).filter((key)=>!variantKeys.includes(key)).reduce((acc, key)=>({
                ...acc,
                [key]: props[key]
            }), {});
        return [
            omitted,
            picked
        ];
    } else return [
        props,
        picked
    ];
};
var $b73ce7eb4b1568b2$export$ab8830944406cf18 = (originalProps, variantKeys, commonKeys)=>{
    const props = Object.keys(originalProps).filter((key)=>!variantKeys.includes(key) || (commonKeys == null ? void 0 : commonKeys.includes(key))).reduce((acc, key)=>({
            ...acc,
            [key]: originalProps[key]
        }), {});
    const variants = variantKeys.reduce((acc, key)=>({
            ...acc,
            [key]: originalProps[key]
        }), {});
    return [
        props,
        variants
    ];
};
var $b73ce7eb4b1568b2$export$749da038d9da17ac = (component)=>{
    var _a, _b, _c;
    return !!((_c = (_b = (_a = component.type) == null ? void 0 : _a.render) == null ? void 0 : _b.displayName) == null ? void 0 : _c.includes("NextUI"));
};

});

parcelRegister("3kiob", function(module, exports) {

$parcel$export(module.exports, "AnimatePresence", function () { return $9744623a78dc500b$export$3ae376d12526dd6f; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $6wQiX = parcelRequire("6wQiX");

var $gbBZ9 = parcelRequire("gbBZ9");

var $6Sdxq = parcelRequire("6Sdxq");

var $8OSCH = parcelRequire("8OSCH");

var $527gh = parcelRequire("527gh");

var $gDPsv = parcelRequire("gDPsv");

var $59uSO = parcelRequire("59uSO");
const $9744623a78dc500b$var$getChildKey = (child)=>child.key || "";
function $9744623a78dc500b$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $9744623a78dc500b$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $9744623a78dc500b$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $exYeM.Children).forEach(children, (child)=>{
        if ((0, $exYeM.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $9744623a78dc500b$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $59uSO.invariant)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $exYeM.useContext)((0, $8OSCH.LayoutGroupContext)).forceRender || (0, $6wQiX.useForceUpdate)()[0];
    const isMounted = (0, $gbBZ9.useIsMounted)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $9744623a78dc500b$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $exYeM.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $exYeM.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $exYeM.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $exYeM.useRef)(true);
    (0, $527gh.useIsomorphicLayoutEffect)(()=>{
        isInitialRender.current = false;
        $9744623a78dc500b$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $gDPsv.useUnmountEffect)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: childrenToRender.map((child)=>(0, $aSiaI.jsx)((0, $6Sdxq.PresenceChild), {
                isPresent: true,
                initial: initial ? undefined : false,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                children: child
            }, $9744623a78dc500b$var$getChildKey(child)))
    });
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($9744623a78dc500b$var$getChildKey);
    const targetKeys = filteredChildren.map($9744623a78dc500b$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                // clean up the exiting children map
                exitingChildren.delete(key);
                // compute the keys of children that were rendered once but are no longer present
                // this could happen in case of too many fast consequent renderings
                // @link https://github.com/framer/motion/issues/2023
                const leftOverKeys = Array.from(allChildren.keys()).filter((childKey)=>!targetKeys.includes(childKey));
                // clean up the all children map
                leftOverKeys.forEach((leftOverKey)=>allChildren.delete(leftOverKey));
                // make sure to render only the children that are actually visible
                presentChildren.current = filteredChildren.filter((presentChild)=>{
                    const presentChildKey = $9744623a78dc500b$var$getChildKey(presentChild);
                    return(// filter out the node exiting
                    presentChildKey === key || // filter out the leftover children
                    leftOverKeys.includes(presentChildKey));
                });
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = (0, $aSiaI.jsx)((0, $6Sdxq.PresenceChild), {
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                children: child
            }, $9744623a78dc500b$var$getChildKey(child));
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : (0, $aSiaI.jsx)((0, $6Sdxq.PresenceChild), {
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode,
            children: child
        }, $9744623a78dc500b$var$getChildKey(child));
    });
    return (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $exYeM.cloneElement)(child))
    });
};

});
parcelRegister("6wQiX", function(module, exports) {

$parcel$export(module.exports, "useForceUpdate", function () { return $e3793b3f0bbd618f$export$91db9bc4f8ac944a; });

var $exYeM = parcelRequire("exYeM");

var $gbBZ9 = parcelRequire("gbBZ9");

var $h9ps1 = parcelRequire("h9ps1");
function $e3793b3f0bbd618f$export$91db9bc4f8ac944a() {
    const isMounted = (0, $gbBZ9.useIsMounted)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $exYeM.useState)(0);
    const forceRender = (0, $exYeM.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $exYeM.useCallback)(()=>(0, $h9ps1.frame).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}

});
parcelRegister("gbBZ9", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", function () { return $a949daf2cc278282$export$80c2a3957bcb42ea; });

var $exYeM = parcelRequire("exYeM");

var $527gh = parcelRequire("527gh");
function $a949daf2cc278282$export$80c2a3957bcb42ea() {
    const isMounted = (0, $exYeM.useRef)(false);
    (0, $527gh.useIsomorphicLayoutEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}

});
parcelRegister("527gh", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $0e2d049f2abcd2c9$export$700979bc83e7db82; });

var $exYeM = parcelRequire("exYeM");

var $giwOG = parcelRequire("giwOG");
const $0e2d049f2abcd2c9$export$700979bc83e7db82 = (0, $giwOG.isBrowser) ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);

});
parcelRegister("giwOG", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $c763d68aeba74b31$export$4e09c449d6c407f7; });
const $c763d68aeba74b31$export$4e09c449d6c407f7 = typeof document !== "undefined";

});



parcelRegister("h9ps1", function(module, exports) {

$parcel$export(module.exports, "frame", function () { return $301e135f87ffeb5c$export$2cef06c20297c17d; });
$parcel$export(module.exports, "cancelFrame", function () { return $301e135f87ffeb5c$export$ec99c0ef4978dccb; });
$parcel$export(module.exports, "frameData", function () { return $301e135f87ffeb5c$export$fff89137e9e818ce; });

var $jbcYW = parcelRequire("jbcYW");

var $gevWd = parcelRequire("gevWd");
const { schedule: $301e135f87ffeb5c$export$2cef06c20297c17d, cancel: $301e135f87ffeb5c$export$ec99c0ef4978dccb, state: $301e135f87ffeb5c$export$fff89137e9e818ce, steps: $301e135f87ffeb5c$export$be3f796aed065412 } = (0, $gevWd.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $jbcYW.noop), true);

});
parcelRegister("jbcYW", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $001eda3aa79c6ebe$export$8793edee2d425525; });
const $001eda3aa79c6ebe$export$8793edee2d425525 = (any)=>any;

});

parcelRegister("gevWd", function(module, exports) {

$parcel$export(module.exports, "createRenderBatcher", function () { return $2c4ecd0dc095867d$export$510b0596a933801a; });

var $fLabD = parcelRequire("fLabD");

var $4DBmi = parcelRequire("4DBmi");
const $2c4ecd0dc095867d$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $2c4ecd0dc095867d$var$maxElapsed = 40;
function $2c4ecd0dc095867d$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $2c4ecd0dc095867d$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $4DBmi.createRenderStep)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>{
        steps[stepId].process(state);
    };
    const processBatch = ()=>{
        const timestamp = (0, $fLabD.MotionGlobalConfig).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $2c4ecd0dc095867d$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $2c4ecd0dc095867d$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $2c4ecd0dc095867d$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$2c4ecd0dc095867d$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

});
parcelRegister("fLabD", function(module, exports) {

$parcel$export(module.exports, "MotionGlobalConfig", function () { return $3cdabdabfda62d22$export$dd826089e3c5e502; });
const $3cdabdabfda62d22$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};

});

parcelRegister("4DBmi", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $734cfe98781f7335$export$b995e5e85f5c8289; });
class $734cfe98781f7335$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $734cfe98781f7335$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $734cfe98781f7335$var$Queue();
    let nextFrame = new $734cfe98781f7335$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
                callback(frameData);
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});




parcelRegister("6Sdxq", function(module, exports) {

$parcel$export(module.exports, "PresenceChild", function () { return $47d1b175d59538db$export$979daf65881a382a; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $igvvk = parcelRequire("igvvk");

var $8GmSS = parcelRequire("8GmSS");

var $cQWYa = parcelRequire("cQWYa");
const $47d1b175d59538db$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $8GmSS.useConstant)($47d1b175d59538db$var$newChildrenMap);
    const id = (0, $exYeM.useId)();
    const context = (0, $exYeM.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random()
    ] : [
        isPresent
    ]);
    (0, $exYeM.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $exYeM.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $aSiaI.jsx)((0, $cQWYa.PopChild), {
        isPresent: isPresent,
        children: children
    });
    return (0, $aSiaI.jsx)((0, $igvvk.PresenceContext).Provider, {
        value: context,
        children: children
    });
};
function $47d1b175d59538db$var$newChildrenMap() {
    return new Map();
}

});
parcelRegister("igvvk", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", function () { return $32835478aabc17b5$export$f224e4635b6f8ce2; });

var $exYeM = parcelRequire("exYeM");
/**
 * @public
 */ const $32835478aabc17b5$export$f224e4635b6f8ce2 = (0, $exYeM.createContext)(null);

});

parcelRegister("8GmSS", function(module, exports) {

$parcel$export(module.exports, "useConstant", function () { return $73d7e626f45c1838$export$fe4300aa8eebea86; });

var $exYeM = parcelRequire("exYeM");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $73d7e626f45c1838$export$fe4300aa8eebea86(init) {
    const ref = (0, $exYeM.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});

parcelRegister("cQWYa", function(module, exports) {

$parcel$export(module.exports, "PopChild", function () { return $da62d876e989a420$export$1d6cdde0c6816c6d; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aUORc = parcelRequire("aUORc");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $da62d876e989a420$var$PopChildMeasure extends $exYeM.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $da62d876e989a420$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $exYeM.useId)();
    const ref = (0, $exYeM.useRef)(null);
    const size = (0, $exYeM.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $exYeM.useContext)((0, $aUORc.MotionConfigContext));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $exYeM.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $aSiaI.jsx)($da62d876e989a420$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $exYeM.cloneElement(children, {
            ref: ref
        })
    });
}

});
parcelRegister("aUORc", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", function () { return $2d642de93cca1124$export$22a697fb29aac98d; });

var $exYeM = parcelRequire("exYeM");
/**
 * @public
 */ const $2d642de93cca1124$export$22a697fb29aac98d = (0, $exYeM.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});

});



parcelRegister("8OSCH", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", function () { return $0d8fa753a19a110b$export$a3579ca508007a95; });

var $exYeM = parcelRequire("exYeM");
const $0d8fa753a19a110b$export$a3579ca508007a95 = (0, $exYeM.createContext)({});

});

parcelRegister("gDPsv", function(module, exports) {

$parcel$export(module.exports, "useUnmountEffect", function () { return $5575fd4776144082$export$f3a192d0cbd30b96; });

var $exYeM = parcelRequire("exYeM");
function $5575fd4776144082$export$f3a192d0cbd30b96(callback) {
    return (0, $exYeM.useEffect)(()=>()=>callback(), []);
}

});

parcelRegister("59uSO", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $21125973824588d9$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $21125973824588d9$export$f5708dca728d7177; });

var $jbcYW = parcelRequire("jbcYW");
let $21125973824588d9$export$491112666e282270 = (0, $jbcYW.noop);
let $21125973824588d9$export$f5708dca728d7177 = (0, $jbcYW.noop);
var $21125973824588d9$var$check, $21125973824588d9$var$message, $21125973824588d9$var$check1, $21125973824588d9$var$message1;

});


parcelRegister("dVYhV", function(module, exports) {

$parcel$export(module.exports, "domAnimation", function () { return $2e274ee68e02292f$export$2cb19dbf990677e3; });

var $ePiah = parcelRequire("ePiah");

var $9tKwF = parcelRequire("9tKwF");

var $4DDuc = parcelRequire("4DDuc");
/**
 * @public
 */ const $2e274ee68e02292f$export$2cb19dbf990677e3 = {
    renderer: (0, $4DDuc.createDomVisualElement),
    ...(0, $ePiah.animations),
    ...(0, $9tKwF.gestureAnimations)
};

});
parcelRegister("ePiah", function(module, exports) {

$parcel$export(module.exports, "animations", function () { return $7170ce59c2debd45$export$7f9953c70dacfd7f; });

var $i1X5D = parcelRequire("i1X5D");

var $i481Q = parcelRequire("i481Q");
const $7170ce59c2debd45$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $i1X5D.AnimationFeature)
    },
    exit: {
        Feature: (0, $i481Q.ExitAnimationFeature)
    }
};

});
parcelRegister("i1X5D", function(module, exports) {

$parcel$export(module.exports, "AnimationFeature", function () { return $4c042cb37597b7b9$export$b45b3fe5caabdca; });

var $45ATh = parcelRequire("45ATh");

var $50jFR = parcelRequire("50jFR");

var $6jdHd = parcelRequire("6jdHd");
class $4c042cb37597b7b9$export$b45b3fe5caabdca extends (0, $6jdHd.Feature) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $50jFR.createAnimationState)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $45ATh.isAnimationControls)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}

});
parcelRegister("45ATh", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $0c915d7372d9814d$export$aa71198ceeaf53ce; });
function $0c915d7372d9814d$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("50jFR", function(module, exports) {

$parcel$export(module.exports, "createAnimationState", function () { return $b147b3fbcf8b2fc8$export$bb53502b7a672aa8; });

var $45ATh = parcelRequire("45ATh");

var $2VWpM = parcelRequire("2VWpM");

var $lzDaX = parcelRequire("lzDaX");

var $jzTF8 = parcelRequire("jzTF8");

var $9UsrA = parcelRequire("9UsrA");

var $7NOUe = parcelRequire("7NOUe");

var $W290Y = parcelRequire("W290Y");
const $b147b3fbcf8b2fc8$var$reversePriorityOrder = [
    ...(0, $7NOUe.variantPriorityOrder)
].reverse();
const $b147b3fbcf8b2fc8$var$numAnimationTypes = (0, $7NOUe.variantPriorityOrder).length;
function $b147b3fbcf8b2fc8$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $W290Y.animateVisualElement)(visualElement, animation, options)));
}
function $b147b3fbcf8b2fc8$export$bb53502b7a672aa8(visualElement) {
    let animate = $b147b3fbcf8b2fc8$var$animateList(visualElement);
    const state = $b147b3fbcf8b2fc8$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $9UsrA.resolveVariant)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $b147b3fbcf8b2fc8$var$numAnimationTypes; i++){
            const type = $b147b3fbcf8b2fc8$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $jzTF8.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $45ATh.isAnimationControls)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $b147b3fbcf8b2fc8$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $2VWpM.isKeyframesTarget)(next) && (0, $2VWpM.isKeyframesTarget)(prev)) valueHasChanged = !(0, $lzDaX.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $b147b3fbcf8b2fc8$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $lzDaX.shallowCompare)(next, prev);
    return false;
}
function $b147b3fbcf8b2fc8$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $b147b3fbcf8b2fc8$var$createState() {
    return {
        animate: $b147b3fbcf8b2fc8$var$createTypeState(true),
        whileInView: $b147b3fbcf8b2fc8$var$createTypeState(),
        whileHover: $b147b3fbcf8b2fc8$var$createTypeState(),
        whileTap: $b147b3fbcf8b2fc8$var$createTypeState(),
        whileDrag: $b147b3fbcf8b2fc8$var$createTypeState(),
        whileFocus: $b147b3fbcf8b2fc8$var$createTypeState(),
        exit: $b147b3fbcf8b2fc8$var$createTypeState()
    };
}

});
parcelRegister("2VWpM", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $6f683bc80c6d969e$export$9153ad4c4999f4a0; });
const $6f683bc80c6d969e$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};

});

parcelRegister("lzDaX", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", function () { return $423df1fac2a0b98a$export$90e866afbd6b9f1a; });
function $423df1fac2a0b98a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("jzTF8", function(module, exports) {

$parcel$export(module.exports, "isVariantLabel", function () { return $a36779356b36fa8a$export$720b90e312cea233; });
/**
 * Decides if the supplied variable is variant label
 */ function $a36779356b36fa8a$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}

});

parcelRegister("9UsrA", function(module, exports) {

$parcel$export(module.exports, "resolveVariant", function () { return $730ab9aa0424fb5a$export$7b1b1c981f4f0558; });

var $cuKdH = parcelRequire("cuKdH");
function $730ab9aa0424fb5a$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $cuKdH.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

});
parcelRegister("cuKdH", function(module, exports) {

$parcel$export(module.exports, "resolveVariantFromProps", function () { return $1527d424ce16b34c$export$d68f140c4d9b48bc; });
function $1527d424ce16b34c$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $1527d424ce16b34c$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $1527d424ce16b34c$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $1527d424ce16b34c$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}

});


parcelRegister("7NOUe", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", function () { return $46d8d186c05e43b0$export$16e45afcc206d3a8; });
$parcel$export(module.exports, "variantProps", function () { return $46d8d186c05e43b0$export$1405a65085f40b9; });
const $46d8d186c05e43b0$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $46d8d186c05e43b0$export$1405a65085f40b9 = [
    "initial",
    ...$46d8d186c05e43b0$export$16e45afcc206d3a8
];

});

parcelRegister("W290Y", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", function () { return $e364f8e011fb793b$export$ff62cf473653f109; });

var $9UsrA = parcelRequire("9UsrA");

var $dTq8p = parcelRequire("dTq8p");

var $lSHJj = parcelRequire("lSHJj");

var $h9ps1 = parcelRequire("h9ps1");
function $e364f8e011fb793b$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $lSHJj.animateVariant)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $lSHJj.animateVariant)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $9UsrA.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $dTq8p.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        (0, $h9ps1.frame).postRender(()=>{
            visualElement.notify("AnimationComplete", definition);
        });
    });
}

});
parcelRegister("dTq8p", function(module, exports) {

$parcel$export(module.exports, "animateTarget", function () { return $63d62870b9fa1dce$export$68cacfeee78d98d2; });

var $aGhCP = parcelRequire("aGhCP");

var $3Nhne = parcelRequire("3Nhne");

var $7xpSg = parcelRequire("7xpSg");

var $drLSE = parcelRequire("drLSE");

var $guNhb = parcelRequire("guNhb");

var $1j0VF = parcelRequire("1j0VF");

var $h9ps1 = parcelRequire("h9ps1");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $63d62870b9fa1dce$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $63d62870b9fa1dce$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $63d62870b9fa1dce$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...(0, $guNhb.getValueTransition)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.HandoffAppearAnimations) {
            const appearId = (0, $1j0VF.getOptimisedAppearId)(visualElement);
            if (appearId) {
                const elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $h9ps1.frame));
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    isHandoff = true;
                }
            }
        }
        value.start((0, $3Nhne.animateMotionValue)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $aGhCP.transformProps).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) {
            if ((0, $7xpSg.isWillChangeMotionValue)(willChange)) {
                willChange.add(key);
                animation.then(()=>willChange.remove(key));
            }
            animations.push(animation);
        }
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $h9ps1.frame).update(()=>{
            transitionEnd && (0, $drLSE.setTarget)(visualElement, transitionEnd);
        });
    });
    return animations;
}

});
parcelRegister("aGhCP", function(module, exports) {

$parcel$export(module.exports, "transformPropOrder", function () { return $da211e07316d6e39$export$280dc01950909d86; });
$parcel$export(module.exports, "transformProps", function () { return $da211e07316d6e39$export$7b42a0094fb00b6e; });
/**
 * Generate a list of every possible transform key.
 */ const $da211e07316d6e39$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $da211e07316d6e39$export$7b42a0094fb00b6e = new Set($da211e07316d6e39$export$280dc01950909d86);

});

parcelRegister("3Nhne", function(module, exports) {

$parcel$export(module.exports, "animateMotionValue", function () { return $b414a5ed52d2ead3$export$90b3dfc33ff3548; });

var $5X3GB = parcelRequire("5X3GB");

var $1X6Cj = parcelRequire("1X6Cj");

var $guNhb = parcelRequire("guNhb");

var $fLabD = parcelRequire("fLabD");

var $ejZQ0 = parcelRequire("ejZQ0");

var $eogZo = parcelRequire("eogZo");

var $h9ps1 = parcelRequire("h9ps1");

var $1lE9Q = parcelRequire("1lE9Q");

var $9Crwj = parcelRequire("9Crwj");

var $f91Jp = parcelRequire("f91Jp");
const $b414a5ed52d2ead3$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $guNhb.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $5X3GB.secondsToMilliseconds)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $guNhb.isTransitionDefined)(valueTransition)) options = {
            ...options,
            ...(0, $1X6Cj.getDefaultTransition)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $5X3GB.secondsToMilliseconds)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $5X3GB.secondsToMilliseconds)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $ejZQ0.instantAnimationState).current || (0, $fLabD.MotionGlobalConfig).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $eogZo.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $h9ps1.frame).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $f91Jp.GroupPlaybackControls)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $1lE9Q.AcceleratedAnimation).supports(options)) return new (0, $1lE9Q.AcceleratedAnimation)(options);
        else return new (0, $9Crwj.MainThreadAnimation)(options);
    };

});
parcelRegister("5X3GB", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $bfda710cf857a073$export$fc3e7e8557f8c8c7; });
$parcel$export(module.exports, "millisecondsToSeconds", function () { return $bfda710cf857a073$export$f64c3bfbc58eec0f; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $bfda710cf857a073$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $bfda710cf857a073$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

});

parcelRegister("1X6Cj", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $d51b9411f6ccbbd1$export$262124b154b9f1c0; });

var $aGhCP = parcelRequire("aGhCP");
const $d51b9411f6ccbbd1$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $d51b9411f6ccbbd1$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $d51b9411f6ccbbd1$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $d51b9411f6ccbbd1$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $d51b9411f6ccbbd1$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $d51b9411f6ccbbd1$var$keyframesTransition;
    else if ((0, $aGhCP.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? $d51b9411f6ccbbd1$var$criticallyDampedSpring(keyframes[1]) : $d51b9411f6ccbbd1$var$underDampedSpring;
    return $d51b9411f6ccbbd1$var$ease;
};

});

parcelRegister("guNhb", function(module, exports) {

$parcel$export(module.exports, "isTransitionDefined", function () { return $1d127c5bbdfabc9c$export$ca8e47dc8ed5a9d7; });
$parcel$export(module.exports, "getValueTransition", function () { return $1d127c5bbdfabc9c$export$7c1391340308742e; });
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $1d127c5bbdfabc9c$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $1d127c5bbdfabc9c$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}

});

parcelRegister("ejZQ0", function(module, exports) {

$parcel$export(module.exports, "instantAnimationState", function () { return $f006002175d4313e$export$888a3d84909f9e3d; });
const $f006002175d4313e$export$888a3d84909f9e3d = {
    current: false
};

});

parcelRegister("eogZo", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", function () { return $511bcb3f09b5d5d2$export$14de59408fad90b; });
const $511bcb3f09b5d5d2$var$isNotNull = (value)=>value !== null;
function $511bcb3f09b5d5d2$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($511bcb3f09b5d5d2$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});

parcelRegister("1lE9Q", function(module, exports) {

$parcel$export(module.exports, "AcceleratedAnimation", function () { return $a16b4fc0114fb32a$export$2a45abb4e6513325; });

var $d04GL = parcelRequire("d04GL");

var $gfclk = parcelRequire("gfclk");

var $6nEp5 = parcelRequire("6nEp5");

var $jbcYW = parcelRequire("jbcYW");

var $5X3GB = parcelRequire("5X3GB");

var $e8lTn = parcelRequire("e8lTn");

var $9Crwj = parcelRequire("9Crwj");

var $1k7uw = parcelRequire("1k7uw");

var $kca8O = parcelRequire("kca8O");

var $eogZo = parcelRequire("eogZo");
const $a16b4fc0114fb32a$var$supportsWaapi = (0, $6nEp5.memo)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $a16b4fc0114fb32a$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $a16b4fc0114fb32a$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $a16b4fc0114fb32a$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $a16b4fc0114fb32a$var$requiresPregeneratedKeyframes(options) {
    return options.type === "spring" || options.name === "backgroundColor" || !(0, $kca8O.isWaapiSupportedEasing)(options.ease);
}
function $a16b4fc0114fb32a$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $9Crwj.MainThreadAnimation)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $a16b4fc0114fb32a$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $a16b4fc0114fb32a$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $a16b4fc0114fb32a$var$sampleDelta,
        ease: "linear"
    };
}
class $a16b4fc0114fb32a$export$2a45abb4e6513325 extends (0, $e8lTn.BaseAnimation) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, keyframes: keyframes } = this.options;
        this.resolver = new (0, $gfclk.DOMKeyframesResolver)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($a16b4fc0114fb32a$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, ...options } = this.options;
            const pregeneratedAnimation = $a16b4fc0114fb32a$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $1k7uw.animateStyle)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = (0, $d04GL.time).now();
        if (this.pendingTimeline) {
            animation.timeline = this.pendingTimeline;
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $eogZo.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $5X3GB.millisecondsToSeconds)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $5X3GB.millisecondsToSeconds)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $5X3GB.secondsToMilliseconds)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $jbcYW.noop;
            const { animation: animation } = resolved;
            animation.timeline = timeline;
            animation.onfinish = null;
        }
        return 0, $jbcYW.noop;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, ...options } = this.options;
            const sampleAnimation = new (0, $9Crwj.MainThreadAnimation)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $5X3GB.secondsToMilliseconds)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $a16b4fc0114fb32a$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $a16b4fc0114fb32a$var$sampleDelta);
        }
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return $a16b4fc0114fb32a$var$supportsWaapi() && name && $a16b4fc0114fb32a$var$acceleratedValues.has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}

});
parcelRegister("d04GL", function(module, exports) {

$parcel$export(module.exports, "time", function () { return $960d9779faf6f40c$export$2da9be4cfdb689b1; });

var $fLabD = parcelRequire("fLabD");

var $h9ps1 = parcelRequire("h9ps1");
let $960d9779faf6f40c$var$now;
function $960d9779faf6f40c$var$clearTime() {
    $960d9779faf6f40c$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $960d9779faf6f40c$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($960d9779faf6f40c$var$now === undefined) $960d9779faf6f40c$export$2da9be4cfdb689b1.set((0, $h9ps1.frameData).isProcessing || (0, $fLabD.MotionGlobalConfig).useManualTiming ? (0, $h9ps1.frameData).timestamp : performance.now());
        return $960d9779faf6f40c$var$now;
    },
    set: (newTime)=>{
        $960d9779faf6f40c$var$now = newTime;
        queueMicrotask($960d9779faf6f40c$var$clearTime);
    }
};

});

parcelRegister("gfclk", function(module, exports) {

$parcel$export(module.exports, "DOMKeyframesResolver", function () { return $891e5637f91f7d52$export$4983792d11b61017; });

var $hon14 = parcelRequire("hon14");

var $9YOLh = parcelRequire("9YOLh");

var $8wvQl = parcelRequire("8wvQl");

var $izQMG = parcelRequire("izQMG");

var $1d5RG = parcelRequire("1d5RG");

var $32TFF = parcelRequire("32TFF");

var $9CDww = parcelRequire("9CDww");
class $891e5637f91f7d52$export$4983792d11b61017 extends (0, $32TFF.KeyframeResolver) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue){
        super(unresolvedKeyframes, onComplete, name, motionValue, motionValue === null || motionValue === void 0 ? void 0 : motionValue.owner, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $8wvQl.isCSSVariableToken)(keyframe)) {
                    const resolved = (0, $9YOLh.getVariableValue)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $izQMG.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $1d5RG.findDimensionValueType)(origin);
        const targetType = (0, $1d5RG.findDimensionValueType)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $izQMG.isNumOrPxType)(originType) && (0, $izQMG.isNumOrPxType)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $hon14.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $9CDww.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $izQMG.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $izQMG.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

});
parcelRegister("hon14", function(module, exports) {

$parcel$export(module.exports, "isNone", function () { return $79eb9ac4c2b846cb$export$e56af863d5645d5f; });

var $1OeNz = parcelRequire("1OeNz");
function $79eb9ac4c2b846cb$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $1OeNz.isZeroValueString)(value);
    else return true;
}

});
parcelRegister("1OeNz", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", function () { return $dc25af1e857ab50f$export$ade84c85e44a6cb1; });
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $dc25af1e857ab50f$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);

});


parcelRegister("9YOLh", function(module, exports) {

$parcel$export(module.exports, "getVariableValue", function () { return $43d08db277fd08bd$export$289398774300c991; });

var $59uSO = parcelRequire("59uSO");

var $7uiB3 = parcelRequire("7uiB3");

var $8wvQl = parcelRequire("8wvQl");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $43d08db277fd08bd$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $43d08db277fd08bd$export$b9f0c1f373aee2b0(current) {
    const match = $43d08db277fd08bd$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $43d08db277fd08bd$var$maxDepth = 4;
function $43d08db277fd08bd$export$289398774300c991(current, element, depth = 1) {
    (0, $59uSO.invariant)(depth <= $43d08db277fd08bd$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $43d08db277fd08bd$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $7uiB3.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $8wvQl.isCSSVariableToken)(fallback) ? $43d08db277fd08bd$export$289398774300c991(fallback, element, depth + 1) : fallback;
}

});
parcelRegister("7uiB3", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $fe062db003bcffb8$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $fe062db003bcffb8$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

});

parcelRegister("8wvQl", function(module, exports) {

$parcel$export(module.exports, "isCSSVariableName", function () { return $7788fac55eb8bc79$export$9de1236619d9e756; });
$parcel$export(module.exports, "isCSSVariableToken", function () { return $7788fac55eb8bc79$export$31f9caa2600b5723; });
const $7788fac55eb8bc79$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $7788fac55eb8bc79$export$9de1236619d9e756 = $7788fac55eb8bc79$var$checkStringStartsWith("--");
const $7788fac55eb8bc79$var$startsAsVariableToken = $7788fac55eb8bc79$var$checkStringStartsWith("var(--");
const $7788fac55eb8bc79$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $7788fac55eb8bc79$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $7788fac55eb8bc79$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $7788fac55eb8bc79$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

});


parcelRegister("izQMG", function(module, exports) {

$parcel$export(module.exports, "positionalKeys", function () { return $c21fcd3807f5d2f0$export$c66c0d5db2a205d; });
$parcel$export(module.exports, "isNumOrPxType", function () { return $c21fcd3807f5d2f0$export$8e5250d1aa9bf370; });
$parcel$export(module.exports, "removeNonTranslationalTransform", function () { return $c21fcd3807f5d2f0$export$39d4bc9655f3f632; });
$parcel$export(module.exports, "positionalValues", function () { return $c21fcd3807f5d2f0$export$781d46a8aa670d52; });

var $aGhCP = parcelRequire("aGhCP");

var $2NSBK = parcelRequire("2NSBK");

var $dBAI6 = parcelRequire("dBAI6");
const $c21fcd3807f5d2f0$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $c21fcd3807f5d2f0$export$8e5250d1aa9bf370 = (v)=>v === (0, $2NSBK.number) || v === (0, $dBAI6.px);
const $c21fcd3807f5d2f0$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $c21fcd3807f5d2f0$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $c21fcd3807f5d2f0$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $c21fcd3807f5d2f0$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $c21fcd3807f5d2f0$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $c21fcd3807f5d2f0$var$nonTranslationalTransformKeys = (0, $aGhCP.transformPropOrder).filter((key)=>!$c21fcd3807f5d2f0$var$transformKeys.has(key));
function $c21fcd3807f5d2f0$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $c21fcd3807f5d2f0$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $c21fcd3807f5d2f0$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $c21fcd3807f5d2f0$var$getTranslateFromMatrix(4, 13),
    y: $c21fcd3807f5d2f0$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$c21fcd3807f5d2f0$export$781d46a8aa670d52.translateX = $c21fcd3807f5d2f0$export$781d46a8aa670d52.x;
$c21fcd3807f5d2f0$export$781d46a8aa670d52.translateY = $c21fcd3807f5d2f0$export$781d46a8aa670d52.y;

});
parcelRegister("2NSBK", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $3b3d1d8d17c11467$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $3b3d1d8d17c11467$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $3b3d1d8d17c11467$export$dcdf75081b88279d; });

var $c0yRa = parcelRequire("c0yRa");
const $3b3d1d8d17c11467$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $3b3d1d8d17c11467$export$58f0f39f63f3cf42 = {
    ...$3b3d1d8d17c11467$export$98e628dec113755e,
    transform: (v)=>(0, $c0yRa.clamp)(0, 1, v)
};
const $3b3d1d8d17c11467$export$dcdf75081b88279d = {
    ...$3b3d1d8d17c11467$export$98e628dec113755e,
    default: 1
};

});
parcelRegister("c0yRa", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $b55556710a8b54c0$export$7d15b64cf5a3a4c4; });
const $b55556710a8b54c0$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

});


parcelRegister("dBAI6", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $e8f3e6c5adc69edc$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $e8f3e6c5adc69edc$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $e8f3e6c5adc69edc$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $e8f3e6c5adc69edc$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $e8f3e6c5adc69edc$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $e8f3e6c5adc69edc$export$44e2e1705876d7ed; });

var $6rWfM = parcelRequire("6rWfM");
const $e8f3e6c5adc69edc$var$createUnitType = (unit)=>({
        test: (v)=>(0, $6rWfM.isString)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $e8f3e6c5adc69edc$export$41fc368e1a942b97 = $e8f3e6c5adc69edc$var$createUnitType("deg");
const $e8f3e6c5adc69edc$export$626336c2cd4b14de = $e8f3e6c5adc69edc$var$createUnitType("%");
const $e8f3e6c5adc69edc$export$91c0eda1d06bf008 = $e8f3e6c5adc69edc$var$createUnitType("px");
const $e8f3e6c5adc69edc$export$f91e8c45a95a32f2 = $e8f3e6c5adc69edc$var$createUnitType("vh");
const $e8f3e6c5adc69edc$export$aed3d7b7d206c196 = $e8f3e6c5adc69edc$var$createUnitType("vw");
const $e8f3e6c5adc69edc$export$44e2e1705876d7ed = {
    ...$e8f3e6c5adc69edc$export$626336c2cd4b14de,
    parse: (v)=>$e8f3e6c5adc69edc$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$e8f3e6c5adc69edc$export$626336c2cd4b14de.transform(v * 100)
};

});
parcelRegister("6rWfM", function(module, exports) {

$parcel$export(module.exports, "sanitize", function () { return $eb49388da280e24f$export$83d2e9e3e4ee39ed; });
$parcel$export(module.exports, "floatRegex", function () { return $eb49388da280e24f$export$2444ca58c08448e4; });
$parcel$export(module.exports, "colorRegex", function () { return $eb49388da280e24f$export$740b69c5fad25dba; });
$parcel$export(module.exports, "singleColorRegex", function () { return $eb49388da280e24f$export$ed808ff6ecd39e8d; });
$parcel$export(module.exports, "isString", function () { return $eb49388da280e24f$export$844ec244b1367d54; });
/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $eb49388da280e24f$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $eb49388da280e24f$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
const $eb49388da280e24f$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
const $eb49388da280e24f$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function $eb49388da280e24f$export$844ec244b1367d54(v) {
    return typeof v === "string";
}

});



parcelRegister("1d5RG", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $b2fd586ec5020ed9$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $b2fd586ec5020ed9$export$eefdd52e3ccae428; });

var $2NSBK = parcelRequire("2NSBK");

var $dBAI6 = parcelRequire("dBAI6");

var $fFX0a = parcelRequire("fFX0a");

var $qyYUL = parcelRequire("qyYUL");
/**
 * A list of value types commonly used for dimensions
 */ const $b2fd586ec5020ed9$export$d176691c1998a1f5 = [
    (0, $2NSBK.number),
    (0, $dBAI6.px),
    (0, $dBAI6.percent),
    (0, $dBAI6.degrees),
    (0, $dBAI6.vw),
    (0, $dBAI6.vh),
    (0, $qyYUL.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $b2fd586ec5020ed9$export$eefdd52e3ccae428 = (v)=>$b2fd586ec5020ed9$export$d176691c1998a1f5.find((0, $fFX0a.testValueType)(v));

});
parcelRegister("fFX0a", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $0a85921ea474cb14$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ const $0a85921ea474cb14$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);

});

parcelRegister("qyYUL", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $e8457b7d67ceabe9$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ const $e8457b7d67ceabe9$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};

});


parcelRegister("32TFF", function(module, exports) {

$parcel$export(module.exports, "flushKeyframeResolvers", function () { return $80c84fe89f88d202$export$78b96d2a12593b05; });
$parcel$export(module.exports, "KeyframeResolver", function () { return $80c84fe89f88d202$export$74d34ca3182f1750; });

var $izQMG = parcelRequire("izQMG");

var $h9ps1 = parcelRequire("h9ps1");
const $80c84fe89f88d202$var$toResolve = new Set();
let $80c84fe89f88d202$var$isScheduled = false;
let $80c84fe89f88d202$var$anyNeedsMeasurement = false;
function $80c84fe89f88d202$var$measureAllKeyframes() {
    if ($80c84fe89f88d202$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($80c84fe89f88d202$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $izQMG.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $80c84fe89f88d202$var$anyNeedsMeasurement = false;
    $80c84fe89f88d202$var$isScheduled = false;
    $80c84fe89f88d202$var$toResolve.forEach((resolver)=>resolver.complete());
    $80c84fe89f88d202$var$toResolve.clear();
}
function $80c84fe89f88d202$var$readAllKeyframes() {
    $80c84fe89f88d202$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $80c84fe89f88d202$var$anyNeedsMeasurement = true;
    });
}
function $80c84fe89f88d202$export$78b96d2a12593b05() {
    $80c84fe89f88d202$var$readAllKeyframes();
    $80c84fe89f88d202$var$measureAllKeyframes();
}
class $80c84fe89f88d202$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $80c84fe89f88d202$var$toResolve.add(this);
            if (!$80c84fe89f88d202$var$isScheduled) {
                $80c84fe89f88d202$var$isScheduled = true;
                (0, $h9ps1.frame).read($80c84fe89f88d202$var$readAllKeyframes);
                (0, $h9ps1.frame).resolveKeyframes($80c84fe89f88d202$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $80c84fe89f88d202$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $80c84fe89f88d202$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}

});

parcelRegister("9CDww", function(module, exports) {

$parcel$export(module.exports, "makeNoneKeyframesAnimatable", function () { return $3f14005f681887c7$export$8cc4958f8e540f37; });

var $l1Pxi = parcelRequire("l1Pxi");

var $4VPQH = parcelRequire("4VPQH");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $3f14005f681887c7$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $3f14005f681887c7$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$3f14005f681887c7$var$invalidTemplates.has(keyframe) && (0, $l1Pxi.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $4VPQH.getAnimatableNone)(name, animatableTemplate);
}

});
parcelRegister("l1Pxi", function(module, exports) {

$parcel$export(module.exports, "analyseComplexValue", function () { return $20185419c445ef46$export$b61fc7c44bf646d5; });
$parcel$export(module.exports, "complex", function () { return $20185419c445ef46$export$83a0e34f1302825b; });

var $3zHZ7 = parcelRequire("3zHZ7");

var $6rWfM = parcelRequire("6rWfM");
function $20185419c445ef46$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $6rWfM.isString)(v) && (((_a = v.match((0, $6rWfM.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $6rWfM.colorRegex))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $20185419c445ef46$var$NUMBER_TOKEN = "number";
const $20185419c445ef46$var$COLOR_TOKEN = "color";
const $20185419c445ef46$var$VAR_TOKEN = "var";
const $20185419c445ef46$var$VAR_FUNCTION_TOKEN = "var(";
const $20185419c445ef46$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $20185419c445ef46$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $20185419c445ef46$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($20185419c445ef46$var$complexRegex, (parsedValue)=>{
        if ((0, $3zHZ7.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push($20185419c445ef46$var$COLOR_TOKEN);
            values.push((0, $3zHZ7.color).parse(parsedValue));
        } else if (parsedValue.startsWith($20185419c445ef46$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($20185419c445ef46$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($20185419c445ef46$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $20185419c445ef46$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($20185419c445ef46$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $20185419c445ef46$var$parseComplexValue(v) {
    return $20185419c445ef46$export$b61fc7c44bf646d5(v).values;
}
function $20185419c445ef46$var$createTransformer(source) {
    const { split: split, types: types } = $20185419c445ef46$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $20185419c445ef46$var$NUMBER_TOKEN) output += (0, $6rWfM.sanitize)(v[i]);
                else if (type === $20185419c445ef46$var$COLOR_TOKEN) output += (0, $3zHZ7.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $20185419c445ef46$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $20185419c445ef46$var$getAnimatableNone(v) {
    const parsed = $20185419c445ef46$var$parseComplexValue(v);
    const transformer = $20185419c445ef46$var$createTransformer(v);
    return transformer(parsed.map($20185419c445ef46$var$convertNumbersToZero));
}
const $20185419c445ef46$export$83a0e34f1302825b = {
    test: $20185419c445ef46$var$test,
    parse: $20185419c445ef46$var$parseComplexValue,
    createTransformer: $20185419c445ef46$var$createTransformer,
    getAnimatableNone: $20185419c445ef46$var$getAnimatableNone
};

});
parcelRegister("3zHZ7", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $9aa3b4c939055303$export$35e9368ef982300f; });

var $6rWfM = parcelRequire("6rWfM");

var $8QUi5 = parcelRequire("8QUi5");

var $NqKlm = parcelRequire("NqKlm");

var $iq4zk = parcelRequire("iq4zk");
const $9aa3b4c939055303$export$35e9368ef982300f = {
    test: (v)=>(0, $iq4zk.rgba).test(v) || (0, $8QUi5.hex).test(v) || (0, $NqKlm.hsla).test(v),
    parse: (v)=>{
        if ((0, $iq4zk.rgba).test(v)) return (0, $iq4zk.rgba).parse(v);
        else if ((0, $NqKlm.hsla).test(v)) return (0, $NqKlm.hsla).parse(v);
        else return (0, $8QUi5.hex).parse(v);
    },
    transform: (v)=>{
        return (0, $6rWfM.isString)(v) ? v : v.hasOwnProperty("red") ? (0, $iq4zk.rgba).transform(v) : (0, $NqKlm.hsla).transform(v);
    }
};

});
parcelRegister("8QUi5", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $aeb63d9188419d43$export$834dfc94dde4b3d8; });

var $iq4zk = parcelRequire("iq4zk");

var $2ufRn = parcelRequire("2ufRn");
function $aeb63d9188419d43$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $aeb63d9188419d43$export$834dfc94dde4b3d8 = {
    test: (0, $2ufRn.isColorString)("#"),
    parse: $aeb63d9188419d43$var$parseHex,
    transform: (0, $iq4zk.rgba).transform
};

});
parcelRegister("iq4zk", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $85af50c0409e6514$export$4e46ac54fc82cf3b; });

var $c0yRa = parcelRequire("c0yRa");

var $2NSBK = parcelRequire("2NSBK");

var $6rWfM = parcelRequire("6rWfM");

var $2ufRn = parcelRequire("2ufRn");
const $85af50c0409e6514$var$clampRgbUnit = (v)=>(0, $c0yRa.clamp)(0, 255, v);
const $85af50c0409e6514$export$7a99c86b5b1f4c9e = {
    ...(0, $2NSBK.number),
    transform: (v)=>Math.round($85af50c0409e6514$var$clampRgbUnit(v))
};
const $85af50c0409e6514$export$4e46ac54fc82cf3b = {
    test: (0, $2ufRn.isColorString)("rgb", "red"),
    parse: (0, $2ufRn.splitColor)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $85af50c0409e6514$export$7a99c86b5b1f4c9e.transform(red) + ", " + $85af50c0409e6514$export$7a99c86b5b1f4c9e.transform(green) + ", " + $85af50c0409e6514$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $6rWfM.sanitize)((0, $2NSBK.alpha).transform(alpha$1)) + ")"
};

});
parcelRegister("2ufRn", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $75e61ee5dd842e4f$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $75e61ee5dd842e4f$export$73d6f35be992df24; });

var $6rWfM = parcelRequire("6rWfM");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $75e61ee5dd842e4f$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $6rWfM.isString)(v) && (0, $6rWfM.singleColorRegex).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $75e61ee5dd842e4f$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $6rWfM.isString)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $6rWfM.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

});



parcelRegister("NqKlm", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $849448f5a3a709c4$export$810b04175080204c; });

var $2NSBK = parcelRequire("2NSBK");

var $dBAI6 = parcelRequire("dBAI6");

var $6rWfM = parcelRequire("6rWfM");

var $2ufRn = parcelRequire("2ufRn");
const $849448f5a3a709c4$export$810b04175080204c = {
    test: (0, $2ufRn.isColorString)("hsl", "hue"),
    parse: (0, $2ufRn.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $dBAI6.percent).transform((0, $6rWfM.sanitize)(saturation)) + ", " + (0, $dBAI6.percent).transform((0, $6rWfM.sanitize)(lightness)) + ", " + (0, $6rWfM.sanitize)((0, $2NSBK.alpha).transform(alpha$1)) + ")";
    }
};

});



parcelRegister("4VPQH", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $f39674aa42131bf6$export$cea0cedcb94873b5; });

var $l1Pxi = parcelRequire("l1Pxi");

var $d8t2W = parcelRequire("d8t2W");

var $5trun = parcelRequire("5trun");
function $f39674aa42131bf6$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $5trun.getDefaultValueType)(key);
    if (defaultValueType !== (0, $d8t2W.filter)) defaultValueType = (0, $l1Pxi.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

});
parcelRegister("d8t2W", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $c9578b271c7cac5c$export$3dea766d36a8935f; });

var $l1Pxi = parcelRequire("l1Pxi");

var $6rWfM = parcelRequire("6rWfM");
/**
 * Properties that should default to 1 or 100%
 */ const $c9578b271c7cac5c$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $c9578b271c7cac5c$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $6rWfM.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $c9578b271c7cac5c$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $c9578b271c7cac5c$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $c9578b271c7cac5c$export$3dea766d36a8935f = {
    ...(0, $l1Pxi.complex),
    getAnimatableNone: (v)=>{
        const functions = v.match($c9578b271c7cac5c$var$functionRegex);
        return functions ? functions.map($c9578b271c7cac5c$var$applyDefaultFilter).join(" ") : v;
    }
};

});

parcelRegister("5trun", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $10ea5fd01401393b$export$67d1babe0338d23b; });

var $3zHZ7 = parcelRequire("3zHZ7");

var $d8t2W = parcelRequire("d8t2W");

var $fg9sn = parcelRequire("fg9sn");
/**
 * A map of default value types for common values
 */ const $10ea5fd01401393b$export$98cd7c72c5a731fb = {
    ...(0, $fg9sn.numberValueTypes),
    color: // Color props
    $3zHZ7.color,
    backgroundColor: (0, $3zHZ7.color),
    outlineColor: (0, $3zHZ7.color),
    fill: (0, $3zHZ7.color),
    stroke: (0, $3zHZ7.color),
    // Border props
    borderColor: (0, $3zHZ7.color),
    borderTopColor: (0, $3zHZ7.color),
    borderRightColor: (0, $3zHZ7.color),
    borderBottomColor: (0, $3zHZ7.color),
    borderLeftColor: (0, $3zHZ7.color),
    filter: $d8t2W.filter,
    WebkitFilter: (0, $d8t2W.filter)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $10ea5fd01401393b$export$67d1babe0338d23b = (key)=>$10ea5fd01401393b$export$98cd7c72c5a731fb[key];

});
parcelRegister("fg9sn", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $0d74cfa63198be03$export$eec14432cd1cb67b; });

var $2NSBK = parcelRequire("2NSBK");

var $dBAI6 = parcelRequire("dBAI6");

var $7JjKg = parcelRequire("7JjKg");
const $0d74cfa63198be03$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $dBAI6.px),
    borderTopWidth: (0, $dBAI6.px),
    borderRightWidth: (0, $dBAI6.px),
    borderBottomWidth: (0, $dBAI6.px),
    borderLeftWidth: (0, $dBAI6.px),
    borderRadius: (0, $dBAI6.px),
    radius: (0, $dBAI6.px),
    borderTopLeftRadius: (0, $dBAI6.px),
    borderTopRightRadius: (0, $dBAI6.px),
    borderBottomRightRadius: (0, $dBAI6.px),
    borderBottomLeftRadius: (0, $dBAI6.px),
    // Positioning props
    width: (0, $dBAI6.px),
    maxWidth: (0, $dBAI6.px),
    height: (0, $dBAI6.px),
    maxHeight: (0, $dBAI6.px),
    size: (0, $dBAI6.px),
    top: (0, $dBAI6.px),
    right: (0, $dBAI6.px),
    bottom: (0, $dBAI6.px),
    left: (0, $dBAI6.px),
    // Spacing props
    padding: (0, $dBAI6.px),
    paddingTop: (0, $dBAI6.px),
    paddingRight: (0, $dBAI6.px),
    paddingBottom: (0, $dBAI6.px),
    paddingLeft: (0, $dBAI6.px),
    margin: (0, $dBAI6.px),
    marginTop: (0, $dBAI6.px),
    marginRight: (0, $dBAI6.px),
    marginBottom: (0, $dBAI6.px),
    marginLeft: (0, $dBAI6.px),
    // Transform props
    rotate: (0, $dBAI6.degrees),
    rotateX: (0, $dBAI6.degrees),
    rotateY: (0, $dBAI6.degrees),
    rotateZ: (0, $dBAI6.degrees),
    scale: $2NSBK.scale,
    scaleX: (0, $2NSBK.scale),
    scaleY: (0, $2NSBK.scale),
    scaleZ: (0, $2NSBK.scale),
    skew: (0, $dBAI6.degrees),
    skewX: (0, $dBAI6.degrees),
    skewY: (0, $dBAI6.degrees),
    distance: (0, $dBAI6.px),
    translateX: (0, $dBAI6.px),
    translateY: (0, $dBAI6.px),
    translateZ: (0, $dBAI6.px),
    x: (0, $dBAI6.px),
    y: (0, $dBAI6.px),
    z: (0, $dBAI6.px),
    perspective: (0, $dBAI6.px),
    transformPerspective: (0, $dBAI6.px),
    opacity: (0, $2NSBK.alpha),
    originX: (0, $dBAI6.progressPercentage),
    originY: (0, $dBAI6.progressPercentage),
    originZ: (0, $dBAI6.px),
    // Misc
    zIndex: (0, $7JjKg.int),
    backgroundPositionX: (0, $dBAI6.px),
    backgroundPositionY: (0, $dBAI6.px),
    // SVG
    fillOpacity: (0, $2NSBK.alpha),
    strokeOpacity: (0, $2NSBK.alpha),
    numOctaves: (0, $7JjKg.int)
};

});
parcelRegister("7JjKg", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $d16ea4f0603eeb66$export$7d260a2a5f8bc19e; });

var $2NSBK = parcelRequire("2NSBK");
const $d16ea4f0603eeb66$export$7d260a2a5f8bc19e = {
    ...(0, $2NSBK.number),
    transform: Math.round
};

});






parcelRegister("6nEp5", function(module, exports) {

$parcel$export(module.exports, "memo", function () { return $14eb16b16cce0ebe$export$7c73462e0d25e514; });
function $14eb16b16cce0ebe$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}

});

parcelRegister("e8lTn", function(module, exports) {

$parcel$export(module.exports, "BaseAnimation", function () { return $ed332976403bd896$export$d1e4f34b9c2550c1; });

var $32TFF = parcelRequire("32TFF");

var $ejZQ0 = parcelRequire("ejZQ0");

var $dH7kw = parcelRequire("dH7kw");

var $eogZo = parcelRequire("eogZo");
class $ed332976403bd896$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $32TFF.flushKeyframeResolvers)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $dH7kw.canAnimate)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $ejZQ0.instantAnimationState).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $eogZo.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}

});
parcelRegister("dH7kw", function(module, exports) {

$parcel$export(module.exports, "canAnimate", function () { return $1f73039afafc0199$export$1b109e6c9968df4f; });

var $59uSO = parcelRequire("59uSO");

var $hb2Hz = parcelRequire("hb2Hz");
function $1f73039afafc0199$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $1f73039afafc0199$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $hb2Hz.isAnimatable)(originKeyframe, name);
    const isTargetAnimatable = (0, $hb2Hz.isAnimatable)(targetKeyframe, name);
    (0, $59uSO.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $1f73039afafc0199$var$hasKeyframesChanged(keyframes) || type === "spring" && velocity;
}

});
parcelRegister("hb2Hz", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $ad3409c8def06c51$export$65676b58b122bc38; });

var $l1Pxi = parcelRequire("l1Pxi");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $ad3409c8def06c51$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $l1Pxi.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});



parcelRegister("9Crwj", function(module, exports) {

$parcel$export(module.exports, "MainThreadAnimation", function () { return $bdbd2d344da3cfef$export$fd98d9cca67a58bc; });

var $32TFF = parcelRequire("32TFF");

var $3eXog = parcelRequire("3eXog");

var $9YyRs = parcelRequire("9YyRs");

var $8bCFz = parcelRequire("8bCFz");

var $e8lTn = parcelRequire("e8lTn");

var $6CPM0 = parcelRequire("6CPM0");

var $9j4oR = parcelRequire("9j4oR");

var $aQizw = parcelRequire("aQizw");

var $5X3GB = parcelRequire("5X3GB");

var $c0yRa = parcelRequire("c0yRa");


var $9EfgD = parcelRequire("9EfgD");

var $eogZo = parcelRequire("eogZo");
const $bdbd2d344da3cfef$var$generators = {
    decay: (0, $9YyRs.inertia),
    inertia: $9YyRs.inertia,
    tween: (0, $8bCFz.keyframes),
    keyframes: (0, $8bCFz.keyframes),
    spring: $3eXog.spring
};
const $bdbd2d344da3cfef$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $bdbd2d344da3cfef$export$fd98d9cca67a58bc extends (0, $e8lTn.BaseAnimation) {
    constructor({ KeyframeResolver: KeyframeResolver$1 = (0, $32TFF.KeyframeResolver), ...options }){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, keyframes: keyframes } = this.options;
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        if (name && motionValue && motionValue.owner) this.resolver = motionValue.owner.resolveKeyframes(keyframes, onResolved, name, motionValue);
        else this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = $bdbd2d344da3cfef$var$generators[type] || (0, $8bCFz.keyframes);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $8bCFz.keyframes) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $6CPM0.pipe)($bdbd2d344da3cfef$var$percentToProgress, (0, $9j4oR.mix)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $aQizw.calcGeneratorDuration)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $c0yRa.clamp)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $eogZo.getFinalKeyframe)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $5X3GB.millisecondsToSeconds)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $5X3GB.millisecondsToSeconds)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $5X3GB.secondsToMilliseconds)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $5X3GB.millisecondsToSeconds)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $9EfgD.frameloopDriver), onPlay: onPlay } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime || this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $bdbd2d344da3cfef$export$ee9b76de7353d815(options) {
    return new $bdbd2d344da3cfef$export$fd98d9cca67a58bc(options);
}

});
parcelRegister("3eXog", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $9c2b8560de502fe4$export$b36281d89752ae66; });

var $5X3GB = parcelRequire("5X3GB");

var $llhMa = parcelRequire("llhMa");

var $jT6Fp = parcelRequire("jT6Fp");
const $9c2b8560de502fe4$var$durationKeys = [
    "duration",
    "bounce"
];
const $9c2b8560de502fe4$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $9c2b8560de502fe4$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $9c2b8560de502fe4$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$9c2b8560de502fe4$var$isSpringType(options, $9c2b8560de502fe4$var$physicsKeys) && $9c2b8560de502fe4$var$isSpringType(options, $9c2b8560de502fe4$var$durationKeys)) {
        const derived = (0, $jT6Fp.findSpring)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $9c2b8560de502fe4$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $9c2b8560de502fe4$var$getSpringOptions({
        ...options,
        velocity: -(0, $5X3GB.millisecondsToSeconds)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $5X3GB.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $jT6Fp.calcAngularFreq)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $llhMa.calcGeneratorVelocity)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}

});
parcelRegister("llhMa", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorVelocity", function () { return $0ea446648b330676$export$854187271d233eb5; });

var $5J1E9 = parcelRequire("5J1E9");
const $0ea446648b330676$var$velocitySampleDuration = 5; // ms
function $0ea446648b330676$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $0ea446648b330676$var$velocitySampleDuration, 0);
    return (0, $5J1E9.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

});
parcelRegister("5J1E9", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $802cd06bac70029a$export$eab0632f7ad4f9d7; });
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $802cd06bac70029a$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});


parcelRegister("jT6Fp", function(module, exports) {

$parcel$export(module.exports, "findSpring", function () { return $13cfb88998c1052a$export$b15f158dc6d6f458; });
$parcel$export(module.exports, "calcAngularFreq", function () { return $13cfb88998c1052a$export$5f679887c3a78b15; });

var $59uSO = parcelRequire("59uSO");

var $c0yRa = parcelRequire("c0yRa");

var $5X3GB = parcelRequire("5X3GB");
const $13cfb88998c1052a$var$safeMin = 0.001;
const $13cfb88998c1052a$export$a3cdb76e84ee608e = 0.01;
const $13cfb88998c1052a$export$1824b851fad8862b = 10.0;
const $13cfb88998c1052a$export$ff08f2d53484465 = 0.05;
const $13cfb88998c1052a$export$201ca48e54038115 = 1;
function $13cfb88998c1052a$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $59uSO.warning)(duration <= (0, $5X3GB.secondsToMilliseconds)($13cfb88998c1052a$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $c0yRa.clamp)($13cfb88998c1052a$export$ff08f2d53484465, $13cfb88998c1052a$export$201ca48e54038115, dampingRatio);
    duration = (0, $c0yRa.clamp)($13cfb88998c1052a$export$a3cdb76e84ee608e, $13cfb88998c1052a$export$1824b851fad8862b, (0, $5X3GB.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $13cfb88998c1052a$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $13cfb88998c1052a$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $13cfb88998c1052a$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $13cfb88998c1052a$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$13cfb88998c1052a$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $13cfb88998c1052a$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $5X3GB.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $13cfb88998c1052a$var$rootIterations = 12;
function $13cfb88998c1052a$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $13cfb88998c1052a$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $13cfb88998c1052a$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});


parcelRegister("9YyRs", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $385208c905445c33$export$ee3ff3a17106998; });

var $3eXog = parcelRequire("3eXog");

var $llhMa = parcelRequire("llhMa");
function $385208c905445c33$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $3eXog.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $llhMa.calcGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

});

parcelRegister("8bCFz", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $a21436596a4cb4a3$export$d25ddfdf17c3ad3e; });

var $gRz0A = parcelRequire("gRz0A");

var $f0vpb = parcelRequire("f0vpb");

var $19gJf = parcelRequire("19gJf");

var $1jFny = parcelRequire("1jFny");

var $28YXT = parcelRequire("28YXT");

var $jUQt8 = parcelRequire("jUQt8");
function $a21436596a4cb4a3$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $gRz0A.easeInOut)).splice(0, values.length - 1);
}
function $a21436596a4cb4a3$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $f0vpb.isEasingArray)(ease) ? ease.map((0, $19gJf.easingDefinitionToFunction)) : (0, $19gJf.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $jUQt8.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $28YXT.defaultOffset)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $1jFny.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $a21436596a4cb4a3$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

});
parcelRegister("gRz0A", function(module, exports) {

$parcel$export(module.exports, "easeIn", function () { return $c8b74045bf313d3a$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $c8b74045bf313d3a$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $c8b74045bf313d3a$export$c07234257a03d5e9; });

var $ez5d2 = parcelRequire("ez5d2");
const $c8b74045bf313d3a$export$929e5a82286172a6 = (0, $ez5d2.cubicBezier)(0.42, 0, 1, 1);
const $c8b74045bf313d3a$export$57636bb43b1ccbb0 = (0, $ez5d2.cubicBezier)(0, 0, 0.58, 1);
const $c8b74045bf313d3a$export$c07234257a03d5e9 = (0, $ez5d2.cubicBezier)(0.42, 0, 0.58, 1);

});
parcelRegister("ez5d2", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $3737dbfe96debfa1$export$2c575fa1d20488bd; });

var $jbcYW = parcelRequire("jbcYW");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $3737dbfe96debfa1$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $3737dbfe96debfa1$var$subdivisionPrecision = 0.0000001;
const $3737dbfe96debfa1$var$subdivisionMaxIterations = 12;
function $3737dbfe96debfa1$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $3737dbfe96debfa1$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $3737dbfe96debfa1$var$subdivisionPrecision && ++i < $3737dbfe96debfa1$var$subdivisionMaxIterations);
    return currentT;
}
function $3737dbfe96debfa1$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $jbcYW.noop;
    const getTForX = (aX)=>$3737dbfe96debfa1$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $3737dbfe96debfa1$var$calcBezier(getTForX(t), mY1, mY2);
}

});


parcelRegister("f0vpb", function(module, exports) {

$parcel$export(module.exports, "isEasingArray", function () { return $aeb97d5b77acc966$export$216948827bbdc797; });
const $aeb97d5b77acc966$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});

parcelRegister("19gJf", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $88c8bfe8b7e57b27$export$ef97fe084f156ca4; });

var $59uSO = parcelRequire("59uSO");

var $ez5d2 = parcelRequire("ez5d2");

var $jbcYW = parcelRequire("jbcYW");

var $gRz0A = parcelRequire("gRz0A");

var $8twtr = parcelRequire("8twtr");

var $clRJt = parcelRequire("clRJt");

var $gzgPz = parcelRequire("gzgPz");
const $88c8bfe8b7e57b27$var$easingLookup = {
    linear: (0, $jbcYW.noop),
    easeIn: $gRz0A.easeIn,
    easeInOut: $gRz0A.easeInOut,
    easeOut: $gRz0A.easeOut,
    circIn: $8twtr.circIn,
    circInOut: $8twtr.circInOut,
    circOut: $8twtr.circOut,
    backIn: $clRJt.backIn,
    backInOut: $clRJt.backInOut,
    backOut: $clRJt.backOut,
    anticipate: $gzgPz.anticipate
};
const $88c8bfe8b7e57b27$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $59uSO.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $ez5d2.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $59uSO.invariant)($88c8bfe8b7e57b27$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $88c8bfe8b7e57b27$var$easingLookup[definition];
    }
    return definition;
};

});
parcelRegister("8twtr", function(module, exports) {

$parcel$export(module.exports, "circIn", function () { return $2c3e49d3e54725d4$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $2c3e49d3e54725d4$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $2c3e49d3e54725d4$export$30d3455eee55bed5; });

var $7AS9c = parcelRequire("7AS9c");

var $b1iQw = parcelRequire("b1iQw");
const $2c3e49d3e54725d4$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $2c3e49d3e54725d4$export$c8d67a19199d1a50 = (0, $b1iQw.reverseEasing)($2c3e49d3e54725d4$export$e444123e42d03385);
const $2c3e49d3e54725d4$export$30d3455eee55bed5 = (0, $7AS9c.mirrorEasing)($2c3e49d3e54725d4$export$e444123e42d03385);

});
parcelRegister("7AS9c", function(module, exports) {

$parcel$export(module.exports, "mirrorEasing", function () { return $491548cdece44f33$export$f946554fb8aeaf0d; });
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $491548cdece44f33$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

});

parcelRegister("b1iQw", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $5a530d260e29c865$export$2c07eeff45156d4d; });
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $5a530d260e29c865$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);

});


parcelRegister("clRJt", function(module, exports) {

$parcel$export(module.exports, "backOut", function () { return $d8f936f95fb21cba$export$77edfce482316a60; });
$parcel$export(module.exports, "backIn", function () { return $d8f936f95fb21cba$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backInOut", function () { return $d8f936f95fb21cba$export$ddc5fd596f6c71b2; });

var $ez5d2 = parcelRequire("ez5d2");

var $7AS9c = parcelRequire("7AS9c");

var $b1iQw = parcelRequire("b1iQw");
const $d8f936f95fb21cba$export$77edfce482316a60 = (0, $ez5d2.cubicBezier)(0.33, 1.53, 0.69, 0.99);
const $d8f936f95fb21cba$export$b01116c84cdfe1a2 = (0, $b1iQw.reverseEasing)($d8f936f95fb21cba$export$77edfce482316a60);
const $d8f936f95fb21cba$export$ddc5fd596f6c71b2 = (0, $7AS9c.mirrorEasing)($d8f936f95fb21cba$export$b01116c84cdfe1a2);

});

parcelRegister("gzgPz", function(module, exports) {

$parcel$export(module.exports, "anticipate", function () { return $e12b7a3993b78d59$export$6b0af63b873d419e; });

var $clRJt = parcelRequire("clRJt");
const $e12b7a3993b78d59$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $clRJt.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

});


parcelRegister("1jFny", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $7a8f7810cf7f62f1$export$89e29e4ab65e70a9; });

var $59uSO = parcelRequire("59uSO");

var $c0yRa = parcelRequire("c0yRa");

var $6CPM0 = parcelRequire("6CPM0");

var $amie4 = parcelRequire("amie4");

var $jbcYW = parcelRequire("jbcYW");

var $9j4oR = parcelRequire("9j4oR");
function $7a8f7810cf7f62f1$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $9j4oR.mix);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $jbcYW.noop) : ease;
            mixer = (0, $6CPM0.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $7a8f7810cf7f62f1$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $59uSO.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $7a8f7810cf7f62f1$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $amie4.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $c0yRa.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

});
parcelRegister("6CPM0", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $3e3ea55737c24d5c$export$a4627e546088548d; });
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $3e3ea55737c24d5c$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $3e3ea55737c24d5c$export$a4627e546088548d = (...transformers)=>transformers.reduce($3e3ea55737c24d5c$var$combineFunctions);

});

parcelRegister("amie4", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $98fa8bab6764d451$export$504d7abb21fa8c9; });
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $98fa8bab6764d451$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});

parcelRegister("9j4oR", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $db0fe8fe6e0bf583$export$2c9e8a9632a706b2; });

var $jWGTz = parcelRequire("jWGTz");

var $NwvLi = parcelRequire("NwvLi");
function $db0fe8fe6e0bf583$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $NwvLi.mixNumber)(from, to, p);
    const mixer = (0, $jWGTz.getMixer)(from);
    return mixer(from, to);
}

});
parcelRegister("jWGTz", function(module, exports) {

$parcel$export(module.exports, "getMixer", function () { return $c4df8059f4d4f707$export$36ec24672cd098e0; });

var $NwvLi = parcelRequire("NwvLi");

var $3OscK = parcelRequire("3OscK");

var $6CPM0 = parcelRequire("6CPM0");

var $59uSO = parcelRequire("59uSO");

var $3zHZ7 = parcelRequire("3zHZ7");

var $l1Pxi = parcelRequire("l1Pxi");

var $8wvQl = parcelRequire("8wvQl");

var $a2gT1 = parcelRequire("a2gT1");

var $cdtXA = parcelRequire("cdtXA");
function $c4df8059f4d4f707$var$mixNumber(a, b) {
    return (p)=>(0, $NwvLi.mixNumber)(a, b, p);
}
function $c4df8059f4d4f707$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $c4df8059f4d4f707$var$mixNumber;
    else if (typeof a === "string") return (0, $8wvQl.isCSSVariableToken)(a) ? (0, $cdtXA.mixImmediate) : (0, $3zHZ7.color).test(a) ? (0, $3OscK.mixColor) : $c4df8059f4d4f707$export$65516310a87d8205;
    else if (Array.isArray(a)) return $c4df8059f4d4f707$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $3zHZ7.color).test(a) ? (0, $3OscK.mixColor) : $c4df8059f4d4f707$export$ebc23b6840c51ba1;
    return 0, $cdtXA.mixImmediate;
}
function $c4df8059f4d4f707$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$c4df8059f4d4f707$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $c4df8059f4d4f707$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $c4df8059f4d4f707$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $c4df8059f4d4f707$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $c4df8059f4d4f707$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $l1Pxi.complex).createTransformer(target);
    const originStats = (0, $l1Pxi.analyseComplexValue)(origin);
    const targetStats = (0, $l1Pxi.analyseComplexValue)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $a2gT1.invisibleValues).has(origin) && !targetStats.values.length || (0, $a2gT1.invisibleValues).has(target) && !originStats.values.length) return (0, $a2gT1.mixVisibility)(origin, target);
        return (0, $6CPM0.pipe)($c4df8059f4d4f707$export$3bbefa2f402845c4($c4df8059f4d4f707$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $59uSO.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $cdtXA.mixImmediate)(origin, target);
    }
};

});
parcelRegister("NwvLi", function(module, exports) {

$parcel$export(module.exports, "mixNumber", function () { return $588ba3a890ebeea1$export$3bb0b4ff1037b8dd; });
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $588ba3a890ebeea1$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};

});

parcelRegister("3OscK", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $01245b4a979f486f$export$51e568cf5c039bac; });

var $NwvLi = parcelRequire("NwvLi");

var $59uSO = parcelRequire("59uSO");

var $1yVct = parcelRequire("1yVct");

var $8QUi5 = parcelRequire("8QUi5");

var $iq4zk = parcelRequire("iq4zk");

var $NqKlm = parcelRequire("NqKlm");

var $cdtXA = parcelRequire("cdtXA");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $01245b4a979f486f$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $01245b4a979f486f$var$colorTypes = [
    (0, $8QUi5.hex),
    (0, $iq4zk.rgba),
    (0, $NqKlm.hsla)
];
const $01245b4a979f486f$var$getColorType = (v)=>$01245b4a979f486f$var$colorTypes.find((type)=>type.test(v));
function $01245b4a979f486f$var$asRGBA(color) {
    const type = $01245b4a979f486f$var$getColorType(color);
    (0, $59uSO.warning)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $NqKlm.hsla)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $1yVct.hslaToRgba)(model);
    return model;
}
const $01245b4a979f486f$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $01245b4a979f486f$var$asRGBA(from);
    const toRGBA = $01245b4a979f486f$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $cdtXA.mixImmediate)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $01245b4a979f486f$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $01245b4a979f486f$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $01245b4a979f486f$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $NwvLi.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $iq4zk.rgba).transform(blended);
    };
};

});
parcelRegister("1yVct", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", function () { return $f2fd9537b9736456$export$6ae64dbcd6bfc33e; });
// Adapted from https://gist.github.com/mjackson/5311256
function $f2fd9537b9736456$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $f2fd9537b9736456$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $f2fd9537b9736456$var$hueToRgb(p, q, hue + 1 / 3);
        green = $f2fd9537b9736456$var$hueToRgb(p, q, hue);
        blue = $f2fd9537b9736456$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});

parcelRegister("cdtXA", function(module, exports) {

$parcel$export(module.exports, "mixImmediate", function () { return $84d949ffc7ebc4e9$export$a6f92d4bae65c0f1; });
function $84d949ffc7ebc4e9$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}

});


parcelRegister("a2gT1", function(module, exports) {

$parcel$export(module.exports, "invisibleValues", function () { return $ec496a39a81ed2a5$export$e5a55ae567dd4ac7; });
$parcel$export(module.exports, "mixVisibility", function () { return $ec496a39a81ed2a5$export$fed62ccc3fb1a568; });
const $ec496a39a81ed2a5$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $ec496a39a81ed2a5$export$fed62ccc3fb1a568(origin, target) {
    if ($ec496a39a81ed2a5$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}

});




parcelRegister("28YXT", function(module, exports) {

$parcel$export(module.exports, "defaultOffset", function () { return $514a1d36e18c8614$export$24dbcec0b26e6d9d; });

var $ig71U = parcelRequire("ig71U");
function $514a1d36e18c8614$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $ig71U.fillOffset)(offset, arr.length - 1);
    return offset;
}

});
parcelRegister("ig71U", function(module, exports) {

$parcel$export(module.exports, "fillOffset", function () { return $c3be58b89be3196b$export$dafee61230cf05c6; });

var $NwvLi = parcelRequire("NwvLi");

var $amie4 = parcelRequire("amie4");
function $c3be58b89be3196b$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $amie4.progress)(0, remaining, i);
        offset.push((0, $NwvLi.mixNumber)(min, 1, offsetProgress));
    }
}

});


parcelRegister("jUQt8", function(module, exports) {

$parcel$export(module.exports, "convertOffsetToTimes", function () { return $14aaf33a81a363c0$export$2a91b4e3a4539316; });
function $14aaf33a81a363c0$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}

});


parcelRegister("aQizw", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorDuration", function () { return $2c9655bdaefca666$export$cbdd6b3d40ea54e2; });
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $2c9655bdaefca666$export$f4ff70a5b4808fd8 = 20000;
function $2c9655bdaefca666$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $2c9655bdaefca666$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $2c9655bdaefca666$export$f4ff70a5b4808fd8 ? Infinity : duration;
}

});

parcelRegister("9EfgD", function(module, exports) {

$parcel$export(module.exports, "frameloopDriver", function () { return $f493cd23202dddb3$export$c1033964b5ad7fef; });

var $d04GL = parcelRequire("d04GL");

var $h9ps1 = parcelRequire("h9ps1");
const $f493cd23202dddb3$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $h9ps1.frame).update(passTimestamp, true),
        stop: ()=>(0, $h9ps1.cancelFrame)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $h9ps1.frameData).isProcessing ? (0, $h9ps1.frameData).timestamp : (0, $d04GL.time).now()
    };
};

});


parcelRegister("1k7uw", function(module, exports) {

$parcel$export(module.exports, "animateStyle", function () { return $0717cb5fef3b9569$export$c76cd972d26986f9; });

var $kca8O = parcelRequire("kca8O");
function $0717cb5fef3b9569$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $kca8O.mapEasingToNativeEasing)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}

});
parcelRegister("kca8O", function(module, exports) {

$parcel$export(module.exports, "isWaapiSupportedEasing", function () { return $d454d8d346a47741$export$fcdd8f3f2160beda; });
$parcel$export(module.exports, "mapEasingToNativeEasing", function () { return $d454d8d346a47741$export$916ea73bcd3a6030; });

var $fUqOj = parcelRequire("fUqOj");
function $d454d8d346a47741$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && easing in $d454d8d346a47741$export$2cf569f5e2221176 || (0, $fUqOj.isBezierDefinition)(easing) || Array.isArray(easing) && easing.every($d454d8d346a47741$export$fcdd8f3f2160beda));
}
const $d454d8d346a47741$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $d454d8d346a47741$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $d454d8d346a47741$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $d454d8d346a47741$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $d454d8d346a47741$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $d454d8d346a47741$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $d454d8d346a47741$var$mapEasingToNativeEasingWithDefault(easing) {
    return $d454d8d346a47741$export$916ea73bcd3a6030(easing) || $d454d8d346a47741$export$2cf569f5e2221176.easeOut;
}
function $d454d8d346a47741$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    else if ((0, $fUqOj.isBezierDefinition)(easing)) return $d454d8d346a47741$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map($d454d8d346a47741$var$mapEasingToNativeEasingWithDefault);
    else return $d454d8d346a47741$export$2cf569f5e2221176[easing];
}

});
parcelRegister("fUqOj", function(module, exports) {

$parcel$export(module.exports, "isBezierDefinition", function () { return $775b0dd2cff56849$export$ff43f99925d7366b; });
const $775b0dd2cff56849$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";

});




parcelRegister("f91Jp", function(module, exports) {

$parcel$export(module.exports, "GroupPlaybackControls", function () { return $3abee9a5ece0b64c$export$c1e41718f71efe41; });

var $8t6B1 = parcelRequire("8t6B1");

var $dzRX6 = parcelRequire("dzRX6");
class $3abee9a5ece0b64c$export$c1e41718f71efe41 {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const cancelAll = this.animations.map((animation)=>{
            if ((0, $dzRX6.supportsScrollTimeline)() && animation.attachTimeline) animation.attachTimeline(timeline);
            else {
                animation.pause();
                return (0, $8t6B1.observeTimeline)((progress)=>{
                    animation.time = animation.duration * progress;
                }, timeline);
            }
        });
        return ()=>{
            cancelAll.forEach((cancelTimeline, i)=>{
                if (cancelTimeline) cancelTimeline();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}

});
parcelRegister("8t6B1", function(module, exports) {

$parcel$export(module.exports, "observeTimeline", function () { return $327b272f50abb932$export$b4f1bbab0c442a76; });

var $h9ps1 = parcelRequire("h9ps1");
function $327b272f50abb932$export$b4f1bbab0c442a76(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime: currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $h9ps1.frame).update(onFrame, true);
    return ()=>(0, $h9ps1.cancelFrame)(onFrame);
}

});

parcelRegister("dzRX6", function(module, exports) {

$parcel$export(module.exports, "supportsScrollTimeline", function () { return $86e86c2597ba3556$export$20d68f04f30763a5; });

var $6nEp5 = parcelRequire("6nEp5");
const $86e86c2597ba3556$export$20d68f04f30763a5 = (0, $6nEp5.memo)(()=>window.ScrollTimeline !== undefined);

});



parcelRegister("7xpSg", function(module, exports) {

$parcel$export(module.exports, "isWillChangeMotionValue", function () { return $78c97899e24aca1c$export$98397f3adbf6259f; });

var $erBmB = parcelRequire("erBmB");
function $78c97899e24aca1c$export$98397f3adbf6259f(value) {
    return Boolean((0, $erBmB.isMotionValue)(value) && value.add);
}

});
parcelRegister("erBmB", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $65e8d3d378a9947e$export$605d60a2578142d3; });
const $65e8d3d378a9947e$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);

});


parcelRegister("drLSE", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $e4befcaa41a4f540$export$1f61c53461aff4a5; });

var $7fJT7 = parcelRequire("7fJT7");

var $kbEqR = parcelRequire("kbEqR");

var $9UsrA = parcelRequire("9UsrA");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $e4befcaa41a4f540$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $kbEqR.motionValue)(value));
}
function $e4befcaa41a4f540$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $9UsrA.resolveVariant)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $7fJT7.resolveFinalValueInKeyframes)(target[key]);
        $e4befcaa41a4f540$var$setMotionValue(visualElement, key, value);
    }
}

});
parcelRegister("7fJT7", function(module, exports) {

$parcel$export(module.exports, "isCustomValue", function () { return $0d15acf980467e42$export$2f308ad9864b3ac9; });
$parcel$export(module.exports, "resolveFinalValueInKeyframes", function () { return $0d15acf980467e42$export$5485128c47bd48bb; });

var $2VWpM = parcelRequire("2VWpM");
const $0d15acf980467e42$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $0d15acf980467e42$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $2VWpM.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

});

parcelRegister("kbEqR", function(module, exports) {

$parcel$export(module.exports, "MotionValue", function () { return $4b2846f88af5423d$export$8cea36d14ee64562; });
$parcel$export(module.exports, "motionValue", function () { return $4b2846f88af5423d$export$ce8bdc721e76545f; });

var $dhBB2 = parcelRequire("dhBB2");

var $5J1E9 = parcelRequire("5J1E9");


var $d04GL = parcelRequire("d04GL");

var $h9ps1 = parcelRequire("h9ps1");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $4b2846f88af5423d$var$MAX_VELOCITY_DELTA = 30;
const $4b2846f88af5423d$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $4b2846f88af5423d$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $4b2846f88af5423d$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.2.10";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $d04GL.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $d04GL.time).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $4b2846f88af5423d$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $dhBB2.SubscriptionManager)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $h9ps1.frame).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($4b2846f88af5423d$export$67fcd818a264039d.current) $4b2846f88af5423d$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $d04GL.time).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $4b2846f88af5423d$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $4b2846f88af5423d$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $5J1E9.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $4b2846f88af5423d$export$ce8bdc721e76545f(init, options) {
    return new $4b2846f88af5423d$export$8cea36d14ee64562(init, options);
}

});
parcelRegister("dhBB2", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $97358bb0f01597b3$export$e7dff9482a5fd23c; });

var $cHqJ9 = parcelRequire("cHqJ9");
class $97358bb0f01597b3$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $cHqJ9.addUniqueItem)(this.subscriptions, handler);
        return ()=>(0, $cHqJ9.removeItem)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

});
parcelRegister("cHqJ9", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $d2a9bfd104bd5453$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $d2a9bfd104bd5453$export$fe2d9b4e03920b4c; });
function $d2a9bfd104bd5453$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $d2a9bfd104bd5453$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $d2a9bfd104bd5453$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});




parcelRegister("1j0VF", function(module, exports) {

$parcel$export(module.exports, "getOptimisedAppearId", function () { return $a2e0096f48bfe337$export$5f8d21e84d1d84fc; });

var $fTE3g = parcelRequire("fTE3g");
function $a2e0096f48bfe337$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.getProps()[0, $fTE3g.optimizedAppearDataAttribute];
}

});
parcelRegister("fTE3g", function(module, exports) {

$parcel$export(module.exports, "optimizedAppearDataAttribute", function () { return $99c2b47e65be39f1$export$8592e1c077c890a6; });

var $3V9D9 = parcelRequire("3V9D9");
const $99c2b47e65be39f1$export$ed7b8fa9dbf0105d = "framerAppearId";
const $99c2b47e65be39f1$export$8592e1c077c890a6 = "data-" + (0, $3V9D9.camelToDash)($99c2b47e65be39f1$export$ed7b8fa9dbf0105d);

});
parcelRegister("3V9D9", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $ccc055b4a72c1347$export$9fd24a634729c672; });
/**
 * Convert camelCase to dash-case properties.
 */ const $ccc055b4a72c1347$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();

});




parcelRegister("lSHJj", function(module, exports) {

$parcel$export(module.exports, "animateVariant", function () { return $f24a58bcb9fc172f$export$4709dc300705b2af; });

var $9UsrA = parcelRequire("9UsrA");

var $dTq8p = parcelRequire("dTq8p");
function $f24a58bcb9fc172f$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $9UsrA.resolveVariant)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $dTq8p.animateTarget)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $f24a58bcb9fc172f$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $f24a58bcb9fc172f$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($f24a58bcb9fc172f$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($f24a58bcb9fc172f$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $f24a58bcb9fc172f$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}

});



parcelRegister("6jdHd", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return $c280630d94a7df00$export$6e91cf7616333d5; });
class $c280630d94a7df00$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}

});


parcelRegister("i481Q", function(module, exports) {

$parcel$export(module.exports, "ExitAnimationFeature", function () { return $1d482825f4aa3400$export$4989d1eb6104cc6c; });

var $6jdHd = parcelRequire("6jdHd");
let $1d482825f4aa3400$var$id = 0;
class $1d482825f4aa3400$export$4989d1eb6104cc6c extends (0, $6jdHd.Feature) {
    constructor(){
        super(...arguments);
        this.id = $1d482825f4aa3400$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}

});


parcelRegister("9tKwF", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", function () { return $60b1baafc37a77f3$export$e5b72898e5a201f1; });

var $2HB5R = parcelRequire("2HB5R");

var $ipnFa = parcelRequire("ipnFa");

var $ivdNK = parcelRequire("ivdNK");

var $jd5rb = parcelRequire("jd5rb");
const $60b1baafc37a77f3$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $jd5rb.InViewFeature)
    },
    tap: {
        Feature: (0, $ivdNK.PressGesture)
    },
    focus: {
        Feature: (0, $ipnFa.FocusGesture)
    },
    hover: {
        Feature: (0, $2HB5R.HoverGesture)
    }
};

});
parcelRegister("2HB5R", function(module, exports) {

$parcel$export(module.exports, "HoverGesture", function () { return $4eb998171579f70f$export$93a81ea037eac456; });

var $24j4k = parcelRequire("24j4k");

var $6CPM0 = parcelRequire("6CPM0");

var $kXmYR = parcelRequire("kXmYR");

var $6jdHd = parcelRequire("6jdHd");

var $h9ps1 = parcelRequire("h9ps1");
function $4eb998171579f70f$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $kXmYR.isDragActive)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) (0, $h9ps1.frame).postRender(()=>callback(event, info));
    };
    return (0, $24j4k.addPointerEvent)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $4eb998171579f70f$export$93a81ea037eac456 extends (0, $6jdHd.Feature) {
    mount() {
        this.unmount = (0, $6CPM0.pipe)($4eb998171579f70f$var$addHoverEvent(this.node, true), $4eb998171579f70f$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}

});
parcelRegister("24j4k", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", function () { return $a3b5ca0718993d16$export$fcff2e64e6676b81; });

var $3tB5g = parcelRequire("3tB5g");

var $fpvCP = parcelRequire("fpvCP");
function $a3b5ca0718993d16$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $3tB5g.addDomEvent)(target, eventName, (0, $fpvCP.addPointerInfo)(handler), options);
}

});
parcelRegister("3tB5g", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", function () { return $a8c57a49f398792d$export$b1d829ddf82884aa; });
function $a8c57a49f398792d$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}

});

parcelRegister("fpvCP", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", function () { return $19290b72856733e8$export$12f84bb882d06e1a; });
$parcel$export(module.exports, "addPointerInfo", function () { return $19290b72856733e8$export$c404e80f92c98d29; });

var $jUrFq = parcelRequire("jUrFq");
function $19290b72856733e8$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $19290b72856733e8$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $jUrFq.isPrimaryPointer)(event) && handler(event, $19290b72856733e8$export$12f84bb882d06e1a(event));
};

});
parcelRegister("jUrFq", function(module, exports) {

$parcel$export(module.exports, "isPrimaryPointer", function () { return $5332f0d6324f3440$export$a4cf9c8a4b063a6e; });
const $5332f0d6324f3440$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

});



parcelRegister("kXmYR", function(module, exports) {

$parcel$export(module.exports, "isDragActive", function () { return $96522e0a3b96b9e4$export$1b3dd616664938e4; });
function $96522e0a3b96b9e4$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $96522e0a3b96b9e4$var$globalHorizontalLock = $96522e0a3b96b9e4$export$518c5fc2dcb7974b("dragHorizontal");
const $96522e0a3b96b9e4$var$globalVerticalLock = $96522e0a3b96b9e4$export$518c5fc2dcb7974b("dragVertical");
function $96522e0a3b96b9e4$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $96522e0a3b96b9e4$var$globalVerticalLock();
    else if (drag === "x") lock = $96522e0a3b96b9e4$var$globalHorizontalLock();
    else {
        const openHorizontal = $96522e0a3b96b9e4$var$globalHorizontalLock();
        const openVertical = $96522e0a3b96b9e4$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $96522e0a3b96b9e4$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $96522e0a3b96b9e4$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}

});


parcelRegister("ipnFa", function(module, exports) {

$parcel$export(module.exports, "FocusGesture", function () { return $f67fa3b39a62de2d$export$d4826db40d47595b; });

var $3tB5g = parcelRequire("3tB5g");

var $6jdHd = parcelRequire("6jdHd");

var $6CPM0 = parcelRequire("6CPM0");
class $f67fa3b39a62de2d$export$d4826db40d47595b extends (0, $6jdHd.Feature) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $6CPM0.pipe)((0, $3tB5g.addDomEvent)(this.node.current, "focus", ()=>this.onFocus()), (0, $3tB5g.addDomEvent)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}

});

parcelRegister("ivdNK", function(module, exports) {

$parcel$export(module.exports, "PressGesture", function () { return $b8443dc0347df040$export$f026abdbba7f0c9e; });

var $fpvCP = parcelRequire("fpvCP");

var $3tB5g = parcelRequire("3tB5g");

var $24j4k = parcelRequire("24j4k");

var $6jdHd = parcelRequire("6jdHd");

var $6CPM0 = parcelRequire("6CPM0");

var $kXmYR = parcelRequire("kXmYR");

var $aXiVV = parcelRequire("aXiVV");

var $jbcYW = parcelRequire("jbcYW");

var $h9ps1 = parcelRequire("h9ps1");
function $b8443dc0347df040$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $fpvCP.extractEventInfo)(syntheticPointerEvent));
}
class $b8443dc0347df040$export$f026abdbba7f0c9e extends (0, $6jdHd.Feature) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $jbcYW.noop);
        this.removeEndListeners = (0, $jbcYW.noop);
        this.removeAccessibleListeners = (0, $jbcYW.noop);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ const handler = !globalTapTarget && !(0, $aXiVV.isNodeOrChild)(this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $h9ps1.frame).update(()=>handler(endEvent, endInfo));
            };
            const removePointerUpListener = (0, $24j4k.addPointerEvent)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $24j4k.addPointerEvent)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $6CPM0.pipe)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $b8443dc0347df040$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $h9ps1.frame).postRender(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $3tB5g.addDomEvent)(this.node.current, "keyup", handleKeyup);
                $b8443dc0347df040$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $3tB5g.addDomEvent)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $b8443dc0347df040$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $3tB5g.addDomEvent)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $6CPM0.pipe)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $h9ps1.frame).postRender(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $kXmYR.isDragActive)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $h9ps1.frame).postRender(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $24j4k.addPointerEvent)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $3tB5g.addDomEvent)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $6CPM0.pipe)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}

});
parcelRegister("aXiVV", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", function () { return $67a7f133a245336d$export$e841ada32ff745b; });
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $67a7f133a245336d$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $67a7f133a245336d$export$e841ada32ff745b(parent, child.parentElement);
};

});


parcelRegister("jd5rb", function(module, exports) {

$parcel$export(module.exports, "InViewFeature", function () { return $da2908b1137e754a$export$150851c8cc2f0c72; });

var $6jdHd = parcelRequire("6jdHd");

var $eUuSA = parcelRequire("eUuSA");
const $da2908b1137e754a$var$thresholdNames = {
    some: 0,
    all: 1
};
class $da2908b1137e754a$export$150851c8cc2f0c72 extends (0, $6jdHd.Feature) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $da2908b1137e754a$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $eUuSA.observeIntersection)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($da2908b1137e754a$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $da2908b1137e754a$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}

});
parcelRegister("eUuSA", function(module, exports) {

$parcel$export(module.exports, "observeIntersection", function () { return $6e6be83e8d5cf4f5$export$b2bcd62fb7925aa5; });
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $6e6be83e8d5cf4f5$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $6e6be83e8d5cf4f5$var$observers = new WeakMap();
const $6e6be83e8d5cf4f5$var$fireObserverCallback = (entry)=>{
    const callback = $6e6be83e8d5cf4f5$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $6e6be83e8d5cf4f5$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($6e6be83e8d5cf4f5$var$fireObserverCallback);
};
function $6e6be83e8d5cf4f5$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$6e6be83e8d5cf4f5$var$observers.has(lookupRoot)) $6e6be83e8d5cf4f5$var$observers.set(lookupRoot, {});
    const rootObservers = $6e6be83e8d5cf4f5$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($6e6be83e8d5cf4f5$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $6e6be83e8d5cf4f5$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $6e6be83e8d5cf4f5$var$initIntersectionObserver(options);
    $6e6be83e8d5cf4f5$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $6e6be83e8d5cf4f5$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

});



parcelRegister("4DDuc", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", function () { return $38a6ac1b54bc169a$export$56ba0183203348f5; });

var $exYeM = parcelRequire("exYeM");

var $4xByy = parcelRequire("4xByy");

var $eqSIA = parcelRequire("eqSIA");

var $d51nF = parcelRequire("d51nF");
const $38a6ac1b54bc169a$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $d51nF.isSVGComponent)(Component) ? new (0, $eqSIA.SVGVisualElement)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $4xByy.HTMLVisualElement)(options, {
        allowProjection: Component !== (0, $exYeM.Fragment),
        enableHardwareAcceleration: true
    });
};

});
parcelRegister("4xByy", function(module, exports) {

$parcel$export(module.exports, "HTMLVisualElement", function () { return $b877597daa557132$export$23fea75b03ac16b3; });

var $cOKvu = parcelRequire("cOKvu");

var $8wvQl = parcelRequire("8wvQl");

var $aGhCP = parcelRequire("aGhCP");

var $caXcX = parcelRequire("caXcX");

var $ljCOa = parcelRequire("ljCOa");

var $5trun = parcelRequire("5trun");

var $lGvIj = parcelRequire("lGvIj");

var $Vc4D6 = parcelRequire("Vc4D6");

var $erBmB = parcelRequire("erBmB");
function $b877597daa557132$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $b877597daa557132$export$23fea75b03ac16b3 extends (0, $Vc4D6.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "html";
    }
    readValueFromInstance(instance, key) {
        if ((0, $aGhCP.transformProps).has(key)) {
            const defaultType = (0, $5trun.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $b877597daa557132$export$3735103072e4a80(instance);
            const value = ((0, $8wvQl.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $lGvIj.measureViewportBox)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $cOKvu.buildHTMLStyles)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $caXcX.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $erBmB.isMotionValue)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $ljCOa.renderHTML)(instance, renderState, styleProp, projection);
    }
}

});
parcelRegister("cOKvu", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $d5a7ccaf3657bbce$export$bb517f8b40f8e99d; });

var $d8qeu = parcelRequire("d8qeu");

var $8wvQl = parcelRequire("8wvQl");

var $aGhCP = parcelRequire("aGhCP");

var $czGna = parcelRequire("czGna");

var $fg9sn = parcelRequire("fg9sn");
function $d5a7ccaf3657bbce$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $8wvQl.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $fg9sn.numberValueTypes)[key];
        const valueAsType = (0, $czGna.getValueAsType)(value, valueType);
        if ((0, $aGhCP.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $d8qeu.buildTransform)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

});
parcelRegister("d8qeu", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $9384da345cfe955b$export$bdc96e0d5c8f914; });

var $aGhCP = parcelRequire("aGhCP");
const $9384da345cfe955b$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $9384da345cfe955b$var$numTransforms = (0, $aGhCP.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $9384da345cfe955b$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $9384da345cfe955b$var$numTransforms; i++){
        const key = (0, $aGhCP.transformPropOrder)[i];
        if (transform[key] !== undefined) {
            const transformName = $9384da345cfe955b$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}

});

parcelRegister("czGna", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $6a51529d989adf9c$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $6a51529d989adf9c$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};

});


parcelRegister("caXcX", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $e87aa36d3552d0b1$export$16da615486abaa45; });

var $bd0Li = parcelRequire("bd0Li");

var $erBmB = parcelRequire("erBmB");
function $e87aa36d3552d0b1$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $erBmB.isMotionValue)(style[key]) || prevProps.style && (0, $erBmB.isMotionValue)(prevProps.style[key]) || (0, $bd0Li.isForcedMotionValue)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}

});
parcelRegister("bd0Li", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $57cc9ca03e37ffaf$export$6d27ce8e3de1c3cf; });

var $8ysBn = parcelRequire("8ysBn");

var $aGhCP = parcelRequire("aGhCP");
function $57cc9ca03e37ffaf$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $aGhCP.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $8ysBn.scaleCorrectors)[key] || key === "opacity");
}

});
parcelRegister("8ysBn", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", function () { return $93099dc5c3aa7524$export$91ddd985b97788d1; });
const $93099dc5c3aa7524$export$91ddd985b97788d1 = {};
function $93099dc5c3aa7524$export$de9e7791c71225fd(correctors) {
    Object.assign($93099dc5c3aa7524$export$91ddd985b97788d1, correctors);
}

});



parcelRegister("ljCOa", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $4d3a9c3652fbcbe3$export$1a32bf6229c258c0; });
function $4d3a9c3652fbcbe3$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}

});

parcelRegister("lGvIj", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", function () { return $5df6dc38d07b7e46$export$d8718b6a7e5c624e; });

var $g60P5 = parcelRequire("g60P5");

var $5Ql3c = parcelRequire("5Ql3c");
function $5df6dc38d07b7e46$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $g60P5.convertBoundingBoxToBox)((0, $g60P5.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $5df6dc38d07b7e46$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $5df6dc38d07b7e46$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $5Ql3c.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, $5Ql3c.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

});
parcelRegister("g60P5", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", function () { return $51f4355a9b48a0fa$export$d3955c6a8f65a36b; });
$parcel$export(module.exports, "transformBoxPoints", function () { return $51f4355a9b48a0fa$export$21543fb75483a50; });
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $51f4355a9b48a0fa$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $51f4355a9b48a0fa$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $51f4355a9b48a0fa$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("5Ql3c", function(module, exports) {

$parcel$export(module.exports, "translateAxis", function () { return $3cadfa9c5538c02d$export$a807a5ce5ebb3895; });

var $NwvLi = parcelRequire("NwvLi");

var $bByPR = parcelRequire("bByPR");
/**
 * Scales a point based on a factor and an originPoint
 */ function $3cadfa9c5538c02d$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $3cadfa9c5538c02d$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $3cadfa9c5538c02d$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $3cadfa9c5538c02d$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $3cadfa9c5538c02d$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $3cadfa9c5538c02d$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $3cadfa9c5538c02d$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $3cadfa9c5538c02d$export$d80074982803af5c(box, { x: x, y: y }) {
    $3cadfa9c5538c02d$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $3cadfa9c5538c02d$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $3cadfa9c5538c02d$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $3cadfa9c5538c02d$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $3cadfa9c5538c02d$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $bByPR.hasTransform)(node.latestValues)) $3cadfa9c5538c02d$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $3cadfa9c5538c02d$var$snapToDefault(treeScale.x);
    treeScale.y = $3cadfa9c5538c02d$var$snapToDefault(treeScale.y);
}
function $3cadfa9c5538c02d$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $3cadfa9c5538c02d$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $3cadfa9c5538c02d$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $NwvLi.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $3cadfa9c5538c02d$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $3cadfa9c5538c02d$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $3cadfa9c5538c02d$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $3cadfa9c5538c02d$export$58b16271041fbfb(box, transform) {
    $3cadfa9c5538c02d$export$625f1dd140a2f5e7(box.x, transform, $3cadfa9c5538c02d$var$xKeys);
    $3cadfa9c5538c02d$export$625f1dd140a2f5e7(box.y, transform, $3cadfa9c5538c02d$var$yKeys);
}

});
parcelRegister("bByPR", function(module, exports) {

$parcel$export(module.exports, "hasTransform", function () { return $43492ab836cff22d$export$a545127cf1fbb600; });
function $43492ab836cff22d$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $43492ab836cff22d$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$43492ab836cff22d$var$isIdentityScale(scale) || !$43492ab836cff22d$var$isIdentityScale(scaleX) || !$43492ab836cff22d$var$isIdentityScale(scaleY);
}
function $43492ab836cff22d$export$a545127cf1fbb600(values) {
    return $43492ab836cff22d$export$bdf30dca883ea463(values) || $43492ab836cff22d$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $43492ab836cff22d$export$bf80f5f8f4dc327f(values) {
    return $43492ab836cff22d$var$is2DTranslate(values.x) || $43492ab836cff22d$var$is2DTranslate(values.y);
}
function $43492ab836cff22d$var$is2DTranslate(value) {
    return value && value !== "0%";
}

});



parcelRegister("Vc4D6", function(module, exports) {

$parcel$export(module.exports, "DOMVisualElement", function () { return $8825121c87528f05$export$e49735c2a366bdc7; });

var $llX7f = parcelRequire("llX7f");

var $gfclk = parcelRequire("gfclk");
class $8825121c87528f05$export$e49735c2a366bdc7 extends (0, $llX7f.VisualElement) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $gfclk.DOMKeyframesResolver);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
}

});
parcelRegister("llX7f", function(module, exports) {

$parcel$export(module.exports, "VisualElement", function () { return $47882417e3714d5d$export$fa8b653c0f3714e5; });


var $8KmSz = parcelRequire("8KmSz");

var $hTIyI = parcelRequire("hTIyI");

var $hbaAs = parcelRequire("hbaAs");

var $3bOMV = parcelRequire("3bOMV");

var $dhBB2 = parcelRequire("dhBB2");

var $kbEqR = parcelRequire("kbEqR");

var $7xpSg = parcelRequire("7xpSg");

var $erBmB = parcelRequire("erBmB");

var $aGhCP = parcelRequire("aGhCP");

var $lAfBY = parcelRequire("lAfBY");

var $jzTF8 = parcelRequire("jzTF8");

var $4VwAK = parcelRequire("4VwAK");

var $cuKdH = parcelRequire("cuKdH");


var $93CWN = parcelRequire("93CWN");

var $7NOUe = parcelRequire("7NOUe");

var $9yPQe = parcelRequire("9yPQe");

var $32TFF = parcelRequire("32TFF");

var $7uiB3 = parcelRequire("7uiB3");

var $1OeNz = parcelRequire("1OeNz");

var $5OGiL = parcelRequire("5OGiL");

var $l1Pxi = parcelRequire("l1Pxi");

var $4VPQH = parcelRequire("4VPQH");

var $h9ps1 = parcelRequire("h9ps1");
const $47882417e3714d5d$var$featureNames = Object.keys((0, $93CWN.featureDefinitions));
const $47882417e3714d5d$var$numFeatures = $47882417e3714d5d$var$featureNames.length;
const $47882417e3714d5d$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $47882417e3714d5d$var$numVariantProps = (0, $7NOUe.variantProps).length;
function $47882417e3714d5d$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $47882417e3714d5d$var$getClosestProjectingNode(visualElement.parent);
}
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $47882417e3714d5d$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        this.resolveKeyframes = (keyframes, // We use an onComplete callback here rather than a Promise as a Promise
        // resolution is a microtask and we want to retain the ability to force
        // the resolution of keyframes synchronously.
        onComplete, name, value)=>{
            return new this.KeyframeResolver(keyframes, onComplete, name, value, this);
        };
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $32TFF.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $h9ps1.frame).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $lAfBY.isControllingVariants)(props);
        this.isVariantNode = (0, $lAfBY.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $erBmB.isMotionValue)(value)) {
                value.set(latestValues[key], false);
                if ((0, $7xpSg.isWillChangeMotionValue)(willChange)) willChange.add(key);
            }
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $9yPQe.visualElementStore).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $3bOMV.hasReducedMotionListener).current) (0, $hbaAs.initPrefersReducedMotion)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $3bOMV.prefersReducedMotion).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        var _a;
        (0, $9yPQe.visualElementStore).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $h9ps1.cancelFrame)(this.notifyUpdate);
        (0, $h9ps1.cancelFrame)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)(_a = this.features[key]) === null || _a === void 0 || _a.unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $aGhCP.transformProps).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $h9ps1.frame).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $47882417e3714d5d$var$numFeatures; i++){
            const name = $47882417e3714d5d$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $93CWN.featureDefinitions)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection = new ProjectionNodeConstructor(this.latestValues, renderedProps["data-framer-portal-id"] ? undefined : $47882417e3714d5d$var$getClosestProjectingNode(this.parent));
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $hTIyI.isRefObject)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $8KmSz.createBox)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $47882417e3714d5d$var$propEventHandlers.length; i++){
            const key = $47882417e3714d5d$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $4VwAK.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $47882417e3714d5d$var$numVariantProps; i++){
            const name = (0, $7NOUe.variantProps)[i];
            const prop = this.props[name];
            if ((0, $jzTF8.isVariantLabel)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $kbEqR.motionValue)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $7uiB3.isNumericalString)(value) || (0, $1OeNz.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $5OGiL.findValueType)(value) && (0, $l1Pxi.complex).test(target)) value = (0, $4VPQH.getAnimatableNone)(key, target);
            this.setBaseTarget(key, (0, $erBmB.isMotionValue)(value) ? value.get() : value);
        }
        return (0, $erBmB.isMotionValue)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $cuKdH.resolveVariantFromProps)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $erBmB.isMotionValue)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $dhBB2.SubscriptionManager)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}

});
parcelRegister("8KmSz", function(module, exports) {

$parcel$export(module.exports, "createBox", function () { return $704cbd53c53f9d5c$export$6459fc9e86be362e; });
const $704cbd53c53f9d5c$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $704cbd53c53f9d5c$export$3d227df54007d73a = ()=>({
        x: $704cbd53c53f9d5c$export$ff25708b37f72782(),
        y: $704cbd53c53f9d5c$export$ff25708b37f72782()
    });
const $704cbd53c53f9d5c$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $704cbd53c53f9d5c$export$6459fc9e86be362e = ()=>({
        x: $704cbd53c53f9d5c$export$6db76765312617ac(),
        y: $704cbd53c53f9d5c$export$6db76765312617ac()
    });

});

parcelRegister("hTIyI", function(module, exports) {

$parcel$export(module.exports, "isRefObject", function () { return $7be42aa7b9b2349b$export$dedd81df7bc1307; });
function $7be42aa7b9b2349b$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});

parcelRegister("hbaAs", function(module, exports) {

$parcel$export(module.exports, "initPrefersReducedMotion", function () { return $aec9488d77744f8a$export$ca9f41fb23dded3d; });

var $giwOG = parcelRequire("giwOG");

var $3bOMV = parcelRequire("3bOMV");
function $aec9488d77744f8a$export$ca9f41fb23dded3d() {
    (0, $3bOMV.hasReducedMotionListener).current = true;
    if (!(0, $giwOG.isBrowser)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $3bOMV.prefersReducedMotion).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $3bOMV.prefersReducedMotion).current = false;
}

});
parcelRegister("3bOMV", function(module, exports) {

$parcel$export(module.exports, "prefersReducedMotion", function () { return $51b97d8ce853ec4e$export$ff7706047246b98b; });
$parcel$export(module.exports, "hasReducedMotionListener", function () { return $51b97d8ce853ec4e$export$6476d16e2fd2d0db; });
// Does this device prefer reduced motion? Returns `null` server-side.
const $51b97d8ce853ec4e$export$ff7706047246b98b = {
    current: null
};
const $51b97d8ce853ec4e$export$6476d16e2fd2d0db = {
    current: false
};

});


parcelRegister("lAfBY", function(module, exports) {

$parcel$export(module.exports, "isControllingVariants", function () { return $6d3c07e99f9f7e5a$export$4b3c3bd8d910d78d; });
$parcel$export(module.exports, "isVariantNode", function () { return $6d3c07e99f9f7e5a$export$ce46fa4165cdec40; });

var $45ATh = parcelRequire("45ATh");

var $jzTF8 = parcelRequire("jzTF8");

var $7NOUe = parcelRequire("7NOUe");
function $6d3c07e99f9f7e5a$export$4b3c3bd8d910d78d(props) {
    return (0, $45ATh.isAnimationControls)(props.animate) || (0, $7NOUe.variantProps).some((name)=>(0, $jzTF8.isVariantLabel)(props[name]));
}
function $6d3c07e99f9f7e5a$export$ce46fa4165cdec40(props) {
    return Boolean($6d3c07e99f9f7e5a$export$4b3c3bd8d910d78d(props) || props.variants);
}

});

parcelRegister("4VwAK", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $36e186eef14354e1$export$9a552858d5197f6e; });

var $7xpSg = parcelRequire("7xpSg");


var $kbEqR = parcelRequire("kbEqR");

var $erBmB = parcelRequire("erBmB");
function $36e186eef14354e1$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $erBmB.isMotionValue)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $7xpSg.isWillChangeMotionValue)(willChange)) willChange.add(key);
        } else if ((0, $erBmB.isMotionValue)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $kbEqR.motionValue)(nextValue, {
                owner: element
            }));
            if ((0, $7xpSg.isWillChangeMotionValue)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $kbEqR.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});

parcelRegister("93CWN", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", function () { return $f7fe4e10b799a8b2$export$65570e08d843624d; });
const $f7fe4e10b799a8b2$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $f7fe4e10b799a8b2$export$65570e08d843624d = {};
for(const key in $f7fe4e10b799a8b2$var$featureProps)$f7fe4e10b799a8b2$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$f7fe4e10b799a8b2$var$featureProps[key].some((name)=>!!props[name])
};

});

parcelRegister("9yPQe", function(module, exports) {

$parcel$export(module.exports, "visualElementStore", function () { return $2a8cc64b32f75635$export$bc2a978a17abfdde; });
const $2a8cc64b32f75635$export$bc2a978a17abfdde = new WeakMap();

});

parcelRegister("5OGiL", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $b271d9f56e72d485$export$950e7e59ea1ffed7; });

var $3zHZ7 = parcelRequire("3zHZ7");

var $l1Pxi = parcelRequire("l1Pxi");

var $1d5RG = parcelRequire("1d5RG");

var $fFX0a = parcelRequire("fFX0a");
/**
 * A list of all ValueTypes
 */ const $b271d9f56e72d485$var$valueTypes = [
    ...(0, $1d5RG.dimensionValueTypes),
    (0, $3zHZ7.color),
    (0, $l1Pxi.complex)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $b271d9f56e72d485$export$950e7e59ea1ffed7 = (v)=>$b271d9f56e72d485$var$valueTypes.find((0, $fFX0a.testValueType)(v));

});




parcelRegister("eqSIA", function(module, exports) {

$parcel$export(module.exports, "SVGVisualElement", function () { return $83f9c44d75db63b5$export$86bcdffbaf733d84; });

var $gG0hH = parcelRequire("gG0hH");

var $Vc4D6 = parcelRequire("Vc4D6");

var $4X2JK = parcelRequire("4X2JK");

var $3V9D9 = parcelRequire("3V9D9");

var $iABU5 = parcelRequire("iABU5");

var $aGhCP = parcelRequire("aGhCP");

var $3RbVp = parcelRequire("3RbVp");

var $5trun = parcelRequire("5trun");

var $8KmSz = parcelRequire("8KmSz");

var $5wAah = parcelRequire("5wAah");
class $83f9c44d75db63b5$export$86bcdffbaf733d84 extends (0, $Vc4D6.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $aGhCP.transformProps).has(key)) {
            const defaultType = (0, $5trun.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $iABU5.camelCaseAttributes).has(key) ? (0, $3V9D9.camelToDash)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $8KmSz.createBox)();
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $gG0hH.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, options, props) {
        (0, $4X2JK.buildSVGAttrs)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $3RbVp.renderSVG)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $5wAah.isSVGTag)(instance.tagName);
        super.mount(instance);
    }
}

});
parcelRegister("gG0hH", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $4c74588f3910fe04$export$16da615486abaa45; });

var $erBmB = parcelRequire("erBmB");

var $caXcX = parcelRequire("caXcX");

var $aGhCP = parcelRequire("aGhCP");
function $4c74588f3910fe04$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $caXcX.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(const key in props)if ((0, $erBmB.isMotionValue)(props[key]) || (0, $erBmB.isMotionValue)(prevProps[key])) {
        const targetKey = (0, $aGhCP.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});

parcelRegister("4X2JK", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $22afbc6679b4fb16$export$5475d24f125d7053; });

var $cOKvu = parcelRequire("cOKvu");

var $6Tkja = parcelRequire("6Tkja");

var $49mLE = parcelRequire("49mLE");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $22afbc6679b4fb16$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $cOKvu.buildHTMLStyles)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $6Tkja.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $49mLE.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("6Tkja", function(module, exports) {

$parcel$export(module.exports, "calcSVGTransformOrigin", function () { return $de9ca7d9f74b1dc4$export$d4fbcfc8e5472155; });

var $dBAI6 = parcelRequire("dBAI6");
function $de9ca7d9f74b1dc4$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $dBAI6.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $de9ca7d9f74b1dc4$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $de9ca7d9f74b1dc4$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $de9ca7d9f74b1dc4$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

});

parcelRegister("49mLE", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $ecef2446ddaf0120$export$311b43f666da1d82; });

var $dBAI6 = parcelRequire("dBAI6");
const $ecef2446ddaf0120$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $ecef2446ddaf0120$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $ecef2446ddaf0120$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $ecef2446ddaf0120$var$dashKeys : $ecef2446ddaf0120$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $dBAI6.px).transform(-offset);
    // Build the dash array
    const pathLength = (0, $dBAI6.px).transform(length);
    const pathSpacing = (0, $dBAI6.px).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

});


parcelRegister("iABU5", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $53f5831d8ff6fe26$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ const $53f5831d8ff6fe26$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

});

parcelRegister("3RbVp", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $6ecc69af052e005d$export$c5f8399d19a7394b; });

var $3V9D9 = parcelRequire("3V9D9");

var $ljCOa = parcelRequire("ljCOa");

var $iABU5 = parcelRequire("iABU5");
function $6ecc69af052e005d$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $ljCOa.renderHTML)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $iABU5.camelCaseAttributes).has(key) ? (0, $3V9D9.camelToDash)(key) : key, renderState.attrs[key]);
}

});

parcelRegister("5wAah", function(module, exports) {

$parcel$export(module.exports, "isSVGTag", function () { return $e49695f00398c04d$export$6328ce7565ea1049; });
const $e49695f00398c04d$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";

});


parcelRegister("d51nF", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", function () { return $9c5a7490b01b42fd$export$88f3fc2fd3766989; });

var $7tqQK = parcelRequire("7tqQK");
function $9c5a7490b01b42fd$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $7tqQK.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}

});
parcelRegister("7tqQK", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", function () { return $3382724af6d1489a$export$40209c4c512158e6; });
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $3382724af6d1489a$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

});




parcelRegister("b0UTF", function(module, exports) {

$parcel$export(module.exports, "LazyMotion", function () { return $d8cf2adaf6a4e6f2$export$23c340a7eb1b419; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $8zFLG = parcelRequire("8zFLG");

var $bhr1j = parcelRequire("bhr1j");
/**
 * Used in conjunction with the `m` component to reduce bundle size.
 *
 * `m` is a version of the `motion` component that only loads functionality
 * critical for the initial render.
 *
 * `LazyMotion` can then be used to either synchronously or asynchronously
 * load animation and gesture support.
 *
 * ```jsx
 * // Synchronous loading
 * import { LazyMotion, m, domAnimation } from "framer-motion"
 *
 * function App() {
 *   return (
 *     <LazyMotion features={domAnimation}>
 *       <m.div animate={{ scale: 2 }} />
 *     </LazyMotion>
 *   )
 * }
 *
 * // Asynchronous loading
 * import { LazyMotion, m } from "framer-motion"
 *
 * function App() {
 *   return (
 *     <LazyMotion features={() => import('./path/to/domAnimation')}>
 *       <m.div animate={{ scale: 2 }} />
 *     </LazyMotion>
 *   )
 * }
 * ```
 *
 * @public
 */ function $d8cf2adaf6a4e6f2$export$23c340a7eb1b419({ children: children, features: features, strict: strict = false }) {
    const [, setIsLoaded] = (0, $exYeM.useState)(!$d8cf2adaf6a4e6f2$var$isLazyBundle(features));
    const loadedRenderer = (0, $exYeM.useRef)(undefined);
    /**
     * If this is a synchronous load, load features immediately
     */ if (!$d8cf2adaf6a4e6f2$var$isLazyBundle(features)) {
        const { renderer: renderer, ...loadedFeatures } = features;
        loadedRenderer.current = renderer;
        (0, $bhr1j.loadFeatures)(loadedFeatures);
    }
    (0, $exYeM.useEffect)(()=>{
        if ($d8cf2adaf6a4e6f2$var$isLazyBundle(features)) features().then(({ renderer: renderer, ...loadedFeatures })=>{
            (0, $bhr1j.loadFeatures)(loadedFeatures);
            loadedRenderer.current = renderer;
            setIsLoaded(true);
        });
    }, []);
    return (0, $aSiaI.jsx)((0, $8zFLG.LazyContext).Provider, {
        value: {
            renderer: loadedRenderer.current,
            strict: strict
        },
        children: children
    });
}
function $d8cf2adaf6a4e6f2$var$isLazyBundle(features) {
    return typeof features === "function";
}

});
parcelRegister("8zFLG", function(module, exports) {

$parcel$export(module.exports, "LazyContext", function () { return $1cdfc9563e072a56$export$40f10139ecf1f171; });

var $exYeM = parcelRequire("exYeM");
const $1cdfc9563e072a56$export$40f10139ecf1f171 = (0, $exYeM.createContext)({
    strict: false
});

});

parcelRegister("bhr1j", function(module, exports) {

$parcel$export(module.exports, "loadFeatures", function () { return $ffc510cd2c0997fc$export$449561ec5703cdc8; });

var $93CWN = parcelRequire("93CWN");
function $ffc510cd2c0997fc$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $93CWN.featureDefinitions)[key] = {
        ...(0, $93CWN.featureDefinitions)[key],
        ...features[key]
    };
}

});


parcelRegister("gtP8X", function(module, exports) {

$parcel$export(module.exports, "m", function () { return $eea6be61cff6b714$export$953cecd6e717a553; });

var $fUnYZ = parcelRequire("fUnYZ");

var $ehij6 = parcelRequire("ehij6");
/**
 * @public
 */ const $eea6be61cff6b714$export$953cecd6e717a553 = (0, $fUnYZ.createMotionProxy)((0, $ehij6.createDomMotionConfig));

});
parcelRegister("fUnYZ", function(module, exports) {

$parcel$export(module.exports, "createMotionProxy", function () { return $6b2ebacab9b54f79$export$a28d6df673050e18; });

var $fQGPM = parcelRequire("fQGPM");
/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $6b2ebacab9b54f79$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $fQGPM.createMotionComponent)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}

});
parcelRegister("fQGPM", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", function () { return $002ee5308395fa07$export$46b7e4b9dc6110c3; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aUORc = parcelRequire("aUORc");

var $aA01Q = parcelRequire("aA01Q");

var $2yEdg = parcelRequire("2yEdg");

var $c4CvM = parcelRequire("c4CvM");

var $eTyhn = parcelRequire("eTyhn");

var $bhr1j = parcelRequire("bhr1j");

var $giwOG = parcelRequire("giwOG");

var $8OSCH = parcelRequire("8OSCH");

var $8zFLG = parcelRequire("8zFLG");

var $jaBTv = parcelRequire("jaBTv");

var $8LyRZ = parcelRequire("8LyRZ");
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $002ee5308395fa07$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $bhr1j.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $exYeM.useContext)((0, $aUORc.MotionConfigContext)),
            ...props,
            layoutId: $002ee5308395fa07$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $eTyhn.useCreateMotionContext)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $giwOG.isBrowser)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $2yEdg.useVisualElement)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $exYeM.useContext)((0, $jaBTv.SwitchLayoutGroupContext));
            const isStrict = (0, $exYeM.useContext)((0, $8zFLG.LazyContext)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $aSiaI.jsxs)((0, $aA01Q.MotionContext).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $aSiaI.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $c4CvM.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefComponent = (0, $exYeM.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $8LyRZ.motionComponentSymbol] = Component;
    return ForwardRefComponent;
}
function $002ee5308395fa07$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $exYeM.useContext)((0, $8OSCH.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}

});
parcelRegister("aA01Q", function(module, exports) {

$parcel$export(module.exports, "MotionContext", function () { return $9a6e4e852eb4f373$export$2285bbca2c666415; });

var $exYeM = parcelRequire("exYeM");
const $9a6e4e852eb4f373$export$2285bbca2c666415 = (0, $exYeM.createContext)({});

});

parcelRegister("2yEdg", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", function () { return $d1d2872af74835eb$export$dc0335d73ab0b115; });

var $exYeM = parcelRequire("exYeM");

var $igvvk = parcelRequire("igvvk");

var $aA01Q = parcelRequire("aA01Q");

var $527gh = parcelRequire("527gh");

var $8zFLG = parcelRequire("8zFLG");

var $aUORc = parcelRequire("aUORc");

var $fTE3g = parcelRequire("fTE3g");

var $anbeJ = parcelRequire("anbeJ");
function $d1d2872af74835eb$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $exYeM.useContext)((0, $aA01Q.MotionContext));
    const lazyContext = (0, $exYeM.useContext)((0, $8zFLG.LazyContext));
    const presenceContext = (0, $exYeM.useContext)((0, $igvvk.PresenceContext));
    const reducedMotionConfig = (0, $exYeM.useContext)((0, $aUORc.MotionConfigContext)).reducedMotion;
    const visualElementRef = (0, $exYeM.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $exYeM.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, $exYeM.useRef)(Boolean(props[0, $fTE3g.optimizedAppearDataAttribute] && !window.HandoffComplete));
    (0, $527gh.useIsomorphicLayoutEffect)(()=>{
        if (!visualElement) return;
        (0, $anbeJ.microtask).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $exYeM.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            window.HandoffComplete = true;
        }
    });
    return visualElement;
}

});
parcelRegister("anbeJ", function(module, exports) {

$parcel$export(module.exports, "microtask", function () { return $a1ef008917ac1826$export$bb76eed83315504c; });

var $gevWd = parcelRequire("gevWd");
const { schedule: $a1ef008917ac1826$export$bb76eed83315504c, cancel: $a1ef008917ac1826$export$3252729004b8456e } = (0, $gevWd.createRenderBatcher)(queueMicrotask, false);

});


parcelRegister("c4CvM", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", function () { return $3e0b35cdea07cd56$export$c684914703d321fd; });

var $exYeM = parcelRequire("exYeM");

var $hTIyI = parcelRequire("hTIyI");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $3e0b35cdea07cd56$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $exYeM.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $hTIyI.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});

parcelRegister("eTyhn", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", function () { return $1fba5faa46b4b8c9$export$c5638d843b37a176; });

var $exYeM = parcelRequire("exYeM");

var $aA01Q = parcelRequire("aA01Q");

var $E6tX5 = parcelRequire("E6tX5");
function $1fba5faa46b4b8c9$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $E6tX5.getCurrentTreeVariants)(props, (0, $exYeM.useContext)((0, $aA01Q.MotionContext)));
    return (0, $exYeM.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $1fba5faa46b4b8c9$var$variantLabelsAsDependency(initial),
        $1fba5faa46b4b8c9$var$variantLabelsAsDependency(animate)
    ]);
}
function $1fba5faa46b4b8c9$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("E6tX5", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", function () { return $d9dc1d37927f1414$export$12fc32fc096a04a3; });

var $jzTF8 = parcelRequire("jzTF8");

var $lAfBY = parcelRequire("lAfBY");
function $d9dc1d37927f1414$export$12fc32fc096a04a3(props, context) {
    if ((0, $lAfBY.isControllingVariants)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $jzTF8.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $jzTF8.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});


parcelRegister("jaBTv", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", function () { return $df9c3e45a16d5ebc$export$da5f7b802957459a; });

var $exYeM = parcelRequire("exYeM");
/**
 * Internal, exported only for usage in Framer
 */ const $df9c3e45a16d5ebc$export$da5f7b802957459a = (0, $exYeM.createContext)({});

});

parcelRegister("8LyRZ", function(module, exports) {

$parcel$export(module.exports, "motionComponentSymbol", function () { return $352246c6734b361d$export$28e2e4cce424ae23; });
const $352246c6734b361d$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");

});



parcelRegister("ehij6", function(module, exports) {

$parcel$export(module.exports, "createDomMotionConfig", function () { return $e939d64425c6240c$export$732916c0e88175fb; });

var $d51nF = parcelRequire("d51nF");

var $jV9MY = parcelRequire("jV9MY");

var $9XCsT = parcelRequire("9XCsT");

var $eIle6 = parcelRequire("eIle6");
function $e939d64425c6240c$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $d51nF.isSVGComponent)(Component) ? (0, $9XCsT.svgMotionConfig) : (0, $eIle6.htmlMotionConfig);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $jV9MY.createUseRender)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}

});
parcelRegister("jV9MY", function(module, exports) {

$parcel$export(module.exports, "createUseRender", function () { return $9f5d406889886ff1$export$5d29104eefd89cc8; });

var $exYeM = parcelRequire("exYeM");

var $aRRKx = parcelRequire("aRRKx");

var $7GFRj = parcelRequire("7GFRj");

var $d51nF = parcelRequire("d51nF");

var $bSNjt = parcelRequire("bSNjt");

var $erBmB = parcelRequire("erBmB");
function $9f5d406889886ff1$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $d51nF.isSVGComponent)(Component) ? (0, $bSNjt.useSVGProps) : (0, $aRRKx.useHTMLProps);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $7GFRj.filterProps)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $exYeM.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $exYeM.useMemo)(()=>(0, $erBmB.isMotionValue)(children) ? children.get() : children, [
            children
        ]);
        return (0, $exYeM.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}

});
parcelRegister("aRRKx", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", function () { return $582c92f88e1a1e68$export$40dafdb8630c956b; });
$parcel$export(module.exports, "useHTMLProps", function () { return $582c92f88e1a1e68$export$57be0a314572d87d; });

var $exYeM = parcelRequire("exYeM");

var $bd0Li = parcelRequire("bd0Li");

var $erBmB = parcelRequire("erBmB");

var $cOKvu = parcelRequire("cOKvu");

var $1Qm33 = parcelRequire("1Qm33");
function $582c92f88e1a1e68$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $erBmB.isMotionValue)(source[key]) && !(0, $bd0Li.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $582c92f88e1a1e68$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $exYeM.useMemo)(()=>{
        const state = (0, $1Qm33.createHtmlRenderState)();
        (0, $cOKvu.buildHTMLStyles)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $582c92f88e1a1e68$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $582c92f88e1a1e68$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $582c92f88e1a1e68$var$useInitialMotionValues(props, visualState, isStatic));
    return style;
}
function $582c92f88e1a1e68$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $582c92f88e1a1e68$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRegister("1Qm33", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", function () { return $43cb856997daead8$export$8940b483cf52eeda; });
const $43cb856997daead8$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });

});


parcelRegister("7GFRj", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $a52b0ca54619c60e$export$d697c39a2985a4c; });

var $dOow0 = parcelRequire("dOow0");
let $a52b0ca54619c60e$var$shouldForward = (key)=>!(0, $dOow0.isValidMotionProp)(key);
function $a52b0ca54619c60e$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $a52b0ca54619c60e$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $dOow0.isValidMotionProp)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $a52b0ca54619c60e$export$59d6962c470509a5($a52b0ca54619c60e$import$c6bce8c37c642938$2e2bcd8739ae039);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $a52b0ca54619c60e$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($a52b0ca54619c60e$var$shouldForward(key) || forwardMotionProps === true && (0, $dOow0.isValidMotionProp)(key) || !isDom && !(0, $dOow0.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

});
parcelRegister("dOow0", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", function () { return $1f4002463fc06750$export$2f9c46555243bf04; });
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $1f4002463fc06750$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $1f4002463fc06750$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $1f4002463fc06750$var$validMotionProps.has(key);
}

});


parcelRegister("bSNjt", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", function () { return $678da409a301bad8$export$84309c4f53cb1bd5; });

var $exYeM = parcelRequire("exYeM");

var $aRRKx = parcelRequire("aRRKx");

var $4X2JK = parcelRequire("4X2JK");

var $cpGJm = parcelRequire("cpGJm");

var $5wAah = parcelRequire("5wAah");
function $678da409a301bad8$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $exYeM.useMemo)(()=>{
        const state = (0, $cpGJm.createSvgRenderState)();
        (0, $4X2JK.buildSVGAttrs)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $5wAah.isSVGTag)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $aRRKx.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}

});
parcelRegister("cpGJm", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", function () { return $93153305d91bad5b$export$41be8b43e1c4d4f9; });

var $1Qm33 = parcelRequire("1Qm33");
const $93153305d91bad5b$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $1Qm33.createHtmlRenderState)(),
        attrs: {}
    });

});



parcelRegister("9XCsT", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", function () { return $a38e3c634edf90c1$export$44dabd3fae512e85; });

var $3RbVp = parcelRequire("3RbVp");

var $gG0hH = parcelRequire("gG0hH");

var $gJvYH = parcelRequire("gJvYH");

var $cpGJm = parcelRequire("cpGJm");

var $4X2JK = parcelRequire("4X2JK");

var $5wAah = parcelRequire("5wAah");

var $h9ps1 = parcelRequire("h9ps1");
const $a38e3c634edf90c1$export$44dabd3fae512e85 = {
    useVisualState: (0, $gJvYH.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $gG0hH.scrapeMotionValuesFromProps),
        createRenderState: (0, $cpGJm.createSvgRenderState),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $h9ps1.frame).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $h9ps1.frame).render(()=>{
                (0, $4X2JK.buildSVGAttrs)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $5wAah.isSVGTag)(instance.tagName), props.transformTemplate);
                (0, $3RbVp.renderSVG)(instance, renderState);
            });
        }
    })
};

});
parcelRegister("gJvYH", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", function () { return $30ccd5a4894de23b$export$e91e107bc6d03a8e; });

var $exYeM = parcelRequire("exYeM");

var $45ATh = parcelRequire("45ATh");

var $igvvk = parcelRequire("igvvk");

var $cuKdH = parcelRequire("cuKdH");

var $8GmSS = parcelRequire("8GmSS");

var $d5EFs = parcelRequire("d5EFs");

var $aA01Q = parcelRequire("aA01Q");

var $lAfBY = parcelRequire("lAfBY");
function $30ccd5a4894de23b$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $30ccd5a4894de23b$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $30ccd5a4894de23b$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $exYeM.useContext)((0, $aA01Q.MotionContext));
        const presenceContext = (0, $exYeM.useContext)((0, $igvvk.PresenceContext));
        const make = ()=>$30ccd5a4894de23b$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $8GmSS.useConstant)(make);
    };
function $30ccd5a4894de23b$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $d5EFs.resolveMotionValue)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $lAfBY.isControllingVariants)(props);
    const isVariantNode$1 = (0, $lAfBY.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $45ATh.isAnimationControls)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $cuKdH.resolveVariantFromProps)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}

});
parcelRegister("d5EFs", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", function () { return $a6687c7d507e2d36$export$fcc2206ecb6d74b; });

var $7fJT7 = parcelRequire("7fJT7");

var $erBmB = parcelRequire("erBmB");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $a6687c7d507e2d36$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $erBmB.isMotionValue)(value) ? value.get() : value;
    return (0, $7fJT7.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

});



parcelRegister("eIle6", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", function () { return $7e738ddebc5e1ace$export$e13ea21d87ea57c8; });

var $gJvYH = parcelRequire("gJvYH");

var $caXcX = parcelRequire("caXcX");

var $1Qm33 = parcelRequire("1Qm33");
const $7e738ddebc5e1ace$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $gJvYH.makeUseVisualState)({
        scrapeMotionValuesFromProps: $caXcX.scrapeMotionValuesFromProps,
        createRenderState: (0, $1Qm33.createHtmlRenderState)
    })
};

});



parcelRegister("ftZJ0", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_VARIANTS", function () { return $3d8d351f6772d50b$export$55b7325ba41bb523; });
"use client";
// src/transition-utils.ts
var $3d8d351f6772d50b$export$9ee1d08bb6db426f = {
    ease: [
        0.36,
        0.66,
        0.4,
        1
    ],
    easeIn: [
        0.4,
        0,
        1,
        1
    ],
    easeOut: [
        0,
        0,
        0.2,
        1
    ],
    easeInOut: [
        0.4,
        0,
        0.2,
        1
    ],
    spring: [
        0.155,
        1.105,
        0.295,
        1.12
    ],
    springOut: [
        0.57,
        -0.15,
        0.62,
        0.07
    ],
    softSpring: [
        0.16,
        1.11,
        0.3,
        1.02
    ]
};
var $3d8d351f6772d50b$export$f995eb860f745cb = {
    enter: {
        duration: 0.2,
        ease: $3d8d351f6772d50b$export$9ee1d08bb6db426f.easeOut
    },
    exit: {
        duration: 0.1,
        ease: $3d8d351f6772d50b$export$9ee1d08bb6db426f.easeIn
    }
};
var $3d8d351f6772d50b$export$55b7325ba41bb523 = {
    scaleSpring: {
        enter: {
            transform: "scale(1)",
            opacity: 1,
            transition: {
                type: "spring",
                bounce: 0,
                duration: 0.2
            }
        },
        exit: {
            transform: "scale(0.85)",
            opacity: 0,
            transition: {
                type: "easeOut",
                duration: 0.15
            }
        }
    },
    scaleSpringOpacity: {
        initial: {
            opacity: 0,
            transform: "scale(0.8)"
        },
        enter: {
            opacity: 1,
            transform: "scale(1)",
            transition: {
                type: "spring",
                bounce: 0,
                duration: 0.3
            }
        },
        exit: {
            opacity: 0,
            transform: "scale(0.96)",
            transition: {
                type: "easeOut",
                bounce: 0,
                duration: 0.15
            }
        }
    },
    scale: {
        enter: {
            scale: 1
        },
        exit: {
            scale: 0.95
        }
    },
    scaleFadeIn: {
        enter: {
            transform: "scale(1)",
            opacity: 1,
            transition: {
                duration: 0.25,
                ease: $3d8d351f6772d50b$export$9ee1d08bb6db426f.easeIn
            }
        },
        exit: {
            transform: "scale(0.95)",
            opacity: 0,
            transition: {
                duration: 0.2,
                ease: $3d8d351f6772d50b$export$9ee1d08bb6db426f.easeOut
            }
        }
    },
    scaleInOut: {
        enter: {
            transform: "scale(1)",
            opacity: 1,
            transition: {
                duration: 0.4,
                ease: $3d8d351f6772d50b$export$9ee1d08bb6db426f.ease
            }
        },
        exit: {
            transform: "scale(1.03)",
            opacity: 0,
            transition: {
                duration: 0.3,
                ease: $3d8d351f6772d50b$export$9ee1d08bb6db426f.ease
            }
        }
    },
    fade: {
        enter: {
            opacity: 1,
            transition: {
                duration: 0.4,
                ease: $3d8d351f6772d50b$export$9ee1d08bb6db426f.ease
            }
        },
        exit: {
            opacity: 0,
            transition: {
                duration: 0.3,
                ease: $3d8d351f6772d50b$export$9ee1d08bb6db426f.ease
            }
        }
    },
    collapse: {
        enter: {
            opacity: 1,
            height: "auto",
            transition: {
                height: {
                    type: "spring",
                    bounce: 0,
                    duration: 0.3
                },
                opacity: {
                    easings: "ease",
                    duration: 0.4
                }
            }
        },
        exit: {
            opacity: 0,
            height: 0,
            transition: {
                easings: "ease",
                duration: 0.3
            }
        }
    }
};

});

parcelRegister("fxzCj", function(module, exports) {

$parcel$export(module.exports, "SelectionManager", function () { return $b50590dbc1c8a4fb$export$6c8a5aaad13c9852; });

var $fhL49 = parcelRequire("fhL49");

var $bdcQ4 = parcelRequire("bdcQ4");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $b50590dbc1c8a4fb$export$6c8a5aaad13c9852 {
    /**
   * The type of selection that is allowed in the collection.
   */ get selectionMode() {
        return this.state.selectionMode;
    }
    /**
   * Whether the collection allows empty selection.
   */ get disallowEmptySelection() {
        return this.state.disallowEmptySelection;
    }
    /**
   * The selection behavior for the collection.
   */ get selectionBehavior() {
        return this.state.selectionBehavior;
    }
    /**
   * Sets the selection behavior for the collection.
   */ setSelectionBehavior(selectionBehavior) {
        this.state.setSelectionBehavior(selectionBehavior);
    }
    /**
   * Whether the collection is currently focused.
   */ get isFocused() {
        return this.state.isFocused;
    }
    /**
   * Sets whether the collection is focused.
   */ setFocused(isFocused) {
        this.state.setFocused(isFocused);
    }
    /**
   * The current focused key in the collection.
   */ get focusedKey() {
        return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */ get childFocusStrategy() {
        return this.state.childFocusStrategy;
    }
    /**
   * Sets the focused key.
   */ setFocusedKey(key, childFocusStrategy) {
        if (key == null || this.collection.getItem(key)) this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
   * The currently selected keys in the collection.
   */ get selectedKeys() {
        return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
   * The raw selection value for the collection.
   * Either 'all' for select all, or a set of keys.
   */ get rawSelection() {
        return this.state.selectedKeys;
    }
    /**
   * Returns whether a key is selected.
   */ isSelected(key) {
        if (this.state.selectionMode === "none") return false;
        key = this.getKey(key);
        return this.state.selectedKeys === "all" ? this.canSelectItem(key) : this.state.selectedKeys.has(key);
    }
    /**
   * Whether the selection is empty.
   */ get isEmpty() {
        return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
    }
    /**
   * Whether all items in the collection are selected.
   */ get isSelectAll() {
        if (this.isEmpty) return false;
        if (this.state.selectedKeys === "all") return true;
        if (this._isSelectAll != null) return this._isSelectAll;
        let allKeys = this.getSelectAllKeys();
        let selectedKeys = this.state.selectedKeys;
        this._isSelectAll = allKeys.every((k)=>selectedKeys.has(k));
        return this._isSelectAll;
    }
    get firstSelectedKey() {
        let first = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!first || item && (0, $bdcQ4.compareNodeOrder)(this.collection, item, first) < 0) first = item;
        }
        return first === null || first === void 0 ? void 0 : first.key;
    }
    get lastSelectedKey() {
        let last = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!last || item && (0, $bdcQ4.compareNodeOrder)(this.collection, item, last) > 0) last = item;
        }
        return last === null || last === void 0 ? void 0 : last.key;
    }
    get disabledKeys() {
        return this.state.disabledKeys;
    }
    get disabledBehavior() {
        return this.state.disabledBehavior;
    }
    /**
   * Extends the selection to the given key.
   */ extendSelection(toKey) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            this.replaceSelection(toKey);
            return;
        }
        toKey = this.getKey(toKey);
        let selection;
        // Only select the one key if coming from a select all.
        if (this.state.selectedKeys === "all") selection = new (0, $fhL49.Selection)([
            toKey
        ], toKey, toKey);
        else {
            let selectedKeys = this.state.selectedKeys;
            let anchorKey = selectedKeys.anchorKey || toKey;
            selection = new (0, $fhL49.Selection)(selectedKeys, anchorKey, toKey);
            for (let key of this.getKeyRange(anchorKey, selectedKeys.currentKey || toKey))selection.delete(key);
            for (let key of this.getKeyRange(toKey, anchorKey))if (this.canSelectItem(key)) selection.add(key);
        }
        this.state.setSelectedKeys(selection);
    }
    getKeyRange(from, to) {
        let fromItem = this.collection.getItem(from);
        let toItem = this.collection.getItem(to);
        if (fromItem && toItem) {
            if ((0, $bdcQ4.compareNodeOrder)(this.collection, fromItem, toItem) <= 0) return this.getKeyRangeInternal(from, to);
            return this.getKeyRangeInternal(to, from);
        }
        return [];
    }
    getKeyRangeInternal(from, to) {
        let keys = [];
        let key = from;
        while(key){
            let item = this.collection.getItem(key);
            if (item && item.type === "item" || item.type === "cell" && this.allowsCellSelection) keys.push(key);
            if (key === to) return keys;
            key = this.collection.getKeyAfter(key);
        }
        return [];
    }
    getKey(key) {
        let item = this.collection.getItem(key);
        if (!item) return key;
        // If cell selection is allowed, just return the key.
        if (item.type === "cell" && this.allowsCellSelection) return key;
        // Find a parent item to select
        while(item.type !== "item" && item.parentKey != null)item = this.collection.getItem(item.parentKey);
        if (!item || item.type !== "item") return null;
        return item.key;
    }
    /**
   * Toggles whether the given key is selected.
   */ toggleSelection(key) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single" && !this.isSelected(key)) {
            this.replaceSelection(key);
            return;
        }
        key = this.getKey(key);
        if (key == null) return;
        let keys = new (0, $fhL49.Selection)(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
        if (keys.has(key)) keys.delete(key);
        else if (this.canSelectItem(key)) {
            keys.add(key);
            keys.anchorKey = key;
            keys.currentKey = key;
        }
        if (this.disallowEmptySelection && keys.size === 0) return;
        this.state.setSelectedKeys(keys);
    }
    /**
   * Replaces the selection with only the given key.
   */ replaceSelection(key) {
        if (this.selectionMode === "none") return;
        key = this.getKey(key);
        if (key == null) return;
        let selection = this.canSelectItem(key) ? new (0, $fhL49.Selection)([
            key
        ], key, key) : new (0, $fhL49.Selection)();
        this.state.setSelectedKeys(selection);
    }
    /**
   * Replaces the selection with the given keys.
   */ setSelectedKeys(keys) {
        if (this.selectionMode === "none") return;
        let selection = new (0, $fhL49.Selection)();
        for (let key of keys){
            key = this.getKey(key);
            if (key != null) {
                selection.add(key);
                if (this.selectionMode === "single") break;
            }
        }
        this.state.setSelectedKeys(selection);
    }
    getSelectAllKeys() {
        let keys = [];
        let addKeys = (key)=>{
            while(key){
                if (this.canSelectItem(key)) {
                    let item = this.collection.getItem(key);
                    if (item.type === "item") keys.push(key);
                    // Add child keys. If cell selection is allowed, then include item children too.
                    if (item.hasChildNodes && (this.allowsCellSelection || item.type !== "item")) addKeys((0, $bdcQ4.getFirstItem)((0, $bdcQ4.getChildNodes)(item, this.collection)).key);
                }
                key = this.collection.getKeyAfter(key);
            }
        };
        addKeys(this.collection.getFirstKey());
        return keys;
    }
    /**
   * Selects all items in the collection.
   */ selectAll() {
        if (!this.isSelectAll && this.selectionMode === "multiple") this.state.setSelectedKeys("all");
    }
    /**
   * Removes all keys from the selection.
   */ clearSelection() {
        if (!this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new (0, $fhL49.Selection)());
    }
    /**
   * Toggles between select all and an empty selection.
   */ toggleSelectAll() {
        if (this.isSelectAll) this.clearSelection();
        else this.selectAll();
    }
    select(key, e) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);
            else this.replaceSelection(key);
        } else if (this.selectionBehavior === "toggle" || e && (e.pointerType === "touch" || e.pointerType === "virtual")) this.toggleSelection(key);
        else this.replaceSelection(key);
    }
    /**
   * Returns whether the current selection is equal to the given selection.
   */ isSelectionEqual(selection) {
        if (selection === this.state.selectedKeys) return true;
        // Check if the set of keys match.
        let selectedKeys = this.selectedKeys;
        if (selection.size !== selectedKeys.size) return false;
        for (let key of selection){
            if (!selectedKeys.has(key)) return false;
        }
        for (let key of selectedKeys){
            if (!selection.has(key)) return false;
        }
        return true;
    }
    canSelectItem(key) {
        var _item_props;
        if (this.state.selectionMode === "none" || this.state.disabledKeys.has(key)) return false;
        let item = this.collection.getItem(key);
        if (!item || (item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || item.type === "cell" && !this.allowsCellSelection) return false;
        return true;
    }
    isDisabled(key) {
        var _this_collection_getItem_props, _this_collection_getItem;
        return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(key) || !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.isDisabled));
    }
    isLink(key) {
        var _this_collection_getItem_props, _this_collection_getItem;
        return !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.href);
    }
    getItemProps(key) {
        var _this_collection_getItem;
        return (_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : _this_collection_getItem.props;
    }
    constructor(collection, state, options){
        this.collection = collection;
        this.state = state;
        var _options_allowsCellSelection;
        this.allowsCellSelection = (_options_allowsCellSelection = options === null || options === void 0 ? void 0 : options.allowsCellSelection) !== null && _options_allowsCellSelection !== void 0 ? _options_allowsCellSelection : false;
        this._isSelectAll = null;
    }
}

});
parcelRegister("fhL49", function(module, exports) {

$parcel$export(module.exports, "Selection", function () { return $b20cf3d9c287d957$export$52baac22726c72bf; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $b20cf3d9c287d957$export$52baac22726c72bf extends Set {
    constructor(keys, anchorKey, currentKey){
        super(keys);
        if (keys instanceof $b20cf3d9c287d957$export$52baac22726c72bf) {
            this.anchorKey = anchorKey || keys.anchorKey;
            this.currentKey = currentKey || keys.currentKey;
        } else {
            this.anchorKey = anchorKey;
            this.currentKey = currentKey;
        }
    }
}

});

parcelRegister("bdcQ4", function(module, exports) {

$parcel$export(module.exports, "getChildNodes", function () { return $829ade21c41c973d$export$1005530eda016c13; });
$parcel$export(module.exports, "getFirstItem", function () { return $829ade21c41c973d$export$fbdeaa6a76694f71; });
$parcel$export(module.exports, "compareNodeOrder", function () { return $829ade21c41c973d$export$8c434b3a7a4dad6; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $829ade21c41c973d$export$1005530eda016c13(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === "function") return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function $829ade21c41c973d$export$fbdeaa6a76694f71(iterable) {
    return $829ade21c41c973d$export$5f3398f8733f90e2(iterable, 0);
}
function $829ade21c41c973d$export$5f3398f8733f90e2(iterable, index) {
    if (index < 0) return undefined;
    let i = 0;
    for (let item of iterable){
        if (i === index) return item;
        i++;
    }
}
function $829ade21c41c973d$export$7475b2c64539e4cf(iterable) {
    let lastItem = undefined;
    for (let value of iterable)lastItem = value;
    return lastItem;
}
function $829ade21c41c973d$export$8c434b3a7a4dad6(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    let aAncestors = [
        ...$829ade21c41c973d$var$$c5a24bc478652b5f$var$getAncestors(collection, a),
        a
    ];
    let bAncestors = [
        ...$829ade21c41c973d$var$$c5a24bc478652b5f$var$getAncestors(collection, b),
        b
    ];
    let firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex((a, i)=>a !== bAncestors[i]);
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex((node)=>node === b) >= 0) return 1;
    else if (bAncestors.findIndex((node)=>node === a) >= 0) return -1;
    // 🤷
    return -1;
}
function $829ade21c41c973d$var$$c5a24bc478652b5f$var$getAncestors(collection, node) {
    let parents = [];
    while((node === null || node === void 0 ? void 0 : node.parentKey) != null){
        node = collection.getItem(node.parentKey);
        parents.unshift(node);
    }
    return parents;
}

});


parcelRegister("dlWrh", function(module, exports) {

$parcel$export(module.exports, "useMultipleSelectionState", function () { return $9b8a9151d30c41f9$export$253fe78d46329472; });

var $fhL49 = parcelRequire("fhL49");

var $e0Pl7 = parcelRequire("e0Pl7");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9b8a9151d30c41f9$var$$7af3f5b51489e0b5$var$equalSets(setA, setB) {
    if (setA.size !== setB.size) return false;
    for (let item of setA){
        if (!setB.has(item)) return false;
    }
    return true;
}
function $9b8a9151d30c41f9$export$253fe78d46329472(props) {
    let { selectionMode: selectionMode = "none", disallowEmptySelection: disallowEmptySelection, allowDuplicateSelectionEvents: allowDuplicateSelectionEvents, selectionBehavior: selectionBehaviorProp = "toggle", disabledBehavior: disabledBehavior = "all" } = props;
    // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
    // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).
    let isFocusedRef = (0, $exYeM.useRef)(false);
    let [, setFocused] = (0, $exYeM.useState)(false);
    let focusedKeyRef = (0, $exYeM.useRef)(null);
    let childFocusStrategyRef = (0, $exYeM.useRef)(null);
    let [, setFocusedKey] = (0, $exYeM.useState)(null);
    let selectedKeysProp = (0, $exYeM.useMemo)(()=>$9b8a9151d30c41f9$var$$7af3f5b51489e0b5$var$convertSelection(props.selectedKeys), [
        props.selectedKeys
    ]);
    let defaultSelectedKeys = (0, $exYeM.useMemo)(()=>$9b8a9151d30c41f9$var$$7af3f5b51489e0b5$var$convertSelection(props.defaultSelectedKeys, new (0, $fhL49.Selection)()), [
        props.defaultSelectedKeys
    ]);
    let [selectedKeys, setSelectedKeys] = (0, $e0Pl7.useControlledState)(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange);
    let disabledKeysProp = (0, $exYeM.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let [selectionBehavior, setSelectionBehavior] = (0, $exYeM.useState)(selectionBehaviorProp);
    // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
    // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.
    if (selectionBehaviorProp === "replace" && selectionBehavior === "toggle" && typeof selectedKeys === "object" && selectedKeys.size === 0) setSelectionBehavior("replace");
    // If the selectionBehavior prop changes, update the state as well.
    let lastSelectionBehavior = (0, $exYeM.useRef)(selectionBehaviorProp);
    (0, $exYeM.useEffect)(()=>{
        if (selectionBehaviorProp !== lastSelectionBehavior.current) {
            setSelectionBehavior(selectionBehaviorProp);
            lastSelectionBehavior.current = selectionBehaviorProp;
        }
    }, [
        selectionBehaviorProp
    ]);
    return {
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        selectionBehavior: selectionBehavior,
        setSelectionBehavior: setSelectionBehavior,
        get isFocused () {
            return isFocusedRef.current;
        },
        setFocused (f) {
            isFocusedRef.current = f;
            setFocused(f);
        },
        get focusedKey () {
            return focusedKeyRef.current;
        },
        get childFocusStrategy () {
            return childFocusStrategyRef.current;
        },
        setFocusedKey (k, childFocusStrategy = "first") {
            focusedKeyRef.current = k;
            childFocusStrategyRef.current = childFocusStrategy;
            setFocusedKey(k);
        },
        selectedKeys: selectedKeys,
        setSelectedKeys (keys) {
            if (allowDuplicateSelectionEvents || !$9b8a9151d30c41f9$var$$7af3f5b51489e0b5$var$equalSets(keys, selectedKeys)) setSelectedKeys(keys);
        },
        disabledKeys: disabledKeysProp,
        disabledBehavior: disabledBehavior
    };
}
function $9b8a9151d30c41f9$var$$7af3f5b51489e0b5$var$convertSelection(selection, defaultValue) {
    if (!selection) return defaultValue;
    return selection === "all" ? "all" : new (0, $fhL49.Selection)(selection);
}

});
parcelRegister("e0Pl7", function(module, exports) {

$parcel$export(module.exports, "useControlledState", function () { return $a338e3bf06dc39e4$export$40bfa8c7b0832715; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a338e3bf06dc39e4$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $exYeM.useState)(value || defaultValue);
    let isControlledRef = (0, $exYeM.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $exYeM.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    let currentValue = isControlled ? value : stateValue;
    let setValue = (0, $exYeM.useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? currentValue : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}

});


parcelRegister("eLJRH", function(module, exports) {

$parcel$export(module.exports, "useCollection", function () { return $ac090857927b3efd$export$6cd28814d92fa9c9; });

var $fQBMY = parcelRequire("fQBMY");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ac090857927b3efd$export$6cd28814d92fa9c9(props, factory, context) {
    let builder = (0, $exYeM.useMemo)(()=>new (0, $fQBMY.CollectionBuilder)(), []);
    let { children: children, items: items, collection: collection } = props;
    let result = (0, $exYeM.useMemo)(()=>{
        if (collection) return collection;
        let nodes = builder.build({
            children: children,
            items: items
        }, context);
        return factory(nodes);
    }, [
        builder,
        children,
        items,
        collection,
        context,
        factory
    ]);
    return result;
}

});
parcelRegister("fQBMY", function(module, exports) {

$parcel$export(module.exports, "CollectionBuilder", function () { return $b899067330b6a255$export$bf788dd355e3a401; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $b899067330b6a255$export$bf788dd355e3a401 {
    build(props, context) {
        this.context = context;
        return $b899067330b6a255$var$$eb2240fc39a57fa5$var$iterable(()=>this.iterateCollection(props));
    }
    *iterateCollection(props) {
        let { children: children, items: items } = props;
        if (typeof children === "function") {
            if (!items) throw new Error("props.children was a function but props.items is missing");
            for (let item of props.items)yield* this.getFullNode({
                value: item
            }, {
                renderer: children
            });
        } else {
            let items = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Children.forEach(children, (child)=>{
                items.push(child);
            });
            let index = 0;
            for (let item of items){
                let nodes = this.getFullNode({
                    element: item,
                    index: index
                }, {});
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === "cell" && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            var _v_key;
            let key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
            if (key == null) throw new Error("No key found for item");
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).isValidElement(element)) {
            let type = element.type;
            if (typeof type !== "function" && typeof type.getCollectionNode !== "function") {
                let name = typeof element.type === "function" ? element.type.name : element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            let index = partialNode.index;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                let nodeKey = childNode.key;
                if (!nodeKey) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index: index,
                    wrapper: $b899067330b6a255$var$$eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    // Cache the node based on its value
                    node.value = childNode.value || partialNode.value;
                    if (node.value) this.cache.set(node.value, node);
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${$b899067330b6a255$var$$eb2240fc39a57fa5$var$capitalize(node.type)}> in <${$b899067330b6a255$var$$eb2240fc39a57fa5$var$capitalize(parentNode.type)}>. Only <${$b899067330b6a255$var$$eb2240fc39a57fa5$var$capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null) return;
        // Create full node
        let builder = this;
        let node = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: partialNode.value,
            level: parentNode ? parentNode.level + 1 : 0,
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: partialNode.textValue,
            "aria-label": partialNode["aria-label"],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes,
            childNodes: $b899067330b6a255$var$$eb2240fc39a57fa5$var$iterable(function*() {
                if (!partialNode.hasChildNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node.key}${child.key}`;
                    child.index = index;
                    let nodes = builder.getFullNode(child, builder.getChildState(state, child), node.key, node);
                    for (let node of nodes){
                        index++;
                        yield node;
                    }
                }
            })
        };
        yield node;
    }
    constructor(){
        this.cache = new WeakMap();
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function $b899067330b6a255$var$$eb2240fc39a57fa5$var$iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item of iterable){
                cache.push(item);
                yield item;
            }
        }
    };
}
function $b899067330b6a255$var$$eb2240fc39a57fa5$var$compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element));
    if (outer) return outer;
    if (inner) return inner;
}
function $b899067330b6a255$var$$eb2240fc39a57fa5$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}

});


parcelRegister("k0Xsz", function(module, exports) {

$parcel$export(module.exports, "isScrollable", function () { return $e921ee337307dfbd$export$2bb74740c4e19def; });
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e921ee337307dfbd$export$2bb74740c4e19def(node, checkForOverflow) {
    let style = window.getComputedStyle(node);
    let isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
    if (isScrollable && checkForOverflow) isScrollable = node.scrollHeight !== node.clientHeight || node.scrollWidth !== node.clientWidth;
    return isScrollable;
}

});

parcelRegister("d7oDp", function(module, exports) {

$parcel$export(module.exports, "scrollIntoView", function () { return $98cf09b8979b3edd$export$53a0910f038337bd; });
$parcel$export(module.exports, "scrollIntoViewport", function () { return $98cf09b8979b3edd$export$c826860796309d1b; });

var $5dBze = parcelRequire("5dBze");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $98cf09b8979b3edd$export$53a0910f038337bd(scrollView, element) {
    let offsetX = $98cf09b8979b3edd$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "left");
    let offsetY = $98cf09b8979b3edd$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "top");
    let width = element.offsetWidth;
    let height = element.offsetHeight;
    let x = scrollView.scrollLeft;
    let y = scrollView.scrollTop;
    // Account for top/left border offsetting the scroll top/Left
    let { borderTopWidth: borderTopWidth, borderLeftWidth: borderLeftWidth } = getComputedStyle(scrollView);
    let borderAdjustedX = scrollView.scrollLeft + parseInt(borderLeftWidth, 10);
    let borderAdjustedY = scrollView.scrollTop + parseInt(borderTopWidth, 10);
    // Ignore end/bottom border via clientHeight/Width instead of offsetHeight/Width
    let maxX = borderAdjustedX + scrollView.clientWidth;
    let maxY = borderAdjustedY + scrollView.clientHeight;
    if (offsetX <= x) x = offsetX - parseInt(borderLeftWidth, 10);
    else if (offsetX + width > maxX) x += offsetX + width - maxX;
    if (offsetY <= borderAdjustedY) y = offsetY - parseInt(borderTopWidth, 10);
    else if (offsetY + height > maxY) y += offsetY + height - maxY;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $98cf09b8979b3edd$var$$2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    const prop = axis === "left" ? "offsetLeft" : "offsetTop";
    let sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}
function $98cf09b8979b3edd$export$c826860796309d1b(targetElement, opts) {
    if (document.contains(targetElement)) {
        let root = document.scrollingElement || document.documentElement;
        let isScrollPrevented = window.getComputedStyle(root).overflow === "hidden";
        // If scrolling is not currently prevented then we aren’t in a overlay nor is a overlay open, just use element.scrollIntoView to bring the element into view
        if (!isScrollPrevented) {
            var // won't cause a scroll if the element is already focused and doesn't behave consistently when an element is partially out of view horizontally vs vertically
            _targetElement_scrollIntoView;
            let { left: originalLeft, top: originalTop } = targetElement.getBoundingClientRect();
            targetElement === null || targetElement === void 0 || (_targetElement_scrollIntoView = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView === void 0 || _targetElement_scrollIntoView.call(targetElement, {
                block: "nearest"
            });
            let { left: newLeft, top: newTop } = targetElement.getBoundingClientRect();
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                var _opts_containingElement_scrollIntoView, _opts_containingElement, _targetElement_scrollIntoView1;
                opts === null || opts === void 0 || (_opts_containingElement = opts.containingElement) === null || _opts_containingElement === void 0 || (_opts_containingElement_scrollIntoView = _opts_containingElement.scrollIntoView) === null || _opts_containingElement_scrollIntoView === void 0 || _opts_containingElement_scrollIntoView.call(_opts_containingElement, {
                    block: "center",
                    inline: "center"
                });
                (_targetElement_scrollIntoView1 = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView1 === void 0 || _targetElement_scrollIntoView1.call(targetElement, {
                    block: "nearest"
                });
            }
        } else {
            let scrollParents = (0, $5dBze.getScrollParents)(targetElement);
            // If scrolling is prevented, we don't want to scroll the body since it might move the overlay partially offscreen and the user can't scroll it back into view.
            for (let scrollParent of scrollParents)$98cf09b8979b3edd$export$53a0910f038337bd(scrollParent, targetElement);
        }
    }
}

});
parcelRegister("5dBze", function(module, exports) {

$parcel$export(module.exports, "getScrollParents", function () { return $3ccb4eb44488cc00$export$94ed1c92c7beeb22; });

var $k0Xsz = parcelRequire("k0Xsz");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3ccb4eb44488cc00$export$94ed1c92c7beeb22(node, checkForOverflow) {
    const scrollParents = [];
    while(node && node !== document.documentElement){
        if ((0, $k0Xsz.isScrollable)(node, checkForOverflow)) scrollParents.push(node);
        node = node.parentElement;
    }
    return scrollParents;
}

});


parcelRegister("dK1OU", function(module, exports) {

$parcel$export(module.exports, "useCollator", function () { return $a010fbafd17c94ab$export$a16aca283550c30d; });

var $9ljKT = parcelRequire("9ljKT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $a010fbafd17c94ab$var$$325a3faab7a68acd$var$cache = new Map();
function $a010fbafd17c94ab$export$a16aca283550c30d(options) {
    let { locale: locale } = (0, $9ljKT.useLocale)();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($a010fbafd17c94ab$var$$325a3faab7a68acd$var$cache.has(cacheKey)) return $a010fbafd17c94ab$var$$325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $a010fbafd17c94ab$var$$325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}

});
parcelRegister("9ljKT", function(module, exports) {

$parcel$export(module.exports, "useLocale", function () { return $6cd56632b62534fb$export$43bb16f9c6d9e3f7; });

var $8Mefp = parcelRequire("8Mefp");

var $egPQf = parcelRequire("egPQf");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6cd56632b62534fb$var$$18f2051aff69b9bf$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
function $6cd56632b62534fb$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    let defaultLocale = (0, $egPQf.useDefaultLocale)();
    let value = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>{
        if (!locale) return defaultLocale;
        return {
            locale: locale,
            direction: (0, $8Mefp.isRTL)(locale) ? "rtl" : "ltr"
        };
    }, [
        defaultLocale,
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6cd56632b62534fb$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
function $6cd56632b62534fb$export$43bb16f9c6d9e3f7() {
    let defaultLocale = (0, $egPQf.useDefaultLocale)();
    let context = (0, $exYeM.useContext)($6cd56632b62534fb$var$$18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}

});
parcelRegister("8Mefp", function(module, exports) {

$parcel$export(module.exports, "isRTL", function () { return $663ddbacea0c8e75$export$702d680b21cbd764; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $663ddbacea0c8e75$var$$148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
const $663ddbacea0c8e75$var$$148a7a147e38ea7f$var$RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $663ddbacea0c8e75$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    // @ts-ignore
    if (Intl.Locale) {
        let locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        let textInfo = typeof locale.getTextInfo === "function" ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === "rtl";
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $663ddbacea0c8e75$var$$148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = localeString.split("-")[0];
    return $663ddbacea0c8e75$var$$148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}

});

parcelRegister("egPQf", function(module, exports) {

$parcel$export(module.exports, "useDefaultLocale", function () { return $a63ac60453daa77d$export$188ec29ebc2bdc3a; });

var $8Mefp = parcelRequire("8Mefp");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
const $a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
function $a63ac60453daa77d$export$f09106e7c6677ec5() {
    let locale = typeof window !== "undefined" && window[$a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: (0, $8Mefp.isRTL)(locale) ? "rtl" : "ltr"
    };
}
let $a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$currentLocale = $a63ac60453daa77d$export$f09106e7c6677ec5();
let $a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$listeners = new Set();
function $a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$updateLocale() {
    $a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$currentLocale = $a63ac60453daa77d$export$f09106e7c6677ec5();
    for (let listener of $a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$listeners)listener($a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$currentLocale);
}
function $a63ac60453daa77d$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $aVmq3.useIsSSR)();
    let [defaultLocale, setDefaultLocale] = (0, $exYeM.useState)($a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$currentLocale);
    (0, $exYeM.useEffect)(()=>{
        if ($a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$updateLocale);
        $a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $a63ac60453daa77d$var$$1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}

});



parcelRegister("kX516", function(module, exports) {

$parcel$export(module.exports, "divider_default", function () { return $6f5fa45154870093$export$2233c5fdcde64809; });

var $fRz3o = parcelRequire("fRz3o");

var $8Oq4a = parcelRequire("8Oq4a");

var $aSiaI = parcelRequire("aSiaI");
var $6f5fa45154870093$var$Divider = (0, $8Oq4a.forwardRef)((props, ref)=>{
    const { Component: Component, getDividerProps: getDividerProps } = (0, $fRz3o.useDivider)({
        ...props
    });
    return /* @__PURE__ */ (0, $aSiaI.jsx)(Component, {
        ref: ref,
        ...getDividerProps()
    });
});
$6f5fa45154870093$var$Divider.displayName = "NextUI.Divider";
var $6f5fa45154870093$export$2233c5fdcde64809 = $6f5fa45154870093$var$Divider;

});
parcelRegister("fRz3o", function(module, exports) {

$parcel$export(module.exports, "useDivider", function () { return $50de7fc9f7c3bab7$export$9352472c0af59bd6; });

var $9Lu9p = parcelRequire("9Lu9p");

var $iyy2i = parcelRequire("iyy2i");

var $exYeM = parcelRequire("exYeM");
function $50de7fc9f7c3bab7$export$9352472c0af59bd6(props) {
    const { as: as, className: className, orientation: orientation, ...otherProps } = props;
    let Component = as || "hr";
    if (Component === "hr" && orientation === "vertical") Component = "div";
    const { separatorProps: separatorProps } = (0, $9Lu9p.useSeparator)({
        elementType: typeof Component === "string" ? Component : "hr",
        orientation: orientation
    });
    const styles = (0, $exYeM.useMemo)(()=>(0, $iyy2i.divider)({
            orientation: orientation,
            className: className
        }), [
        orientation,
        className
    ]);
    const getDividerProps = (0, $exYeM.useCallback)((props2 = {})=>({
            className: styles,
            role: "separator",
            "data-orientation": orientation,
            ...separatorProps,
            ...otherProps,
            ...props2
        }), [
        styles,
        orientation,
        separatorProps,
        otherProps
    ]);
    return {
        Component: Component,
        getDividerProps: getDividerProps
    };
}

});
parcelRegister("9Lu9p", function(module, exports) {

$parcel$export(module.exports, "useSeparator", function () { return $52351d6c109c9154$export$52210f68a14655d0; });
// src/use-separator.ts

var $LA3Ym = parcelRequire("LA3Ym");
function $52351d6c109c9154$export$52210f68a14655d0(props) {
    let domProps = (0, $LA3Ym.filterDOMProps)(props, {
        enabled: typeof props.elementType === "string"
    });
    let ariaOrientation;
    if (props.orientation === "vertical") ariaOrientation = "vertical";
    if (props.elementType !== "hr") return {
        separatorProps: {
            ...domProps,
            role: "separator",
            "aria-orientation": ariaOrientation
        }
    };
    return {
        separatorProps: domProps
    };
}

});

parcelRegister("iyy2i", function(module, exports) {

$parcel$export(module.exports, "divider", function () { return $167bb1fc35e1f52c$export$e8c9778bf415dd08; });

var $a2Moz = parcelRequire("a2Moz");
// src/components/divider.ts
var $167bb1fc35e1f52c$export$e8c9778bf415dd08 = (0, $a2Moz.tv)({
    base: "shrink-0 bg-divider border-none",
    variants: {
        orientation: {
            horizontal: "w-full h-divider",
            vertical: "h-full w-divider"
        }
    },
    defaultVariants: {
        orientation: "horizontal"
    }
});

});



parcelRegister("aavYS", function(module, exports) {

$parcel$export(module.exports, "Item", function () { return $7673a54b13e34cba$export$6d08773d2e66f8f2; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7673a54b13e34cba$var$$c1d7fb2ec91bae71$var$Item(props) {
    return null;
}
$7673a54b13e34cba$var$$c1d7fb2ec91bae71$var$Item.getCollectionNode = function* getCollectionNode(props, context) {
    let { childItems: childItems, title: title, children: children } = props;
    let rendered = props.title || props.children;
    let textValue = props.textValue || (typeof rendered === "string" ? rendered : "") || props["aria-label"] || "";
    // suppressTextValueWarning is used in components like Tabs, which don't have type to select support.
    if (!textValue && !(context === null || context === void 0 ? void 0 : context.suppressTextValueWarning)) console.warn("<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop.");
    yield {
        type: "item",
        props: props,
        rendered: rendered,
        textValue: textValue,
        "aria-label": props["aria-label"],
        hasChildNodes: $7673a54b13e34cba$var$$c1d7fb2ec91bae71$var$hasChildItems(props),
        *childNodes () {
            if (childItems) for (let child of childItems)yield {
                type: "item",
                value: child
            };
            else if (title) {
                let items = [];
                (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Children.forEach(children, (child)=>{
                    items.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
function $7673a54b13e34cba$var$$c1d7fb2ec91bae71$var$hasChildItems(props) {
    if (props.hasChildItems != null) return props.hasChildItems;
    if (props.childItems) return true;
    if (props.title && (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Children.count(props.children) > 0) return true;
    return false;
}
// We don't want getCollectionNode to show up in the type definition
let $7673a54b13e34cba$export$6d08773d2e66f8f2 = $7673a54b13e34cba$var$$c1d7fb2ec91bae71$var$Item;
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7673a54b13e34cba$var$$9fc4852771d079eb$var$Section(props) {
    return null;
}
$7673a54b13e34cba$var$$9fc4852771d079eb$var$Section.getCollectionNode = function* getCollectionNode(props) {
    let { children: children, title: title, items: items } = props;
    yield {
        type: "section",
        props: props,
        hasChildNodes: true,
        rendered: title,
        "aria-label": props["aria-label"],
        *childNodes () {
            if (typeof children === "function") {
                if (!items) throw new Error("props.children was a function but props.items is missing");
                for (let item of items)yield {
                    type: "item",
                    value: item,
                    renderer: children
                };
            } else {
                let items = [];
                (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Children.forEach(children, (child)=>{
                    items.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
// We don't want getCollectionNode to show up in the type definition
let $7673a54b13e34cba$export$6e2c8f0811a474ce = $7673a54b13e34cba$var$$9fc4852771d079eb$var$Section;
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $7673a54b13e34cba$export$bf788dd355e3a401 {
    build(props, context) {
        this.context = context;
        return $7673a54b13e34cba$var$$eb2240fc39a57fa5$var$iterable(()=>this.iterateCollection(props));
    }
    *iterateCollection(props) {
        let { children: children, items: items } = props;
        if (typeof children === "function") {
            if (!items) throw new Error("props.children was a function but props.items is missing");
            for (let item of props.items)yield* this.getFullNode({
                value: item
            }, {
                renderer: children
            });
        } else {
            let items = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Children.forEach(children, (child)=>{
                items.push(child);
            });
            let index = 0;
            for (let item of items){
                let nodes = this.getFullNode({
                    element: item,
                    index: index
                }, {});
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === "cell" && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            var _v_key;
            let key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
            if (key == null) throw new Error("No key found for item");
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).isValidElement(element)) {
            let type = element.type;
            if (typeof type !== "function" && typeof type.getCollectionNode !== "function") {
                let name = typeof element.type === "function" ? element.type.name : element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            let index = partialNode.index;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                let nodeKey = childNode.key;
                if (!nodeKey) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index: index,
                    wrapper: $7673a54b13e34cba$var$$eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    // Cache the node based on its value
                    node.value = childNode.value || partialNode.value;
                    if (node.value) this.cache.set(node.value, node);
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${$7673a54b13e34cba$var$$eb2240fc39a57fa5$var$capitalize(node.type)}> in <${$7673a54b13e34cba$var$$eb2240fc39a57fa5$var$capitalize(parentNode.type)}>. Only <${$7673a54b13e34cba$var$$eb2240fc39a57fa5$var$capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null) return;
        // Create full node
        let builder = this;
        let node = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: partialNode.value,
            level: parentNode ? parentNode.level + 1 : 0,
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: partialNode.textValue,
            "aria-label": partialNode["aria-label"],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes,
            childNodes: $7673a54b13e34cba$var$$eb2240fc39a57fa5$var$iterable(function*() {
                if (!partialNode.hasChildNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node.key}${child.key}`;
                    child.index = index;
                    let nodes = builder.getFullNode(child, builder.getChildState(state, child), node.key, node);
                    for (let node of nodes){
                        index++;
                        yield node;
                    }
                }
            })
        };
        yield node;
    }
    constructor(){
        this.cache = new WeakMap();
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function $7673a54b13e34cba$var$$eb2240fc39a57fa5$var$iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item of iterable){
                cache.push(item);
                yield item;
            }
        }
    };
}
function $7673a54b13e34cba$var$$eb2240fc39a57fa5$var$compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element));
    if (outer) return outer;
    if (inner) return inner;
}
function $7673a54b13e34cba$var$$eb2240fc39a57fa5$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
function $7673a54b13e34cba$export$6cd28814d92fa9c9(props, factory, context) {
    let builder = (0, $exYeM.useMemo)(()=>new $7673a54b13e34cba$export$bf788dd355e3a401(), []);
    let { children: children, items: items, collection: collection } = props;
    let result = (0, $exYeM.useMemo)(()=>{
        if (collection) return collection;
        let nodes = builder.build({
            children: children,
            items: items
        }, context);
        return factory(nodes);
    }, [
        builder,
        children,
        items,
        collection,
        context,
        factory
    ]);
    return result;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7673a54b13e34cba$export$1005530eda016c13(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === "function") return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function $7673a54b13e34cba$export$fbdeaa6a76694f71(iterable) {
    return $7673a54b13e34cba$export$5f3398f8733f90e2(iterable, 0);
}
function $7673a54b13e34cba$export$5f3398f8733f90e2(iterable, index) {
    if (index < 0) return undefined;
    let i = 0;
    for (let item of iterable){
        if (i === index) return item;
        i++;
    }
}
function $7673a54b13e34cba$export$7475b2c64539e4cf(iterable) {
    let lastItem = undefined;
    for (let value of iterable)lastItem = value;
    return lastItem;
}
function $7673a54b13e34cba$export$8c434b3a7a4dad6(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    let aAncestors = [
        ...$7673a54b13e34cba$var$$c5a24bc478652b5f$var$getAncestors(collection, a),
        a
    ];
    let bAncestors = [
        ...$7673a54b13e34cba$var$$c5a24bc478652b5f$var$getAncestors(collection, b),
        b
    ];
    let firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex((a, i)=>a !== bAncestors[i]);
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex((node)=>node === b) >= 0) return 1;
    else if (bAncestors.findIndex((node)=>node === a) >= 0) return -1;
    // 🤷
    return -1;
}
function $7673a54b13e34cba$var$$c5a24bc478652b5f$var$getAncestors(collection, node) {
    let parents = [];
    while((node === null || node === void 0 ? void 0 : node.parentKey) != null){
        node = collection.getItem(node.parentKey);
        parents.unshift(node);
    }
    return parents;
}
const $7673a54b13e34cba$var$$453cc9f0df89c0a5$var$cache = new WeakMap();
function $7673a54b13e34cba$export$77d5aafae4e095b2(collection) {
    let count = $7673a54b13e34cba$var$$453cc9f0df89c0a5$var$cache.get(collection);
    if (count != null) return count;
    count = 0;
    let countItems = (items)=>{
        for (let item of items)if (item.type === "section") countItems($7673a54b13e34cba$export$1005530eda016c13(item, collection));
        else count++;
    };
    countItems(collection);
    $7673a54b13e34cba$var$$453cc9f0df89c0a5$var$cache.set(collection, count);
    return count;
}

});

parcelRegister("d1Ui9", function(module, exports) {

$parcel$export(module.exports, "Calculator", function () { return $51b1402e144fdd00$export$770682f56f7e9e8f; });
// NOTE: IF YOU CHANGE THE CONTENT HERE YOU NEED TO CHANGE THE CONTENT ON THE WRAPPED CALCULATOR HERE AND ON WEBSITE TOO

var $aSiaI = parcelRequire("aSiaI");

var $3XQiF = parcelRequire("3XQiF");
var $kX516 = parcelRequire("kX516");
var $3CO4s = parcelRequire("3CO4s");
var $bowRT = parcelRequire("bowRT");
var $fsqWO = parcelRequire("fsqWO");
var $dq8HR = parcelRequire("dq8HR");
var $jNBsp = parcelRequire("jNBsp");
var $aO5Cd = parcelRequire("aO5Cd");
var $1KY5Y = parcelRequire("1KY5Y");
var $i9Gb7 = parcelRequire("i9Gb7");

var $afsmN = parcelRequire("afsmN");
var $glhfa = parcelRequire("glhfa");
var $bU8KF = parcelRequire("bU8KF");
var $7nTfy = parcelRequire("7nTfy");
var $hS8Na = parcelRequire("hS8Na");
var $kFp87 = parcelRequire("kFp87");

var $eH0la = parcelRequire("eH0la");

var $exYeM = parcelRequire("exYeM");

var $jQkMW = parcelRequire("jQkMW");

var $7zbAk = parcelRequire("7zbAk");

var $hTj76 = parcelRequire("hTj76");

var $codwM = parcelRequire("codwM");



const $51b1402e144fdd00$var$membershipsRake = 0;
const $51b1402e144fdd00$var$currencyTypes = [
    {
        name: "DKK",
        label: "DKK",
        value: "da-DK",
        currency: "DKK",
        symbol: "kr"
    },
    {
        name: "USD",
        label: "USD",
        value: "en-US",
        currency: "USD",
        symbol: "$"
    },
    {
        name: "EUR",
        label: "EUR",
        value: "en-GB",
        currency: "EUR",
        symbol: "\u20AC"
    }
];
if (typeof window !== "undefined" && !(0, $codwM.default).__loaded) (0, $codwM.default).init("phc_aDiLXpzc4PfexVbJojOhrEDrsoQ6OFzqA6okexm9qSR", {
    api_host: "https://sleeve.fm/s/m",
    person_profiles: "always",
    autocapture: false
});
const $51b1402e144fdd00$export$770682f56f7e9e8f = ()=>{
    const [socialFollowers, setSocialFollowers] = (0, $exYeM.useState)(100000);
    const [socialPercent, setSocialPercent] = (0, $exYeM.useState)(10);
    const [emailSubscribers, setEmailSubscribers] = (0, $exYeM.useState)(20000);
    const [hasEditedTiers, setHasEditedTiers] = (0, $exYeM.useState)(false);
    const [tiers, setTiers] = (0, $exYeM.useState)([]);
    const [currencyName, setCurrencyName] = (0, $exYeM.useState)("USD");
    const [frequency, setFrequency] = (0, $exYeM.useState)("yearly");
    const [isLoadingFromUrl, setIsLoadingFromUrl] = (0, $exYeM.useState)(true);
    const [hasLoadedTiersFromUrl, setHasLoadedTiersFromUrl] = (0, $exYeM.useState)(false);
    const frequencyMultiplier = frequency === "monthly" ? 1 : 12;
    const currencies = {
        USD: {
            symbol: "$",
            locale: "en-US",
            fee: 0.3
        },
        DKK: {
            symbol: "kr",
            locale: "da-DK",
            fee: 1.8
        },
        EUR: {
            symbol: "\u20AC",
            locale: "en-GB",
            fee: 0.3
        }
    };
    const currentCurrency = currencies[currencyName];
    const freeTierTotal = (0, $exYeM.useMemo)(()=>emailSubscribers + socialPercent / 100 * socialFollowers, [
        emailSubscribers,
        socialFollowers,
        socialPercent
    ]);
    // Fire once when the user first models their numbers (edits a tier or input)
    const hasTrackedModeled = (0, $exYeM.useRef)(false);
    const trackModeled = (0, $exYeM.useCallback)(()=>{
        if (!hasTrackedModeled.current) {
            hasTrackedModeled.current = true;
            (0, $codwM.default).capture("calculator_modeled");
        }
    }, []);
    // Decode state from URL on component mount
    (0, $exYeM.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const encodedData = Array.from(urlParams.keys())[0];
        if (encodedData) try {
            const decodedData = JSON.parse(atob(decodeURIComponent(encodedData)));
            console.log("Decoded data:", decodedData);
            // Set all state at once to avoid race conditions
            if (decodedData.socialFollowers !== undefined) setSocialFollowers(decodedData.socialFollowers);
            if (decodedData.socialPercent !== undefined) setSocialPercent(decodedData.socialPercent);
            if (decodedData.emailSubscribers !== undefined) setEmailSubscribers(decodedData.emailSubscribers);
            if (decodedData.currencyName) setCurrencyName(decodedData.currencyName);
            if (decodedData.frequency) setFrequency(decodedData.frequency);
            if (decodedData.tiers && Array.isArray(decodedData.tiers)) {
                setTiers(decodedData.tiers);
                setHasLoadedTiersFromUrl(true);
            }
            setIsLoadingFromUrl(false);
        } catch (error) {
            console.error("Failed to decode URL data:", error);
            setIsLoadingFromUrl(false);
        }
        else setIsLoadingFromUrl(false);
    }, []);
    // Initialize default tiers only if not loading from URL and tiers are empty
    (0, $exYeM.useEffect)(()=>{
        if (!isLoadingFromUrl && tiers.length === 0) {
            console.log("Initializing default tiers");
            setTiers([
                {
                    id: "free",
                    pledgers: Math.round(freeTierTotal),
                    amount: 0,
                    label: "Free"
                },
                {
                    id: "base",
                    pledgers: Math.round(freeTierTotal * 0.1),
                    amount: 5,
                    label: "Base"
                },
                {
                    id: "premium",
                    pledgers: Math.round(freeTierTotal * 0.01),
                    amount: 10,
                    label: "Premium"
                },
                {
                    id: "VIP",
                    pledgers: Math.round(freeTierTotal * 0.0025),
                    amount: 50,
                    label: "VIP"
                }
            ]);
        }
    }, [
        freeTierTotal,
        isLoadingFromUrl,
        tiers.length
    ]);
    // Update tiers when audience changes - robust logic
    (0, $exYeM.useEffect)(()=>{
        if (isLoadingFromUrl || tiers.length === 0) return;
        console.log("Audience change effect triggered", {
            freeTierTotal: freeTierTotal,
            hasEditedTiers: hasEditedTiers,
            hasLoadedTiersFromUrl: hasLoadedTiersFromUrl,
            tiersLength: tiers.length
        });
        if (!hasEditedTiers && !hasLoadedTiersFromUrl) {
            // Fresh state or after reset - update all tiers based on audience
            console.log("Updating all tiers based on audience change (fresh/reset state)");
            setTiers([
                {
                    id: "free",
                    pledgers: Math.round(freeTierTotal),
                    amount: 0,
                    label: "Free"
                },
                {
                    id: "base",
                    pledgers: Math.round(freeTierTotal * 0.1),
                    amount: 5,
                    label: "Base"
                },
                {
                    id: "premium",
                    pledgers: Math.round(freeTierTotal * 0.01),
                    amount: 10,
                    label: "Premium"
                },
                {
                    id: "VIP",
                    pledgers: Math.round(freeTierTotal * 0.0025),
                    amount: 50,
                    label: "VIP"
                }
            ]);
        } else {
            // We have custom tiers (from URL or manual edits) - only update free tier
            console.log("Updating only free tier (preserving custom values)");
            setTiers((currentTiers)=>currentTiers.map((tier)=>tier.id === "free" ? {
                        ...tier,
                        pledgers: Math.round(freeTierTotal)
                    } : tier));
        }
    }, [
        freeTierTotal,
        isLoadingFromUrl,
        hasEditedTiers,
        hasLoadedTiersFromUrl
    ]);
    // Encode state into URL whenever state changes (but not during initial load)
    (0, $exYeM.useEffect)(()=>{
        if (isLoadingFromUrl || tiers.length === 0) return;
        const data = btoa(JSON.stringify({
            socialFollowers: socialFollowers,
            socialPercent: socialPercent,
            emailSubscribers: emailSubscribers,
            tiers: tiers,
            currencyName: currencyName,
            frequency: frequency
        }));
        const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + encodeURIComponent(data);
        window.history.replaceState({
            path: newurl
        }, "", newurl);
        console.log("Encoded state to URL");
    }, [
        socialFollowers,
        socialPercent,
        emailSubscribers,
        tiers,
        currencyName,
        frequency,
        isLoadingFromUrl
    ]);
    const updateTierPledgers = (0, $exYeM.useCallback)((id, pledgers)=>{
        trackModeled();
        setHasEditedTiers(true);
        setTiers((tiers)=>tiers.map((t)=>t.id === id ? {
                    ...t,
                    pledgers: pledgers
                } : t));
    }, [
        trackModeled
    ]);
    const updateTierAmount = (0, $exYeM.useCallback)((id, amount)=>{
        trackModeled();
        setHasEditedTiers(true);
        setTiers((tiers)=>tiers.map((t)=>t.id === id ? {
                    ...t,
                    amount: amount
                } : t));
    }, [
        trackModeled
    ]);
    const deleteTier = (id)=>{
        setHasEditedTiers(true);
        setTiers((tiers)=>tiers.filter((t)=>t.id !== id));
    };
    const addTier = ()=>{
        setHasEditedTiers(true);
        setTiers((tiers)=>[
                ...tiers,
                {
                    id: (0, $hTj76.default)(),
                    pledgers: 10,
                    amount: 7
                }
            ]);
    };
    const calculateStripeFee = (amount)=>amount <= 0 ? 0 : amount * 0.03 + currencies[currencyName].fee;
    const tierIncome = (tier)=>tier.amount > 0 ? (tier.amount - tier.amount * $51b1402e144fdd00$var$membershipsRake - calculateStripeFee(tier.amount)) * tier.pledgers : 0;
    const pledgeIncome = tiers.reduce((acc, t)=>acc + tierIncome(t), 0) * frequencyMultiplier;
    const currencyFormatter = new Intl.NumberFormat(currentCurrency.locale, {
        style: "currency",
        currency: currencyName,
        maximumFractionDigits: 0
    });
    const sankeyOptions = (0, $exYeM.useMemo)(()=>({
            legend: "none",
            animation: {
                duration: 1000,
                easing: "out",
                startup: true
            },
            sankey: {
                node: {
                    label: {
                        fontSize: 14,
                        bold: true
                    }
                }
            },
            tooltip: {
                isHtml: true,
                textStyle: {
                    fontSize: 14,
                    fontName: "Inter, system-ui, sans-serif"
                }
            }
        }), []);
    const sankeyData = (0, $exYeM.useMemo)(()=>{
        const totals = {
            you: 0,
            processing: 0
        };
        tiers.forEach((tier)=>{
            const amount = Number(tier.amount);
            const pledgers = Number(tier.pledgers);
            if (isNaN(amount) || isNaN(pledgers) || amount <= 0 || pledgers <= 0) return;
            totals.you += tierIncome(tier) * frequencyMultiplier;
            totals.processing += calculateStripeFee(amount) * pledgers * frequencyMultiplier;
        });
        return [
            [
                "From",
                "To",
                "Amount",
                {
                    role: "tooltip",
                    type: "string",
                    p: {
                        html: true
                    }
                }
            ],
            [
                "Members",
                "You",
                Math.round(totals.you),
                `<div style="padding: 8px; font-family: Inter, system-ui, sans-serif;"><strong>${currencyFormatter.format(Math.round(totals.you))}</strong></div>`
            ],
            [
                "Members",
                "Processing Fees",
                Math.round(totals.processing),
                `<div style="padding: 8px; font-family: Inter, system-ui, sans-serif;"><strong>${currencyFormatter.format(Math.round(totals.processing))}</strong></div>`
            ]
        ];
    }, [
        tiers,
        frequencyMultiplier,
        currencyFormatter
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "calculator space-y-6",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "mt-3 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "prose prose-sm text-balance italic",
                        children: "Try modeling your tiers below and start imagining what a direct connection with your audience could mean for your music and your future."
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex justify-end gap-2 w-full sm:w-auto",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $i9Gb7.tooltip_default), {
                                        content: "Click to copy a link to this model",
                                        placement: "left",
                                        radius: "none",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3XQiF.button_default), {
                                            isIconOnly: true,
                                            variant: "flat",
                                            radius: "none",
                                            size: "sm",
                                            className: "min-h-[44px] min-w-[44px]",
                                            onClick: ()=>{
                                                (0, $codwM.default).capture("CalculatorShare");
                                                navigator.clipboard.writeText(window.location.href);
                                                (0, (/*@__PURE__*/$parcel$interopDefault($7zbAk))).success("Copied to clipboard");
                                            },
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $afsmN.Clipboard), {
                                                size: 18
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7zbAk.Toaster), {
                                        toastOptions: {
                                            duration: 3000
                                        },
                                        containerClassName: "font-inter"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $jNBsp.select_default), {
                                size: "sm",
                                radius: "none",
                                variant: "bordered",
                                classNames: {
                                    base: "w-24 base",
                                    trigger: "shadow-none min-h-[44px]",
                                    mainWrapper: "mainwrapper",
                                    innerWrapper: "innerwrapper",
                                    label: "label"
                                },
                                id: "currency",
                                selectedKeys: [
                                    currencyName
                                ],
                                onSelectionChange: (e)=>setCurrencyName(Array.from(e)[0]),
                                children: $51b1402e144fdd00$var$currencyTypes.map((d)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $aO5Cd.listbox_item_base_default), {
                                        id: "currency",
                                        children: d.name
                                    }, d.currency))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kX516.divider_default), {}),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "sticky top-4 z-10 bg-white border border-gray-200 rounded-lg p-3 sm:p-4 shadow-sm grid gap-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                className: "prose-md sm:prose-lg font-semibold",
                                children: "Estimated Income"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex flex-row items-center justify-between gap-2 sm:gap-0",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                        className: "text-xl sm:text-2xl font-bold",
                                        children: currencyFormatter.format(pledgeIncome)
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1KY5Y.switch_default), {
                                        classNames: {
                                            label: "min-w-16"
                                        },
                                        isSelected: frequency === "yearly",
                                        onValueChange: (val)=>setFrequency(val ? "yearly" : "monthly"),
                                        children: frequency === "monthly" ? "Monthly" : "Yearly"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kX516.divider_default), {}),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $bowRT.popover_default), {
                                placement: "bottom",
                                showArrow: true,
                                triggerScaleOnOpen: false,
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dq8HR.popover_trigger_default), {
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("h3", {
                                            className: "prose-md font-semibold flex items-center hover:cursor-pointer gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    children: "Your Audience"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7nTfy.Question), {
                                                    size: 18,
                                                    weight: "fill"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fsqWO.popover_content_default), {
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "px-1 py-2",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                    className: "text-sm font-bold",
                                                    children: "Add your email list size and your total social followers."
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                    className: "text-sm text-gray-500",
                                                    children: "We'll estimate how many might join you on Sleeve. We start with your email list plus 10% of social followers as your free tier, but your fans might surprise you! From there, we estimate 10% might become paying members and 1% premium supporters."
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                    className: "text-sm text-gray-500",
                                                    children: "We'll use this to model your potential subscriber base below."
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3CO4s.input_default), {
                                        variant: "faded",
                                        type: "number",
                                        placeholder: "0.00",
                                        labelPlacement: "outside",
                                        radius: "none",
                                        endContent: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "pointer-events-none flex items-center",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $hS8Na.User), {
                                                size: 14
                                            })
                                        }),
                                        classNames: {
                                            mainWrapper: "mainwrapper",
                                            inputWrapper: "shadow-none !ps-0 inputwrapper min-h-[44px]",
                                            innerWrapper: "innerwrapper",
                                            input: "group-data-[focus=true]/text:!outline-none group-data-[focus=true]/text:!border-none !outline-none !border-none focus:ring-0 input text-base"
                                        },
                                        min: 0,
                                        value: String(emailSubscribers),
                                        onChange: (e)=>{
                                            trackModeled();
                                            setEmailSubscribers(Number(e.target.value));
                                        },
                                        label: "Email List Size"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "grid grid-cols-[1fr_120px] sm:contents gap-3 sm:gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3CO4s.input_default), {
                                                variant: "faded",
                                                type: "number",
                                                placeholder: "0.00",
                                                labelPlacement: "outside",
                                                radius: "none",
                                                endContent: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "pointer-events-none flex items-center",
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $hS8Na.User), {
                                                        size: 14
                                                    })
                                                }),
                                                classNames: {
                                                    mainWrapper: "mainwrapper",
                                                    inputWrapper: "shadow-none !ps-0 inputwrapper min-h-[44px]",
                                                    innerWrapper: "innerwrapper",
                                                    input: "group-data-[focus=true]/text:!outline-none group-data-[focus=true]/text:!border-none !outline-none !border-none focus:ring-0 input text-base"
                                                },
                                                min: 0,
                                                value: String(socialFollowers),
                                                label: "Total Social Followers",
                                                onChange: (e)=>{
                                                    trackModeled();
                                                    setSocialFollowers(Number(e.target.value));
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3CO4s.input_default), {
                                                variant: "faded",
                                                type: "number",
                                                placeholder: "0",
                                                labelPlacement: "outside",
                                                radius: "none",
                                                label: "% on Sleeve",
                                                endContent: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "pointer-events-none flex items-center",
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $glhfa.Percent), {
                                                        size: 14
                                                    })
                                                }),
                                                classNames: {
                                                    mainWrapper: "mainwrapper",
                                                    inputWrapper: "shadow-none !ps-0 inputwrapper min-h-[44px]",
                                                    innerWrapper: "innerwrapper",
                                                    input: "group-data-[focus=true]/text:!outline-none group-data-[focus=true]/text:!border-none !outline-none !border-none focus:ring-0 input text-base text-center sm:text-left"
                                                },
                                                min: 0,
                                                max: 100,
                                                value: String(socialPercent),
                                                onChange: (e)=>{
                                                    trackModeled();
                                                    setSocialPercent(Number(e.target.value));
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "px-1 sm:px-2",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $jQkMW.default), {
                    chartType: "Sankey",
                    width: "100%",
                    height: "250px",
                    data: sankeyData,
                    options: sankeyOptions
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kX516.divider_default), {}),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "px-1 sm:px-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                        className: "text-base font-semibold leading-7 text-gray-900",
                        children: "Membership Tiers"
                    }),
                    tiers.map((t, index)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "my-2",
                            children: [
                                index === 0 && /*#__PURE__*/ (0, $aSiaI.jsxs)("h3", {
                                    className: "text-sm font-semibold text-gray-900",
                                    children: [
                                        "Free Tier/Followers (",
                                        emailSubscribers.toLocaleString(),
                                        " from email list + ",
                                        socialPercent,
                                        "% of",
                                        " ",
                                        socialFollowers.toLocaleString(),
                                        " social)"
                                    ]
                                }),
                                index === 1 && /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                    className: "mt-6 text-sm font-semibold text-gray-900",
                                    children: "Paid Tiers"
                                }),
                                index === 1 && /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "mt-2 hidden sm:flex items-center gap-4 text-sm font-medium text-gray-500",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "w-1/2",
                                            children: "Members"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "w-1/2",
                                            children: "Tier Price"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "min-w-8"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "mb-4 flex flex-col gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kX516.divider_default), {
                                            className: "my-2"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4 order-2 sm:order-1",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                    className: "flex-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                            className: "block text-xs font-medium text-gray-700 mb-1 sm:hidden",
                                                            children: "Members"
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3CO4s.input_default), {
                                                            variant: "faded",
                                                            type: "number",
                                                            placeholder: "0.00",
                                                            labelPlacement: "outside",
                                                            radius: "none",
                                                            endContent: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                className: "pointer-events-none flex items-center",
                                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $hS8Na.User), {
                                                                    size: 14
                                                                })
                                                            }),
                                                            classNames: {
                                                                mainWrapper: "mainwrapper",
                                                                inputWrapper: "shadow-none !ps-0 inputwrapper min-h-[44px]",
                                                                innerWrapper: "innerwrapper",
                                                                input: "group-data-[focus=true]/text:!outline-none group-data-[focus=true]/text:!border-none !outline-none !border-none focus:ring-0 input text-base"
                                                            },
                                                            min: 0,
                                                            value: String(t.pledgers),
                                                            onChange: (e)=>updateTierPledgers(t.id, e.currentTarget.valueAsNumber)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                    className: "flex-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                            className: "block text-xs font-medium text-gray-700 mb-1 sm:hidden",
                                                            children: "Tier Price"
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3CO4s.input_default), {
                                                            variant: "faded",
                                                            type: "number",
                                                            placeholder: "0.00",
                                                            labelPlacement: "outside",
                                                            radius: "none",
                                                            startContent: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                className: "pointer-events-none flex items-center",
                                                                children: currentCurrency.symbol
                                                            }),
                                                            classNames: {
                                                                mainWrapper: "mainwrapper",
                                                                inputWrapper: "shadow-none !pe-0 inputwrapper min-h-[44px]",
                                                                innerWrapper: "innerwrapper",
                                                                input: "group-data-[focus=true]/text:!outline-none group-data-[focus=true]/text:!border-none !outline-none !border-none focus:ring-0 input text-base"
                                                            },
                                                            min: 0,
                                                            value: String(t.amount),
                                                            onChange: (e)=>updateTierAmount(t.id, e.currentTarget.valueAsNumber),
                                                            isDisabled: t.id === "free"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($eH0la)))({
                                                        "justify-center sm:justify-start": true,
                                                        "sm:invisible hidden": t.id === "free"
                                                    }),
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $3XQiF.button_default), {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($eH0la)))({
                                                            "flex items-center justify-center sm:!px-0 [&>svg]:!max-w-[32px] [&>svg]:! min-w-[32px]": true,
                                                            invisible: t.id === "free"
                                                        }),
                                                        size: "sm",
                                                        variant: "flat",
                                                        onClick: ()=>deleteTier(t.id),
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                className: "sm:hidden",
                                                                children: "Delete tier"
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kFp87.X), {
                                                                size: 16
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("p", {
                                            className: "sm:pl-2 text-base sm:text-sm text-gray-500 mb-1  mt-2 order-1 sm:order-2",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                    className: "font-semibold",
                                                    children: [
                                                        t.label,
                                                        " Tier:"
                                                    ]
                                                }),
                                                " ",
                                                t.id !== "free" && tiers[0]?.pledgers > 0 ? (()=>{
                                                    const percentage = t.pledgers / tiers[0].pledgers * 100;
                                                    if (percentage < 1 && percentage > 0) return `${percentage.toFixed(1)}%`;
                                                    return `${Math.round(percentage)}%`;
                                                })() : "",
                                                " ",
                                                t.id !== "free" && " of followers \u2022",
                                                " ",
                                                currencyFormatter.format(tierIncome(t) * frequencyMultiplier),
                                                " ",
                                                frequency
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, t.id)),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex w-full flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kX516.divider_default), {}),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                onClick: ()=>addTier(),
                                type: "button",
                                className: "inline-flex w-full items-center justify-center gap-x-1.5 bg-gray-50 px-2 py-1 text-xs font-semibold text-gray-600 shadow-sm hover:bg-gray-100 min-h-[44px]",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bU8KF.PlusCircle), {
                                        size: 16
                                    }),
                                    "Add a Tier"
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                onClick: ()=>{
                                    setHasEditedTiers(false);
                                    setHasLoadedTiersFromUrl(false);
                                    // Clear tiers to trigger re-initialization
                                    setTiers([]);
                                },
                                type: "button",
                                className: "inline-flex w-full items-center justify-center gap-x-1.5 px-2 py-1 text-xs font-semibold text-gray-600 min-h-[44px]",
                                children: "Reset Tiers to Defaults"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("3XQiF", function(module, exports) {

$parcel$export(module.exports, "button_default", function () { return $ea3deb3eae1be263$export$11c362adf4e83e40; });

var $cNkCP = parcelRequire("cNkCP");

var $e73nX = parcelRequire("e73nX");

var $2fXFb = parcelRequire("2fXFb");

var $8Oq4a = parcelRequire("8Oq4a");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $ea3deb3eae1be263$var$Button = (0, $8Oq4a.forwardRef)((props, ref)=>{
    const { Component: Component, domRef: domRef, children: children, styles: styles, spinnerSize: spinnerSize, spinner: spinner = /* @__PURE__ */ (0, $aSiaI.jsx)((0, $e73nX.spinner_default), {
        color: "current",
        size: spinnerSize
    }), spinnerPlacement: spinnerPlacement, startContent: startContent, endContent: endContent, isLoading: isLoading, disableRipple: disableRipple, getButtonProps: getButtonProps, getRippleProps: getRippleProps, isIconOnly: isIconOnly } = (0, $cNkCP.useButton)({
        ...props,
        ref: ref
    });
    return /* @__PURE__ */ (0, $aSiaI.jsxs)(Component, {
        ref: domRef,
        className: styles,
        ...getButtonProps(),
        children: [
            startContent,
            isLoading && spinnerPlacement === "start" && spinner,
            isLoading && isIconOnly ? null : children,
            isLoading && spinnerPlacement === "end" && spinner,
            endContent,
            !disableRipple && /* @__PURE__ */ (0, $aSiaI.jsx)((0, $2fXFb.ripple_default), {
                ...getRippleProps()
            })
        ]
    });
});
$ea3deb3eae1be263$var$Button.displayName = "NextUI.Button";
var $ea3deb3eae1be263$export$11c362adf4e83e40 = $ea3deb3eae1be263$var$Button;

});
parcelRegister("cNkCP", function(module, exports) {

$parcel$export(module.exports, "useButton", function () { return $df8654892bc9932b$export$ea18c227d4417cc3; });

var $iO7m5 = parcelRequire("iO7m5");

var $lJ6o6 = parcelRequire("lJ6o6");

var $jj4Oc = parcelRequire("jj4Oc");

var $exYeM = parcelRequire("exYeM");

var $k5F2B = parcelRequire("k5F2B");

var $kdWpA = parcelRequire("kdWpA");
var $8vAG4 = parcelRequire("8vAG4");

var $LA3Ym = parcelRequire("LA3Ym");
var $lfs90 = parcelRequire("lfs90");

var $aU4de = parcelRequire("aU4de");

var $i3Grl = parcelRequire("i3Grl");

var $b6W9a = parcelRequire("b6W9a");

var $9Rdlz = parcelRequire("9Rdlz");
"use client";
function $df8654892bc9932b$export$ea18c227d4417cc3(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    const groupContext = (0, $iO7m5.useButtonGroupContext)();
    const globalContext = (0, $lJ6o6.useProviderContext)();
    const isInGroup = !!groupContext;
    const { ref: ref, as: as, children: children, startContent: startContentProp, endContent: endContentProp, autoFocus: autoFocus, className: className, spinner: spinner, isLoading: isLoading = false, disableRipple: disableRippleProp = false, fullWidth: fullWidth = (_a = groupContext == null ? void 0 : groupContext.fullWidth) != null ? _a : false, radius: radius = groupContext == null ? void 0 : groupContext.radius, size: size = (_b = groupContext == null ? void 0 : groupContext.size) != null ? _b : "md", color: color = (_c = groupContext == null ? void 0 : groupContext.color) != null ? _c : "default", variant: variant = (_d = groupContext == null ? void 0 : groupContext.variant) != null ? _d : "solid", disableAnimation: disableAnimation = (_f = (_e = groupContext == null ? void 0 : groupContext.disableAnimation) != null ? _e : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _f : false, isDisabled: isDisabledProp = (_g = groupContext == null ? void 0 : groupContext.isDisabled) != null ? _g : false, isIconOnly: isIconOnly = (_h = groupContext == null ? void 0 : groupContext.isIconOnly) != null ? _h : false, spinnerPlacement: spinnerPlacement = "start", onPress: onPress, onClick: onClick, ...otherProps } = props;
    const Component = as || "button";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $lfs90.useDOMRef)(ref);
    const disableRipple = (_i = disableRippleProp || (globalContext == null ? void 0 : globalContext.disableRipple)) != null ? _i : disableAnimation;
    const { isFocusVisible: isFocusVisible, isFocused: isFocused, focusProps: focusProps } = (0, $k5F2B.useFocusRing)({
        autoFocus: autoFocus
    });
    const isDisabled = isDisabledProp || isLoading;
    const styles = (0, $exYeM.useMemo)(()=>(0, $aU4de.button)({
            size: size,
            color: color,
            variant: variant,
            radius: radius,
            fullWidth: fullWidth,
            isDisabled: isDisabled,
            isInGroup: isInGroup,
            disableAnimation: disableAnimation,
            isIconOnly: isIconOnly,
            className: className
        }), [
        size,
        color,
        variant,
        radius,
        fullWidth,
        isDisabled,
        isInGroup,
        isIconOnly,
        disableAnimation,
        className
    ]);
    const { onClick: onRippleClickHandler, onClear: onClearRipple, ripples: ripples } = (0, $9Rdlz.useRipple)();
    const handleClick = (0, $exYeM.useCallback)((e)=>{
        if (disableRipple || isDisabled || disableAnimation) return;
        domRef.current && onRippleClickHandler(e);
    }, [
        disableRipple,
        isDisabled,
        disableAnimation,
        domRef,
        onRippleClickHandler
    ]);
    const { buttonProps: ariaButtonProps, isPressed: isPressed } = (0, $i3Grl.useAriaButton)({
        elementType: as,
        isDisabled: isDisabled,
        onPress: onPress,
        onClick: (0, $kdWpA.chain)(onClick, handleClick),
        ...otherProps
    }, domRef);
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $b6W9a.useHover)({
        isDisabled: isDisabled
    });
    const getButtonProps = (0, $exYeM.useCallback)((props2 = {})=>({
            "data-disabled": (0, $jj4Oc.dataAttr)(isDisabled),
            "data-focus": (0, $jj4Oc.dataAttr)(isFocused),
            "data-pressed": (0, $jj4Oc.dataAttr)(isPressed),
            "data-focus-visible": (0, $jj4Oc.dataAttr)(isFocusVisible),
            "data-hover": (0, $jj4Oc.dataAttr)(isHovered),
            "data-loading": (0, $jj4Oc.dataAttr)(isLoading),
            ...(0, $8vAG4.mergeProps)(ariaButtonProps, focusProps, hoverProps, (0, $LA3Ym.filterDOMProps)(otherProps, {
                enabled: shouldFilterDOMProps
            }), (0, $LA3Ym.filterDOMProps)(props2))
        }), [
        isLoading,
        isDisabled,
        isFocused,
        isPressed,
        shouldFilterDOMProps,
        isFocusVisible,
        isHovered,
        ariaButtonProps,
        focusProps,
        hoverProps,
        otherProps
    ]);
    const getIconClone = (icon)=>(0, $exYeM.isValidElement)(icon) ? (0, $exYeM.cloneElement)(icon, {
            "aria-hidden": true,
            focusable: false,
            tabIndex: -1
        }) : null;
    const startContent = getIconClone(startContentProp);
    const endContent = getIconClone(endContentProp);
    const spinnerSize = (0, $exYeM.useMemo)(()=>{
        const buttonSpinnerSizeMap = {
            sm: "sm",
            md: "sm",
            lg: "md"
        };
        return buttonSpinnerSizeMap[size];
    }, [
        size
    ]);
    const getRippleProps = (0, $exYeM.useCallback)(()=>({
            ripples: ripples,
            onClear: onClearRipple
        }), [
        ripples,
        onClearRipple
    ]);
    return {
        Component: Component,
        children: children,
        domRef: domRef,
        spinner: spinner,
        styles: styles,
        startContent: startContent,
        endContent: endContent,
        isLoading: isLoading,
        spinnerPlacement: spinnerPlacement,
        spinnerSize: spinnerSize,
        disableRipple: disableRipple,
        getButtonProps: getButtonProps,
        getRippleProps: getRippleProps,
        isIconOnly: isIconOnly
    };
}

});
parcelRegister("iO7m5", function(module, exports) {

$parcel$export(module.exports, "useButtonGroupContext", function () { return $c54080133c683013$export$85d63e852e3be3b3; });

var $aC86g = parcelRequire("aC86g");
"use client";
var [$c54080133c683013$export$85041a2bb9328e33, $c54080133c683013$export$85d63e852e3be3b3] = (0, $aC86g.createContext)({
    name: "ButtonGroupContext",
    strict: false
});

});

parcelRegister("aU4de", function(module, exports) {

$parcel$export(module.exports, "button", function () { return $8d6119767fd07290$export$2ba01fb71ed41cb6; });

var $cbpib = parcelRequire("cbpib");

var $a2Moz = parcelRequire("a2Moz");

var $9dwEN = parcelRequire("9dwEN");
// src/components/button.ts
var $8d6119767fd07290$export$2ba01fb71ed41cb6 = (0, $a2Moz.tv)({
    base: [
        "z-0",
        "group",
        "relative",
        "inline-flex",
        "items-center",
        "justify-center",
        "box-border",
        "appearance-none",
        "outline-none",
        "select-none",
        "whitespace-nowrap",
        "min-w-max",
        "font-normal",
        "subpixel-antialiased",
        "overflow-hidden",
        "tap-highlight-transparent",
        "data-[pressed=true]:scale-[0.97]",
        ...(0, $9dwEN.dataFocusVisibleClasses)
    ],
    variants: {
        variant: {
            solid: "",
            bordered: "border-medium bg-transparent",
            light: "bg-transparent",
            flat: "",
            faded: "border-medium",
            shadow: "",
            ghost: "border-medium bg-transparent"
        },
        size: {
            sm: "px-3 min-w-16 h-8 text-tiny gap-2 rounded-small",
            md: "px-4 min-w-20 h-10 text-small gap-2 rounded-medium",
            lg: "px-6 min-w-24 h-12 text-medium gap-3 rounded-large"
        },
        color: {
            default: "",
            primary: "",
            secondary: "",
            success: "",
            warning: "",
            danger: ""
        },
        radius: {
            none: "rounded-none",
            sm: "rounded-small",
            md: "rounded-medium",
            lg: "rounded-large",
            full: "rounded-full"
        },
        fullWidth: {
            true: "w-full"
        },
        isDisabled: {
            true: "opacity-disabled pointer-events-none"
        },
        isInGroup: {
            true: "[&:not(:first-child):not(:last-child)]:rounded-none"
        },
        isIconOnly: {
            true: "px-0 !gap-0",
            false: "[&>svg]:max-w-[theme(spacing.8)]"
        },
        disableAnimation: {
            true: "!transition-none",
            false: "transition-transform-colors-opacity motion-reduce:transition-none"
        }
    },
    defaultVariants: {
        size: "md",
        variant: "solid",
        color: "default",
        fullWidth: false,
        isDisabled: false,
        isInGroup: false
    },
    compoundVariants: [
        {
            variant: "solid",
            color: "default",
            class: (0, $cbpib.colorVariants).solid.default
        },
        {
            variant: "solid",
            color: "primary",
            class: (0, $cbpib.colorVariants).solid.primary
        },
        {
            variant: "solid",
            color: "secondary",
            class: (0, $cbpib.colorVariants).solid.secondary
        },
        {
            variant: "solid",
            color: "success",
            class: (0, $cbpib.colorVariants).solid.success
        },
        {
            variant: "solid",
            color: "warning",
            class: (0, $cbpib.colorVariants).solid.warning
        },
        {
            variant: "solid",
            color: "danger",
            class: (0, $cbpib.colorVariants).solid.danger
        },
        {
            variant: "shadow",
            color: "default",
            class: (0, $cbpib.colorVariants).shadow.default
        },
        {
            variant: "shadow",
            color: "primary",
            class: (0, $cbpib.colorVariants).shadow.primary
        },
        {
            variant: "shadow",
            color: "secondary",
            class: (0, $cbpib.colorVariants).shadow.secondary
        },
        {
            variant: "shadow",
            color: "success",
            class: (0, $cbpib.colorVariants).shadow.success
        },
        {
            variant: "shadow",
            color: "warning",
            class: (0, $cbpib.colorVariants).shadow.warning
        },
        {
            variant: "shadow",
            color: "danger",
            class: (0, $cbpib.colorVariants).shadow.danger
        },
        {
            variant: "bordered",
            color: "default",
            class: (0, $cbpib.colorVariants).bordered.default
        },
        {
            variant: "bordered",
            color: "primary",
            class: (0, $cbpib.colorVariants).bordered.primary
        },
        {
            variant: "bordered",
            color: "secondary",
            class: (0, $cbpib.colorVariants).bordered.secondary
        },
        {
            variant: "bordered",
            color: "success",
            class: (0, $cbpib.colorVariants).bordered.success
        },
        {
            variant: "bordered",
            color: "warning",
            class: (0, $cbpib.colorVariants).bordered.warning
        },
        {
            variant: "bordered",
            color: "danger",
            class: (0, $cbpib.colorVariants).bordered.danger
        },
        {
            variant: "flat",
            color: "default",
            class: (0, $cbpib.colorVariants).flat.default
        },
        {
            variant: "flat",
            color: "primary",
            class: (0, $cbpib.colorVariants).flat.primary
        },
        {
            variant: "flat",
            color: "secondary",
            class: (0, $cbpib.colorVariants).flat.secondary
        },
        {
            variant: "flat",
            color: "success",
            class: (0, $cbpib.colorVariants).flat.success
        },
        {
            variant: "flat",
            color: "warning",
            class: (0, $cbpib.colorVariants).flat.warning
        },
        {
            variant: "flat",
            color: "danger",
            class: (0, $cbpib.colorVariants).flat.danger
        },
        {
            variant: "faded",
            color: "default",
            class: (0, $cbpib.colorVariants).faded.default
        },
        {
            variant: "faded",
            color: "primary",
            class: (0, $cbpib.colorVariants).faded.primary
        },
        {
            variant: "faded",
            color: "secondary",
            class: (0, $cbpib.colorVariants).faded.secondary
        },
        {
            variant: "faded",
            color: "success",
            class: (0, $cbpib.colorVariants).faded.success
        },
        {
            variant: "faded",
            color: "warning",
            class: (0, $cbpib.colorVariants).faded.warning
        },
        {
            variant: "faded",
            color: "danger",
            class: (0, $cbpib.colorVariants).faded.danger
        },
        {
            variant: "light",
            color: "default",
            class: [
                (0, $cbpib.colorVariants).light.default,
                "data-[hover=true]:bg-default/40"
            ]
        },
        {
            variant: "light",
            color: "primary",
            class: [
                (0, $cbpib.colorVariants).light.primary,
                "data-[hover=true]:bg-primary/20"
            ]
        },
        {
            variant: "light",
            color: "secondary",
            class: [
                (0, $cbpib.colorVariants).light.secondary,
                "data-[hover=true]:bg-secondary/20"
            ]
        },
        {
            variant: "light",
            color: "success",
            class: [
                (0, $cbpib.colorVariants).light.success,
                "data-[hover=true]:bg-success/20"
            ]
        },
        {
            variant: "light",
            color: "warning",
            class: [
                (0, $cbpib.colorVariants).light.warning,
                "data-[hover=true]:bg-warning/20"
            ]
        },
        {
            variant: "light",
            color: "danger",
            class: [
                (0, $cbpib.colorVariants).light.danger,
                "data-[hover=true]:bg-danger/20"
            ]
        },
        {
            variant: "ghost",
            color: "default",
            class: (0, $cbpib.colorVariants).ghost.default
        },
        {
            variant: "ghost",
            color: "primary",
            class: (0, $cbpib.colorVariants).ghost.primary
        },
        {
            variant: "ghost",
            color: "secondary",
            class: (0, $cbpib.colorVariants).ghost.secondary
        },
        {
            variant: "ghost",
            color: "success",
            class: (0, $cbpib.colorVariants).ghost.success
        },
        {
            variant: "ghost",
            color: "warning",
            class: (0, $cbpib.colorVariants).ghost.warning
        },
        {
            variant: "ghost",
            color: "danger",
            class: (0, $cbpib.colorVariants).ghost.danger
        },
        {
            isInGroup: true,
            class: "rounded-none first:rounded-s-medium last:rounded-e-medium"
        },
        {
            isInGroup: true,
            size: "sm",
            class: "rounded-none first:rounded-s-small last:rounded-e-small"
        },
        {
            isInGroup: true,
            size: "md",
            class: "rounded-none first:rounded-s-medium last:rounded-e-medium"
        },
        {
            isInGroup: true,
            size: "lg",
            class: "rounded-none first:rounded-s-large last:rounded-e-large"
        },
        {
            isInGroup: true,
            isRounded: true,
            class: "rounded-none first:rounded-s-full last:rounded-e-full"
        },
        {
            isInGroup: true,
            radius: "none",
            class: "rounded-none first:rounded-s-none last:rounded-e-none"
        },
        {
            isInGroup: true,
            radius: "sm",
            class: "rounded-none first:rounded-s-small last:rounded-e-small"
        },
        {
            isInGroup: true,
            radius: "md",
            class: "rounded-none first:rounded-s-medium last:rounded-e-medium"
        },
        {
            isInGroup: true,
            radius: "lg",
            class: "rounded-none first:rounded-s-large last:rounded-e-large"
        },
        {
            isInGroup: true,
            radius: "full",
            class: "rounded-none first:rounded-s-full last:rounded-e-full"
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "default",
            className: (0, $9dwEN.collapseAdjacentVariantBorders).default
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "primary",
            className: (0, $9dwEN.collapseAdjacentVariantBorders).primary
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "secondary",
            className: (0, $9dwEN.collapseAdjacentVariantBorders).secondary
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "success",
            className: (0, $9dwEN.collapseAdjacentVariantBorders).success
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "warning",
            className: (0, $9dwEN.collapseAdjacentVariantBorders).warning
        },
        {
            isInGroup: true,
            variant: [
                "ghost",
                "bordered"
            ],
            color: "danger",
            className: (0, $9dwEN.collapseAdjacentVariantBorders).danger
        },
        {
            isIconOnly: true,
            size: "sm",
            class: "min-w-8 w-8 h-8"
        },
        {
            isIconOnly: true,
            size: "md",
            class: "min-w-10 w-10 h-10"
        },
        {
            isIconOnly: true,
            size: "lg",
            class: "min-w-12 w-12 h-12"
        },
        {
            variant: [
                "solid",
                "faded",
                "flat",
                "bordered",
                "shadow"
            ],
            class: "data-[hover=true]:opacity-hover"
        }
    ]
});
var $8d6119767fd07290$export$9c686a975407e95c = (0, $a2Moz.tv)({
    base: "inline-flex items-center justify-center h-auto",
    variants: {
        fullWidth: {
            true: "w-full"
        }
    },
    defaultVariants: {
        fullWidth: false
    }
});

});
parcelRegister("cbpib", function(module, exports) {

$parcel$export(module.exports, "colorVariants", function () { return $2c933785a2b046b1$export$ac48af53e325e736; });
// src/utils/variants.ts
var $2c933785a2b046b1$var$solid = {
    default: "bg-default text-default-foreground",
    primary: "bg-primary text-primary-foreground",
    secondary: "bg-secondary text-secondary-foreground",
    success: "bg-success text-success-foreground",
    warning: "bg-warning text-warning-foreground",
    danger: "bg-danger text-danger-foreground",
    foreground: "bg-foreground text-background"
};
var $2c933785a2b046b1$var$shadow = {
    default: "shadow-lg shadow-default/50 bg-default text-default-foreground",
    primary: "shadow-lg shadow-primary/40 bg-primary text-primary-foreground",
    secondary: "shadow-lg shadow-secondary/40 bg-secondary text-secondary-foreground",
    success: "shadow-lg shadow-success/40 bg-success text-success-foreground",
    warning: "shadow-lg shadow-warning/40 bg-warning text-warning-foreground",
    danger: "shadow-lg shadow-danger/40 bg-danger text-danger-foreground",
    foreground: "shadow-lg shadow-foreground/40 bg-foreground text-background"
};
var $2c933785a2b046b1$var$bordered = {
    default: "bg-transparent border-default text-foreground",
    primary: "bg-transparent border-primary text-primary",
    secondary: "bg-transparent border-secondary text-secondary",
    success: "bg-transparent border-success text-success",
    warning: "bg-transparent border-warning text-warning",
    danger: "bg-transparent border-danger text-danger",
    foreground: "bg-transparent border-foreground text-foreground"
};
var $2c933785a2b046b1$var$flat = {
    default: "bg-default/40 text-default-foreground",
    primary: "bg-primary/20 text-primary",
    secondary: "bg-secondary/20 text-secondary",
    success: "bg-success/20 text-success-600 dark:text-success",
    warning: "bg-warning/20 text-warning-600 dark:text-warning",
    danger: "bg-danger/20 text-danger dark:text-danger-500",
    foreground: "bg-foreground/10 text-foreground"
};
var $2c933785a2b046b1$var$faded = {
    default: "border-default bg-default-100 text-default-foreground",
    primary: "border-default bg-default-100 text-primary",
    secondary: "border-default bg-default-100 text-secondary",
    success: "border-default bg-default-100 text-success",
    warning: "border-default bg-default-100 text-warning",
    danger: "border-default bg-default-100 text-danger",
    foreground: "border-default bg-default-100 text-foreground"
};
var $2c933785a2b046b1$var$light = {
    default: "bg-transparent text-default-foreground",
    primary: "bg-transparent text-primary",
    secondary: "bg-transparent text-secondary",
    success: "bg-transparent text-success",
    warning: "bg-transparent text-warning",
    danger: "bg-transparent text-danger",
    foreground: "bg-transparent text-foreground"
};
var $2c933785a2b046b1$var$ghost = {
    default: "border-default text-default-foreground hover:!bg-default",
    primary: "border-primary text-primary hover:!text-primary-foreground hover:!bg-primary",
    secondary: "border-secondary text-secondary hover:text-secondary-foreground hover:!bg-secondary",
    success: "border-success text-success hover:!text-success-foreground hover:!bg-success",
    warning: "border-warning text-warning hover:!text-warning-foreground hover:!bg-warning",
    danger: "border-danger text-danger hover:!text-danger-foreground hover:!bg-danger",
    foreground: "border-foreground text-foreground hover:!bg-foreground"
};
var $2c933785a2b046b1$export$ac48af53e325e736 = {
    solid: $2c933785a2b046b1$var$solid,
    shadow: $2c933785a2b046b1$var$shadow,
    bordered: $2c933785a2b046b1$var$bordered,
    flat: $2c933785a2b046b1$var$flat,
    faded: $2c933785a2b046b1$var$faded,
    light: $2c933785a2b046b1$var$light,
    ghost: $2c933785a2b046b1$var$ghost
};

});


parcelRegister("i3Grl", function(module, exports) {

$parcel$export(module.exports, "useAriaButton", function () { return $ccd74d4b97220b89$export$1aff6edc04132adb; });
// src/index.ts

var $9cffb = parcelRequire("9cffb");
var $8vAG4 = parcelRequire("8vAG4");

var $k5F2B = parcelRequire("k5F2B");

var $b6W9a = parcelRequire("b6W9a");
function $ccd74d4b97220b89$export$1aff6edc04132adb(props, ref) {
    let { elementType: elementType = "button", isDisabled: isDisabled, onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressChange: onPressChange, preventFocusOnPress: preventFocusOnPress, allowFocusWhenDisabled: allowFocusWhenDisabled, onClick: deprecatedOnClick, href: href, target: target, rel: rel, type: type = "button", allowTextSelectionOnPress: allowTextSelectionOnPress } = props;
    let additionalProps;
    if (elementType === "button") additionalProps = {
        type: type,
        disabled: isDisabled
    };
    else additionalProps = {
        role: "button",
        tabIndex: isDisabled ? void 0 : 0,
        href: elementType === "a" && isDisabled ? void 0 : href,
        target: elementType === "a" ? target : void 0,
        type: elementType === "input" ? type : void 0,
        disabled: elementType === "input" ? isDisabled : void 0,
        "aria-disabled": !isDisabled || elementType === "input" ? void 0 : isDisabled,
        rel: elementType === "a" ? rel : void 0
    };
    let { pressProps: pressProps, isPressed: isPressed } = (0, $b6W9a.usePress)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        allowTextSelectionOnPress: allowTextSelectionOnPress,
        ref: ref
    });
    let { focusableProps: focusableProps } = (0, $k5F2B.useFocusable)(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = (0, $8vAG4.mergeProps)(focusableProps, pressProps, (0, $9cffb.filterDOMProps)(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: (0, $8vAG4.mergeProps)(additionalProps, buttonProps, {
            "aria-haspopup": props["aria-haspopup"],
            "aria-expanded": props["aria-expanded"],
            "aria-controls": props["aria-controls"],
            "aria-pressed": props["aria-pressed"],
            onClick: (e)=>{
                deprecatedOnClick == null || deprecatedOnClick(e);
            }
        })
    };
}

});

parcelRegister("9Rdlz", function(module, exports) {

$parcel$export(module.exports, "useRipple", function () { return $6a9f943e350e896d$export$66d23405c38d2c80; });

var $luNG9 = parcelRequire("luNG9");

var $exYeM = parcelRequire("exYeM");
"use client";
function $6a9f943e350e896d$export$66d23405c38d2c80(props = {}) {
    const [ripples, setRipples] = (0, $exYeM.useState)([]);
    const onClick = (0, $exYeM.useCallback)((event)=>{
        const trigger = event.currentTarget;
        const size = Math.max(trigger.clientWidth, trigger.clientHeight);
        const rect = trigger.getBoundingClientRect();
        setRipples((prevRipples)=>[
                ...prevRipples,
                {
                    key: (0, $luNG9.getUniqueID)(prevRipples.length.toString()),
                    size: size,
                    x: event.clientX - rect.left - size / 2,
                    y: event.clientY - rect.top - size / 2
                }
            ]);
    }, []);
    const onClear = (0, $exYeM.useCallback)((key)=>{
        setRipples((prevState)=>prevState.filter((ripple)=>ripple.key !== key));
    }, []);
    return {
        ripples: ripples,
        onClick: onClick,
        onClear: onClear,
        ...props
    };
}

});


parcelRegister("e73nX", function(module, exports) {

$parcel$export(module.exports, "spinner_default", function () { return $d17b5ad027a32792$export$b67103861f057d1a; });

var $lx7mN = parcelRequire("lx7mN");

var $8Oq4a = parcelRequire("8Oq4a");

var $aSiaI = parcelRequire("aSiaI");
var $d17b5ad027a32792$var$Spinner = (0, $8Oq4a.forwardRef)((props, ref)=>{
    const { slots: slots, classNames: classNames, label: label, getSpinnerProps: getSpinnerProps } = (0, $lx7mN.useSpinner)({
        ...props
    });
    return /* @__PURE__ */ (0, $aSiaI.jsxs)("div", {
        ref: ref,
        ...getSpinnerProps(),
        children: [
            /* @__PURE__ */ (0, $aSiaI.jsxs)("div", {
                className: slots.wrapper({
                    class: classNames == null ? void 0 : classNames.wrapper
                }),
                children: [
                    /* @__PURE__ */ (0, $aSiaI.jsx)("i", {
                        className: slots.circle1({
                            class: classNames == null ? void 0 : classNames.circle1
                        })
                    }),
                    /* @__PURE__ */ (0, $aSiaI.jsx)("i", {
                        className: slots.circle2({
                            class: classNames == null ? void 0 : classNames.circle2
                        })
                    })
                ]
            }),
            label && /* @__PURE__ */ (0, $aSiaI.jsx)("span", {
                className: slots.label({
                    class: classNames == null ? void 0 : classNames.label
                }),
                children: label
            })
        ]
    });
});
$d17b5ad027a32792$var$Spinner.displayName = "NextUI.Spinner";
var $d17b5ad027a32792$export$b67103861f057d1a = $d17b5ad027a32792$var$Spinner;

});
parcelRegister("lx7mN", function(module, exports) {

$parcel$export(module.exports, "useSpinner", function () { return $ed70d977d9e2a75c$export$21495182eeff761c; });
// src/use-spinner.ts

var $8Oq4a = parcelRequire("8Oq4a");

var $eROom = parcelRequire("eROom");

var $6pmNA = parcelRequire("6pmNA");
var $luNG9 = parcelRequire("luNG9");

var $exYeM = parcelRequire("exYeM");
function $ed70d977d9e2a75c$export$21495182eeff761c(originalProps) {
    const [props, variantProps] = (0, $8Oq4a.mapPropsVariants)(originalProps, (0, $eROom.spinner).variantKeys);
    const { children: children, className: className, classNames: classNames, label: labelProp, ...otherProps } = props;
    const slots = (0, $exYeM.useMemo)(()=>(0, $eROom.spinner)({
            ...variantProps
        }), [
        (0, $luNG9.objectToDeps)(variantProps)
    ]);
    const baseStyles = (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.base, className);
    const label = labelProp || children;
    const ariaLabel = (0, $exYeM.useMemo)(()=>{
        if (label && typeof label === "string") return label;
        return !otherProps["aria-label"] ? "Loading" : "";
    }, [
        children,
        label,
        otherProps["aria-label"]
    ]);
    const getSpinnerProps = (0, $exYeM.useCallback)(()=>({
            "aria-label": ariaLabel,
            className: slots.base({
                class: baseStyles
            }),
            ...otherProps
        }), [
        ariaLabel,
        slots,
        baseStyles,
        otherProps
    ]);
    return {
        label: label,
        slots: slots,
        classNames: classNames,
        getSpinnerProps: getSpinnerProps
    };
}

});
parcelRegister("eROom", function(module, exports) {

$parcel$export(module.exports, "spinner", function () { return $3f72df31d31a8ebe$export$641374ffb95bc399; });

var $a2Moz = parcelRequire("a2Moz");
// src/components/spinner.ts
var $3f72df31d31a8ebe$export$641374ffb95bc399 = (0, $a2Moz.tv)({
    slots: {
        base: "relative inline-flex flex-col gap-2 items-center justify-center",
        wrapper: "relative flex",
        circle1: [
            "absolute",
            "w-full",
            "h-full",
            "rounded-full",
            "animate-spinner-ease-spin",
            "border-2",
            "border-solid",
            "border-t-transparent",
            "border-l-transparent",
            "border-r-transparent"
        ],
        circle2: [
            "absolute",
            "w-full",
            "h-full",
            "rounded-full",
            "opacity-75",
            "animate-spinner-linear-spin",
            "border-2",
            "border-dotted",
            "border-t-transparent",
            "border-l-transparent",
            "border-r-transparent"
        ],
        label: "text-foreground dark:text-foreground-dark font-regular"
    },
    variants: {
        size: {
            sm: {
                wrapper: "w-5 h-5",
                circle1: "border-2",
                circle2: "border-2",
                label: "text-small"
            },
            md: {
                wrapper: "w-8 h-8",
                circle1: "border-3",
                circle2: "border-3",
                label: "text-medium"
            },
            lg: {
                wrapper: "w-10 h-10",
                circle1: "border-3",
                circle2: "border-3",
                label: "text-large"
            }
        },
        color: {
            current: {
                circle1: "border-b-current",
                circle2: "border-b-current"
            },
            white: {
                circle1: "border-b-white",
                circle2: "border-b-white"
            },
            default: {
                circle1: "border-b-default",
                circle2: "border-b-default"
            },
            primary: {
                circle1: "border-b-primary",
                circle2: "border-b-primary"
            },
            secondary: {
                circle1: "border-b-secondary",
                circle2: "border-b-secondary"
            },
            success: {
                circle1: "border-b-success",
                circle2: "border-b-success"
            },
            warning: {
                circle1: "border-b-warning",
                circle2: "border-b-warning"
            },
            danger: {
                circle1: "border-b-danger",
                circle2: "border-b-danger"
            }
        },
        labelColor: {
            foreground: {
                label: "text-foreground"
            },
            primary: {
                label: "text-primary"
            },
            secondary: {
                label: "text-secondary"
            },
            success: {
                label: "text-success"
            },
            warning: {
                label: "text-warning"
            },
            danger: {
                label: "text-danger"
            }
        }
    },
    defaultVariants: {
        size: "md",
        color: "primary",
        labelColor: "foreground"
    }
});

});



parcelRegister("2fXFb", function(module, exports) {

$parcel$export(module.exports, "ripple_default", function () { return $131b6e7ff196d91e$export$db886ec4bd2671e8; });

var $3kiob = parcelRequire("3kiob");
var $dVYhV = parcelRequire("dVYhV");
var $b0UTF = parcelRequire("b0UTF");
var $gtP8X = parcelRequire("gtP8X");

var $kIdd2 = parcelRequire("kIdd2");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $131b6e7ff196d91e$var$Ripple = (props)=>{
    const { ripples: ripples = [], motionProps: motionProps, color: color = "currentColor", style: style, onClear: onClear } = props;
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: ripples.map((ripple)=>{
            const duration = (0, $kIdd2.clamp)(0.01 * ripple.size, 0.2, ripple.size > 100 ? 0.75 : 0.5);
            return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $b0UTF.LazyMotion), {
                features: (0, $dVYhV.domAnimation),
                children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $3kiob.AnimatePresence), {
                    mode: "popLayout",
                    children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $gtP8X.m).span, {
                        animate: {
                            transform: "scale(2)",
                            opacity: 0
                        },
                        className: "nextui-ripple",
                        exit: {
                            opacity: 0
                        },
                        initial: {
                            transform: "scale(0)",
                            opacity: 0.35
                        },
                        style: {
                            position: "absolute",
                            backgroundColor: color,
                            borderRadius: "100%",
                            transformOrigin: "center",
                            pointerEvents: "none",
                            overflow: "hidden",
                            inset: 0,
                            zIndex: 0,
                            top: ripple.y,
                            left: ripple.x,
                            width: `${ripple.size}px`,
                            height: `${ripple.size}px`,
                            ...style
                        },
                        transition: {
                            duration: duration
                        },
                        onAnimationComplete: ()=>{
                            onClear(ripple.key);
                        },
                        ...motionProps
                    })
                })
            }, ripple.key);
        })
    });
};
$131b6e7ff196d91e$var$Ripple.displayName = "NextUI.Ripple";
var $131b6e7ff196d91e$export$db886ec4bd2671e8 = $131b6e7ff196d91e$var$Ripple;

});
parcelRegister("kIdd2", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $30b9e06e0d0ea098$export$7d15b64cf5a3a4c4; });
// src/numbers.ts
function $30b9e06e0d0ea098$export$d02631cccf789723(start, end) {
    const length = end - start + 1;
    return Array.from({
        length: length
    }, (_, index)=>index + start);
}
function $30b9e06e0d0ea098$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $30b9e06e0d0ea098$export$b7cb35a8bec19265(value, max = 100) {
    return Math.min(Math.max(value, 0), max);
}

});



parcelRegister("3CO4s", function(module, exports) {

$parcel$export(module.exports, "input_default", function () { return $87e9eb074c8401c2$export$921a3451e53aa4ce; });

var $9M64r = parcelRequire("9M64r");

var $9eroa = parcelRequire("9eroa");

var $exYeM = parcelRequire("exYeM");

var $8Oq4a = parcelRequire("8Oq4a");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $87e9eb074c8401c2$var$Input = (0, $8Oq4a.forwardRef)((props, ref)=>{
    const { Component: Component, label: label, description: description, isClearable: isClearable, startContent: startContent, endContent: endContent, labelPlacement: labelPlacement, hasHelper: hasHelper, isOutsideLeft: isOutsideLeft, shouldLabelBeOutside: shouldLabelBeOutside, errorMessage: errorMessage, isInvalid: isInvalid, getBaseProps: getBaseProps, getLabelProps: getLabelProps, getInputProps: getInputProps, getInnerWrapperProps: getInnerWrapperProps, getInputWrapperProps: getInputWrapperProps, getMainWrapperProps: getMainWrapperProps, getHelperWrapperProps: getHelperWrapperProps, getDescriptionProps: getDescriptionProps, getErrorMessageProps: getErrorMessageProps, getClearButtonProps: getClearButtonProps } = (0, $9M64r.useInput)({
        ...props,
        ref: ref
    });
    const labelContent = label ? /* @__PURE__ */ (0, $aSiaI.jsx)("label", {
        ...getLabelProps(),
        children: label
    }) : null;
    const end = (0, $exYeM.useMemo)(()=>{
        if (isClearable) return /* @__PURE__ */ (0, $aSiaI.jsx)("span", {
            ...getClearButtonProps(),
            children: endContent || /* @__PURE__ */ (0, $aSiaI.jsx)((0, $9eroa.CloseFilledIcon), {})
        });
        return endContent;
    }, [
        isClearable,
        getClearButtonProps
    ]);
    const helperWrapper = (0, $exYeM.useMemo)(()=>{
        if (!hasHelper) return null;
        return /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
            ...getHelperWrapperProps(),
            children: isInvalid && errorMessage ? /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
                ...getErrorMessageProps(),
                children: errorMessage
            }) : description ? /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
                ...getDescriptionProps(),
                children: description
            }) : null
        });
    }, [
        hasHelper,
        isInvalid,
        errorMessage,
        description,
        getHelperWrapperProps,
        getErrorMessageProps,
        getDescriptionProps
    ]);
    const innerWrapper = (0, $exYeM.useMemo)(()=>{
        return /* @__PURE__ */ (0, $aSiaI.jsxs)("div", {
            ...getInnerWrapperProps(),
            children: [
                startContent,
                /* @__PURE__ */ (0, $aSiaI.jsx)("input", {
                    ...getInputProps()
                }),
                end
            ]
        });
    }, [
        startContent,
        end,
        getInputProps,
        getInnerWrapperProps
    ]);
    const mainWrapper = (0, $exYeM.useMemo)(()=>{
        if (shouldLabelBeOutside) return /* @__PURE__ */ (0, $aSiaI.jsxs)("div", {
            ...getMainWrapperProps(),
            children: [
                /* @__PURE__ */ (0, $aSiaI.jsxs)("div", {
                    ...getInputWrapperProps(),
                    children: [
                        !isOutsideLeft ? labelContent : null,
                        innerWrapper
                    ]
                }),
                helperWrapper
            ]
        });
        return /* @__PURE__ */ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
            children: [
                /* @__PURE__ */ (0, $aSiaI.jsxs)("div", {
                    ...getInputWrapperProps(),
                    children: [
                        labelContent,
                        innerWrapper
                    ]
                }),
                helperWrapper
            ]
        });
    }, [
        labelPlacement,
        helperWrapper,
        shouldLabelBeOutside,
        labelContent,
        innerWrapper,
        errorMessage,
        description,
        getMainWrapperProps,
        getInputWrapperProps,
        getErrorMessageProps,
        getDescriptionProps
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsxs)(Component, {
        ...getBaseProps(),
        children: [
            isOutsideLeft ? labelContent : null,
            mainWrapper
        ]
    });
});
$87e9eb074c8401c2$var$Input.displayName = "NextUI.Input";
var $87e9eb074c8401c2$export$921a3451e53aa4ce = $87e9eb074c8401c2$var$Input;

});
parcelRegister("9M64r", function(module, exports) {

$parcel$export(module.exports, "useInput", function () { return $2819ccce00e7da3b$export$1e36b9f257eee5fa; });

var $8Oq4a = parcelRequire("8Oq4a");
var $lJ6o6 = parcelRequire("lJ6o6");

var $7Qd7T = parcelRequire("7Qd7T");

var $k5F2B = parcelRequire("k5F2B");

var $eZiM8 = parcelRequire("eZiM8");

var $LA3Ym = parcelRequire("LA3Ym");
var $lfs90 = parcelRequire("lfs90");

var $b6W9a = parcelRequire("b6W9a");

var $6pmNA = parcelRequire("6pmNA");
var $jj4Oc = parcelRequire("jj4Oc");
var $luNG9 = parcelRequire("luNG9");
var $cF4U7 = parcelRequire("cF4U7");

var $eR6bz = parcelRequire("eR6bz");

var $exYeM = parcelRequire("exYeM");

var $kdWpA = parcelRequire("kdWpA");
var $8vAG4 = parcelRequire("8vAG4");

var $649vw = parcelRequire("649vw");
"use client";
function $2819ccce00e7da3b$export$1e36b9f257eee5fa(originalProps) {
    var _a, _b, _c, _d;
    const globalContext = (0, $lJ6o6.useProviderContext)();
    const [props, variantProps] = (0, $8Oq4a.mapPropsVariants)(originalProps, (0, $eZiM8.input).variantKeys);
    const { ref: ref, as: as, type: type, label: label, baseRef: baseRef, wrapperRef: wrapperRef, description: description, className: className, classNames: classNames, autoFocus: autoFocus, startContent: startContent, endContent: endContent, onClear: onClear, onChange: onChange, validationState: validationState, validationBehavior: validationBehavior = (_a = globalContext == null ? void 0 : globalContext.validationBehavior) != null ? _a : "aria", innerWrapperRef: innerWrapperRefProp, onValueChange: onValueChange = ()=>{}, ...otherProps } = props;
    const handleValueChange = (0, $exYeM.useCallback)((value)=>{
        onValueChange(value != null ? value : "");
    }, [
        onValueChange
    ]);
    const [isFocusWithin, setFocusWithin] = (0, $exYeM.useState)(false);
    const Component = as || "div";
    const disableAnimation = (_c = (_b = originalProps.disableAnimation) != null ? _b : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _c : false;
    const domRef = (0, $lfs90.useDOMRef)(ref);
    const baseDomRef = (0, $lfs90.useDOMRef)(baseRef);
    const inputWrapperRef = (0, $lfs90.useDOMRef)(wrapperRef);
    const innerWrapperRef = (0, $lfs90.useDOMRef)(innerWrapperRefProp);
    const [inputValue, setInputValue] = (0, $eR6bz.useControlledState)(props.value, (_d = props.defaultValue) != null ? _d : "", handleValueChange);
    const isFilledByDefault = [
        "date",
        "time",
        "month",
        "week",
        "range"
    ].includes(type);
    const isFilled = !(0, $jj4Oc.isEmpty)(inputValue) || isFilledByDefault;
    const isFilledWithin = isFilled || isFocusWithin;
    const baseStyles = (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.base, className, isFilled ? "is-filled" : "");
    const isMultiline = originalProps.isMultiline;
    const handleClear = (0, $exYeM.useCallback)(()=>{
        var _a2;
        setInputValue("");
        onClear == null || onClear();
        (_a2 = domRef.current) == null || _a2.focus();
    }, [
        setInputValue,
        onClear
    ]);
    (0, $7Qd7T.useSafeLayoutEffect)(()=>{
        if (!domRef.current) return;
        setInputValue(domRef.current.value);
    }, [
        domRef.current
    ]);
    const { labelProps: labelProps, inputProps: inputProps, isInvalid: isAriaInvalid, validationErrors: validationErrors, validationDetails: validationDetails, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $649vw.useTextField)({
        ...originalProps,
        validationBehavior: validationBehavior,
        autoCapitalize: originalProps.autoCapitalize,
        value: inputValue,
        "aria-label": (0, $cF4U7.safeAriaLabel)(originalProps["aria-label"], originalProps.label, originalProps.placeholder),
        inputElementType: isMultiline ? "textarea" : "input",
        onChange: setInputValue
    }, domRef);
    const { isFocusVisible: isFocusVisible, isFocused: isFocused, focusProps: focusProps } = (0, $k5F2B.useFocusRing)({
        autoFocus: autoFocus,
        isTextInput: true
    });
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $b6W9a.useHover)({
        isDisabled: !!(originalProps == null ? void 0 : originalProps.isDisabled)
    });
    const { focusProps: clearFocusProps, isFocusVisible: isClearButtonFocusVisible } = (0, $k5F2B.useFocusRing)();
    const { focusWithinProps: focusWithinProps } = (0, $b6W9a.useFocusWithin)({
        onFocusWithinChange: setFocusWithin
    });
    const { pressProps: clearPressProps } = (0, $b6W9a.usePress)({
        isDisabled: !!(originalProps == null ? void 0 : originalProps.isDisabled),
        onPress: handleClear
    });
    const isInvalid = validationState === "invalid" || originalProps.isInvalid || isAriaInvalid;
    const labelPlacement = (0, $exYeM.useMemo)(()=>{
        var _a2;
        if ((!originalProps.labelPlacement || originalProps.labelPlacement === "inside") && !label) return "outside";
        return (_a2 = originalProps.labelPlacement) != null ? _a2 : "inside";
    }, [
        originalProps.labelPlacement,
        label
    ]);
    const errorMessage = typeof props.errorMessage === "function" ? props.errorMessage({
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    }) : props.errorMessage || (validationErrors == null ? void 0 : validationErrors.join(" "));
    const isClearable = !!onClear || originalProps.isClearable;
    const hasElements = !!label || !!description || !!errorMessage;
    const hasPlaceholder = !!props.placeholder;
    const hasLabel = !!label;
    const hasHelper = !!description || !!errorMessage;
    const shouldLabelBeOutside = labelPlacement === "outside" || labelPlacement === "outside-left";
    const shouldLabelBeInside = labelPlacement === "inside";
    const isPlaceholderShown = domRef.current ? (!domRef.current.value || domRef.current.value === "" || !inputValue || inputValue === "") && hasPlaceholder : false;
    const isOutsideLeft = labelPlacement === "outside-left";
    const hasStartContent = !!startContent;
    const isLabelOutside = shouldLabelBeOutside ? labelPlacement === "outside-left" || hasPlaceholder || labelPlacement === "outside" && hasStartContent : false;
    const isLabelOutsideAsPlaceholder = labelPlacement === "outside" && !hasPlaceholder && !hasStartContent;
    const slots = (0, $exYeM.useMemo)(()=>(0, $eZiM8.input)({
            ...variantProps,
            isInvalid: isInvalid,
            labelPlacement: labelPlacement,
            isClearable: isClearable,
            disableAnimation: disableAnimation
        }), [
        (0, $luNG9.objectToDeps)(variantProps),
        isInvalid,
        labelPlacement,
        isClearable,
        hasStartContent,
        disableAnimation
    ]);
    const getBaseProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ref: baseDomRef,
            className: slots.base({
                class: baseStyles
            }),
            "data-slot": "base",
            "data-filled": (0, $jj4Oc.dataAttr)(isFilled || hasPlaceholder || hasStartContent || isPlaceholderShown),
            "data-filled-within": (0, $jj4Oc.dataAttr)(isFilledWithin || hasPlaceholder || hasStartContent || isPlaceholderShown),
            "data-focus-within": (0, $jj4Oc.dataAttr)(isFocusWithin),
            "data-focus-visible": (0, $jj4Oc.dataAttr)(isFocusVisible),
            "data-readonly": (0, $jj4Oc.dataAttr)(originalProps.isReadOnly),
            "data-focus": (0, $jj4Oc.dataAttr)(isFocused),
            "data-hover": (0, $jj4Oc.dataAttr)(isHovered),
            "data-required": (0, $jj4Oc.dataAttr)(originalProps.isRequired),
            "data-invalid": (0, $jj4Oc.dataAttr)(isInvalid),
            "data-disabled": (0, $jj4Oc.dataAttr)(originalProps.isDisabled),
            "data-has-elements": (0, $jj4Oc.dataAttr)(hasElements),
            "data-has-helper": (0, $jj4Oc.dataAttr)(hasHelper),
            "data-has-label": (0, $jj4Oc.dataAttr)(hasLabel),
            "data-has-value": (0, $jj4Oc.dataAttr)(!isPlaceholderShown),
            ...focusWithinProps,
            ...props2
        };
    }, [
        slots,
        baseStyles,
        isFilled,
        isFocused,
        isHovered,
        isInvalid,
        hasHelper,
        hasLabel,
        hasElements,
        isPlaceholderShown,
        hasStartContent,
        isFocusWithin,
        isFocusVisible,
        isFilledWithin,
        hasPlaceholder,
        focusWithinProps,
        originalProps.isReadOnly,
        originalProps.isRequired,
        originalProps.isDisabled
    ]);
    const getLabelProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            "data-slot": "label",
            className: slots.label({
                class: classNames == null ? void 0 : classNames.label
            }),
            ...labelProps,
            ...props2
        };
    }, [
        slots,
        labelProps,
        classNames == null ? void 0 : classNames.label
    ]);
    const getInputProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ref: domRef,
            "data-slot": "input",
            "data-filled": (0, $jj4Oc.dataAttr)(isFilled),
            "data-filled-within": (0, $jj4Oc.dataAttr)(isFilledWithin),
            "data-has-start-content": (0, $jj4Oc.dataAttr)(hasStartContent),
            "data-has-end-content": (0, $jj4Oc.dataAttr)(!!endContent),
            className: slots.input({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.input, isFilled ? "is-filled" : "")
            }),
            ...(0, $8vAG4.mergeProps)(focusProps, inputProps, (0, $LA3Ym.filterDOMProps)(otherProps, {
                enabled: true,
                labelable: true,
                omitEventNames: new Set(Object.keys(inputProps))
            }), props2),
            "aria-readonly": (0, $jj4Oc.dataAttr)(originalProps.isReadOnly),
            onChange: (0, $kdWpA.chain)(inputProps.onChange, onChange)
        };
    }, [
        slots,
        inputValue,
        focusProps,
        inputProps,
        otherProps,
        isFilled,
        isFilledWithin,
        hasStartContent,
        endContent,
        classNames == null ? void 0 : classNames.input,
        originalProps.isReadOnly,
        originalProps.isRequired,
        onChange
    ]);
    const getInputWrapperProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ref: inputWrapperRef,
            "data-slot": "input-wrapper",
            "data-hover": (0, $jj4Oc.dataAttr)(isHovered),
            "data-focus-visible": (0, $jj4Oc.dataAttr)(isFocusVisible),
            "data-focus": (0, $jj4Oc.dataAttr)(isFocused),
            className: slots.inputWrapper({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.inputWrapper, isFilled ? "is-filled" : "")
            }),
            ...(0, $8vAG4.mergeProps)(props2, hoverProps),
            onClick: (e)=>{
                if (domRef.current && e.currentTarget === e.target) domRef.current.focus();
            },
            style: {
                cursor: "text",
                ...props2.style
            }
        };
    }, [
        slots,
        isHovered,
        isFocusVisible,
        isFocused,
        inputValue,
        classNames == null ? void 0 : classNames.inputWrapper
    ]);
    const getInnerWrapperProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ref: innerWrapperRef,
            "data-slot": "inner-wrapper",
            onClick: (e)=>{
                if (domRef.current && e.currentTarget === e.target) domRef.current.focus();
            },
            className: slots.innerWrapper({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.innerWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.innerWrapper
    ]);
    const getMainWrapperProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "main-wrapper",
            className: slots.mainWrapper({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.mainWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.mainWrapper
    ]);
    const getHelperWrapperProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "helper-wrapper",
            className: slots.helperWrapper({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.helperWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.helperWrapper
    ]);
    const getDescriptionProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ...descriptionProps,
            "data-slot": "description",
            className: slots.description({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.description, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.description
    ]);
    const getErrorMessageProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ...errorMessageProps,
            "data-slot": "error-message",
            className: slots.errorMessage({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.errorMessage, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        errorMessageProps,
        classNames == null ? void 0 : classNames.errorMessage
    ]);
    const getClearButtonProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ...props2,
            role: "button",
            tabIndex: 0,
            "data-slot": "clear-button",
            "data-focus-visible": (0, $jj4Oc.dataAttr)(isClearButtonFocusVisible),
            className: slots.clearButton({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.clearButton, props2 == null ? void 0 : props2.className)
            }),
            ...(0, $8vAG4.mergeProps)(clearPressProps, clearFocusProps)
        };
    }, [
        slots,
        isClearButtonFocusVisible,
        clearPressProps,
        clearFocusProps,
        classNames == null ? void 0 : classNames.clearButton
    ]);
    return {
        Component: Component,
        classNames: classNames,
        domRef: domRef,
        label: label,
        description: description,
        startContent: startContent,
        endContent: endContent,
        labelPlacement: labelPlacement,
        isClearable: isClearable,
        hasHelper: hasHelper,
        hasStartContent: hasStartContent,
        isLabelOutside: isLabelOutside,
        isOutsideLeft: isOutsideLeft,
        isLabelOutsideAsPlaceholder: isLabelOutsideAsPlaceholder,
        shouldLabelBeOutside: shouldLabelBeOutside,
        shouldLabelBeInside: shouldLabelBeInside,
        hasPlaceholder: hasPlaceholder,
        isInvalid: isInvalid,
        errorMessage: errorMessage,
        getBaseProps: getBaseProps,
        getLabelProps: getLabelProps,
        getInputProps: getInputProps,
        getMainWrapperProps: getMainWrapperProps,
        getInputWrapperProps: getInputWrapperProps,
        getInnerWrapperProps: getInnerWrapperProps,
        getHelperWrapperProps: getHelperWrapperProps,
        getDescriptionProps: getDescriptionProps,
        getErrorMessageProps: getErrorMessageProps,
        getClearButtonProps: getClearButtonProps
    };
}

});
parcelRegister("7Qd7T", function(module, exports) {

$parcel$export(module.exports, "useSafeLayoutEffect", function () { return $ef7b23cf45589dba$export$deebe11a338de063; });
// src/index.ts

var $exYeM = parcelRequire("exYeM");
var $ef7b23cf45589dba$export$deebe11a338de063 = Boolean(globalThis == null ? void 0 : globalThis.document) ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);

});

parcelRegister("eZiM8", function(module, exports) {

$parcel$export(module.exports, "input", function () { return $5cd7e5f2fea94ed9$export$b7e3ae3d7c15e42e; });

var $a2Moz = parcelRequire("a2Moz");

var $9dwEN = parcelRequire("9dwEN");
// src/components/input.ts
var $5cd7e5f2fea94ed9$export$b7e3ae3d7c15e42e = (0, $a2Moz.tv)({
    slots: {
        base: "group flex flex-col",
        label: [
            "absolute",
            "z-10",
            "pointer-events-none",
            "origin-top-left",
            "rtl:origin-top-right",
            "subpixel-antialiased",
            "block",
            "text-small",
            "text-foreground-500"
        ],
        mainWrapper: "h-full",
        inputWrapper: "relative w-full inline-flex tap-highlight-transparent flex-row items-center shadow-sm px-3 gap-3",
        innerWrapper: "inline-flex w-full items-center h-full box-border",
        input: [
            "w-full font-normal bg-transparent !outline-none placeholder:text-foreground-500 focus-visible:outline-none",
            "data-[has-start-content=true]:ps-1.5",
            "data-[has-end-content=true]:pe-1.5"
        ],
        clearButton: [
            "p-2",
            "-m-2",
            "z-10",
            "hidden",
            "absolute",
            "right-3",
            "rtl:right-auto",
            "rtl:left-3",
            "appearance-none",
            "outline-none",
            "select-none",
            "opacity-0",
            "hover:!opacity-100",
            "cursor-pointer",
            "active:!opacity-70",
            "rounded-full",
            ...(0, $9dwEN.dataFocusVisibleClasses)
        ],
        helperWrapper: "hidden group-data-[has-helper=true]:flex p-1 relative flex-col gap-1.5",
        description: "text-tiny text-foreground-400",
        errorMessage: "text-tiny text-danger"
    },
    variants: {
        variant: {
            flat: {
                inputWrapper: [
                    "bg-default-100",
                    "data-[hover=true]:bg-default-200",
                    "group-data-[focus=true]:bg-default-100"
                ]
            },
            faded: {
                inputWrapper: [
                    "bg-default-100",
                    "border-medium",
                    "border-default-200",
                    "data-[hover=true]:border-default-400"
                ],
                value: "group-data-[has-value=true]:text-default-foreground"
            },
            bordered: {
                inputWrapper: [
                    "border-medium",
                    "border-default-200",
                    "data-[hover=true]:border-default-400",
                    "group-data-[focus=true]:border-default-foreground"
                ]
            },
            underlined: {
                inputWrapper: [
                    "!px-1",
                    "!pb-0",
                    "!gap-0",
                    "relative",
                    "box-border",
                    "border-b-medium",
                    "shadow-[0_1px_0px_0_rgba(0,0,0,0.05)]",
                    "border-default-200",
                    "!rounded-none",
                    "hover:border-default-300",
                    "after:content-['']",
                    "after:w-0",
                    "after:origin-center",
                    "after:bg-default-foreground",
                    "after:absolute",
                    "after:left-1/2",
                    "after:-translate-x-1/2",
                    "after:-bottom-[2px]",
                    "after:h-[2px]",
                    "group-data-[focus=true]:after:w-full"
                ],
                innerWrapper: "pb-1",
                label: "group-data-[filled-within=true]:text-foreground"
            }
        },
        color: {
            default: {},
            primary: {},
            secondary: {},
            success: {},
            warning: {},
            danger: {}
        },
        size: {
            sm: {
                label: "text-tiny",
                inputWrapper: "h-8 min-h-8 px-2 rounded-small",
                input: "text-small",
                clearButton: "text-medium"
            },
            md: {
                inputWrapper: "h-10 min-h-10 rounded-medium",
                input: "text-small",
                clearButton: "text-large"
            },
            lg: {
                inputWrapper: "h-12 min-h-12 rounded-large",
                input: "text-medium",
                clearButton: "text-large"
            }
        },
        radius: {
            none: {
                inputWrapper: "rounded-none"
            },
            sm: {
                inputWrapper: "rounded-small"
            },
            md: {
                inputWrapper: "rounded-medium"
            },
            lg: {
                inputWrapper: "rounded-large"
            },
            full: {
                inputWrapper: "rounded-full"
            }
        },
        labelPlacement: {
            outside: {
                mainWrapper: "flex flex-col"
            },
            "outside-left": {
                base: "flex-row items-center flex-nowrap data-[has-helper=true]:items-start",
                inputWrapper: "flex-1",
                mainWrapper: "flex flex-col",
                label: "relative text-foreground pr-2 rtl:pr-0 rtl:pl-2"
            },
            inside: {
                label: "text-tiny cursor-text",
                inputWrapper: "flex-col items-start justify-center gap-0",
                innerWrapper: "group-data-[has-label=true]:items-end"
            }
        },
        fullWidth: {
            true: {
                base: "w-full"
            }
        },
        isClearable: {
            true: {
                input: "peer pr-6 rtl:pr-0 rtl:pl-6",
                clearButton: "peer-data-[filled=true]:opacity-70 peer-data-[filled=true]:block"
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none",
                inputWrapper: "pointer-events-none",
                label: "pointer-events-none"
            }
        },
        isInvalid: {
            true: {
                label: "!text-danger",
                input: "!placeholder:text-danger !text-danger"
            }
        },
        isRequired: {
            true: {
                label: "after:content-['*'] after:text-danger after:ml-0.5 rtl:after:ml-[unset] rtl:after:mr-0.5"
            }
        },
        isMultiline: {
            true: {
                label: "relative",
                inputWrapper: "!h-auto",
                innerWrapper: "items-start group-data-[has-label=true]:items-start",
                input: "resize-none data-[hide-scroll=true]:scrollbar-hide"
            }
        },
        disableAnimation: {
            true: {
                input: "transition-none",
                inputWrapper: "transition-none",
                label: "transition-none"
            },
            false: {
                inputWrapper: "transition-background motion-reduce:transition-none !duration-150",
                label: [
                    "will-change-auto",
                    "!duration-200",
                    "!ease-out",
                    "motion-reduce:transition-none",
                    "transition-[transform,color,left,opacity]"
                ],
                clearButton: [
                    "transition-opacity",
                    "motion-reduce:transition-none"
                ]
            }
        }
    },
    defaultVariants: {
        variant: "flat",
        color: "default",
        size: "md",
        fullWidth: true,
        labelPlacement: "inside",
        isDisabled: false,
        isMultiline: false
    },
    compoundVariants: [
        {
            variant: "flat",
            color: "default",
            class: {
                input: "group-data-[has-value=true]:text-default-foreground"
            }
        },
        {
            variant: "flat",
            color: "primary",
            class: {
                inputWrapper: [
                    "bg-primary-50",
                    "data-[hover=true]:bg-primary-100",
                    "text-primary",
                    "group-data-[focus=true]:bg-primary-50",
                    "placeholder:text-primary"
                ],
                input: "placeholder:text-primary",
                label: "text-primary"
            }
        },
        {
            variant: "flat",
            color: "secondary",
            class: {
                inputWrapper: [
                    "bg-secondary-50",
                    "text-secondary",
                    "data-[hover=true]:bg-secondary-100",
                    "group-data-[focus=true]:bg-secondary-50",
                    "placeholder:text-secondary"
                ],
                input: "placeholder:text-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "flat",
            color: "success",
            class: {
                inputWrapper: [
                    "bg-success-50",
                    "text-success-600",
                    "dark:text-success",
                    "placeholder:text-success-600",
                    "dark:placeholder:text-success",
                    "data-[hover=true]:bg-success-100",
                    "group-data-[focus=true]:bg-success-50"
                ],
                input: "placeholder:text-success-600 dark:placeholder:text-success",
                label: "text-success-600 dark:text-success"
            }
        },
        {
            variant: "flat",
            color: "warning",
            class: {
                inputWrapper: [
                    "bg-warning-50",
                    "text-warning-600",
                    "dark:text-warning",
                    "placeholder:text-warning-600",
                    "dark:placeholder:text-warning",
                    "data-[hover=true]:bg-warning-100",
                    "group-data-[focus=true]:bg-warning-50"
                ],
                input: "placeholder:text-warning-600 dark:placeholder:text-warning",
                label: "text-warning-600 dark:text-warning"
            }
        },
        {
            variant: "flat",
            color: "danger",
            class: {
                inputWrapper: [
                    "bg-danger-50",
                    "text-danger",
                    "dark:text-danger-500",
                    "placeholder:text-danger",
                    "dark:placeholder:text-danger-500",
                    "data-[hover=true]:bg-danger-100",
                    "group-data-[focus=true]:bg-danger-50"
                ],
                input: "placeholder:text-danger dark:placeholder:text-danger-500",
                label: "text-danger dark:text-danger-500"
            }
        },
        {
            variant: "faded",
            color: "primary",
            class: {
                label: "text-primary",
                inputWrapper: "data-[hover=true]:border-primary focus-within:border-primary"
            }
        },
        {
            variant: "faded",
            color: "secondary",
            class: {
                label: "text-secondary",
                inputWrapper: "data-[hover=true]:border-secondary focus-within:border-secondary"
            }
        },
        {
            variant: "faded",
            color: "success",
            class: {
                label: "text-success",
                inputWrapper: "data-[hover=true]:border-success focus-within:border-success"
            }
        },
        {
            variant: "faded",
            color: "warning",
            class: {
                label: "text-warning",
                inputWrapper: "data-[hover=true]:border-warning focus-within:border-warning"
            }
        },
        {
            variant: "faded",
            color: "danger",
            class: {
                label: "text-danger",
                inputWrapper: "data-[hover=true]:border-danger focus-within:border-danger"
            }
        },
        {
            variant: "underlined",
            color: "default",
            class: {
                input: "group-data-[has-value=true]:text-foreground"
            }
        },
        {
            variant: "underlined",
            color: "primary",
            class: {
                inputWrapper: "after:bg-primary",
                label: "text-primary"
            }
        },
        {
            variant: "underlined",
            color: "secondary",
            class: {
                inputWrapper: "after:bg-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "underlined",
            color: "success",
            class: {
                inputWrapper: "after:bg-success",
                label: "text-success"
            }
        },
        {
            variant: "underlined",
            color: "warning",
            class: {
                inputWrapper: "after:bg-warning",
                label: "text-warning"
            }
        },
        {
            variant: "underlined",
            color: "danger",
            class: {
                inputWrapper: "after:bg-danger",
                label: "text-danger"
            }
        },
        {
            variant: "bordered",
            color: "primary",
            class: {
                inputWrapper: "group-data-[focus=true]:border-primary",
                label: "text-primary"
            }
        },
        {
            variant: "bordered",
            color: "secondary",
            class: {
                inputWrapper: "group-data-[focus=true]:border-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "bordered",
            color: "success",
            class: {
                inputWrapper: "group-data-[focus=true]:border-success",
                label: "text-success"
            }
        },
        {
            variant: "bordered",
            color: "warning",
            class: {
                inputWrapper: "group-data-[focus=true]:border-warning",
                label: "text-warning"
            }
        },
        {
            variant: "bordered",
            color: "danger",
            class: {
                inputWrapper: "group-data-[focus=true]:border-danger",
                label: "text-danger"
            }
        },
        {
            labelPlacement: "inside",
            color: "default",
            class: {
                label: "group-data-[filled-within=true]:text-default-600"
            }
        },
        {
            labelPlacement: "outside",
            color: "default",
            class: {
                label: "group-data-[filled-within=true]:text-foreground"
            }
        },
        {
            radius: "full",
            size: [
                "sm"
            ],
            class: {
                inputWrapper: "px-3"
            }
        },
        {
            radius: "full",
            size: "md",
            class: {
                inputWrapper: "px-4"
            }
        },
        {
            radius: "full",
            size: "lg",
            class: {
                inputWrapper: "px-5"
            }
        },
        {
            disableAnimation: false,
            variant: [
                "faded",
                "bordered"
            ],
            class: {
                inputWrapper: "transition-colors motion-reduce:transition-none"
            }
        },
        {
            disableAnimation: false,
            variant: "underlined",
            class: {
                inputWrapper: "after:transition-width motion-reduce:after:transition-none"
            }
        },
        {
            variant: [
                "flat",
                "faded"
            ],
            class: {
                inputWrapper: [
                    ...(0, $9dwEN.groupDataFocusVisibleClasses)
                ]
            }
        },
        {
            isInvalid: true,
            variant: "flat",
            class: {
                inputWrapper: [
                    "!bg-danger-50",
                    "data-[hover=true]:!bg-danger-100",
                    "group-data-[focus=true]:!bg-danger-50"
                ]
            }
        },
        {
            isInvalid: true,
            variant: "bordered",
            class: {
                inputWrapper: "!border-danger group-data-[focus=true]:!border-danger"
            }
        },
        {
            isInvalid: true,
            variant: "underlined",
            class: {
                inputWrapper: "after:!bg-danger"
            }
        },
        {
            labelPlacement: "inside",
            size: "sm",
            class: {
                inputWrapper: "h-12 py-1.5 px-3"
            }
        },
        {
            labelPlacement: "inside",
            size: "md",
            class: {
                inputWrapper: "h-14 py-2"
            }
        },
        {
            labelPlacement: "inside",
            size: "lg",
            class: {
                label: "text-small",
                inputWrapper: "h-16 py-2.5 gap-0"
            }
        },
        {
            labelPlacement: "inside",
            size: "sm",
            variant: [
                "bordered",
                "faded"
            ],
            class: {
                inputWrapper: "py-1"
            }
        },
        {
            labelPlacement: [
                "inside",
                "outside"
            ],
            class: {
                label: [
                    "group-data-[filled-within=true]:pointer-events-auto"
                ]
            }
        },
        {
            labelPlacement: [
                "outside",
                "outside-left"
            ],
            class: {
                input: "h-full"
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: false,
            class: {
                base: "group relative justify-end",
                label: [
                    "pb-0",
                    "z-20",
                    "top-1/2",
                    "-translate-y-1/2",
                    "group-data-[filled-within=true]:left-0"
                ]
            }
        },
        {
            labelPlacement: [
                "inside"
            ],
            class: {
                label: [
                    "group-data-[filled-within=true]:scale-85"
                ]
            }
        },
        {
            labelPlacement: [
                "inside"
            ],
            variant: "flat",
            class: {
                innerWrapper: "pb-0.5"
            }
        },
        {
            variant: "underlined",
            size: "sm",
            class: {
                innerWrapper: "pb-1"
            }
        },
        {
            variant: "underlined",
            size: [
                "md",
                "lg"
            ],
            class: {
                innerWrapper: "pb-1.5"
            }
        },
        {
            labelPlacement: "inside",
            size: [
                "sm",
                "md"
            ],
            class: {
                label: "text-small"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_8px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_6px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_8px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_8px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_6px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_8px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_5px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_3.5px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            size: "lg",
            isMultiline: false,
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled-within=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_4px)]"
                ]
            }
        },
        {
            labelPlacement: "outside",
            size: "sm",
            isMultiline: false,
            class: {
                label: [
                    "left-2",
                    "text-tiny",
                    "group-data-[filled-within=true]:-translate-y-[calc(100%_+_theme(fontSize.tiny)/2_+_16px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_8px)]"
            }
        },
        {
            labelPlacement: "outside",
            size: "md",
            isMultiline: false,
            class: {
                label: [
                    "left-3",
                    "rtl:left-auto",
                    "rtl:right-3",
                    "text-small",
                    "group-data-[filled-within=true]:-translate-y-[calc(100%_+_theme(fontSize.small)/2_+_20px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_10px)]"
            }
        },
        {
            labelPlacement: "outside",
            size: "lg",
            isMultiline: false,
            class: {
                label: [
                    "left-3",
                    "rtl:left-auto",
                    "rtl:right-3",
                    "text-medium",
                    "group-data-[filled-within=true]:-translate-y-[calc(100%_+_theme(fontSize.small)/2_+_24px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_12px)]"
            }
        },
        {
            labelPlacement: "outside-left",
            size: "sm",
            class: {
                label: "group-data-[has-helper=true]:pt-2"
            }
        },
        {
            labelPlacement: "outside-left",
            size: "md",
            class: {
                label: "group-data-[has-helper=true]:pt-3"
            }
        },
        {
            labelPlacement: "outside-left",
            size: "lg",
            class: {
                label: "group-data-[has-helper=true]:pt-4"
            }
        },
        {
            labelPlacement: [
                "outside",
                "outside-left"
            ],
            isMultiline: true,
            class: {
                inputWrapper: "py-2"
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: true,
            class: {
                label: "pb-1.5"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: true,
            class: {
                label: "pb-0.5",
                input: "pt-0"
            }
        },
        {
            isMultiline: true,
            disableAnimation: false,
            class: {
                input: "transition-height !duration-100 motion-reduce:transition-none"
            }
        },
        {
            labelPlacement: [
                "inside",
                "outside"
            ],
            class: {
                label: [
                    "pe-2",
                    "max-w-full",
                    "text-ellipsis",
                    "overflow-hidden"
                ]
            }
        },
        {
            isMultiline: true,
            radius: "full",
            class: {
                inputWrapper: "data-[has-multiple-rows=true]:rounded-large"
            }
        }
    ]
});

});

parcelRegister("cF4U7", function(module, exports) {

$parcel$export(module.exports, "safeAriaLabel", function () { return $b297b799108b9f3e$export$a3d82bd9a7fbdcbb; });
// src/text.ts
var $b297b799108b9f3e$export$bb381007244da5ab = (text)=>{
    if ((text == null ? void 0 : text.length) <= 4) return text;
    return text == null ? void 0 : text.slice(0, 3);
};
var $b297b799108b9f3e$export$a3d82bd9a7fbdcbb = (...texts)=>{
    let ariaLabel = " ";
    for (const text of texts)if (typeof text === "string" && text.length > 0) {
        ariaLabel = text;
        break;
    }
    return ariaLabel;
};

});

parcelRegister("eR6bz", function(module, exports) {

$parcel$export(module.exports, "useControlledState", function () { return $ad0ad0452691c6b9$export$40bfa8c7b0832715; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ad0ad0452691c6b9$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $exYeM.useState)(value || defaultValue);
    let isControlledRef = (0, $exYeM.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $exYeM.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    let currentValue = isControlled ? value : stateValue;
    let setValue = (0, $exYeM.useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? currentValue : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $ad0ad0452691c6b9$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $ad0ad0452691c6b9$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    let string = step.toString();
    let index = string.indexOf(".");
    let precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $ad0ad0452691c6b9$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

});

parcelRegister("649vw", function(module, exports) {

$parcel$export(module.exports, "useTextField", function () { return $46aa7dc3b8ab3a1c$export$712718f7aec83d5; });

var $exYeM = parcelRequire("exYeM");

var $9cffb = parcelRequire("9cffb");
var $2ZDqh = parcelRequire("2ZDqh");
var $8vAG4 = parcelRequire("8vAG4");
var $4sExG = parcelRequire("4sExG");
var $bxL7d = parcelRequire("bxL7d");

var $e0Pl7 = parcelRequire("e0Pl7");

var $gkapI = parcelRequire("gkapI");

var $k8c0o = parcelRequire("k8c0o");

var $7Rk9U = parcelRequire("7Rk9U");

var $xZbfh = parcelRequire("xZbfh");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $46aa7dc3b8ab3a1c$export$712718f7aec83d5(props, ref) {
    let { inputElementType: inputElementType = "input", isDisabled: isDisabled = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, type: type = "text", validationBehavior: validationBehavior = "aria" } = props;
    let [value, setValue] = (0, $e0Pl7.useControlledState)(props.value, props.defaultValue || "", props.onChange);
    let { focusableProps: focusableProps } = (0, $k8c0o.useFocusable)(props, ref);
    let validationState = (0, $xZbfh.useFormValidationState)({
        ...props,
        value: value
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = validationState.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $gkapI.useField)({
        ...props,
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let domProps = (0, $9cffb.filterDOMProps)(props, {
        labelable: true
    });
    const inputOnlyProps = {
        type: type,
        pattern: props.pattern
    };
    (0, $bxL7d.useFormReset)(ref, value, setValue);
    (0, $7Rk9U.useFormValidation)(props, validationState, ref);
    (0, $exYeM.useEffect)(()=>{
        // This works around a React/Chrome bug that prevents textarea elements from validating when controlled.
        // We prevent React from updating defaultValue (i.e. children) of textarea when `value` changes,
        // which causes Chrome to skip validation. Only updating `value` is ok in our case since our
        // textareas are always controlled. React is planning on removing this synchronization in a
        // future major version.
        // https://github.com/facebook/react/issues/19474
        // https://github.com/facebook/react/issues/11896
        if (ref.current instanceof (0, $2ZDqh.getOwnerWindow)(ref.current).HTMLTextAreaElement) {
            let input = ref.current;
            Object.defineProperty(input, "defaultValue", {
                get: ()=>input.value,
                set: ()=>{},
                configurable: true
            });
        }
    }, [
        ref
    ]);
    return {
        labelProps: labelProps,
        inputProps: (0, $8vAG4.mergeProps)(domProps, inputElementType === "input" && inputOnlyProps, {
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired && validationBehavior === "native",
            "aria-required": isRequired && validationBehavior === "aria" || undefined,
            "aria-invalid": isInvalid || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-activedescendant": props["aria-activedescendant"],
            "aria-autocomplete": props["aria-autocomplete"],
            "aria-haspopup": props["aria-haspopup"],
            value: value,
            onChange: (e)=>setValue(e.target.value),
            autoComplete: props.autoComplete,
            autoCapitalize: props.autoCapitalize,
            maxLength: props.maxLength,
            minLength: props.minLength,
            name: props.name,
            placeholder: props.placeholder,
            inputMode: props.inputMode,
            // Clipboard events
            onCopy: props.onCopy,
            onCut: props.onCut,
            onPaste: props.onPaste,
            // Composition events
            onCompositionEnd: props.onCompositionEnd,
            onCompositionStart: props.onCompositionStart,
            onCompositionUpdate: props.onCompositionUpdate,
            // Selection events
            onSelect: props.onSelect,
            // Input events
            onBeforeInput: props.onBeforeInput,
            onInput: props.onInput,
            ...focusableProps,
            ...fieldProps
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $46aa7dc3b8ab3a1c$var$$d841c8010a73d545$var$supportsNativeBeforeInputEvent() {
    return typeof window !== "undefined" && window.InputEvent && // @ts-ignore
    typeof InputEvent.prototype.getTargetRanges === "function";
}
function $46aa7dc3b8ab3a1c$export$4f384c9210e583c3(props, state, inputRef) {
    // All browsers implement the 'beforeinput' event natively except Firefox
    // (currently behind a flag as of Firefox 84). React's polyfill does not
    // run in all cases that the native event fires, e.g. when deleting text.
    // Use the native event if available so that we can prevent invalid deletions.
    // We do not attempt to polyfill this in Firefox since it would be very complicated,
    // the benefit of doing so is fairly minor, and it's going to be natively supported soon.
    let onBeforeInputFallback = (0, $4sExG.useEffectEvent)((e)=>{
        let input = inputRef.current;
        // Compute the next value of the input if the event is allowed to proceed.
        // See https://www.w3.org/TR/input-events-2/#interface-InputEvent-Attributes for a full list of input types.
        let nextValue;
        switch(e.inputType){
            case "historyUndo":
            case "historyRedo":
                // Explicitly allow undo/redo. e.data is null in this case, but there's no need to validate,
                // because presumably the input would have already been validated previously.
                return;
            case "deleteContent":
            case "deleteByCut":
            case "deleteByDrag":
                nextValue = input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case "deleteContentForward":
                // This is potentially incorrect, since the browser may actually delete more than a single UTF-16
                // character. In reality, a full Unicode grapheme cluster consisting of multiple UTF-16 characters
                // or code points may be deleted. However, in our currently supported locales, there are no such cases.
                // If we support additional locales in the future, this may need to change.
                nextValue = input.selectionEnd === input.selectionStart ? input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd + 1) : input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case "deleteContentBackward":
                nextValue = input.selectionEnd === input.selectionStart ? input.value.slice(0, input.selectionStart - 1) + input.value.slice(input.selectionStart) : input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                break;
            case "deleteSoftLineBackward":
            case "deleteHardLineBackward":
                nextValue = input.value.slice(input.selectionStart);
                break;
            default:
                if (e.data != null) nextValue = input.value.slice(0, input.selectionStart) + e.data + input.value.slice(input.selectionEnd);
                break;
        }
        // If we did not compute a value, or the new value is invalid, prevent the event
        // so that the browser does not update the input text, move the selection, or add to
        // the undo/redo stack.
        if (nextValue == null || !state.validate(nextValue)) e.preventDefault();
    });
    (0, $exYeM.useEffect)(()=>{
        if (!$46aa7dc3b8ab3a1c$var$$d841c8010a73d545$var$supportsNativeBeforeInputEvent()) return;
        let input = inputRef.current;
        input.addEventListener("beforeinput", onBeforeInputFallback, false);
        return ()=>{
            input.removeEventListener("beforeinput", onBeforeInputFallback, false);
        };
    }, [
        inputRef,
        onBeforeInputFallback
    ]);
    let onBeforeInput = !$46aa7dc3b8ab3a1c$var$$d841c8010a73d545$var$supportsNativeBeforeInputEvent() ? (e)=>{
        let nextValue = e.target.value.slice(0, e.target.selectionStart) + e.data + e.target.value.slice(e.target.selectionEnd);
        if (!state.validate(nextValue)) e.preventDefault();
    } : null;
    let { labelProps: labelProps, inputProps: textFieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = $46aa7dc3b8ab3a1c$export$712718f7aec83d5(props, inputRef);
    let compositionStartState = (0, $exYeM.useRef)(null);
    return {
        inputProps: (0, $8vAG4.mergeProps)(textFieldProps, {
            onBeforeInput: onBeforeInput,
            onCompositionStart () {
                // Chrome does not implement Input Events Level 2, which specifies the insertFromComposition
                // and deleteByComposition inputType values for the beforeinput event. These are meant to occur
                // at the end of a composition (e.g. Pinyin IME, Android auto correct, etc.), and crucially, are
                // cancelable. The insertCompositionText and deleteCompositionText input types are not cancelable,
                // nor would we want to cancel them because the input from the user is incomplete at that point.
                // In Safari, insertFromComposition/deleteFromComposition will fire, however, allowing us to cancel
                // the final composition result if it is invalid. As a fallback for Chrome and Firefox, which either
                // don't support Input Events Level 2, or beforeinput at all, we store the state of the input when
                // the compositionstart event fires, and undo the changes in compositionend (below) if it is invalid.
                // Unfortunately, this messes up the undo/redo stack, but until insertFromComposition/deleteByComposition
                // are implemented, there is no other way to prevent composed input.
                // See https://bugs.chromium.org/p/chromium/issues/detail?id=1022204
                let { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = inputRef.current;
                compositionStartState.current = {
                    value: value,
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd
                };
            },
            onCompositionEnd () {
                if (!state.validate(inputRef.current.value)) {
                    // Restore the input value in the DOM immediately so we can synchronously update the selection position.
                    // But also update the value in React state as well so it is correct for future updates.
                    let { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = compositionStartState.current;
                    inputRef.current.value = value;
                    inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                    state.setInputValue(value);
                }
            }
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        ...validation
    };
}

});
parcelRegister("bxL7d", function(module, exports) {

$parcel$export(module.exports, "useFormReset", function () { return $867752eca16dddf7$export$5add1d006293d136; });

var $4sExG = parcelRequire("4sExG");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $867752eca16dddf7$export$5add1d006293d136(ref, initialValue, onReset) {
    let resetValue = (0, $exYeM.useRef)(initialValue);
    let handleReset = (0, $4sExG.useEffectEvent)(()=>{
        if (onReset) onReset(resetValue.current);
    });
    (0, $exYeM.useEffect)(()=>{
        var _ref_current;
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        form === null || form === void 0 || form.addEventListener("reset", handleReset);
        return ()=>{
            form === null || form === void 0 || form.removeEventListener("reset", handleReset);
        };
    }, [
        ref,
        handleReset
    ]);
}

});

parcelRegister("gkapI", function(module, exports) {

$parcel$export(module.exports, "useField", function () { return $be26978b437aee36$export$294aa081a6c6f55d; });

var $f2qmo = parcelRequire("f2qmo");

var $8vAG4 = parcelRequire("8vAG4");
var $ezzQB = parcelRequire("ezzQB");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $be26978b437aee36$export$294aa081a6c6f55d(props) {
    let { description: description, errorMessage: errorMessage, isInvalid: isInvalid, validationState: validationState } = props;
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $f2qmo.useLabel)(props);
    let descriptionId = (0, $ezzQB.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    let errorMessageId = (0, $ezzQB.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, $8vAG4.mergeProps)(fieldProps, {
        "aria-describedby": [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props["aria-describedby"]
        ].filter(Boolean).join(" ") || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}

});
parcelRegister("f2qmo", function(module, exports) {

$parcel$export(module.exports, "useLabel", function () { return $af2b7d856d2d3fc1$export$8467354a121f1b9f; });

var $ezzQB = parcelRequire("ezzQB");
var $ed4mS = parcelRequire("ed4mS");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $af2b7d856d2d3fc1$export$8467354a121f1b9f(props) {
    let { id: id, label: label, "aria-labelledby": ariaLabelledby, "aria-label": ariaLabel, labelElementType: labelElementType = "label" } = props;
    id = (0, $ezzQB.useId)(id);
    let labelId = (0, $ezzQB.useId)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === "label" ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
    let fieldProps = (0, $ed4mS.useLabels)({
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}

});
parcelRegister("ed4mS", function(module, exports) {

$parcel$export(module.exports, "useLabels", function () { return $a585aafa8e690ebe$export$d6875122194c7b44; });

var $ezzQB = parcelRequire("ezzQB");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a585aafa8e690ebe$export$d6875122194c7b44(props, defaultLabel) {
    let { id: id, "aria-label": label, "aria-labelledby": labelledBy } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = (0, $ezzQB.useId)(id);
    if (labelledBy && label) {
        let ids = new Set([
            id,
            ...labelledBy.trim().split(/\s+/)
        ]);
        labelledBy = [
            ...ids
        ].join(" ");
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(" ");
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        "aria-label": label,
        "aria-labelledby": labelledBy
    };
}

});



parcelRegister("k8c0o", function(module, exports) {

$parcel$export(module.exports, "useFocusable", function () { return $ea7dde08a9f1e0d1$export$4c014de7c8940b4c; });

var $k7KUR = parcelRequire("k7KUR");

var $8vAG4 = parcelRequire("8vAG4");
var $4g3pq = parcelRequire("4g3pq");
var $hbWr9 = parcelRequire("hbWr9");

var $exYeM = parcelRequire("exYeM");

var $3rmT5 = parcelRequire("3rmT5");
var $ah6Zr = parcelRequire("ah6Zr");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $ea7dde08a9f1e0d1$var$$e6afbd83fe6ebbd2$var$FocusableContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
function $ea7dde08a9f1e0d1$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $exYeM.useContext)($ea7dde08a9f1e0d1$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $hbWr9.useSyncRef)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $ea7dde08a9f1e0d1$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $4g3pq.useObjectRef)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($ea7dde08a9f1e0d1$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $ea7dde08a9f1e0d1$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef($ea7dde08a9f1e0d1$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $ea7dde08a9f1e0d1$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $3rmT5.useFocus)(props);
    let { keyboardProps: keyboardProps } = (0, $ah6Zr.useKeyboard)(props);
    let interactions = (0, $8vAG4.mergeProps)(focusProps, keyboardProps);
    let domProps = $ea7dde08a9f1e0d1$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $exYeM.useRef)(props.autoFocus);
    (0, $exYeM.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $k7KUR.focusSafely)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $8vAG4.mergeProps)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}

});
parcelRegister("k7KUR", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $ea68daab7b2c51e7$export$80f3e147d781571c; });

var $6Qamj = parcelRequire("6Qamj");
var $2ZDqh = parcelRequire("2ZDqh");
var $jgteb = parcelRequire("jgteb");

var $cn2nf = parcelRequire("cn2nf");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ea68daab7b2c51e7$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $2ZDqh.getOwnerDocument)(element);
    if ((0, $cn2nf.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $jgteb.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $6Qamj.focusWithoutScrolling)(element);
        });
    } else (0, $6Qamj.focusWithoutScrolling)(element);
}

});
parcelRegister("cn2nf", function(module, exports) {

$parcel$export(module.exports, "getInteractionModality", function () { return $9019796b2b5b146a$export$630ff653c5ada6a9; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $9019796b2b5b146a$var$$507fabe10e71c6fb$var$currentModality = null;
let $9019796b2b5b146a$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $9019796b2b5b146a$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $9019796b2b5b146a$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $9019796b2b5b146a$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $9019796b2b5b146a$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $9019796b2b5b146a$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $9019796b2b5b146a$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $9019796b2b5b146a$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $gbqqi.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $9019796b2b5b146a$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($9019796b2b5b146a$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $9019796b2b5b146a$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $9019796b2b5b146a$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $9019796b2b5b146a$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $9019796b2b5b146a$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $9019796b2b5b146a$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $87CgO.isVirtualClick)(e)) {
        $9019796b2b5b146a$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $9019796b2b5b146a$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$9019796b2b5b146a$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$9019796b2b5b146a$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $9019796b2b5b146a$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $9019796b2b5b146a$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $9019796b2b5b146a$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $9019796b2b5b146a$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $9019796b2b5b146a$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $9019796b2b5b146a$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $9019796b2b5b146a$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $9019796b2b5b146a$export$d90243b58daecda7.get((0, $2ZDqh.getOwnerWindow)(element))) return;
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $9019796b2b5b146a$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $9019796b2b5b146a$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $9019796b2b5b146a$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $9019796b2b5b146a$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$9019796b2b5b146a$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $9019796b2b5b146a$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $9019796b2b5b146a$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $9019796b2b5b146a$export$d90243b58daecda7.delete(windowObject);
};
function $9019796b2b5b146a$export$2f1888112f558a7d(element) {
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $9019796b2b5b146a$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $9019796b2b5b146a$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$9019796b2b5b146a$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $9019796b2b5b146a$export$2f1888112f558a7d();
function $9019796b2b5b146a$export$b9b3dfddab17db27() {
    return $9019796b2b5b146a$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $9019796b2b5b146a$export$630ff653c5ada6a9() {
    return $9019796b2b5b146a$var$$507fabe10e71c6fb$var$currentModality;
}
function $9019796b2b5b146a$export$8397ddfc504fdb9a(modality) {
    $9019796b2b5b146a$var$$507fabe10e71c6fb$var$currentModality = modality;
    $9019796b2b5b146a$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $9019796b2b5b146a$export$98e20ec92f614cfe() {
    $9019796b2b5b146a$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $exYeM.useState)($9019796b2b5b146a$var$$507fabe10e71c6fb$var$currentModality);
    (0, $exYeM.useEffect)(()=>{
        let handler = ()=>{
            setModality($9019796b2b5b146a$var$$507fabe10e71c6fb$var$currentModality);
        };
        $9019796b2b5b146a$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $9019796b2b5b146a$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $aVmq3.useIsSSR)() ? null : modality;
}
const $9019796b2b5b146a$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $9019796b2b5b146a$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$9019796b2b5b146a$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$9019796b2b5b146a$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $9019796b2b5b146a$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(autoFocus || $9019796b2b5b146a$export$b9b3dfddab17db27());
    $9019796b2b5b146a$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $9019796b2b5b146a$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $9019796b2b5b146a$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $exYeM.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$9019796b2b5b146a$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($9019796b2b5b146a$export$b9b3dfddab17db27());
        };
        $9019796b2b5b146a$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $9019796b2b5b146a$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("3rmT5", function(module, exports) {

$parcel$export(module.exports, "useFocus", function () { return $2815a5b34f94d286$export$f8168d8dd8fd66e6; });

var $jj3SS = parcelRequire("jj3SS");

var $exYeM = parcelRequire("exYeM");

var $2ZDqh = parcelRequire("2ZDqh");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $2815a5b34f94d286$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $exYeM.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $jj3SS.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $exYeM.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});
parcelRegister("jj3SS", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $e0e2cdfb5d2edbc1$export$715c682d09d639cc; });

var $exYeM = parcelRequire("exYeM");

var $4sExG = parcelRequire("4sExG");
var $71dP2 = parcelRequire("71dP2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $e0e2cdfb5d2edbc1$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $e0e2cdfb5d2edbc1$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $exYeM.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $71dP2.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $4sExG.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $exYeM.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $e0e2cdfb5d2edbc1$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("ah6Zr", function(module, exports) {

$parcel$export(module.exports, "useKeyboard", function () { return $77b0e9f8b980aceb$export$8f71654801c2f7cd; });

var $jjplz = parcelRequire("jjplz");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $77b0e9f8b980aceb$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $jjplz.createEventHandler)(props.onKeyDown),
            onKeyUp: (0, $jjplz.createEventHandler)(props.onKeyUp)
        }
    };
}

});
parcelRegister("jjplz", function(module, exports) {

$parcel$export(module.exports, "createEventHandler", function () { return $e0f3740db8664906$export$48d1ea6320830260; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e0f3740db8664906$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}

});



parcelRegister("7Rk9U", function(module, exports) {

$parcel$export(module.exports, "useFormValidation", function () { return $5b8d1ebda9fe6209$export$b8473d3665f3a75a; });

var $exYeM = parcelRequire("exYeM");

var $fckjJ = parcelRequire("fckjJ");

var $4sExG = parcelRequire("4sExG");
var $71dP2 = parcelRequire("71dP2");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5b8d1ebda9fe6209$export$b8473d3665f3a75a(props, state, ref) {
    let { validationBehavior: validationBehavior, focus: focus } = props;
    (0, $71dP2.useLayoutEffect)(()=>{
        if (validationBehavior === "native" && (ref === null || ref === void 0 ? void 0 : ref.current)) {
            let errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
            ref.current.setCustomValidity(errorMessage);
            // Prevent default tooltip for validation message.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=605277
            if (!ref.current.hasAttribute("title")) ref.current.title = "";
            if (!state.realtimeValidation.isInvalid) state.updateValidation($5b8d1ebda9fe6209$var$$e93e671b31057976$var$getNativeValidity(ref.current));
        }
    });
    let onReset = (0, $4sExG.useEffectEvent)(()=>{
        state.resetValidation();
    });
    let onInvalid = (0, $4sExG.useEffectEvent)((e)=>{
        var _ref_current;
        // Only commit validation if we are not already displaying one.
        // This avoids clearing server errors that the user didn't actually fix.
        if (!state.displayValidation.isInvalid) state.commitValidation();
        // Auto focus the first invalid input in a form, unless the error already had its default prevented.
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        if (!e.defaultPrevented && ref && form && $5b8d1ebda9fe6209$var$$e93e671b31057976$var$getFirstInvalidInput(form) === ref.current) {
            var _ref_current1;
            if (focus) focus();
            else (_ref_current1 = ref.current) === null || _ref_current1 === void 0 || _ref_current1.focus();
            (0, $fckjJ.setInteractionModality)("keyboard");
        }
        // Prevent default browser error UI from appearing.
        e.preventDefault();
    });
    let onChange = (0, $4sExG.useEffectEvent)(()=>{
        state.commitValidation();
    });
    (0, $exYeM.useEffect)(()=>{
        let input = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!input) return;
        let form = input.form;
        input.addEventListener("invalid", onInvalid);
        input.addEventListener("change", onChange);
        form === null || form === void 0 || form.addEventListener("reset", onReset);
        return ()=>{
            input.removeEventListener("invalid", onInvalid);
            input.removeEventListener("change", onChange);
            form === null || form === void 0 || form.removeEventListener("reset", onReset);
        };
    }, [
        ref,
        onInvalid,
        onChange,
        onReset,
        validationBehavior
    ]);
}
function $5b8d1ebda9fe6209$var$$e93e671b31057976$var$getValidity(input) {
    // The native ValidityState object is live, meaning each property is a getter that returns the current state.
    // We need to create a snapshot of the validity state at the time this function is called to avoid unpredictable React renders.
    let validity = input.validity;
    return {
        badInput: validity.badInput,
        customError: validity.customError,
        patternMismatch: validity.patternMismatch,
        rangeOverflow: validity.rangeOverflow,
        rangeUnderflow: validity.rangeUnderflow,
        stepMismatch: validity.stepMismatch,
        tooLong: validity.tooLong,
        tooShort: validity.tooShort,
        typeMismatch: validity.typeMismatch,
        valueMissing: validity.valueMissing,
        valid: validity.valid
    };
}
function $5b8d1ebda9fe6209$var$$e93e671b31057976$var$getNativeValidity(input) {
    return {
        isInvalid: !input.validity.valid,
        validationDetails: $5b8d1ebda9fe6209$var$$e93e671b31057976$var$getValidity(input),
        validationErrors: input.validationMessage ? [
            input.validationMessage
        ] : []
    };
}
function $5b8d1ebda9fe6209$var$$e93e671b31057976$var$getFirstInvalidInput(form) {
    for(let i = 0; i < form.elements.length; i++){
        let element = form.elements[i];
        if (!element.validity.valid) return element;
    }
    return null;
}

});
parcelRegister("fckjJ", function(module, exports) {

$parcel$export(module.exports, "setInteractionModality", function () { return $b107bc900f70f9c2$export$8397ddfc504fdb9a; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$currentModality = null;
let $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $b107bc900f70f9c2$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $gbqqi.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($b107bc900f70f9c2$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $87CgO.isVirtualClick)(e)) {
        $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$b107bc900f70f9c2$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$b107bc900f70f9c2$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $b107bc900f70f9c2$export$d90243b58daecda7.get((0, $2ZDqh.getOwnerWindow)(element))) return;
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $b107bc900f70f9c2$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$b107bc900f70f9c2$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $b107bc900f70f9c2$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $b107bc900f70f9c2$export$d90243b58daecda7.delete(windowObject);
};
function $b107bc900f70f9c2$export$2f1888112f558a7d(element) {
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$b107bc900f70f9c2$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $b107bc900f70f9c2$export$2f1888112f558a7d();
function $b107bc900f70f9c2$export$b9b3dfddab17db27() {
    return $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $b107bc900f70f9c2$export$630ff653c5ada6a9() {
    return $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$currentModality;
}
function $b107bc900f70f9c2$export$8397ddfc504fdb9a(modality) {
    $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$currentModality = modality;
    $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $b107bc900f70f9c2$export$98e20ec92f614cfe() {
    $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $exYeM.useState)($b107bc900f70f9c2$var$$507fabe10e71c6fb$var$currentModality);
    (0, $exYeM.useEffect)(()=>{
        let handler = ()=>{
            setModality($b107bc900f70f9c2$var$$507fabe10e71c6fb$var$currentModality);
        };
        $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $aVmq3.useIsSSR)() ? null : modality;
}
const $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$b107bc900f70f9c2$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$b107bc900f70f9c2$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $b107bc900f70f9c2$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(autoFocus || $b107bc900f70f9c2$export$b9b3dfddab17db27());
    $b107bc900f70f9c2$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $b107bc900f70f9c2$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $exYeM.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$b107bc900f70f9c2$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($b107bc900f70f9c2$export$b9b3dfddab17db27());
        };
        $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b107bc900f70f9c2$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("xZbfh", function(module, exports) {

$parcel$export(module.exports, "useFormValidationState", function () { return $06628a54c8dc0685$export$fc1a364ae1f3ff10; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $06628a54c8dc0685$export$aca958c65c314e6c = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
const $06628a54c8dc0685$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = {
    ...$06628a54c8dc0685$export$aca958c65c314e6c,
    customError: true,
    valid: false
};
const $06628a54c8dc0685$export$dad6ae84456c676a = {
    isInvalid: false,
    validationDetails: $06628a54c8dc0685$export$aca958c65c314e6c,
    validationErrors: []
};
const $06628a54c8dc0685$export$571b5131b7e65c11 = (0, $exYeM.createContext)({});
const $06628a54c8dc0685$export$a763b9476acd3eb = "__formValidationState" + Date.now();
function $06628a54c8dc0685$export$fc1a364ae1f3ff10(props) {
    // Private prop for parent components to pass state to children.
    if (props[$06628a54c8dc0685$export$a763b9476acd3eb]) {
        let { realtimeValidation: realtimeValidation, displayValidation: displayValidation, updateValidation: updateValidation, resetValidation: resetValidation, commitValidation: commitValidation } = props[$06628a54c8dc0685$export$a763b9476acd3eb];
        return {
            realtimeValidation: realtimeValidation,
            displayValidation: displayValidation,
            updateValidation: updateValidation,
            resetValidation: resetValidation,
            commitValidation: commitValidation
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $06628a54c8dc0685$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props);
}
function $06628a54c8dc0685$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props) {
    let { isInvalid: isInvalid, validationState: validationState, name: name, value: value, builtinValidation: builtinValidation, validate: validate, validationBehavior: validationBehavior = "aria" } = props;
    // backward compatibility.
    if (validationState) isInvalid || (isInvalid = validationState === "invalid");
    // If the isInvalid prop is controlled, update validation result in realtime.
    let controlledError = isInvalid !== undefined ? {
        isInvalid: isInvalid,
        validationErrors: [],
        validationDetails: $06628a54c8dc0685$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    let clientError = (0, $exYeM.useMemo)(()=>$06628a54c8dc0685$var$$e5be200c675c3b3a$var$getValidationResult($06628a54c8dc0685$var$$e5be200c675c3b3a$var$runValidate(validate, value)), [
        validate,
        value
    ]);
    if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = null;
    // Get relevant server errors from the form.
    let serverErrors = (0, $exYeM.useContext)($06628a54c8dc0685$export$571b5131b7e65c11);
    let serverErrorMessages = (0, $exYeM.useMemo)(()=>{
        if (name) return Array.isArray(name) ? name.flatMap((name)=>$06628a54c8dc0685$var$$e5be200c675c3b3a$var$asArray(serverErrors[name])) : $06628a54c8dc0685$var$$e5be200c675c3b3a$var$asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    let [lastServerErrors, setLastServerErrors] = (0, $exYeM.useState)(serverErrors);
    let [isServerErrorCleared, setServerErrorCleared] = (0, $exYeM.useState)(false);
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    let serverError = (0, $exYeM.useMemo)(()=>$06628a54c8dc0685$var$$e5be200c675c3b3a$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages), [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    let nextValidation = (0, $exYeM.useRef)($06628a54c8dc0685$export$dad6ae84456c676a);
    let [currentValidity, setCurrentValidity] = (0, $exYeM.useState)($06628a54c8dc0685$export$dad6ae84456c676a);
    let lastError = (0, $exYeM.useRef)($06628a54c8dc0685$export$dad6ae84456c676a);
    let commitValidation = ()=>{
        if (!commitQueued) return;
        setCommitQueued(false);
        let error = clientError || builtinValidation || nextValidation.current;
        if (!$06628a54c8dc0685$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    let [commitQueued, setCommitQueued] = (0, $exYeM.useState)(false);
    (0, $exYeM.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    let realtimeValidation = controlledError || serverError || clientError || builtinValidation || $06628a54c8dc0685$export$dad6ae84456c676a;
    let displayValidation = validationBehavior === "native" ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation: realtimeValidation,
        displayValidation: displayValidation,
        updateValidation (value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === "aria" && !$06628a54c8dc0685$var$$e5be200c675c3b3a$var$isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation () {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            let error = $06628a54c8dc0685$export$dad6ae84456c676a;
            if (!$06628a54c8dc0685$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === "native") setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation () {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === "native") setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function $06628a54c8dc0685$var$$e5be200c675c3b3a$var$asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function $06628a54c8dc0685$var$$e5be200c675c3b3a$var$runValidate(validate, value) {
    if (typeof validate === "function") {
        let e = validate(value);
        if (e && typeof e !== "boolean") return $06628a54c8dc0685$var$$e5be200c675c3b3a$var$asArray(e);
    }
    return [];
}
function $06628a54c8dc0685$var$$e5be200c675c3b3a$var$getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: $06628a54c8dc0685$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
}
function $06628a54c8dc0685$var$$e5be200c675c3b3a$var$isEqualValidation(a, b) {
    if (a === b) return true;
    return a && b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every((a, i)=>a === b.validationErrors[i]) && Object.entries(a.validationDetails).every(([k, v])=>b.validationDetails[k] === v);
}
function $06628a54c8dc0685$export$75ee7c75d68f5b0e(...results) {
    let errors = new Set();
    let isInvalid = false;
    let validationDetails = {
        ...$06628a54c8dc0685$export$aca958c65c314e6c
    };
    for (let v of results){
        var _validationDetails, _key;
        for (let e of v.validationErrors)errors.add(e);
        // Only these properties apply for checkboxes.
        isInvalid || (isInvalid = v.isInvalid);
        for(let key in validationDetails)(_validationDetails = validationDetails)[_key = key] || (_validationDetails[_key] = v.validationDetails[key]);
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid: isInvalid,
        validationErrors: [
            ...errors
        ],
        validationDetails: validationDetails
    };
}

});



parcelRegister("9eroa", function(module, exports) {

$parcel$export(module.exports, "CloseFilledIcon", function () { return $8d0b2ff350b2b402$export$2b32a5a2c6e4dc78; });
// src/close-filled.tsx

var $aSiaI = parcelRequire("aSiaI");
var $8d0b2ff350b2b402$export$2b32a5a2c6e4dc78 = (props)=>/* @__PURE__ */ (0, $aSiaI.jsx)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /* @__PURE__ */ (0, $aSiaI.jsx)("path", {
            d: "M12 2a10 10 0 1010 10A10.016 10.016 0 0012 2zm3.36 12.3a.754.754 0 010 1.06.748.748 0 01-1.06 0l-2.3-2.3-2.3 2.3a.748.748 0 01-1.06 0 .754.754 0 010-1.06l2.3-2.3-2.3-2.3A.75.75 0 019.7 8.64l2.3 2.3 2.3-2.3a.75.75 0 011.06 1.06l-2.3 2.3z",
            fill: "currentColor"
        })
    });

});


parcelRegister("bowRT", function(module, exports) {

$parcel$export(module.exports, "popover_default", function () { return $b4a73188acc42e12$export$b56270f92ff8018; });

var $aG9V8 = parcelRequire("aG9V8");

var $2BSid = parcelRequire("2BSid");

var $exYeM = parcelRequire("exYeM");

var $8Oq4a = parcelRequire("8Oq4a");

var $fJq7l = parcelRequire("fJq7l");

var $3kiob = parcelRequire("3kiob");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $b4a73188acc42e12$var$Popover = (0, $8Oq4a.forwardRef)((props, ref)=>{
    const { children: children, ...otherProps } = props;
    const context = (0, $2BSid.usePopover)({
        ...otherProps,
        ref: ref
    });
    const [trigger, content] = (0, $exYeM.Children).toArray(children);
    const overlay = /* @__PURE__ */ (0, $aSiaI.jsx)((0, $fJq7l.Overlay), {
        disableFocusManagement: true,
        portalContainer: context.portalContainer,
        children: content
    });
    return /* @__PURE__ */ (0, $aSiaI.jsxs)((0, $aG9V8.PopoverProvider), {
        value: context,
        children: [
            trigger,
            context.disableAnimation && context.isOpen ? overlay : /* @__PURE__ */ (0, $aSiaI.jsx)((0, $3kiob.AnimatePresence), {
                children: context.isOpen ? overlay : null
            })
        ]
    });
});
$b4a73188acc42e12$var$Popover.displayName = "NextUI.Popover";
var $b4a73188acc42e12$export$b56270f92ff8018 = $b4a73188acc42e12$var$Popover;

});
parcelRegister("aG9V8", function(module, exports) {

$parcel$export(module.exports, "PopoverProvider", function () { return $c983b203896abe31$export$bf694c7c431c162a; });
$parcel$export(module.exports, "usePopoverContext", function () { return $c983b203896abe31$export$1468d0761b26e6c8; });

var $aC86g = parcelRequire("aC86g");
"use client";
var [$c983b203896abe31$export$bf694c7c431c162a, $c983b203896abe31$export$1468d0761b26e6c8] = (0, $aC86g.createContext)({
    name: "PopoverContext",
    errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
});

});

parcelRegister("2BSid", function(module, exports) {

$parcel$export(module.exports, "usePopover", function () { return $958c255b9078ed24$export$542a6fd13ac93354; });

var $8JpJD = parcelRequire("8JpJD");

var $exYeM = parcelRequire("exYeM");

var $lfs90 = parcelRequire("lfs90");

var $7oAOq = parcelRequire("7oAOq");

var $k5F2B = parcelRequire("k5F2B");

var $fJq7l = parcelRequire("fJq7l");

var $8Oq4a = parcelRequire("8Oq4a");
var $lJ6o6 = parcelRequire("lJ6o6");

var $KekyV = parcelRequire("KekyV");

var $fCtGx = parcelRequire("fCtGx");

var $8vAG4 = parcelRequire("8vAG4");
var $eToUM = parcelRequire("eToUM");

var $6pmNA = parcelRequire("6pmNA");
var $jj4Oc = parcelRequire("jj4Oc");
var $luNG9 = parcelRequire("luNG9");

var $IIWhi = parcelRequire("IIWhi");
"use client";
function $958c255b9078ed24$export$542a6fd13ac93354(originalProps) {
    var _a, _b, _c;
    const globalContext = (0, $lJ6o6.useProviderContext)();
    const [props, variantProps] = (0, $8Oq4a.mapPropsVariants)(originalProps, (0, $fCtGx.popover).variantKeys);
    const { as: as, ref: ref, children: children, state: stateProp, triggerRef: triggerRefProp, scrollRef: scrollRef, defaultOpen: defaultOpen, onOpenChange: onOpenChange, isOpen: isOpenProp, isNonModal: isNonModal = true, shouldFlip: shouldFlip = true, containerPadding: containerPadding = 12, shouldBlockScroll: shouldBlockScroll = false, isDismissable: isDismissable = true, shouldCloseOnBlur: shouldCloseOnBlur, portalContainer: portalContainer, updatePositionDeps: updatePositionDeps, dialogProps: dialogPropsProp, placement: placementProp = "top", triggerType: triggerType = "dialog", showArrow: showArrow = false, offset: offset = 7, crossOffset: crossOffset = 0, boundaryElement: boundaryElement, isKeyboardDismissDisabled: isKeyboardDismissDisabled, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, motionProps: motionProps, className: className, classNames: classNames, onClose: onClose, ...otherProps } = props;
    const Component = as || "div";
    const domRef = (0, $lfs90.useDOMRef)(ref);
    const domTriggerRef = (0, $exYeM.useRef)(null);
    const wasTriggerPressedRef = (0, $exYeM.useRef)(false);
    const dialogRef = (0, $exYeM.useRef)(null);
    const triggerRef = triggerRefProp || domTriggerRef;
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const innerState = (0, $7oAOq.useOverlayTriggerState)({
        isOpen: isOpenProp,
        defaultOpen: defaultOpen,
        onOpenChange: (isOpen)=>{
            onOpenChange == null || onOpenChange(isOpen);
            if (!isOpen) onClose == null || onClose();
        }
    });
    const state = stateProp || innerState;
    const { popoverProps: popoverProps, underlayProps: underlayProps, placement: ariaPlacement } = (0, $8JpJD.useReactAriaPopover)({
        triggerRef: triggerRef,
        isNonModal: isNonModal,
        popoverRef: domRef,
        placement: placementProp,
        offset: offset,
        scrollRef: scrollRef,
        isDismissable: isDismissable,
        shouldCloseOnBlur: shouldCloseOnBlur,
        boundaryElement: boundaryElement,
        crossOffset: crossOffset,
        shouldFlip: shouldFlip,
        containerPadding: containerPadding,
        updatePositionDeps: updatePositionDeps,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, state);
    const { triggerProps: triggerProps } = (0, $fJq7l.useOverlayTrigger)({
        type: triggerType
    }, state, triggerRef);
    const { isFocusVisible: isFocusVisible, isFocused: isFocused, focusProps: focusProps } = (0, $k5F2B.useFocusRing)();
    const { dialogProps: dialogProps, titleProps: titleProps } = (0, $IIWhi.useDialog)({}, dialogRef);
    const slots = (0, $exYeM.useMemo)(()=>(0, $fCtGx.popover)({
            ...variantProps
        }), [
        (0, $luNG9.objectToDeps)(variantProps)
    ]);
    const baseStyles = (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.base, className);
    const getPopoverProps = (props2 = {})=>({
            ref: domRef,
            ...(0, $8vAG4.mergeProps)(popoverProps, otherProps, props2),
            style: (0, $8vAG4.mergeProps)(popoverProps.style, otherProps.style, props2.style)
        });
    const getDialogProps = (props2 = {})=>({
            ref: dialogRef,
            "data-slot": "base",
            "data-open": (0, $jj4Oc.dataAttr)(state.isOpen),
            "data-focus": (0, $jj4Oc.dataAttr)(isFocused),
            "data-arrow": (0, $jj4Oc.dataAttr)(showArrow),
            "data-focus-visible": (0, $jj4Oc.dataAttr)(isFocusVisible),
            "data-placement": (0, $KekyV.getArrowPlacement)(ariaPlacement, placementProp),
            ...(0, $8vAG4.mergeProps)(focusProps, dialogProps, dialogPropsProp, props2),
            className: slots.base({
                class: (0, $6pmNA.clsx)(baseStyles)
            }),
            style: {
                outline: "none"
            }
        });
    const getContentProps = (0, $exYeM.useCallback)((props2 = {})=>({
            "data-slot": "content",
            "data-open": (0, $jj4Oc.dataAttr)(state.isOpen),
            "data-arrow": (0, $jj4Oc.dataAttr)(showArrow),
            "data-placement": (0, $KekyV.getArrowPlacement)(ariaPlacement, placementProp),
            className: slots.content({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.content, props2.className)
            })
        }), [
        slots,
        state.isOpen,
        showArrow,
        ariaPlacement,
        placementProp,
        classNames
    ]);
    const placement = (0, $exYeM.useMemo)(()=>(0, $KekyV.getShouldUseAxisPlacement)(ariaPlacement, placementProp) ? ariaPlacement || placementProp : placementProp, [
        ariaPlacement,
        placementProp
    ]);
    const onPress = (0, $exYeM.useCallback)((e)=>{
        var _a2;
        let pressTimer;
        if (e.pointerType === "touch" && ((originalProps == null ? void 0 : originalProps.backdrop) === "blur" || (originalProps == null ? void 0 : originalProps.backdrop) === "opaque")) pressTimer = setTimeout(()=>{
            wasTriggerPressedRef.current = true;
        }, 100);
        else wasTriggerPressedRef.current = true;
        (_a2 = triggerProps.onPress) == null || _a2.call(triggerProps, e);
        return ()=>{
            clearTimeout(pressTimer);
        };
    }, [
        triggerProps == null ? void 0 : triggerProps.onPress
    ]);
    const getTriggerProps = (0, $exYeM.useCallback)((props2 = {}, _ref = null)=>{
        const { isDisabled: isDisabled, ...otherProps2 } = props2;
        return {
            "data-slot": "trigger",
            "aria-haspopup": "dialog",
            ...(0, $8vAG4.mergeProps)(triggerProps, otherProps2),
            onPress: onPress,
            isDisabled: isDisabled,
            className: slots.trigger({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.trigger, props2.className),
                isTriggerDisabled: isDisabled
            }),
            ref: (0, $eToUM.mergeRefs)(_ref, triggerRef)
        };
    }, [
        state,
        triggerProps,
        onPress,
        triggerRef
    ]);
    const getBackdropProps = (0, $exYeM.useCallback)((props2 = {})=>({
            "data-slot": "backdrop",
            className: slots.backdrop({
                class: classNames == null ? void 0 : classNames.backdrop
            }),
            onClick: (e)=>{
                if (!wasTriggerPressedRef.current) {
                    e.preventDefault();
                    return;
                }
                state.close();
                wasTriggerPressedRef.current = false;
            },
            ...underlayProps,
            ...props2
        }), [
        slots,
        state.isOpen,
        classNames,
        underlayProps
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (state.isOpen && (domRef == null ? void 0 : domRef.current)) return (0, $fJq7l.ariaHideOutside)([
            domRef == null ? void 0 : domRef.current
        ]);
    }, [
        state.isOpen,
        domRef
    ]);
    return {
        state: state,
        Component: Component,
        children: children,
        classNames: classNames,
        showArrow: showArrow,
        triggerRef: triggerRef,
        placement: placement,
        isNonModal: isNonModal,
        titleProps: titleProps,
        popoverRef: domRef,
        portalContainer: portalContainer,
        isOpen: state.isOpen,
        onClose: state.close,
        disableAnimation: disableAnimation,
        shouldBlockScroll: shouldBlockScroll,
        backdrop: (_c = originalProps.backdrop) != null ? _c : "transparent",
        motionProps: motionProps,
        getBackdropProps: getBackdropProps,
        getPopoverProps: getPopoverProps,
        getTriggerProps: getTriggerProps,
        getDialogProps: getDialogProps,
        getContentProps: getContentProps
    };
}

});
parcelRegister("8JpJD", function(module, exports) {

$parcel$export(module.exports, "useReactAriaPopover", function () { return $701d142246e5bbc5$export$edc31d940c0b0631; });

var $exYeM = parcelRequire("exYeM");

var $fJq7l = parcelRequire("fJq7l");

var $blhTL = parcelRequire("blhTL");
var $75g4P = parcelRequire("75g4P");
var $KekyV = parcelRequire("KekyV");

var $8vAG4 = parcelRequire("8vAG4");

var $7Qd7T = parcelRequire("7Qd7T");
"use client";
function $701d142246e5bbc5$export$edc31d940c0b0631(props, state) {
    const { triggerRef: triggerRef, popoverRef: popoverRef, showArrow: showArrow, offset: offset = 7, crossOffset: crossOffset = 0, scrollRef: scrollRef, shouldFlip: shouldFlip, boundaryElement: boundaryElement, isDismissable: isDismissable = true, shouldCloseOnBlur: shouldCloseOnBlur = true, placement: placementProp = "top", containerPadding: containerPadding, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, isNonModal: isNonModalProp, isKeyboardDismissDisabled: isKeyboardDismissDisabled, updatePositionDeps: updatePositionDeps = [], ...otherProps } = props;
    const isNonModal = isNonModalProp != null ? isNonModalProp : true;
    const { overlayProps: overlayProps, underlayProps: underlayProps } = (0, $fJq7l.useOverlay)({
        isOpen: state.isOpen,
        onClose: state.close,
        shouldCloseOnBlur: shouldCloseOnBlur,
        isDismissable: isDismissable,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside ? shouldCloseOnInteractOutside : (element)=>(0, $75g4P.ariaShouldCloseOnInteractOutside)(element, triggerRef, state)
    }, popoverRef);
    const { overlayProps: positionProps, arrowProps: arrowProps, placement: placement, updatePosition: updatePosition } = (0, $fJq7l.useOverlayPosition)({
        ...otherProps,
        shouldFlip: shouldFlip,
        crossOffset: crossOffset,
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        scrollRef: scrollRef,
        boundaryElement: boundaryElement,
        containerPadding: containerPadding,
        placement: (0, $KekyV.toReactAriaPlacement)(placementProp),
        offset: showArrow ? offset + 3 : offset,
        onClose: ()=>{}
    });
    (0, $7Qd7T.useSafeLayoutEffect)(()=>{
        if (!updatePositionDeps.length) return;
        updatePosition();
    }, updatePositionDeps);
    (0, $exYeM.useEffect)(()=>{
        if (state.isOpen && !isNonModal && popoverRef.current) return (0, $blhTL.ariaHideOutside)([
            popoverRef.current
        ]);
    }, [
        isNonModal,
        state.isOpen,
        popoverRef
    ]);
    return {
        popoverProps: (0, $8vAG4.mergeProps)(overlayProps, positionProps),
        arrowProps: arrowProps,
        underlayProps: underlayProps,
        placement: placement
    };
}

});
parcelRegister("fJq7l", function(module, exports) {

$parcel$export(module.exports, "useOverlayPosition", function () { return $b73f51611919ce3d$export$d39e1813b3bdd0e1; });
$parcel$export(module.exports, "useOverlay", function () { return $b73f51611919ce3d$export$ea8f71083e90600f; });
$parcel$export(module.exports, "useOverlayTrigger", function () { return $b73f51611919ce3d$export$f9d5c8beee7d008d; });
$parcel$export(module.exports, "OverlayContainer", function () { return $b73f51611919ce3d$export$b47c3594eab58386; });
$parcel$export(module.exports, "DismissButton", function () { return $b73f51611919ce3d$export$2317d149ed6f78c4; });
$parcel$export(module.exports, "ariaHideOutside", function () { return $b73f51611919ce3d$export$1c3ebcada18427bf; });
$parcel$export(module.exports, "Overlay", function () { return $b73f51611919ce3d$export$c6fdb837b070b4ff; });

var $4QjZq = parcelRequire("4QjZq");

var $2ejYU = parcelRequire("2ejYU");

var $aLVKe = parcelRequire("aLVKe");

var $l3N8j = parcelRequire("l3N8j");

var $kCzX0 = parcelRequire("kCzX0");

var $gpz0A = parcelRequire("gpz0A");

var $k4L3y = parcelRequire("k4L3y");

var $fM69b = parcelRequire("fM69b");

var $97Rf5 = parcelRequire("97Rf5");

var $gxfQE = parcelRequire("gxfQE");

var $ejcuW = parcelRequire("ejcuW");

var $f4Dn9 = parcelRequire("f4Dn9");

var $9ZZ9S = parcelRequire("9ZZ9S");

var $3Sr89 = parcelRequire("3Sr89");

var $joMOA = parcelRequire("joMOA");

var $c27Q8 = parcelRequire("c27Q8");

var $7jPjR = parcelRequire("7jPjR");

var $cJjZ8 = parcelRequire("cJjZ8");

var $ckobM = parcelRequire("ckobM");

var $90wC2 = parcelRequire("90wC2");

var $dLwUu = parcelRequire("dLwUu");

var $EgOYE = parcelRequire("EgOYE");

var $gximO = parcelRequire("gximO");

var $jcQqf = parcelRequire("jcQqf");

var $3kfB5 = parcelRequire("3kfB5");

var $7rWM7 = parcelRequire("7rWM7");

var $cWJ1G = parcelRequire("cWJ1G");

var $6Bi3e = parcelRequire("6Bi3e");

var $c5ynI = parcelRequire("c5ynI");

var $2ShnL = parcelRequire("2ShnL");

var $gzXzc = parcelRequire("gzXzc");

var $hAcha = parcelRequire("hAcha");

var $aUBCP = parcelRequire("aUBCP");

var $721re = parcelRequire("721re");

var $exYeM = parcelRequire("exYeM");

var $kdWpA = parcelRequire("kdWpA");
var $87exK = parcelRequire("87exK");
var $lCded = parcelRequire("lCded");
var $gbqqi = parcelRequire("gbqqi");
var $8vAG4 = parcelRequire("8vAG4");
var $ezzQB = parcelRequire("ezzQB");
var $ed4mS = parcelRequire("ed4mS");
var $71dP2 = parcelRequire("71dP2");
var $gEiSh = parcelRequire("gEiSh");

var $9ljKT = parcelRequire("9ljKT");
var $6FcvQ = parcelRequire("6FcvQ");

var $jgnwK = parcelRequire("jgnwK");

var $92Nxl = parcelRequire("92Nxl");
var $lcmdy = parcelRequire("lcmdy");
var $fu8ZQ = parcelRequire("fu8ZQ");

var $d2lNW = parcelRequire("d2lNW");

var $aVmq3 = parcelRequire("aVmq3");

var $lRiVc = parcelRequire("lRiVc");
function $b73f51611919ce3d$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b73f51611919ce3d$var$$edcf132a9284368a$var$AXIS = {
    top: "top",
    bottom: "top",
    left: "left",
    right: "left"
};
const $b73f51611919ce3d$var$$edcf132a9284368a$var$FLIPPED_DIRECTION = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
const $b73f51611919ce3d$var$$edcf132a9284368a$var$CROSS_AXIS = {
    top: "left",
    left: "top"
};
const $b73f51611919ce3d$var$$edcf132a9284368a$var$AXIS_SIZE = {
    top: "height",
    left: "width"
};
const $b73f51611919ce3d$var$$edcf132a9284368a$var$TOTAL_SIZE = {
    width: "totalWidth",
    height: "totalHeight"
};
const $b73f51611919ce3d$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {};
// @ts-ignore
let $b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
function $b73f51611919ce3d$var$$edcf132a9284368a$var$getContainerDimensions(containerNode) {
    let width = 0, height = 0, totalWidth = 0, totalHeight = 0, top = 0, left = 0;
    let scroll = {};
    let isPinchZoomedIn = ($b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport === null || $b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport.scale) > 1;
    if (containerNode.tagName === "BODY") {
        let documentElement = document.documentElement;
        totalWidth = documentElement.clientWidth;
        totalHeight = documentElement.clientHeight;
        var _visualViewport_width;
        width = (_visualViewport_width = $b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport === null || $b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport.width) !== null && _visualViewport_width !== void 0 ? _visualViewport_width : totalWidth;
        var _visualViewport_height;
        height = (_visualViewport_height = $b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport === null || $b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport.height) !== null && _visualViewport_height !== void 0 ? _visualViewport_height : totalHeight;
        scroll.top = documentElement.scrollTop || containerNode.scrollTop;
        scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;
        // The goal of the below is to get a top/left value that represents the top/left of the visual viewport with
        // respect to the layout viewport origin. This combined with the scrollTop/scrollLeft will allow us to calculate
        // coordinates/values with respect to the visual viewport or with respect to the layout viewport.
        if ($b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport) {
            top = $b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport.offsetTop;
            left = $b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport.offsetLeft;
        }
    } else {
        ({ width: width, height: height, top: top, left: left } = $b73f51611919ce3d$var$$edcf132a9284368a$var$getOffset(containerNode));
        scroll.top = containerNode.scrollTop;
        scroll.left = containerNode.scrollLeft;
        totalWidth = width;
        totalHeight = height;
    }
    if ((0, $gbqqi.isWebKit)() && (containerNode.tagName === "BODY" || containerNode.tagName === "HTML") && isPinchZoomedIn) {
        // Safari will report a non-zero scrollTop/Left for the non-scrolling body/HTML element when pinch zoomed in unlike other browsers.
        // Set to zero for parity calculations so we get consistent positioning of overlays across all browsers.
        // Also switch to visualViewport.pageTop/pageLeft so that we still accomodate for scroll positioning for body/HTML elements that are actually scrollable
        // before pinch zoom happens
        scroll.top = 0;
        scroll.left = 0;
        top = $b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport.pageTop;
        left = $b73f51611919ce3d$var$$edcf132a9284368a$var$visualViewport.pageLeft;
    }
    return {
        width: width,
        height: height,
        totalWidth: totalWidth,
        totalHeight: totalHeight,
        scroll: scroll,
        top: top,
        left: left
    };
}
function $b73f51611919ce3d$var$$edcf132a9284368a$var$getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
// Determines the amount of space required when moving the overlay to ensure it remains in the boundary
function $b73f51611919ce3d$var$$edcf132a9284368a$var$getDelta(axis, offset, size, // positioned within (most of the time this is the <body>).
boundaryDimensions, // positioned relative to (e.g. parent with position: relative).
// Usually this is the same as the boundary element, but if the popover
// is portaled somewhere other than the body and has an ancestor with
// position: relative/absolute, it will be different.
containerDimensions, padding, containerOffsetWithBoundary) {
    let containerScroll = containerDimensions.scroll[axis];
    // The height/width of the boundary. Matches the axis along which we are adjusting the overlay position
    let boundarySize = boundaryDimensions[$b73f51611919ce3d$var$$edcf132a9284368a$var$AXIS_SIZE[axis]];
    // Calculate the edges of the boundary (accomodating for the boundary padding) and the edges of the overlay.
    // Note that these values are with respect to the visual viewport (aka 0,0 is the top left of the viewport)
    let boundaryStartEdge = boundaryDimensions.scroll[$b73f51611919ce3d$var$$edcf132a9284368a$var$AXIS[axis]] + padding;
    let boundaryEndEdge = boundarySize + boundaryDimensions.scroll[$b73f51611919ce3d$var$$edcf132a9284368a$var$AXIS[axis]] - padding;
    let startEdgeOffset = offset - containerScroll + containerOffsetWithBoundary[axis] - boundaryDimensions[$b73f51611919ce3d$var$$edcf132a9284368a$var$AXIS[axis]];
    let endEdgeOffset = offset - containerScroll + size + containerOffsetWithBoundary[axis] - boundaryDimensions[$b73f51611919ce3d$var$$edcf132a9284368a$var$AXIS[axis]];
    // If any of the overlay edges falls outside of the boundary, shift the overlay the required amount to align one of the overlay's
    // edges with the closest boundary edge.
    if (startEdgeOffset < boundaryStartEdge) return boundaryStartEdge - startEdgeOffset;
    else if (endEdgeOffset > boundaryEndEdge) return Math.max(boundaryEndEdge - endEdgeOffset, boundaryStartEdge - startEdgeOffset);
    else return 0;
}
function $b73f51611919ce3d$var$$edcf132a9284368a$var$getMargins(node) {
    let style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function $b73f51611919ce3d$var$$edcf132a9284368a$var$parsePlacement(input) {
    if ($b73f51611919ce3d$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input]) return $b73f51611919ce3d$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
    let [placement, crossPlacement] = input.split(" ");
    let axis = $b73f51611919ce3d$var$$edcf132a9284368a$var$AXIS[placement] || "right";
    let crossAxis = $b73f51611919ce3d$var$$edcf132a9284368a$var$CROSS_AXIS[axis];
    if (!$b73f51611919ce3d$var$$edcf132a9284368a$var$AXIS[crossPlacement]) crossPlacement = "center";
    let size = $b73f51611919ce3d$var$$edcf132a9284368a$var$AXIS_SIZE[axis];
    let crossSize = $b73f51611919ce3d$var$$edcf132a9284368a$var$AXIS_SIZE[crossAxis];
    $b73f51611919ce3d$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return $b73f51611919ce3d$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
}
function $b73f51611919ce3d$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset) {
    let { placement: placement, crossPlacement: crossPlacement, axis: axis, crossAxis: crossAxis, size: size, crossSize: crossSize } = placementInfo;
    let position = {};
    // button position
    position[crossAxis] = childOffset[crossAxis];
    if (crossPlacement === "center") // at this point the overlay center should match the button center
    position[crossAxis] += (childOffset[crossSize] - overlaySize[crossSize]) / 2;
    else if (crossPlacement !== crossAxis) // at this point the overlay bottom should match the button bottom
    position[crossAxis] += childOffset[crossSize] - overlaySize[crossSize];
    /* else {
    the overlay top should match the button top
  } */ position[crossAxis] += crossOffset;
    // overlay top overlapping arrow with button bottom
    const minPosition = childOffset[crossAxis] - overlaySize[crossSize] + arrowSize + arrowBoundaryOffset;
    // overlay bottom overlapping arrow with button top
    const maxPosition = childOffset[crossAxis] + childOffset[crossSize] - arrowSize - arrowBoundaryOffset;
    position[crossAxis] = (0, $87exK.clamp)(position[crossAxis], minPosition, maxPosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container, which should be as large as boundaryDimensions.
        const containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] : boundaryDimensions[$b73f51611919ce3d$var$$edcf132a9284368a$var$TOTAL_SIZE[size]];
        position[$b73f51611919ce3d$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function $b73f51611919ce3d$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlayHeight, heightGrowthDirection) {
    const containerHeight = isContainerPositioned ? containerOffsetWithBoundary.height : boundaryDimensions[$b73f51611919ce3d$var$$edcf132a9284368a$var$TOTAL_SIZE.height];
    // For cases where position is set via "bottom" instead of "top", we need to calculate the true overlay top with respect to the boundary. Reverse calculate this with the same method
    // used in computePosition.
    let overlayTop = position.top != null ? containerOffsetWithBoundary.top + position.top : containerOffsetWithBoundary.top + (containerHeight - position.bottom - overlayHeight);
    let maxHeight = heightGrowthDirection !== "top" ? Math.max(0, boundaryDimensions.height + boundaryDimensions.top + boundaryDimensions.scroll.top // this is the bottom of the boundary
     - overlayTop // this is the top of the overlay
     - (margins.top + margins.bottom + padding // save additional space for margin and padding
    )) : Math.max(0, overlayTop + overlayHeight // this is the bottom of the overlay
     - (boundaryDimensions.top + boundaryDimensions.scroll.top // this is the top of the boundary
    ) - (margins.top + margins.bottom + padding // save additional space for margin and padding
    ));
    return Math.min(boundaryDimensions.height - padding * 2, maxHeight);
}
function $b73f51611919ce3d$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
    let { placement: placement, axis: axis, size: size } = placementInfo;
    if (placement === axis) return Math.max(0, childOffset[axis] - boundaryDimensions[axis] - boundaryDimensions.scroll[axis] + containerOffsetWithBoundary[axis] - margins[axis] - margins[$b73f51611919ce3d$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + boundaryDimensions.scroll[axis] - containerOffsetWithBoundary[axis] - childOffset[axis] - childOffset[size] - margins[axis] - margins[$b73f51611919ce3d$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $b73f51611919ce3d$var$$edcf132a9284368a$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight, arrowSize, arrowBoundaryOffset) {
    let placementInfo = $b73f51611919ce3d$var$$edcf132a9284368a$var$parsePlacement(placementInput);
    let { size: size, crossAxis: crossAxis, crossSize: crossSize, placement: placement, crossPlacement: crossPlacement } = placementInfo;
    let position = $b73f51611919ce3d$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    let normalizedOffset = offset;
    let space = $b73f51611919ce3d$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && scrollSize[size] > space) {
        let flippedPlacementInfo = $b73f51611919ce3d$var$$edcf132a9284368a$var$parsePlacement(`${$b73f51611919ce3d$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
        let flippedPosition = $b73f51611919ce3d$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
        let flippedSpace = $b73f51611919ce3d$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    // Determine the direction the height of the overlay can grow so that we can choose how to calculate the max height
    let heightGrowthDirection = "bottom";
    if (placementInfo.axis === "top") {
        if (placementInfo.placement === "top") heightGrowthDirection = "top";
        else if (placementInfo.placement === "bottom") heightGrowthDirection = "bottom";
    } else if (placementInfo.crossAxis === "top") {
        if (placementInfo.crossPlacement === "top") heightGrowthDirection = "bottom";
        else if (placementInfo.crossPlacement === "bottom") heightGrowthDirection = "top";
    }
    let delta = $b73f51611919ce3d$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let maxHeight = $b73f51611919ce3d$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlaySize.height, heightGrowthDirection);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = $b73f51611919ce3d$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    delta = $b73f51611919ce3d$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let arrowPosition = {};
    // All values are transformed so that 0 is at the top/left of the overlay depending on the orientation
    // Prefer the arrow being in the center of the trigger/overlay anchor element
    let preferredArrowPosition = childOffset[crossAxis] + .5 * childOffset[crossSize] - overlaySize[crossAxis];
    // Min/Max position limits for the arrow with respect to the overlay
    const arrowMinPosition = arrowSize / 2 + arrowBoundaryOffset;
    const arrowMaxPosition = overlaySize[crossSize] - arrowSize / 2 - arrowBoundaryOffset;
    // Min/Max position limits for the arrow with respect to the trigger/overlay anchor element
    const arrowOverlappingChildMinEdge = childOffset[crossAxis] - overlaySize[crossAxis] + arrowSize / 2;
    const arrowOverlappingChildMaxEdge = childOffset[crossAxis] + childOffset[crossSize] - overlaySize[crossAxis] - arrowSize / 2;
    // Clamp the arrow positioning so that it always is within the bounds of the anchor and the overlay
    const arrowPositionOverlappingChild = (0, $87exK.clamp)(preferredArrowPosition, arrowOverlappingChildMinEdge, arrowOverlappingChildMaxEdge);
    arrowPosition[crossAxis] = (0, $87exK.clamp)(arrowPositionOverlappingChild, arrowMinPosition, arrowMaxPosition);
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placementInfo.placement
    };
}
function $b73f51611919ce3d$var$$edcf132a9284368a$export$b3ceb0cbf1056d98(opts) {
    let { placement: placement, targetNode: targetNode, overlayNode: overlayNode, scrollNode: scrollNode, padding: padding, shouldFlip: shouldFlip, boundaryElement: boundaryElement, offset: offset, crossOffset: crossOffset, maxHeight: maxHeight, arrowSize: arrowSize = 0, arrowBoundaryOffset: arrowBoundaryOffset = 0 } = opts;
    let container = overlayNode instanceof HTMLElement ? $b73f51611919ce3d$var$$edcf132a9284368a$var$getContainingBlock(overlayNode) : document.documentElement;
    let isViewportContainer = container === document.documentElement;
    const containerPositionStyle = window.getComputedStyle(container).position;
    let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== "static";
    let childOffset = isViewportContainer ? $b73f51611919ce3d$var$$edcf132a9284368a$var$getOffset(targetNode) : $b73f51611919ce3d$var$$edcf132a9284368a$var$getPosition(targetNode, container);
    if (!isViewportContainer) {
        let { marginTop: marginTop, marginLeft: marginLeft } = window.getComputedStyle(targetNode);
        childOffset.top += parseInt(marginTop, 10) || 0;
        childOffset.left += parseInt(marginLeft, 10) || 0;
    }
    let overlaySize = $b73f51611919ce3d$var$$edcf132a9284368a$var$getOffset(overlayNode);
    let margins = $b73f51611919ce3d$var$$edcf132a9284368a$var$getMargins(overlayNode);
    overlaySize.width += margins.left + margins.right;
    overlaySize.height += margins.top + margins.bottom;
    let scrollSize = $b73f51611919ce3d$var$$edcf132a9284368a$var$getScroll(scrollNode);
    let boundaryDimensions = $b73f51611919ce3d$var$$edcf132a9284368a$var$getContainerDimensions(boundaryElement);
    let containerDimensions = $b73f51611919ce3d$var$$edcf132a9284368a$var$getContainerDimensions(container);
    // If the container is the HTML element wrapping the body element, the retrieved scrollTop/scrollLeft will be equal to the
    // body element's scroll. Set the container's scroll values to 0 since the overlay's edge position value in getDelta don't then need to be further offset
    // by the container scroll since they are essentially the same containing element and thus in the same coordinate system
    let containerOffsetWithBoundary = boundaryElement.tagName === "BODY" ? $b73f51611919ce3d$var$$edcf132a9284368a$var$getOffset(container) : $b73f51611919ce3d$var$$edcf132a9284368a$var$getPosition(container, boundaryElement);
    if (container.tagName === "HTML" && boundaryElement.tagName === "BODY") {
        containerDimensions.scroll.top = 0;
        containerDimensions.scroll.left = 0;
    }
    return $b73f51611919ce3d$var$$edcf132a9284368a$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight, arrowSize, arrowBoundaryOffset);
}
function $b73f51611919ce3d$var$$edcf132a9284368a$var$getOffset(node) {
    let { top: top, left: left, width: width, height: height } = node.getBoundingClientRect();
    let { scrollTop: scrollTop, scrollLeft: scrollLeft, clientTop: clientTop, clientLeft: clientLeft } = document.documentElement;
    return {
        top: top + scrollTop - clientTop,
        left: left + scrollLeft - clientLeft,
        width: width,
        height: height
    };
}
function $b73f51611919ce3d$var$$edcf132a9284368a$var$getPosition(node, parent) {
    let style = window.getComputedStyle(node);
    let offset;
    if (style.position === "fixed") {
        let { top: top, left: left, width: width, height: height } = node.getBoundingClientRect();
        offset = {
            top: top,
            left: left,
            width: width,
            height: height
        };
    } else {
        offset = $b73f51611919ce3d$var$$edcf132a9284368a$var$getOffset(node);
        let parentOffset = $b73f51611919ce3d$var$$edcf132a9284368a$var$getOffset(parent);
        let parentStyle = window.getComputedStyle(parent);
        parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
        parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
        offset.top -= parentOffset.top;
        offset.left -= parentOffset.left;
    }
    offset.top -= parseInt(style.marginTop, 10) || 0;
    offset.left -= parseInt(style.marginLeft, 10) || 0;
    return offset;
}
// Returns the containing block of an element, which is the element that
// this element will be positioned relative to.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
function $b73f51611919ce3d$var$$edcf132a9284368a$var$getContainingBlock(node) {
    // The offsetParent of an element in most cases equals the containing block.
    // https://w3c.github.io/csswg-drafts/cssom-view/#dom-htmlelement-offsetparent
    let offsetParent = node.offsetParent;
    // The offsetParent algorithm terminates at the document body,
    // even if the body is not a containing block. Double check that
    // and use the documentElement if so.
    if (offsetParent && offsetParent === document.body && window.getComputedStyle(offsetParent).position === "static" && !$b73f51611919ce3d$var$$edcf132a9284368a$var$isContainingBlock(offsetParent)) offsetParent = document.documentElement;
    // TODO(later): handle table elements?
    // The offsetParent can be null if the element has position: fixed, or a few other cases.
    // We have to walk up the tree manually in this case because fixed positioned elements
    // are still positioned relative to their containing block, which is not always the viewport.
    if (offsetParent == null) {
        offsetParent = node.parentElement;
        while(offsetParent && !$b73f51611919ce3d$var$$edcf132a9284368a$var$isContainingBlock(offsetParent))offsetParent = offsetParent.parentElement;
    }
    // Fall back to the viewport.
    return offsetParent || document.documentElement;
}
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
function $b73f51611919ce3d$var$$edcf132a9284368a$var$isContainingBlock(node) {
    let style = window.getComputedStyle(node);
    return style.transform !== "none" || /transform|perspective/.test(style.willChange) || style.filter !== "none" || style.contain === "paint" || // @ts-ignore
    "backdropFilter" in style && style.backdropFilter !== "none" || // @ts-ignore
    "WebkitBackdropFilter" in style && style.WebkitBackdropFilter !== "none";
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b73f51611919ce3d$var$$dd149f63282afbbf$export$f6211563215e3b37 = new WeakMap();
function $b73f51611919ce3d$var$$dd149f63282afbbf$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef, isOpen: isOpen, onClose: onClose } = opts;
    (0, $exYeM.useEffect)(()=>{
        if (!isOpen || onClose === null) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            let onCloseHandler = onClose || $b73f51611919ce3d$var$$dd149f63282afbbf$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener("scroll", onScroll, true);
        return ()=>{
            window.removeEventListener("scroll", onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}
// @ts-ignore
let $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
function $b73f51611919ce3d$export$d39e1813b3bdd0e1(props) {
    let { direction: direction } = (0, $9ljKT.useLocale)();
    let { arrowSize: arrowSize = 0, targetRef: targetRef, overlayRef: overlayRef, scrollRef: scrollRef = overlayRef, placement: placement = "bottom", containerPadding: containerPadding = 12, shouldFlip: shouldFlip = true, boundaryElement: boundaryElement = typeof document !== "undefined" ? document.body : null, offset: offset = 0, crossOffset: crossOffset = 0, shouldUpdatePosition: shouldUpdatePosition = true, isOpen: isOpen = true, onClose: onClose, maxHeight: maxHeight, arrowBoundaryOffset: arrowBoundaryOffset = 0 } = props;
    let [position, setPosition] = (0, $exYeM.useState)({
        position: {},
        arrowOffsetLeft: undefined,
        arrowOffsetTop: undefined,
        maxHeight: undefined,
        placement: undefined
    });
    let deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight,
        arrowBoundaryOffset,
        arrowSize
    ];
    // Note, the position freezing breaks if body sizes itself dynamicly with the visual viewport but that might
    // just be a non-realistic use case
    // Upon opening a overlay, record the current visual viewport scale so we can freeze the overlay styles
    let lastScale = (0, $exYeM.useRef)($b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport === null || $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport.scale);
    (0, $exYeM.useEffect)(()=>{
        if (isOpen) lastScale.current = $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport === null || $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport.scale;
    }, [
        isOpen
    ]);
    let updatePosition = (0, $exYeM.useCallback)(()=>{
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !scrollRef.current || !boundaryElement) return;
        if (($b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport === null || $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport.scale) !== lastScale.current) return;
        // Always reset the overlay's previous max height if not defined by the user so that we can compensate for
        // RAC collections populating after a second render and properly set a correct max height + positioning when it populates.
        if (!maxHeight && overlayRef.current) overlayRef.current.style.maxHeight = "none";
        let position = $b73f51611919ce3d$var$$edcf132a9284368a$export$b3ceb0cbf1056d98({
            placement: $b73f51611919ce3d$var$$2a41e45df1593e64$var$translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight,
            arrowSize: arrowSize,
            arrowBoundaryOffset: arrowBoundaryOffset
        });
        // Modify overlay styles directly so positioning happens immediately without the need of a second render
        // This is so we don't have to delay autoFocus scrolling or delay applying preventScroll for popovers
        Object.keys(position.position).forEach((key)=>overlayRef.current.style[key] = position.position[key] + "px");
        overlayRef.current.style.maxHeight = position.maxHeight != null ? position.maxHeight + "px" : undefined;
        // Trigger a set state for a second render anyway for arrow positioning
        setPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    (0, $71dP2.useLayoutEffect)(updatePosition, deps);
    // Update position on window resize
    $b73f51611919ce3d$var$$2a41e45df1593e64$var$useResize(updatePosition);
    (0, $gEiSh.useResizeObserver)({
        ref: overlayRef,
        onResize: updatePosition
    });
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    let isResizing = (0, $exYeM.useRef)(false);
    (0, $71dP2.useLayoutEffect)(()=>{
        let timeout;
        let onResize = ()=>{
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        // Only reposition the overlay if a scroll event happens immediately as a result of resize (aka the virtual keyboard has appears)
        // We don't want to reposition the overlay if the user has pinch zoomed in and is scrolling the viewport around.
        let onScroll = ()=>{
            if (isResizing.current) onResize();
        };
        $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport === null || $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport === void 0 || $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport.addEventListener("resize", onResize);
        $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport === null || $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport === void 0 || $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport.addEventListener("scroll", onScroll);
        return ()=>{
            $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport === null || $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport === void 0 || $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport.removeEventListener("resize", onResize);
            $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport === null || $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport === void 0 || $b73f51611919ce3d$var$$2a41e45df1593e64$var$visualViewport.removeEventListener("scroll", onScroll);
        };
    }, [
        updatePosition
    ]);
    let close = (0, $exYeM.useCallback)(()=>{
        if (!isResizing.current) onClose();
    }, [
        onClose,
        isResizing
    ]);
    $b73f51611919ce3d$var$$dd149f63282afbbf$export$18fc8428861184da({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose && close
    });
    return {
        overlayProps: {
            style: {
                position: "absolute",
                zIndex: 100000,
                ...position.position,
                maxHeight: position.maxHeight
            }
        },
        placement: position.placement,
        arrowProps: {
            "aria-hidden": "true",
            role: "presentation",
            style: {
                left: position.arrowOffsetLeft,
                top: position.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function $b73f51611919ce3d$var$$2a41e45df1593e64$var$useResize(onResize) {
    (0, $71dP2.useLayoutEffect)(()=>{
        window.addEventListener("resize", onResize, false);
        return ()=>{
            window.removeEventListener("resize", onResize, false);
        };
    }, [
        onResize
    ]);
}
function $b73f51611919ce3d$var$$2a41e45df1593e64$var$translateRTL(position, direction) {
    if (direction === "rtl") return position.replace("start", "right").replace("end", "left");
    return position.replace("start", "left").replace("end", "right");
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b73f51611919ce3d$var$$a11501f3d1d39e6c$var$visibleOverlays = [];
function $b73f51611919ce3d$export$ea8f71083e90600f(props, ref) {
    let { onClose: onClose, shouldCloseOnBlur: shouldCloseOnBlur, isOpen: isOpen, isDismissable: isDismissable = false, isKeyboardDismissDisabled: isKeyboardDismissDisabled = false, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside } = props;
    (0, $exYeM.useEffect)(()=>{
        if (isOpen) $b73f51611919ce3d$var$$a11501f3d1d39e6c$var$visibleOverlays.push(ref);
        return ()=>{
            let index = $b73f51611919ce3d$var$$a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref);
            if (index >= 0) $b73f51611919ce3d$var$$a11501f3d1d39e6c$var$visibleOverlays.splice(index, 1);
        };
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack
    let onHide = ()=>{
        if ($b73f51611919ce3d$var$$a11501f3d1d39e6c$var$visibleOverlays[$b73f51611919ce3d$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    let onInteractOutsideStart = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($b73f51611919ce3d$var$$a11501f3d1d39e6c$var$visibleOverlays[$b73f51611919ce3d$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };
    let onInteractOutside = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($b73f51611919ce3d$var$$a11501f3d1d39e6c$var$visibleOverlays[$b73f51611919ce3d$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
            onHide();
        }
    };
    // Handle the escape key
    let onKeyDown = (e)=>{
        if (e.key === "Escape" && !isKeyboardDismissDisabled) {
            e.stopPropagation();
            e.preventDefault();
            onHide();
        }
    };
    (0, $fu8ZQ.useInteractOutside)({
        ref: ref,
        onInteractOutside: isDismissable && isOpen ? onInteractOutside : null,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let { focusWithinProps: focusWithinProps } = (0, $lcmdy.useFocusWithin)({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: (e)=>{
            // Do not close if relatedTarget is null, which means focus is lost to the body.
            // That can happen when switching tabs, or due to a VoiceOver/Chrome bug with Control+Option+Arrow navigation.
            // Clicking on the body to close the overlay should already be handled by useInteractOutside.
            // https://github.com/adobe/react-spectrum/issues/4130
            // https://github.com/adobe/react-spectrum/issues/4922
            //
            // If focus is moving into a child focus scope (e.g. menu inside a dialog),
            // do not close the outer overlay. At this point, the active scope should
            // still be the outer overlay, since blur events run before focus.
            if (!e.relatedTarget || (0, $jgnwK.isElementInChildOfActiveScope)(e.relatedTarget)) return;
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose();
        }
    });
    let onPointerDownUnderlay = (e)=>{
        // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
        if (e.target === e.currentTarget) e.preventDefault();
    };
    return {
        overlayProps: {
            onKeyDown: onKeyDown,
            ...focusWithinProps
        },
        underlayProps: {
            onPointerDown: onPointerDownUnderlay
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b73f51611919ce3d$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type } = props;
    let { isOpen: isOpen } = state;
    (0, $exYeM.useEffect)(()=>{
        if (ref && ref.current) $b73f51611919ce3d$var$$dd149f63282afbbf$export$f6211563215e3b37.set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === "menu") ariaHasPopup = true;
    else if (type === "listbox") ariaHasPopup = "listbox";
    let overlayId = (0, $ezzQB.useId)();
    return {
        triggerProps: {
            "aria-haspopup": ariaHasPopup,
            "aria-expanded": isOpen,
            "aria-controls": isOpen ? overlayId : null,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore
const $b73f51611919ce3d$var$$49c51c25361d4cd2$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
// HTML input types that do not cause the software keyboard to appear.
const $b73f51611919ce3d$var$$49c51c25361d4cd2$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let $b73f51611919ce3d$var$$49c51c25361d4cd2$var$preventScrollCount = 0;
let $b73f51611919ce3d$var$$49c51c25361d4cd2$var$restore;
function $b73f51611919ce3d$export$ee0f7cc6afcd1c18(options = {}) {
    let { isDisabled: isDisabled } = options;
    (0, $71dP2.useLayoutEffect)(()=>{
        if (isDisabled) return;
        $b73f51611919ce3d$var$$49c51c25361d4cd2$var$preventScrollCount++;
        if ($b73f51611919ce3d$var$$49c51c25361d4cd2$var$preventScrollCount === 1) {
            if ((0, $gbqqi.isIOS)()) $b73f51611919ce3d$var$$49c51c25361d4cd2$var$restore = $b73f51611919ce3d$var$$49c51c25361d4cd2$var$preventScrollMobileSafari();
            else $b73f51611919ce3d$var$$49c51c25361d4cd2$var$restore = $b73f51611919ce3d$var$$49c51c25361d4cd2$var$preventScrollStandard();
        }
        return ()=>{
            $b73f51611919ce3d$var$$49c51c25361d4cd2$var$preventScrollCount--;
            if ($b73f51611919ce3d$var$$49c51c25361d4cd2$var$preventScrollCount === 0) $b73f51611919ce3d$var$$49c51c25361d4cd2$var$restore();
        };
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $b73f51611919ce3d$var$$49c51c25361d4cd2$var$preventScrollStandard() {
    return (0, $kdWpA.chain)($b73f51611919ce3d$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $b73f51611919ce3d$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Set `overscroll-behavior: contain` on nested scrollable regions so they do not scroll the page when at
//    the top or bottom. Work around a bug where this does not work when the element does not actually overflow
//    by preventing default in a `touchmove` event.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function $b73f51611919ce3d$var$$49c51c25361d4cd2$var$preventScrollMobileSafari() {
    let scrollable;
    let restoreScrollableStyles;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = (0, $lCded.getScrollParent)(e.target, true);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead.
        if (scrollable instanceof HTMLElement && window.getComputedStyle(scrollable).overscrollBehavior === "auto") restoreScrollableStyles = $b73f51611919ce3d$var$$49c51c25361d4cd2$var$setStyle(scrollable, "overscrollBehavior", "contain");
    };
    let onTouchMove = (e)=>{
        // Prevent scrolling the window.
        if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // overscroll-behavior should prevent scroll chaining, but currently does not
        // if the element doesn't actually overflow. https://bugs.webkit.org/show_bug.cgi?id=243452
        // This checks that both the width and height do not overflow, otherwise we might
        // block horizontal scrolling too. In that case, adding `touch-action: pan-x` to
        // the element will prevent vertical page scrolling. We can't add that automatically
        // because it must be set before the touchstart event.
        if (scrollable.scrollHeight === scrollable.clientHeight && scrollable.scrollWidth === scrollable.clientWidth) e.preventDefault();
    };
    let onTouchEnd = (e)=>{
        let target = e.target;
        // Apply this change if we're not already focused on the target element
        if ($b73f51611919ce3d$var$$49c51c25361d4cd2$var$willOpenKeyboard(target) && target !== document.activeElement) {
            e.preventDefault();
            setupStyles();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = "translateY(-2000px)";
            target.focus();
            requestAnimationFrame(()=>{
                target.style.transform = "";
            });
        }
        if (restoreScrollableStyles) restoreScrollableStyles();
    };
    let onFocus = (e)=>{
        let target = e.target;
        if ($b73f51611919ce3d$var$$49c51c25361d4cd2$var$willOpenKeyboard(target)) {
            setupStyles();
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = "translateY(-2000px)";
            requestAnimationFrame(()=>{
                target.style.transform = "";
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if ($b73f51611919ce3d$var$$49c51c25361d4cd2$var$visualViewport) {
                    if ($b73f51611919ce3d$var$$49c51c25361d4cd2$var$visualViewport.height < window.innerHeight) // to wait for the transform to be removed.
                    requestAnimationFrame(()=>{
                        $b73f51611919ce3d$var$$49c51c25361d4cd2$var$scrollIntoView(target);
                    });
                    else // measure the correct position to scroll to.
                    $b73f51611919ce3d$var$$49c51c25361d4cd2$var$visualViewport.addEventListener("resize", ()=>$b73f51611919ce3d$var$$49c51c25361d4cd2$var$scrollIntoView(target), {
                        once: true
                    });
                }
            });
        }
    };
    let restoreStyles = null;
    let setupStyles = ()=>{
        if (restoreStyles) return;
        let onWindowScroll = ()=>{
            // Last resort. If the window scrolled, scroll it back to the top.
            // It should always be at the top because the body will have a negative margin (see below).
            window.scrollTo(0, 0);
        };
        // Record the original scroll position so we can restore it.
        // Then apply a negative margin to the body to offset it by the scroll position. This will
        // enable us to scroll the window to the top, which is required for the rest of this to work.
        let scrollX = window.pageXOffset;
        let scrollY = window.pageYOffset;
        restoreStyles = (0, $kdWpA.chain)($b73f51611919ce3d$var$$49c51c25361d4cd2$var$addEvent(window, "scroll", onWindowScroll), $b73f51611919ce3d$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $b73f51611919ce3d$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"), $b73f51611919ce3d$var$$49c51c25361d4cd2$var$setStyle(document.body, "marginTop", `-${scrollY}px`), ()=>{
            window.scrollTo(scrollX, scrollY);
        });
        // Scroll to the top. The negative margin on the body will make this appear the same.
        window.scrollTo(0, 0);
    };
    let removeEvents = (0, $kdWpA.chain)($b73f51611919ce3d$var$$49c51c25361d4cd2$var$addEvent(document, "touchstart", onTouchStart, {
        passive: false,
        capture: true
    }), $b73f51611919ce3d$var$$49c51c25361d4cd2$var$addEvent(document, "touchmove", onTouchMove, {
        passive: false,
        capture: true
    }), $b73f51611919ce3d$var$$49c51c25361d4cd2$var$addEvent(document, "touchend", onTouchEnd, {
        passive: false,
        capture: true
    }), $b73f51611919ce3d$var$$49c51c25361d4cd2$var$addEvent(document, "focus", onFocus, true));
    return ()=>{
        // Restore styles and scroll the page back to where it was.
        restoreScrollableStyles === null || restoreScrollableStyles === void 0 || restoreScrollableStyles();
        restoreStyles === null || restoreStyles === void 0 || restoreStyles();
        removeEvents();
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $b73f51611919ce3d$var$$49c51c25361d4cd2$var$setStyle(element, style, value) {
    let cur = element.style[style];
    element.style[style] = value;
    return ()=>{
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $b73f51611919ce3d$var$$49c51c25361d4cd2$var$addEvent(target, event, handler, options) {
    target.addEventListener(event, handler, options);
    return ()=>{
        target.removeEventListener(event, handler, options);
    };
}
function $b73f51611919ce3d$var$$49c51c25361d4cd2$var$scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    while(target && target !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = (0, $lCded.getScrollParent)(target);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== target) {
            let scrollableTop = scrollable.getBoundingClientRect().top;
            let targetTop = target.getBoundingClientRect().top;
            if (targetTop > scrollableTop + target.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
        }
        target = scrollable.parentElement;
    }
}
function $b73f51611919ce3d$var$$49c51c25361d4cd2$var$willOpenKeyboard(target) {
    return target instanceof HTMLInputElement && !$b73f51611919ce3d$var$$49c51c25361d4cd2$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b73f51611919ce3d$var$$f57aed4a881a3485$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
function $b73f51611919ce3d$export$178405afcd8c5eb(props) {
    let { children: children } = props;
    let parent = (0, $exYeM.useContext)($b73f51611919ce3d$var$$f57aed4a881a3485$var$Context);
    let [modalCount, setModalCount] = (0, $exYeM.useState)(0);
    let context = (0, $exYeM.useMemo)(()=>({
            parent: parent,
            modalCount: modalCount,
            addModal () {
                setModalCount((count)=>count + 1);
                if (parent) parent.addModal();
            },
            removeModal () {
                setModalCount((count)=>count - 1);
                if (parent) parent.removeModal();
            }
        }), [
        parent,
        modalCount
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($b73f51611919ce3d$var$$f57aed4a881a3485$var$Context.Provider, {
        value: context
    }, children);
}
function $b73f51611919ce3d$export$d9aaed4c3ece1bc0() {
    let context = (0, $exYeM.useContext)($b73f51611919ce3d$var$$f57aed4a881a3485$var$Context);
    return {
        modalProviderProps: {
            "aria-hidden": context && context.modalCount > 0 ? true : null
        }
    };
}
/**
 * Creates a root node that will be aria-hidden if there are other modals open.
 */ function $b73f51611919ce3d$var$$f57aed4a881a3485$var$OverlayContainerDOM(props) {
    let { modalProviderProps: modalProviderProps } = $b73f51611919ce3d$export$d9aaed4c3ece1bc0();
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        "data-overlay-container": true,
        ...props,
        ...modalProviderProps
    });
}
function $b73f51611919ce3d$export$bf688221f59024e5(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($b73f51611919ce3d$export$178405afcd8c5eb, null, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($b73f51611919ce3d$var$$f57aed4a881a3485$var$OverlayContainerDOM, props));
}
function $b73f51611919ce3d$export$b47c3594eab58386(props) {
    let isSSR = (0, $aVmq3.useIsSSR)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, ...rest } = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (portalContainer === null || portalContainer === void 0 ? void 0 : portalContainer.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
    }, [
        portalContainer
    ]);
    if (!portalContainer) return null;
    let contents = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($b73f51611919ce3d$export$bf688221f59024e5, rest);
    return (0, (/*@__PURE__*/$parcel$interopDefault($d2lNW))).createPortal(contents, portalContainer);
}
function $b73f51611919ce3d$export$33ffd74ebf07f060(options) {
    // Add aria-hidden to all parent providers on mount, and restore on unmount.
    let context = (0, $exYeM.useContext)($b73f51611919ce3d$var$$f57aed4a881a3485$var$Context);
    if (!context) throw new Error("Modal is not contained within a provider");
    (0, $exYeM.useEffect)(()=>{
        if ((options === null || options === void 0 ? void 0 : options.isDisabled) || !context || !context.parent) return;
        // The immediate context is from the provider containing this modal, so we only
        // want to trigger aria-hidden on its parents not on the modal provider itself.
        context.parent.addModal();
        return ()=>{
            if (context && context.parent) context.parent.removeModal();
        };
    }, [
        context,
        context.parent,
        options === null || options === void 0 ? void 0 : options.isDisabled
    ]);
    return {
        modalProps: {
            "data-ismodal": !(options === null || options === void 0 ? void 0 : options.isDisabled)
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $b73f51611919ce3d$var$$a2f21f5f14f60553$exports = {};
$b73f51611919ce3d$var$$a2f21f5f14f60553$exports = {
    "ar-AE": (0, $4QjZq.default),
    "bg-BG": (0, $2ejYU.default),
    "cs-CZ": (0, $aLVKe.default),
    "da-DK": (0, $l3N8j.default),
    "de-DE": (0, $kCzX0.default),
    "el-GR": (0, $gpz0A.default),
    "en-US": (0, $k4L3y.default),
    "es-ES": (0, $fM69b.default),
    "et-EE": (0, $97Rf5.default),
    "fi-FI": (0, $gxfQE.default),
    "fr-FR": (0, $ejcuW.default),
    "he-IL": (0, $f4Dn9.default),
    "hr-HR": (0, $9ZZ9S.default),
    "hu-HU": (0, $3Sr89.default),
    "it-IT": (0, $joMOA.default),
    "ja-JP": (0, $c27Q8.default),
    "ko-KR": (0, $7jPjR.default),
    "lt-LT": (0, $cJjZ8.default),
    "lv-LV": (0, $ckobM.default),
    "nb-NO": (0, $90wC2.default),
    "nl-NL": (0, $dLwUu.default),
    "pl-PL": (0, $EgOYE.default),
    "pt-BR": (0, $gximO.default),
    "pt-PT": (0, $jcQqf.default),
    "ro-RO": (0, $3kfB5.default),
    "ru-RU": (0, $7rWM7.default),
    "sk-SK": (0, $cWJ1G.default),
    "sl-SI": (0, $6Bi3e.default),
    "sr-SP": (0, $c5ynI.default),
    "sv-SE": (0, $2ShnL.default),
    "tr-TR": (0, $gzXzc.default),
    "uk-UA": (0, $hAcha.default),
    "zh-CN": (0, $aUBCP.default),
    "zh-TW": (0, $721re.default)
};
function $b73f51611919ce3d$export$2317d149ed6f78c4(props) {
    let { onDismiss: onDismiss, ...otherProps } = props;
    let stringFormatter = (0, $6FcvQ.useLocalizedStringFormatter)(/*@__PURE__*/ $b73f51611919ce3d$var$$parcel$interopDefault($b73f51611919ce3d$var$$a2f21f5f14f60553$exports), "@react-aria/overlays");
    let labels = (0, $ed4mS.useLabels)(otherProps, stringFormatter.format("dismiss"));
    let onClick = ()=>{
        if (onDismiss) onDismiss();
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $lRiVc.VisuallyHidden), null, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("button", {
        ...labels,
        tabIndex: -1,
        onClick: onClick,
        style: {
            width: 1,
            height: 1
        }
    }));
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
let $b73f51611919ce3d$var$$5e3802645cc19319$var$refCountMap = new WeakMap();
let $b73f51611919ce3d$var$$5e3802645cc19319$var$observerStack = [];
function $b73f51611919ce3d$export$1c3ebcada18427bf(targets, root = document.body) {
    let visibleNodes = new Set(targets);
    let hiddenNodes = new Set();
    let walk = (root)=>{
        // Keep live announcer and top layer elements (e.g. toasts) visible.
        for (let element of root.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]"))visibleNodes.add(element);
        let acceptNode = (node)=>{
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
            // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
            // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
            if (visibleNodes.has(node) || hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
            // Skip this node but continue to children if one of the targets is inside the node.
            for (let target of visibleNodes){
                if (node.contains(target)) return NodeFilter.FILTER_SKIP;
            }
            return NodeFilter.FILTER_ACCEPT;
        };
        let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
            acceptNode: acceptNode
        });
        // TreeWalker does not include the root.
        let acceptRoot = acceptNode(root);
        if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root);
        if (acceptRoot !== NodeFilter.FILTER_REJECT) {
            let node = walker.nextNode();
            while(node != null){
                hide(node);
                node = walker.nextNode();
            }
        }
    };
    let hide = (node)=>{
        var _refCountMap_get;
        let refCount = (_refCountMap_get = $b73f51611919ce3d$var$$5e3802645cc19319$var$refCountMap.get(node)) !== null && _refCountMap_get !== void 0 ? _refCountMap_get : 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (node.getAttribute("aria-hidden") === "true" && refCount === 0) return;
        if (refCount === 0) node.setAttribute("aria-hidden", "true");
        hiddenNodes.add(node);
        $b73f51611919ce3d$var$$5e3802645cc19319$var$refCountMap.set(node, refCount + 1);
    };
    // If there is already a MutationObserver listening from a previous call,
    // disconnect it so the new on takes over.
    if ($b73f51611919ce3d$var$$5e3802645cc19319$var$observerStack.length) $b73f51611919ce3d$var$$5e3802645cc19319$var$observerStack[$b73f51611919ce3d$var$$5e3802645cc19319$var$observerStack.length - 1].disconnect();
    walk(root);
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== "childList" || change.addedNodes.length === 0) continue;
            // If the parent element of the added nodes is not within one of the targets,
            // and not already inside a hidden node, hide all of the new children.
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target))) {
                for (let node of change.removedNodes)if (node instanceof Element) {
                    visibleNodes.delete(node);
                    hiddenNodes.delete(node);
                }
                for (let node of change.addedNodes){
                    if ((node instanceof HTMLElement || node instanceof SVGElement) && (node.dataset.liveAnnouncer === "true" || node.dataset.reactAriaTopLayer === "true")) visibleNodes.add(node);
                    else if (node instanceof Element) walk(node);
                }
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    let observerWrapper = {
        observe () {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect () {
            observer.disconnect();
        }
    };
    $b73f51611919ce3d$var$$5e3802645cc19319$var$observerStack.push(observerWrapper);
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = $b73f51611919ce3d$var$$5e3802645cc19319$var$refCountMap.get(node);
            if (count === 1) {
                node.removeAttribute("aria-hidden");
                $b73f51611919ce3d$var$$5e3802645cc19319$var$refCountMap.delete(node);
            } else $b73f51611919ce3d$var$$5e3802645cc19319$var$refCountMap.set(node, count - 1);
        }
        // Remove this observer from the stack, and start the previous one.
        if (observerWrapper === $b73f51611919ce3d$var$$5e3802645cc19319$var$observerStack[$b73f51611919ce3d$var$$5e3802645cc19319$var$observerStack.length - 1]) {
            $b73f51611919ce3d$var$$5e3802645cc19319$var$observerStack.pop();
            if ($b73f51611919ce3d$var$$5e3802645cc19319$var$observerStack.length) $b73f51611919ce3d$var$$5e3802645cc19319$var$observerStack[$b73f51611919ce3d$var$$5e3802645cc19319$var$observerStack.length - 1].observe();
        } else $b73f51611919ce3d$var$$5e3802645cc19319$var$observerStack.splice($b73f51611919ce3d$var$$5e3802645cc19319$var$observerStack.indexOf(observerWrapper), 1);
    };
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b73f51611919ce3d$export$542a6fd13ac93354(props, state) {
    let { triggerRef: triggerRef, popoverRef: popoverRef, isNonModal: isNonModal, isKeyboardDismissDisabled: isKeyboardDismissDisabled, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, ...otherProps } = props;
    let { overlayProps: overlayProps, underlayProps: underlayProps } = $b73f51611919ce3d$export$ea8f71083e90600f({
        isOpen: state.isOpen,
        onClose: state.close,
        shouldCloseOnBlur: true,
        isDismissable: !isNonModal,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, popoverRef);
    let { overlayProps: positionProps, arrowProps: arrowProps, placement: placement } = $b73f51611919ce3d$export$d39e1813b3bdd0e1({
        ...otherProps,
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        onClose: isNonModal ? state.close : null
    });
    $b73f51611919ce3d$export$ee0f7cc6afcd1c18({
        isDisabled: isNonModal || !state.isOpen
    });
    (0, $71dP2.useLayoutEffect)(()=>{
        if (state.isOpen && !isNonModal && popoverRef.current) return $b73f51611919ce3d$export$1c3ebcada18427bf([
            popoverRef.current
        ]);
    }, [
        isNonModal,
        state.isOpen,
        popoverRef
    ]);
    return {
        popoverProps: (0, $8vAG4.mergeProps)(overlayProps, positionProps),
        arrowProps: arrowProps,
        underlayProps: underlayProps,
        placement: placement
    };
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b73f51611919ce3d$var$$337b884510726a0d$export$a2200b96afd16271 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
function $b73f51611919ce3d$export$c6fdb837b070b4ff(props) {
    let isSSR = (0, $aVmq3.useIsSSR)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, isExiting: isExiting } = props;
    let [contain, setContain] = (0, $exYeM.useState)(false);
    let contextValue = (0, $exYeM.useMemo)(()=>({
            contain: contain,
            setContain: setContain
        }), [
        contain,
        setContain
    ]);
    if (!portalContainer) return null;
    let contents = props.children;
    if (!props.disableFocusManagement) contents = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $jgnwK.FocusScope), {
        restoreFocus: true,
        contain: contain && !isExiting
    }, contents);
    contents = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($b73f51611919ce3d$var$$337b884510726a0d$export$a2200b96afd16271.Provider, {
        value: contextValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $92Nxl.ClearPressResponder), null, contents));
    return (0, (/*@__PURE__*/$parcel$interopDefault($d2lNW))).createPortal(contents, portalContainer);
}
function $b73f51611919ce3d$export$14c98a7594375490() {
    let ctx = (0, $exYeM.useContext)($b73f51611919ce3d$var$$337b884510726a0d$export$a2200b96afd16271);
    let setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
    (0, $71dP2.useLayoutEffect)(()=>{
        setContain === null || setContain === void 0 || setContain(true);
    }, [
        setContain
    ]);
}
function $b73f51611919ce3d$export$dbc0f175b25fb0fb(props, state, ref) {
    let { overlayProps: overlayProps, underlayProps: underlayProps } = $b73f51611919ce3d$export$ea8f71083e90600f({
        ...props,
        isOpen: state.isOpen,
        onClose: state.close
    }, ref);
    $b73f51611919ce3d$export$ee0f7cc6afcd1c18({
        isDisabled: !state.isOpen
    });
    $b73f51611919ce3d$export$14c98a7594375490();
    (0, $exYeM.useEffect)(()=>{
        if (state.isOpen) return $b73f51611919ce3d$export$1c3ebcada18427bf([
            ref.current
        ]);
    }, [
        state.isOpen,
        ref
    ]);
    return {
        modalProps: (0, $8vAG4.mergeProps)(overlayProps),
        underlayProps: underlayProps
    };
}

});
parcelRegister("4QjZq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $386b864dbb5fb85e$export$2e2bcd8739ae039; });
var $386b864dbb5fb85e$export$2e2bcd8739ae039 = {};
$386b864dbb5fb85e$export$2e2bcd8739ae039 = {
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};

});

parcelRegister("2ejYU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19fc6378a1ee46ee$export$2e2bcd8739ae039; });
var $19fc6378a1ee46ee$export$2e2bcd8739ae039 = {};
$19fc6378a1ee46ee$export$2e2bcd8739ae039 = {
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};

});

parcelRegister("aLVKe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d7b1609df6c319e$export$2e2bcd8739ae039; });
var $7d7b1609df6c319e$export$2e2bcd8739ae039 = {};
$7d7b1609df6c319e$export$2e2bcd8739ae039 = {
    "dismiss": `Odstranit`
};

});

parcelRegister("l3N8j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f54ffd9be7f6a43e$export$2e2bcd8739ae039; });
var $f54ffd9be7f6a43e$export$2e2bcd8739ae039 = {};
$f54ffd9be7f6a43e$export$2e2bcd8739ae039 = {
    "dismiss": `Luk`
};

});

parcelRegister("kCzX0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0333e4bab3570ae$export$2e2bcd8739ae039; });
var $f0333e4bab3570ae$export$2e2bcd8739ae039 = {};
$f0333e4bab3570ae$export$2e2bcd8739ae039 = {
    "dismiss": `Schlie\xdfen`
};

});

parcelRegister("gpz0A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf2a23185540ada4$export$2e2bcd8739ae039; });
var $bf2a23185540ada4$export$2e2bcd8739ae039 = {};
$bf2a23185540ada4$export$2e2bcd8739ae039 = {
    "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};

});

parcelRegister("k4L3y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9d8aecb86c7e821$export$2e2bcd8739ae039; });
var $e9d8aecb86c7e821$export$2e2bcd8739ae039 = {};
$e9d8aecb86c7e821$export$2e2bcd8739ae039 = {
    "dismiss": `Dismiss`
};

});

parcelRegister("fM69b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7c01b5fba66121f$export$2e2bcd8739ae039; });
var $b7c01b5fba66121f$export$2e2bcd8739ae039 = {};
$b7c01b5fba66121f$export$2e2bcd8739ae039 = {
    "dismiss": `Descartar`
};

});

parcelRegister("97Rf5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a4e114fc8140fb0$export$2e2bcd8739ae039; });
var $6a4e114fc8140fb0$export$2e2bcd8739ae039 = {};
$6a4e114fc8140fb0$export$2e2bcd8739ae039 = {
    "dismiss": `L\xf5peta`
};

});

parcelRegister("gxfQE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $031b4a695f826faf$export$2e2bcd8739ae039; });
var $031b4a695f826faf$export$2e2bcd8739ae039 = {};
$031b4a695f826faf$export$2e2bcd8739ae039 = {
    "dismiss": `Hylk\xe4\xe4`
};

});

parcelRegister("ejcuW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6ac88e0446fd168$export$2e2bcd8739ae039; });
var $a6ac88e0446fd168$export$2e2bcd8739ae039 = {};
$a6ac88e0446fd168$export$2e2bcd8739ae039 = {
    "dismiss": `Rejeter`
};

});

parcelRegister("f4Dn9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af95c543fe6aea97$export$2e2bcd8739ae039; });
var $af95c543fe6aea97$export$2e2bcd8739ae039 = {};
$af95c543fe6aea97$export$2e2bcd8739ae039 = {
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};

});

parcelRegister("9ZZ9S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7479405557ff4b6b$export$2e2bcd8739ae039; });
var $7479405557ff4b6b$export$2e2bcd8739ae039 = {};
$7479405557ff4b6b$export$2e2bcd8739ae039 = {
    "dismiss": `Odbaci`
};

});

parcelRegister("3Sr89", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d2b75d090137d68$export$2e2bcd8739ae039; });
var $2d2b75d090137d68$export$2e2bcd8739ae039 = {};
$2d2b75d090137d68$export$2e2bcd8739ae039 = {
    "dismiss": `Elutas\xedt\xe1s`
};

});

parcelRegister("joMOA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1f61fd680922db0$export$2e2bcd8739ae039; });
var $e1f61fd680922db0$export$2e2bcd8739ae039 = {};
$e1f61fd680922db0$export$2e2bcd8739ae039 = {
    "dismiss": `Ignora`
};

});

parcelRegister("c27Q8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c2bc0c282fd5485$export$2e2bcd8739ae039; });
var $8c2bc0c282fd5485$export$2e2bcd8739ae039 = {};
$8c2bc0c282fd5485$export$2e2bcd8739ae039 = {
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};

});

parcelRegister("7jPjR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55421daffaf0cc5f$export$2e2bcd8739ae039; });
var $55421daffaf0cc5f$export$2e2bcd8739ae039 = {};
$55421daffaf0cc5f$export$2e2bcd8739ae039 = {
    "dismiss": `\u{BB34}\u{C2DC}`
};

});

parcelRegister("cJjZ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94493098cc5d55f1$export$2e2bcd8739ae039; });
var $94493098cc5d55f1$export$2e2bcd8739ae039 = {};
$94493098cc5d55f1$export$2e2bcd8739ae039 = {
    "dismiss": `Atmesti`
};

});

parcelRegister("ckobM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f9a1dbac94b1370$export$2e2bcd8739ae039; });
var $8f9a1dbac94b1370$export$2e2bcd8739ae039 = {};
$8f9a1dbac94b1370$export$2e2bcd8739ae039 = {
    "dismiss": `Ner\u{101}d\u{12B}t`
};

});

parcelRegister("90wC2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68ed69497c91b9dc$export$2e2bcd8739ae039; });
var $68ed69497c91b9dc$export$2e2bcd8739ae039 = {};
$68ed69497c91b9dc$export$2e2bcd8739ae039 = {
    "dismiss": `Lukk`
};

});

parcelRegister("dLwUu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0593163ebfd1399$export$2e2bcd8739ae039; });
var $a0593163ebfd1399$export$2e2bcd8739ae039 = {};
$a0593163ebfd1399$export$2e2bcd8739ae039 = {
    "dismiss": `Negeren`
};

});

parcelRegister("EgOYE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0790c8e26f1550ff$export$2e2bcd8739ae039; });
var $0790c8e26f1550ff$export$2e2bcd8739ae039 = {};
$0790c8e26f1550ff$export$2e2bcd8739ae039 = {
    "dismiss": `Zignoruj`
};

});

parcelRegister("gximO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c09df9b76f7cfe28$export$2e2bcd8739ae039; });
var $c09df9b76f7cfe28$export$2e2bcd8739ae039 = {};
$c09df9b76f7cfe28$export$2e2bcd8739ae039 = {
    "dismiss": `Descartar`
};

});

parcelRegister("jcQqf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfb7cd504857991f$export$2e2bcd8739ae039; });
var $dfb7cd504857991f$export$2e2bcd8739ae039 = {};
$dfb7cd504857991f$export$2e2bcd8739ae039 = {
    "dismiss": `Dispensar`
};

});

parcelRegister("3kfB5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26bf569b94505303$export$2e2bcd8739ae039; });
var $26bf569b94505303$export$2e2bcd8739ae039 = {};
$26bf569b94505303$export$2e2bcd8739ae039 = {
    "dismiss": `Revocare`
};

});

parcelRegister("7rWM7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56c8a582b715a82c$export$2e2bcd8739ae039; });
var $56c8a582b715a82c$export$2e2bcd8739ae039 = {};
$56c8a582b715a82c$export$2e2bcd8739ae039 = {
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};

});

parcelRegister("cWJ1G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96cdd417f453362d$export$2e2bcd8739ae039; });
var $96cdd417f453362d$export$2e2bcd8739ae039 = {};
$96cdd417f453362d$export$2e2bcd8739ae039 = {
    "dismiss": `Zru\u{161}i\u{165}`
};

});

parcelRegister("6Bi3e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ce4336186980ed9$export$2e2bcd8739ae039; });
var $4ce4336186980ed9$export$2e2bcd8739ae039 = {};
$4ce4336186980ed9$export$2e2bcd8739ae039 = {
    "dismiss": `Opusti`
};

});

parcelRegister("c5ynI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cd09f24355ec7bd$export$2e2bcd8739ae039; });
var $8cd09f24355ec7bd$export$2e2bcd8739ae039 = {};
$8cd09f24355ec7bd$export$2e2bcd8739ae039 = {
    "dismiss": `Odbaci`
};

});

parcelRegister("2ShnL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $217e1bac427b51d5$export$2e2bcd8739ae039; });
var $217e1bac427b51d5$export$2e2bcd8739ae039 = {};
$217e1bac427b51d5$export$2e2bcd8739ae039 = {
    "dismiss": `Avvisa`
};

});

parcelRegister("gzXzc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c11e1ef163fe7195$export$2e2bcd8739ae039; });
var $c11e1ef163fe7195$export$2e2bcd8739ae039 = {};
$c11e1ef163fe7195$export$2e2bcd8739ae039 = {
    "dismiss": `Kapat`
};

});

parcelRegister("hAcha", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cccf522c0304a153$export$2e2bcd8739ae039; });
var $cccf522c0304a153$export$2e2bcd8739ae039 = {};
$cccf522c0304a153$export$2e2bcd8739ae039 = {
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};

});

parcelRegister("aUBCP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f1c51eaf6e9a143$export$2e2bcd8739ae039; });
var $7f1c51eaf6e9a143$export$2e2bcd8739ae039 = {};
$7f1c51eaf6e9a143$export$2e2bcd8739ae039 = {
    "dismiss": `\u{53D6}\u{6D88}`
};

});

parcelRegister("721re", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51e9d5e5cfae1033$export$2e2bcd8739ae039; });
var $51e9d5e5cfae1033$export$2e2bcd8739ae039 = {};
$51e9d5e5cfae1033$export$2e2bcd8739ae039 = {
    "dismiss": `\u{95DC}\u{9589}`
};

});

parcelRegister("87exK", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $5e8a4232a77ce759$export$7d15b64cf5a3a4c4; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $5e8a4232a77ce759$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $5e8a4232a77ce759$export$e1a7b8e69ef6c52f(value, step) {
    let roundedValue = value;
    let stepString = step.toString();
    let pointIndex = stepString.indexOf(".");
    let precision = pointIndex >= 0 ? stepString.length - pointIndex : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        roundedValue = Math.round(roundedValue * pow) / pow;
    }
    return roundedValue;
}
function $5e8a4232a77ce759$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = $5e8a4232a77ce759$export$e1a7b8e69ef6c52f(Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder, step);
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor($5e8a4232a77ce759$export$e1a7b8e69ef6c52f((max - min) / step, step)) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor($5e8a4232a77ce759$export$e1a7b8e69ef6c52f(max / step, step)) * step;
    // correct floating point behavior by rounding to step precision
    snappedValue = $5e8a4232a77ce759$export$e1a7b8e69ef6c52f(snappedValue, step);
    return snappedValue;
}
function $5e8a4232a77ce759$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

});

parcelRegister("lCded", function(module, exports) {

$parcel$export(module.exports, "getScrollParent", function () { return $fbc76874527d6495$export$cfa2225e87938781; });

var $k0Xsz = parcelRequire("k0Xsz");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fbc76874527d6495$export$cfa2225e87938781(node, checkForOverflow) {
    let scrollableNode = node;
    if ((0, $k0Xsz.isScrollable)(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
    while(scrollableNode && !(0, $k0Xsz.isScrollable)(scrollableNode, checkForOverflow))scrollableNode = scrollableNode.parentElement;
    return scrollableNode || document.scrollingElement || document.documentElement;
}

});

parcelRegister("gEiSh", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", function () { return $c1ef05d69f2e2e70$export$683480f191c0e3ea; });

var $exYeM = parcelRequire("exYeM");
function $c1ef05d69f2e2e70$var$$9daab02d461809db$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== "undefined";
}
function $c1ef05d69f2e2e70$export$683480f191c0e3ea(options) {
    const { ref: ref, onResize: onResize } = options;
    (0, $exYeM.useEffect)(()=>{
        let element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!$c1ef05d69f2e2e70$var$$9daab02d461809db$var$hasResizeObserver()) {
            window.addEventListener("resize", onResize, false);
            return ()=>{
                window.removeEventListener("resize", onResize, false);
            };
        } else {
            const resizeObserverInstance = new window.ResizeObserver((entries)=>{
                if (!entries.length) return;
                onResize();
            });
            resizeObserverInstance.observe(element);
            return ()=>{
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        onResize,
        ref
    ]);
}

});

parcelRegister("6FcvQ", function(module, exports) {

$parcel$export(module.exports, "useLocalizedStringFormatter", function () { return $4da04727952c7955$export$f12b703ca79dfbb1; });

var $9ljKT = parcelRequire("9ljKT");

var $1jHkC = parcelRequire("1jHkC");
var $g2TA9 = parcelRequire("g2TA9");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4da04727952c7955$var$$fca6afa0e843324b$var$cache = new WeakMap();
function $4da04727952c7955$var$$fca6afa0e843324b$var$getCachedDictionary(strings) {
    let dictionary = $4da04727952c7955$var$$fca6afa0e843324b$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, $1jHkC.LocalizedStringDictionary)(strings);
        $4da04727952c7955$var$$fca6afa0e843324b$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $4da04727952c7955$export$87b761675e8eaa10(strings, packageName) {
    return packageName && (0, $1jHkC.LocalizedStringDictionary).getGlobalDictionaryForPackage(packageName) || $4da04727952c7955$var$$fca6afa0e843324b$var$getCachedDictionary(strings);
}
function $4da04727952c7955$export$f12b703ca79dfbb1(strings, packageName) {
    let { locale: locale } = (0, $9ljKT.useLocale)();
    let dictionary = $4da04727952c7955$export$87b761675e8eaa10(strings, packageName);
    return (0, $exYeM.useMemo)(()=>new (0, $g2TA9.LocalizedStringFormatter)(locale, dictionary), [
        locale,
        dictionary
    ]);
}

});
parcelRegister("1jHkC", function(module, exports) {

$parcel$export(module.exports, "LocalizedStringDictionary", function () { return $0f592d863ab2adbd$export$c17fa47878dc55b6; });
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $0f592d863ab2adbd$var$$5b160d28a433310d$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
const $0f592d863ab2adbd$var$$5b160d28a433310d$var$stringsSymbol = Symbol.for("react-aria.i18n.strings");
let $0f592d863ab2adbd$var$$5b160d28a433310d$var$cachedGlobalStrings = undefined;
class $0f592d863ab2adbd$export$c17fa47878dc55b6 {
    /** Returns a localized string for the given key and locale. */ getStringForLocale(key, locale) {
        let strings = this.getStringsForLocale(locale);
        let string = strings[key];
        if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
        return string;
    }
    /** Returns all localized strings for the given locale. */ getStringsForLocale(locale) {
        let strings = this.strings[locale];
        if (!strings) {
            strings = $0f592d863ab2adbd$var$$5b160d28a433310d$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
            this.strings[locale] = strings;
        }
        return strings;
    }
    static getGlobalDictionaryForPackage(packageName) {
        if (typeof window === "undefined") return null;
        let locale = window[$0f592d863ab2adbd$var$$5b160d28a433310d$var$localeSymbol];
        if ($0f592d863ab2adbd$var$$5b160d28a433310d$var$cachedGlobalStrings === undefined) {
            let globalStrings = window[$0f592d863ab2adbd$var$$5b160d28a433310d$var$stringsSymbol];
            if (!globalStrings) return null;
            $0f592d863ab2adbd$var$$5b160d28a433310d$var$cachedGlobalStrings = {};
            for(let pkg in globalStrings)$0f592d863ab2adbd$var$$5b160d28a433310d$var$cachedGlobalStrings[pkg] = new $0f592d863ab2adbd$export$c17fa47878dc55b6({
                [locale]: globalStrings[pkg]
            }, locale);
        }
        let dictionary = $0f592d863ab2adbd$var$$5b160d28a433310d$var$cachedGlobalStrings === null || $0f592d863ab2adbd$var$$5b160d28a433310d$var$cachedGlobalStrings === void 0 ? void 0 : $0f592d863ab2adbd$var$$5b160d28a433310d$var$cachedGlobalStrings[packageName];
        if (!dictionary) throw new Error(`Strings for package "${packageName}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
        return dictionary;
    }
    constructor(messages, defaultLocale = "en-US"){
        // Clone messages so we don't modify the original object.
        // Filter out entries with falsy values which may have been caused by applying optimize-locales-plugin.
        this.strings = Object.fromEntries(Object.entries(messages).filter(([, v])=>v));
        this.defaultLocale = defaultLocale;
    }
}
function $0f592d863ab2adbd$var$$5b160d28a433310d$var$getStringsForLocale(locale, strings, defaultLocale = "en-US") {
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    let language = $0f592d863ab2adbd$var$$5b160d28a433310d$var$getLanguage(locale);
    if (strings[language]) return strings[language];
    for(let key in strings){
        if (key.startsWith(language + "-")) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $0f592d863ab2adbd$var$$5b160d28a433310d$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) return new Intl.Locale(locale).language;
    return locale.split("-")[0];
}

});

parcelRegister("g2TA9", function(module, exports) {

$parcel$export(module.exports, "LocalizedStringFormatter", function () { return $bae7f2b0e89f751f$export$2f817fcdc4b89ae0; });
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $bae7f2b0e89f751f$var$$6db58dc88e78b024$var$pluralRulesCache = new Map();
const $bae7f2b0e89f751f$var$$6db58dc88e78b024$var$numberFormatCache = new Map();
class $bae7f2b0e89f751f$export$2f817fcdc4b89ae0 {
    /** Formats a localized string for the given key with the provided variables. */ format(key, variables) {
        let message = this.strings.getStringForLocale(key, this.locale);
        return typeof message === "function" ? message(variables, this) : message;
    }
    plural(count, options, type = "cardinal") {
        let opt = options["=" + count];
        if (opt) return typeof opt === "function" ? opt() : opt;
        let key = this.locale + ":" + type;
        let pluralRules = $bae7f2b0e89f751f$var$$6db58dc88e78b024$var$pluralRulesCache.get(key);
        if (!pluralRules) {
            pluralRules = new Intl.PluralRules(this.locale, {
                type: type
            });
            $bae7f2b0e89f751f$var$$6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
        }
        let selected = pluralRules.select(count);
        opt = options[selected] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    number(value) {
        let numberFormat = $bae7f2b0e89f751f$var$$6db58dc88e78b024$var$numberFormatCache.get(this.locale);
        if (!numberFormat) {
            numberFormat = new Intl.NumberFormat(this.locale);
            $bae7f2b0e89f751f$var$$6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
        }
        return numberFormat.format(value);
    }
    select(options, value) {
        let opt = options[value] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    constructor(locale, strings){
        this.locale = locale;
        this.strings = strings;
    }
}

});


parcelRegister("jgnwK", function(module, exports) {

$parcel$export(module.exports, "FocusScope", function () { return $e061c2f95b3f2eb6$export$20e40289641fbbb6; });
$parcel$export(module.exports, "isElementInChildOfActiveScope", function () { return $e061c2f95b3f2eb6$export$1258395f99bf9cbf; });

var $6viic = parcelRequire("6viic");

var $bouI5 = parcelRequire("bouI5");

var $2ZDqh = parcelRequire("2ZDqh");
var $71dP2 = parcelRequire("71dP2");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
let $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope = null;
function $e061c2f95b3f2eb6$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $exYeM.useRef)(null);
    let endRef = (0, $exYeM.useRef)(null);
    let scopeRef = (0, $exYeM.useRef)([]);
    let { parentNode: parentNode } = (0, $exYeM.useContext)($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $exYeM.useMemo)(()=>new $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $e061c2f95b3f2eb6$export$d06fae2ee68b101e.root;
        if ($e061c2f95b3f2eb6$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope && !$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isAncestorScope($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $e061c2f95b3f2eb6$export$d06fae2ee68b101e.getTreeNode($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $e061c2f95b3f2eb6$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        let node = $e061c2f95b3f2eb6$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $exYeM.useEffect)(()=>{
        const activeElement = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $e061c2f95b3f2eb6$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $e061c2f95b3f2eb6$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $e061c2f95b3f2eb6$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope || $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $e061c2f95b3f2eb6$export$d06fae2ee68b101e.getTreeNode(parentScope))) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $e061c2f95b3f2eb6$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $exYeM.useMemo)(()=>$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $exYeM.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $e061c2f95b3f2eb6$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $exYeM.useContext)($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $e061c2f95b3f2eb6$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $e061c2f95b3f2eb6$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $e061c2f95b3f2eb6$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $e061c2f95b3f2eb6$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $e061c2f95b3f2eb6$export$4c063cf1350e6fed(element) {
    return element.matches($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $e061c2f95b3f2eb6$export$d06fae2ee68b101e.getTreeNode($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $exYeM.useRef)();
    let raf = (0, $exYeM.useRef)();
    (0, $71dP2.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $e061c2f95b3f2eb6$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope || $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isAncestorScope($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope && $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope.current) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusFirstInScope($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope.current) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusFirstInScope($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $e061c2f95b3f2eb6$export$d06fae2ee68b101e.traverse($e061c2f95b3f2eb6$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $e061c2f95b3f2eb6$export$1258395f99bf9cbf(element) {
    return $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInChildScope(element, $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope);
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $e061c2f95b3f2eb6$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $6viic.focusSafely)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $e061c2f95b3f2eb6$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $e061c2f95b3f2eb6$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(nextNode);
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(autoFocus);
    (0, $exYeM.useEffect)(()=>{
        if (autoFocusRef.current) {
            $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $71dP2.useLayoutEffect)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $e061c2f95b3f2eb6$export$d06fae2ee68b101e.getTreeNode($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $exYeM.useRef)(typeof document !== "undefined" ? (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $71dP2.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope || $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isAncestorScope($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $e061c2f95b3f2eb6$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $e061c2f95b3f2eb6$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $e061c2f95b3f2eb6$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $e061c2f95b3f2eb6$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $e061c2f95b3f2eb6$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $e061c2f95b3f2eb6$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $e061c2f95b3f2eb6$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $2ZDqh.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, $bouI5.isElementVisible)(node) && (!scope || $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $e061c2f95b3f2eb6$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(root).activeElement;
            let walker = $e061c2f95b3f2eb6$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(root).activeElement;
            let walker = $e061c2f95b3f2eb6$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$last(walker);
                if (next) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $e061c2f95b3f2eb6$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $e061c2f95b3f2eb6$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$last(walker);
            if (next) $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $e061c2f95b3f2eb6$export$d06fae2ee68b101e = new $e061c2f95b3f2eb6$var$$9bf71ea28793e738$var$Tree();

});
parcelRegister("6viic", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $4bc3d3dcff3751f5$export$80f3e147d781571c; });

var $6Qamj = parcelRequire("6Qamj");
var $2ZDqh = parcelRequire("2ZDqh");
var $jgteb = parcelRequire("jgteb");

var $94MZz = parcelRequire("94MZz");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4bc3d3dcff3751f5$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $2ZDqh.getOwnerDocument)(element);
    if ((0, $94MZz.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $jgteb.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $6Qamj.focusWithoutScrolling)(element);
        });
    } else (0, $6Qamj.focusWithoutScrolling)(element);
}

});
parcelRegister("94MZz", function(module, exports) {

$parcel$export(module.exports, "getInteractionModality", function () { return $69ba7d963ef8b34b$export$630ff653c5ada6a9; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$currentModality = null;
let $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $69ba7d963ef8b34b$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $gbqqi.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $87CgO.isVirtualClick)(e)) {
        $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $69ba7d963ef8b34b$export$d90243b58daecda7.get((0, $2ZDqh.getOwnerWindow)(element))) return;
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $69ba7d963ef8b34b$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$69ba7d963ef8b34b$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $69ba7d963ef8b34b$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $69ba7d963ef8b34b$export$d90243b58daecda7.delete(windowObject);
};
function $69ba7d963ef8b34b$export$2f1888112f558a7d(element) {
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $69ba7d963ef8b34b$export$2f1888112f558a7d();
function $69ba7d963ef8b34b$export$b9b3dfddab17db27() {
    return $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $69ba7d963ef8b34b$export$630ff653c5ada6a9() {
    return $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$currentModality;
}
function $69ba7d963ef8b34b$export$8397ddfc504fdb9a(modality) {
    $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$currentModality = modality;
    $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $69ba7d963ef8b34b$export$98e20ec92f614cfe() {
    $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $exYeM.useState)($69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$currentModality);
    (0, $exYeM.useEffect)(()=>{
        let handler = ()=>{
            setModality($69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$currentModality);
        };
        $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $aVmq3.useIsSSR)() ? null : modality;
}
const $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $69ba7d963ef8b34b$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(autoFocus || $69ba7d963ef8b34b$export$b9b3dfddab17db27());
    $69ba7d963ef8b34b$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $69ba7d963ef8b34b$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $exYeM.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($69ba7d963ef8b34b$export$b9b3dfddab17db27());
        };
        $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $69ba7d963ef8b34b$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("bouI5", function(module, exports) {

$parcel$export(module.exports, "isElementVisible", function () { return $84b9c1f6d9d647ec$export$e989c0fffaa6b27a; });

var $2ZDqh = parcelRequire("2ZDqh");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $84b9c1f6d9d647ec$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $84b9c1f6d9d647ec$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $84b9c1f6d9d647ec$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $84b9c1f6d9d647ec$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $84b9c1f6d9d647ec$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $84b9c1f6d9d647ec$export$e989c0fffaa6b27a(element.parentElement, element));
}

});


parcelRegister("92Nxl", function(module, exports) {

$parcel$export(module.exports, "ClearPressResponder", function () { return $695ab9f11b4629d2$export$cf75428e0b9ed1ea; });

var $oPBWI = parcelRequire("oPBWI");

var $8vAG4 = parcelRequire("8vAG4");
var $4g3pq = parcelRequire("4g3pq");
var $hbWr9 = parcelRequire("hbWr9");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $695ab9f11b4629d2$export$3351871ee4b288b8 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ children: children, ...props }, ref)=>{
    let isRegistered = (0, $exYeM.useRef)(false);
    let prevContext = (0, $exYeM.useContext)((0, $oPBWI.PressResponderContext));
    ref = (0, $4g3pq.useObjectRef)(ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref));
    let context = (0, $8vAG4.mergeProps)(prevContext || {}, {
        ...props,
        ref: ref,
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    (0, $hbWr9.useSyncRef)(prevContext, ref);
    (0, $exYeM.useEffect)(()=>{
        if (!isRegistered.current) {
            console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
            isRegistered.current = true; // only warn once in strict mode.
        }
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $oPBWI.PressResponderContext).Provider, {
        value: context
    }, children);
});
function $695ab9f11b4629d2$export$cf75428e0b9ed1ea({ children: children }) {
    let context = (0, $exYeM.useMemo)(()=>({
            register: ()=>{}
        }), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $oPBWI.PressResponderContext).Provider, {
        value: context
    }, children);
}

});
parcelRegister("oPBWI", function(module, exports) {

$parcel$export(module.exports, "PressResponderContext", function () { return $04aa46e1acb39039$export$5165eccb35aaadb5; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $04aa46e1acb39039$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({
    register: ()=>{}
});
$04aa46e1acb39039$export$5165eccb35aaadb5.displayName = "PressResponderContext";

});


parcelRegister("lcmdy", function(module, exports) {

$parcel$export(module.exports, "useFocusWithin", function () { return $f6ebf3e665a3d0b0$export$420e68273165f4ec; });

var $2Ochm = parcelRequire("2Ochm");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $f6ebf3e665a3d0b0$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $exYeM.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $exYeM.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, $2Ochm.useSyntheticBlurEvent)(onBlur);
    let onFocus = (0, $exYeM.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

});
parcelRegister("2Ochm", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $20b9c69d5d3cd1bc$export$715c682d09d639cc; });

var $exYeM = parcelRequire("exYeM");

var $4sExG = parcelRequire("4sExG");
var $71dP2 = parcelRequire("71dP2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $20b9c69d5d3cd1bc$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $20b9c69d5d3cd1bc$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $exYeM.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $71dP2.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $4sExG.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $exYeM.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $20b9c69d5d3cd1bc$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("fu8ZQ", function(module, exports) {

$parcel$export(module.exports, "useInteractOutside", function () { return $b460a2e543b880f3$export$872b660ac5a1ff98; });

var $2ZDqh = parcelRequire("2ZDqh");
var $4sExG = parcelRequire("4sExG");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $b460a2e543b880f3$export$872b660ac5a1ff98(props) {
    let { ref: ref, onInteractOutside: onInteractOutside, isDisabled: isDisabled, onInteractOutsideStart: onInteractOutsideStart } = props;
    let stateRef = (0, $exYeM.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    let onPointerDown = (0, $4sExG.useEffectEvent)((e)=>{
        if (onInteractOutside && $b460a2e543b880f3$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
            if (onInteractOutsideStart) onInteractOutsideStart(e);
            stateRef.current.isPointerDown = true;
        }
    });
    let triggerInteractOutside = (0, $4sExG.useEffectEvent)((e)=>{
        if (onInteractOutside) onInteractOutside(e);
    });
    (0, $exYeM.useEffect)(()=>{
        let state = stateRef.current;
        if (isDisabled) return;
        const element = ref.current;
        const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== "undefined") {
            let onPointerUp = (e)=>{
                if (state.isPointerDown && $b460a2e543b880f3$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            // changing these to capture phase fixed combobox
            documentObject.addEventListener("pointerdown", onPointerDown, true);
            documentObject.addEventListener("pointerup", onPointerUp, true);
            return ()=>{
                documentObject.removeEventListener("pointerdown", onPointerDown, true);
                documentObject.removeEventListener("pointerup", onPointerUp, true);
            };
        } else {
            let onMouseUp = (e)=>{
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && $b460a2e543b880f3$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            let onTouchEnd = (e)=>{
                state.ignoreEmulatedMouseEvents = true;
                if (state.isPointerDown && $b460a2e543b880f3$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            documentObject.addEventListener("mousedown", onPointerDown, true);
            documentObject.addEventListener("mouseup", onMouseUp, true);
            documentObject.addEventListener("touchstart", onPointerDown, true);
            documentObject.addEventListener("touchend", onTouchEnd, true);
            return ()=>{
                documentObject.removeEventListener("mousedown", onPointerDown, true);
                documentObject.removeEventListener("mouseup", onMouseUp, true);
                documentObject.removeEventListener("touchstart", onPointerDown, true);
                documentObject.removeEventListener("touchend", onTouchEnd, true);
            };
        }
    }, [
        ref,
        isDisabled,
        onPointerDown,
        triggerInteractOutside
    ]);
}
function $b460a2e543b880f3$var$$e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    if (event.target) {
        // if the event target is no longer in the document, ignore
        const ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
        // If the target is within a top layer element (e.g. toasts), ignore.
        if (event.target.closest("[data-react-aria-top-layer]")) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}

});

parcelRegister("lRiVc", function(module, exports) {

$parcel$export(module.exports, "VisuallyHidden", function () { return $fe9d39a36a682b3c$export$439d29a4e110a164; });

var $8vAG4 = parcelRequire("8vAG4");

var $exYeM = parcelRequire("exYeM");

var $lcmdy = parcelRequire("lcmdy");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $fe9d39a36a682b3c$var$$5c3e21d68f1c4674$var$styles = {
    border: 0,
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap"
};
function $fe9d39a36a682b3c$export$a966af930f325cab(props = {}) {
    let { style: style, isFocusable: isFocusable } = props;
    let [isFocused, setFocused] = (0, $exYeM.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $lcmdy.useFocusWithin)({
        isDisabled: !isFocusable,
        onFocusWithinChange: (val)=>setFocused(val)
    });
    // If focused, don't hide the element.
    let combinedStyles = (0, $exYeM.useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$fe9d39a36a682b3c$var$$5c3e21d68f1c4674$var$styles,
            ...style
        };
        else return $fe9d39a36a682b3c$var$$5c3e21d68f1c4674$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusWithinProps,
            style: combinedStyles
        }
    };
}
function $fe9d39a36a682b3c$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children, elementType: Element = "div", isFocusable: isFocusable, style: style, ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = $fe9d39a36a682b3c$export$a966af930f325cab(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Element, (0, $8vAG4.mergeProps)(otherProps, visuallyHiddenProps), children);
}

});


parcelRegister("blhTL", function(module, exports) {

$parcel$export(module.exports, "ariaHideOutside", function () { return $5872765b2376f3d3$export$1c3ebcada18427bf; });
"use client";
// src/overlays/ariaHideOutside.ts
var $5872765b2376f3d3$var$refCountMap = /* @__PURE__ */ new WeakMap();
var $5872765b2376f3d3$var$observerStack = [];
function $5872765b2376f3d3$export$1c3ebcada18427bf(targets, root = document.body) {
    let visibleNodes = new Set(targets);
    let hiddenNodes = /* @__PURE__ */ new Set();
    let walk = (root2)=>{
        for (let element of root2.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]"))visibleNodes.add(element);
        let acceptNode = (node)=>{
            const parentElement = node.parentElement;
            if (visibleNodes.has(node) || hiddenNodes.has(parentElement) && parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
            for (let target of visibleNodes){
                if (node.contains(target)) return NodeFilter.FILTER_SKIP;
            }
            return NodeFilter.FILTER_ACCEPT;
        };
        let walker = document.createTreeWalker(root2, NodeFilter.SHOW_ELEMENT, {
            acceptNode: acceptNode
        });
        let acceptRoot = acceptNode(root2);
        if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root2);
        if (acceptRoot !== NodeFilter.FILTER_REJECT) {
            let node = walker.nextNode();
            while(node != null){
                hide(node);
                node = walker.nextNode();
            }
        }
    };
    let hide = (node)=>{
        var _a;
        let refCount = (_a = $5872765b2376f3d3$var$refCountMap.get(node)) != null ? _a : 0;
        if (node.getAttribute("aria-hidden") === "true" && refCount === 0) return;
        if (refCount === 0) node.setAttribute("aria-hidden", "true");
        hiddenNodes.add(node);
        $5872765b2376f3d3$var$refCountMap.set(node, refCount + 1);
    };
    if ($5872765b2376f3d3$var$observerStack.length) $5872765b2376f3d3$var$observerStack[$5872765b2376f3d3$var$observerStack.length - 1].disconnect();
    walk(root);
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== "childList" || change.addedNodes.length === 0) continue;
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target))) {
                for (let node of change.removedNodes)if (node instanceof Element) {
                    visibleNodes.delete(node);
                    hiddenNodes.delete(node);
                }
                for (let node of change.addedNodes){
                    if ((node instanceof HTMLElement || node instanceof SVGElement) && (node.dataset.liveAnnouncer === "true" || node.dataset.reactAriaTopLayer === "true")) visibleNodes.add(node);
                    else if (node instanceof Element) walk(node);
                }
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    let observerWrapper = {
        observe () {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect () {
            observer.disconnect();
        }
    };
    $5872765b2376f3d3$var$observerStack.push(observerWrapper);
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = $5872765b2376f3d3$var$refCountMap.get(node);
            if (count == null) continue;
            if (count === 1) {
                node.removeAttribute("aria-hidden");
                $5872765b2376f3d3$var$refCountMap.delete(node);
            } else $5872765b2376f3d3$var$refCountMap.set(node, count - 1);
        }
        if (observerWrapper === $5872765b2376f3d3$var$observerStack[$5872765b2376f3d3$var$observerStack.length - 1]) {
            $5872765b2376f3d3$var$observerStack.pop();
            if ($5872765b2376f3d3$var$observerStack.length) $5872765b2376f3d3$var$observerStack[$5872765b2376f3d3$var$observerStack.length - 1].observe();
        } else $5872765b2376f3d3$var$observerStack.splice($5872765b2376f3d3$var$observerStack.indexOf(observerWrapper), 1);
    };
}

});

parcelRegister("75g4P", function(module, exports) {

$parcel$export(module.exports, "ariaShouldCloseOnInteractOutside", function () { return $31392013f6346508$export$ef74e55a94b62f23; });
"use client";
// src/overlays/ariaShouldCloseOnInteractOutside.ts
var $31392013f6346508$export$ef74e55a94b62f23 = (element, ref, state, shouldFocus)=>{
    var _a, _b;
    let trigger = ref == null ? void 0 : ref.current;
    const clickOnUnderlay = ((_b = (_a = element == null ? void 0 : element.children) == null ? void 0 : _a[0]) == null ? void 0 : _b.getAttribute("role")) === "dialog";
    if (!trigger || !trigger.contains(element)) {
        if (shouldFocus) shouldFocus.current = false;
        if (!clickOnUnderlay) state.close();
    } else if (shouldFocus) shouldFocus.current = true;
    return clickOnUnderlay;
};

});

parcelRegister("KekyV", function(module, exports) {

$parcel$export(module.exports, "getTransformOrigins", function () { return $892e6c82a98ff0bd$export$d0ca24f1cd6d5c41; });
$parcel$export(module.exports, "toReactAriaPlacement", function () { return $892e6c82a98ff0bd$export$94c1bd7c13567e02; });
$parcel$export(module.exports, "getShouldUseAxisPlacement", function () { return $892e6c82a98ff0bd$export$6f1fde9fd5d7ce61; });
$parcel$export(module.exports, "getArrowPlacement", function () { return $892e6c82a98ff0bd$export$98fe55eaa3d1484b; });
"use client";
// src/overlays/utils.ts
var $892e6c82a98ff0bd$export$d0ca24f1cd6d5c41 = (placement)=>{
    const origins = {
        top: {
            originY: 1
        },
        bottom: {
            originY: 0
        },
        left: {
            originX: 1
        },
        right: {
            originX: 0
        },
        "top-start": {
            originX: 0,
            originY: 1
        },
        "top-end": {
            originX: 1,
            originY: 1
        },
        "bottom-start": {
            originX: 0,
            originY: 0
        },
        "bottom-end": {
            originX: 1,
            originY: 0
        },
        "right-start": {
            originX: 0,
            originY: 0
        },
        "right-end": {
            originX: 0,
            originY: 1
        },
        "left-start": {
            originX: 1,
            originY: 0
        },
        "left-end": {
            originX: 1,
            originY: 1
        }
    };
    return (origins == null ? void 0 : origins[placement]) || {};
};
var $892e6c82a98ff0bd$export$94c1bd7c13567e02 = (placement)=>{
    const mapPositions = {
        top: "top",
        bottom: "bottom",
        left: "left",
        right: "right",
        "top-start": "top start",
        "top-end": "top end",
        "bottom-start": "bottom start",
        "bottom-end": "bottom end",
        "left-start": "left top",
        "left-end": "left bottom",
        "right-start": "right top",
        "right-end": "right bottom"
    };
    return mapPositions[placement];
};
var $892e6c82a98ff0bd$export$3d8d9aff18e3ce6 = (placement)=>{
    const mapPositions = {
        top: "top",
        bottom: "bottom",
        left: "left",
        right: "right",
        center: "top"
    };
    return mapPositions[placement];
};
var $892e6c82a98ff0bd$export$6f1fde9fd5d7ce61 = (axisPlacement, overlayPlacement)=>{
    if (overlayPlacement.includes("-")) {
        const [position] = overlayPlacement.split("-");
        if (position.includes(axisPlacement)) return false;
    }
    return true;
};
var $892e6c82a98ff0bd$export$98fe55eaa3d1484b = (dynamicPlacement, placement)=>{
    if (placement.includes("-")) {
        const [, position] = placement.split("-");
        return `${dynamicPlacement}-${position}`;
    }
    return dynamicPlacement;
};

});


parcelRegister("7oAOq", function(module, exports) {

$parcel$export(module.exports, "useOverlayTriggerState", function () { return $56275471ca7d065c$export$61c6a8c84e605fb6; });

var $exYeM = parcelRequire("exYeM");

var $cqcnF = parcelRequire("cqcnF");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $56275471ca7d065c$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = (0, $cqcnF.useControlledState)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    const open = (0, $exYeM.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    const close = (0, $exYeM.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const toggle = (0, $exYeM.useCallback)(()=>{
        setOpen(!isOpen);
    }, [
        setOpen,
        isOpen
    ]);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open: open,
        close: close,
        toggle: toggle
    };
}

});
parcelRegister("cqcnF", function(module, exports) {

$parcel$export(module.exports, "useControlledState", function () { return $90b18446a33c6835$export$40bfa8c7b0832715; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $90b18446a33c6835$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $exYeM.useState)(value || defaultValue);
    let isControlledRef = (0, $exYeM.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $exYeM.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    let currentValue = isControlled ? value : stateValue;
    let setValue = (0, $exYeM.useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? currentValue : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $90b18446a33c6835$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $90b18446a33c6835$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    let string = step.toString();
    let index = string.indexOf(".");
    let precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $90b18446a33c6835$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

});


parcelRegister("fCtGx", function(module, exports) {

$parcel$export(module.exports, "popover", function () { return $82a48f21e9caa3be$export$899efff2d0433d49; });

var $cbpib = parcelRequire("cbpib");

var $a2Moz = parcelRequire("a2Moz");

var $9dwEN = parcelRequire("9dwEN");
// src/components/popover.ts
var $82a48f21e9caa3be$export$899efff2d0433d49 = (0, $a2Moz.tv)({
    slots: {
        base: [
            "z-0",
            "relative",
            "bg-transparent",
            "before:content-['']",
            "before:hidden",
            "before:z-[-1]",
            "before:absolute",
            "before:rotate-45",
            "before:w-2.5",
            "before:h-2.5",
            "before:rounded-sm",
            "data-[arrow=true]:before:block",
            "data-[placement=top]:before:-bottom-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=top]:before:left-1/2",
            "data-[placement=top]:before:-translate-x-1/2",
            "data-[placement=top-start]:before:-bottom-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=top-start]:before:left-3",
            "data-[placement=top-end]:before:-bottom-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=top-end]:before:right-3",
            "data-[placement=bottom]:before:-top-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=bottom]:before:left-1/2",
            "data-[placement=bottom]:before:-translate-x-1/2",
            "data-[placement=bottom-start]:before:-top-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=bottom-start]:before:left-3",
            "data-[placement=bottom-end]:before:-top-[calc(theme(spacing.5)/4_-_1.5px)]",
            "data-[placement=bottom-end]:before:right-3",
            "data-[placement=left]:before:-right-[calc(theme(spacing.5)/4_-_2px)]",
            "data-[placement=left]:before:top-1/2",
            "data-[placement=left]:before:-translate-y-1/2",
            "data-[placement=left-start]:before:-right-[calc(theme(spacing.5)/4_-_3px)]",
            "data-[placement=left-start]:before:top-1/4",
            "data-[placement=left-end]:before:-right-[calc(theme(spacing.5)/4_-_3px)]",
            "data-[placement=left-end]:before:bottom-1/4",
            "data-[placement=right]:before:-left-[calc(theme(spacing.5)/4_-_2px)]",
            "data-[placement=right]:before:top-1/2",
            "data-[placement=right]:before:-translate-y-1/2",
            "data-[placement=right-start]:before:-left-[calc(theme(spacing.5)/4_-_3px)]",
            "data-[placement=right-start]:before:top-1/4",
            "data-[placement=right-end]:before:-left-[calc(theme(spacing.5)/4_-_3px)]",
            "data-[placement=right-end]:before:bottom-1/4",
            ...(0, $9dwEN.dataFocusVisibleClasses)
        ],
        content: [
            "z-10",
            "px-2.5",
            "py-1",
            "w-full",
            "inline-flex",
            "flex-col",
            "items-center",
            "justify-center",
            "box-border",
            "subpixel-antialiased",
            "outline-none",
            "box-border"
        ],
        trigger: [
            "z-10"
        ],
        backdrop: [
            "hidden"
        ],
        arrow: []
    },
    variants: {
        size: {
            sm: {
                content: "text-tiny"
            },
            md: {
                content: "text-small"
            },
            lg: {
                content: "text-medium"
            }
        },
        color: {
            default: {
                base: "before:bg-content1 before:shadow-small",
                content: "bg-content1"
            },
            foreground: {
                base: "before:bg-foreground",
                content: (0, $cbpib.colorVariants).solid.foreground
            },
            primary: {
                base: "before:bg-primary",
                content: (0, $cbpib.colorVariants).solid.primary
            },
            secondary: {
                base: "before:bg-secondary",
                content: (0, $cbpib.colorVariants).solid.secondary
            },
            success: {
                base: "before:bg-success",
                content: (0, $cbpib.colorVariants).solid.success
            },
            warning: {
                base: "before:bg-warning",
                content: (0, $cbpib.colorVariants).solid.warning
            },
            danger: {
                base: "before:bg-danger",
                content: (0, $cbpib.colorVariants).solid.danger
            }
        },
        radius: {
            none: {
                content: "rounded-none"
            },
            sm: {
                content: "rounded-small"
            },
            md: {
                content: "rounded-medium"
            },
            lg: {
                content: "rounded-large"
            },
            full: {
                content: "rounded-full"
            }
        },
        shadow: {
            sm: {
                content: "shadow-small"
            },
            md: {
                content: "shadow-medium"
            },
            lg: {
                content: "shadow-large"
            }
        },
        backdrop: {
            transparent: {},
            opaque: {
                backdrop: "bg-overlay/50 backdrop-opacity-disabled"
            },
            blur: {
                backdrop: "backdrop-blur-sm backdrop-saturate-150 bg-overlay/30"
            }
        },
        triggerScaleOnOpen: {
            true: {
                trigger: [
                    "aria-expanded:scale-[0.97]",
                    "aria-expanded:opacity-70",
                    "subpixel-antialiased"
                ]
            },
            false: {}
        },
        disableAnimation: {
            true: {
                base: "animate-none"
            }
        },
        isTriggerDisabled: {
            true: {
                trigger: "opacity-disabled pointer-events-none"
            },
            false: {}
        }
    },
    defaultVariants: {
        color: "default",
        radius: "lg",
        size: "md",
        shadow: "md",
        backdrop: "transparent",
        triggerScaleOnOpen: true
    },
    compoundVariants: [
        {
            backdrop: [
                "opaque",
                "blur"
            ],
            class: {
                backdrop: "block w-full h-full fixed inset-0 -z-30"
            }
        }
    ]
});

});

parcelRegister("eToUM", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", function () { return $ad7987539bf6dab7$export$c9058316764c140e; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ad7987539bf6dab7$export$c9058316764c140e(...refs) {
    if (refs.length === 1) return refs[0];
    return (value)=>{
        for (let ref of refs){
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        }
    };
}

});

parcelRegister("IIWhi", function(module, exports) {

$parcel$export(module.exports, "useDialog", function () { return $0866f81e58805069$export$d55e7ee900f34e93; });

var $9cffb = parcelRequire("9cffb");
var $ezzQB = parcelRequire("ezzQB");

var $aq8TS = parcelRequire("aq8TS");

var $exYeM = parcelRequire("exYeM");

var $kvNGv = parcelRequire("kvNGv");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0866f81e58805069$export$d55e7ee900f34e93(props, ref) {
    let { role: role = "dialog" } = props;
    let titleId = (0, $ezzQB.useSlotId)();
    titleId = props["aria-label"] ? undefined : titleId;
    let isRefocusing = (0, $exYeM.useRef)(false);
    (0, $exYeM.useEffect)(()=>{
        if (ref.current && !ref.current.contains(document.activeElement)) {
            (0, $aq8TS.focusSafely)(ref.current);
            // Safari on iOS does not move the VoiceOver cursor to the dialog
            // or announce that it has opened until it has rendered. A workaround
            // is to wait for half a second, then blur and re-focus the dialog.
            let timeout = setTimeout(()=>{
                if (document.activeElement === ref.current) {
                    isRefocusing.current = true;
                    if (ref.current) {
                        ref.current.blur();
                        (0, $aq8TS.focusSafely)(ref.current);
                    }
                    isRefocusing.current = false;
                }
            }, 500);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        ref
    ]);
    (0, $kvNGv.useOverlayFocusContain)();
    // We do not use aria-modal due to a Safari bug which forces the first focusable element to be focused
    // on mount when inside an iframe, no matter which element we programmatically focus.
    // See https://bugs.webkit.org/show_bug.cgi?id=211934.
    // useModal sets aria-hidden on all elements outside the dialog, so the dialog will behave as a modal
    // even without aria-modal on the dialog itself.
    return {
        dialogProps: {
            ...(0, $9cffb.filterDOMProps)(props, {
                labelable: true
            }),
            role: role,
            tabIndex: -1,
            "aria-labelledby": props["aria-labelledby"] || titleId,
            // Prevent blur events from reaching useOverlay, which may cause
            // popovers to close. Since focus is contained within the dialog,
            // we don't want this to occur due to the above useEffect.
            onBlur: (e)=>{
                if (isRefocusing.current) e.stopPropagation();
            }
        },
        titleProps: {
            id: titleId
        }
    };
}

});
parcelRegister("aq8TS", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $79633c7bcd6da9f6$export$80f3e147d781571c; });

var $6Qamj = parcelRequire("6Qamj");
var $2ZDqh = parcelRequire("2ZDqh");
var $jgteb = parcelRequire("jgteb");

var $cW55k = parcelRequire("cW55k");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $79633c7bcd6da9f6$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $2ZDqh.getOwnerDocument)(element);
    if ((0, $cW55k.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $jgteb.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $6Qamj.focusWithoutScrolling)(element);
        });
    } else (0, $6Qamj.focusWithoutScrolling)(element);
}

});
parcelRegister("cW55k", function(module, exports) {

$parcel$export(module.exports, "getInteractionModality", function () { return $96aed890b04b541c$export$630ff653c5ada6a9; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $96aed890b04b541c$var$$507fabe10e71c6fb$var$currentModality = null;
let $96aed890b04b541c$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $96aed890b04b541c$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $96aed890b04b541c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $96aed890b04b541c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $96aed890b04b541c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $96aed890b04b541c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $96aed890b04b541c$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $96aed890b04b541c$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $gbqqi.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $96aed890b04b541c$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $96aed890b04b541c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($96aed890b04b541c$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $96aed890b04b541c$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $96aed890b04b541c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $96aed890b04b541c$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $96aed890b04b541c$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $96aed890b04b541c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $96aed890b04b541c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $96aed890b04b541c$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $87CgO.isVirtualClick)(e)) {
        $96aed890b04b541c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $96aed890b04b541c$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $96aed890b04b541c$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$96aed890b04b541c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$96aed890b04b541c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $96aed890b04b541c$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $96aed890b04b541c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $96aed890b04b541c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $96aed890b04b541c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $96aed890b04b541c$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $96aed890b04b541c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $96aed890b04b541c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $96aed890b04b541c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $96aed890b04b541c$export$d90243b58daecda7.get((0, $2ZDqh.getOwnerWindow)(element))) return;
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $96aed890b04b541c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $96aed890b04b541c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $96aed890b04b541c$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $96aed890b04b541c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$96aed890b04b541c$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $96aed890b04b541c$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $96aed890b04b541c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $96aed890b04b541c$export$d90243b58daecda7.delete(windowObject);
};
function $96aed890b04b541c$export$2f1888112f558a7d(element) {
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $96aed890b04b541c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $96aed890b04b541c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$96aed890b04b541c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $96aed890b04b541c$export$2f1888112f558a7d();
function $96aed890b04b541c$export$b9b3dfddab17db27() {
    return $96aed890b04b541c$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $96aed890b04b541c$export$630ff653c5ada6a9() {
    return $96aed890b04b541c$var$$507fabe10e71c6fb$var$currentModality;
}
function $96aed890b04b541c$export$8397ddfc504fdb9a(modality) {
    $96aed890b04b541c$var$$507fabe10e71c6fb$var$currentModality = modality;
    $96aed890b04b541c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $96aed890b04b541c$export$98e20ec92f614cfe() {
    $96aed890b04b541c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $exYeM.useState)($96aed890b04b541c$var$$507fabe10e71c6fb$var$currentModality);
    (0, $exYeM.useEffect)(()=>{
        let handler = ()=>{
            setModality($96aed890b04b541c$var$$507fabe10e71c6fb$var$currentModality);
        };
        $96aed890b04b541c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $96aed890b04b541c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $aVmq3.useIsSSR)() ? null : modality;
}
const $96aed890b04b541c$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $96aed890b04b541c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$96aed890b04b541c$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$96aed890b04b541c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $96aed890b04b541c$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(autoFocus || $96aed890b04b541c$export$b9b3dfddab17db27());
    $96aed890b04b541c$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $96aed890b04b541c$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $96aed890b04b541c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $exYeM.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$96aed890b04b541c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($96aed890b04b541c$export$b9b3dfddab17db27());
        };
        $96aed890b04b541c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $96aed890b04b541c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("kvNGv", function(module, exports) {

$parcel$export(module.exports, "useOverlayFocusContain", function () { return $eeed3e32019b4b92$export$14c98a7594375490; });

var $hpuS4 = parcelRequire("hpuS4");

var $k2Kxc = parcelRequire("k2Kxc");

var $4cdsA = parcelRequire("4cdsA");

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");

var $aVmq3 = parcelRequire("aVmq3");

var $71dP2 = parcelRequire("71dP2");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $eeed3e32019b4b92$export$a2200b96afd16271 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
function $eeed3e32019b4b92$export$c6fdb837b070b4ff(props) {
    let isSSR = (0, $aVmq3.useIsSSR)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, isExiting: isExiting } = props;
    let [contain, setContain] = (0, $exYeM.useState)(false);
    let contextValue = (0, $exYeM.useMemo)(()=>({
            contain: contain,
            setContain: setContain
        }), [
        contain,
        setContain
    ]);
    let { getContainer: getContainer } = (0, $hpuS4.useUNSTABLE_PortalContext)();
    if (!props.portalContainer && getContainer) portalContainer = getContainer();
    if (!portalContainer) return null;
    let contents = props.children;
    if (!props.disableFocusManagement) contents = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $4cdsA.FocusScope), {
        restoreFocus: true,
        contain: contain && !isExiting
    }, contents);
    contents = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($eeed3e32019b4b92$export$a2200b96afd16271.Provider, {
        value: contextValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $k2Kxc.ClearPressResponder), null, contents));
    return (0, (/*@__PURE__*/$parcel$interopDefault($d2lNW))).createPortal(contents, portalContainer);
}
function $eeed3e32019b4b92$export$14c98a7594375490() {
    let ctx = (0, $exYeM.useContext)($eeed3e32019b4b92$export$a2200b96afd16271);
    let setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
    (0, $71dP2.useLayoutEffect)(()=>{
        setContain === null || setContain === void 0 || setContain(true);
    }, [
        setContain
    ]);
}

});
parcelRegister("hpuS4", function(module, exports) {

$parcel$export(module.exports, "useUNSTABLE_PortalContext", function () { return $caccb7d87329b92b$export$574e9b0fb070c3b0; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $caccb7d87329b92b$export$60d741e20e0aa309 = (0, $exYeM.createContext)({});
function $caccb7d87329b92b$export$db995ea7163b4b67(props) {
    let { getContainer: getContainer } = props;
    let { getContainer: ctxGetContainer } = $caccb7d87329b92b$export$574e9b0fb070c3b0();
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($caccb7d87329b92b$export$60d741e20e0aa309.Provider, {
        value: {
            getContainer: getContainer === null ? null : getContainer !== null && getContainer !== void 0 ? getContainer : ctxGetContainer
        }
    }, props.children);
}
function $caccb7d87329b92b$export$574e9b0fb070c3b0() {
    var _useContext;
    return (_useContext = (0, $exYeM.useContext)($caccb7d87329b92b$export$60d741e20e0aa309)) !== null && _useContext !== void 0 ? _useContext : {};
}

});

parcelRegister("k2Kxc", function(module, exports) {

$parcel$export(module.exports, "ClearPressResponder", function () { return $e9781756606e149d$export$cf75428e0b9ed1ea; });

var $1U9FF = parcelRequire("1U9FF");

var $8vAG4 = parcelRequire("8vAG4");
var $4g3pq = parcelRequire("4g3pq");
var $hbWr9 = parcelRequire("hbWr9");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e9781756606e149d$export$3351871ee4b288b8 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ children: children, ...props }, ref)=>{
    let isRegistered = (0, $exYeM.useRef)(false);
    let prevContext = (0, $exYeM.useContext)((0, $1U9FF.PressResponderContext));
    ref = (0, $4g3pq.useObjectRef)(ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref));
    let context = (0, $8vAG4.mergeProps)(prevContext || {}, {
        ...props,
        ref: ref,
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    (0, $hbWr9.useSyncRef)(prevContext, ref);
    (0, $exYeM.useEffect)(()=>{
        if (!isRegistered.current) {
            console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
            isRegistered.current = true; // only warn once in strict mode.
        }
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $1U9FF.PressResponderContext).Provider, {
        value: context
    }, children);
});
function $e9781756606e149d$export$cf75428e0b9ed1ea({ children: children }) {
    let context = (0, $exYeM.useMemo)(()=>({
            register: ()=>{}
        }), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $1U9FF.PressResponderContext).Provider, {
        value: context
    }, children);
}

});
parcelRegister("1U9FF", function(module, exports) {

$parcel$export(module.exports, "PressResponderContext", function () { return $163285dcb41a66ac$export$5165eccb35aaadb5; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $163285dcb41a66ac$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({
    register: ()=>{}
});
$163285dcb41a66ac$export$5165eccb35aaadb5.displayName = "PressResponderContext";

});


parcelRegister("4cdsA", function(module, exports) {

$parcel$export(module.exports, "FocusScope", function () { return $30e2b94920ec35df$export$20e40289641fbbb6; });

var $aq8TS = parcelRequire("aq8TS");

var $gMBBU = parcelRequire("gMBBU");

var $2ZDqh = parcelRequire("2ZDqh");
var $71dP2 = parcelRequire("71dP2");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $30e2b94920ec35df$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
let $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope = null;
function $30e2b94920ec35df$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $exYeM.useRef)(null);
    let endRef = (0, $exYeM.useRef)(null);
    let scopeRef = (0, $exYeM.useRef)([]);
    let { parentNode: parentNode } = (0, $exYeM.useContext)($30e2b94920ec35df$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $exYeM.useMemo)(()=>new $30e2b94920ec35df$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $30e2b94920ec35df$export$d06fae2ee68b101e.root;
        if ($30e2b94920ec35df$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope && !$30e2b94920ec35df$var$$9bf71ea28793e738$var$isAncestorScope($30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $30e2b94920ec35df$export$d06fae2ee68b101e.getTreeNode($30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $30e2b94920ec35df$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        let node = $30e2b94920ec35df$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $30e2b94920ec35df$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $30e2b94920ec35df$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $30e2b94920ec35df$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $30e2b94920ec35df$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $exYeM.useEffect)(()=>{
        const activeElement = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $30e2b94920ec35df$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $30e2b94920ec35df$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $30e2b94920ec35df$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope || $30e2b94920ec35df$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $30e2b94920ec35df$export$d06fae2ee68b101e.getTreeNode(parentScope))) $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $30e2b94920ec35df$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $exYeM.useMemo)(()=>$30e2b94920ec35df$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $exYeM.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($30e2b94920ec35df$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $30e2b94920ec35df$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $exYeM.useContext)($30e2b94920ec35df$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $30e2b94920ec35df$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $30e2b94920ec35df$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $30e2b94920ec35df$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $30e2b94920ec35df$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $30e2b94920ec35df$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $30e2b94920ec35df$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $30e2b94920ec35df$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $30e2b94920ec35df$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $30e2b94920ec35df$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$30e2b94920ec35df$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $30e2b94920ec35df$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $30e2b94920ec35df$export$4c063cf1350e6fed(element) {
    return element.matches($30e2b94920ec35df$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $30e2b94920ec35df$export$d06fae2ee68b101e.getTreeNode($30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $exYeM.useRef)();
    let raf = (0, $exYeM.useRef)();
    (0, $71dP2.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$30e2b94920ec35df$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $30e2b94920ec35df$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $30e2b94920ec35df$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope || $30e2b94920ec35df$var$$9bf71ea28793e738$var$isAncestorScope($30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($30e2b94920ec35df$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope && $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope.current) $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusFirstInScope($30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($30e2b94920ec35df$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $30e2b94920ec35df$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope.current) $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusFirstInScope($30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $30e2b94920ec35df$export$d06fae2ee68b101e.traverse($30e2b94920ec35df$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $30e2b94920ec35df$export$1258395f99bf9cbf(element) {
    return $30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInChildScope(element, $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope);
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $30e2b94920ec35df$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $aq8TS.focusSafely)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $30e2b94920ec35df$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $30e2b94920ec35df$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $30e2b94920ec35df$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $30e2b94920ec35df$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(nextNode);
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(autoFocus);
    (0, $exYeM.useEffect)(()=>{
        if (autoFocusRef.current) {
            $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $71dP2.useLayoutEffect)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $30e2b94920ec35df$export$d06fae2ee68b101e.getTreeNode($30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $exYeM.useRef)(typeof document !== "undefined" ? (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $71dP2.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope || $30e2b94920ec35df$var$$9bf71ea28793e738$var$isAncestorScope($30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $30e2b94920ec35df$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$30e2b94920ec35df$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $30e2b94920ec35df$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $30e2b94920ec35df$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $30e2b94920ec35df$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $30e2b94920ec35df$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $30e2b94920ec35df$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $30e2b94920ec35df$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $30e2b94920ec35df$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $30e2b94920ec35df$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $30e2b94920ec35df$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $30e2b94920ec35df$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $2ZDqh.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, $gMBBU.isElementVisible)(node) && (!scope || $30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $30e2b94920ec35df$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(root).activeElement;
            let walker = $30e2b94920ec35df$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(root).activeElement;
            let walker = $30e2b94920ec35df$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $30e2b94920ec35df$var$$9bf71ea28793e738$var$last(walker);
                if (next) $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $30e2b94920ec35df$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $30e2b94920ec35df$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $30e2b94920ec35df$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $30e2b94920ec35df$var$$9bf71ea28793e738$var$last(walker);
            if (next) $30e2b94920ec35df$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $30e2b94920ec35df$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $30e2b94920ec35df$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $30e2b94920ec35df$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $30e2b94920ec35df$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $30e2b94920ec35df$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $30e2b94920ec35df$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $30e2b94920ec35df$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $30e2b94920ec35df$export$d06fae2ee68b101e = new $30e2b94920ec35df$var$$9bf71ea28793e738$var$Tree();

});
parcelRegister("gMBBU", function(module, exports) {

$parcel$export(module.exports, "isElementVisible", function () { return $c37e4db0fc6be4bc$export$e989c0fffaa6b27a; });

var $2ZDqh = parcelRequire("2ZDqh");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c37e4db0fc6be4bc$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $c37e4db0fc6be4bc$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $c37e4db0fc6be4bc$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $c37e4db0fc6be4bc$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $c37e4db0fc6be4bc$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $c37e4db0fc6be4bc$export$e989c0fffaa6b27a(element.parentElement, element));
}

});






parcelRegister("fsqWO", function(module, exports) {

$parcel$export(module.exports, "popover_content_default", function () { return $269f2fcb9c9616ea$export$2a0d18fe44adc4b6; });

var $aG9V8 = parcelRequire("aG9V8");

var $exYeM = parcelRequire("exYeM");

var $8Oq4a = parcelRequire("8Oq4a");

var $fJq7l = parcelRequire("fJq7l");

var $ftZJ0 = parcelRequire("ftZJ0");

var $dVYhV = parcelRequire("dVYhV");
var $b0UTF = parcelRequire("b0UTF");
var $gtP8X = parcelRequire("gtP8X");

var $66kma = parcelRequire("66kma");

var $KekyV = parcelRequire("KekyV");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $269f2fcb9c9616ea$var$PopoverContent = (0, $8Oq4a.forwardRef)((props, _)=>{
    const { as: as, children: children, className: className, ...otherProps } = props;
    const { Component: OverlayComponent, isOpen: isOpen, placement: placement, backdrop: backdrop, motionProps: motionProps, titleProps: titleProps, disableAnimation: disableAnimation, shouldBlockScroll: shouldBlockScroll, getPopoverProps: getPopoverProps, getDialogProps: getDialogProps, getBackdropProps: getBackdropProps, getContentProps: getContentProps, isNonModal: isNonModal, onClose: onClose } = (0, $aG9V8.usePopoverContext)();
    const dialogProps = getDialogProps(otherProps);
    delete dialogProps.role;
    const Component = as || OverlayComponent || "div";
    const content = /* @__PURE__ */ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            !isNonModal && /* @__PURE__ */ (0, $aSiaI.jsx)((0, $fJq7l.DismissButton), {
                onDismiss: onClose
            }),
            /* @__PURE__ */ (0, $aSiaI.jsx)(Component, {
                ...dialogProps,
                children: /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
                    ...getContentProps({
                        className: className
                    }),
                    children: typeof children === "function" ? children(titleProps) : children
                })
            }),
            /* @__PURE__ */ (0, $aSiaI.jsx)((0, $fJq7l.DismissButton), {
                onDismiss: onClose
            })
        ]
    });
    const backdropContent = (0, $exYeM.useMemo)(()=>{
        if (backdrop === "transparent") return null;
        if (disableAnimation) return /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
            ...getBackdropProps()
        });
        return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $b0UTF.LazyMotion), {
            features: (0, $dVYhV.domAnimation),
            children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $gtP8X.m).div, {
                animate: "enter",
                exit: "exit",
                initial: "exit",
                variants: (0, $ftZJ0.TRANSITION_VARIANTS).fade,
                ...getBackdropProps()
            })
        });
    }, [
        backdrop,
        disableAnimation,
        getBackdropProps
    ]);
    const RemoveScrollWrapper = (0, $exYeM.useCallback)(({ children: children2 })=>{
        return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $66kma.default), {
            enabled: shouldBlockScroll && isOpen,
            removeScrollBar: false,
            children: children2
        });
    }, [
        shouldBlockScroll,
        isOpen
    ]);
    const contents = disableAnimation ? /* @__PURE__ */ (0, $aSiaI.jsx)(RemoveScrollWrapper, {
        children: content
    }) : /* @__PURE__ */ (0, $aSiaI.jsx)((0, $b0UTF.LazyMotion), {
        features: (0, $dVYhV.domAnimation),
        children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $gtP8X.m).div, {
            animate: "enter",
            exit: "exit",
            initial: "initial",
            style: {
                ...(0, $KekyV.getTransformOrigins)(placement === "center" ? "top" : placement)
            },
            variants: (0, $ftZJ0.TRANSITION_VARIANTS).scaleSpringOpacity,
            ...motionProps,
            children: /* @__PURE__ */ (0, $aSiaI.jsx)(RemoveScrollWrapper, {
                children: content
            })
        })
    });
    return /* @__PURE__ */ (0, $aSiaI.jsxs)("div", {
        ...getPopoverProps(),
        children: [
            backdropContent,
            contents
        ]
    });
});
$269f2fcb9c9616ea$var$PopoverContent.displayName = "NextUI.PopoverContent";
var $269f2fcb9c9616ea$export$2a0d18fe44adc4b6 = $269f2fcb9c9616ea$var$PopoverContent;

});
parcelRegister("66kma", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $471317fac98e876e$export$2e2bcd8739ae039; });

var $4tSb9 = parcelRequire("4tSb9");

var $exYeM = parcelRequire("exYeM");

var $9hJNd = parcelRequire("9hJNd");

var $89Gpq = parcelRequire("89Gpq");
var $471317fac98e876e$var$ReactRemoveScroll = $exYeM.forwardRef(function(props, ref) {
    return $exYeM.createElement((0, $9hJNd.RemoveScroll), (0, $4tSb9.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $89Gpq.default)
    }));
});
$471317fac98e876e$var$ReactRemoveScroll.classNames = (0, $9hJNd.RemoveScroll).classNames;
var $471317fac98e876e$export$2e2bcd8739ae039 = $471317fac98e876e$var$ReactRemoveScroll;

});
parcelRegister("4tSb9", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $3433e5a3eb89c040$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $3433e5a3eb89c040$export$3c9a16f847548506; });
$parcel$export(module.exports, "__spreadArray", function () { return $3433e5a3eb89c040$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $3433e5a3eb89c040$var$extendStatics = function(d, b) {
    $3433e5a3eb89c040$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3433e5a3eb89c040$var$extendStatics(d, b);
};
function $3433e5a3eb89c040$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3433e5a3eb89c040$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3433e5a3eb89c040$export$18ce0697a983be9b = function() {
    $3433e5a3eb89c040$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3433e5a3eb89c040$export$18ce0697a983be9b.apply(this, arguments);
};
function $3433e5a3eb89c040$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3433e5a3eb89c040$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3433e5a3eb89c040$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3433e5a3eb89c040$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3433e5a3eb89c040$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3433e5a3eb89c040$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3433e5a3eb89c040$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3433e5a3eb89c040$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3433e5a3eb89c040$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3433e5a3eb89c040$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3433e5a3eb89c040$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3433e5a3eb89c040$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3433e5a3eb89c040$export$45d3717a4c69092e(o, m, p);
}
function $3433e5a3eb89c040$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3433e5a3eb89c040$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3433e5a3eb89c040$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3433e5a3eb89c040$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3433e5a3eb89c040$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3433e5a3eb89c040$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3433e5a3eb89c040$export$10c90e4f7922046c(v) {
    return this instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? (this.v = v, this) : new $3433e5a3eb89c040$export$10c90e4f7922046c(v);
}
function $3433e5a3eb89c040$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3433e5a3eb89c040$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3433e5a3eb89c040$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3433e5a3eb89c040$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3433e5a3eb89c040$export$19a8beecd37a4c45 === "function" ? $3433e5a3eb89c040$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3433e5a3eb89c040$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3433e5a3eb89c040$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3433e5a3eb89c040$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3433e5a3eb89c040$export$45d3717a4c69092e(result, mod, k);
    }
    $3433e5a3eb89c040$var$__setModuleDefault(result, mod);
    return result;
}
function $3433e5a3eb89c040$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3433e5a3eb89c040$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3433e5a3eb89c040$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3433e5a3eb89c040$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3433e5a3eb89c040$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3433e5a3eb89c040$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3433e5a3eb89c040$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3433e5a3eb89c040$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $3433e5a3eb89c040$export$2e2bcd8739ae039 = {
    __extends: $3433e5a3eb89c040$export$a8ba968b8961cb8a,
    __assign: $3433e5a3eb89c040$export$18ce0697a983be9b,
    __rest: $3433e5a3eb89c040$export$3c9a16f847548506,
    __decorate: $3433e5a3eb89c040$export$29e00dfd3077644b,
    __param: $3433e5a3eb89c040$export$d5ad3fd78186038f,
    __metadata: $3433e5a3eb89c040$export$f1db080c865becb9,
    __awaiter: $3433e5a3eb89c040$export$1050f835b63b671e,
    __generator: $3433e5a3eb89c040$export$67ebef60e6f28a6,
    __createBinding: $3433e5a3eb89c040$export$45d3717a4c69092e,
    __exportStar: $3433e5a3eb89c040$export$f33643c0debef087,
    __values: $3433e5a3eb89c040$export$19a8beecd37a4c45,
    __read: $3433e5a3eb89c040$export$8d051b38c9118094,
    __spread: $3433e5a3eb89c040$export$afc72e2116322959,
    __spreadArrays: $3433e5a3eb89c040$export$6388937ca91ccae8,
    __spreadArray: $3433e5a3eb89c040$export$1216008129fb82ed,
    __await: $3433e5a3eb89c040$export$10c90e4f7922046c,
    __asyncGenerator: $3433e5a3eb89c040$export$e427f37a30a4de9b,
    __asyncDelegator: $3433e5a3eb89c040$export$bbd80228419bb833,
    __asyncValues: $3433e5a3eb89c040$export$e3b29a3d6162315f,
    __makeTemplateObject: $3433e5a3eb89c040$export$4fb47efe1390b86f,
    __importStar: $3433e5a3eb89c040$export$c21735bcef00d192,
    __importDefault: $3433e5a3eb89c040$export$da59b14a69baef04,
    __classPrivateFieldGet: $3433e5a3eb89c040$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3433e5a3eb89c040$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3433e5a3eb89c040$export$81fdc39f203e4e04,
    __addDisposableResource: $3433e5a3eb89c040$export$88ac25d8e944e405,
    __disposeResources: $3433e5a3eb89c040$export$8f076105dc360e92
};

});

parcelRegister("9hJNd", function(module, exports) {

$parcel$export(module.exports, "RemoveScroll", function () { return $6c2939159ce57a12$export$22940b497e769dee; });

var $4tSb9 = parcelRequire("4tSb9");

var $exYeM = parcelRequire("exYeM");

var $e5Jyk = parcelRequire("e5Jyk");

var $i2wL0 = parcelRequire("i2wL0");

var $6QCYO = parcelRequire("6QCYO");
var $6c2939159ce57a12$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $6c2939159ce57a12$export$22940b497e769dee = $exYeM.forwardRef(function(props, parentRef) {
    var ref = $exYeM.useRef(null);
    var _a = $exYeM.useState({
        onScrollCapture: $6c2939159ce57a12$var$nothing,
        onWheelCapture: $6c2939159ce57a12$var$nothing,
        onTouchMoveCapture: $6c2939159ce57a12$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $4tSb9.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $i2wL0.useMergeRefs)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $4tSb9.__assign)((0, $4tSb9.__assign)({}, rest), callbacks);
    return $exYeM.createElement($exYeM.Fragment, null, enabled && $exYeM.createElement(SideCar, {
        sideCar: (0, $6QCYO.effectCar),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $exYeM.cloneElement($exYeM.Children.only(children), (0, $4tSb9.__assign)((0, $4tSb9.__assign)({}, containerProps), {
        ref: containerRef
    })) : $exYeM.createElement(Container, (0, $4tSb9.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$6c2939159ce57a12$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$6c2939159ce57a12$export$22940b497e769dee.classNames = {
    fullWidth: (0, $e5Jyk.fullWidthClassName),
    zeroRight: (0, $e5Jyk.zeroRightClassName)
};

});
parcelRegister("e5Jyk", function(module, exports) {

$parcel$export(module.exports, "zeroRightClassName", function () { return $a424de23c132f073$export$1da7500147d4bc3; });
$parcel$export(module.exports, "fullWidthClassName", function () { return $a424de23c132f073$export$898e37bbd2a0ae4e; });
$parcel$export(module.exports, "noScrollbarsClassName", function () { return $a424de23c132f073$export$bb813dfbbc432abc; });
$parcel$export(module.exports, "removedBarSizeVariable", function () { return $a424de23c132f073$export$63d0edf80fea83b1; });
var $a424de23c132f073$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $a424de23c132f073$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $a424de23c132f073$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $a424de23c132f073$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";

});

parcelRegister("i2wL0", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", function () { return $d221d2c5d570aa1d$export$74665b213cb5c4cf; });

var $exYeM = parcelRequire("exYeM");

var $7A1Im = parcelRequire("7A1Im");

var $hRsiu = parcelRequire("hRsiu");
var $d221d2c5d570aa1d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $exYeM.useLayoutEffect : $exYeM.useEffect;
var $d221d2c5d570aa1d$var$currentValues = new WeakMap();
function $d221d2c5d570aa1d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $hRsiu.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $7A1Im.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $d221d2c5d570aa1d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $d221d2c5d570aa1d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $7A1Im.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $7A1Im.assignRef)(ref, current_1);
            });
        }
        $d221d2c5d570aa1d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("7A1Im", function(module, exports) {

$parcel$export(module.exports, "assignRef", function () { return $584d39a8643d937a$export$d734136a7b018efe; });
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $584d39a8643d937a$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("hRsiu", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", function () { return $d00d56265ba92762$export$25bec8c6f54ee79a; });

var $exYeM = parcelRequire("exYeM");
function $d00d56265ba92762$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $exYeM.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("6QCYO", function(module, exports) {

$parcel$export(module.exports, "effectCar", function () { return $4fc5d5f926eb9841$export$e27363444bedfeac; });

var $l2Xws = parcelRequire("l2Xws");
var $4fc5d5f926eb9841$export$e27363444bedfeac = (0, $l2Xws.createSidecarMedium)();

});
parcelRegister("l2Xws", function(module, exports) {

$parcel$export(module.exports, "createSidecarMedium", function () { return $f527f4cfb322b92a$export$e13ec7dd7a14088d; });

var $4tSb9 = parcelRequire("4tSb9");
function $f527f4cfb322b92a$var$ItoI(a) {
    return a;
}
function $f527f4cfb322b92a$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $f527f4cfb322b92a$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $f527f4cfb322b92a$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $f527f4cfb322b92a$var$ItoI;
    return $f527f4cfb322b92a$var$innerCreateMedium(defaults, middleware);
}
function $f527f4cfb322b92a$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $f527f4cfb322b92a$var$innerCreateMedium(null);
    medium.options = (0, $4tSb9.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});



parcelRegister("89Gpq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f000f9080e28e0a$export$2e2bcd8739ae039; });

var $2OxKG = parcelRequire("2OxKG");

var $jkdca = parcelRequire("jkdca");

var $6QCYO = parcelRequire("6QCYO");
var $5f000f9080e28e0a$export$2e2bcd8739ae039 = (0, $2OxKG.exportSidecar)((0, $6QCYO.effectCar), (0, $jkdca.RemoveScrollSideCar));

});
parcelRegister("2OxKG", function(module, exports) {

$parcel$export(module.exports, "exportSidecar", function () { return $20ca6eb20b4dc049$export$6cacc8fb0a9b94ce; });

var $4tSb9 = parcelRequire("4tSb9");

var $exYeM = parcelRequire("exYeM");
var $20ca6eb20b4dc049$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $4tSb9.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $exYeM.createElement(Target, (0, $4tSb9.__assign)({}, rest));
};
$20ca6eb20b4dc049$var$SideCar.isSideCarExport = true;
function $20ca6eb20b4dc049$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $20ca6eb20b4dc049$var$SideCar;
}

});

parcelRegister("jkdca", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollSideCar", function () { return $e11a1edcdcbdc39d$export$a09dbff87b5da2d; });

var $4tSb9 = parcelRequire("4tSb9");

var $exYeM = parcelRequire("exYeM");
parcelRequire("ed7ve");
var $fNOuY = parcelRequire("fNOuY");
parcelRequire("fEiKH");
var $5fZtp = parcelRequire("5fZtp");

var $047Wv = parcelRequire("047Wv");

var $bMXzs = parcelRequire("bMXzs");
var $e11a1edcdcbdc39d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $e11a1edcdcbdc39d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $e11a1edcdcbdc39d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $e11a1edcdcbdc39d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $e11a1edcdcbdc39d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $e11a1edcdcbdc39d$var$idCounter = 0;
var $e11a1edcdcbdc39d$var$lockStack = [];
function $e11a1edcdcbdc39d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $exYeM.useRef([]);
    var touchStartRef = $exYeM.useRef([
        0,
        0
    ]);
    var activeAxis = $exYeM.useRef();
    var id = $exYeM.useState($e11a1edcdcbdc39d$var$idCounter++)[0];
    var Style = $exYeM.useState((0, $5fZtp.styleSingleton))[0];
    var lastProps = $exYeM.useRef(props);
    $exYeM.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $exYeM.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $4tSb9.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($e11a1edcdcbdc39d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $exYeM.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $bMXzs.locationCouldBeScrolled)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $bMXzs.locationCouldBeScrolled)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $bMXzs.handleScroll)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $exYeM.useCallback(function(_event) {
        var event = _event;
        if (!$e11a1edcdcbdc39d$var$lockStack.length || $e11a1edcdcbdc39d$var$lockStack[$e11a1edcdcbdc39d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $e11a1edcdcbdc39d$export$39efaa2ca254a28d(event) : $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $e11a1edcdcbdc39d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($e11a1edcdcbdc39d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $exYeM.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $e11a1edcdcbdc39d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $exYeM.useCallback(function(event) {
        touchStartRef.current = $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $e11a1edcdcbdc39d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $e11a1edcdcbdc39d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $exYeM.useEffect(function() {
        $e11a1edcdcbdc39d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $047Wv.nonPassive));
        document.addEventListener("touchmove", shouldPrevent, (0, $047Wv.nonPassive));
        document.addEventListener("touchstart", scrollTouchStart, (0, $047Wv.nonPassive));
        return function() {
            $e11a1edcdcbdc39d$var$lockStack = $e11a1edcdcbdc39d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $047Wv.nonPassive));
            document.removeEventListener("touchmove", shouldPrevent, (0, $047Wv.nonPassive));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $047Wv.nonPassive));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $exYeM.createElement($exYeM.Fragment, null, inert ? $exYeM.createElement(Style, {
        styles: $e11a1edcdcbdc39d$var$generateStyle(id)
    }) : null, removeScrollBar ? $exYeM.createElement((0, $fNOuY.RemoveScrollBar), {
        gapMode: props.gapMode
    }) : null);
}
function $e11a1edcdcbdc39d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}

});
parcelRegister("ed7ve", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", function () { return (parcelRequire("fNOuY")).RemoveScrollBar; });

var $fNOuY = parcelRequire("fNOuY");

var $e5Jyk = parcelRequire("e5Jyk");

var $c3C0C = parcelRequire("c3C0C");

});
parcelRegister("fNOuY", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", function () { return $b8129a946e86d087$export$9aa43b459c5ae9b9; });

var $exYeM = parcelRequire("exYeM");
parcelRequire("fEiKH");
var $5fZtp = parcelRequire("5fZtp");

var $e5Jyk = parcelRequire("e5Jyk");

var $c3C0C = parcelRequire("c3C0C");
var $b8129a946e86d087$var$Style = (0, $5fZtp.styleSingleton)();
var $b8129a946e86d087$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $b8129a946e86d087$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $e5Jyk.noScrollbarsClassName), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($b8129a946e86d087$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $e5Jyk.zeroRightClassName), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $e5Jyk.fullWidthClassName), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $e5Jyk.zeroRightClassName), " .").concat((0, $e5Jyk.zeroRightClassName), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $e5Jyk.fullWidthClassName), " .").concat((0, $e5Jyk.fullWidthClassName), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($b8129a946e86d087$export$65254d5f26cb9564, "] {\n    ").concat((0, $e5Jyk.removedBarSizeVariable), ": ").concat(gap, "px;\n  }\n");
};
var $b8129a946e86d087$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($b8129a946e86d087$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $b8129a946e86d087$export$a1939b1f9f9b02dc = function() {
    $exYeM.useEffect(function() {
        document.body.setAttribute($b8129a946e86d087$export$65254d5f26cb9564, ($b8129a946e86d087$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $b8129a946e86d087$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($b8129a946e86d087$export$65254d5f26cb9564);
            else document.body.setAttribute($b8129a946e86d087$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $b8129a946e86d087$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $b8129a946e86d087$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $exYeM.useMemo(function() {
        return (0, $c3C0C.getGapWidth)(gapMode);
    }, [
        gapMode
    ]);
    return $exYeM.createElement($b8129a946e86d087$var$Style, {
        styles: $b8129a946e86d087$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};

});
parcelRegister("fEiKH", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", function () { return (parcelRequire("5fZtp")).styleSingleton; });

var $5fZtp = parcelRequire("5fZtp");

var $0wmpO = parcelRequire("0wmpO");

var $BQzKQ = parcelRequire("BQzKQ");

});
parcelRegister("5fZtp", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", function () { return $3d3e09c66c873f3e$export$c1248ee86ba532c8; });

var $BQzKQ = parcelRequire("BQzKQ");
var $3d3e09c66c873f3e$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $BQzKQ.styleHookSingleton)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

});
parcelRegister("BQzKQ", function(module, exports) {

$parcel$export(module.exports, "styleHookSingleton", function () { return $071c3d40780405a9$export$7d7b35c2d250e94c; });

var $exYeM = parcelRequire("exYeM");

var $0wmpO = parcelRequire("0wmpO");
var $071c3d40780405a9$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $0wmpO.stylesheetSingleton)();
    return function(styles, isDynamic) {
        $exYeM.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};

});
parcelRegister("0wmpO", function(module, exports) {

$parcel$export(module.exports, "stylesheetSingleton", function () { return $00191a54979f785d$export$7c74eec858d5d226; });

var $guB8P = parcelRequire("guB8P");
function $00191a54979f785d$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $guB8P.getNonce)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $00191a54979f785d$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $00191a54979f785d$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $00191a54979f785d$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $00191a54979f785d$var$makeStyleTag()) {
                    $00191a54979f785d$var$injectStyles(stylesheet, style);
                    $00191a54979f785d$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

});
parcelRegister("guB8P", function(module, exports) {

$parcel$export(module.exports, "getNonce", function () { return $c01c422d43bc8e57$export$2b85b721e524d74b; });
var $c01c422d43bc8e57$var$currentNonce;
var $c01c422d43bc8e57$export$c5f670b24c0ae95a = function(nonce) {
    $c01c422d43bc8e57$var$currentNonce = nonce;
};
var $c01c422d43bc8e57$export$2b85b721e524d74b = function() {
    if ($c01c422d43bc8e57$var$currentNonce) return $c01c422d43bc8e57$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};

});





parcelRegister("c3C0C", function(module, exports) {

$parcel$export(module.exports, "getGapWidth", function () { return $8c733fa2685d08ec$export$75f2ca8f029c77f4; });
var $8c733fa2685d08ec$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $8c733fa2685d08ec$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $8c733fa2685d08ec$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $8c733fa2685d08ec$var$parse(left),
        $8c733fa2685d08ec$var$parse(top),
        $8c733fa2685d08ec$var$parse(right)
    ];
};
var $8c733fa2685d08ec$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $8c733fa2685d08ec$export$efed13b5d0ca3386;
    var offsets = $8c733fa2685d08ec$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};

});



parcelRegister("047Wv", function(module, exports) {

$parcel$export(module.exports, "nonPassive", function () { return $00c689171e355a98$export$10a6e88623fa9454; });
var $00c689171e355a98$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $00c689171e355a98$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $00c689171e355a98$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $00c689171e355a98$var$options, $00c689171e355a98$var$options);
    // @ts-ignore
    window.removeEventListener("test", $00c689171e355a98$var$options, $00c689171e355a98$var$options);
} catch (err) {
    $00c689171e355a98$var$passiveSupported = false;
}
var $00c689171e355a98$export$10a6e88623fa9454 = $00c689171e355a98$var$passiveSupported ? {
    passive: false
} : false;

});

parcelRegister("bMXzs", function(module, exports) {

$parcel$export(module.exports, "locationCouldBeScrolled", function () { return $895262f629112328$export$9ec64480cae49817; });
$parcel$export(module.exports, "handleScroll", function () { return $895262f629112328$export$dde0441bd4a6ded8; });
var $895262f629112328$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $895262f629112328$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$895262f629112328$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $895262f629112328$var$elementCouldBeVScrolled = function(node) {
    return $895262f629112328$var$elementCanBeScrolled(node, "overflowY");
};
var $895262f629112328$var$elementCouldBeHScrolled = function(node) {
    return $895262f629112328$var$elementCanBeScrolled(node, "overflowX");
};
var $895262f629112328$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $895262f629112328$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $895262f629112328$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $895262f629112328$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $895262f629112328$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $895262f629112328$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $895262f629112328$var$elementCouldBeVScrolled(node) : $895262f629112328$var$elementCouldBeHScrolled(node);
};
var $895262f629112328$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $895262f629112328$var$getVScrollVariables(node) : $895262f629112328$var$getHScrollVariables(node);
};
var $895262f629112328$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $895262f629112328$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $895262f629112328$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $895262f629112328$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($895262f629112328$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};

});





parcelRegister("dq8HR", function(module, exports) {

$parcel$export(module.exports, "popover_trigger_default", function () { return $f995d2918572daf4$export$251d96216457b64b; });

var $aG9V8 = parcelRequire("aG9V8");

var $exYeM = parcelRequire("exYeM");

var $8Oq4a = parcelRequire("8Oq4a");

var $Q2syC = parcelRequire("Q2syC");

var $i3Grl = parcelRequire("i3Grl");

var $3XQiF = parcelRequire("3XQiF");

var $8vAG4 = parcelRequire("8vAG4");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $f995d2918572daf4$var$PopoverTrigger = (0, $8Oq4a.forwardRef)((props, _)=>{
    const { triggerRef: triggerRef, getTriggerProps: getTriggerProps } = (0, $aG9V8.usePopoverContext)();
    const { children: children, ...otherProps } = props;
    const child = (0, $exYeM.useMemo)(()=>{
        if (typeof children === "string") return /* @__PURE__ */ (0, $aSiaI.jsx)("p", {
            children: children
        });
        return (0, $exYeM.Children).only(children);
    }, [
        children
    ]);
    const { onPress: onPress, isDisabled: isDisabled, ...restProps } = (0, $exYeM.useMemo)(()=>{
        return getTriggerProps((0, $8vAG4.mergeProps)(otherProps, child.props), child.ref);
    }, [
        getTriggerProps,
        child.props,
        otherProps,
        child.ref
    ]);
    const [, triggerChildren] = (0, $Q2syC.pickChildren)(children, (0, $3XQiF.button_default));
    const { buttonProps: buttonProps } = (0, $i3Grl.useAriaButton)({
        onPress: onPress,
        isDisabled: isDisabled
    }, triggerRef);
    const hasNextUIButton = (0, $exYeM.useMemo)(()=>{
        return (triggerChildren == null ? void 0 : triggerChildren[0]) !== void 0;
    }, [
        triggerChildren
    ]);
    return (0, $exYeM.cloneElement)(child, (0, $8vAG4.mergeProps)(restProps, hasNextUIButton ? {
        onPress: onPress,
        isDisabled: isDisabled
    } : buttonProps));
});
$f995d2918572daf4$var$PopoverTrigger.displayName = "NextUI.PopoverTrigger";
var $f995d2918572daf4$export$251d96216457b64b = $f995d2918572daf4$var$PopoverTrigger;

});
parcelRegister("Q2syC", function(module, exports) {

$parcel$export(module.exports, "pickChildren", function () { return $eecb061c0775a8b1$export$7d7d2f98282298f7; });

var $cZA1Z = parcelRequire("cZA1Z");

var $6hsMb = parcelRequire("6hsMb");
// src/children.ts
var $eecb061c0775a8b1$var$import_react = (0, $6hsMb.__toESM)((0, $cZA1Z.require_react)());
function $eecb061c0775a8b1$export$b2c43d7d050b2e63(children) {
    return $eecb061c0775a8b1$var$import_react.Children.toArray(children).filter((child)=>(0, $eecb061c0775a8b1$var$import_react.isValidElement)(child));
}
var $eecb061c0775a8b1$export$7d7d2f98282298f7 = (children, targetChild)=>{
    var _a;
    let target = [];
    const withoutTargetChildren = (_a = $eecb061c0775a8b1$var$import_react.Children.map(children, (item)=>{
        if (!(0, $eecb061c0775a8b1$var$import_react.isValidElement)(item)) return item;
        if (item.type === targetChild) {
            target.push(item);
            return null;
        }
        return item;
    })) == null ? void 0 : _a.filter(Boolean);
    const targetChildren = target.length >= 0 ? target : void 0;
    return [
        withoutTargetChildren,
        targetChildren
    ];
};

});
parcelRegister("cZA1Z", function(module, exports) {

$parcel$export(module.exports, "require_react", function () { return $591fca340be5da8b$export$18dc0e75b6bbb2d3; });

var $6hsMb = parcelRequire("6hsMb");
// ../../../node_modules/.pnpm/react@18.2.0/node_modules/react/cjs/react.production.min.js
var $591fca340be5da8b$var$require_react_production_min = (0, $6hsMb.__commonJS)({
    "../../../node_modules/.pnpm/react@18.2.0/node_modules/react/cjs/react.production.min.js" (exports) {
        "use strict";
        var l = Symbol.for("react.element");
        var n = Symbol.for("react.portal");
        var p = Symbol.for("react.fragment");
        var q = Symbol.for("react.strict_mode");
        var r = Symbol.for("react.profiler");
        var t = Symbol.for("react.provider");
        var u = Symbol.for("react.context");
        var v = Symbol.for("react.forward_ref");
        var w = Symbol.for("react.suspense");
        var x = Symbol.for("react.memo");
        var y = Symbol.for("react.lazy");
        var z = Symbol.iterator;
        function A(a) {
            if (null === a || "object" !== typeof a) return null;
            a = z && a[z] || a["@@iterator"];
            return "function" === typeof a ? a : null;
        }
        var B = {
            isMounted: function() {
                return false;
            },
            enqueueForceUpdate: function() {},
            enqueueReplaceState: function() {},
            enqueueSetState: function() {}
        };
        var C = Object.assign;
        var D = {};
        function E(a, b, e) {
            this.props = a;
            this.context = b;
            this.refs = D;
            this.updater = e || B;
        }
        E.prototype.isReactComponent = {};
        E.prototype.setState = function(a, b) {
            if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
            this.updater.enqueueSetState(this, a, b, "setState");
        };
        E.prototype.forceUpdate = function(a) {
            this.updater.enqueueForceUpdate(this, a, "forceUpdate");
        };
        function F() {}
        F.prototype = E.prototype;
        function G(a, b, e) {
            this.props = a;
            this.context = b;
            this.refs = D;
            this.updater = e || B;
        }
        var H = G.prototype = new F();
        H.constructor = G;
        C(H, E.prototype);
        H.isPureReactComponent = true;
        var I = Array.isArray;
        var J = Object.prototype.hasOwnProperty;
        var K = {
            current: null
        };
        var L = {
            key: true,
            ref: true,
            __self: true,
            __source: true
        };
        function M(a, b, e) {
            var d, c = {}, k = null, h = null;
            if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
            var g = arguments.length - 2;
            if (1 === g) c.children = e;
            else if (1 < g) {
                for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
                c.children = f;
            }
            if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
            return {
                $$typeof: l,
                type: a,
                key: k,
                ref: h,
                props: c,
                _owner: K.current
            };
        }
        function N(a, b) {
            return {
                $$typeof: l,
                type: a.type,
                key: b,
                ref: a.ref,
                props: a.props,
                _owner: a._owner
            };
        }
        function O(a) {
            return "object" === typeof a && null !== a && a.$$typeof === l;
        }
        function escape(a) {
            var b = {
                "=": "=0",
                ":": "=2"
            };
            return "$" + a.replace(/[=:]/g, function(a2) {
                return b[a2];
            });
        }
        var P = /\/+/g;
        function Q(a, b) {
            return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
        }
        function R(a, b, e, d, c) {
            var k = typeof a;
            if ("undefined" === k || "boolean" === k) a = null;
            var h = false;
            if (null === a) h = true;
            else switch(k){
                case "string":
                case "number":
                    h = true;
                    break;
                case "object":
                    switch(a.$$typeof){
                        case l:
                        case n:
                            h = true;
                    }
            }
            if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a2) {
                return a2;
            })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
            h = 0;
            d = "" === d ? "." : d + ":";
            if (I(a)) for(var g = 0; g < a.length; g++){
                k = a[g];
                var f = d + Q(k, g);
                h += R(k, b, e, f, c);
            }
            else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
            else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
            return h;
        }
        function S(a, b, e) {
            if (null == a) return a;
            var d = [], c = 0;
            R(a, d, "", "", function(a2) {
                return b.call(e, a2, c++);
            });
            return d;
        }
        function T(a) {
            if (-1 === a._status) {
                var b = a._result;
                b = b();
                b.then(function(b2) {
                    if (0 === a._status || -1 === a._status) a._status = 1, a._result = b2;
                }, function(b2) {
                    if (0 === a._status || -1 === a._status) a._status = 2, a._result = b2;
                });
                -1 === a._status && (a._status = 0, a._result = b);
            }
            if (1 === a._status) return a._result.default;
            throw a._result;
        }
        var U = {
            current: null
        };
        var V = {
            transition: null
        };
        var W = {
            ReactCurrentDispatcher: U,
            ReactCurrentBatchConfig: V,
            ReactCurrentOwner: K
        };
        exports.Children = {
            map: S,
            forEach: function(a, b, e) {
                S(a, function() {
                    b.apply(this, arguments);
                }, e);
            },
            count: function(a) {
                var b = 0;
                S(a, function() {
                    b++;
                });
                return b;
            },
            toArray: function(a) {
                return S(a, function(a2) {
                    return a2;
                }) || [];
            },
            only: function(a) {
                if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
                return a;
            }
        };
        exports.Component = E;
        exports.Fragment = p;
        exports.Profiler = r;
        exports.PureComponent = G;
        exports.StrictMode = q;
        exports.Suspense = w;
        exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
        exports.cloneElement = function(a, b, e) {
            if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
            var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
            if (null != b) {
                void 0 !== b.ref && (k = b.ref, h = K.current);
                void 0 !== b.key && (c = "" + b.key);
                if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
                for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
            }
            var f = arguments.length - 2;
            if (1 === f) d.children = e;
            else if (1 < f) {
                g = Array(f);
                for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
                d.children = g;
            }
            return {
                $$typeof: l,
                type: a.type,
                key: c,
                ref: k,
                props: d,
                _owner: h
            };
        };
        exports.createContext = function(a) {
            a = {
                $$typeof: u,
                _currentValue: a,
                _currentValue2: a,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
                _defaultValue: null,
                _globalName: null
            };
            a.Provider = {
                $$typeof: t,
                _context: a
            };
            return a.Consumer = a;
        };
        exports.createElement = M;
        exports.createFactory = function(a) {
            var b = M.bind(null, a);
            b.type = a;
            return b;
        };
        exports.createRef = function() {
            return {
                current: null
            };
        };
        exports.forwardRef = function(a) {
            return {
                $$typeof: v,
                render: a
            };
        };
        exports.isValidElement = O;
        exports.lazy = function(a) {
            return {
                $$typeof: y,
                _payload: {
                    _status: -1,
                    _result: a
                },
                _init: T
            };
        };
        exports.memo = function(a, b) {
            return {
                $$typeof: x,
                type: a,
                compare: void 0 === b ? null : b
            };
        };
        exports.startTransition = function(a) {
            var b = V.transition;
            V.transition = {};
            try {
                a();
            } finally{
                V.transition = b;
            }
        };
        exports.unstable_act = function() {
            throw Error("act(...) is not supported in production builds of React.");
        };
        exports.useCallback = function(a, b) {
            return U.current.useCallback(a, b);
        };
        exports.useContext = function(a) {
            return U.current.useContext(a);
        };
        exports.useDebugValue = function() {};
        exports.useDeferredValue = function(a) {
            return U.current.useDeferredValue(a);
        };
        exports.useEffect = function(a, b) {
            return U.current.useEffect(a, b);
        };
        exports.useId = function() {
            return U.current.useId();
        };
        exports.useImperativeHandle = function(a, b, e) {
            return U.current.useImperativeHandle(a, b, e);
        };
        exports.useInsertionEffect = function(a, b) {
            return U.current.useInsertionEffect(a, b);
        };
        exports.useLayoutEffect = function(a, b) {
            return U.current.useLayoutEffect(a, b);
        };
        exports.useMemo = function(a, b) {
            return U.current.useMemo(a, b);
        };
        exports.useReducer = function(a, b, e) {
            return U.current.useReducer(a, b, e);
        };
        exports.useRef = function(a) {
            return U.current.useRef(a);
        };
        exports.useState = function(a) {
            return U.current.useState(a);
        };
        exports.useSyncExternalStore = function(a, b, e) {
            return U.current.useSyncExternalStore(a, b, e);
        };
        exports.useTransition = function() {
            return U.current.useTransition();
        };
        exports.version = "18.2.0";
    }
});
// ../../../node_modules/.pnpm/react@18.2.0/node_modules/react/cjs/react.development.js
var $591fca340be5da8b$var$require_react_development = (0, $6hsMb.__commonJS)({
    "../../../node_modules/.pnpm/react@18.2.0/node_modules/react/cjs/react.development.js" (exports, module) {
        "use strict";
    }
});
// ../../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var $591fca340be5da8b$export$18dc0e75b6bbb2d3 = (0, $6hsMb.__commonJS)({
    "../../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js" (exports, module) {
        "use strict";
        module.exports = $591fca340be5da8b$var$require_react_production_min();
    }
});
 /**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */  /**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
});
parcelRegister("6hsMb", function(module, exports) {

$parcel$export(module.exports, "__commonJS", function () { return $a8a20db94db512a8$export$c98acbe61b4a254a; });
$parcel$export(module.exports, "__toESM", function () { return $a8a20db94db512a8$export$82dec27a9dce9602; });
var $a8a20db94db512a8$var$__create = Object.create;
var $a8a20db94db512a8$var$__defProp = Object.defineProperty;
var $a8a20db94db512a8$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $a8a20db94db512a8$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $a8a20db94db512a8$var$__getProtoOf = Object.getPrototypeOf;
var $a8a20db94db512a8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a8a20db94db512a8$export$c98acbe61b4a254a = (cb, mod)=>function __require() {
        return mod || (0, cb[$a8a20db94db512a8$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $a8a20db94db512a8$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $a8a20db94db512a8$var$__getOwnPropNames(from))if (!$a8a20db94db512a8$var$__hasOwnProp.call(to, key) && key !== except) $a8a20db94db512a8$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $a8a20db94db512a8$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $a8a20db94db512a8$export$82dec27a9dce9602 = (mod, isNodeMode, target)=>(target = mod != null ? $a8a20db94db512a8$var$__create($a8a20db94db512a8$var$__getProtoOf(mod)) : {}, $a8a20db94db512a8$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $a8a20db94db512a8$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));

});




parcelRegister("jNBsp", function(module, exports) {

$parcel$export(module.exports, "select_default", function () { return $80cef3fa4b54421d$export$5f058b6414bc662f; });

var $3pqwE = parcelRequire("3pqwE");

var $cbsbu = parcelRequire("cbsbu");

var $6b1sx = parcelRequire("6b1sx");

var $9fwCr = parcelRequire("9fwCr");

var $9cxwv = parcelRequire("9cxwv");

var $e73nX = parcelRequire("e73nX");

var $8Oq4a = parcelRequire("8Oq4a");

var $MSTUT = parcelRequire("MSTUT");

var $exYeM = parcelRequire("exYeM");

var $1gBTM = parcelRequire("1gBTM");

var $3kiob = parcelRequire("3kiob");

var $aSiaI = parcelRequire("aSiaI");
"use client";
function $80cef3fa4b54421d$var$Select(props, ref) {
    const { Component: Component, state: state, label: label, hasHelper: hasHelper, isLoading: isLoading, triggerRef: triggerRef, selectorIcon: selectorIcon = /* @__PURE__ */ (0, $aSiaI.jsx)((0, $9cxwv.ChevronDownIcon), {}), description: description, errorMessage: errorMessage, isInvalid: isInvalid, startContent: startContent, endContent: endContent, placeholder: placeholder, renderValue: renderValue, isOutsideLeft: isOutsideLeft, disableAnimation: disableAnimation, getBaseProps: getBaseProps, getLabelProps: getLabelProps, getTriggerProps: getTriggerProps, getValueProps: getValueProps, getListboxProps: getListboxProps, getPopoverProps: getPopoverProps, getSpinnerProps: getSpinnerProps, getMainWrapperProps: getMainWrapperProps, getInnerWrapperProps: getInnerWrapperProps, getHiddenSelectProps: getHiddenSelectProps, getHelperWrapperProps: getHelperWrapperProps, getListboxWrapperProps: getListboxWrapperProps, getDescriptionProps: getDescriptionProps, getErrorMessageProps: getErrorMessageProps, getSelectorIconProps: getSelectorIconProps } = (0, $cbsbu.useSelect)({
        ...props,
        ref: ref
    });
    const labelContent = label ? /* @__PURE__ */ (0, $aSiaI.jsx)("label", {
        ...getLabelProps(),
        children: label
    }) : null;
    const clonedIcon = (0, $exYeM.cloneElement)(selectorIcon, getSelectorIconProps());
    const helperWrapper = (0, $exYeM.useMemo)(()=>{
        if (!hasHelper) return null;
        return /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
            ...getHelperWrapperProps(),
            children: isInvalid && errorMessage ? /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
                ...getErrorMessageProps(),
                children: errorMessage
            }) : description ? /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
                ...getDescriptionProps(),
                children: description
            }) : null
        });
    }, [
        hasHelper,
        isInvalid,
        errorMessage,
        description,
        getHelperWrapperProps,
        getErrorMessageProps,
        getDescriptionProps
    ]);
    const renderSelectedItem = (0, $exYeM.useMemo)(()=>{
        var _a;
        if (!((_a = state.selectedItems) == null ? void 0 : _a.length)) return placeholder;
        if (renderValue && typeof renderValue === "function") {
            const mappedItems = [
                ...state.selectedItems
            ].map((item)=>({
                    key: item.key,
                    data: item.value,
                    type: item.type,
                    props: item.props,
                    textValue: item.textValue,
                    rendered: item.rendered,
                    "aria-label": item["aria-label"]
                }));
            return renderValue(mappedItems);
        }
        return state.selectedItems.map((item)=>item.textValue).join(", ");
    }, [
        state.selectedItems,
        renderValue,
        placeholder
    ]);
    const renderIndicator = (0, $exYeM.useMemo)(()=>{
        if (isLoading) return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $e73nX.spinner_default), {
            ...getSpinnerProps()
        });
        return clonedIcon;
    }, [
        isLoading,
        clonedIcon,
        getSpinnerProps
    ]);
    const popoverContent = (0, $exYeM.useMemo)(()=>state.isOpen ? /* @__PURE__ */ (0, $aSiaI.jsx)((0, $9fwCr.free_solo_popover_default), {
            ...getPopoverProps(),
            children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $MSTUT.scroll_shadow_default), {
                ...getListboxWrapperProps(),
                children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $6b1sx.listbox_default), {
                    ...getListboxProps()
                })
            })
        }) : null, [
        state.isOpen,
        getPopoverProps,
        state,
        triggerRef,
        getListboxWrapperProps,
        getListboxProps
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsxs)("div", {
        ...getBaseProps(),
        children: [
            /* @__PURE__ */ (0, $aSiaI.jsx)((0, $3pqwE.HiddenSelect), {
                ...getHiddenSelectProps()
            }),
            isOutsideLeft ? labelContent : null,
            /* @__PURE__ */ (0, $aSiaI.jsxs)("div", {
                ...getMainWrapperProps(),
                children: [
                    /* @__PURE__ */ (0, $aSiaI.jsxs)(Component, {
                        ...getTriggerProps(),
                        children: [
                            !isOutsideLeft ? labelContent : null,
                            /* @__PURE__ */ (0, $aSiaI.jsxs)("div", {
                                ...getInnerWrapperProps(),
                                children: [
                                    startContent,
                                    /* @__PURE__ */ (0, $aSiaI.jsx)("span", {
                                        ...getValueProps(),
                                        children: renderSelectedItem
                                    }),
                                    endContent && state.selectedItems && /* @__PURE__ */ (0, $aSiaI.jsx)((0, $1gBTM.VisuallyHidden), {
                                        elementType: "span",
                                        children: ","
                                    }),
                                    endContent
                                ]
                            }),
                            renderIndicator
                        ]
                    }),
                    helperWrapper
                ]
            }),
            disableAnimation ? popoverContent : /* @__PURE__ */ (0, $aSiaI.jsx)((0, $3kiob.AnimatePresence), {
                children: popoverContent
            })
        ]
    });
}
var $80cef3fa4b54421d$export$5f058b6414bc662f = (0, $8Oq4a.forwardRef)($80cef3fa4b54421d$var$Select);
$80cef3fa4b54421d$var$Select.displayName = "NextUI.Select";

});
parcelRegister("3pqwE", function(module, exports) {

$parcel$export(module.exports, "HiddenSelect", function () { return $e68f48f65385ee5e$export$cbd84cdb2e668835; });

var $cbsbu = parcelRequire("cbsbu");

var $bxL7d = parcelRequire("bxL7d");

var $b6W9a = parcelRequire("b6W9a");

var $1gBTM = parcelRequire("1gBTM");

var $8NHlZ = parcelRequire("8NHlZ");

var $aSiaI = parcelRequire("aSiaI");
"use client";
function $e68f48f65385ee5e$export$f809e80f58e251d1(props, state, triggerRef) {
    var _a;
    let data = (0, $cbsbu.selectData).get(state) || {};
    let { autoComplete: autoComplete, name: name = data.name, isDisabled: isDisabled = data.isDisabled, selectionMode: selectionMode, onChange: onChange } = props;
    let { validationBehavior: validationBehavior, isRequired: isRequired } = data;
    let modality = (0, $b6W9a.useInteractionModality)();
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $1gBTM.useVisuallyHidden)();
    (0, $bxL7d.useFormReset)(props.selectRef, state.selectedKeys, state.setSelectedKeys);
    (0, $8NHlZ.useFormValidation)({
        validationBehavior: validationBehavior,
        focus: ()=>{
            var _a2;
            return (_a2 = triggerRef.current) == null ? void 0 : _a2.focus();
        }
    }, state, props.selectRef);
    return {
        containerProps: {
            ...visuallyHiddenProps,
            "aria-hidden": true,
            ["data-a11y-ignore"]: "aria-hidden-focus"
        },
        inputProps: {
            type: "text",
            tabIndex: modality == null || state.isFocused || state.isOpen ? -1 : 0,
            autoComplete: autoComplete,
            value: (_a = [
                ...state.selectedKeys
            ].join(",")) != null ? _a : "",
            required: isRequired,
            style: {
                fontSize: 16
            },
            onFocus: ()=>{
                var _a2;
                return (_a2 = triggerRef.current) == null ? void 0 : _a2.focus();
            },
            disabled: isDisabled,
            onChange: ()=>{}
        },
        selectProps: {
            name: name,
            tabIndex: -1,
            autoComplete: autoComplete,
            disabled: isDisabled,
            size: state.collection.size,
            value: selectionMode === "multiple" ? [
                ...state.selectedKeys
            ].map((k)=>String(k)) : [
                ...state.selectedKeys
            ][0],
            multiple: selectionMode === "multiple",
            onChange: (e)=>{
                state.setSelectedKeys(e.target.value);
                onChange == null || onChange(e);
            }
        }
    };
}
function $e68f48f65385ee5e$export$cbd84cdb2e668835(props) {
    var _a;
    let { state: state, triggerRef: triggerRef, selectRef: selectRef, label: label, name: name, isDisabled: isDisabled } = props;
    let { containerProps: containerProps, inputProps: inputProps, selectProps: selectProps } = $e68f48f65385ee5e$export$f809e80f58e251d1({
        ...props,
        selectRef: selectRef
    }, state, triggerRef);
    if (state.collection.size <= 300) return /* @__PURE__ */ (0, $aSiaI.jsxs)("div", {
        ...containerProps,
        "data-testid": "hidden-select-container",
        children: [
            /* @__PURE__ */ (0, $aSiaI.jsx)("input", {
                ...inputProps
            }),
            /* @__PURE__ */ (0, $aSiaI.jsxs)("label", {
                children: [
                    label,
                    /* @__PURE__ */ (0, $aSiaI.jsxs)("select", {
                        ...selectProps,
                        ref: selectRef,
                        children: [
                            /* @__PURE__ */ (0, $aSiaI.jsx)("option", {}),
                            [
                                ...state.collection.getKeys()
                            ].map((key)=>{
                                let item = state.collection.getItem(key);
                                if ((item == null ? void 0 : item.type) === "item") return /* @__PURE__ */ (0, $aSiaI.jsx)("option", {
                                    value: item.key,
                                    children: item.textValue
                                }, item.key);
                            })
                        ]
                    })
                ]
            })
        ]
    });
    else if (name) return /* @__PURE__ */ (0, $aSiaI.jsx)("input", {
        autoComplete: selectProps.autoComplete,
        disabled: isDisabled,
        name: name,
        type: "hidden",
        value: (_a = [
            ...state.selectedKeys
        ].join(",")) != null ? _a : ""
    });
    return null;
}

});
parcelRegister("cbsbu", function(module, exports) {

$parcel$export(module.exports, "selectData", function () { return $0c6f687dfeda48ff$export$703601b7e90536f8; });
$parcel$export(module.exports, "useSelect", function () { return $0c6f687dfeda48ff$export$e64b2f635402ca43; });

var $8Oq4a = parcelRequire("8Oq4a");
var $lJ6o6 = parcelRequire("lJ6o6");

var $874YT = parcelRequire("874YT");

var $LA3Ym = parcelRequire("LA3Ym");
var $lfs90 = parcelRequire("lfs90");

var $exYeM = parcelRequire("exYeM");

var $i3Grl = parcelRequire("i3Grl");

var $k5F2B = parcelRequire("k5F2B");

var $6pmNA = parcelRequire("6pmNA");
var $jj4Oc = parcelRequire("jj4Oc");
var $luNG9 = parcelRequire("luNG9");

var $8vAG4 = parcelRequire("8vAG4");

var $b6W9a = parcelRequire("b6W9a");

var $dDDPx = parcelRequire("dDDPx");
var $dwC3Z = parcelRequire("dwC3Z");

var $7Qd7T = parcelRequire("7Qd7T");

var $75g4P = parcelRequire("75g4P");
"use client";
var $0c6f687dfeda48ff$export$703601b7e90536f8 = /* @__PURE__ */ new WeakMap();
function $0c6f687dfeda48ff$export$e64b2f635402ca43(originalProps) {
    var _a, _b, _c, _d, _e;
    const globalContext = (0, $lJ6o6.useProviderContext)();
    const [props, variantProps] = (0, $8Oq4a.mapPropsVariants)(originalProps, (0, $874YT.select).variantKeys);
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const { ref: ref, as: as, label: label, name: name, isLoading: isLoading, selectorIcon: selectorIcon, isOpen: isOpen, defaultOpen: defaultOpen, onOpenChange: onOpenChange, startContent: startContent, endContent: endContent, description: description, renderValue: renderValue, onSelectionChange: onSelectionChange, placeholder: placeholder, children: children, disallowEmptySelection: disallowEmptySelection = false, selectionMode: selectionMode = "single", spinnerRef: spinnerRef, scrollRef: scrollRefProp, popoverProps: popoverProps = {}, scrollShadowProps: scrollShadowProps = {}, listboxProps: listboxProps = {}, spinnerProps: spinnerProps = {}, validationState: validationState, onChange: onChange, onClose: onClose, className: className, classNames: classNames, ...otherProps } = props;
    const scrollShadowRef = (0, $lfs90.useDOMRef)(scrollRefProp);
    const slotsProps = {
        popoverProps: (0, $8vAG4.mergeProps)({
            placement: "bottom",
            triggerScaleOnOpen: false,
            offset: 5,
            disableAnimation: disableAnimation
        }, popoverProps),
        scrollShadowProps: (0, $8vAG4.mergeProps)({
            ref: scrollShadowRef,
            isEnabled: (_c = originalProps.showScrollIndicators) != null ? _c : true,
            hideScrollBar: true,
            offset: 15
        }, scrollShadowProps),
        listboxProps: (0, $8vAG4.mergeProps)({
            disableAnimation: disableAnimation
        }, listboxProps)
    };
    const Component = as || "button";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $lfs90.useDOMRef)(ref);
    const triggerRef = (0, $exYeM.useRef)(null);
    const listBoxRef = (0, $exYeM.useRef)(null);
    const popoverRef = (0, $exYeM.useRef)(null);
    let state = (0, $dwC3Z.useMultiSelectState)({
        ...props,
        isOpen: isOpen,
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        children: children,
        isRequired: originalProps.isRequired,
        isDisabled: originalProps.isDisabled,
        defaultOpen: defaultOpen,
        onOpenChange: (open)=>{
            onOpenChange == null || onOpenChange(open);
            if (!open) onClose == null || onClose();
        },
        onSelectionChange: (keys)=>{
            onSelectionChange == null || onSelectionChange(keys);
            if (onChange && typeof onChange === "function" && domRef.current) {
                const event = {
                    target: {
                        ...domRef.current,
                        value: Array.from(keys).join(","),
                        name: domRef.current.name
                    }
                };
                onChange(event);
            }
        }
    });
    state = {
        ...state,
        ...originalProps.isDisabled && {
            disabledKeys: /* @__PURE__ */ new Set([
                ...state.collection.getKeys()
            ])
        }
    };
    (0, $7Qd7T.useSafeLayoutEffect)(()=>{
        var _a2;
        if (!((_a2 = domRef.current) == null ? void 0 : _a2.value)) return;
        state.setSelectedKeys(/* @__PURE__ */ new Set([
            ...state.selectedKeys,
            domRef.current.value
        ]));
    }, [
        domRef.current
    ]);
    const { labelProps: labelProps, triggerProps: triggerProps, valueProps: valueProps, menuProps: menuProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, isInvalid: isAriaInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = (0, $dDDPx.useMultiSelect)({
        ...props,
        disallowEmptySelection: disallowEmptySelection,
        isDisabled: originalProps.isDisabled
    }, state, triggerRef);
    const isInvalid = originalProps.isInvalid || validationState === "invalid" || isAriaInvalid;
    const { isPressed: isPressed, buttonProps: buttonProps } = (0, $i3Grl.useAriaButton)(triggerProps, triggerRef);
    const { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $k5F2B.useFocusRing)();
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $b6W9a.useHover)({
        isDisabled: originalProps.isDisabled
    });
    const labelPlacement = (0, $exYeM.useMemo)(()=>{
        var _a2;
        if ((!originalProps.labelPlacement || originalProps.labelPlacement === "inside") && !label) return "outside";
        return (_a2 = originalProps.labelPlacement) != null ? _a2 : "inside";
    }, [
        originalProps.labelPlacement,
        label
    ]);
    const hasPlaceholder = !!placeholder;
    const shouldLabelBeOutside = labelPlacement === "outside-left" || labelPlacement === "outside" && (hasPlaceholder || !!originalProps.isMultiline);
    const shouldLabelBeInside = labelPlacement === "inside";
    const isOutsideLeft = labelPlacement === "outside-left";
    const isFilled = state.isOpen || hasPlaceholder || !!((_d = state.selectedItems) == null ? void 0 : _d.length) || !!startContent || !!endContent || !!originalProps.isMultiline;
    const hasValue = !!((_e = state.selectedItems) == null ? void 0 : _e.length);
    const hasLabel = !!label;
    const baseStyles = (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.base, className);
    const slots = (0, $exYeM.useMemo)(()=>(0, $874YT.select)({
            ...variantProps,
            isInvalid: isInvalid,
            labelPlacement: labelPlacement,
            disableAnimation: disableAnimation,
            className: className
        }), [
        (0, $luNG9.objectToDeps)(variantProps),
        isInvalid,
        labelPlacement,
        disableAnimation,
        className
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (state.isOpen && popoverRef.current && listBoxRef.current) {
            let selectedItem = listBoxRef.current.querySelector("[aria-selected=true] [data-label=true]");
            let scrollShadow = scrollShadowRef.current;
            if (selectedItem && scrollShadow && selectedItem.parentElement) {
                let scrollShadowRect = scrollShadow == null ? void 0 : scrollShadow.getBoundingClientRect();
                let scrollShadowHeight = scrollShadowRect.height;
                scrollShadow.scrollTop = selectedItem.parentElement.offsetTop - scrollShadowHeight / 2 + selectedItem.parentElement.clientHeight / 2;
            }
        }
    }, [
        state.isOpen,
        disableAnimation
    ]);
    const errorMessage = typeof props.errorMessage === "function" ? props.errorMessage({
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    }) : props.errorMessage || (validationErrors == null ? void 0 : validationErrors.join(" "));
    const hasHelper = !!description || !!errorMessage;
    (0, $exYeM.useEffect)(()=>{
        if (state.isOpen && popoverRef.current && triggerRef.current) {
            let selectRect = triggerRef.current.getBoundingClientRect();
            let popover = popoverRef.current;
            popover.style.width = selectRect.width + "px";
        }
    }, [
        state.isOpen
    ]);
    const getBaseProps = (0, $exYeM.useCallback)((props2 = {})=>({
            "data-slot": "base",
            "data-filled": (0, $jj4Oc.dataAttr)(isFilled),
            "data-has-value": (0, $jj4Oc.dataAttr)(hasValue),
            "data-has-label": (0, $jj4Oc.dataAttr)(hasLabel),
            "data-has-helper": (0, $jj4Oc.dataAttr)(hasHelper),
            className: slots.base({
                class: (0, $6pmNA.clsx)(baseStyles, props2.className)
            }),
            ...props2
        }), [
        slots,
        hasHelper,
        hasValue,
        hasLabel,
        isFilled,
        baseStyles
    ]);
    const getTriggerProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ref: triggerRef,
            "data-slot": "trigger",
            "data-open": (0, $jj4Oc.dataAttr)(state.isOpen),
            "data-disabled": (0, $jj4Oc.dataAttr)(originalProps == null ? void 0 : originalProps.isDisabled),
            "data-focus": (0, $jj4Oc.dataAttr)(isFocused),
            "data-pressed": (0, $jj4Oc.dataAttr)(isPressed),
            "data-focus-visible": (0, $jj4Oc.dataAttr)(isFocusVisible),
            "data-hover": (0, $jj4Oc.dataAttr)(isHovered),
            className: slots.trigger({
                class: classNames == null ? void 0 : classNames.trigger
            }),
            ...(0, $8vAG4.mergeProps)(buttonProps, focusProps, hoverProps, (0, $LA3Ym.filterDOMProps)(otherProps, {
                enabled: shouldFilterDOMProps
            }), (0, $LA3Ym.filterDOMProps)(props2))
        };
    }, [
        slots,
        triggerRef,
        state.isOpen,
        classNames == null ? void 0 : classNames.trigger,
        originalProps == null ? void 0 : originalProps.isDisabled,
        isFocused,
        isPressed,
        isFocusVisible,
        isHovered,
        buttonProps,
        focusProps,
        hoverProps,
        otherProps,
        shouldFilterDOMProps
    ]);
    const getHiddenSelectProps = (0, $exYeM.useCallback)((props2 = {})=>({
            state: state,
            triggerRef: triggerRef,
            selectRef: domRef,
            selectionMode: selectionMode,
            label: originalProps == null ? void 0 : originalProps.label,
            name: originalProps == null ? void 0 : originalProps.name,
            isRequired: originalProps == null ? void 0 : originalProps.isRequired,
            autoComplete: originalProps == null ? void 0 : originalProps.autoComplete,
            isDisabled: originalProps == null ? void 0 : originalProps.isDisabled,
            onChange: onChange,
            ...props2
        }), [
        state,
        selectionMode,
        originalProps == null ? void 0 : originalProps.label,
        originalProps == null ? void 0 : originalProps.autoComplete,
        originalProps == null ? void 0 : originalProps.name,
        originalProps == null ? void 0 : originalProps.isDisabled,
        triggerRef
    ]);
    const getLabelProps = (0, $exYeM.useCallback)((props2 = {})=>({
            "data-slot": "label",
            className: slots.label({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.label, props2.className)
            }),
            ...labelProps,
            ...props2
        }), [
        slots,
        classNames == null ? void 0 : classNames.label,
        labelProps
    ]);
    const getValueProps = (0, $exYeM.useCallback)((props2 = {})=>({
            "data-slot": "value",
            className: slots.value({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.value, props2.className)
            }),
            ...valueProps,
            ...props2
        }), [
        slots,
        classNames == null ? void 0 : classNames.value,
        valueProps
    ]);
    const getListboxWrapperProps = (0, $exYeM.useCallback)((props2 = {})=>({
            "data-slot": "listboxWrapper",
            className: slots.listboxWrapper({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.listboxWrapper, props2 == null ? void 0 : props2.className)
            }),
            ...(0, $8vAG4.mergeProps)(slotsProps.scrollShadowProps, props2)
        }), [
        slots.listboxWrapper,
        classNames == null ? void 0 : classNames.listboxWrapper,
        slotsProps.scrollShadowProps
    ]);
    const getListboxProps = (props2 = {})=>{
        return {
            state: state,
            ref: listBoxRef,
            "data-slot": "listbox",
            className: slots.listbox({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.listbox, props2 == null ? void 0 : props2.className)
            }),
            ...(0, $8vAG4.mergeProps)(slotsProps.listboxProps, props2, menuProps)
        };
    };
    const getPopoverProps = (0, $exYeM.useCallback)((props2 = {})=>{
        var _a2, _b2;
        const popoverProps2 = (0, $8vAG4.mergeProps)(slotsProps.popoverProps, props2);
        return {
            state: state,
            triggerRef: triggerRef,
            ref: popoverRef,
            "data-slot": "popover",
            scrollRef: listBoxRef,
            triggerType: "listbox",
            classNames: {
                content: slots.popoverContent({
                    class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.popoverContent, props2.className)
                })
            },
            ...popoverProps2,
            offset: state.selectedItems && state.selectedItems.length > 0 ? state.selectedItems.length * 1e-8 + (((_a2 = slotsProps.popoverProps) == null ? void 0 : _a2.offset) || 0) : (_b2 = slotsProps.popoverProps) == null ? void 0 : _b2.offset,
            shouldCloseOnInteractOutside: (popoverProps2 == null ? void 0 : popoverProps2.shouldCloseOnInteractOutside) ? popoverProps2.shouldCloseOnInteractOutside : (element)=>(0, $75g4P.ariaShouldCloseOnInteractOutside)(element, triggerRef, state)
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.popoverContent,
        slotsProps.popoverProps,
        triggerRef,
        state,
        state.selectedItems
    ]);
    const getSelectorIconProps = (0, $exYeM.useCallback)(()=>({
            "data-slot": "selectorIcon",
            "aria-hidden": (0, $jj4Oc.dataAttr)(true),
            "data-open": (0, $jj4Oc.dataAttr)(state.isOpen),
            className: slots.selectorIcon({
                class: classNames == null ? void 0 : classNames.selectorIcon
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.selectorIcon,
        state == null ? void 0 : state.isOpen
    ]);
    const getInnerWrapperProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "innerWrapper",
            className: slots.innerWrapper({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.innerWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.innerWrapper
    ]);
    const getHelperWrapperProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "helperWrapper",
            className: slots.helperWrapper({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.helperWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.helperWrapper
    ]);
    const getDescriptionProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ...descriptionProps,
            "data-slot": "description",
            className: slots.description({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.description, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.description
    ]);
    const getMainWrapperProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "data-slot": "mainWrapper",
            className: slots.mainWrapper({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.mainWrapper, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.mainWrapper
    ]);
    const getErrorMessageProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ...props2,
            ...errorMessageProps,
            "data-slot": "errorMessage",
            className: slots.errorMessage({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.errorMessage, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        errorMessageProps,
        classNames == null ? void 0 : classNames.errorMessage
    ]);
    const getSpinnerProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            "aria-hidden": (0, $jj4Oc.dataAttr)(true),
            "data-slot": "spinner",
            color: "current",
            size: "sm",
            ...spinnerProps,
            ...props2,
            ref: spinnerRef,
            className: slots.spinner({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.spinner, props2 == null ? void 0 : props2.className)
            })
        };
    }, [
        slots,
        spinnerRef,
        spinnerProps,
        classNames == null ? void 0 : classNames.spinner
    ]);
    $0c6f687dfeda48ff$export$703601b7e90536f8.set(state, {
        isDisabled: originalProps == null ? void 0 : originalProps.isDisabled,
        isRequired: originalProps == null ? void 0 : originalProps.isRequired,
        name: originalProps == null ? void 0 : originalProps.name,
        validationBehavior: "native"
    });
    return {
        Component: Component,
        domRef: domRef,
        state: state,
        label: label,
        name: name,
        triggerRef: triggerRef,
        isLoading: isLoading,
        placeholder: placeholder,
        startContent: startContent,
        endContent: endContent,
        description: description,
        selectorIcon: selectorIcon,
        hasHelper: hasHelper,
        labelPlacement: labelPlacement,
        hasPlaceholder: hasPlaceholder,
        renderValue: renderValue,
        selectionMode: selectionMode,
        disableAnimation: disableAnimation,
        isOutsideLeft: isOutsideLeft,
        shouldLabelBeOutside: shouldLabelBeOutside,
        shouldLabelBeInside: shouldLabelBeInside,
        isInvalid: isInvalid,
        errorMessage: errorMessage,
        getBaseProps: getBaseProps,
        getTriggerProps: getTriggerProps,
        getLabelProps: getLabelProps,
        getValueProps: getValueProps,
        getListboxProps: getListboxProps,
        getPopoverProps: getPopoverProps,
        getSpinnerProps: getSpinnerProps,
        getMainWrapperProps: getMainWrapperProps,
        getListboxWrapperProps: getListboxWrapperProps,
        getHiddenSelectProps: getHiddenSelectProps,
        getInnerWrapperProps: getInnerWrapperProps,
        getHelperWrapperProps: getHelperWrapperProps,
        getDescriptionProps: getDescriptionProps,
        getErrorMessageProps: getErrorMessageProps,
        getSelectorIconProps: getSelectorIconProps
    };
}

});
parcelRegister("874YT", function(module, exports) {

$parcel$export(module.exports, "select", function () { return $d44070f4b32984f1$export$2e6c959c16ff56b8; });

var $a2Moz = parcelRequire("a2Moz");

var $9dwEN = parcelRequire("9dwEN");
// src/components/select.ts
var $d44070f4b32984f1$export$2e6c959c16ff56b8 = (0, $a2Moz.tv)({
    slots: {
        base: [
            "group inline-flex flex-col relative w-full"
        ],
        label: [
            "block",
            "absolute",
            "z-10",
            "origin-top-left",
            "rtl:origin-top-right",
            "subpixel-antialiased",
            "text-small",
            "text-foreground-500",
            "pointer-events-none"
        ],
        mainWrapper: "w-full flex flex-col",
        trigger: "relative px-3 gap-3 w-full inline-flex flex-row items-center shadow-sm outline-none tap-highlight-transparent",
        innerWrapper: "inline-flex h-full w-[calc(100%_-_theme(spacing.6))] min-h-4 items-center gap-1.5 box-border",
        selectorIcon: "absolute right-3 rtl:left-3 rtl:right-[unset] w-4 h-4",
        spinner: "absolute right-3 rtl:left-3 rtl:right-[unset]",
        value: [
            "text-foreground-500",
            "font-normal",
            "w-full",
            "text-left",
            "rtl:text-right"
        ],
        listboxWrapper: "scroll-py-6 max-h-64 w-full",
        listbox: "",
        popoverContent: "w-full p-1 overflow-hidden",
        helperWrapper: "p-1 flex relative flex-col gap-1.5",
        description: "text-tiny text-foreground-400",
        errorMessage: "text-tiny text-danger"
    },
    variants: {
        variant: {
            flat: {
                trigger: [
                    "bg-default-100",
                    "data-[hover=true]:bg-default-200",
                    "group-data-[focus=true]:bg-default-100"
                ]
            },
            faded: {
                trigger: [
                    "bg-default-100",
                    "border-medium",
                    "border-default-200",
                    "data-[hover=true]:border-default-400"
                ],
                value: "group-data-[has-value=true]:text-default-foreground"
            },
            bordered: {
                trigger: [
                    "border-medium",
                    "border-default-200",
                    "data-[hover=true]:border-default-400",
                    "data-[open=true]:border-default-foreground",
                    "data-[focus=true]:border-default-foreground",
                    "data-[focus=true]:border-default-foreground"
                ]
            },
            underlined: {
                trigger: [
                    "!px-1",
                    "!pb-0",
                    "!gap-0",
                    "relative",
                    "box-border",
                    "border-b-medium",
                    "shadow-[0_1px_0px_0_rgba(0,0,0,0.05)]",
                    "border-default-200",
                    "!rounded-none",
                    "hover:border-default-300",
                    "after:content-['']",
                    "after:w-0",
                    "after:origin-center",
                    "after:bg-default-foreground",
                    "after:absolute",
                    "after:left-1/2",
                    "after:-translate-x-1/2",
                    "after:-bottom-[2px]",
                    "after:h-[2px]",
                    "data-[open=true]:after:w-full",
                    "data-[focus=true]:after:w-full"
                ],
                label: "group-data-[filled=true]:text-foreground"
            }
        },
        color: {
            default: {},
            primary: {},
            secondary: {},
            success: {},
            warning: {},
            danger: {}
        },
        size: {
            sm: {
                label: "text-tiny",
                trigger: "h-8 min-h-8 px-2 rounded-small",
                value: "text-small"
            },
            md: {
                trigger: "h-10 min-h-10 rounded-medium",
                value: "text-small"
            },
            lg: {
                trigger: "h-12 min-h-12 rounded-large",
                value: "text-medium"
            }
        },
        radius: {
            none: {
                trigger: "rounded-none"
            },
            sm: {
                trigger: "rounded-small"
            },
            md: {
                trigger: "rounded-medium"
            },
            lg: {
                trigger: "rounded-large"
            },
            full: {
                trigger: "rounded-full"
            }
        },
        labelPlacement: {
            outside: {
                base: "flex flex-col"
            },
            "outside-left": {
                base: "flex-row items-center flex-nowrap items-start",
                label: "relative pr-2 rtl:pl-2 rtl:pr-[unset] text-foreground"
            },
            inside: {
                label: "text-tiny cursor-pointer",
                trigger: "flex-col items-start justify-center gap-0"
            }
        },
        fullWidth: {
            true: {
                base: "w-full"
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none",
                trigger: "pointer-events-none"
            }
        },
        isInvalid: {
            true: {
                label: "!text-danger",
                value: "!text-danger",
                selectorIcon: "text-danger"
            }
        },
        isRequired: {
            true: {
                label: "after:content-['*'] after:text-danger after:ml-0.5"
            }
        },
        isMultiline: {
            true: {
                label: "relative",
                trigger: "!h-auto"
            },
            false: {
                value: "truncate"
            }
        },
        disableAnimation: {
            true: {
                trigger: "after:transition-none",
                base: "transition-none",
                label: "transition-none",
                selectorIcon: "transition-none"
            },
            false: {
                base: "transition-background motion-reduce:transition-none !duration-150",
                label: [
                    "will-change-auto",
                    "origin-top-left",
                    "rtl:origin-top-right",
                    "!duration-200",
                    "!ease-out",
                    "transition-[transform,color,left,opacity]",
                    "motion-reduce:transition-none"
                ],
                selectorIcon: "transition-transform duration-150 ease motion-reduce:transition-none"
            }
        },
        disableSelectorIconRotation: {
            true: {},
            false: {
                selectorIcon: "data-[open=true]:rotate-180"
            }
        }
    },
    defaultVariants: {
        variant: "flat",
        color: "default",
        size: "md",
        labelPlacement: "inside",
        fullWidth: true,
        isDisabled: false,
        isMultiline: false,
        disableSelectorIconRotation: false
    },
    compoundVariants: [
        {
            variant: "flat",
            color: "default",
            class: {
                value: "group-data-[has-value=true]:text-default-foreground"
            }
        },
        {
            variant: "flat",
            color: "primary",
            class: {
                trigger: [
                    "bg-primary-50",
                    "text-primary",
                    "data-[hover=true]:bg-primary-100",
                    "group-data-[focus=true]:bg-primary-50"
                ],
                value: "text-primary",
                label: "text-primary"
            }
        },
        {
            variant: "flat",
            color: "secondary",
            class: {
                trigger: [
                    "bg-secondary-50",
                    "text-secondary",
                    "data-[hover=true]:bg-secondary-100",
                    "group-data-[focus=true]:bg-secondary-50"
                ],
                value: "text-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "flat",
            color: "success",
            class: {
                trigger: [
                    "bg-success-50",
                    "text-success-600",
                    "dark:text-success",
                    "data-[hover=true]:bg-success-100",
                    "group-data-[focus=true]:bg-success-50"
                ],
                value: "text-success-600 dark:text-success",
                label: "text-success-600 dark:text-success"
            }
        },
        {
            variant: "flat",
            color: "warning",
            class: {
                trigger: [
                    "bg-warning-50",
                    "text-warning-600",
                    "dark:text-warning",
                    "data-[hover=true]:bg-warning-100",
                    "group-data-[focus=true]:bg-warning-50"
                ],
                value: "text-warning-600 dark:text-warning",
                label: "text-warning-600 dark:text-warning"
            }
        },
        {
            variant: "flat",
            color: "danger",
            class: {
                trigger: [
                    "bg-danger-50",
                    "text-danger",
                    "dark:text-danger-500",
                    "data-[hover=true]:bg-danger-100",
                    "group-data-[focus=true]:bg-danger-50"
                ],
                value: "text-danger dark:text-danger-500",
                label: "text-danger dark:text-danger-500"
            }
        },
        {
            variant: "faded",
            color: "primary",
            class: {
                trigger: "data-[hover=true]:border-primary",
                label: "text-primary"
            }
        },
        {
            variant: "faded",
            color: "secondary",
            class: {
                trigger: "data-[hover=true]:border-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "faded",
            color: "success",
            class: {
                trigger: "data-[hover=true]:border-success",
                label: "text-success"
            }
        },
        {
            variant: "faded",
            color: "warning",
            class: {
                trigger: "data-[hover=true]:border-warning",
                label: "text-warning"
            }
        },
        {
            variant: "faded",
            color: "danger",
            class: {
                trigger: "data-[hover=true]:border-danger",
                label: "text-danger"
            }
        },
        {
            variant: "underlined",
            color: "default",
            class: {
                value: "group-data-[has-value=true]:text-foreground"
            }
        },
        {
            variant: "underlined",
            color: "primary",
            class: {
                trigger: "after:bg-primary",
                label: "text-primary"
            }
        },
        {
            variant: "underlined",
            color: "secondary",
            class: {
                trigger: "after:bg-secondary",
                label: "text-secondary"
            }
        },
        {
            variant: "underlined",
            color: "success",
            class: {
                trigger: "after:bg-success",
                label: "text-success"
            }
        },
        {
            variant: "underlined",
            color: "warning",
            class: {
                trigger: "after:bg-warning",
                label: "text-warning"
            }
        },
        {
            variant: "underlined",
            color: "danger",
            class: {
                trigger: "after:bg-danger",
                label: "text-danger"
            }
        },
        {
            variant: "bordered",
            color: "primary",
            class: {
                trigger: [
                    "data-[open=true]:border-primary",
                    "data-[focus=true]:border-primary"
                ],
                label: "text-primary"
            }
        },
        {
            variant: "bordered",
            color: "secondary",
            class: {
                trigger: [
                    "data-[open=true]:border-secondary",
                    "data-[focus=true]:border-secondary"
                ],
                label: "text-secondary"
            }
        },
        {
            variant: "bordered",
            color: "success",
            class: {
                trigger: [
                    "data-[open=true]:border-success",
                    "data-[focus=true]:border-success"
                ],
                label: "text-success"
            }
        },
        {
            variant: "bordered",
            color: "warning",
            class: {
                trigger: [
                    "data-[open=true]:border-warning",
                    "data-[focus=true]:border-warning"
                ],
                label: "text-warning"
            }
        },
        {
            variant: "bordered",
            color: "danger",
            class: {
                trigger: [
                    "data-[open=true]:border-danger",
                    "data-[focus=true]:border-danger"
                ],
                label: "text-danger"
            }
        },
        {
            labelPlacement: "inside",
            color: "default",
            class: {
                label: "group-data-[filled=true]:text-default-600"
            }
        },
        {
            labelPlacement: "outside",
            color: "default",
            class: {
                label: "group-data-[filled=true]:text-foreground"
            }
        },
        {
            radius: "full",
            size: [
                "sm"
            ],
            class: {
                trigger: "px-3"
            }
        },
        {
            radius: "full",
            size: "md",
            class: {
                trigger: "px-4"
            }
        },
        {
            radius: "full",
            size: "lg",
            class: {
                trigger: "px-5"
            }
        },
        {
            disableAnimation: false,
            variant: [
                "faded",
                "bordered"
            ],
            class: {
                trigger: "transition-colors motion-reduce:transition-none"
            }
        },
        {
            disableAnimation: false,
            variant: "underlined",
            class: {
                trigger: "after:transition-width motion-reduce:after:transition-none"
            }
        },
        {
            variant: [
                "flat",
                "faded"
            ],
            class: {
                trigger: [
                    ...(0, $9dwEN.dataFocusVisibleClasses)
                ]
            }
        },
        {
            isInvalid: true,
            variant: "flat",
            class: {
                trigger: [
                    "bg-danger-50",
                    "data-[hover=true]:bg-danger-100",
                    "group-data-[focus=true]:bg-danger-50"
                ]
            }
        },
        {
            isInvalid: true,
            variant: "bordered",
            class: {
                trigger: "!border-danger group-data-[focus=true]:border-danger"
            }
        },
        {
            isInvalid: true,
            variant: "underlined",
            class: {
                trigger: "after:bg-danger"
            }
        },
        {
            labelPlacement: "inside",
            size: "sm",
            class: {
                trigger: "h-12 min-h-12 py-1.5 px-3"
            }
        },
        {
            labelPlacement: "inside",
            size: "md",
            class: {
                trigger: "h-14 min-h-14 py-2"
            }
        },
        {
            labelPlacement: "inside",
            size: "lg",
            class: {
                label: "text-small",
                trigger: "h-16 min-h-16 py-2.5 gap-0"
            }
        },
        {
            labelPlacement: [
                "inside",
                "outside"
            ],
            class: {
                label: [
                    "group-data-[filled=true]:pointer-events-auto"
                ]
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: false,
            class: {
                base: "group relative justify-end",
                label: [
                    "pb-0",
                    "z-20",
                    "top-1/2",
                    "-translate-y-1/2",
                    "group-data-[filled=true]:left-0",
                    "rtl:group-data-[filled=true]:right-0",
                    "rtl:group-data-[filled=true]:left-[unset]"
                ]
            }
        },
        {
            labelPlacement: [
                "inside"
            ],
            class: {
                label: "group-data-[filled=true]:scale-85"
            }
        },
        {
            labelPlacement: "inside",
            size: [
                "sm",
                "md"
            ],
            class: {
                label: "text-small"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_8px)]"
                ],
                innerWrapper: "group-data-[has-label=true]:pt-4"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_6px)]"
                ],
                innerWrapper: "group-data-[has-label=true]:pt-4"
            }
        },
        {
            labelPlacement: "inside",
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_8px)]"
                ],
                innerWrapper: "group-data-[has-label=true]:pt-5"
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_8px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_6px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: [
                "faded",
                "bordered"
            ],
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_8px_-_theme(borderWidth.medium))]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "sm",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.tiny)/2_-_5px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_3.5px)]"
                ]
            }
        },
        {
            labelPlacement: "inside",
            variant: "underlined",
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "text-medium",
                    "group-data-[filled=true]:-translate-y-[calc(50%_+_theme(fontSize.small)/2_-_4px)]"
                ]
            }
        },
        {
            labelPlacement: "outside",
            size: "sm",
            isMultiline: false,
            class: {
                label: [
                    "left-2",
                    "rtl:right-2",
                    "rtl:left-[unset]",
                    "text-tiny",
                    "group-data-[filled=true]:-translate-y-[calc(100%_+_theme(fontSize.tiny)/2_+_16px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_8px)]"
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: false,
            size: "md",
            class: {
                label: [
                    "left-3",
                    "rtl:right-3",
                    "rtl:left-[unset]",
                    "text-small",
                    "group-data-[filled=true]:-translate-y-[calc(100%_+_theme(fontSize.small)/2_+_20px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_10px)]"
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: false,
            size: "lg",
            class: {
                label: [
                    "left-3",
                    "rtl:right-3",
                    "rtl:left-[unset]",
                    "text-medium",
                    "group-data-[filled=true]:-translate-y-[calc(100%_+_theme(fontSize.small)/2_+_24px)]"
                ],
                base: "data-[has-label=true]:mt-[calc(theme(fontSize.small)_+_12px)]"
            }
        },
        {
            labelPlacement: "outside",
            isMultiline: true,
            class: {
                label: "pb-1.5"
            }
        },
        {
            labelPlacement: [
                "inside",
                "outside"
            ],
            class: {
                label: [
                    "pe-2",
                    "max-w-full",
                    "text-ellipsis",
                    "overflow-hidden"
                ]
            }
        }
    ]
});

});

parcelRegister("dDDPx", function(module, exports) {

$parcel$export(module.exports, "useMultiSelect", function () { return $e05eaebac2cbd1b4$export$efbfa63d6e989c0e; });
// src/use-multiselect.ts

var $0UyBs = parcelRequire("0UyBs");

var $b6W9a = parcelRequire("b6W9a");

var $i5NOo = parcelRequire("i5NOo");

var $i24pp = parcelRequire("i24pp");

var $ekziR = parcelRequire("ekziR");

var $kdWpA = parcelRequire("kdWpA");
var $9cffb = parcelRequire("9cffb");
var $8vAG4 = parcelRequire("8vAG4");
var $ezzQB = parcelRequire("ezzQB");

var $exYeM = parcelRequire("exYeM");
function $e05eaebac2cbd1b4$export$efbfa63d6e989c0e(props, state, ref) {
    const { disallowEmptySelection: disallowEmptySelection, isDisabled: isDisabled } = props;
    const collator = (0, $0UyBs.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    const delegate = (0, $exYeM.useMemo)(()=>new (0, $ekziR.ListKeyboardDelegate)(state.collection, state.disabledKeys, null, collator), [
        state.collection,
        state.disabledKeys,
        collator
    ]);
    const { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $i24pp.useMenuTrigger)({
        isDisabled: isDisabled,
        type: "listbox"
    }, state, ref);
    const triggerOnKeyDown = (e)=>{
        if (state.selectionMode === "single") switch(e.key){
            case "ArrowLeft":
                {
                    e.preventDefault();
                    const key = state.selectedKeys.size > 0 ? delegate.getKeyAbove(state.selectedKeys.values().next().value) : delegate.getFirstKey();
                    if (key) state.setSelectedKeys([
                        key
                    ]);
                    break;
                }
            case "ArrowRight":
                {
                    e.preventDefault();
                    const key = state.selectedKeys.size > 0 ? delegate.getKeyBelow(state.selectedKeys.values().next().value) : delegate.getFirstKey();
                    if (key) state.setSelectedKeys([
                        key
                    ]);
                    break;
                }
        }
    };
    const { typeSelectProps: typeSelectProps } = (0, $ekziR.useTypeSelect)({
        keyboardDelegate: delegate,
        selectionManager: state.selectionManager,
        onTypeSelect (key) {
            state.setSelectedKeys([
                key
            ]);
        }
    });
    const { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    const { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $i5NOo.useField)({
        ...props,
        labelElementType: "span",
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    typeSelectProps.onKeyDown = typeSelectProps.onKeyDownCapture;
    delete typeSelectProps.onKeyDownCapture;
    const domProps = (0, $9cffb.filterDOMProps)(props, {
        labelable: true
    });
    const triggerProps = (0, $8vAG4.mergeProps)(typeSelectProps, menuTriggerProps, fieldProps);
    const valueId = (0, $ezzQB.useId)();
    return {
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                var _a;
                if (!props.isDisabled) {
                    (_a = ref.current) == null || _a.focus();
                    (0, $b6W9a.setInteractionModality)("keyboard");
                }
            }
        },
        triggerProps: (0, $8vAG4.mergeProps)(domProps, {
            ...triggerProps,
            onKeyDown: (0, $kdWpA.chain)(triggerProps.onKeyDown, triggerOnKeyDown, props.onKeyDown),
            onKeyUp: props.onKeyUp,
            "aria-labelledby": [
                valueId,
                domProps["aria-label"] !== void 0 ? domProps["aria-labelledby"] !== void 0 ? domProps["aria-labelledby"] : triggerProps.id : triggerProps["aria-labelledby"]
            ].join(" "),
            onFocus (e) {
                if (state.isFocused) return;
                if (props.onFocus) props.onFocus(e);
                state.setFocused(true);
            },
            onBlur (e) {
                if (state.isOpen) return;
                if (props.onBlur) props.onBlur(e);
                state.setFocused(false);
            }
        }),
        valueProps: {
            id: valueId
        },
        menuProps: {
            ...menuProps,
            disallowEmptySelection: disallowEmptySelection,
            autoFocus: state.focusStrategy || true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            onBlur: (e)=>{
                if (e.currentTarget.contains(e.relatedTarget)) return;
                if (props.onBlur) props.onBlur(e);
                state.setFocused(false);
            },
            onFocus: menuProps == null ? void 0 : menuProps.onFocus,
            "aria-labelledby": [
                fieldProps["aria-labelledby"],
                triggerProps["aria-label"] && !fieldProps["aria-labelledby"] ? triggerProps.id : null
            ].filter(Boolean).join(" ")
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}

});
parcelRegister("0UyBs", function(module, exports) {

$parcel$export(module.exports, "useCollator", function () { return $002bdf4443ecdcd1$export$a16aca283550c30d; });

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");

var $1jHkC = parcelRequire("1jHkC");
var $g2TA9 = parcelRequire("g2TA9");

var $gRRGt = parcelRequire("gRRGt");

var $dbGK4 = parcelRequire("dbGK4");

var $3PRgM = parcelRequire("3PRgM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $002bdf4443ecdcd1$var$$148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
const $002bdf4443ecdcd1$var$$148a7a147e38ea7f$var$RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $002bdf4443ecdcd1$var$$148a7a147e38ea7f$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    // @ts-ignore
    if (Intl.Locale) {
        let locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        let textInfo = typeof locale.getTextInfo === "function" ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === "rtl";
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $002bdf4443ecdcd1$var$$148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = localeString.split("-")[0];
    return $002bdf4443ecdcd1$var$$148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
const $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
function $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
    let locale = typeof window !== "undefined" && window[$002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: $002bdf4443ecdcd1$var$$148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
    };
}
let $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$currentLocale = $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
let $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$listeners = new Set();
function $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$updateLocale() {
    $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$currentLocale = $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
    for (let listener of $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$listeners)listener($002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$currentLocale);
}
function $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $aVmq3.useIsSSR)();
    let [defaultLocale, setDefaultLocale] = (0, $exYeM.useState)($002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$currentLocale);
    (0, $exYeM.useEffect)(()=>{
        if ($002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$updateLocale);
        $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}
const $002bdf4443ecdcd1$var$$18f2051aff69b9bf$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
function $002bdf4443ecdcd1$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    let defaultLocale = $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
    let value = locale ? {
        locale: locale,
        direction: $002bdf4443ecdcd1$var$$148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
    } : defaultLocale;
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($002bdf4443ecdcd1$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
function $002bdf4443ecdcd1$export$43bb16f9c6d9e3f7() {
    let defaultLocale = $002bdf4443ecdcd1$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
    let context = (0, $exYeM.useContext)($002bdf4443ecdcd1$var$$18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}
var $002bdf4443ecdcd1$var$$2aa2084a6c2b6b4f$exports = {};
"use strict";
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $002bdf4443ecdcd1$var$$fca6afa0e843324b$var$cache = new WeakMap();
function $002bdf4443ecdcd1$var$$fca6afa0e843324b$var$getCachedDictionary(strings) {
    let dictionary = $002bdf4443ecdcd1$var$$fca6afa0e843324b$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, $1jHkC.LocalizedStringDictionary)(strings);
        $002bdf4443ecdcd1$var$$fca6afa0e843324b$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $002bdf4443ecdcd1$export$87b761675e8eaa10(strings, packageName) {
    return packageName && (0, $1jHkC.LocalizedStringDictionary).getGlobalDictionaryForPackage(packageName) || $002bdf4443ecdcd1$var$$fca6afa0e843324b$var$getCachedDictionary(strings);
}
function $002bdf4443ecdcd1$export$f12b703ca79dfbb1(strings, packageName) {
    let { locale: locale } = $002bdf4443ecdcd1$export$43bb16f9c6d9e3f7();
    let dictionary = $002bdf4443ecdcd1$export$87b761675e8eaa10(strings, packageName);
    return (0, $exYeM.useMemo)(()=>new (0, $g2TA9.LocalizedStringFormatter)(locale, dictionary), [
        locale,
        dictionary
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $002bdf4443ecdcd1$export$a2f47a3d2973640(options = {}) {
    let { locale: locale } = $002bdf4443ecdcd1$export$43bb16f9c6d9e3f7();
    return (0, $exYeM.useMemo)(()=>new Intl.ListFormat(locale, options), [
        locale,
        options
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $002bdf4443ecdcd1$export$85fd5fdf27bacc79(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    options = (0, $dbGK4.useDeepMemo)(options !== null && options !== void 0 ? options : {}, $002bdf4443ecdcd1$var$$896ba0a80a8f4d36$var$isEqual);
    let { locale: locale } = $002bdf4443ecdcd1$export$43bb16f9c6d9e3f7();
    return (0, $exYeM.useMemo)(()=>new (0, $gRRGt.DateFormatter)(locale, options), [
        locale,
        options
    ]);
}
function $002bdf4443ecdcd1$var$$896ba0a80a8f4d36$var$isEqual(a, b) {
    if (a === b) return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $002bdf4443ecdcd1$export$b7a616150fdb9f44(options = {}) {
    let { locale: locale } = $002bdf4443ecdcd1$export$43bb16f9c6d9e3f7();
    return (0, $exYeM.useMemo)(()=>new (0, $3PRgM.NumberFormatter)(locale, options), [
        locale,
        options
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $002bdf4443ecdcd1$var$$325a3faab7a68acd$var$cache = new Map();
function $002bdf4443ecdcd1$export$a16aca283550c30d(options) {
    let { locale: locale } = $002bdf4443ecdcd1$export$43bb16f9c6d9e3f7();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($002bdf4443ecdcd1$var$$325a3faab7a68acd$var$cache.has(cacheKey)) return $002bdf4443ecdcd1$var$$325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $002bdf4443ecdcd1$var$$325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $002bdf4443ecdcd1$export$3274cf84b703fff(options) {
    let collator = $002bdf4443ecdcd1$export$a16aca283550c30d({
        usage: "search",
        ...options
    });
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    let startsWith = (0, $exYeM.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        // Normalize both strings so we can slice safely
        // TODO: take into account the ignorePunctuation option as well...
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        return collator.compare(string.slice(0, substring.length), substring) === 0;
    }, [
        collator
    ]);
    let endsWith = (0, $exYeM.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        return collator.compare(string.slice(-substring.length), substring) === 0;
    }, [
        collator
    ]);
    let contains = (0, $exYeM.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        let scan = 0;
        let sliceLen = substring.length;
        for(; scan + sliceLen <= string.length; scan++){
            let slice = string.slice(scan, scan + sliceLen);
            if (collator.compare(substring, slice) === 0) return true;
        }
        return false;
    }, [
        collator
    ]);
    return (0, $exYeM.useMemo)(()=>({
            startsWith: startsWith,
            endsWith: endsWith,
            contains: contains
        }), [
        startsWith,
        endsWith,
        contains
    ]);
}

});
parcelRegister("gRRGt", function(module, exports) {

$parcel$export(module.exports, "DateFormatter", function () { return $c47b3d21f527ea2f$export$ad991b66133851cf; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$formatterCache = new Map();
class $c47b3d21f527ea2f$export$ad991b66133851cf {
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === "function") return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === "function") return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if ($c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12";
        }
        // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
        // https://bugs.webkit.org/show_bug.cgi?id=241564
        if (resolvedOptions.calendar === "ethiopic-amete-alem") resolvedOptions.calendar = "ethioaa";
        return resolvedOptions;
    }
    constructor(locale, options = {}){
        this.formatter = $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options);
        this.options = options;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: "h11"
    },
    false: {}
};
function $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === "boolean" && $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$hour12Preferences[String(options.hour12)][locale.split("-")[0]];
        let defaultHourCycle = options.hour12 ? "h12" : "h23";
        options.hourCycle = pref !== null && pref !== void 0 ? pref : defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$formatterCache.has(cacheKey)) return $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = null;
function $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior() {
    if ($c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior == null) $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === "24";
    return $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior;
}
let $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = null;
function $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle() {
    if ($c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle == null) $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat("fr", {
        hour: "numeric",
        hour12: false
    }).resolvedOptions().hourCycle === "h12";
    return $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle;
}
function $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, "");
    locale += (locale.includes("-u-") ? "" : "-u") + "-nu-latn";
    let formatter = $c47b3d21f527ea2f$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === "hour").value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === "hour").value, 10);
    if (min === 0 && max === 23) return "h23";
    if (min === 24 && max === 23) return "h24";
    if (min === 0 && max === 11) return "h11";
    if (min === 12 && max === 11) return "h12";
    throw new Error("Unexpected hour cycle result");
}

});

parcelRegister("dbGK4", function(module, exports) {

$parcel$export(module.exports, "useDeepMemo", function () { return $999d7520e17f298c$export$722debc0e56fea39; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ function $999d7520e17f298c$export$722debc0e56fea39(value, isEqual) {
    // Using a ref during render is ok here because it's only an optimization – both values are equivalent.
    // If a render is thrown away, it'll still work the same no matter if the next render is the same or not.
    let lastValue = (0, $exYeM.useRef)(null);
    if (value && lastValue.current && isEqual(value, lastValue.current)) value = lastValue.current;
    lastValue.current = value;
    return value;
}

});

parcelRegister("3PRgM", function(module, exports) {

$parcel$export(module.exports, "NumberFormatter", function () { return $2caf74beb16e6003$export$cc77c4ff7e8673c5; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$formatterCache = new Map();
let $2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
    // @ts-ignore
    $2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat("de-DE", {
        signDisplay: "exceptZero"
    }).resolvedOptions().signDisplay === "exceptZero";
// eslint-disable-next-line no-empty
} catch (e) {}
let $2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$supportsUnit = false;
try {
    // @ts-ignore
    $2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat("de-DE", {
        style: "unit",
        unit: "degree"
    }).resolvedOptions().style === "unit";
// eslint-disable-next-line no-empty
} catch (e) {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
const $2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            "ja-JP": " \u5EA6",
            "zh-TW": "\u5EA6",
            "sl-SI": " \xb0"
        }
    }
};
class $2caf74beb16e6003$export$cc77c4ff7e8673c5 {
    /** Formats a number value as a string, according to the locale and options provided to the constructor. */ format(value) {
        let res = "";
        if (!$2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) res = $2caf74beb16e6003$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
        else res = this.numberFormatter.format(value);
        if (this.options.style === "unit" && !$2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$supportsUnit) {
            var _UNITS_unit;
            let { unit: unit, unitDisplay: unitDisplay = "short", locale: locale } = this.resolvedOptions();
            if (!unit) return res;
            let values = (_UNITS_unit = $2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay];
            res += values[locale] || values.default;
        }
        return res;
    }
    /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ formatToParts(value) {
        // TODO: implement signDisplay for formatToParts
        // @ts-ignore
        return this.numberFormatter.formatToParts(value);
    }
    /** Formats a number range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRange === "function") return this.numberFormatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.format(start)} \u{2013} ${this.format(end)}`;
    }
    /** Formats a number range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRangeToParts === "function") return this.numberFormatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.numberFormatter.formatToParts(start);
        let endParts = this.numberFormatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let options = this.numberFormatter.resolvedOptions();
        if (!$2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) options = {
            ...options,
            signDisplay: this.options.signDisplay
        };
        if (!$2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$supportsUnit && this.options.style === "unit") options = {
            ...options,
            style: "unit",
            unit: this.options.unit,
            unitDisplay: this.options.unitDisplay
        };
        return options;
    }
    constructor(locale, options = {}){
        this.numberFormatter = $2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
}
function $2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options = {}) {
    let { numberingSystem: numberingSystem } = options;
    if (numberingSystem && locale.includes("-nu-")) {
        if (!locale.includes("-u-")) locale += "-u-";
        locale += `-nu-${numberingSystem}`;
    }
    if (options.style === "unit" && !$2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$supportsUnit) {
        var _UNITS_unit;
        let { unit: unit, unitDisplay: unitDisplay = "short" } = options;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((_UNITS_unit = $2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay])) throw new Error(`Unsupported unit ${unit} with unitDisplay = ${unitDisplay}`);
        options = {
            ...options,
            style: "decimal"
        };
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$formatterCache.has(cacheKey)) return $2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.NumberFormat(locale, options);
    $2caf74beb16e6003$var$$488c6ddbf4ef74c2$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $2caf74beb16e6003$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === "auto") return numberFormat.format(num);
    else if (signDisplay === "never") return numberFormat.format(Math.abs(num));
    else {
        let needsPositiveSign = false;
        if (signDisplay === "always") needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === "exceptZero") {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            let negative = numberFormat.format(-num);
            let noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            let minus = negative.replace(noSign, "").replace(/\u200e|\u061C/, "");
            if ([
                ...minus
            ].length !== 1) console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case");
            let positive = negative.replace(noSign, "!!!").replace(minus, "+").replace("!!!", noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}

});


parcelRegister("i5NOo", function(module, exports) {

$parcel$export(module.exports, "useField", function () { return $d2bf552fd220e0e5$export$294aa081a6c6f55d; });

var $8vAG4 = parcelRequire("8vAG4");
var $ezzQB = parcelRequire("ezzQB");
var $ed4mS = parcelRequire("ed4mS");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d2bf552fd220e0e5$export$8467354a121f1b9f(props) {
    let { id: id, label: label, "aria-labelledby": ariaLabelledby, "aria-label": ariaLabel, labelElementType: labelElementType = "label" } = props;
    id = (0, $ezzQB.useId)(id);
    let labelId = (0, $ezzQB.useId)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === "label" ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
    let fieldProps = (0, $ed4mS.useLabels)({
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}
function $d2bf552fd220e0e5$export$294aa081a6c6f55d(props) {
    let { description: description, errorMessage: errorMessage, isInvalid: isInvalid, validationState: validationState } = props;
    let { labelProps: labelProps, fieldProps: fieldProps } = $d2bf552fd220e0e5$export$8467354a121f1b9f(props);
    let descriptionId = (0, $ezzQB.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    let errorMessageId = (0, $ezzQB.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, $8vAG4.mergeProps)(fieldProps, {
        "aria-describedby": [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props["aria-describedby"]
        ].filter(Boolean).join(" ") || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}

});

parcelRegister("i24pp", function(module, exports) {

$parcel$export(module.exports, "useMenuTrigger", function () { return $d20bd561c19865b3$export$dc9c12ed27dd1b49; });

var $2GUus = parcelRequire("2GUus");

var $dvbMq = parcelRequire("dvbMq");

var $eUsmq = parcelRequire("eUsmq");

var $3ap0M = parcelRequire("3ap0M");

var $aPyEQ = parcelRequire("aPyEQ");

var $Jyk9X = parcelRequire("Jyk9X");

var $iTXIb = parcelRequire("iTXIb");

var $b2UX8 = parcelRequire("b2UX8");

var $dzY4b = parcelRequire("dzY4b");

var $eCln3 = parcelRequire("eCln3");

var $gW5Qd = parcelRequire("gW5Qd");

var $akYA4 = parcelRequire("akYA4");

var $kyZ9G = parcelRequire("kyZ9G");

var $c4idF = parcelRequire("c4idF");

var $iQxb9 = parcelRequire("iQxb9");

var $W8amT = parcelRequire("W8amT");

var $4jvxv = parcelRequire("4jvxv");

var $cRjKh = parcelRequire("cRjKh");

var $751N8 = parcelRequire("751N8");

var $6kMEI = parcelRequire("6kMEI");

var $aRbhB = parcelRequire("aRbhB");

var $hcZb1 = parcelRequire("hcZb1");

var $5GtBQ = parcelRequire("5GtBQ");

var $kJBV1 = parcelRequire("kJBV1");

var $6zkis = parcelRequire("6zkis");

var $dtRap = parcelRequire("dtRap");

var $crMOm = parcelRequire("crMOm");

var $zIf7E = parcelRequire("zIf7E");

var $b1DQN = parcelRequire("b1DQN");

var $f3Q9d = parcelRequire("f3Q9d");

var $kgktt = parcelRequire("kgktt");

var $4oJsT = parcelRequire("4oJsT");

var $61vK7 = parcelRequire("61vK7");

var $hbJVs = parcelRequire("hbJVs");

var $9cffb = parcelRequire("9cffb");
var $8vAG4 = parcelRequire("8vAG4");
var $4sExG = parcelRequire("4sExG");
var $ezzQB = parcelRequire("ezzQB");
var $71dP2 = parcelRequire("71dP2");
var $gEiSh = parcelRequire("gEiSh");
var $h6krv = parcelRequire("h6krv");

var $9ljKT = parcelRequire("9ljKT");
var $6FcvQ = parcelRequire("6FcvQ");

var $hXX5l = parcelRequire("hXX5l");
var $glM3t = parcelRequire("glM3t");
var $39uZ6 = parcelRequire("39uZ6");
var $59ucR = parcelRequire("59ucR");
var $hfLMA = parcelRequire("hfLMA");
var $3xNbd = parcelRequire("3xNbd");

var $6z6dF = parcelRequire("6z6dF");

var $2Ya72 = parcelRequire("2Ya72");
var $1sTcE = parcelRequire("1sTcE");

var $jXecf = parcelRequire("jXecf");

var $exYeM = parcelRequire("exYeM");
function $d20bd561c19865b3$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $d20bd561c19865b3$var$$2cbb7ca666678a14$exports = {};
$d20bd561c19865b3$var$$2cbb7ca666678a14$exports = {
    "ar-AE": (0, $2GUus.default),
    "bg-BG": (0, $dvbMq.default),
    "cs-CZ": (0, $eUsmq.default),
    "da-DK": (0, $3ap0M.default),
    "de-DE": (0, $aPyEQ.default),
    "el-GR": (0, $Jyk9X.default),
    "en-US": (0, $iTXIb.default),
    "es-ES": (0, $b2UX8.default),
    "et-EE": (0, $dzY4b.default),
    "fi-FI": (0, $eCln3.default),
    "fr-FR": (0, $gW5Qd.default),
    "he-IL": (0, $akYA4.default),
    "hr-HR": (0, $kyZ9G.default),
    "hu-HU": (0, $c4idF.default),
    "it-IT": (0, $iQxb9.default),
    "ja-JP": (0, $W8amT.default),
    "ko-KR": (0, $4jvxv.default),
    "lt-LT": (0, $cRjKh.default),
    "lv-LV": (0, $751N8.default),
    "nb-NO": (0, $6kMEI.default),
    "nl-NL": (0, $aRbhB.default),
    "pl-PL": (0, $hcZb1.default),
    "pt-BR": (0, $5GtBQ.default),
    "pt-PT": (0, $kJBV1.default),
    "ro-RO": (0, $6zkis.default),
    "ru-RU": (0, $dtRap.default),
    "sk-SK": (0, $crMOm.default),
    "sl-SI": (0, $zIf7E.default),
    "sr-SP": (0, $b1DQN.default),
    "sv-SE": (0, $f3Q9d.default),
    "tr-TR": (0, $kgktt.default),
    "uk-UA": (0, $4oJsT.default),
    "zh-CN": (0, $61vK7.default),
    "zh-TW": (0, $hbJVs.default)
};
function $d20bd561c19865b3$export$dc9c12ed27dd1b49(props, state, ref) {
    let { type: type = "menu", isDisabled: isDisabled, trigger: trigger = "press" } = props;
    let menuTriggerId = (0, $ezzQB.useId)();
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $6z6dF.useOverlayTrigger)({
        type: type
    }, state, ref);
    let onKeyDown = (e)=>{
        if (isDisabled) return;
        if (trigger === "longPress" && !e.altKey) return;
        if (ref && ref.current) switch(e.key){
            case "Enter":
            case " ":
                if (trigger === "longPress") return;
            // fallthrough
            case "ArrowDown":
                // Stop propagation, unless it would already be handled by useKeyboard.
                if (!("continuePropagation" in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle("first");
                break;
            case "ArrowUp":
                if (!("continuePropagation" in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle("last");
                break;
            default:
                // Allow other keys.
                if ("continuePropagation" in e) e.continuePropagation();
        }
    };
    let stringFormatter = (0, $6FcvQ.useLocalizedStringFormatter)(/*@__PURE__*/ $d20bd561c19865b3$var$$parcel$interopDefault($d20bd561c19865b3$var$$2cbb7ca666678a14$exports), "@react-aria/menu");
    let { longPressProps: longPressProps } = (0, $hfLMA.useLongPress)({
        isDisabled: isDisabled || trigger !== "longPress",
        accessibilityDescription: stringFormatter.format("longPressMessage"),
        onLongPressStart () {
            state.close();
        },
        onLongPress () {
            state.open("first");
        }
    });
    let pressProps = {
        onPressStart (e) {
            // For consistency with native, open the menu on mouse/key down, but touch up.
            if (e.pointerType !== "touch" && e.pointerType !== "keyboard" && !isDisabled) // Otherwise, the menu itself will be focused.
            state.toggle(e.pointerType === "virtual" ? "first" : null);
        },
        onPress (e) {
            if (e.pointerType === "touch" && !isDisabled) state.toggle();
        }
    };
    // omit onPress from triggerProps since we override it above.
    delete triggerProps.onPress;
    return {
        menuTriggerProps: {
            ...triggerProps,
            ...trigger === "press" ? pressProps : longPressProps,
            id: menuTriggerId,
            onKeyDown: onKeyDown
        },
        menuProps: {
            ...overlayProps,
            "aria-labelledby": menuTriggerId,
            autoFocus: state.focusStrategy || true,
            onClose: state.close
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d20bd561c19865b3$var$$d5336fe17ce95402$export$6f49b4016bfc8d56 = new WeakMap();
function $d20bd561c19865b3$export$38eaa17faae8f579(props, state, ref) {
    let { shouldFocusWrap: shouldFocusWrap = true, onKeyDown: onKeyDown, onKeyUp: onKeyUp, ...otherProps } = props;
    if (!props["aria-label"] && !props["aria-labelledby"]) console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
    let domProps = (0, $9cffb.filterDOMProps)(props, {
        labelable: true
    });
    let { listProps: listProps } = (0, $1sTcE.useSelectableList)({
        ...otherProps,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        shouldFocusWrap: shouldFocusWrap,
        linkBehavior: "override"
    });
    $d20bd561c19865b3$var$$d5336fe17ce95402$export$6f49b4016bfc8d56.set(state, {
        onClose: props.onClose,
        onAction: props.onAction
    });
    return {
        menuProps: (0, $8vAG4.mergeProps)(domProps, {
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        }, {
            role: "menu",
            ...listProps,
            onKeyDown: (e)=>{
                // don't clear the menu selected keys if the user is presses escape since escape closes the menu
                if (e.key !== "Escape") listProps.onKeyDown(e);
            }
        })
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d20bd561c19865b3$export$9d32628fc2aea7da(props, state, ref) {
    var _item_props;
    let { key: key, closeOnSelect: closeOnSelect, isVirtualized: isVirtualized, "aria-haspopup": hasPopup, onPressStart: pressStartProp, onPressUp: pressUpProp, onPress: onPress, onPressChange: onPressChange, onPressEnd: onPressEnd, onHoverStart: hoverStartProp, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onFocus: onFocus, onFocusChange: onFocusChange, onBlur: onBlur } = props;
    let isTrigger = !!hasPopup;
    var _props_isDisabled;
    let isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : state.disabledKeys.has(key);
    var _props_isSelected;
    let isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : state.selectionManager.isSelected(key);
    let data = $d20bd561c19865b3$var$$d5336fe17ce95402$export$6f49b4016bfc8d56.get(state);
    let onClose = props.onClose || data.onClose;
    let onAction = isTrigger ? ()=>{} : props.onAction || data.onAction;
    let router = (0, $h6krv.useRouter)();
    let performAction = (e)=>{
        if (onAction) onAction(key);
        if (e.target instanceof HTMLAnchorElement) router.open(e.target, e);
    };
    let role = "menuitem";
    if (!isTrigger) {
        if (state.selectionManager.selectionMode === "single") role = "menuitemradio";
        else if (state.selectionManager.selectionMode === "multiple") role = "menuitemcheckbox";
    }
    let labelId = (0, $ezzQB.useSlotId)();
    let descriptionId = (0, $ezzQB.useSlotId)();
    let keyboardId = (0, $ezzQB.useSlotId)();
    let ariaProps = {
        "aria-disabled": isDisabled || undefined,
        role: role,
        "aria-label": props["aria-label"],
        "aria-labelledby": labelId,
        "aria-describedby": [
            descriptionId,
            keyboardId
        ].filter(Boolean).join(" ") || undefined,
        "aria-controls": props["aria-controls"],
        "aria-haspopup": hasPopup,
        "aria-expanded": props["aria-expanded"]
    };
    if (state.selectionManager.selectionMode !== "none" && !isTrigger) ariaProps["aria-checked"] = isSelected;
    let item = state.collection.getItem(key);
    if (isVirtualized) {
        ariaProps["aria-posinset"] = item === null || item === void 0 ? void 0 : item.index;
        ariaProps["aria-setsize"] = (0, $jXecf.getItemCount)(state.collection);
    }
    let onPressStart = (e)=>{
        if (e.pointerType === "keyboard") performAction(e);
        pressStartProp === null || pressStartProp === void 0 || pressStartProp(e);
    };
    let onPressUp = (e)=>{
        if (e.pointerType !== "keyboard") {
            performAction(e);
            // Pressing a menu item should close by default in single selection mode but not multiple
            // selection mode, except if overridden by the closeOnSelect prop.
            if (!isTrigger && onClose && (closeOnSelect !== null && closeOnSelect !== void 0 ? closeOnSelect : state.selectionManager.selectionMode !== "multiple" || state.selectionManager.isLink(key))) onClose();
        }
        pressUpProp === null || pressUpProp === void 0 || pressUpProp(e);
    };
    let { itemProps: itemProps, isFocused: isFocused } = (0, $2Ya72.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: true,
        allowsDifferentPressOrigin: true,
        // Disable all handling of links in useSelectable item
        // because we handle it ourselves. The behavior of menus
        // is slightly different from other collections because
        // actions are performed on key down rather than key up.
        linkBehavior: "none"
    });
    let { pressProps: pressProps, isPressed: isPressed } = (0, $3xNbd.usePress)({
        onPressStart: onPressStart,
        onPress: onPress,
        onPressUp: onPressUp,
        onPressChange: onPressChange,
        onPressEnd: onPressEnd,
        isDisabled: isDisabled
    });
    let { hoverProps: hoverProps } = (0, $39uZ6.useHover)({
        isDisabled: isDisabled,
        onHoverStart (e) {
            if (!(0, $hXX5l.isFocusVisible)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
            hoverStartProp === null || hoverStartProp === void 0 || hoverStartProp(e);
        },
        onHoverChange: onHoverChange,
        onHoverEnd: onHoverEnd
    });
    let { keyboardProps: keyboardProps } = (0, $59ucR.useKeyboard)({
        onKeyDown: (e)=>{
            // Ignore repeating events, which may have started on the menu trigger before moving
            // focus to the menu item. We want to wait for a second complete key press sequence.
            if (e.repeat) {
                e.continuePropagation();
                return;
            }
            switch(e.key){
                case " ":
                    if (!isDisabled && state.selectionManager.selectionMode === "none" && !isTrigger && closeOnSelect !== false && onClose) onClose();
                    break;
                case "Enter":
                    // The Enter key should always close on select, except if overridden.
                    if (!isDisabled && closeOnSelect !== false && !isTrigger && onClose) onClose();
                    break;
                default:
                    if (!isTrigger) e.continuePropagation();
                    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
                    break;
            }
        },
        onKeyUp: onKeyUp
    });
    let { focusProps: focusProps } = (0, $glM3t.useFocus)({
        onBlur: onBlur,
        onFocus: onFocus,
        onFocusChange: onFocusChange
    });
    let domProps = (0, $9cffb.filterDOMProps)(item.props, {
        isLink: !!(item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.href)
    });
    delete domProps.id;
    return {
        menuItemProps: {
            ...ariaProps,
            ...(0, $8vAG4.mergeProps)(domProps, isTrigger ? {
                onFocus: itemProps.onFocus
            } : itemProps, pressProps, hoverProps, keyboardProps, focusProps),
            tabIndex: itemProps.tabIndex != null ? -1 : undefined
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        keyboardShortcutProps: {
            id: keyboardId
        },
        isFocused: isFocused,
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d20bd561c19865b3$export$73f7a44322579622(props) {
    let { heading: heading, "aria-label": ariaLabel } = props;
    let headingId = (0, $ezzQB.useId)();
    return {
        itemProps: {
            role: "presentation"
        },
        headingProps: heading ? {
            // Techincally, menus cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a label for the nested group.
            id: headingId,
            role: "presentation"
        } : {},
        groupProps: {
            role: "group",
            "aria-label": ariaLabel,
            "aria-labelledby": heading ? headingId : undefined
        }
    };
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d20bd561c19865b3$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS = 2;
const $d20bd561c19865b3$var$$d275435c250248f8$var$THROTTLE_TIME = 50;
const $d20bd561c19865b3$var$$d275435c250248f8$var$TIMEOUT_TIME = 1000;
const $d20bd561c19865b3$var$$d275435c250248f8$var$ANGLE_PADDING = Math.PI / 12; // 15°
function $d20bd561c19865b3$var$$d275435c250248f8$export$85ec83e04c95f50a(options) {
    let { menuRef: menuRef, submenuRef: submenuRef, isOpen: isOpen, isDisabled: isDisabled } = options;
    let prevPointerPos = (0, $exYeM.useRef)();
    let submenuRect = (0, $exYeM.useRef)();
    let lastProcessedTime = (0, $exYeM.useRef)(0);
    let timeout = (0, $exYeM.useRef)();
    let autoCloseTimeout = (0, $exYeM.useRef)();
    let submenuSide = (0, $exYeM.useRef)();
    let movementsTowardsSubmenuCount = (0, $exYeM.useRef)(2);
    let [preventPointerEvents, setPreventPointerEvents] = (0, $exYeM.useState)(false);
    let updateSubmenuRect = ()=>{
        if (submenuRef.current) {
            submenuRect.current = submenuRef.current.getBoundingClientRect();
            submenuSide.current = undefined;
        }
    };
    (0, $gEiSh.useResizeObserver)({
        ref: submenuRef,
        onResize: updateSubmenuRect
    });
    let reset = ()=>{
        setPreventPointerEvents(false);
        movementsTowardsSubmenuCount.current = $d20bd561c19865b3$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS;
    };
    let modality = (0, $hXX5l.useInteractionModality)();
    (0, $exYeM.useEffect)(()=>{
        if (preventPointerEvents && menuRef.current) menuRef.current.style.pointerEvents = "none";
        else menuRef.current.style.pointerEvents = "";
    }, [
        menuRef,
        preventPointerEvents
    ]);
    (0, $exYeM.useEffect)(()=>{
        let submenu = submenuRef.current;
        let menu = menuRef.current;
        if (isDisabled || !submenu || !isOpen || modality !== "pointer") {
            reset();
            return;
        }
        submenuRect.current = submenu.getBoundingClientRect();
        let onPointerMove = (e)=>{
            if (e.pointerType === "touch" || e.pointerType === "pen") return;
            let currentTime = Date.now();
            // Throttle
            if (currentTime - lastProcessedTime.current < $d20bd561c19865b3$var$$d275435c250248f8$var$THROTTLE_TIME) return;
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            let { clientX: mouseX, clientY: mouseY } = e;
            if (!prevPointerPos.current) {
                prevPointerPos.current = {
                    x: mouseX,
                    y: mouseY
                };
                return;
            }
            if (!submenuRect.current) return;
            if (!submenuSide.current) submenuSide.current = mouseX > submenuRect.current.right ? "left" : "right";
            // Pointer is outside of parent menu
            if (mouseX < menu.getBoundingClientRect().left || mouseX > menu.getBoundingClientRect().right || mouseY < menu.getBoundingClientRect().top || mouseY > menu.getBoundingClientRect().bottom) {
                reset();
                return;
            }
            /* Check if pointer is moving towards submenu.
        Uses the 2-argument arctangent (https://en.wikipedia.org/wiki/Atan2) to calculate:
          - angle between previous pointer and top of submenu
          - angle between previous pointer and bottom of submenu
          - angle between previous pointer and current pointer (delta)
        If the pointer delta angle value is between the top and bottom angle values, we know the pointer is moving towards the submenu.
      */ let prevMouseX = prevPointerPos.current.x;
            let prevMouseY = prevPointerPos.current.y;
            let toSubmenuX = submenuSide.current === "right" ? submenuRect.current.left - prevMouseX : prevMouseX - submenuRect.current.right;
            let angleTop = Math.atan2(prevMouseY - submenuRect.current.top, toSubmenuX) + $d20bd561c19865b3$var$$d275435c250248f8$var$ANGLE_PADDING;
            let angleBottom = Math.atan2(prevMouseY - submenuRect.current.bottom, toSubmenuX) - $d20bd561c19865b3$var$$d275435c250248f8$var$ANGLE_PADDING;
            let anglePointer = Math.atan2(prevMouseY - mouseY, submenuSide.current === "left" ? -(mouseX - prevMouseX) : mouseX - prevMouseX);
            let isMovingTowardsSubmenu = anglePointer < angleTop && anglePointer > angleBottom;
            movementsTowardsSubmenuCount.current = isMovingTowardsSubmenu ? Math.min(movementsTowardsSubmenuCount.current + 1, $d20bd561c19865b3$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS) : Math.max(movementsTowardsSubmenuCount.current - 1, 0);
            if (movementsTowardsSubmenuCount.current >= $d20bd561c19865b3$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS) setPreventPointerEvents(true);
            else setPreventPointerEvents(false);
            lastProcessedTime.current = currentTime;
            prevPointerPos.current = {
                x: mouseX,
                y: mouseY
            };
            // If the pointer is moving towards the submenu, start a timeout to close if no other movements are made after 500ms.
            if (isMovingTowardsSubmenu) timeout.current = setTimeout(()=>{
                reset();
                autoCloseTimeout.current = setTimeout(()=>{
                    // Fire a pointerover event to trigger the menu to close.
                    // Wait until pointer-events:none is no longer applied
                    let target = document.elementFromPoint(mouseX, mouseY);
                    if (target && menu.contains(target)) target.dispatchEvent(new PointerEvent("pointerover", {
                        bubbles: true,
                        cancelable: true
                    }));
                }, 100);
            }, $d20bd561c19865b3$var$$d275435c250248f8$var$TIMEOUT_TIME);
        };
        window.addEventListener("pointermove", onPointerMove);
        return ()=>{
            window.removeEventListener("pointermove", onPointerMove);
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            movementsTowardsSubmenuCount.current = $d20bd561c19865b3$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS;
        };
    }, [
        isDisabled,
        isOpen,
        menuRef,
        modality,
        setPreventPointerEvents,
        submenuRef
    ]);
}
function $d20bd561c19865b3$export$3819f8ee9f4ce664(props, state, ref) {
    let { parentMenuRef: parentMenuRef, submenuRef: submenuRef, type: type = "menu", isDisabled: isDisabled, node: node, delay: delay = 200 } = props;
    let submenuTriggerId = (0, $ezzQB.useId)();
    let overlayId = (0, $ezzQB.useId)();
    let { direction: direction } = (0, $9ljKT.useLocale)();
    let openTimeout = (0, $exYeM.useRef)();
    let cancelOpenTimeout = (0, $exYeM.useCallback)(()=>{
        if (openTimeout.current) {
            clearTimeout(openTimeout.current);
            openTimeout.current = undefined;
        }
    }, [
        openTimeout
    ]);
    let onSubmenuOpen = (0, $4sExG.useEffectEvent)((focusStrategy)=>{
        cancelOpenTimeout();
        state.open(focusStrategy);
    });
    let onSubmenuClose = (0, $4sExG.useEffectEvent)(()=>{
        cancelOpenTimeout();
        state.close();
    });
    (0, $71dP2.useLayoutEffect)(()=>{
        return ()=>{
            cancelOpenTimeout();
        };
    }, [
        cancelOpenTimeout
    ]);
    let submenuKeyDown = (e)=>{
        switch(e.key){
            case "ArrowLeft":
                if (direction === "ltr" && e.currentTarget.contains(e.target)) {
                    e.stopPropagation();
                    onSubmenuClose();
                    ref.current.focus();
                }
                break;
            case "ArrowRight":
                if (direction === "rtl" && e.currentTarget.contains(e.target)) {
                    e.stopPropagation();
                    onSubmenuClose();
                    ref.current.focus();
                }
                break;
            case "Escape":
                e.stopPropagation();
                state.closeAll();
                break;
        }
    };
    let submenuProps = {
        id: overlayId,
        "aria-label": node.textValue,
        submenuLevel: state.submenuLevel,
        ...type === "menu" && {
            onClose: state.closeAll,
            autoFocus: state.focusStrategy,
            onKeyDown: submenuKeyDown
        }
    };
    let submenuTriggerKeyDown = (e)=>{
        switch(e.key){
            case "ArrowRight":
                if (!isDisabled) {
                    if (direction === "ltr") {
                        if (!state.isOpen) onSubmenuOpen("first");
                        if (type === "menu" && !!(submenuRef === null || submenuRef === void 0 ? void 0 : submenuRef.current) && document.activeElement === (ref === null || ref === void 0 ? void 0 : ref.current)) submenuRef.current.focus();
                    } else if (state.isOpen) onSubmenuClose();
                    else e.continuePropagation();
                }
                break;
            case "ArrowLeft":
                if (!isDisabled) {
                    if (direction === "rtl") {
                        if (!state.isOpen) onSubmenuOpen("first");
                        if (type === "menu" && !!(submenuRef === null || submenuRef === void 0 ? void 0 : submenuRef.current) && document.activeElement === (ref === null || ref === void 0 ? void 0 : ref.current)) submenuRef.current.focus();
                    } else if (state.isOpen) onSubmenuClose();
                    else e.continuePropagation();
                }
                break;
            case "Escape":
                state.closeAll();
                break;
            default:
                e.continuePropagation();
                break;
        }
    };
    let onPressStart = (e)=>{
        if (!isDisabled && (e.pointerType === "virtual" || e.pointerType === "keyboard")) onSubmenuOpen("first");
    };
    let onPress = (e)=>{
        if (!isDisabled && (e.pointerType === "touch" || e.pointerType === "mouse")) // press up happening on the newly opened tray items
        onSubmenuOpen();
    };
    let onHoverChange = (isHovered)=>{
        if (!isDisabled) {
            if (isHovered && !state.isOpen) {
                if (!openTimeout.current) openTimeout.current = setTimeout(()=>{
                    onSubmenuOpen();
                }, delay);
            } else if (!isHovered) cancelOpenTimeout();
        }
    };
    let onBlur = (e)=>{
        if (state.isOpen && parentMenuRef.current.contains(e.relatedTarget)) onSubmenuClose();
    };
    let shouldCloseOnInteractOutside = (target)=>{
        if (target !== ref.current) return true;
        return false;
    };
    $d20bd561c19865b3$var$$d275435c250248f8$export$85ec83e04c95f50a({
        menuRef: parentMenuRef,
        submenuRef: submenuRef,
        isOpen: state.isOpen,
        isDisabled: isDisabled
    });
    return {
        submenuTriggerProps: {
            id: submenuTriggerId,
            "aria-controls": state.isOpen ? overlayId : undefined,
            "aria-haspopup": !isDisabled ? type : undefined,
            "aria-expanded": state.isOpen ? "true" : "false",
            onPressStart: onPressStart,
            onPress: onPress,
            onHoverChange: onHoverChange,
            onKeyDown: submenuTriggerKeyDown,
            onBlur: onBlur,
            isOpen: state.isOpen
        },
        submenuProps: submenuProps,
        popoverProps: {
            isNonModal: true,
            disableFocusManagement: true,
            shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
        }
    };
}

});
parcelRegister("2GUus", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f5b52d301440646$export$2e2bcd8739ae039; });
var $1f5b52d301440646$export$2e2bcd8739ae039 = {};
$1f5b52d301440646$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{637}\u{648}\u{644}\u{627}\u{64B} \u{623}\u{648} \u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} Alt + \u{627}\u{644}\u{633}\u{647}\u{645} \u{644}\u{623}\u{633}\u{641}\u{644} \u{644}\u{641}\u{62A}\u{62D} \u{627}\u{644}\u{642}\u{627}\u{626}\u{645}\u{629}`
};

});

parcelRegister("dvbMq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d474edcec5f49e9$export$2e2bcd8739ae039; });
var $9d474edcec5f49e9$export$2e2bcd8739ae039 = {};
$9d474edcec5f49e9$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Alt+ \u{441}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{43D}\u{430}\u{434}\u{43E}\u{43B}\u{443}, \u{437}\u{430} \u{434}\u{430} \u{43E}\u{442}\u{432}\u{43E}\u{440}\u{438}\u{442}\u{435} \u{43C}\u{435}\u{43D}\u{44E}\u{442}\u{43E}`
};

});

parcelRegister("eUsmq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adac4b82a25abb31$export$2e2bcd8739ae039; });
var $adac4b82a25abb31$export$2e2bcd8739ae039 = {};
$adac4b82a25abb31$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dlouh\xfdm stiskem nebo stisknut\xedm kl\xe1ves Alt + \u{161}ipka dol\u{16F} otev\u{159}ete nab\xeddku`
};

});

parcelRegister("3ap0M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24e5b50936853059$export$2e2bcd8739ae039; });
var $24e5b50936853059$export$2e2bcd8739ae039 = {};
$24e5b50936853059$export$2e2bcd8739ae039 = {
    "longPressMessage": `Langt tryk eller tryk p\xe5 Alt + pil ned for at \xe5bne menuen`
};

});

parcelRegister("aPyEQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e298d230218f81c$export$2e2bcd8739ae039; });
var $7e298d230218f81c$export$2e2bcd8739ae039 = {};
$7e298d230218f81c$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dr\xfccken Sie lange oder dr\xfccken Sie Alt + Nach-unten, um das Men\xfc zu \xf6ffnen`
};

});

parcelRegister("Jyk9X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $088ed4257f124aa7$export$2e2bcd8739ae039; });
var $088ed4257f124aa7$export$2e2bcd8739ae039 = {};
$088ed4257f124aa7$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{3A0}\u{3B9}\u{3AD}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3AE} \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Alt + \u{3BA}\u{3AC}\u{3C4}\u{3C9} \u{3B2}\u{3AD}\u{3BB}\u{3BF}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3B1}\u{3BD}\u{3BF}\u{3AF}\u{3BE}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3BF} \u{3BC}\u{3B5}\u{3BD}\u{3BF}\u{3CD}`
};

});

parcelRegister("iTXIb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc2bae8d60b91ba3$export$2e2bcd8739ae039; });
var $dc2bae8d60b91ba3$export$2e2bcd8739ae039 = {};
$dc2bae8d60b91ba3$export$2e2bcd8739ae039 = {
    "longPressMessage": `Long press or press Alt + ArrowDown to open menu`
};

});

parcelRegister("b2UX8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80ac0f40ee1a553f$export$2e2bcd8739ae039; });
var $80ac0f40ee1a553f$export$2e2bcd8739ae039 = {};
$80ac0f40ee1a553f$export$2e2bcd8739ae039 = {
    "longPressMessage": `Mantenga pulsado o pulse Alt + flecha abajo para abrir el men\xfa`
};

});

parcelRegister("dzY4b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e2d232d6556bbfd$export$2e2bcd8739ae039; });
var $9e2d232d6556bbfd$export$2e2bcd8739ae039 = {};
$9e2d232d6556bbfd$export$2e2bcd8739ae039 = {
    "longPressMessage": `Men\xfc\xfc avamiseks vajutage pikalt v\xf5i vajutage klahve Alt + allanool`
};

});

parcelRegister("eCln3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa45311590fffecb$export$2e2bcd8739ae039; });
var $aa45311590fffecb$export$2e2bcd8739ae039 = {};
$aa45311590fffecb$export$2e2bcd8739ae039 = {
    "longPressMessage": `Avaa valikko painamalla pohjassa tai n\xe4pp\xe4inyhdistelm\xe4ll\xe4 Alt + Alanuoli`
};

});

parcelRegister("gW5Qd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c546981258c5d212$export$2e2bcd8739ae039; });
var $c546981258c5d212$export$2e2bcd8739ae039 = {};
$c546981258c5d212$export$2e2bcd8739ae039 = {
    "longPressMessage": `Appuyez de mani\xe8re prolong\xe9e ou appuyez sur Alt\xa0+\xa0Fl\xe8che vers le bas pour ouvrir le menu.`
};

});

parcelRegister("akYA4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $786ac3b75b0a673c$export$2e2bcd8739ae039; });
var $786ac3b75b0a673c$export$2e2bcd8739ae039 = {};
$786ac3b75b0a673c$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{5DC}\u{5D7}\u{5E5} \u{5DC}\u{5D7}\u{5D9}\u{5E6}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5D0}\u{5D5} \u{5D4}\u{5E7}\u{5E9} Alt + ArrowDown \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E4}\u{5EA}\u{5D5}\u{5D7} \u{5D0}\u{5EA} \u{5D4}\u{5EA}\u{5E4}\u{5E8}\u{5D9}\u{5D8}`
};

});

parcelRegister("kyZ9G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef866bc43753bd15$export$2e2bcd8739ae039; });
var $ef866bc43753bd15$export$2e2bcd8739ae039 = {};
$ef866bc43753bd15$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika`
};

});

parcelRegister("c4idF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c93fdbe0b56deba$export$2e2bcd8739ae039; });
var $8c93fdbe0b56deba$export$2e2bcd8739ae039 = {};
$8c93fdbe0b56deba$export$2e2bcd8739ae039 = {
    "longPressMessage": `Nyomja meg hosszan, vagy nyomja meg az Alt + lefele ny\xedl gombot a men\xfc megnyit\xe1s\xe1hoz`
};

});

parcelRegister("iQxb9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db86d1ed93e3034c$export$2e2bcd8739ae039; });
var $db86d1ed93e3034c$export$2e2bcd8739ae039 = {};
$db86d1ed93e3034c$export$2e2bcd8739ae039 = {
    "longPressMessage": `Premere a lungo o premere Alt + Freccia gi\xf9 per aprire il menu`
};

});

parcelRegister("W8amT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0aebc08991a3a477$export$2e2bcd8739ae039; });
var $0aebc08991a3a477$export$2e2bcd8739ae039 = {};
$0aebc08991a3a477$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{9577}\u{62BC}\u{3057}\u{307E}\u{305F}\u{306F} Alt+\u{4E0B}\u{77E2}\u{5370}\u{30AD}\u{30FC}\u{3067}\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{3092}\u{958B}\u{304F}`
};

});

parcelRegister("4jvxv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $324166d1f516f7b8$export$2e2bcd8739ae039; });
var $324166d1f516f7b8$export$2e2bcd8739ae039 = {};
$324166d1f516f7b8$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{AE38}\u{AC8C} \u{B204}\u{B974}\u{AC70}\u{B098} Alt + \u{C544}\u{B798}\u{CABD} \u{D654}\u{C0B4}\u{D45C}\u{B97C} \u{B20C}\u{B7EC} \u{BA54}\u{B274} \u{C5F4}\u{AE30}`
};

});

parcelRegister("cRjKh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95c9c04c2f1025a9$export$2e2bcd8739ae039; });
var $95c9c04c2f1025a9$export$2e2bcd8739ae039 = {};
$95c9c04c2f1025a9$export$2e2bcd8739ae039 = {
    "longPressMessage": `Nor\u{117}dami atidaryti meniu, nuspaud\u{119} palaikykite arba paspauskite \u{201E}Alt + ArrowDown\u{201C}.`
};

});

parcelRegister("751N8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $527a63caf481f613$export$2e2bcd8739ae039; });
var $527a63caf481f613$export$2e2bcd8739ae039 = {};
$527a63caf481f613$export$2e2bcd8739ae039 = {
    "longPressMessage": `Lai atv\u{113}rtu izv\u{113}lni, turiet nospiestu vai nospiediet tausti\u{146}u kombin\u{101}ciju Alt + lejupv\u{113}rst\u{101} bulti\u{146}a`
};

});

parcelRegister("6kMEI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49ca5a54c38ea557$export$2e2bcd8739ae039; });
var $49ca5a54c38ea557$export$2e2bcd8739ae039 = {};
$49ca5a54c38ea557$export$2e2bcd8739ae039 = {
    "longPressMessage": `Langt trykk eller trykk Alt + PilNed for \xe5 \xe5pne menyen`
};

});

parcelRegister("aRbhB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e779b29a5b34e67$export$2e2bcd8739ae039; });
var $7e779b29a5b34e67$export$2e2bcd8739ae039 = {};
$7e779b29a5b34e67$export$2e2bcd8739ae039 = {
    "longPressMessage": `Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen`
};

});

parcelRegister("hcZb1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8730316b35d1493$export$2e2bcd8739ae039; });
var $c8730316b35d1493$export$2e2bcd8739ae039 = {};
$c8730316b35d1493$export$2e2bcd8739ae039 = {
    "longPressMessage": `Naci\u{15B}nij i przytrzymaj lub naci\u{15B}nij klawisze Alt + Strza\u{142}ka w d\xf3\u{142}, aby otworzy\u{107} menu`
};

});

parcelRegister("5GtBQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4237d7d0ea44fbf7$export$2e2bcd8739ae039; });
var $4237d7d0ea44fbf7$export$2e2bcd8739ae039 = {};
$4237d7d0ea44fbf7$export$2e2bcd8739ae039 = {
    "longPressMessage": `Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu`
};

});

parcelRegister("kJBV1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1856c7caf3c37d6$export$2e2bcd8739ae039; });
var $f1856c7caf3c37d6$export$2e2bcd8739ae039 = {};
$f1856c7caf3c37d6$export$2e2bcd8739ae039 = {
    "longPressMessage": `Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu`
};

});

parcelRegister("6zkis", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c85c1743eacf822$export$2e2bcd8739ae039; });
var $4c85c1743eacf822$export$2e2bcd8739ae039 = {};
$4c85c1743eacf822$export$2e2bcd8739ae039 = {
    "longPressMessage": `Ap\u{103}sa\u{21B}i lung sau ap\u{103}sa\u{21B}i pe Alt + s\u{103}geat\u{103} \xeen jos pentru a deschide meniul`
};

});

parcelRegister("dtRap", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d0739a6f48ff5a2$export$2e2bcd8739ae039; });
var $9d0739a6f48ff5a2$export$2e2bcd8739ae039 = {};
$9d0739a6f48ff5a2$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} Alt + \u{421}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44E}`
};

});

parcelRegister("crMOm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90fdde91b5e29690$export$2e2bcd8739ae039; });
var $90fdde91b5e29690$export$2e2bcd8739ae039 = {};
$90fdde91b5e29690$export$2e2bcd8739ae039 = {
    "longPressMessage": `Ponuku otvor\xedte dlh\xfdm stla\u{10D}en\xedm alebo stla\u{10D}en\xedm kl\xe1vesu Alt + kl\xe1vesu so \u{161}\xedpkou nadol`
};

});

parcelRegister("zIf7E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06b596b842093fbc$export$2e2bcd8739ae039; });
var $06b596b842093fbc$export$2e2bcd8739ae039 = {};
$06b596b842093fbc$export$2e2bcd8739ae039 = {
    "longPressMessage": `Za odprtje menija pritisnite in dr\u{17E}ite gumb ali pritisnite Alt+pu\u{161}\u{10D}ica navzdol`
};

});

parcelRegister("b1DQN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $806eb32f4506ce8f$export$2e2bcd8739ae039; });
var $806eb32f4506ce8f$export$2e2bcd8739ae039 = {};
$806eb32f4506ce8f$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni`
};

});

parcelRegister("f3Q9d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af6f96423d2a06e6$export$2e2bcd8739ae039; });
var $af6f96423d2a06e6$export$2e2bcd8739ae039 = {};
$af6f96423d2a06e6$export$2e2bcd8739ae039 = {
    "longPressMessage": `H\xe5ll nedtryckt eller tryck p\xe5 Alt + pil ned\xe5t f\xf6r att \xf6ppna menyn`
};

});

parcelRegister("kgktt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec052f096a97cfae$export$2e2bcd8739ae039; });
var $ec052f096a97cfae$export$2e2bcd8739ae039 = {};
$ec052f096a97cfae$export$2e2bcd8739ae039 = {
    "longPressMessage": `Men\xfcy\xfc a\xe7mak i\xe7in uzun bas\u{131}n veya Alt + A\u{15F}a\u{11F}\u{131} Ok tu\u{15F}una bas\u{131}n`
};

});

parcelRegister("4oJsT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $333cabbd3d0d45cf$export$2e2bcd8739ae039; });
var $333cabbd3d0d45cf$export$2e2bcd8739ae039 = {};
$333cabbd3d0d45cf$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{414}\u{43E}\u{432}\u{433}\u{43E} \u{430}\u{431}\u{43E} \u{437}\u{432}\u{438}\u{447}\u{430}\u{439}\u{43D}\u{43E} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{43A}\u{43E}\u{43C}\u{431}\u{456}\u{43D}\u{430}\u{446}\u{456}\u{44E} \u{43A}\u{43B}\u{430}\u{432}\u{456}\u{448} Alt \u{456} \u{441}\u{442}\u{440}\u{456}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{449}\u{43E}\u{431} \u{432}\u{456}\u{434}\u{43A}\u{440}\u{438}\u{442}\u{438} \u{43C}\u{435}\u{43D}\u{44E}`
};

});

parcelRegister("61vK7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $462b7589aae137de$export$2e2bcd8739ae039; });
var $462b7589aae137de$export$2e2bcd8739ae039 = {};
$462b7589aae137de$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{957F}\u{6309}\u{6216}\u{6309} Alt + \u{5411}\u{4E0B}\u{65B9}\u{5411}\u{952E}\u{4EE5}\u{6253}\u{5F00}\u{83DC}\u{5355}`
};

});

parcelRegister("hbJVs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c83716a38248d685$export$2e2bcd8739ae039; });
var $c83716a38248d685$export$2e2bcd8739ae039 = {};
$c83716a38248d685$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{9577}\u{6309}\u{6216}\u{6309} Alt+\u{5411}\u{4E0B}\u{9375}\u{4EE5}\u{958B}\u{555F}\u{529F}\u{80FD}\u{8868}`
};

});

parcelRegister("hXX5l", function(module, exports) {

$parcel$export(module.exports, "isFocusVisible", function () { return $d145c773824cc2d9$export$b9b3dfddab17db27; });
$parcel$export(module.exports, "useInteractionModality", function () { return $d145c773824cc2d9$export$98e20ec92f614cfe; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $d145c773824cc2d9$var$$507fabe10e71c6fb$var$currentModality = null;
let $d145c773824cc2d9$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $d145c773824cc2d9$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $d145c773824cc2d9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $d145c773824cc2d9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $d145c773824cc2d9$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $d145c773824cc2d9$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $d145c773824cc2d9$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $d145c773824cc2d9$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $gbqqi.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $d145c773824cc2d9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($d145c773824cc2d9$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $d145c773824cc2d9$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $d145c773824cc2d9$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $d145c773824cc2d9$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $d145c773824cc2d9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $d145c773824cc2d9$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $87CgO.isVirtualClick)(e)) {
        $d145c773824cc2d9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $d145c773824cc2d9$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$d145c773824cc2d9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$d145c773824cc2d9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $d145c773824cc2d9$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $d145c773824cc2d9$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $d145c773824cc2d9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $d145c773824cc2d9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $d145c773824cc2d9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $d145c773824cc2d9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $d145c773824cc2d9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $d145c773824cc2d9$export$d90243b58daecda7.get((0, $2ZDqh.getOwnerWindow)(element))) return;
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $d145c773824cc2d9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $d145c773824cc2d9$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $d145c773824cc2d9$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $d145c773824cc2d9$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$d145c773824cc2d9$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $d145c773824cc2d9$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $d145c773824cc2d9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $d145c773824cc2d9$export$d90243b58daecda7.delete(windowObject);
};
function $d145c773824cc2d9$export$2f1888112f558a7d(element) {
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $d145c773824cc2d9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $d145c773824cc2d9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$d145c773824cc2d9$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $d145c773824cc2d9$export$2f1888112f558a7d();
function $d145c773824cc2d9$export$b9b3dfddab17db27() {
    return $d145c773824cc2d9$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $d145c773824cc2d9$export$630ff653c5ada6a9() {
    return $d145c773824cc2d9$var$$507fabe10e71c6fb$var$currentModality;
}
function $d145c773824cc2d9$export$8397ddfc504fdb9a(modality) {
    $d145c773824cc2d9$var$$507fabe10e71c6fb$var$currentModality = modality;
    $d145c773824cc2d9$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $d145c773824cc2d9$export$98e20ec92f614cfe() {
    $d145c773824cc2d9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $exYeM.useState)($d145c773824cc2d9$var$$507fabe10e71c6fb$var$currentModality);
    (0, $exYeM.useEffect)(()=>{
        let handler = ()=>{
            setModality($d145c773824cc2d9$var$$507fabe10e71c6fb$var$currentModality);
        };
        $d145c773824cc2d9$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $d145c773824cc2d9$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $aVmq3.useIsSSR)() ? null : modality;
}
const $d145c773824cc2d9$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $d145c773824cc2d9$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$d145c773824cc2d9$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$d145c773824cc2d9$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $d145c773824cc2d9$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(autoFocus || $d145c773824cc2d9$export$b9b3dfddab17db27());
    $d145c773824cc2d9$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $d145c773824cc2d9$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $d145c773824cc2d9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $exYeM.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$d145c773824cc2d9$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($d145c773824cc2d9$export$b9b3dfddab17db27());
        };
        $d145c773824cc2d9$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $d145c773824cc2d9$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});

parcelRegister("glM3t", function(module, exports) {

$parcel$export(module.exports, "useFocus", function () { return $be73e241425cec81$export$f8168d8dd8fd66e6; });

var $cO67d = parcelRequire("cO67d");

var $exYeM = parcelRequire("exYeM");

var $2ZDqh = parcelRequire("2ZDqh");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $be73e241425cec81$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $exYeM.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $cO67d.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $exYeM.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});
parcelRegister("cO67d", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $952ee5e903ff8515$export$715c682d09d639cc; });

var $exYeM = parcelRequire("exYeM");

var $4sExG = parcelRequire("4sExG");
var $71dP2 = parcelRequire("71dP2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $952ee5e903ff8515$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $952ee5e903ff8515$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $exYeM.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $71dP2.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $4sExG.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $exYeM.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $952ee5e903ff8515$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("39uZ6", function(module, exports) {

$parcel$export(module.exports, "useHover", function () { return $24ba3f3a56425fe0$export$ae780daf29e6d456; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $24ba3f3a56425fe0$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $24ba3f3a56425fe0$var$$6179b936705e76d3$var$hoverCount = 0;
function $24ba3f3a56425fe0$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $24ba3f3a56425fe0$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $24ba3f3a56425fe0$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $24ba3f3a56425fe0$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $24ba3f3a56425fe0$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $24ba3f3a56425fe0$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $24ba3f3a56425fe0$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $24ba3f3a56425fe0$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $24ba3f3a56425fe0$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $24ba3f3a56425fe0$var$$6179b936705e76d3$var$hoverCount--;
        if ($24ba3f3a56425fe0$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $24ba3f3a56425fe0$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $24ba3f3a56425fe0$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $24ba3f3a56425fe0$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $exYeM.useState)(false);
    let state = (0, $exYeM.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, $exYeM.useEffect)($24ba3f3a56425fe0$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $exYeM.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($24ba3f3a56425fe0$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$24ba3f3a56425fe0$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $exYeM.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}

});

parcelRegister("59ucR", function(module, exports) {

$parcel$export(module.exports, "useKeyboard", function () { return $3c053963ddf09f04$export$8f71654801c2f7cd; });

var $jU2dI = parcelRequire("jU2dI");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3c053963ddf09f04$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $jU2dI.createEventHandler)(props.onKeyDown),
            onKeyUp: (0, $jU2dI.createEventHandler)(props.onKeyUp)
        }
    };
}

});
parcelRegister("jU2dI", function(module, exports) {

$parcel$export(module.exports, "createEventHandler", function () { return $e7d4f8304a3b1110$export$48d1ea6320830260; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e7d4f8304a3b1110$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}

});


parcelRegister("hfLMA", function(module, exports) {

$parcel$export(module.exports, "useLongPress", function () { return $c8f8e70433735030$export$c24ed0104d07eab9; });

var $3xNbd = parcelRequire("3xNbd");

var $8vAG4 = parcelRequire("8vAG4");
var $6qwZD = parcelRequire("6qwZD");
var $aGeuR = parcelRequire("aGeuR");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c8f8e70433735030$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $c8f8e70433735030$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $c8f8e70433735030$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $exYeM.useRef)();
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $aGeuR.useGlobalListeners)();
    let { pressProps: pressProps } = (0, $3xNbd.usePress)({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, $6qwZD.useDescription)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $8vAG4.mergeProps)(pressProps, descriptionProps)
    };
}

});
parcelRegister("3xNbd", function(module, exports) {

$parcel$export(module.exports, "usePress", function () { return $294a9a48aecda8d4$export$45712eceda6fad21; });

var $idrqc = parcelRequire("idrqc");

var $kFiDz = parcelRequire("kFiDz");

var $29jGr = parcelRequire("29jGr");

var $6DVYY = parcelRequire("6DVYY");

var $iAON1 = parcelRequire("iAON1");

var $kdWpA = parcelRequire("kdWpA");
var $6Qamj = parcelRequire("6Qamj");
var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");
var $8vAG4 = parcelRequire("8vAG4");
var $h6krv = parcelRequire("h6krv");
var $4sExG = parcelRequire("4sExG");
var $aGeuR = parcelRequire("aGeuR");
var $hbWr9 = parcelRequire("hbWr9");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $exYeM.useContext)((0, $kFiDz.PressResponderContext));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $8vAG4.mergeProps)(contextProps, props);
        register();
    }
    (0, $hbWr9.useSyncRef)(context, props.ref);
    return props;
}
var $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $iAON1._)(this, $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $29jGr._)(this, $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $6DVYY._)(this, $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $iAON1._)(this, $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $294a9a48aecda8d4$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $exYeM.useState)(false);
    let ref = (0, $exYeM.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $aGeuR.useGlobalListeners)();
    let triggerPressStart = (0, $4sExG.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $4sExG.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $4sExG.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $4sExG.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $idrqc.restoreTextSelection)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $4sExG.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $exYeM.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "keyup", (0, $kdWpA.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $gbqqi.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $h6krv.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $87CgO.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$294a9a48aecda8d4$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$294a9a48aecda8d4$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $h6krv.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $87CgO.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $idrqc.disableTextSelection)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $idrqc.restoreTextSelection)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $87CgO.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $idrqc.disableTextSelection)(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $2ZDqh.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $idrqc.restoreTextSelection)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $exYeM.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $idrqc.restoreTextSelection)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $8vAG4.mergeProps)(domProps, pressProps)
    };
}
function $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $2ZDqh.getOwnerWindow)(element).HTMLInputElement && !$294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $2ZDqh.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $294a9a48aecda8d4$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}

});
parcelRegister("idrqc", function(module, exports) {

$parcel$export(module.exports, "disableTextSelection", function () { return $d42eb63e1760cb52$export$16a4697467175487; });
$parcel$export(module.exports, "restoreTextSelection", function () { return $d42eb63e1760cb52$export$b0d6fa1ab32e3295; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $jgteb = parcelRequire("jgteb");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $d42eb63e1760cb52$var$$14c0b72509d70225$var$state = "default";
let $d42eb63e1760cb52$var$$14c0b72509d70225$var$savedUserSelect = "";
let $d42eb63e1760cb52$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $d42eb63e1760cb52$export$16a4697467175487(target) {
    if ((0, $gbqqi.isIOS)()) {
        if ($d42eb63e1760cb52$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $2ZDqh.getOwnerDocument)(target);
            $d42eb63e1760cb52$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $d42eb63e1760cb52$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $d42eb63e1760cb52$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $d42eb63e1760cb52$export$b0d6fa1ab32e3295(target) {
    if ((0, $gbqqi.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($d42eb63e1760cb52$var$$14c0b72509d70225$var$state !== "disabled") return;
        $d42eb63e1760cb52$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $jgteb.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($d42eb63e1760cb52$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $2ZDqh.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $d42eb63e1760cb52$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $d42eb63e1760cb52$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $d42eb63e1760cb52$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $d42eb63e1760cb52$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $d42eb63e1760cb52$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $d42eb63e1760cb52$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}

});

parcelRegister("kFiDz", function(module, exports) {

$parcel$export(module.exports, "PressResponderContext", function () { return $f0b617f8e324a1cd$export$5165eccb35aaadb5; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f0b617f8e324a1cd$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({
    register: ()=>{}
});
$f0b617f8e324a1cd$export$5165eccb35aaadb5.displayName = "PressResponderContext";

});



parcelRegister("6z6dF", function(module, exports) {

$parcel$export(module.exports, "useOverlayTrigger", function () { return $4c7ad6072d6a2cb1$export$f9d5c8beee7d008d; });

var $je0Wp = parcelRequire("je0Wp");

var $exYeM = parcelRequire("exYeM");

var $ezzQB = parcelRequire("ezzQB");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4c7ad6072d6a2cb1$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type } = props;
    let { isOpen: isOpen } = state;
    (0, $exYeM.useEffect)(()=>{
        if (ref && ref.current) (0, $je0Wp.onCloseMap).set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === "menu") ariaHasPopup = true;
    else if (type === "listbox") ariaHasPopup = "listbox";
    let overlayId = (0, $ezzQB.useId)();
    return {
        triggerProps: {
            "aria-haspopup": ariaHasPopup,
            "aria-expanded": isOpen,
            "aria-controls": isOpen ? overlayId : null,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}

});
parcelRegister("je0Wp", function(module, exports) {

$parcel$export(module.exports, "onCloseMap", function () { return $dff00e02c890bd91$export$f6211563215e3b37; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $dff00e02c890bd91$export$f6211563215e3b37 = new WeakMap();
function $dff00e02c890bd91$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef, isOpen: isOpen, onClose: onClose } = opts;
    (0, $exYeM.useEffect)(()=>{
        if (!isOpen || onClose === null) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            let onCloseHandler = onClose || $dff00e02c890bd91$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener("scroll", onScroll, true);
        return ()=>{
            window.removeEventListener("scroll", onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}

});


parcelRegister("2Ya72", function(module, exports) {

$parcel$export(module.exports, "useSelectableItem", function () { return $2299077c15c0499c$export$ecf600387e221c37; });

var $koOwD = parcelRequire("koOwD");

var $8zm8Z = parcelRequire("8zm8Z");

var $8vAG4 = parcelRequire("8vAG4");
var $h6krv = parcelRequire("h6krv");

var $kgNEJ = parcelRequire("kgNEJ");
var $9N13I = parcelRequire("9N13I");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2299077c15c0499c$export$ecf600387e221c37(options) {
    let { selectionManager: manager, key: key, ref: ref, shouldSelectOnPressUp: shouldSelectOnPressUp, shouldUseVirtualFocus: shouldUseVirtualFocus, focus: focus, isDisabled: isDisabled, onAction: onAction, allowsDifferentPressOrigin: allowsDifferentPressOrigin, linkBehavior: linkBehavior = "action" } = options;
    let router = (0, $h6krv.useRouter)();
    let onSelect = (e)=>{
        if (e.pointerType === "keyboard" && (0, $koOwD.isNonContiguousSelectionModifier)(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === "none") return;
            if (manager.isLink(key)) {
                if (linkBehavior === "selection") {
                    let itemProps = manager.getItemProps(key);
                    router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
                    // Always set selected keys back to what they were so that select and combobox close.
                    manager.setSelectedKeys(manager.selectedKeys);
                    return;
                } else if (linkBehavior === "override" || linkBehavior === "none") return;
            }
            if (manager.selectionMode === "single") {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === "toggle" || e && ((0, $koOwD.isCtrlKeyPressed)(e) || e.pointerType === "touch" || e.pointerType === "virtual")) manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    (0, $exYeM.useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused && !shouldUseVirtualFocus) {
            if (focus) focus();
            else if (document.activeElement !== ref.current) (0, $8zm8Z.focusSafely)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let isLinkOverride = manager.isLink(key) && linkBehavior === "override";
    let hasLinkAction = manager.isLink(key) && linkBehavior !== "selection" && linkBehavior !== "none";
    let allowsSelection = !isDisabled && manager.canSelectItem(key) && !isLinkOverride;
    let allowsActions = (onAction || hasLinkAction) && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === "replace" ? !allowsSelection : !allowsSelection || manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === "replace";
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (0, $exYeM.useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (0, $exYeM.useRef)(false);
    let hadPrimaryActionOnPressStart = (0, $exYeM.useRef)(false);
    let performAction = (e)=>{
        if (onAction) onAction();
        if (hasLinkAction) {
            let itemProps = manager.getItemProps(key);
            router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
        }
    };
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {};
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === "keyboard" && (!hasAction || $2299077c15c0499c$var$$880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== "mouse") {
                if (e.pointerType === "keyboard" && !$2299077c15c0499c$var$$880e95eb8b93ba9a$var$isActionKey()) return;
                performAction(e);
            } else if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
        };
        else {
            itemPressProps.onPressUp = hasPrimaryAction ? null : (e)=>{
                if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? performAction : null;
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (allowsSelection && (e.pointerType === "mouse" && !hasPrimaryAction || e.pointerType === "keyboard" && (!allowsActions || $2299077c15c0499c$var$$880e95eb8b93ba9a$var$isSelectionKey()))) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === "touch" || e.pointerType === "pen" || e.pointerType === "virtual" || e.pointerType === "keyboard" && hasAction && $2299077c15c0499c$var$$880e95eb8b93ba9a$var$isActionKey() || e.pointerType === "mouse" && hadPrimaryActionOnPressStart.current) {
                if (hasAction) performAction(e);
                else if (allowsSelection) onSelect(e);
            }
        };
    }
    itemProps["data-key"] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    let { pressProps: pressProps, isPressed: isPressed } = (0, $9N13I.usePress)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === "mouse") {
            e.stopPropagation();
            e.preventDefault();
            performAction(e);
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps } = (0, $kgNEJ.useLongPress)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === "touch") {
                onSelect(e);
                manager.setSelectionBehavior("toggle");
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === "touch" && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    // Prevent default on link clicks so that we control exactly
    // when they open (to match selection behavior).
    let onClick = manager.isLink(key) ? (e)=>{
        if (!(0, $h6krv.openLink).isOpening) e.preventDefault();
    } : undefined;
    return {
        itemProps: (0, $8vAG4.mergeProps)(itemProps, allowsSelection || hasPrimaryAction ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStartCapture: onDragStartCapture,
            onClick: onClick
        }),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isFocused: manager.isFocused && manager.focusedKey === key,
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $2299077c15c0499c$var$$880e95eb8b93ba9a$var$isActionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === "Enter";
}
function $2299077c15c0499c$var$$880e95eb8b93ba9a$var$isSelectionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === " " || (event === null || event === void 0 ? void 0 : event.code) === "Space";
}

});
parcelRegister("koOwD", function(module, exports) {

$parcel$export(module.exports, "isNonContiguousSelectionModifier", function () { return $ed9d3dd369c470e7$export$d3e3bd3e26688c04; });
$parcel$export(module.exports, "isCtrlKeyPressed", function () { return $ed9d3dd369c470e7$export$16792effe837dba3; });

var $gbqqi = parcelRequire("gbqqi");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ed9d3dd369c470e7$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, $gbqqi.isAppleDevice)() ? e.altKey : e.ctrlKey;
}
function $ed9d3dd369c470e7$export$16792effe837dba3(e) {
    if ((0, $gbqqi.isMac)()) return e.metaKey;
    return e.ctrlKey;
}

});

parcelRegister("8zm8Z", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $63d2c4f15c43055d$export$80f3e147d781571c; });

var $6Qamj = parcelRequire("6Qamj");
var $2ZDqh = parcelRequire("2ZDqh");
var $jgteb = parcelRequire("jgteb");

var $cpAUK = parcelRequire("cpAUK");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $63d2c4f15c43055d$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $2ZDqh.getOwnerDocument)(element);
    if ((0, $cpAUK.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $jgteb.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $6Qamj.focusWithoutScrolling)(element);
        });
    } else (0, $6Qamj.focusWithoutScrolling)(element);
}

});
parcelRegister("cpAUK", function(module, exports) {

$parcel$export(module.exports, "getInteractionModality", function () { return $9094744445c0a82d$export$630ff653c5ada6a9; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $9094744445c0a82d$var$$507fabe10e71c6fb$var$currentModality = null;
let $9094744445c0a82d$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $9094744445c0a82d$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $9094744445c0a82d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $9094744445c0a82d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $9094744445c0a82d$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $9094744445c0a82d$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $9094744445c0a82d$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $9094744445c0a82d$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $gbqqi.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $9094744445c0a82d$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $9094744445c0a82d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($9094744445c0a82d$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $9094744445c0a82d$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $9094744445c0a82d$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $9094744445c0a82d$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $9094744445c0a82d$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $9094744445c0a82d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $9094744445c0a82d$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $9094744445c0a82d$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $87CgO.isVirtualClick)(e)) {
        $9094744445c0a82d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $9094744445c0a82d$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $9094744445c0a82d$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$9094744445c0a82d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$9094744445c0a82d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $9094744445c0a82d$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $9094744445c0a82d$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $9094744445c0a82d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $9094744445c0a82d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $9094744445c0a82d$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $9094744445c0a82d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $9094744445c0a82d$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $9094744445c0a82d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $9094744445c0a82d$export$d90243b58daecda7.get((0, $2ZDqh.getOwnerWindow)(element))) return;
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $9094744445c0a82d$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $9094744445c0a82d$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $9094744445c0a82d$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $9094744445c0a82d$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$9094744445c0a82d$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $9094744445c0a82d$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $9094744445c0a82d$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $9094744445c0a82d$export$d90243b58daecda7.delete(windowObject);
};
function $9094744445c0a82d$export$2f1888112f558a7d(element) {
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $9094744445c0a82d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $9094744445c0a82d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$9094744445c0a82d$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $9094744445c0a82d$export$2f1888112f558a7d();
function $9094744445c0a82d$export$b9b3dfddab17db27() {
    return $9094744445c0a82d$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $9094744445c0a82d$export$630ff653c5ada6a9() {
    return $9094744445c0a82d$var$$507fabe10e71c6fb$var$currentModality;
}
function $9094744445c0a82d$export$8397ddfc504fdb9a(modality) {
    $9094744445c0a82d$var$$507fabe10e71c6fb$var$currentModality = modality;
    $9094744445c0a82d$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $9094744445c0a82d$export$98e20ec92f614cfe() {
    $9094744445c0a82d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $exYeM.useState)($9094744445c0a82d$var$$507fabe10e71c6fb$var$currentModality);
    (0, $exYeM.useEffect)(()=>{
        let handler = ()=>{
            setModality($9094744445c0a82d$var$$507fabe10e71c6fb$var$currentModality);
        };
        $9094744445c0a82d$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $9094744445c0a82d$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $aVmq3.useIsSSR)() ? null : modality;
}
const $9094744445c0a82d$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $9094744445c0a82d$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$9094744445c0a82d$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$9094744445c0a82d$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $9094744445c0a82d$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(autoFocus || $9094744445c0a82d$export$b9b3dfddab17db27());
    $9094744445c0a82d$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $9094744445c0a82d$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $9094744445c0a82d$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $exYeM.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$9094744445c0a82d$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($9094744445c0a82d$export$b9b3dfddab17db27());
        };
        $9094744445c0a82d$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $9094744445c0a82d$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("kgNEJ", function(module, exports) {

$parcel$export(module.exports, "useLongPress", function () { return $ec1bd1eec5ad1a18$export$c24ed0104d07eab9; });

var $9N13I = parcelRequire("9N13I");

var $8vAG4 = parcelRequire("8vAG4");
var $6qwZD = parcelRequire("6qwZD");
var $aGeuR = parcelRequire("aGeuR");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ec1bd1eec5ad1a18$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $ec1bd1eec5ad1a18$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $ec1bd1eec5ad1a18$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $exYeM.useRef)();
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $aGeuR.useGlobalListeners)();
    let { pressProps: pressProps } = (0, $9N13I.usePress)({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, $6qwZD.useDescription)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $8vAG4.mergeProps)(pressProps, descriptionProps)
    };
}

});
parcelRegister("9N13I", function(module, exports) {

$parcel$export(module.exports, "usePress", function () { return $720982f46ce411a3$export$45712eceda6fad21; });

var $eU62x = parcelRequire("eU62x");

var $YdEq5 = parcelRequire("YdEq5");

var $29jGr = parcelRequire("29jGr");

var $6DVYY = parcelRequire("6DVYY");

var $iAON1 = parcelRequire("iAON1");

var $kdWpA = parcelRequire("kdWpA");
var $6Qamj = parcelRequire("6Qamj");
var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");
var $8vAG4 = parcelRequire("8vAG4");
var $h6krv = parcelRequire("h6krv");
var $4sExG = parcelRequire("4sExG");
var $aGeuR = parcelRequire("aGeuR");
var $hbWr9 = parcelRequire("hbWr9");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $720982f46ce411a3$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $exYeM.useContext)((0, $YdEq5.PressResponderContext));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $8vAG4.mergeProps)(contextProps, props);
        register();
    }
    (0, $hbWr9.useSyncRef)(context, props.ref);
    return props;
}
var $720982f46ce411a3$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $720982f46ce411a3$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $iAON1._)(this, $720982f46ce411a3$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $29jGr._)(this, $720982f46ce411a3$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $6DVYY._)(this, $720982f46ce411a3$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $iAON1._)(this, $720982f46ce411a3$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $720982f46ce411a3$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $720982f46ce411a3$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $720982f46ce411a3$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $exYeM.useState)(false);
    let ref = (0, $exYeM.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $aGeuR.useGlobalListeners)();
    let triggerPressStart = (0, $4sExG.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $720982f46ce411a3$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $4sExG.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $720982f46ce411a3$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $720982f46ce411a3$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $4sExG.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $720982f46ce411a3$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $4sExG.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($720982f46ce411a3$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $eU62x.restoreTextSelection)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $4sExG.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $exYeM.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($720982f46ce411a3$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($720982f46ce411a3$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($720982f46ce411a3$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($720982f46ce411a3$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "keyup", (0, $kdWpA.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $gbqqi.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $h6krv.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $87CgO.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $720982f46ce411a3$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($720982f46ce411a3$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($720982f46ce411a3$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $720982f46ce411a3$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$720982f46ce411a3$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$720982f46ce411a3$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $h6krv.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $87CgO.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($720982f46ce411a3$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $eU62x.disableTextSelection)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($720982f46ce411a3$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $720982f46ce411a3$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $720982f46ce411a3$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($720982f46ce411a3$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($720982f46ce411a3$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($720982f46ce411a3$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($720982f46ce411a3$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($720982f46ce411a3$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $eU62x.restoreTextSelection)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($720982f46ce411a3$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $87CgO.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $720982f46ce411a3$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($720982f46ce411a3$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($720982f46ce411a3$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $720982f46ce411a3$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $eU62x.disableTextSelection)(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $2ZDqh.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $720982f46ce411a3$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $720982f46ce411a3$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $720982f46ce411a3$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $720982f46ce411a3$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $eU62x.restoreTextSelection)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $exYeM.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $eU62x.restoreTextSelection)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $8vAG4.mergeProps)(domProps, pressProps)
    };
}
function $720982f46ce411a3$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $720982f46ce411a3$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $2ZDqh.getOwnerWindow)(element).HTMLInputElement && !$720982f46ce411a3$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $2ZDqh.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $720982f46ce411a3$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $720982f46ce411a3$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $720982f46ce411a3$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $720982f46ce411a3$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $720982f46ce411a3$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $720982f46ce411a3$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $720982f46ce411a3$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $720982f46ce411a3$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $720982f46ce411a3$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $720982f46ce411a3$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $720982f46ce411a3$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$720982f46ce411a3$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($720982f46ce411a3$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $720982f46ce411a3$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $720982f46ce411a3$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $720982f46ce411a3$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}

});
parcelRegister("eU62x", function(module, exports) {

$parcel$export(module.exports, "disableTextSelection", function () { return $ad9afb081f504dc2$export$16a4697467175487; });
$parcel$export(module.exports, "restoreTextSelection", function () { return $ad9afb081f504dc2$export$b0d6fa1ab32e3295; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $jgteb = parcelRequire("jgteb");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $ad9afb081f504dc2$var$$14c0b72509d70225$var$state = "default";
let $ad9afb081f504dc2$var$$14c0b72509d70225$var$savedUserSelect = "";
let $ad9afb081f504dc2$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $ad9afb081f504dc2$export$16a4697467175487(target) {
    if ((0, $gbqqi.isIOS)()) {
        if ($ad9afb081f504dc2$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $2ZDqh.getOwnerDocument)(target);
            $ad9afb081f504dc2$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $ad9afb081f504dc2$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $ad9afb081f504dc2$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $ad9afb081f504dc2$export$b0d6fa1ab32e3295(target) {
    if ((0, $gbqqi.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($ad9afb081f504dc2$var$$14c0b72509d70225$var$state !== "disabled") return;
        $ad9afb081f504dc2$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $jgteb.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($ad9afb081f504dc2$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $2ZDqh.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $ad9afb081f504dc2$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $ad9afb081f504dc2$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $ad9afb081f504dc2$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $ad9afb081f504dc2$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $ad9afb081f504dc2$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $ad9afb081f504dc2$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}

});

parcelRegister("YdEq5", function(module, exports) {

$parcel$export(module.exports, "PressResponderContext", function () { return $0b503180688d64c5$export$5165eccb35aaadb5; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $0b503180688d64c5$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({
    register: ()=>{}
});
$0b503180688d64c5$export$5165eccb35aaadb5.displayName = "PressResponderContext";

});




parcelRegister("1sTcE", function(module, exports) {

$parcel$export(module.exports, "useSelectableList", function () { return $11133a29650e8128$export$b95089534ab7c1fd; });

var $j72GW = parcelRequire("j72GW");

var $colLn = parcelRequire("colLn");

var $dK1OU = parcelRequire("dK1OU");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $11133a29650e8128$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager, collection: collection, disabledKeys: disabledKeys, ref: ref, keyboardDelegate: keyboardDelegate } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $dK1OU.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let disabledBehavior = selectionManager.disabledBehavior;
    let delegate = (0, $exYeM.useMemo)(()=>keyboardDelegate || new (0, $colLn.ListKeyboardDelegate)({
            collection: collection,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            ref: ref,
            collator: collator
        }), [
        keyboardDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior
    ]);
    let { collectionProps: collectionProps } = (0, $j72GW.useSelectableCollection)({
        ...props,
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate
    });
    return {
        listProps: collectionProps
    };
}

});
parcelRegister("j72GW", function(module, exports) {

$parcel$export(module.exports, "useSelectableCollection", function () { return $dea0c246a76ede37$export$d6daf82dcd84e87c; });

var $koOwD = parcelRequire("koOwD");

var $11YFZ = parcelRequire("11YFZ");

var $d2lNW = parcelRequire("d2lNW");

var $exYeM = parcelRequire("exYeM");

var $8zm8Z = parcelRequire("8zm8Z");
var $kQVoJ = parcelRequire("kQVoJ");

var $6Qamj = parcelRequire("6Qamj");
var $8vAG4 = parcelRequire("8vAG4");
var $d7oDp = parcelRequire("d7oDp");
var $aVei0 = parcelRequire("aVei0");
var $h6krv = parcelRequire("h6krv");

var $cpAUK = parcelRequire("cpAUK");

var $9ljKT = parcelRequire("9ljKT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $dea0c246a76ede37$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager, keyboardDelegate: delegate, ref: ref, autoFocus: autoFocus = false, shouldFocusWrap: shouldFocusWrap = false, disallowEmptySelection: disallowEmptySelection = false, disallowSelectAll: disallowSelectAll = false, selectOnFocus: selectOnFocus = manager.selectionBehavior === "replace", disallowTypeAhead: disallowTypeAhead = false, shouldUseVirtualFocus: shouldUseVirtualFocus, allowsTabNavigation: allowsTabNavigation = false, isVirtualized: isVirtualized, scrollRef: scrollRef = ref, linkBehavior: linkBehavior = "action" } = options;
    let { direction: direction } = (0, $9ljKT.useLocale)();
    let router = (0, $h6krv.useRouter)();
    let onKeyDown = (e)=>{
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === "Tab") e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!ref.current.contains(e.target)) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                if (manager.isLink(key) && linkBehavior === "selection" && selectOnFocus && !(0, $koOwD.isNonContiguousSelectionModifier)(e)) {
                    (0, $d2lNW.flushSync)(()=>{
                        manager.setFocusedKey(key, childFocus);
                    });
                    let item = scrollRef.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`);
                    let itemProps = manager.getItemProps(key);
                    router.open(item, e, itemProps.href, itemProps.routerOptions);
                    return;
                }
                manager.setFocusedKey(key, childFocus);
                if (manager.isLink(key) && linkBehavior === "override") return;
                if (e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(key);
                else if (selectOnFocus && !(0, $koOwD.isNonContiguousSelectionModifier)(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case "ArrowDown":
                if (delegate.getKeyBelow) {
                    var _delegate_getFirstKey, _delegate_getFirstKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyBelow(manager.focusedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowUp":
                if (delegate.getKeyAbove) {
                    var _delegate_getLastKey, _delegate_getLastKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyAbove(manager.focusedKey) : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getLastKey1 = delegate.getLastKey) === null || _delegate_getLastKey1 === void 0 ? void 0 : _delegate_getLastKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowLeft":
                if (delegate.getKeyLeftOf) {
                    var _delegate_getFirstKey2, _delegate_getLastKey2;
                    e.preventDefault();
                    let nextKey = delegate.getKeyLeftOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getFirstKey2 = delegate.getFirstKey) === null || _delegate_getFirstKey2 === void 0 ? void 0 : _delegate_getFirstKey2.call(delegate, manager.focusedKey) : (_delegate_getLastKey2 = delegate.getLastKey) === null || _delegate_getLastKey2 === void 0 ? void 0 : _delegate_getLastKey2.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "first" : "last");
                }
                break;
            case "ArrowRight":
                if (delegate.getKeyRightOf) {
                    var _delegate_getLastKey3, _delegate_getFirstKey3;
                    e.preventDefault();
                    let nextKey = delegate.getKeyRightOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getLastKey3 = delegate.getLastKey) === null || _delegate_getLastKey3 === void 0 ? void 0 : _delegate_getLastKey3.call(delegate, manager.focusedKey) : (_delegate_getFirstKey3 = delegate.getFirstKey) === null || _delegate_getFirstKey3 === void 0 ? void 0 : _delegate_getFirstKey3.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "last" : "first");
                }
                break;
            case "Home":
                if (delegate.getFirstKey) {
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, (0, $koOwD.isCtrlKeyPressed)(e));
                    manager.setFocusedKey(firstKey);
                    if ((0, $koOwD.isCtrlKeyPressed)(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(firstKey);
                    else if (selectOnFocus) manager.replaceSelection(firstKey);
                }
                break;
            case "End":
                if (delegate.getLastKey) {
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, (0, $koOwD.isCtrlKeyPressed)(e));
                    manager.setFocusedKey(lastKey);
                    if ((0, $koOwD.isCtrlKeyPressed)(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(lastKey);
                    else if (selectOnFocus) manager.replaceSelection(lastKey);
                }
                break;
            case "PageDown":
                if (delegate.getKeyPageBelow) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "PageUp":
                if (delegate.getKeyPageAbove) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "a":
                if ((0, $koOwD.isCtrlKeyPressed)(e) && manager.selectionMode === "multiple" && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case "Escape":
                if (!disallowEmptySelection && manager.selectedKeys.size !== 0) {
                    e.stopPropagation();
                    e.preventDefault();
                    manager.clearSelection();
                }
                break;
            case "Tab":
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = (0, $kQVoJ.getFocusableTreeWalker)(ref.current, {
                            tabbable: true
                        });
                        let next;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        if (next && !next.contains(document.activeElement)) (0, $6Qamj.focusWithoutScrolling)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    let scrollPos = (0, $exYeM.useRef)({
        top: 0,
        left: 0
    });
    (0, $aVei0.useEvent)(scrollRef, "scroll", isVirtualized ? null : ()=>{
        scrollPos.current = {
            top: scrollRef.current.scrollTop,
            left: scrollRef.current.scrollLeft
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            let navigateToFirstKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _manager_lastSelectedKey, _manager_firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToFirstKey((_manager_lastSelectedKey = manager.lastSelectedKey) !== null && _manager_lastSelectedKey !== void 0 ? _manager_lastSelectedKey : delegate.getLastKey());
            else navigateToFirstKey((_manager_firstSelectedKey = manager.firstSelectedKey) !== null && _manager_firstSelectedKey !== void 0 ? _manager_firstSelectedKey : delegate.getFirstKey());
        } else if (!isVirtualized) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
        }
        if (!isVirtualized && manager.focusedKey != null) {
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element) {
                // This prevents a flash of focus on the first/last element in the collection, or the collection itself.
                if (!element.contains(document.activeElement)) (0, $6Qamj.focusWithoutScrolling)(element);
                let modality = (0, $cpAUK.getInteractionModality)();
                if (modality === "keyboard") (0, $d7oDp.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    const autoFocusRef = (0, $exYeM.useRef)(autoFocus);
    (0, $exYeM.useEffect)(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === "first") focusedKey = delegate.getFirstKey();
            if (autoFocus === "last") focusedKey = delegate.getLastKey();
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) {
                for (let key of selectedKeys)if (manager.canSelectItem(key)) {
                    focusedKey = key;
                    break;
                }
            }
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus) (0, $8zm8Z.focusSafely)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If not virtualized, scroll the focused element into view when the focusedKey changes.
    // When virtualized, Virtualizer handles this internally.
    let lastFocusedKey = (0, $exYeM.useRef)(manager.focusedKey);
    (0, $exYeM.useEffect)(()=>{
        let modality = (0, $cpAUK.getInteractionModality)();
        if (manager.isFocused && manager.focusedKey != null && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)) {
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element && (modality === "keyboard" || autoFocusRef.current)) {
                if (!isVirtualized) (0, $d7oDp.scrollIntoView)(scrollRef.current, element);
                // Avoid scroll in iOS VO, since it may cause overlay to close (i.e. RAC submenu)
                if (modality !== "virtual") (0, $d7oDp.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
        // If the focused key becomes null (e.g. the last item is deleted), focus the whole collection.
        if (manager.isFocused && manager.focusedKey == null && lastFocusedKey.current != null) (0, $8zm8Z.focusSafely)(ref.current);
        lastFocusedKey.current = manager.focusedKey;
        autoFocusRef.current = false;
    }, [
        isVirtualized,
        scrollRef,
        manager.focusedKey,
        manager.isFocused,
        ref
    ]);
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === e.target) e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps } = (0, $11YFZ.useTypeSelect)({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = (0, $8vAG4.mergeProps)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    // If using virtual focus, don't set a tabIndex at all so that VoiceOver on iOS 14 doesn't try
    // to move real DOM focus to the element anyway.
    let tabIndex;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    return {
        collectionProps: {
            ...handlers,
            tabIndex: tabIndex
        }
    };
}

});
parcelRegister("11YFZ", function(module, exports) {

$parcel$export(module.exports, "useTypeSelect", function () { return $0c04f378422633c1$export$e32c88dfddc6e1d8; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const $0c04f378422633c1$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $0c04f378422633c1$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate, selectionManager: selectionManager, onTypeSelect: onTypeSelect } = options;
    let state = (0, $exYeM.useRef)({
        search: "",
        timeout: null
    }).current;
    let onKeyDown = (e)=>{
        let character = $0c04f378422633c1$var$$fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target)) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === " " && state.search.trim().length > 0) {
            e.preventDefault();
            if (!("continuePropagation" in e)) e.stopPropagation();
        }
        state.search += character;
        // Use the delegate to find a key to focus.
        // Prioritize items after the currently focused item, falling back to searching the whole list.
        let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
        // If no key found, search from the top.
        if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
        if (key != null) {
            selectionManager.setFocusedKey(key);
            if (onTypeSelect) onTypeSelect(key);
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = "";
        }, $0c04f378422633c1$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : null
        }
    };
}
function $0c04f378422633c1$var$$fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return "";
}

});

parcelRegister("kQVoJ", function(module, exports) {

$parcel$export(module.exports, "getFocusableTreeWalker", function () { return $f2e53006994bc8e7$export$2d6ec8fc375ceafa; });

var $8zm8Z = parcelRequire("8zm8Z");

var $9fJOa = parcelRequire("9fJOa");

var $2ZDqh = parcelRequire("2ZDqh");
var $71dP2 = parcelRequire("71dP2");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f2e53006994bc8e7$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
let $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope = null;
function $f2e53006994bc8e7$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $exYeM.useRef)(null);
    let endRef = (0, $exYeM.useRef)(null);
    let scopeRef = (0, $exYeM.useRef)([]);
    let { parentNode: parentNode } = (0, $exYeM.useContext)($f2e53006994bc8e7$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $exYeM.useMemo)(()=>new $f2e53006994bc8e7$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $f2e53006994bc8e7$export$d06fae2ee68b101e.root;
        if ($f2e53006994bc8e7$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope && !$f2e53006994bc8e7$var$$9bf71ea28793e738$var$isAncestorScope($f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $f2e53006994bc8e7$export$d06fae2ee68b101e.getTreeNode($f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $f2e53006994bc8e7$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        let node = $f2e53006994bc8e7$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $f2e53006994bc8e7$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $f2e53006994bc8e7$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $f2e53006994bc8e7$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $f2e53006994bc8e7$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $exYeM.useEffect)(()=>{
        const activeElement = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $f2e53006994bc8e7$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $f2e53006994bc8e7$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $f2e53006994bc8e7$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope || $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $f2e53006994bc8e7$export$d06fae2ee68b101e.getTreeNode(parentScope))) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $f2e53006994bc8e7$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $exYeM.useMemo)(()=>$f2e53006994bc8e7$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $exYeM.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($f2e53006994bc8e7$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $f2e53006994bc8e7$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $exYeM.useContext)($f2e53006994bc8e7$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $f2e53006994bc8e7$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $f2e53006994bc8e7$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $f2e53006994bc8e7$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $f2e53006994bc8e7$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $f2e53006994bc8e7$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $f2e53006994bc8e7$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $f2e53006994bc8e7$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $f2e53006994bc8e7$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $f2e53006994bc8e7$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $f2e53006994bc8e7$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $f2e53006994bc8e7$export$4c063cf1350e6fed(element) {
    return element.matches($f2e53006994bc8e7$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $f2e53006994bc8e7$export$d06fae2ee68b101e.getTreeNode($f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $exYeM.useRef)();
    let raf = (0, $exYeM.useRef)();
    (0, $71dP2.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$f2e53006994bc8e7$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $f2e53006994bc8e7$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $f2e53006994bc8e7$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope || $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isAncestorScope($f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($f2e53006994bc8e7$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope && $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope.current) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusFirstInScope($f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($f2e53006994bc8e7$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $f2e53006994bc8e7$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope.current) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusFirstInScope($f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $f2e53006994bc8e7$export$d06fae2ee68b101e.traverse($f2e53006994bc8e7$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $f2e53006994bc8e7$export$1258395f99bf9cbf(element) {
    return $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInChildScope(element, $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope);
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $f2e53006994bc8e7$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $8zm8Z.focusSafely)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $f2e53006994bc8e7$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $f2e53006994bc8e7$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $f2e53006994bc8e7$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $f2e53006994bc8e7$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(nextNode);
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(autoFocus);
    (0, $exYeM.useEffect)(()=>{
        if (autoFocusRef.current) {
            $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $71dP2.useLayoutEffect)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $f2e53006994bc8e7$export$d06fae2ee68b101e.getTreeNode($f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $exYeM.useRef)(typeof document !== "undefined" ? (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $71dP2.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope || $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isAncestorScope($f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$f2e53006994bc8e7$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $f2e53006994bc8e7$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $f2e53006994bc8e7$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $f2e53006994bc8e7$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $f2e53006994bc8e7$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $f2e53006994bc8e7$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $f2e53006994bc8e7$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $f2e53006994bc8e7$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $f2e53006994bc8e7$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $f2e53006994bc8e7$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $f2e53006994bc8e7$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $2ZDqh.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, $9fJOa.isElementVisible)(node) && (!scope || $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $f2e53006994bc8e7$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(root).activeElement;
            let walker = $f2e53006994bc8e7$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(root).activeElement;
            let walker = $f2e53006994bc8e7$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $f2e53006994bc8e7$var$$9bf71ea28793e738$var$last(walker);
                if (next) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $f2e53006994bc8e7$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $f2e53006994bc8e7$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $f2e53006994bc8e7$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $f2e53006994bc8e7$var$$9bf71ea28793e738$var$last(walker);
            if (next) $f2e53006994bc8e7$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $f2e53006994bc8e7$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $f2e53006994bc8e7$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $f2e53006994bc8e7$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $f2e53006994bc8e7$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $f2e53006994bc8e7$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $f2e53006994bc8e7$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $f2e53006994bc8e7$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $f2e53006994bc8e7$export$d06fae2ee68b101e = new $f2e53006994bc8e7$var$$9bf71ea28793e738$var$Tree();

});
parcelRegister("9fJOa", function(module, exports) {

$parcel$export(module.exports, "isElementVisible", function () { return $6bc90c4fb0f85892$export$e989c0fffaa6b27a; });

var $2ZDqh = parcelRequire("2ZDqh");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6bc90c4fb0f85892$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $6bc90c4fb0f85892$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $6bc90c4fb0f85892$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $6bc90c4fb0f85892$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $6bc90c4fb0f85892$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $6bc90c4fb0f85892$export$e989c0fffaa6b27a(element.parentElement, element));
}

});



parcelRegister("colLn", function(module, exports) {

$parcel$export(module.exports, "ListKeyboardDelegate", function () { return $90589ba20b57b02b$export$a05409b8bb224a5a; });

var $k0Xsz = parcelRequire("k0Xsz");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $90589ba20b57b02b$export$a05409b8bb224a5a {
    isDisabled(item) {
        var _item_props;
        return this.disabledBehavior === "all" && (((_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || this.disabledKeys.has(item.key));
    }
    getNextKey(key) {
        key = this.collection.getKeyAfter(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.isDisabled(item)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getPreviousKey(key) {
        key = this.collection.getKeyBefore(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.isDisabled(item)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    findKey(key, nextKey, shouldSkip) {
        let item = this.getItem(key);
        if (!item) return null;
        // Find the item above or below in the same column.
        let prevRect = item.getBoundingClientRect();
        do {
            key = nextKey(key);
            item = this.getItem(key);
        }while (item && shouldSkip(prevRect, item.getBoundingClientRect()));
        return key;
    }
    isSameRow(prevRect, itemRect) {
        return prevRect.top === itemRect.top || prevRect.left !== itemRect.left;
    }
    isSameColumn(prevRect, itemRect) {
        return prevRect.left === itemRect.left || prevRect.top !== itemRect.top;
    }
    getKeyBelow(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getNextKey(key), this.isSameRow);
        else return this.getNextKey(key);
    }
    getKeyAbove(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getPreviousKey(key), this.isSameRow);
        else return this.getPreviousKey(key);
    }
    getNextColumn(key, right) {
        return right ? this.getPreviousKey(key) : this.getNextKey(key);
    }
    getKeyRightOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "rtl");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "rtl"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "rtl");
        return null;
    }
    getKeyLeftOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "ltr");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "ltr"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "ltr");
        return null;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if ((item === null || item === void 0 ? void 0 : item.type) === "item" && !this.isDisabled(item)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.isDisabled(item)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    getItem(key) {
        return key !== null ? this.ref.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`) : null;
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, $k0Xsz.isScrollable)(menu)) return this.getFirstKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.max(0, itemRect.x - containerX + itemRect.width - containerRect.width);
            while(item && itemRect.x - containerX > pageX){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.max(0, itemRect.y - containerY + itemRect.height - containerRect.height);
            while(item && itemRect.y - containerY > pageY){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getFirstKey();
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, $k0Xsz.isScrollable)(menu)) return this.getLastKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.min(menu.scrollWidth, itemRect.x - containerX - itemRect.width + containerRect.width);
            while(item && itemRect.x - containerX < pageX){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.min(menu.scrollHeight, itemRect.y - containerY - itemRect.height + containerRect.height);
            while(item && itemRect.y - containerY < pageY){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getLastKey();
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getKeyBelow(key);
        }
        return null;
    }
    constructor(...args){
        if (args.length === 1) {
            let opts = args[0];
            this.collection = opts.collection;
            this.ref = opts.ref;
            this.collator = opts.collator;
            this.disabledKeys = opts.disabledKeys || new Set();
            this.disabledBehavior = opts.disabledBehavior || "all";
            this.orientation = opts.orientation;
            this.direction = opts.direction;
            this.layout = opts.layout || "stack";
        } else {
            this.collection = args[0];
            this.disabledKeys = args[1];
            this.ref = args[2];
            this.collator = args[3];
            this.layout = "stack";
            this.orientation = "vertical";
            this.disabledBehavior = "all";
        }
        // If this is a vertical stack, remove the left/right methods completely
        // so they aren't called by useDroppableCollection.
        if (this.layout === "stack" && this.orientation === "vertical") {
            this.getKeyLeftOf = undefined;
            this.getKeyRightOf = undefined;
        }
    }
}

});


parcelRegister("jXecf", function(module, exports) {

$parcel$export(module.exports, "getItemCount", function () { return $e86e8a298762500c$export$77d5aafae4e095b2; });

var $bdcQ4 = parcelRequire("bdcQ4");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e86e8a298762500c$var$$453cc9f0df89c0a5$var$cache = new WeakMap();
function $e86e8a298762500c$export$77d5aafae4e095b2(collection) {
    let count = $e86e8a298762500c$var$$453cc9f0df89c0a5$var$cache.get(collection);
    if (count != null) return count;
    count = 0;
    let countItems = (items)=>{
        for (let item of items)if (item.type === "section") countItems((0, $bdcQ4.getChildNodes)(item, collection));
        else count++;
    };
    countItems(collection);
    $e86e8a298762500c$var$$453cc9f0df89c0a5$var$cache.set(collection, count);
    return count;
}

});


parcelRegister("ekziR", function(module, exports) {

$parcel$export(module.exports, "useTypeSelect", function () { return $a6ee516f41e11b4a$export$e32c88dfddc6e1d8; });
$parcel$export(module.exports, "ListKeyboardDelegate", function () { return $a6ee516f41e11b4a$export$a05409b8bb224a5a; });

var $d2lNW = parcelRequire("d2lNW");

var $exYeM = parcelRequire("exYeM");

var $1efMh = parcelRequire("1efMh");
var $i1IkK = parcelRequire("i1IkK");

var $6Qamj = parcelRequire("6Qamj");
var $gbqqi = parcelRequire("gbqqi");
var $k0Xsz = parcelRequire("k0Xsz");
var $8vAG4 = parcelRequire("8vAG4");
var $h6krv = parcelRequire("h6krv");
var $d7oDp = parcelRequire("d7oDp");
var $aVei0 = parcelRequire("aVei0");

var $lnAK3 = parcelRequire("lnAK3");
var $agR94 = parcelRequire("agR94");
var $eDqWa = parcelRequire("eDqWa");

var $i4QhB = parcelRequire("i4QhB");
var $es7WB = parcelRequire("es7WB");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a6ee516f41e11b4a$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, $gbqqi.isAppleDevice)() ? e.altKey : e.ctrlKey;
}
function $a6ee516f41e11b4a$var$$feb5ffebff200149$export$16792effe837dba3(e) {
    if ((0, $gbqqi.isMac)()) return e.metaKey;
    return e.ctrlKey;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const $a6ee516f41e11b4a$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $a6ee516f41e11b4a$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate, selectionManager: selectionManager, onTypeSelect: onTypeSelect } = options;
    let state = (0, $exYeM.useRef)({
        search: "",
        timeout: null
    }).current;
    let onKeyDown = (e)=>{
        let character = $a6ee516f41e11b4a$var$$fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target)) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === " " && state.search.trim().length > 0) {
            e.preventDefault();
            if (!("continuePropagation" in e)) e.stopPropagation();
        }
        state.search += character;
        // Use the delegate to find a key to focus.
        // Prioritize items after the currently focused item, falling back to searching the whole list.
        let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
        // If no key found, search from the top.
        if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
        if (key != null) {
            selectionManager.setFocusedKey(key);
            if (onTypeSelect) onTypeSelect(key);
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = "";
        }, $a6ee516f41e11b4a$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : null
        }
    };
}
function $a6ee516f41e11b4a$var$$fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return "";
}
function $a6ee516f41e11b4a$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager, keyboardDelegate: delegate, ref: ref, autoFocus: autoFocus = false, shouldFocusWrap: shouldFocusWrap = false, disallowEmptySelection: disallowEmptySelection = false, disallowSelectAll: disallowSelectAll = false, selectOnFocus: selectOnFocus = manager.selectionBehavior === "replace", disallowTypeAhead: disallowTypeAhead = false, shouldUseVirtualFocus: shouldUseVirtualFocus, allowsTabNavigation: allowsTabNavigation = false, isVirtualized: isVirtualized, scrollRef: scrollRef = ref, linkBehavior: linkBehavior = "action" } = options;
    let { direction: direction } = (0, $es7WB.useLocale)();
    let router = (0, $h6krv.useRouter)();
    let onKeyDown = (e)=>{
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === "Tab") e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!ref.current.contains(e.target)) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                if (manager.isLink(key) && linkBehavior === "selection" && selectOnFocus && !$a6ee516f41e11b4a$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e)) {
                    (0, $d2lNW.flushSync)(()=>{
                        manager.setFocusedKey(key, childFocus);
                    });
                    let item = scrollRef.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`);
                    router.open(item, e);
                    return;
                }
                manager.setFocusedKey(key, childFocus);
                if (manager.isLink(key) && linkBehavior === "override") return;
                if (e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(key);
                else if (selectOnFocus && !$a6ee516f41e11b4a$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case "ArrowDown":
                if (delegate.getKeyBelow) {
                    var _delegate_getFirstKey, _delegate_getFirstKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyBelow(manager.focusedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowUp":
                if (delegate.getKeyAbove) {
                    var _delegate_getLastKey, _delegate_getLastKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyAbove(manager.focusedKey) : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getLastKey1 = delegate.getLastKey) === null || _delegate_getLastKey1 === void 0 ? void 0 : _delegate_getLastKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowLeft":
                if (delegate.getKeyLeftOf) {
                    var _delegate_getFirstKey2, _delegate_getLastKey2;
                    e.preventDefault();
                    let nextKey = delegate.getKeyLeftOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getFirstKey2 = delegate.getFirstKey) === null || _delegate_getFirstKey2 === void 0 ? void 0 : _delegate_getFirstKey2.call(delegate, manager.focusedKey) : (_delegate_getLastKey2 = delegate.getLastKey) === null || _delegate_getLastKey2 === void 0 ? void 0 : _delegate_getLastKey2.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "first" : "last");
                }
                break;
            case "ArrowRight":
                if (delegate.getKeyRightOf) {
                    var _delegate_getLastKey3, _delegate_getFirstKey3;
                    e.preventDefault();
                    let nextKey = delegate.getKeyRightOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getLastKey3 = delegate.getLastKey) === null || _delegate_getLastKey3 === void 0 ? void 0 : _delegate_getLastKey3.call(delegate, manager.focusedKey) : (_delegate_getFirstKey3 = delegate.getFirstKey) === null || _delegate_getFirstKey3 === void 0 ? void 0 : _delegate_getFirstKey3.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "last" : "first");
                }
                break;
            case "Home":
                if (delegate.getFirstKey) {
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, $a6ee516f41e11b4a$var$$feb5ffebff200149$export$16792effe837dba3(e));
                    manager.setFocusedKey(firstKey);
                    if ($a6ee516f41e11b4a$var$$feb5ffebff200149$export$16792effe837dba3(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(firstKey);
                    else if (selectOnFocus) manager.replaceSelection(firstKey);
                }
                break;
            case "End":
                if (delegate.getLastKey) {
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, $a6ee516f41e11b4a$var$$feb5ffebff200149$export$16792effe837dba3(e));
                    manager.setFocusedKey(lastKey);
                    if ($a6ee516f41e11b4a$var$$feb5ffebff200149$export$16792effe837dba3(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(lastKey);
                    else if (selectOnFocus) manager.replaceSelection(lastKey);
                }
                break;
            case "PageDown":
                if (delegate.getKeyPageBelow) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "PageUp":
                if (delegate.getKeyPageAbove) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "a":
                if ($a6ee516f41e11b4a$var$$feb5ffebff200149$export$16792effe837dba3(e) && manager.selectionMode === "multiple" && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case "Escape":
                e.preventDefault();
                if (!disallowEmptySelection) manager.clearSelection();
                break;
            case "Tab":
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = (0, $i1IkK.getFocusableTreeWalker)(ref.current, {
                            tabbable: true
                        });
                        let next;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        if (next && !next.contains(document.activeElement)) (0, $6Qamj.focusWithoutScrolling)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    let scrollPos = (0, $exYeM.useRef)({
        top: 0,
        left: 0
    });
    (0, $aVei0.useEvent)(scrollRef, "scroll", isVirtualized ? null : ()=>{
        scrollPos.current = {
            top: scrollRef.current.scrollTop,
            left: scrollRef.current.scrollLeft
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            let navigateToFirstKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _manager_lastSelectedKey, _manager_firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToFirstKey((_manager_lastSelectedKey = manager.lastSelectedKey) !== null && _manager_lastSelectedKey !== void 0 ? _manager_lastSelectedKey : delegate.getLastKey());
            else navigateToFirstKey((_manager_firstSelectedKey = manager.firstSelectedKey) !== null && _manager_firstSelectedKey !== void 0 ? _manager_firstSelectedKey : delegate.getFirstKey());
        } else if (!isVirtualized) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
        }
        if (!isVirtualized && manager.focusedKey != null) {
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element) {
                // This prevents a flash of focus on the first/last element in the collection, or the collection itself.
                if (!element.contains(document.activeElement)) (0, $6Qamj.focusWithoutScrolling)(element);
                let modality = (0, $lnAK3.getInteractionModality)();
                if (modality === "keyboard") (0, $d7oDp.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    const autoFocusRef = (0, $exYeM.useRef)(autoFocus);
    (0, $exYeM.useEffect)(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === "first") focusedKey = delegate.getFirstKey();
            if (autoFocus === "last") focusedKey = delegate.getLastKey();
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) {
                for (let key of selectedKeys)if (manager.canSelectItem(key)) {
                    focusedKey = key;
                    break;
                }
            }
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus) (0, $1efMh.focusSafely)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If not virtualized, scroll the focused element into view when the focusedKey changes.
    // When virtualized, Virtualizer handles this internally.
    let lastFocusedKey = (0, $exYeM.useRef)(manager.focusedKey);
    (0, $exYeM.useEffect)(()=>{
        let modality = (0, $lnAK3.getInteractionModality)();
        if (manager.isFocused && manager.focusedKey != null && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)) {
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element && (modality === "keyboard" || autoFocusRef.current)) {
                if (!isVirtualized) (0, $d7oDp.scrollIntoView)(scrollRef.current, element);
                // Avoid scroll in iOS VO, since it may cause overlay to close (i.e. RAC submenu)
                if (modality !== "virtual") (0, $d7oDp.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
        // If the focused key becomes null (e.g. the last item is deleted), focus the whole collection.
        if (manager.isFocused && manager.focusedKey == null && lastFocusedKey.current != null) (0, $1efMh.focusSafely)(ref.current);
        lastFocusedKey.current = manager.focusedKey;
        autoFocusRef.current = false;
    }, [
        isVirtualized,
        scrollRef,
        manager.focusedKey,
        manager.isFocused,
        ref
    ]);
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === e.target) e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps } = $a6ee516f41e11b4a$export$e32c88dfddc6e1d8({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = (0, $8vAG4.mergeProps)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    // If using virtual focus, don't set a tabIndex at all so that VoiceOver on iOS 14 doesn't try
    // to move real DOM focus to the element anyway.
    let tabIndex;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    return {
        collectionProps: {
            ...handlers,
            tabIndex: tabIndex
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a6ee516f41e11b4a$export$ecf600387e221c37(options) {
    let { selectionManager: manager, key: key, ref: ref, shouldSelectOnPressUp: shouldSelectOnPressUp, shouldUseVirtualFocus: shouldUseVirtualFocus, focus: focus, isDisabled: isDisabled, onAction: onAction, allowsDifferentPressOrigin: allowsDifferentPressOrigin, linkBehavior: linkBehavior = "action" } = options;
    let router = (0, $h6krv.useRouter)();
    let onSelect = (e)=>{
        if (e.pointerType === "keyboard" && $a6ee516f41e11b4a$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === "none") return;
            if (manager.isLink(key)) {
                if (linkBehavior === "selection") {
                    router.open(ref.current, e);
                    // Always set selected keys back to what they were so that select and combobox close.
                    manager.setSelectedKeys(manager.selectedKeys);
                    return;
                } else if (linkBehavior === "override" || linkBehavior === "none") return;
            }
            if (manager.selectionMode === "single") {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === "toggle" || e && ($a6ee516f41e11b4a$var$$feb5ffebff200149$export$16792effe837dba3(e) || e.pointerType === "touch" || e.pointerType === "virtual")) manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    (0, $exYeM.useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused && !shouldUseVirtualFocus) {
            if (focus) focus();
            else if (document.activeElement !== ref.current) (0, $1efMh.focusSafely)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let isLinkOverride = manager.isLink(key) && linkBehavior === "override";
    let hasLinkAction = manager.isLink(key) && linkBehavior !== "selection" && linkBehavior !== "none";
    let allowsSelection = !isDisabled && manager.canSelectItem(key) && !isLinkOverride;
    let allowsActions = (onAction || hasLinkAction) && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === "replace" ? !allowsSelection : !allowsSelection || manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === "replace";
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (0, $exYeM.useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (0, $exYeM.useRef)(false);
    let hadPrimaryActionOnPressStart = (0, $exYeM.useRef)(false);
    let performAction = (e)=>{
        if (onAction) onAction();
        if (hasLinkAction) router.open(ref.current, e);
    };
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {};
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === "keyboard" && (!hasAction || $a6ee516f41e11b4a$var$$880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== "mouse") {
                if (e.pointerType === "keyboard" && !$a6ee516f41e11b4a$var$$880e95eb8b93ba9a$var$isActionKey()) return;
                performAction(e);
            } else if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
        };
        else {
            itemPressProps.onPressUp = hasPrimaryAction ? null : (e)=>{
                if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? performAction : null;
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (allowsSelection && (e.pointerType === "mouse" && !hasPrimaryAction || e.pointerType === "keyboard" && (!allowsActions || $a6ee516f41e11b4a$var$$880e95eb8b93ba9a$var$isSelectionKey()))) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === "touch" || e.pointerType === "pen" || e.pointerType === "virtual" || e.pointerType === "keyboard" && hasAction && $a6ee516f41e11b4a$var$$880e95eb8b93ba9a$var$isActionKey() || e.pointerType === "mouse" && hadPrimaryActionOnPressStart.current) {
                if (hasAction) performAction(e);
                else if (allowsSelection) onSelect(e);
            }
        };
    }
    itemProps["data-key"] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    let { pressProps: pressProps, isPressed: isPressed } = (0, $eDqWa.usePress)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === "mouse") {
            e.stopPropagation();
            e.preventDefault();
            performAction(e);
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps } = (0, $agR94.useLongPress)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === "touch") {
                onSelect(e);
                manager.setSelectionBehavior("toggle");
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === "touch" && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    // Prevent default on link clicks so that we control exactly
    // when they open (to match selection behavior).
    let onClick = manager.isLink(key) ? (e)=>{
        if (!(0, $h6krv.openLink).isOpening) e.preventDefault();
    } : undefined;
    return {
        itemProps: (0, $8vAG4.mergeProps)(itemProps, allowsSelection || hasPrimaryAction ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStartCapture: onDragStartCapture,
            onClick: onClick
        }),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isFocused: manager.isFocused && manager.focusedKey === key,
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $a6ee516f41e11b4a$var$$880e95eb8b93ba9a$var$isActionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === "Enter";
}
function $a6ee516f41e11b4a$var$$880e95eb8b93ba9a$var$isSelectionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === " " || (event === null || event === void 0 ? void 0 : event.code) === "Space";
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $a6ee516f41e11b4a$export$a05409b8bb224a5a {
    getNextKey(key) {
        key = this.collection.getKeyAfter(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getPreviousKey(key) {
        key = this.collection.getKeyBefore(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    findKey(key, nextKey, shouldSkip) {
        let item = this.getItem(key);
        if (!item) return null;
        // Find the item above or below in the same column.
        let prevRect = item.getBoundingClientRect();
        do {
            key = nextKey(key);
            item = this.getItem(key);
        }while (item && shouldSkip(prevRect, item.getBoundingClientRect()));
        return key;
    }
    isSameRow(prevRect, itemRect) {
        return prevRect.top === itemRect.top || prevRect.left !== itemRect.left;
    }
    isSameColumn(prevRect, itemRect) {
        return prevRect.left === itemRect.left || prevRect.top !== itemRect.top;
    }
    getKeyBelow(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getNextKey(key), this.isSameRow);
        else return this.getNextKey(key);
    }
    getKeyAbove(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getPreviousKey(key), this.isSameRow);
        else return this.getPreviousKey(key);
    }
    getNextColumn(key, right) {
        return right ? this.getPreviousKey(key) : this.getNextKey(key);
    }
    getKeyRightOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "rtl");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "rtl"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "rtl");
        return null;
    }
    getKeyLeftOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "ltr");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "ltr"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "ltr");
        return null;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if ((item === null || item === void 0 ? void 0 : item.type) === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    getItem(key) {
        return this.ref.current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`);
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, $k0Xsz.isScrollable)(menu)) return this.getFirstKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.max(0, itemRect.x - containerX + itemRect.width - containerRect.width);
            while(item && itemRect.x - containerX > pageX){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.max(0, itemRect.y - containerY + itemRect.height - containerRect.height);
            while(item && itemRect.y - containerY > pageY){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getFirstKey();
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, $k0Xsz.isScrollable)(menu)) return this.getLastKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.min(menu.scrollWidth, itemRect.x - containerX - itemRect.width + containerRect.width);
            while(item && itemRect.x - containerX < pageX){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.min(menu.scrollHeight, itemRect.y - containerY - itemRect.height + containerRect.height);
            while(item && itemRect.y - containerY < pageY){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getLastKey();
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getKeyBelow(key);
        }
        return null;
    }
    constructor(...args){
        if (args.length === 1) {
            let opts = args[0];
            this.collection = opts.collection;
            this.ref = opts.ref;
            this.collator = opts.collator;
            this.disabledKeys = opts.disabledKeys || new Set();
            this.orientation = opts.orientation;
            this.direction = opts.direction;
            this.layout = opts.layout || "stack";
        } else {
            this.collection = args[0];
            this.disabledKeys = args[1];
            this.ref = args[2];
            this.collator = args[3];
            this.layout = "stack";
            this.orientation = "vertical";
        }
        // If this is a vertical stack, remove the left/right methods completely
        // so they aren't called by useDroppableCollection.
        if (this.layout === "stack" && this.orientation === "vertical") {
            this.getKeyLeftOf = undefined;
            this.getKeyRightOf = undefined;
        }
    }
}
function $a6ee516f41e11b4a$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager, collection: collection, disabledKeys: disabledKeys, ref: ref, keyboardDelegate: keyboardDelegate } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $i4QhB.useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let disabledBehavior = selectionManager.disabledBehavior;
    let delegate = (0, $exYeM.useMemo)(()=>keyboardDelegate || new $a6ee516f41e11b4a$export$a05409b8bb224a5a(collection, disabledBehavior === "selection" ? new Set() : disabledKeys, ref, collator), [
        keyboardDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior
    ]);
    let { collectionProps: collectionProps } = $a6ee516f41e11b4a$export$d6daf82dcd84e87c({
        ...props,
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate
    });
    return {
        listProps: collectionProps
    };
}

});
parcelRegister("1efMh", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $0e535661d0d86a3e$export$80f3e147d781571c; });

var $6Qamj = parcelRequire("6Qamj");
var $2ZDqh = parcelRequire("2ZDqh");
var $jgteb = parcelRequire("jgteb");

var $dnayS = parcelRequire("dnayS");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0e535661d0d86a3e$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $2ZDqh.getOwnerDocument)(element);
    if ((0, $dnayS.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $jgteb.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $6Qamj.focusWithoutScrolling)(element);
        });
    } else (0, $6Qamj.focusWithoutScrolling)(element);
}

});
parcelRegister("dnayS", function(module, exports) {

$parcel$export(module.exports, "getInteractionModality", function () { return $9bc59d9e8e566eaf$export$630ff653c5ada6a9; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$currentModality = null;
let $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $9bc59d9e8e566eaf$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $gbqqi.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $87CgO.isVirtualClick)(e)) {
        $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $9bc59d9e8e566eaf$export$d90243b58daecda7.get((0, $2ZDqh.getOwnerWindow)(element))) return;
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $9bc59d9e8e566eaf$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$9bc59d9e8e566eaf$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $9bc59d9e8e566eaf$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $9bc59d9e8e566eaf$export$d90243b58daecda7.delete(windowObject);
};
function $9bc59d9e8e566eaf$export$2f1888112f558a7d(element) {
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $9bc59d9e8e566eaf$export$2f1888112f558a7d();
function $9bc59d9e8e566eaf$export$b9b3dfddab17db27() {
    return $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $9bc59d9e8e566eaf$export$630ff653c5ada6a9() {
    return $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$currentModality;
}
function $9bc59d9e8e566eaf$export$8397ddfc504fdb9a(modality) {
    $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$currentModality = modality;
    $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $9bc59d9e8e566eaf$export$98e20ec92f614cfe() {
    $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $exYeM.useState)($9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$currentModality);
    (0, $exYeM.useEffect)(()=>{
        let handler = ()=>{
            setModality($9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$currentModality);
        };
        $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $aVmq3.useIsSSR)() ? null : modality;
}
const $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $9bc59d9e8e566eaf$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(autoFocus || $9bc59d9e8e566eaf$export$b9b3dfddab17db27());
    $9bc59d9e8e566eaf$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $9bc59d9e8e566eaf$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $exYeM.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($9bc59d9e8e566eaf$export$b9b3dfddab17db27());
        };
        $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $9bc59d9e8e566eaf$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("i1IkK", function(module, exports) {

$parcel$export(module.exports, "getFocusableTreeWalker", function () { return $d1fab5bdbfc693ec$export$2d6ec8fc375ceafa; });

var $1efMh = parcelRequire("1efMh");

var $1IEu0 = parcelRequire("1IEu0");

var $2ZDqh = parcelRequire("2ZDqh");
var $71dP2 = parcelRequire("71dP2");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
let $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope = null;
function $d1fab5bdbfc693ec$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $exYeM.useRef)(null);
    let endRef = (0, $exYeM.useRef)(null);
    let scopeRef = (0, $exYeM.useRef)([]);
    let { parentNode: parentNode } = (0, $exYeM.useContext)($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $exYeM.useMemo)(()=>new $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $d1fab5bdbfc693ec$export$d06fae2ee68b101e.root;
        if ($d1fab5bdbfc693ec$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope && !$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isAncestorScope($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $d1fab5bdbfc693ec$export$d06fae2ee68b101e.getTreeNode($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $d1fab5bdbfc693ec$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        let node = $d1fab5bdbfc693ec$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $exYeM.useEffect)(()=>{
        const activeElement = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $d1fab5bdbfc693ec$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $d1fab5bdbfc693ec$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $d1fab5bdbfc693ec$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope || $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $d1fab5bdbfc693ec$export$d06fae2ee68b101e.getTreeNode(parentScope))) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $d1fab5bdbfc693ec$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $exYeM.useMemo)(()=>$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $exYeM.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $d1fab5bdbfc693ec$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $exYeM.useContext)($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $d1fab5bdbfc693ec$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $d1fab5bdbfc693ec$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $d1fab5bdbfc693ec$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $d1fab5bdbfc693ec$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $d1fab5bdbfc693ec$export$4c063cf1350e6fed(element) {
    return element.matches($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $d1fab5bdbfc693ec$export$d06fae2ee68b101e.getTreeNode($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $exYeM.useRef)();
    let raf = (0, $exYeM.useRef)();
    (0, $71dP2.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $d1fab5bdbfc693ec$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope || $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isAncestorScope($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope && $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope.current) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusFirstInScope($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope.current) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusFirstInScope($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $d1fab5bdbfc693ec$export$d06fae2ee68b101e.traverse($d1fab5bdbfc693ec$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $d1fab5bdbfc693ec$export$1258395f99bf9cbf(element) {
    return $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInChildScope(element, $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope);
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $d1fab5bdbfc693ec$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $1efMh.focusSafely)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $d1fab5bdbfc693ec$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $d1fab5bdbfc693ec$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(nextNode);
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(autoFocus);
    (0, $exYeM.useEffect)(()=>{
        if (autoFocusRef.current) {
            $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $71dP2.useLayoutEffect)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $d1fab5bdbfc693ec$export$d06fae2ee68b101e.getTreeNode($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $exYeM.useRef)(typeof document !== "undefined" ? (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $71dP2.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope || $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isAncestorScope($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $d1fab5bdbfc693ec$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $d1fab5bdbfc693ec$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $71dP2.useLayoutEffect)(()=>{
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $d1fab5bdbfc693ec$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $d1fab5bdbfc693ec$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $d1fab5bdbfc693ec$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $d1fab5bdbfc693ec$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $d1fab5bdbfc693ec$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $2ZDqh.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, $1IEu0.isElementVisible)(node) && (!scope || $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $d1fab5bdbfc693ec$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(root).activeElement;
            let walker = $d1fab5bdbfc693ec$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $2ZDqh.getOwnerDocument)(root).activeElement;
            let walker = $d1fab5bdbfc693ec$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$last(walker);
                if (next) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $d1fab5bdbfc693ec$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $d1fab5bdbfc693ec$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$last(walker);
            if (next) $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $d1fab5bdbfc693ec$export$d06fae2ee68b101e = new $d1fab5bdbfc693ec$var$$9bf71ea28793e738$var$Tree();

});
parcelRegister("1IEu0", function(module, exports) {

$parcel$export(module.exports, "isElementVisible", function () { return $14094d95eb03efdb$export$e989c0fffaa6b27a; });

var $2ZDqh = parcelRequire("2ZDqh");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $14094d95eb03efdb$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $14094d95eb03efdb$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $14094d95eb03efdb$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $14094d95eb03efdb$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $14094d95eb03efdb$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $14094d95eb03efdb$export$e989c0fffaa6b27a(element.parentElement, element));
}

});


parcelRegister("lnAK3", function(module, exports) {

$parcel$export(module.exports, "getInteractionModality", function () { return $f9083f1a76cccaf9$export$630ff653c5ada6a9; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$currentModality = null;
let $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $f9083f1a76cccaf9$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $gbqqi.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $87CgO.isVirtualClick)(e)) {
        $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $f9083f1a76cccaf9$export$d90243b58daecda7.get((0, $2ZDqh.getOwnerWindow)(element))) return;
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $f9083f1a76cccaf9$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$f9083f1a76cccaf9$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $f9083f1a76cccaf9$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $f9083f1a76cccaf9$export$d90243b58daecda7.delete(windowObject);
};
function $f9083f1a76cccaf9$export$2f1888112f558a7d(element) {
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $f9083f1a76cccaf9$export$2f1888112f558a7d();
function $f9083f1a76cccaf9$export$b9b3dfddab17db27() {
    return $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $f9083f1a76cccaf9$export$630ff653c5ada6a9() {
    return $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$currentModality;
}
function $f9083f1a76cccaf9$export$8397ddfc504fdb9a(modality) {
    $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$currentModality = modality;
    $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $f9083f1a76cccaf9$export$98e20ec92f614cfe() {
    $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $exYeM.useState)($f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$currentModality);
    (0, $exYeM.useEffect)(()=>{
        let handler = ()=>{
            setModality($f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$currentModality);
        };
        $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $aVmq3.useIsSSR)() ? null : modality;
}
const $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $f9083f1a76cccaf9$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(autoFocus || $f9083f1a76cccaf9$export$b9b3dfddab17db27());
    $f9083f1a76cccaf9$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $f9083f1a76cccaf9$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $exYeM.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($f9083f1a76cccaf9$export$b9b3dfddab17db27());
        };
        $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $f9083f1a76cccaf9$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});

parcelRegister("agR94", function(module, exports) {

$parcel$export(module.exports, "useLongPress", function () { return $77a49f8c19ada044$export$c24ed0104d07eab9; });

var $eDqWa = parcelRequire("eDqWa");

var $8vAG4 = parcelRequire("8vAG4");
var $6qwZD = parcelRequire("6qwZD");
var $aGeuR = parcelRequire("aGeuR");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $77a49f8c19ada044$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $77a49f8c19ada044$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $77a49f8c19ada044$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $exYeM.useRef)();
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $aGeuR.useGlobalListeners)();
    let { pressProps: pressProps } = (0, $eDqWa.usePress)({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, $6qwZD.useDescription)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $8vAG4.mergeProps)(pressProps, descriptionProps)
    };
}

});
parcelRegister("eDqWa", function(module, exports) {

$parcel$export(module.exports, "usePress", function () { return $aa799a631118708e$export$45712eceda6fad21; });

var $9Hzim = parcelRequire("9Hzim");

var $kBhI7 = parcelRequire("kBhI7");

var $29jGr = parcelRequire("29jGr");

var $6DVYY = parcelRequire("6DVYY");

var $iAON1 = parcelRequire("iAON1");

var $kdWpA = parcelRequire("kdWpA");
var $6Qamj = parcelRequire("6Qamj");
var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");
var $8vAG4 = parcelRequire("8vAG4");
var $h6krv = parcelRequire("h6krv");
var $4sExG = parcelRequire("4sExG");
var $aGeuR = parcelRequire("aGeuR");
var $hbWr9 = parcelRequire("hbWr9");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $aa799a631118708e$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $exYeM.useContext)((0, $kBhI7.PressResponderContext));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $8vAG4.mergeProps)(contextProps, props);
        register();
    }
    (0, $hbWr9.useSyncRef)(context, props.ref);
    return props;
}
var $aa799a631118708e$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $aa799a631118708e$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $iAON1._)(this, $aa799a631118708e$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $29jGr._)(this, $aa799a631118708e$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $6DVYY._)(this, $aa799a631118708e$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $iAON1._)(this, $aa799a631118708e$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $aa799a631118708e$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $aa799a631118708e$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $aa799a631118708e$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $exYeM.useState)(false);
    let ref = (0, $exYeM.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $aGeuR.useGlobalListeners)();
    let triggerPressStart = (0, $4sExG.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $aa799a631118708e$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $4sExG.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $aa799a631118708e$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $aa799a631118708e$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $4sExG.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $aa799a631118708e$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $4sExG.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($aa799a631118708e$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $9Hzim.restoreTextSelection)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $4sExG.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $exYeM.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($aa799a631118708e$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($aa799a631118708e$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($aa799a631118708e$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($aa799a631118708e$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "keyup", (0, $kdWpA.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $gbqqi.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $h6krv.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $87CgO.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $aa799a631118708e$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($aa799a631118708e$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($aa799a631118708e$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $aa799a631118708e$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$aa799a631118708e$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$aa799a631118708e$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $h6krv.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $87CgO.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($aa799a631118708e$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $9Hzim.disableTextSelection)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($aa799a631118708e$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $aa799a631118708e$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $aa799a631118708e$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($aa799a631118708e$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($aa799a631118708e$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($aa799a631118708e$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($aa799a631118708e$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($aa799a631118708e$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $9Hzim.restoreTextSelection)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($aa799a631118708e$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $87CgO.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $aa799a631118708e$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($aa799a631118708e$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($aa799a631118708e$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $aa799a631118708e$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $9Hzim.disableTextSelection)(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $2ZDqh.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $aa799a631118708e$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $aa799a631118708e$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $aa799a631118708e$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $aa799a631118708e$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $9Hzim.restoreTextSelection)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $exYeM.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $9Hzim.restoreTextSelection)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $8vAG4.mergeProps)(domProps, pressProps)
    };
}
function $aa799a631118708e$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $aa799a631118708e$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $2ZDqh.getOwnerWindow)(element).HTMLInputElement && !$aa799a631118708e$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $2ZDqh.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $aa799a631118708e$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $aa799a631118708e$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $aa799a631118708e$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $aa799a631118708e$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $aa799a631118708e$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $aa799a631118708e$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $aa799a631118708e$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $aa799a631118708e$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $aa799a631118708e$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $aa799a631118708e$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $aa799a631118708e$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$aa799a631118708e$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($aa799a631118708e$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $aa799a631118708e$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $aa799a631118708e$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $aa799a631118708e$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}

});
parcelRegister("9Hzim", function(module, exports) {

$parcel$export(module.exports, "disableTextSelection", function () { return $7103821763fc07af$export$16a4697467175487; });
$parcel$export(module.exports, "restoreTextSelection", function () { return $7103821763fc07af$export$b0d6fa1ab32e3295; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $jgteb = parcelRequire("jgteb");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $7103821763fc07af$var$$14c0b72509d70225$var$state = "default";
let $7103821763fc07af$var$$14c0b72509d70225$var$savedUserSelect = "";
let $7103821763fc07af$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $7103821763fc07af$export$16a4697467175487(target) {
    if ((0, $gbqqi.isIOS)()) {
        if ($7103821763fc07af$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $2ZDqh.getOwnerDocument)(target);
            $7103821763fc07af$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $7103821763fc07af$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $7103821763fc07af$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $7103821763fc07af$export$b0d6fa1ab32e3295(target) {
    if ((0, $gbqqi.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($7103821763fc07af$var$$14c0b72509d70225$var$state !== "disabled") return;
        $7103821763fc07af$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $jgteb.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($7103821763fc07af$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $2ZDqh.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $7103821763fc07af$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $7103821763fc07af$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $7103821763fc07af$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $7103821763fc07af$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $7103821763fc07af$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $7103821763fc07af$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}

});

parcelRegister("kBhI7", function(module, exports) {

$parcel$export(module.exports, "PressResponderContext", function () { return $eff5004e9ef9520d$export$5165eccb35aaadb5; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $eff5004e9ef9520d$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({
    register: ()=>{}
});
$eff5004e9ef9520d$export$5165eccb35aaadb5.displayName = "PressResponderContext";

});



parcelRegister("i4QhB", function(module, exports) {

$parcel$export(module.exports, "useCollator", function () { return $d2912801e24f8a13$export$a16aca283550c30d; });

var $es7WB = parcelRequire("es7WB");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $d2912801e24f8a13$var$$325a3faab7a68acd$var$cache = new Map();
function $d2912801e24f8a13$export$a16aca283550c30d(options) {
    let { locale: locale } = (0, $es7WB.useLocale)();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($d2912801e24f8a13$var$$325a3faab7a68acd$var$cache.has(cacheKey)) return $d2912801e24f8a13$var$$325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $d2912801e24f8a13$var$$325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}

});
parcelRegister("es7WB", function(module, exports) {

$parcel$export(module.exports, "useLocale", function () { return $a859d7bf49eaa078$export$43bb16f9c6d9e3f7; });

var $2FbP2 = parcelRequire("2FbP2");

var $7DOab = parcelRequire("7DOab");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a859d7bf49eaa078$var$$18f2051aff69b9bf$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
function $a859d7bf49eaa078$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    let defaultLocale = (0, $7DOab.useDefaultLocale)();
    let value = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>{
        if (!locale) return defaultLocale;
        return {
            locale: locale,
            direction: (0, $2FbP2.isRTL)(locale) ? "rtl" : "ltr"
        };
    }, [
        defaultLocale,
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($a859d7bf49eaa078$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
function $a859d7bf49eaa078$export$43bb16f9c6d9e3f7() {
    let defaultLocale = (0, $7DOab.useDefaultLocale)();
    let context = (0, $exYeM.useContext)($a859d7bf49eaa078$var$$18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}

});
parcelRegister("2FbP2", function(module, exports) {

$parcel$export(module.exports, "isRTL", function () { return $1f0894c1f4187bd4$export$702d680b21cbd764; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $1f0894c1f4187bd4$var$$148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
const $1f0894c1f4187bd4$var$$148a7a147e38ea7f$var$RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $1f0894c1f4187bd4$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    // @ts-ignore
    if (Intl.Locale) {
        let locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        let textInfo = typeof locale.getTextInfo === "function" ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === "rtl";
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $1f0894c1f4187bd4$var$$148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = localeString.split("-")[0];
    return $1f0894c1f4187bd4$var$$148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}

});

parcelRegister("7DOab", function(module, exports) {

$parcel$export(module.exports, "useDefaultLocale", function () { return $5903164d6cf482a8$export$188ec29ebc2bdc3a; });

var $2FbP2 = parcelRequire("2FbP2");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
const $5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
function $5903164d6cf482a8$export$f09106e7c6677ec5() {
    let locale = typeof window !== "undefined" && window[$5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: (0, $2FbP2.isRTL)(locale) ? "rtl" : "ltr"
    };
}
let $5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$currentLocale = $5903164d6cf482a8$export$f09106e7c6677ec5();
let $5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$listeners = new Set();
function $5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$updateLocale() {
    $5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$currentLocale = $5903164d6cf482a8$export$f09106e7c6677ec5();
    for (let listener of $5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$listeners)listener($5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$currentLocale);
}
function $5903164d6cf482a8$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $aVmq3.useIsSSR)();
    let [defaultLocale, setDefaultLocale] = (0, $exYeM.useState)($5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$currentLocale);
    (0, $exYeM.useEffect)(()=>{
        if ($5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$updateLocale);
        $5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $5903164d6cf482a8$var$$1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}

});





parcelRegister("dwC3Z", function(module, exports) {

$parcel$export(module.exports, "useMultiSelectState", function () { return $0f96eb8d800121cb$export$85e876c5ce5df8f0; });

var $lpZAy = parcelRequire("lpZAy");

var $kmg5b = parcelRequire("kmg5b");

var $gJuUP = parcelRequire("gJuUP");

var $exYeM = parcelRequire("exYeM");
function $0f96eb8d800121cb$export$85e876c5ce5df8f0(props) {
    const [isFocused, setFocused] = (0, $exYeM.useState)(false);
    const [focusStrategy, setFocusStrategy] = (0, $exYeM.useState)(null);
    const triggerState = (0, $kmg5b.useMenuTriggerState)(props);
    const listState = (0, $lpZAy.useMultiSelectListState)({
        ...props,
        onSelectionChange: (keys)=>{
            if (props.onSelectionChange != null) {
                if (keys === "all") props.onSelectionChange(new Set(listState.collection.getKeys()));
                else props.onSelectionChange(keys);
            }
            if (props.selectionMode === "single") triggerState.close();
        }
    });
    const validationState = (0, $gJuUP.useFormValidationState)({
        ...props,
        validationBehavior: "native",
        value: listState.selectedKeys
    });
    return {
        ...validationState,
        ...listState,
        ...triggerState,
        focusStrategy: focusStrategy,
        close () {
            triggerState.close();
        },
        open (focusStrategy2 = null) {
            if (listState.collection.size !== 0) {
                setFocusStrategy(focusStrategy2);
                triggerState.open();
            }
        },
        toggle (focusStrategy2 = null) {
            if (listState.collection.size !== 0) {
                setFocusStrategy(focusStrategy2);
                triggerState.toggle();
                validationState.commitValidation();
            }
        },
        isFocused: isFocused,
        setFocused: setFocused
    };
}

});
parcelRegister("lpZAy", function(module, exports) {

$parcel$export(module.exports, "useMultiSelectListState", function () { return $7f3d41493f64fbde$export$ce1d728ee50eab64; });
// src/use-multiselect-list-state.ts

var $4uxeW = parcelRequire("4uxeW");

var $exYeM = parcelRequire("exYeM");
function $7f3d41493f64fbde$export$ce1d728ee50eab64(props) {
    const { collection: collection, disabledKeys: disabledKeys, selectionManager: selectionManager, selectionManager: { setSelectedKeys: setSelectedKeys, selectedKeys: selectedKeys, selectionMode: selectionMode } } = (0, $4uxeW.useListState)(props);
    const missingKeys = (0, $exYeM.useMemo)(()=>{
        if (!props.isLoading && selectedKeys.size !== 0) return Array.from(selectedKeys).filter(Boolean).filter((key)=>!collection.getItem(key));
        return [];
    }, [
        selectedKeys,
        collection
    ]);
    const selectedItems = selectedKeys.size !== 0 ? Array.from(selectedKeys).map((key)=>{
        return collection.getItem(key);
    }).filter(Boolean) : null;
    if (missingKeys.length) console.warn(`Select: Keys "${missingKeys.join(", ")}" passed to "selectedKeys" are not present in the collection.`);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        selectionMode: selectionMode,
        selectedKeys: selectedKeys,
        setSelectedKeys: setSelectedKeys.bind(selectionManager),
        selectedItems: selectedItems
    };
}

});
parcelRegister("4uxeW", function(module, exports) {

$parcel$export(module.exports, "useListState", function () { return $3453bf874fad145d$export$2f645645f7bca764; });

var $fxzCj = parcelRequire("fxzCj");
var $dlWrh = parcelRequire("dlWrh");

var $exYeM = parcelRequire("exYeM");

var $eLJRH = parcelRequire("eLJRH");

var $e0Pl7 = parcelRequire("e0Pl7");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $3453bf874fad145d$export$d085fb9e920b5ca7 {
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
    constructor(nodes){
        this.keyMap = new Map();
        this.iterable = nodes;
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && node.type === "section") for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === "item") node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}
function $3453bf874fad145d$export$2f645645f7bca764(props) {
    let { filter: filter } = props;
    let selectionState = (0, $dlWrh.useMultipleSelectionState)(props);
    let disabledKeys = (0, $exYeM.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let factory = (0, $exYeM.useCallback)((nodes)=>filter ? new $3453bf874fad145d$export$d085fb9e920b5ca7(filter(nodes)) : new $3453bf874fad145d$export$d085fb9e920b5ca7(nodes), [
        filter
    ]);
    let context = (0, $exYeM.useMemo)(()=>({
            suppressTextValueWarning: props.suppressTextValueWarning
        }), [
        props.suppressTextValueWarning
    ]);
    let collection = (0, $eLJRH.useCollection)(props, factory, context);
    let selectionManager = (0, $exYeM.useMemo)(()=>new (0, $fxzCj.SelectionManager)(collection, selectionState), [
        collection,
        selectionState
    ]);
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, $exYeM.useRef)(null);
    (0, $exYeM.useEffect)(()=>{
        if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) {
            const startItem = cachedCollection.current.getItem(selectionState.focusedKey);
            const cachedItemNodes = [
                ...cachedCollection.current.getKeys()
            ].map((key)=>{
                const itemNode = cachedCollection.current.getItem(key);
                return itemNode.type === "item" ? itemNode : null;
            }).filter((node)=>node !== null);
            const itemNodes = [
                ...collection.getKeys()
            ].map((key)=>{
                const itemNode = collection.getItem(key);
                return itemNode.type === "item" ? itemNode : null;
            }).filter((node)=>node !== null);
            const diff = cachedItemNodes.length - itemNodes.length;
            let index = Math.min(diff > 1 ? Math.max(startItem.index - diff + 1, 0) : startItem.index, itemNodes.length - 1);
            let newNode;
            while(index >= 0){
                if (!selectionManager.isDisabled(itemNodes[index].key)) {
                    newNode = itemNodes[index];
                    break;
                }
                // Find next, not disabled item.
                if (index < itemNodes.length - 1) index++;
                else {
                    if (index > startItem.index) index = startItem.index;
                    index--;
                }
            }
            selectionState.setFocusedKey(newNode ? newNode.key : null);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager,
        selectionState,
        selectionState.focusedKey
    ]);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3453bf874fad145d$export$e7f05e985daf4b5f(props) {
    var _props_defaultSelectedKey;
    let [selectedKey, setSelectedKey] = (0, $e0Pl7.useControlledState)(props.selectedKey, (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : null, props.onSelectionChange);
    let selectedKeys = (0, $exYeM.useMemo)(()=>selectedKey != null ? [
            selectedKey
        ] : [], [
        selectedKey
    ]);
    let { collection: collection, disabledKeys: disabledKeys, selectionManager: selectionManager } = $3453bf874fad145d$export$2f645645f7bca764({
        ...props,
        selectionMode: "single",
        disallowEmptySelection: true,
        allowDuplicateSelectionEvents: true,
        selectedKeys: selectedKeys,
        onSelectionChange: (keys)=>{
            var _keys_values_next_value;
            let key = (_keys_values_next_value = keys.values().next().value) !== null && _keys_values_next_value !== void 0 ? _keys_values_next_value : null;
            // Always fire onSelectionChange, even if the key is the same
            // as the current key (useControlledState does not).
            if (key === selectedKey && props.onSelectionChange) props.onSelectionChange(key);
            setSelectedKey(key);
        }
    });
    let selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
        selectedItem: selectedItem
    };
}

});


parcelRegister("kmg5b", function(module, exports) {

$parcel$export(module.exports, "useMenuTriggerState", function () { return $ed225664f227efcf$export$79fefeb1c2091ac3; });

var $h2hZ0 = parcelRequire("h2hZ0");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ed225664f227efcf$export$79fefeb1c2091ac3(props) {
    let overlayTriggerState = (0, $h2hZ0.useOverlayTriggerState)(props);
    let [focusStrategy, setFocusStrategy] = (0, $exYeM.useState)(null);
    let [expandedKeysStack, setExpandedKeysStack] = (0, $exYeM.useState)([]);
    let closeAll = ()=>{
        setExpandedKeysStack([]);
        overlayTriggerState.close();
    };
    let openSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            if (level > oldStack.length) return oldStack;
            return [
                ...oldStack.slice(0, level),
                triggerKey
            ];
        });
    };
    let closeSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            let key = oldStack[level];
            if (key === triggerKey) return oldStack.slice(0, level);
            else return oldStack;
        });
    };
    return {
        focusStrategy: focusStrategy,
        ...overlayTriggerState,
        open (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.open();
        },
        toggle (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.toggle();
        },
        close () {
            closeAll();
        },
        UNSTABLE_expandedKeysStack: expandedKeysStack,
        UNSTABLE_openSubmenu: openSubmenu,
        UNSTABLE_closeSubmenu: closeSubmenu
    };
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ed225664f227efcf$export$d39fdbfa42246ac4(props, state) {
    let { triggerKey: triggerKey } = props;
    let { UNSTABLE_expandedKeysStack: UNSTABLE_expandedKeysStack, UNSTABLE_openSubmenu: UNSTABLE_openSubmenu, UNSTABLE_closeSubmenu: UNSTABLE_closeSubmenu, close: closeAll } = state;
    let [submenuLevel] = (0, $exYeM.useState)(UNSTABLE_expandedKeysStack === null || UNSTABLE_expandedKeysStack === void 0 ? void 0 : UNSTABLE_expandedKeysStack.length);
    let isOpen = (0, $exYeM.useMemo)(()=>UNSTABLE_expandedKeysStack[submenuLevel] === triggerKey, [
        UNSTABLE_expandedKeysStack,
        triggerKey,
        submenuLevel
    ]);
    let [focusStrategy, setFocusStrategy] = (0, $exYeM.useState)(null);
    let open = (0, $exYeM.useCallback)((focusStrategy = null)=>{
        setFocusStrategy(focusStrategy);
        UNSTABLE_openSubmenu(triggerKey, submenuLevel);
    }, [
        UNSTABLE_openSubmenu,
        submenuLevel,
        triggerKey
    ]);
    let close = (0, $exYeM.useCallback)(()=>{
        setFocusStrategy(null);
        UNSTABLE_closeSubmenu(triggerKey, submenuLevel);
    }, [
        UNSTABLE_closeSubmenu,
        submenuLevel,
        triggerKey
    ]);
    let toggle = (0, $exYeM.useCallback)((focusStrategy = null)=>{
        setFocusStrategy(focusStrategy);
        if (isOpen) close();
        else open(focusStrategy);
    }, [
        close,
        open,
        isOpen
    ]);
    return (0, $exYeM.useMemo)(()=>({
            focusStrategy: focusStrategy,
            isOpen: isOpen,
            open: open,
            close: close,
            closeAll: closeAll,
            submenuLevel: submenuLevel,
            // TODO: Placeholders that aren't used but give us parity with OverlayTriggerState so we can use this in Popover. Refactor if we update Popover via
            // https://github.com/adobe/react-spectrum/pull/4976#discussion_r1336472863
            setOpen: ()=>{},
            toggle: toggle
        }), [
        isOpen,
        open,
        close,
        closeAll,
        focusStrategy,
        toggle,
        submenuLevel
    ]);
}

});
parcelRegister("h2hZ0", function(module, exports) {

$parcel$export(module.exports, "useOverlayTriggerState", function () { return $c6709297212b9059$export$61c6a8c84e605fb6; });

var $exYeM = parcelRequire("exYeM");

var $e0Pl7 = parcelRequire("e0Pl7");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c6709297212b9059$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = (0, $e0Pl7.useControlledState)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    const open = (0, $exYeM.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    const close = (0, $exYeM.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const toggle = (0, $exYeM.useCallback)(()=>{
        setOpen(!isOpen);
    }, [
        setOpen,
        isOpen
    ]);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open: open,
        close: close,
        toggle: toggle
    };
}

});


parcelRegister("gJuUP", function(module, exports) {

$parcel$export(module.exports, "useFormValidationState", function () { return $c2e8d47a54fcd78e$export$fc1a364ae1f3ff10; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c2e8d47a54fcd78e$export$aca958c65c314e6c = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
const $c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = {
    ...$c2e8d47a54fcd78e$export$aca958c65c314e6c,
    customError: true,
    valid: false
};
const $c2e8d47a54fcd78e$export$dad6ae84456c676a = {
    isInvalid: false,
    validationDetails: $c2e8d47a54fcd78e$export$aca958c65c314e6c,
    validationErrors: []
};
const $c2e8d47a54fcd78e$export$571b5131b7e65c11 = (0, $exYeM.createContext)({});
const $c2e8d47a54fcd78e$export$a763b9476acd3eb = "__formValidationState" + Date.now();
function $c2e8d47a54fcd78e$export$fc1a364ae1f3ff10(props) {
    // Private prop for parent components to pass state to children.
    if (props[$c2e8d47a54fcd78e$export$a763b9476acd3eb]) {
        let { realtimeValidation: realtimeValidation, displayValidation: displayValidation, updateValidation: updateValidation, resetValidation: resetValidation, commitValidation: commitValidation } = props[$c2e8d47a54fcd78e$export$a763b9476acd3eb];
        return {
            realtimeValidation: realtimeValidation,
            displayValidation: displayValidation,
            updateValidation: updateValidation,
            resetValidation: resetValidation,
            commitValidation: commitValidation
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props);
}
function $c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props) {
    let { isInvalid: isInvalid, validationState: validationState, name: name, value: value, builtinValidation: builtinValidation, validate: validate, validationBehavior: validationBehavior = "aria" } = props;
    // backward compatibility.
    if (validationState) isInvalid || (isInvalid = validationState === "invalid");
    // If the isInvalid prop is true, update validation result in realtime (controlled).
    let controlledError = isInvalid ? {
        isInvalid: true,
        validationErrors: [],
        validationDetails: $c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    let clientError = (0, $exYeM.useMemo)(()=>$c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$getValidationResult($c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$runValidate(validate, value)), [
        validate,
        value
    ]);
    if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = null;
    // Get relevant server errors from the form.
    let serverErrors = (0, $exYeM.useContext)($c2e8d47a54fcd78e$export$571b5131b7e65c11);
    let serverErrorMessages = (0, $exYeM.useMemo)(()=>{
        if (name) return Array.isArray(name) ? name.flatMap((name)=>$c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$asArray(serverErrors[name])) : $c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    let [lastServerErrors, setLastServerErrors] = (0, $exYeM.useState)(serverErrors);
    let [isServerErrorCleared, setServerErrorCleared] = (0, $exYeM.useState)(false);
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    let serverError = (0, $exYeM.useMemo)(()=>$c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages), [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    let nextValidation = (0, $exYeM.useRef)($c2e8d47a54fcd78e$export$dad6ae84456c676a);
    let [currentValidity, setCurrentValidity] = (0, $exYeM.useState)($c2e8d47a54fcd78e$export$dad6ae84456c676a);
    let lastError = (0, $exYeM.useRef)($c2e8d47a54fcd78e$export$dad6ae84456c676a);
    let commitValidation = ()=>{
        if (!commitQueued) return;
        setCommitQueued(false);
        let error = clientError || builtinValidation || nextValidation.current;
        if (!$c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    let [commitQueued, setCommitQueued] = (0, $exYeM.useState)(false);
    (0, $exYeM.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    let realtimeValidation = controlledError || serverError || clientError || builtinValidation || $c2e8d47a54fcd78e$export$dad6ae84456c676a;
    let displayValidation = validationBehavior === "native" ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation: realtimeValidation,
        displayValidation: displayValidation,
        updateValidation (value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === "aria" && !$c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation () {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            let error = $c2e8d47a54fcd78e$export$dad6ae84456c676a;
            if (!$c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === "native") setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation () {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === "native") setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function $c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function $c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$runValidate(validate, value) {
    if (typeof validate === "function") {
        let e = validate(value);
        if (e && typeof e !== "boolean") return $c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$asArray(e);
    }
    return [];
}
function $c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: $c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
}
function $c2e8d47a54fcd78e$var$$e5be200c675c3b3a$var$isEqualValidation(a, b) {
    if (a === b) return true;
    return a && b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every((a, i)=>a === b.validationErrors[i]) && Object.entries(a.validationDetails).every(([k, v])=>b.validationDetails[k] === v);
}
function $c2e8d47a54fcd78e$export$75ee7c75d68f5b0e(...results) {
    let errors = new Set();
    let isInvalid = false;
    let validationDetails = {
        ...$c2e8d47a54fcd78e$export$aca958c65c314e6c
    };
    for (let v of results){
        var _validationDetails, _key;
        for (let e of v.validationErrors)errors.add(e);
        // Only these properties apply for checkboxes.
        isInvalid || (isInvalid = v.isInvalid);
        for(let key in validationDetails)(_validationDetails = validationDetails)[_key = key] || (_validationDetails[_key] = v.validationDetails[key]);
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid: isInvalid,
        validationErrors: [
            ...errors
        ],
        validationDetails: validationDetails
    };
}

});



parcelRegister("1gBTM", function(module, exports) {

$parcel$export(module.exports, "useVisuallyHidden", function () { return $0ec4aef5f2f32df2$export$a966af930f325cab; });
$parcel$export(module.exports, "VisuallyHidden", function () { return $0ec4aef5f2f32df2$export$439d29a4e110a164; });

var $8vAG4 = parcelRequire("8vAG4");

var $exYeM = parcelRequire("exYeM");

var $1qPkj = parcelRequire("1qPkj");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $0ec4aef5f2f32df2$var$$5c3e21d68f1c4674$var$styles = {
    border: 0,
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap"
};
function $0ec4aef5f2f32df2$export$a966af930f325cab(props = {}) {
    let { style: style, isFocusable: isFocusable } = props;
    let [isFocused, setFocused] = (0, $exYeM.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $1qPkj.useFocusWithin)({
        isDisabled: !isFocusable,
        onFocusWithinChange: (val)=>setFocused(val)
    });
    // If focused, don't hide the element.
    let combinedStyles = (0, $exYeM.useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$0ec4aef5f2f32df2$var$$5c3e21d68f1c4674$var$styles,
            ...style
        };
        else return $0ec4aef5f2f32df2$var$$5c3e21d68f1c4674$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusWithinProps,
            style: combinedStyles
        }
    };
}
function $0ec4aef5f2f32df2$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children, elementType: Element = "div", isFocusable: isFocusable, style: style, ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = $0ec4aef5f2f32df2$export$a966af930f325cab(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Element, (0, $8vAG4.mergeProps)(otherProps, visuallyHiddenProps), children);
}

});
parcelRegister("1qPkj", function(module, exports) {

$parcel$export(module.exports, "useFocusWithin", function () { return $10b00886de10ddb7$export$420e68273165f4ec; });

var $kpN6M = parcelRequire("kpN6M");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $10b00886de10ddb7$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $exYeM.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $exYeM.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, $kpN6M.useSyntheticBlurEvent)(onBlur);
    let onFocus = (0, $exYeM.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

});
parcelRegister("kpN6M", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $edcc3c524a3b985b$export$715c682d09d639cc; });

var $exYeM = parcelRequire("exYeM");

var $4sExG = parcelRequire("4sExG");
var $71dP2 = parcelRequire("71dP2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $edcc3c524a3b985b$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $edcc3c524a3b985b$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $exYeM.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $71dP2.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $4sExG.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $exYeM.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $edcc3c524a3b985b$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});



parcelRegister("8NHlZ", function(module, exports) {

$parcel$export(module.exports, "useFormValidation", function () { return $668487771f3828dd$export$b8473d3665f3a75a; });

var $exYeM = parcelRequire("exYeM");

var $7K87y = parcelRequire("7K87y");

var $4sExG = parcelRequire("4sExG");
var $71dP2 = parcelRequire("71dP2");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $668487771f3828dd$export$b8473d3665f3a75a(props, state, ref) {
    let { validationBehavior: validationBehavior, focus: focus } = props;
    (0, $71dP2.useLayoutEffect)(()=>{
        if (validationBehavior === "native" && (ref === null || ref === void 0 ? void 0 : ref.current)) {
            let errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
            ref.current.setCustomValidity(errorMessage);
            // Prevent default tooltip for validation message.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=605277
            if (!ref.current.hasAttribute("title")) ref.current.title = "";
            if (!state.realtimeValidation.isInvalid) state.updateValidation($668487771f3828dd$var$$e93e671b31057976$var$getNativeValidity(ref.current));
        }
    });
    let onReset = (0, $4sExG.useEffectEvent)(()=>{
        state.resetValidation();
    });
    let onInvalid = (0, $4sExG.useEffectEvent)((e)=>{
        var _ref_current;
        // Only commit validation if we are not already displaying one.
        // This avoids clearing server errors that the user didn't actually fix.
        if (!state.displayValidation.isInvalid) state.commitValidation();
        // Auto focus the first invalid input in a form, unless the error already had its default prevented.
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        if (!e.defaultPrevented && ref && form && $668487771f3828dd$var$$e93e671b31057976$var$getFirstInvalidInput(form) === ref.current) {
            var _ref_current1;
            if (focus) focus();
            else (_ref_current1 = ref.current) === null || _ref_current1 === void 0 || _ref_current1.focus();
            (0, $7K87y.setInteractionModality)("keyboard");
        }
        // Prevent default browser error UI from appearing.
        e.preventDefault();
    });
    let onChange = (0, $4sExG.useEffectEvent)(()=>{
        state.commitValidation();
    });
    (0, $exYeM.useEffect)(()=>{
        let input = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!input) return;
        let form = input.form;
        input.addEventListener("invalid", onInvalid);
        input.addEventListener("change", onChange);
        form === null || form === void 0 || form.addEventListener("reset", onReset);
        return ()=>{
            input.removeEventListener("invalid", onInvalid);
            input.removeEventListener("change", onChange);
            form === null || form === void 0 || form.removeEventListener("reset", onReset);
        };
    }, [
        ref,
        onInvalid,
        onChange,
        onReset,
        validationBehavior
    ]);
}
function $668487771f3828dd$var$$e93e671b31057976$var$getValidity(input) {
    // The native ValidityState object is live, meaning each property is a getter that returns the current state.
    // We need to create a snapshot of the validity state at the time this function is called to avoid unpredictable React renders.
    let validity = input.validity;
    return {
        badInput: validity.badInput,
        customError: validity.customError,
        patternMismatch: validity.patternMismatch,
        rangeOverflow: validity.rangeOverflow,
        rangeUnderflow: validity.rangeUnderflow,
        stepMismatch: validity.stepMismatch,
        tooLong: validity.tooLong,
        tooShort: validity.tooShort,
        typeMismatch: validity.typeMismatch,
        valueMissing: validity.valueMissing,
        valid: validity.valid
    };
}
function $668487771f3828dd$var$$e93e671b31057976$var$getNativeValidity(input) {
    return {
        isInvalid: !input.validity.valid,
        validationDetails: $668487771f3828dd$var$$e93e671b31057976$var$getValidity(input),
        validationErrors: input.validationMessage ? [
            input.validationMessage
        ] : []
    };
}
function $668487771f3828dd$var$$e93e671b31057976$var$getFirstInvalidInput(form) {
    for(let i = 0; i < form.elements.length; i++){
        let element = form.elements[i];
        if (!element.validity.valid) return element;
    }
    return null;
}

});
parcelRegister("7K87y", function(module, exports) {

$parcel$export(module.exports, "setInteractionModality", function () { return $5a3320ee38d4ab0e$export$8397ddfc504fdb9a; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$currentModality = null;
let $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $5a3320ee38d4ab0e$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $gbqqi.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $87CgO.isVirtualClick)(e)) {
        $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $5a3320ee38d4ab0e$export$d90243b58daecda7.get((0, $2ZDqh.getOwnerWindow)(element))) return;
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $5a3320ee38d4ab0e$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$5a3320ee38d4ab0e$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $5a3320ee38d4ab0e$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $5a3320ee38d4ab0e$export$d90243b58daecda7.delete(windowObject);
};
function $5a3320ee38d4ab0e$export$2f1888112f558a7d(element) {
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $5a3320ee38d4ab0e$export$2f1888112f558a7d();
function $5a3320ee38d4ab0e$export$b9b3dfddab17db27() {
    return $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $5a3320ee38d4ab0e$export$630ff653c5ada6a9() {
    return $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$currentModality;
}
function $5a3320ee38d4ab0e$export$8397ddfc504fdb9a(modality) {
    $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$currentModality = modality;
    $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $5a3320ee38d4ab0e$export$98e20ec92f614cfe() {
    $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $exYeM.useState)($5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$currentModality);
    (0, $exYeM.useEffect)(()=>{
        let handler = ()=>{
            setModality($5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$currentModality);
        };
        $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $aVmq3.useIsSSR)() ? null : modality;
}
const $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $5a3320ee38d4ab0e$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(autoFocus || $5a3320ee38d4ab0e$export$b9b3dfddab17db27());
    $5a3320ee38d4ab0e$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $5a3320ee38d4ab0e$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $exYeM.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($5a3320ee38d4ab0e$export$b9b3dfddab17db27());
        };
        $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $5a3320ee38d4ab0e$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});



parcelRegister("6b1sx", function(module, exports) {

$parcel$export(module.exports, "listbox_default", function () { return $da43c494c6a74e67$export$3f842a5957aa0e7a; });

var $l1Znk = parcelRequire("l1Znk");

var $4Bi1d = parcelRequire("4Bi1d");

var $a7qJQ = parcelRequire("a7qJQ");

var $8Oq4a = parcelRequire("8Oq4a");

var $8vAG4 = parcelRequire("8vAG4");

var $aSiaI = parcelRequire("aSiaI");
"use client";
function $da43c494c6a74e67$var$Listbox(props, ref) {
    const { Component: Component, state: state, color: color, variant: variant, itemClasses: itemClasses, getBaseProps: getBaseProps, topContent: topContent, bottomContent: bottomContent, hideEmptyContent: hideEmptyContent, hideSelectedIcon: hideSelectedIcon, shouldHighlightOnFocus: shouldHighlightOnFocus, disableAnimation: disableAnimation, getEmptyContentProps: getEmptyContentProps, getListProps: getListProps } = (0, $a7qJQ.useListbox)({
        ...props,
        ref: ref
    });
    const content = /* @__PURE__ */ (0, $aSiaI.jsxs)(Component, {
        ...getListProps(),
        children: [
            !state.collection.size && !hideEmptyContent && /* @__PURE__ */ (0, $aSiaI.jsx)("li", {
                children: /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
                    ...getEmptyContentProps()
                })
            }),
            [
                ...state.collection
            ].map((item)=>{
                var _a;
                const itemProps = {
                    color: color,
                    item: item,
                    state: state,
                    variant: variant,
                    disableAnimation: disableAnimation,
                    hideSelectedIcon: hideSelectedIcon,
                    ...item.props
                };
                if (item.type === "section") return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $l1Znk.listbox_section_default), {
                    ...itemProps,
                    itemClasses: itemClasses
                }, item.key);
                let listboxItem = /* @__PURE__ */ (0, $aSiaI.jsx)((0, $4Bi1d.listbox_item_default), {
                    ...itemProps,
                    classNames: (0, $8vAG4.mergeProps)(itemClasses, (_a = item.props) == null ? void 0 : _a.classNames),
                    shouldHighlightOnFocus: shouldHighlightOnFocus
                }, item.key);
                if (item.wrapper) listboxItem = item.wrapper(listboxItem);
                return listboxItem;
            })
        ]
    });
    return /* @__PURE__ */ (0, $aSiaI.jsxs)("div", {
        ...getBaseProps(),
        children: [
            topContent,
            content,
            bottomContent
        ]
    });
}
$da43c494c6a74e67$var$Listbox.displayName = "NextUI.Listbox";
var $da43c494c6a74e67$export$3f842a5957aa0e7a = (0, $8Oq4a.forwardRef)($da43c494c6a74e67$var$Listbox);

});
parcelRegister("l1Znk", function(module, exports) {

$parcel$export(module.exports, "listbox_section_default", function () { return $97191aec302c956f$export$f8b3202ede999f4c; });

var $4Bi1d = parcelRequire("4Bi1d");

var $jIXBM = parcelRequire("jIXBM");

var $exYeM = parcelRequire("exYeM");

var $8Oq4a = parcelRequire("8Oq4a");

var $8vAG4 = parcelRequire("8vAG4");

var $6pmNA = parcelRequire("6pmNA");

var $kX516 = parcelRequire("kX516");

var $aqGcE = parcelRequire("aqGcE");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $97191aec302c956f$var$ListboxSection = (0, $8Oq4a.forwardRef)(({ item: item, state: state, as: as, variant: variant, color: color, disableAnimation: disableAnimation, className: className, classNames: classNames, hideSelectedIcon: hideSelectedIcon, showDivider: showDivider = false, dividerProps: dividerProps = {}, itemClasses: itemClasses, title: title, ...otherProps }, _)=>{
    const Component = as || "li";
    const slots = (0, $exYeM.useMemo)(()=>(0, $jIXBM.menuSection)(), []);
    const baseStyles = (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.base, className);
    const dividerStyles = (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.divider, dividerProps == null ? void 0 : dividerProps.className);
    const { itemProps: itemProps, headingProps: headingProps, groupProps: groupProps } = (0, $aqGcE.useListBoxSection)({
        heading: item.rendered,
        "aria-label": item["aria-label"]
    });
    return /* @__PURE__ */ (0, $aSiaI.jsxs)(Component, {
        "data-slot": "base",
        ...(0, $8vAG4.mergeProps)(itemProps, otherProps),
        className: slots.base({
            class: baseStyles
        }),
        children: [
            item.rendered && /* @__PURE__ */ (0, $aSiaI.jsx)("span", {
                ...headingProps,
                className: slots.heading({
                    class: classNames == null ? void 0 : classNames.heading
                }),
                "data-slot": "heading",
                children: item.rendered
            }),
            /* @__PURE__ */ (0, $aSiaI.jsxs)("ul", {
                ...groupProps,
                className: slots.group({
                    class: classNames == null ? void 0 : classNames.group
                }),
                "data-has-title": !!item.rendered,
                "data-slot": "group",
                children: [
                    [
                        ...item.childNodes
                    ].map((node)=>{
                        const { key: nodeKey, props: nodeProps } = node;
                        let listboxItem = /* @__PURE__ */ (0, $aSiaI.jsx)((0, $4Bi1d.listbox_item_default), {
                            classNames: itemClasses,
                            color: color,
                            disableAnimation: disableAnimation,
                            hideSelectedIcon: hideSelectedIcon,
                            item: node,
                            state: state,
                            variant: variant,
                            ...nodeProps
                        }, nodeKey);
                        if (node.wrapper) listboxItem = node.wrapper(listboxItem);
                        return listboxItem;
                    }),
                    showDivider && /* @__PURE__ */ (0, $aSiaI.jsx)((0, $kX516.divider_default), {
                        as: "li",
                        className: slots.divider({
                            class: dividerStyles
                        }),
                        ...dividerProps
                    })
                ]
            })
        ]
    }, item.key);
});
$97191aec302c956f$var$ListboxSection.displayName = "NextUI.ListboxSection";
var $97191aec302c956f$export$f8b3202ede999f4c = $97191aec302c956f$var$ListboxSection;

});
parcelRegister("4Bi1d", function(module, exports) {

$parcel$export(module.exports, "listbox_item_default", function () { return $074e2f20813bf5aa$export$5f4bb52909be7a78; });

var $7y6jB = parcelRequire("7y6jB");

var $83kKg = parcelRequire("83kKg");

var $exYeM = parcelRequire("exYeM");

var $8Oq4a = parcelRequire("8Oq4a");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $074e2f20813bf5aa$var$ListboxItem = (0, $8Oq4a.forwardRef)((props, _)=>{
    const { Component: Component, rendered: rendered, description: description, isSelectable: isSelectable, isSelected: isSelected, isDisabled: isDisabled, selectedIcon: selectedIcon, startContent: startContent, endContent: endContent, hideSelectedIcon: hideSelectedIcon, disableAnimation: disableAnimation, getItemProps: getItemProps, getLabelProps: getLabelProps, getWrapperProps: getWrapperProps, getDescriptionProps: getDescriptionProps, getSelectedIconProps: getSelectedIconProps } = (0, $83kKg.useListboxItem)(props);
    const selectedContent = (0, $exYeM.useMemo)(()=>{
        const defaultIcon = /* @__PURE__ */ (0, $aSiaI.jsx)((0, $7y6jB.ListboxSelectedIcon), {
            disableAnimation: disableAnimation,
            isSelected: isSelected
        });
        if (typeof selectedIcon === "function") return selectedIcon({
            icon: defaultIcon,
            isSelected: isSelected,
            isDisabled: isDisabled
        });
        if (selectedIcon) return selectedIcon;
        return defaultIcon;
    }, [
        selectedIcon,
        isSelected,
        isDisabled,
        disableAnimation
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsxs)(Component, {
        ...getItemProps(),
        children: [
            startContent,
            description ? /* @__PURE__ */ (0, $aSiaI.jsxs)("div", {
                ...getWrapperProps(),
                children: [
                    /* @__PURE__ */ (0, $aSiaI.jsx)("span", {
                        ...getLabelProps(),
                        children: rendered
                    }),
                    /* @__PURE__ */ (0, $aSiaI.jsx)("span", {
                        ...getDescriptionProps(),
                        children: description
                    })
                ]
            }) : /* @__PURE__ */ (0, $aSiaI.jsx)("span", {
                ...getLabelProps(),
                children: rendered
            }),
            isSelectable && !hideSelectedIcon && /* @__PURE__ */ (0, $aSiaI.jsx)("span", {
                ...getSelectedIconProps(),
                children: selectedContent
            }),
            endContent
        ]
    });
});
$074e2f20813bf5aa$var$ListboxItem.displayName = "NextUI.ListboxItem";
var $074e2f20813bf5aa$export$5f4bb52909be7a78 = $074e2f20813bf5aa$var$ListboxItem;

});
parcelRegister("7y6jB", function(module, exports) {

$parcel$export(module.exports, "ListboxSelectedIcon", function () { return $baa9b2f533f67881$export$5db3965fb0ec818; });

var $aSiaI = parcelRequire("aSiaI");
"use client";
function $baa9b2f533f67881$export$5db3965fb0ec818(props) {
    const { isSelected: isSelected, disableAnimation: disableAnimation, ...otherProps } = props;
    return /* @__PURE__ */ (0, $aSiaI.jsx)("svg", {
        "aria-hidden": "true",
        "data-selected": isSelected,
        role: "presentation",
        viewBox: "0 0 17 18",
        ...otherProps,
        children: /* @__PURE__ */ (0, $aSiaI.jsx)("polyline", {
            fill: "none",
            points: "1 9 7 14 15 4",
            stroke: "currentColor",
            strokeDasharray: 22,
            strokeDashoffset: isSelected ? 44 : 66,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            style: !disableAnimation ? {
                transition: "stroke-dashoffset 200ms ease"
            } : {}
        })
    });
}

});

parcelRegister("83kKg", function(module, exports) {

$parcel$export(module.exports, "useListboxItem", function () { return $b7ffa30bd51ca641$export$887eda06ad18acaf; });

var $exYeM = parcelRequire("exYeM");

var $jIXBM = parcelRequire("jIXBM");

var $8Oq4a = parcelRequire("8Oq4a");
var $lJ6o6 = parcelRequire("lJ6o6");

var $k5F2B = parcelRequire("k5F2B");

var $LA3Ym = parcelRequire("LA3Ym");

var $6pmNA = parcelRequire("6pmNA");
var $jj4Oc = parcelRequire("jj4Oc");
var $luNG9 = parcelRequire("luNG9");

var $aqGcE = parcelRequire("aqGcE");

var $8vAG4 = parcelRequire("8vAG4");

var $b6W9a = parcelRequire("b6W9a");

var $1KuMV = parcelRequire("1KuMV");
"use client";
function $b7ffa30bd51ca641$export$887eda06ad18acaf(originalProps) {
    var _a, _b;
    const globalContext = (0, $lJ6o6.useProviderContext)();
    const [props, variantProps] = (0, $8Oq4a.mapPropsVariants)(originalProps, (0, $jIXBM.menuItem).variantKeys);
    const { as: as, item: item, state: state, description: description, startContent: startContent, endContent: endContent, isVirtualized: isVirtualized, selectedIcon: selectedIcon, className: className, classNames: classNames, autoFocus: autoFocus, onPress: onPress, onClick: onClick, shouldHighlightOnFocus: shouldHighlightOnFocus, hideSelectedIcon: hideSelectedIcon = false, isReadOnly: isReadOnly = false, ...otherProps } = props;
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const domRef = (0, $exYeM.useRef)(null);
    const Component = as || (originalProps.href ? "a" : "li");
    const shouldFilterDOMProps = typeof Component === "string";
    const { rendered: rendered, key: key } = item;
    const isDisabled = state.disabledKeys.has(key) || originalProps.isDisabled;
    const isSelectable = state.selectionManager.selectionMode !== "none";
    const isMobile = (0, $1KuMV.useIsMobile)();
    const { pressProps: pressProps, isPressed: isPressed } = (0, $b6W9a.usePress)({
        ref: domRef,
        isDisabled: isDisabled,
        onPress: onPress
    });
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $b6W9a.useHover)({
        isDisabled: isDisabled
    });
    const { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $k5F2B.useFocusRing)({
        autoFocus: autoFocus
    });
    const { isFocused: isFocused, isSelected: isSelected, optionProps: optionProps, labelProps: labelProps, descriptionProps: descriptionProps } = (0, $aqGcE.useOption)({
        key: key,
        isDisabled: isDisabled,
        "aria-label": props["aria-label"],
        isVirtualized: isVirtualized
    }, state, domRef);
    let itemProps = optionProps;
    const slots = (0, $exYeM.useMemo)(()=>(0, $jIXBM.menuItem)({
            ...variantProps,
            isDisabled: isDisabled,
            disableAnimation: disableAnimation
        }), [
        (0, $luNG9.objectToDeps)(variantProps),
        isDisabled,
        disableAnimation
    ]);
    const baseStyles = (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.base, className);
    if (isReadOnly) itemProps = (0, $luNG9.removeEvents)(itemProps);
    const isHighlighted = (0, $exYeM.useMemo)(()=>{
        if (shouldHighlightOnFocus && isFocused) return true;
        return isMobile ? isHovered || isPressed : isHovered;
    }, [
        isHovered,
        isPressed,
        isFocused,
        isMobile,
        shouldHighlightOnFocus
    ]);
    const getItemProps = (props2 = {})=>({
            ref: domRef,
            ...(0, $8vAG4.mergeProps)({
                onClick: onClick
            }, itemProps, isReadOnly ? {} : (0, $8vAG4.mergeProps)(focusProps, pressProps), hoverProps, (0, $LA3Ym.filterDOMProps)(otherProps, {
                enabled: shouldFilterDOMProps
            }), props2),
            "data-selectable": (0, $jj4Oc.dataAttr)(isSelectable),
            "data-focus": (0, $jj4Oc.dataAttr)(isFocused),
            "data-hover": (0, $jj4Oc.dataAttr)(isHighlighted),
            "data-disabled": (0, $jj4Oc.dataAttr)(isDisabled),
            "data-selected": (0, $jj4Oc.dataAttr)(isSelected),
            "data-pressed": (0, $jj4Oc.dataAttr)(isPressed),
            "data-focus-visible": (0, $jj4Oc.dataAttr)(isFocusVisible),
            className: slots.base({
                class: (0, $6pmNA.clsx)(baseStyles, props2.className)
            })
        });
    const getLabelProps = (props2 = {})=>({
            ...(0, $8vAG4.mergeProps)(labelProps, props2),
            "data-label": (0, $jj4Oc.dataAttr)(true),
            className: slots.title({
                class: classNames == null ? void 0 : classNames.title
            })
        });
    const getDescriptionProps = (props2 = {})=>({
            ...(0, $8vAG4.mergeProps)(descriptionProps, props2),
            className: slots.description({
                class: classNames == null ? void 0 : classNames.description
            })
        });
    const getWrapperProps = (props2 = {})=>({
            ...(0, $8vAG4.mergeProps)(props2),
            className: slots.wrapper({
                class: classNames == null ? void 0 : classNames.wrapper
            })
        });
    const getSelectedIconProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            "aria-hidden": (0, $jj4Oc.dataAttr)(true),
            "data-disabled": (0, $jj4Oc.dataAttr)(isDisabled),
            className: slots.selectedIcon({
                class: classNames == null ? void 0 : classNames.selectedIcon
            }),
            ...props2
        };
    }, [
        isDisabled,
        slots,
        classNames
    ]);
    return {
        Component: Component,
        domRef: domRef,
        slots: slots,
        classNames: classNames,
        isSelectable: isSelectable,
        isSelected: isSelected,
        isDisabled: isDisabled,
        rendered: rendered,
        description: description,
        startContent: startContent,
        endContent: endContent,
        selectedIcon: selectedIcon,
        hideSelectedIcon: hideSelectedIcon,
        disableAnimation: disableAnimation,
        getItemProps: getItemProps,
        getLabelProps: getLabelProps,
        getWrapperProps: getWrapperProps,
        getDescriptionProps: getDescriptionProps,
        getSelectedIconProps: getSelectedIconProps
    };
}

});
parcelRegister("jIXBM", function(module, exports) {

$parcel$export(module.exports, "menu", function () { return $6e34a9d30604cf54$export$b1e5508a851be14d; });
$parcel$export(module.exports, "menuItem", function () { return $6e34a9d30604cf54$export$c176f998e71d0f08; });
$parcel$export(module.exports, "menuSection", function () { return $6e34a9d30604cf54$export$95e0837a3419f5c1; });

var $a2Moz = parcelRequire("a2Moz");

var $9dwEN = parcelRequire("9dwEN");
// src/components/menu.ts
var $6e34a9d30604cf54$export$b1e5508a851be14d = (0, $a2Moz.tv)({
    slots: {
        base: "w-full relative flex flex-col gap-1 p-1",
        list: "w-full flex flex-col gap-0.5 outline-none",
        emptyContent: [
            "h-10",
            "px-2",
            "py-1.5",
            "w-full",
            "h-full",
            "text-foreground-400",
            "text-start"
        ]
    }
});
var $6e34a9d30604cf54$export$c176f998e71d0f08 = (0, $a2Moz.tv)({
    slots: {
        base: [
            "flex",
            "group",
            "gap-2",
            "items-center",
            "justify-between",
            "relative",
            "px-2",
            "py-1.5",
            "w-full",
            "h-full",
            "box-border",
            "rounded-small",
            "subpixel-antialiased",
            "outline-none",
            "cursor-pointer",
            "tap-highlight-transparent",
            ...(0, $9dwEN.dataFocusVisibleClasses),
            "data-[focus-visible=true]:dark:ring-offset-background-content1"
        ],
        wrapper: "w-full flex flex-col items-start justify-center",
        title: "flex-1 text-small font-normal truncate",
        description: [
            "w-full",
            "text-tiny",
            "text-foreground-500",
            "group-hover:text-current"
        ],
        selectedIcon: [
            "text-inherit",
            "w-3",
            "h-3",
            "flex-shrink-0"
        ],
        shortcut: [
            "px-1",
            "py-0.5",
            "rounded",
            "font-sans",
            "text-foreground-500",
            "text-tiny",
            "border-small",
            "border-default-300",
            "group-hover:border-current"
        ]
    },
    variants: {
        variant: {
            solid: {
                base: ""
            },
            bordered: {
                base: "border-medium border-transparent bg-transparent"
            },
            light: {
                base: "bg-transparent"
            },
            faded: {
                base: [
                    "border-small border-transparent hover:border-default data-[hover=true]:bg-default-100",
                    "data-[selectable=true]:focus:border-default data-[selectable=true]:focus:bg-default-100"
                ]
            },
            flat: {
                base: ""
            },
            shadow: {
                base: "data-[hover=true]:shadow-lg"
            }
        },
        color: {
            default: {},
            primary: {},
            secondary: {},
            success: {},
            warning: {},
            danger: {}
        },
        showDivider: {
            true: {
                base: [
                    "mb-1.5",
                    "after:content-['']",
                    "after:absolute",
                    "after:-bottom-1",
                    "after:left-0",
                    "after:right-0",
                    "after:h-divider",
                    "after:bg-divider"
                ]
            },
            false: {}
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none"
            }
        },
        disableAnimation: {
            true: {},
            false: {
                base: "data-[hover=true]:transition-colors"
            }
        }
    },
    defaultVariants: {
        variant: "solid",
        color: "default",
        showDivider: false
    },
    compoundVariants: [
        {
            variant: "solid",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:bg-default",
                    "data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:bg-default",
                    "data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:bg-primary data-[hover=true]:text-primary-foreground",
                    "data-[selectable=true]:focus:bg-primary data-[selectable=true]:focus:text-primary-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:bg-secondary data-[hover=true]:text-secondary-foreground",
                    "data-[selectable=true]:focus:bg-secondary data-[selectable=true]:focus:text-secondary-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:bg-success data-[hover=true]:text-success-foreground",
                    "data-[selectable=true]:focus:bg-success data-[selectable=true]:focus:text-success-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:bg-warning data-[hover=true]:text-warning-foreground",
                    "data-[selectable=true]:focus:bg-warning data-[selectable=true]:focus:text-warning-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:bg-danger data-[hover=true]:text-danger-foreground",
                    "data-[selectable=true]:focus:bg-danger data-[selectable=true]:focus:text-danger-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:shadow-default/50 data-[hover=true]:bg-default data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:shadow-default/50 data-[selectable=true]:focus:bg-default data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:shadow-primary/30 data-[hover=true]:bg-primary data-[hover=true]:text-primary-foreground",
                    "data-[selectable=true]:focus:shadow-primary/30 data-[selectable=true]:focus:bg-primary data-[selectable=true]:focus:text-primary-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:shadow-secondary/30 data-[hover=true]:bg-secondary data-[hover=true]:text-secondary-foreground",
                    "data-[selectable=true]:focus:shadow-secondary/30 data-[selectable=true]:focus:bg-secondary data-[selectable=true]:focus:text-secondary-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:shadow-success/30 data-[hover=true]:bg-success data-[hover=true]:text-success-foreground",
                    "data-[selectable=true]:focus:shadow-success/30 data-[selectable=true]:focus:bg-success data-[selectable=true]:focus:text-success-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:shadow-warning/30 data-[hover=true]:bg-warning data-[hover=true]:text-warning-foreground",
                    "data-[selectable=true]:focus:shadow-warning/30 data-[selectable=true]:focus:bg-warning data-[selectable=true]:focus:text-warning-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:shadow-danger/30 data-[hover=true]:bg-danger data-[hover=true]:text-danger-foreground",
                    "data-[selectable=true]:focus:shadow-danger/30 data-[selectable=true]:focus:bg-danger data-[selectable=true]:focus:text-danger-foreground"
                ]
            }
        },
        {
            variant: "bordered",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:border-default",
                    "data-[selectable=true]:focus:border-default"
                ]
            }
        },
        {
            variant: "bordered",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:border-primary data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:border-primary data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "bordered",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:border-secondary data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:border-secondary data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "bordered",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:border-success data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:border-success data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "bordered",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:border-warning data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:border-warning data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "bordered",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:border-danger data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:border-danger data-[selectable=true]:focus:text-danger"
                ]
            }
        },
        {
            variant: "flat",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:bg-default/40",
                    "data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:bg-default/40",
                    "data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "flat",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:bg-primary/20 data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:bg-primary/20 data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "flat",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:bg-secondary/20 data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:bg-secondary/20 data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "flat",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:bg-success/20 data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:bg-success/20 data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "flat",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:bg-warning/20 data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:bg-warning/20 data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "flat",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:bg-danger/20 data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:bg-danger/20 data-[selectable=true]:focus:text-danger"
                ]
            }
        },
        {
            variant: "faded",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "faded",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "faded",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "faded",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "faded",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "faded",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:text-danger"
                ]
            }
        },
        {
            variant: "light",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:text-default-500",
                    "data-[selectable=true]:focus:text-default-500"
                ]
            }
        },
        {
            variant: "light",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "light",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "light",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "light",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "light",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:text-danger"
                ]
            }
        }
    ]
});
var $6e34a9d30604cf54$export$95e0837a3419f5c1 = (0, $a2Moz.tv)({
    slots: {
        base: "relative mb-2",
        heading: "pl-1 text-tiny text-foreground-500",
        group: "data-[has-title=true]:pt-1",
        divider: "mt-2"
    }
});

});

parcelRegister("aqGcE", function(module, exports) {

$parcel$export(module.exports, "useListBox", function () { return $797d11c32630a8ee$export$50eacbbf140a3141; });
$parcel$export(module.exports, "useOption", function () { return $797d11c32630a8ee$export$497855f14858aa34; });
$parcel$export(module.exports, "useListBoxSection", function () { return $797d11c32630a8ee$export$c3f9f39876e4bc7; });

var $9cffb = parcelRequire("9cffb");
var $gbqqi = parcelRequire("gbqqi");
var $8vAG4 = parcelRequire("8vAG4");
var $ezzQB = parcelRequire("ezzQB");

var $6TwHf = parcelRequire("6TwHf");
var $9vFUJ = parcelRequire("9vFUJ");
var $9tlYp = parcelRequire("9tlYp");

var $f2qmo = parcelRequire("f2qmo");

var $2Ya72 = parcelRequire("2Ya72");
var $1sTcE = parcelRequire("1sTcE");

var $jXecf = parcelRequire("jXecf");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $797d11c32630a8ee$export$3585ede4d035bf14 = new WeakMap();
function $797d11c32630a8ee$var$$b1f0cad8af73213b$var$normalizeKey(key) {
    if (typeof key === "string") return key.replace(/\s*/g, "");
    return "" + key;
}
function $797d11c32630a8ee$export$9145995848b05025(state, itemKey) {
    let data = $797d11c32630a8ee$export$3585ede4d035bf14.get(state);
    if (!data) throw new Error("Unknown list");
    return `${data.id}-option-${$797d11c32630a8ee$var$$b1f0cad8af73213b$var$normalizeKey(itemKey)}`;
}
function $797d11c32630a8ee$export$50eacbbf140a3141(props, state, ref) {
    let domProps = (0, $9cffb.filterDOMProps)(props, {
        labelable: true
    });
    // Use props instead of state here. We don't want this to change due to long press.
    let selectionBehavior = props.selectionBehavior || "toggle";
    let linkBehavior = props.linkBehavior || (selectionBehavior === "replace" ? "action" : "override");
    if (selectionBehavior === "toggle" && linkBehavior === "action") // to initiate selection (checkboxes are not allowed inside a listbox). Link items will not be
    // selectable in this configuration.
    linkBehavior = "override";
    let { listProps: listProps } = (0, $1sTcE.useSelectableList)({
        ...props,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        linkBehavior: linkBehavior
    });
    let { focusWithinProps: focusWithinProps } = (0, $9vFUJ.useFocusWithin)({
        onFocusWithin: props.onFocus,
        onBlurWithin: props.onBlur,
        onFocusWithinChange: props.onFocusChange
    });
    // Share list id and some props with child options.
    let id = (0, $ezzQB.useId)(props.id);
    $797d11c32630a8ee$export$3585ede4d035bf14.set(state, {
        id: id,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        shouldFocusOnHover: props.shouldFocusOnHover,
        isVirtualized: props.isVirtualized,
        onAction: props.onAction,
        linkBehavior: linkBehavior
    });
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $f2qmo.useLabel)({
        ...props,
        id: id,
        // listbox is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: "span"
    });
    return {
        labelProps: labelProps,
        listBoxProps: (0, $8vAG4.mergeProps)(domProps, focusWithinProps, state.selectionManager.selectionMode === "multiple" ? {
            "aria-multiselectable": "true"
        } : {}, {
            role: "listbox",
            ...(0, $8vAG4.mergeProps)(fieldProps, listProps)
        })
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $797d11c32630a8ee$export$497855f14858aa34(props, state, ref) {
    var _item_props;
    let { key: key } = props;
    let data = $797d11c32630a8ee$export$3585ede4d035bf14.get(state);
    var _props_isDisabled;
    let isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : state.disabledKeys.has(key);
    var _props_isSelected;
    let isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : state.selectionManager.isSelected(key);
    var _props_shouldSelectOnPressUp;
    let shouldSelectOnPressUp = (_props_shouldSelectOnPressUp = props.shouldSelectOnPressUp) !== null && _props_shouldSelectOnPressUp !== void 0 ? _props_shouldSelectOnPressUp : data === null || data === void 0 ? void 0 : data.shouldSelectOnPressUp;
    var _props_shouldFocusOnHover;
    let shouldFocusOnHover = (_props_shouldFocusOnHover = props.shouldFocusOnHover) !== null && _props_shouldFocusOnHover !== void 0 ? _props_shouldFocusOnHover : data === null || data === void 0 ? void 0 : data.shouldFocusOnHover;
    var _props_shouldUseVirtualFocus;
    let shouldUseVirtualFocus = (_props_shouldUseVirtualFocus = props.shouldUseVirtualFocus) !== null && _props_shouldUseVirtualFocus !== void 0 ? _props_shouldUseVirtualFocus : data === null || data === void 0 ? void 0 : data.shouldUseVirtualFocus;
    var _props_isVirtualized;
    let isVirtualized = (_props_isVirtualized = props.isVirtualized) !== null && _props_isVirtualized !== void 0 ? _props_isVirtualized : data === null || data === void 0 ? void 0 : data.isVirtualized;
    let labelId = (0, $ezzQB.useSlotId)();
    let descriptionId = (0, $ezzQB.useSlotId)();
    let optionProps = {
        role: "option",
        "aria-disabled": isDisabled || undefined,
        "aria-selected": state.selectionManager.selectionMode !== "none" ? isSelected : undefined
    };
    // Safari with VoiceOver on macOS misreads options with aria-labelledby or aria-label as simply "text".
    // We should not map slots to the label and description on Safari and instead just have VoiceOver read the textContent.
    // https://bugs.webkit.org/show_bug.cgi?id=209279
    if (!((0, $gbqqi.isMac)() && (0, $gbqqi.isWebKit)())) {
        optionProps["aria-label"] = props["aria-label"];
        optionProps["aria-labelledby"] = labelId;
        optionProps["aria-describedby"] = descriptionId;
    }
    let item = state.collection.getItem(key);
    if (isVirtualized) {
        let index = Number(item === null || item === void 0 ? void 0 : item.index);
        optionProps["aria-posinset"] = Number.isNaN(index) ? undefined : index + 1;
        optionProps["aria-setsize"] = (0, $jXecf.getItemCount)(state.collection);
    }
    let { itemProps: itemProps, isPressed: isPressed, isFocused: isFocused, hasAction: hasAction, allowsSelection: allowsSelection } = (0, $2Ya72.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        allowsDifferentPressOrigin: shouldSelectOnPressUp && shouldFocusOnHover,
        isVirtualized: isVirtualized,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        isDisabled: isDisabled,
        onAction: (data === null || data === void 0 ? void 0 : data.onAction) ? ()=>{
            var _data_onAction;
            return data === null || data === void 0 ? void 0 : (_data_onAction = data.onAction) === null || _data_onAction === void 0 ? void 0 : _data_onAction.call(data, key);
        } : undefined,
        linkBehavior: data === null || data === void 0 ? void 0 : data.linkBehavior
    });
    let { hoverProps: hoverProps } = (0, $9tlYp.useHover)({
        isDisabled: isDisabled || !shouldFocusOnHover,
        onHoverStart () {
            if (!(0, $6TwHf.isFocusVisible)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    let domProps = (0, $9cffb.filterDOMProps)(item === null || item === void 0 ? void 0 : item.props, {
        isLink: !!(item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.href)
    });
    delete domProps.id;
    return {
        optionProps: {
            ...optionProps,
            ...(0, $8vAG4.mergeProps)(domProps, itemProps, hoverProps),
            id: $797d11c32630a8ee$export$9145995848b05025(state, key)
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        isFocused: isFocused,
        isFocusVisible: isFocused && (0, $6TwHf.isFocusVisible)(),
        isSelected: isSelected,
        isDisabled: isDisabled,
        isPressed: isPressed,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $797d11c32630a8ee$export$c3f9f39876e4bc7(props) {
    let { heading: heading, "aria-label": ariaLabel } = props;
    let headingId = (0, $ezzQB.useId)();
    return {
        itemProps: {
            role: "presentation"
        },
        headingProps: heading ? {
            // Techincally, listbox cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a visual label for the nested group.
            id: headingId,
            role: "presentation"
        } : {},
        groupProps: {
            role: "group",
            "aria-label": ariaLabel,
            "aria-labelledby": heading ? headingId : undefined
        }
    };
}

});
parcelRegister("6TwHf", function(module, exports) {

$parcel$export(module.exports, "isFocusVisible", function () { return $50513dfdcbc26949$export$b9b3dfddab17db27; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $50513dfdcbc26949$var$$507fabe10e71c6fb$var$currentModality = null;
let $50513dfdcbc26949$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $50513dfdcbc26949$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $50513dfdcbc26949$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $50513dfdcbc26949$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $50513dfdcbc26949$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $50513dfdcbc26949$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $50513dfdcbc26949$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $50513dfdcbc26949$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $gbqqi.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $50513dfdcbc26949$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($50513dfdcbc26949$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $50513dfdcbc26949$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $50513dfdcbc26949$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $50513dfdcbc26949$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $50513dfdcbc26949$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $50513dfdcbc26949$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $87CgO.isVirtualClick)(e)) {
        $50513dfdcbc26949$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $50513dfdcbc26949$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$50513dfdcbc26949$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$50513dfdcbc26949$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $50513dfdcbc26949$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $50513dfdcbc26949$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $50513dfdcbc26949$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $50513dfdcbc26949$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $50513dfdcbc26949$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $50513dfdcbc26949$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $50513dfdcbc26949$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $50513dfdcbc26949$export$d90243b58daecda7.get((0, $2ZDqh.getOwnerWindow)(element))) return;
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $50513dfdcbc26949$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $50513dfdcbc26949$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $50513dfdcbc26949$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $50513dfdcbc26949$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$50513dfdcbc26949$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $50513dfdcbc26949$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $50513dfdcbc26949$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $50513dfdcbc26949$export$d90243b58daecda7.delete(windowObject);
};
function $50513dfdcbc26949$export$2f1888112f558a7d(element) {
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $50513dfdcbc26949$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $50513dfdcbc26949$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$50513dfdcbc26949$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $50513dfdcbc26949$export$2f1888112f558a7d();
function $50513dfdcbc26949$export$b9b3dfddab17db27() {
    return $50513dfdcbc26949$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $50513dfdcbc26949$export$630ff653c5ada6a9() {
    return $50513dfdcbc26949$var$$507fabe10e71c6fb$var$currentModality;
}
function $50513dfdcbc26949$export$8397ddfc504fdb9a(modality) {
    $50513dfdcbc26949$var$$507fabe10e71c6fb$var$currentModality = modality;
    $50513dfdcbc26949$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $50513dfdcbc26949$export$98e20ec92f614cfe() {
    $50513dfdcbc26949$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $exYeM.useState)($50513dfdcbc26949$var$$507fabe10e71c6fb$var$currentModality);
    (0, $exYeM.useEffect)(()=>{
        let handler = ()=>{
            setModality($50513dfdcbc26949$var$$507fabe10e71c6fb$var$currentModality);
        };
        $50513dfdcbc26949$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $50513dfdcbc26949$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $aVmq3.useIsSSR)() ? null : modality;
}
const $50513dfdcbc26949$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $50513dfdcbc26949$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$50513dfdcbc26949$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$50513dfdcbc26949$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $50513dfdcbc26949$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(autoFocus || $50513dfdcbc26949$export$b9b3dfddab17db27());
    $50513dfdcbc26949$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $50513dfdcbc26949$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $50513dfdcbc26949$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $exYeM.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$50513dfdcbc26949$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($50513dfdcbc26949$export$b9b3dfddab17db27());
        };
        $50513dfdcbc26949$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $50513dfdcbc26949$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});

parcelRegister("9vFUJ", function(module, exports) {

$parcel$export(module.exports, "useFocusWithin", function () { return $6ec7858ef9f9a3b3$export$420e68273165f4ec; });

var $8hHS0 = parcelRequire("8hHS0");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $6ec7858ef9f9a3b3$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $exYeM.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $exYeM.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, $8hHS0.useSyntheticBlurEvent)(onBlur);
    let onFocus = (0, $exYeM.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

});
parcelRegister("8hHS0", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $6081f0eee82e7b97$export$715c682d09d639cc; });

var $exYeM = parcelRequire("exYeM");

var $4sExG = parcelRequire("4sExG");
var $71dP2 = parcelRequire("71dP2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $6081f0eee82e7b97$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $6081f0eee82e7b97$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $exYeM.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $71dP2.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $4sExG.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $exYeM.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $6081f0eee82e7b97$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("9tlYp", function(module, exports) {

$parcel$export(module.exports, "useHover", function () { return $6e57ddeb0c456fe3$export$ae780daf29e6d456; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $6e57ddeb0c456fe3$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $6e57ddeb0c456fe3$var$$6179b936705e76d3$var$hoverCount = 0;
function $6e57ddeb0c456fe3$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $6e57ddeb0c456fe3$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $6e57ddeb0c456fe3$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $6e57ddeb0c456fe3$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $6e57ddeb0c456fe3$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $6e57ddeb0c456fe3$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $6e57ddeb0c456fe3$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $6e57ddeb0c456fe3$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $6e57ddeb0c456fe3$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $6e57ddeb0c456fe3$var$$6179b936705e76d3$var$hoverCount--;
        if ($6e57ddeb0c456fe3$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $6e57ddeb0c456fe3$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $6e57ddeb0c456fe3$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $6e57ddeb0c456fe3$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $exYeM.useState)(false);
    let state = (0, $exYeM.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, $exYeM.useEffect)($6e57ddeb0c456fe3$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $exYeM.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($6e57ddeb0c456fe3$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$6e57ddeb0c456fe3$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $exYeM.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}

});


parcelRegister("1KuMV", function(module, exports) {

$parcel$export(module.exports, "useIsMobile", function () { return $8f8f22dd6d6a6f57$export$2b96349243a56116; });
// src/index.ts

var $aVmq3 = parcelRequire("aVmq3");
var $8f8f22dd6d6a6f57$var$MOBILE_SCREEN_WIDTH = 700;
function $8f8f22dd6d6a6f57$export$2b96349243a56116() {
    let isSSR = (0, $aVmq3.useIsSSR)();
    if (isSSR || typeof window === "undefined") return false;
    return window.screen.width <= $8f8f22dd6d6a6f57$var$MOBILE_SCREEN_WIDTH;
}

});




parcelRegister("a7qJQ", function(module, exports) {

$parcel$export(module.exports, "useListbox", function () { return $e9a831326d1bc708$export$33446f1f63e37cb2; });

var $aqGcE = parcelRequire("aqGcE");

var $lJ6o6 = parcelRequire("lJ6o6");

var $jIXBM = parcelRequire("jIXBM");

var $cONwG = parcelRequire("cONwG");

var $LA3Ym = parcelRequire("LA3Ym");
var $lfs90 = parcelRequire("lfs90");

var $exYeM = parcelRequire("exYeM");

var $6pmNA = parcelRequire("6pmNA");
"use client";
function $e9a831326d1bc708$export$33446f1f63e37cb2(props) {
    var _a;
    const globalContext = (0, $lJ6o6.useProviderContext)();
    const { ref: ref, as: as, state: propState, variant: variant, color: color, onAction: onAction, children: children, onSelectionChange: onSelectionChange, disableAnimation: disableAnimation = (_a = globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _a : false, itemClasses: itemClasses, className: className, topContent: topContent, bottomContent: bottomContent, emptyContent: emptyContent = "No items.", hideSelectedIcon: hideSelectedIcon = false, hideEmptyContent: hideEmptyContent = false, shouldHighlightOnFocus: shouldHighlightOnFocus = false, classNames: classNames, ...otherProps } = props;
    const Component = as || "ul";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $lfs90.useDOMRef)(ref);
    const innerState = (0, $cONwG.useListState)({
        ...props,
        children: children,
        onSelectionChange: onSelectionChange
    });
    const state = propState || innerState;
    const { listBoxProps: listBoxProps } = (0, $aqGcE.useListBox)({
        ...props,
        onAction: onAction
    }, state, domRef);
    const slots = (0, $exYeM.useMemo)(()=>(0, $jIXBM.menu)({
            className: className
        }), [
        className
    ]);
    const baseStyles = (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.base, className);
    const getBaseProps = (props2 = {})=>{
        return {
            ref: domRef,
            "data-slot": "base",
            className: slots.base({
                class: baseStyles
            }),
            ...(0, $LA3Ym.filterDOMProps)(otherProps, {
                enabled: shouldFilterDOMProps
            }),
            ...props2
        };
    };
    const getListProps = (props2 = {})=>{
        return {
            "data-slot": "list",
            className: slots.list({
                class: classNames == null ? void 0 : classNames.list
            }),
            ...listBoxProps,
            ...props2
        };
    };
    const getEmptyContentProps = (props2 = {})=>{
        return {
            "data-slot": "empty-content",
            children: emptyContent,
            className: slots.emptyContent({
                class: classNames == null ? void 0 : classNames.emptyContent
            }),
            ...props2
        };
    };
    return {
        Component: Component,
        state: state,
        variant: variant,
        color: color,
        slots: slots,
        classNames: classNames,
        topContent: topContent,
        bottomContent: bottomContent,
        emptyContent: emptyContent,
        hideEmptyContent: hideEmptyContent,
        shouldHighlightOnFocus: shouldHighlightOnFocus,
        hideSelectedIcon: hideSelectedIcon,
        disableAnimation: disableAnimation,
        className: className,
        itemClasses: itemClasses,
        getBaseProps: getBaseProps,
        getListProps: getListProps,
        getEmptyContentProps: getEmptyContentProps
    };
}

});
parcelRegister("cONwG", function(module, exports) {

$parcel$export(module.exports, "useListState", function () { return $9550926bed16f58d$export$2f645645f7bca764; });

var $fxzCj = parcelRequire("fxzCj");
var $dlWrh = parcelRequire("dlWrh");

var $exYeM = parcelRequire("exYeM");

var $eLJRH = parcelRequire("eLJRH");

var $cRBxb = parcelRequire("cRBxb");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $9550926bed16f58d$export$d085fb9e920b5ca7 {
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
    constructor(nodes){
        this.keyMap = new Map();
        this.iterable = nodes;
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && node.type === "section") for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === "item") node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}
function $9550926bed16f58d$export$2f645645f7bca764(props) {
    let { filter: filter } = props;
    let selectionState = (0, $dlWrh.useMultipleSelectionState)(props);
    let disabledKeys = (0, $exYeM.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let factory = (0, $exYeM.useCallback)((nodes)=>filter ? new $9550926bed16f58d$export$d085fb9e920b5ca7(filter(nodes)) : new $9550926bed16f58d$export$d085fb9e920b5ca7(nodes), [
        filter
    ]);
    let context = (0, $exYeM.useMemo)(()=>({
            suppressTextValueWarning: props.suppressTextValueWarning
        }), [
        props.suppressTextValueWarning
    ]);
    let collection = (0, $eLJRH.useCollection)(props, factory, context);
    let selectionManager = (0, $exYeM.useMemo)(()=>new (0, $fxzCj.SelectionManager)(collection, selectionState), [
        collection,
        selectionState
    ]);
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, $exYeM.useRef)(null);
    (0, $exYeM.useEffect)(()=>{
        if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) {
            const startItem = cachedCollection.current.getItem(selectionState.focusedKey);
            const cachedItemNodes = [
                ...cachedCollection.current.getKeys()
            ].map((key)=>{
                const itemNode = cachedCollection.current.getItem(key);
                return itemNode.type === "item" ? itemNode : null;
            }).filter((node)=>node !== null);
            const itemNodes = [
                ...collection.getKeys()
            ].map((key)=>{
                const itemNode = collection.getItem(key);
                return itemNode.type === "item" ? itemNode : null;
            }).filter((node)=>node !== null);
            const diff = cachedItemNodes.length - itemNodes.length;
            let index = Math.min(diff > 1 ? Math.max(startItem.index - diff + 1, 0) : startItem.index, itemNodes.length - 1);
            let newNode;
            while(index >= 0){
                if (!selectionManager.isDisabled(itemNodes[index].key)) {
                    newNode = itemNodes[index];
                    break;
                }
                // Find next, not disabled item.
                if (index < itemNodes.length - 1) index++;
                else {
                    if (index > startItem.index) index = startItem.index;
                    index--;
                }
            }
            selectionState.setFocusedKey(newNode ? newNode.key : null);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager,
        selectionState,
        selectionState.focusedKey
    ]);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9550926bed16f58d$export$e7f05e985daf4b5f(props) {
    var _props_defaultSelectedKey;
    let [selectedKey, setSelectedKey] = (0, $cRBxb.useControlledState)(props.selectedKey, (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : null, props.onSelectionChange);
    let selectedKeys = (0, $exYeM.useMemo)(()=>selectedKey != null ? [
            selectedKey
        ] : [], [
        selectedKey
    ]);
    let { collection: collection, disabledKeys: disabledKeys, selectionManager: selectionManager } = $9550926bed16f58d$export$2f645645f7bca764({
        ...props,
        selectionMode: "single",
        disallowEmptySelection: true,
        allowDuplicateSelectionEvents: true,
        selectedKeys: selectedKeys,
        onSelectionChange: (keys)=>{
            var _keys_values_next_value;
            let key = (_keys_values_next_value = keys.values().next().value) !== null && _keys_values_next_value !== void 0 ? _keys_values_next_value : null;
            // Always fire onSelectionChange, even if the key is the same
            // as the current key (useControlledState does not).
            if (key === selectedKey && props.onSelectionChange) props.onSelectionChange(key);
            setSelectedKey(key);
        }
    });
    let selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
        selectedItem: selectedItem
    };
}

});
parcelRegister("cRBxb", function(module, exports) {

$parcel$export(module.exports, "useControlledState", function () { return $95d78ccdeb7004bd$export$40bfa8c7b0832715; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $95d78ccdeb7004bd$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $exYeM.useState)(value || defaultValue);
    let isControlledRef = (0, $exYeM.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $exYeM.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    let currentValue = isControlled ? value : stateValue;
    let setValue = (0, $exYeM.useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? currentValue : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $95d78ccdeb7004bd$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $95d78ccdeb7004bd$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    let string = step.toString();
    let index = string.indexOf(".");
    let precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $95d78ccdeb7004bd$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

});




parcelRegister("9fwCr", function(module, exports) {

$parcel$export(module.exports, "free_solo_popover_default", function () { return $c89febe933be9a43$export$4f32f7e42026f90b; });

var $2BSid = parcelRequire("2BSid");

var $exYeM = parcelRequire("exYeM");

var $fJq7l = parcelRequire("fJq7l");

var $8Oq4a = parcelRequire("8Oq4a");

var $dVYhV = parcelRequire("dVYhV");
var $b0UTF = parcelRequire("b0UTF");
var $gtP8X = parcelRequire("gtP8X");

var $8vAG4 = parcelRequire("8vAG4");

var $KekyV = parcelRequire("KekyV");

var $ftZJ0 = parcelRequire("ftZJ0");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $c89febe933be9a43$var$FreeSoloPopoverWrapper = (0, $8Oq4a.forwardRef)(({ children: children, motionProps: motionProps, placement: placement, disableAnimation: disableAnimation, style: styleProp = {}, transformOrigin: transformOrigin = {}, ...otherProps }, ref)=>{
    let style = styleProp;
    if (transformOrigin.originX !== void 0 || transformOrigin.originY !== void 0) style = {
        ...style,
        transformOrigin: transformOrigin
    };
    else style = {
        ...style,
        ...(0, $KekyV.getTransformOrigins)(placement === "center" ? "top" : placement)
    };
    return disableAnimation ? /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
        ...otherProps,
        ref: ref,
        children: children
    }) : /* @__PURE__ */ (0, $aSiaI.jsx)((0, $b0UTF.LazyMotion), {
        features: (0, $dVYhV.domAnimation),
        children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $gtP8X.m).div, {
            ref: ref,
            animate: "enter",
            exit: "exit",
            initial: "initial",
            style: style,
            variants: (0, $ftZJ0.TRANSITION_VARIANTS).scaleSpringOpacity,
            ...(0, $8vAG4.mergeProps)(otherProps, motionProps),
            children: children
        })
    });
});
$c89febe933be9a43$var$FreeSoloPopoverWrapper.displayName = "NextUI.FreeSoloPopoverWrapper";
var $c89febe933be9a43$var$FreeSoloPopover = (0, $8Oq4a.forwardRef)(({ children: children, transformOrigin: transformOrigin, ...props }, ref)=>{
    const { Component: Component, state: state, placement: placement, backdrop: backdrop, titleProps: titleProps, portalContainer: portalContainer, disableAnimation: disableAnimation, motionProps: motionProps, isNonModal: isNonModal, getPopoverProps: getPopoverProps, getBackdropProps: getBackdropProps, getDialogProps: getDialogProps, getContentProps: getContentProps } = (0, $2BSid.usePopover)({
        ...props,
        ref: ref
    });
    const backdropContent = $exYeM.useMemo(()=>{
        if (backdrop === "transparent") return null;
        if (disableAnimation) return /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
            ...getBackdropProps()
        });
        return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $b0UTF.LazyMotion), {
            features: (0, $dVYhV.domAnimation),
            children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $gtP8X.m).div, {
                animate: "enter",
                exit: "exit",
                initial: "exit",
                variants: (0, $ftZJ0.TRANSITION_VARIANTS).fade,
                ...getBackdropProps()
            })
        });
    }, [
        backdrop,
        disableAnimation,
        getBackdropProps
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsxs)((0, $fJq7l.Overlay), {
        portalContainer: portalContainer,
        children: [
            !isNonModal && backdropContent,
            /* @__PURE__ */ (0, $aSiaI.jsx)(Component, {
                ...getPopoverProps(),
                children: /* @__PURE__ */ (0, $aSiaI.jsxs)($c89febe933be9a43$var$FreeSoloPopoverWrapper, {
                    disableAnimation: disableAnimation,
                    motionProps: motionProps,
                    placement: placement,
                    tabIndex: -1,
                    transformOrigin: transformOrigin,
                    ...getDialogProps(),
                    children: [
                        !isNonModal && /* @__PURE__ */ (0, $aSiaI.jsx)((0, $fJq7l.DismissButton), {
                            onDismiss: state.close
                        }),
                        /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
                            ...getContentProps(),
                            children: typeof children === "function" ? children(titleProps) : children
                        }),
                        /* @__PURE__ */ (0, $aSiaI.jsx)((0, $fJq7l.DismissButton), {
                            onDismiss: state.close
                        })
                    ]
                })
            })
        ]
    });
});
$c89febe933be9a43$var$FreeSoloPopover.displayName = "NextUI.FreeSoloPopover";
var $c89febe933be9a43$export$4f32f7e42026f90b = $c89febe933be9a43$var$FreeSoloPopover;

});

parcelRegister("9cxwv", function(module, exports) {

$parcel$export(module.exports, "ChevronDownIcon", function () { return $15a04aa6b27f8fe8$export$4857d3f3f5f8319b; });
// src/chevron-down.tsx

var $aSiaI = parcelRequire("aSiaI");
var $15a04aa6b27f8fe8$export$4857d3f3f5f8319b = ({ strokeWidth: strokeWidth = 1.5, ...props })=>/* @__PURE__ */ (0, $aSiaI.jsx)("svg", {
        "aria-hidden": "true",
        fill: "none",
        focusable: "false",
        height: "1em",
        role: "presentation",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: strokeWidth,
        viewBox: "0 0 24 24",
        width: "1em",
        ...props,
        children: /* @__PURE__ */ (0, $aSiaI.jsx)("path", {
            d: "m6 9 6 6 6-6"
        })
    });

});

parcelRegister("MSTUT", function(module, exports) {

$parcel$export(module.exports, "scroll_shadow_default", function () { return $14ce75c7428ab372$export$bef3e985c75eafb5; });

var $8gpcb = parcelRequire("8gpcb");

var $8Oq4a = parcelRequire("8Oq4a");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $14ce75c7428ab372$var$ScrollShadow = (0, $8Oq4a.forwardRef)((props, ref)=>{
    const { Component: Component, children: children, getBaseProps: getBaseProps } = (0, $8gpcb.useScrollShadow)({
        ...props,
        ref: ref
    });
    return /* @__PURE__ */ (0, $aSiaI.jsx)(Component, {
        ...getBaseProps(),
        children: children
    });
});
$14ce75c7428ab372$var$ScrollShadow.displayName = "NextUI.ScrollShadow";
var $14ce75c7428ab372$export$bef3e985c75eafb5 = $14ce75c7428ab372$var$ScrollShadow;

});
parcelRegister("8gpcb", function(module, exports) {

$parcel$export(module.exports, "useScrollShadow", function () { return $000906f471c372af$export$90e7448ca01cde65; });

var $8Oq4a = parcelRequire("8Oq4a");

var $aabcK = parcelRequire("aabcK");

var $lfs90 = parcelRequire("lfs90");

var $1ZESM = parcelRequire("1ZESM");

var $exYeM = parcelRequire("exYeM");

var $luNG9 = parcelRequire("luNG9");
"use client";
function $000906f471c372af$export$90e7448ca01cde65(originalProps) {
    var _a;
    const [props, variantProps] = (0, $8Oq4a.mapPropsVariants)(originalProps, (0, $aabcK.scrollShadow).variantKeys);
    const { ref: ref, as: as, children: children, className: className, style: style, size: size = 40, offset: offset = 0, visibility: visibility = "auto", isEnabled: isEnabled = true, onVisibilityChange: onVisibilityChange, ...otherProps } = props;
    const Component = as || "div";
    const domRef = (0, $lfs90.useDOMRef)(ref);
    (0, $1ZESM.useDataScrollOverflow)({
        domRef: domRef,
        offset: offset,
        visibility: visibility,
        isEnabled: isEnabled,
        onVisibilityChange: onVisibilityChange,
        updateDeps: [
            children
        ],
        overflowCheck: (_a = originalProps.orientation) != null ? _a : "vertical"
    });
    const styles = (0, $exYeM.useMemo)(()=>(0, $aabcK.scrollShadow)({
            ...variantProps,
            className: className
        }), [
        (0, $luNG9.objectToDeps)(variantProps),
        className
    ]);
    const getBaseProps = (props2 = {})=>{
        var _a2;
        return {
            ref: domRef,
            className: styles,
            "data-orientation": (_a2 = originalProps.orientation) != null ? _a2 : "vertical",
            style: {
                "--scroll-shadow-size": `${size}px`,
                ...style,
                ...props2.style
            },
            ...otherProps,
            ...props2
        };
    };
    return {
        Component: Component,
        styles: styles,
        domRef: domRef,
        children: children,
        getBaseProps: getBaseProps
    };
}

});
parcelRegister("aabcK", function(module, exports) {

$parcel$export(module.exports, "scrollShadow", function () { return $7492c46d2f219fd5$export$1515b480513bd18e; });

var $a2Moz = parcelRequire("a2Moz");
// src/components/scroll-shadow.ts
var $7492c46d2f219fd5$var$verticalShadow = [
    "data-[top-scroll=true]:[mask-image:linear-gradient(0deg,#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]",
    "data-[bottom-scroll=true]:[mask-image:linear-gradient(180deg,#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]",
    "data-[top-bottom-scroll=true]:[mask-image:linear-gradient(#000,#000,transparent_0,#000_var(--scroll-shadow-size),#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]"
];
var $7492c46d2f219fd5$var$horizontalShadow = [
    "data-[left-scroll=true]:[mask-image:linear-gradient(270deg,#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]",
    "data-[right-scroll=true]:[mask-image:linear-gradient(90deg,#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]",
    "data-[left-right-scroll=true]:[mask-image:linear-gradient(to_right,#000,#000,transparent_0,#000_var(--scroll-shadow-size),#000_calc(100%_-_var(--scroll-shadow-size)),transparent)]"
];
var $7492c46d2f219fd5$export$1515b480513bd18e = (0, $a2Moz.tv)({
    base: [],
    variants: {
        orientation: {
            vertical: [
                "overflow-y-auto",
                ...$7492c46d2f219fd5$var$verticalShadow
            ],
            horizontal: [
                "overflow-x-auto",
                ...$7492c46d2f219fd5$var$horizontalShadow
            ]
        },
        hideScrollBar: {
            true: "scrollbar-hide",
            false: ""
        }
    },
    defaultVariants: {
        orientation: "vertical",
        hideScrollBar: false
    }
});

});

parcelRegister("1ZESM", function(module, exports) {

$parcel$export(module.exports, "useDataScrollOverflow", function () { return $4008e3e7b77a7160$export$372ebfbb988329b7; });
// src/index.ts

var $luNG9 = parcelRequire("luNG9");

var $exYeM = parcelRequire("exYeM");
function $4008e3e7b77a7160$export$372ebfbb988329b7(props = {}) {
    const { domRef: domRef, isEnabled: isEnabled = true, overflowCheck: overflowCheck = "vertical", visibility: visibility = "auto", offset: offset = 0, onVisibilityChange: onVisibilityChange, updateDeps: updateDeps = [] } = props;
    const visibleRef = (0, $exYeM.useRef)(visibility);
    (0, $exYeM.useEffect)(()=>{
        const el = domRef == null ? void 0 : domRef.current;
        if (!el || !isEnabled) return;
        const setAttributes = (direction, hasBefore, hasAfter, prefix, suffix)=>{
            if (visibility === "auto") {
                const both = `${prefix}${(0, $luNG9.capitalize)(suffix)}Scroll`;
                if (hasBefore && hasAfter) {
                    el.dataset[both] = "true";
                    el.removeAttribute(`data-${prefix}-scroll`);
                    el.removeAttribute(`data-${suffix}-scroll`);
                } else {
                    el.dataset[`${prefix}Scroll`] = hasBefore.toString();
                    el.dataset[`${suffix}Scroll`] = hasAfter.toString();
                    el.removeAttribute(`data-${prefix}-${suffix}-scroll`);
                }
            } else {
                const next = hasBefore && hasAfter ? "both" : hasBefore ? prefix : hasAfter ? suffix : "none";
                if (next !== visibleRef.current) {
                    onVisibilityChange == null || onVisibilityChange(next);
                    visibleRef.current = next;
                }
            }
        };
        const checkOverflow = ()=>{
            const directions = [
                {
                    type: "vertical",
                    prefix: "top",
                    suffix: "bottom"
                },
                {
                    type: "horizontal",
                    prefix: "left",
                    suffix: "right"
                }
            ];
            for (const { type: type, prefix: prefix, suffix: suffix } of directions)if (overflowCheck === type || overflowCheck === "both") {
                const hasBefore = type === "vertical" ? el.scrollTop > offset : el.scrollLeft > offset;
                const hasAfter = type === "vertical" ? el.scrollTop + el.clientHeight + offset < el.scrollHeight : el.scrollLeft + el.clientWidth + offset < el.scrollWidth;
                setAttributes(type, hasBefore, hasAfter, prefix, suffix);
            }
        };
        const clearOverflow = ()=>{
            [
                "top",
                "bottom",
                "top-bottom",
                "left",
                "right",
                "left-right"
            ].forEach((attr)=>{
                el.removeAttribute(`data-${attr}-scroll`);
            });
        };
        checkOverflow();
        el.addEventListener("scroll", checkOverflow);
        if (visibility !== "auto") {
            clearOverflow();
            if (visibility === "both") {
                el.dataset.topBottomScroll = String(overflowCheck === "vertical");
                el.dataset.leftRightScroll = String(overflowCheck === "horizontal");
            } else {
                el.dataset.topBottomScroll = "false";
                el.dataset.leftRightScroll = "false";
                [
                    "top",
                    "bottom",
                    "left",
                    "right"
                ].forEach((attr)=>{
                    el.dataset[`${attr}Scroll`] = String(visibility === attr);
                });
            }
        }
        return ()=>{
            el.removeEventListener("scroll", checkOverflow);
            clearOverflow();
        };
    }, [
        ...updateDeps,
        isEnabled,
        visibility,
        overflowCheck,
        onVisibilityChange,
        domRef
    ]);
}

});




parcelRegister("aO5Cd", function(module, exports) {

$parcel$export(module.exports, "listbox_item_base_default", function () { return $a408253994bef424$export$c9741ea17cd30897; });

var $aavYS = parcelRequire("aavYS");
"use client";
var $a408253994bef424$var$ListboxItemBase = (0, $aavYS.Item);
var $a408253994bef424$export$c9741ea17cd30897 = $a408253994bef424$var$ListboxItemBase;

});

parcelRegister("1KY5Y", function(module, exports) {

$parcel$export(module.exports, "switch_default", function () { return $b0a3d76669e1c3ad$export$fc15fde3b71d3684; });

var $4ly4F = parcelRequire("4ly4F");

var $1gBTM = parcelRequire("1gBTM");

var $exYeM = parcelRequire("exYeM");

var $8Oq4a = parcelRequire("8Oq4a");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $b0a3d76669e1c3ad$var$Switch = (0, $8Oq4a.forwardRef)((props, ref)=>{
    const { Component: Component, children: children, startContent: startContent, endContent: endContent, thumbIcon: thumbIcon, getBaseProps: getBaseProps, getInputProps: getInputProps, getWrapperProps: getWrapperProps, getThumbProps: getThumbProps, getThumbIconProps: getThumbIconProps, getLabelProps: getLabelProps, getStartContentProps: getStartContentProps, getEndContentProps: getEndContentProps } = (0, $4ly4F.useSwitch)({
        ...props,
        ref: ref
    });
    const clonedThumbIcon = typeof thumbIcon === "function" ? thumbIcon(getThumbIconProps({
        includeStateProps: true
    })) : thumbIcon && (0, $exYeM.cloneElement)(thumbIcon, getThumbIconProps());
    const clonedStartContent = startContent && (0, $exYeM.cloneElement)(startContent, getStartContentProps());
    const clonedEndContent = endContent && (0, $exYeM.cloneElement)(endContent, getEndContentProps());
    return /* @__PURE__ */ (0, $aSiaI.jsxs)(Component, {
        ...getBaseProps(),
        children: [
            /* @__PURE__ */ (0, $aSiaI.jsx)((0, $1gBTM.VisuallyHidden), {
                elementType: "span",
                children: /* @__PURE__ */ (0, $aSiaI.jsx)("input", {
                    ...getInputProps()
                })
            }),
            /* @__PURE__ */ (0, $aSiaI.jsxs)("span", {
                ...getWrapperProps(),
                children: [
                    startContent && clonedStartContent,
                    /* @__PURE__ */ (0, $aSiaI.jsx)("span", {
                        ...getThumbProps(),
                        children: thumbIcon && clonedThumbIcon
                    }),
                    endContent && clonedEndContent
                ]
            }),
            children && /* @__PURE__ */ (0, $aSiaI.jsx)("span", {
                ...getLabelProps(),
                children: children
            })
        ]
    });
});
$b0a3d76669e1c3ad$var$Switch.displayName = "NextUI.Switch";
var $b0a3d76669e1c3ad$export$fc15fde3b71d3684 = $b0a3d76669e1c3ad$var$Switch;

});
parcelRegister("4ly4F", function(module, exports) {

$parcel$export(module.exports, "useSwitch", function () { return $3713ec717da71231$export$d853f7095ae95f88; });

var $exYeM = parcelRequire("exYeM");

var $8Oq4a = parcelRequire("8Oq4a");
var $lJ6o6 = parcelRequire("lJ6o6");

var $3XCHN = parcelRequire("3XCHN");

var $7Qd7T = parcelRequire("7Qd7T");

var $b6W9a = parcelRequire("b6W9a");

var $frbz0 = parcelRequire("frbz0");

var $kdWpA = parcelRequire("kdWpA");
var $8vAG4 = parcelRequire("8vAG4");

var $6pmNA = parcelRequire("6pmNA");
var $jj4Oc = parcelRequire("jj4Oc");
var $luNG9 = parcelRequire("luNG9");

var $4FVrf = parcelRequire("4FVrf");

var $cpFiE = parcelRequire("cpFiE");

var $k5F2B = parcelRequire("k5F2B");
"use client";
function $3713ec717da71231$export$d853f7095ae95f88(originalProps = {}) {
    var _a, _b;
    const globalContext = (0, $lJ6o6.useProviderContext)();
    const [props, variantProps] = (0, $8Oq4a.mapPropsVariants)(originalProps, (0, $frbz0.toggle).variantKeys);
    const { ref: ref, as: as, name: name, value: value = "", isReadOnly: isReadOnlyProp = false, autoFocus: autoFocus = false, startContent: startContent, endContent: endContent, defaultSelected: defaultSelected, isSelected: isSelectedProp, children: children, thumbIcon: thumbIcon, className: className, classNames: classNames, onChange: onChange, onValueChange: onValueChange, ...otherProps } = props;
    const Component = as || "label";
    const domRef = (0, $exYeM.useRef)(null);
    const inputRef = (0, $exYeM.useRef)(null);
    const disableAnimation = (_b = (_a = originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const labelId = (0, $exYeM.useId)();
    const ariaSwitchProps = (0, $exYeM.useMemo)(()=>{
        const ariaLabel = otherProps["aria-label"] || typeof children === "string" ? children : void 0;
        return {
            name: name,
            value: value,
            children: children,
            autoFocus: autoFocus,
            defaultSelected: defaultSelected,
            isSelected: isSelectedProp,
            isDisabled: !!originalProps.isDisabled,
            isReadOnly: isReadOnlyProp,
            "aria-label": ariaLabel,
            "aria-labelledby": otherProps["aria-labelledby"] || labelId,
            onChange: onValueChange
        };
    }, [
        value,
        name,
        labelId,
        children,
        autoFocus,
        isReadOnlyProp,
        isSelectedProp,
        defaultSelected,
        originalProps.isDisabled,
        otherProps["aria-label"],
        otherProps["aria-labelledby"],
        onValueChange
    ]);
    const state = (0, $cpFiE.useToggleState)(ariaSwitchProps);
    (0, $7Qd7T.useSafeLayoutEffect)(()=>{
        if (!inputRef.current) return;
        const isInputRefChecked = !!inputRef.current.checked;
        state.setSelected(isInputRefChecked);
    }, [
        inputRef.current
    ]);
    const { inputProps: inputProps, isPressed: isPressedKeyboard, isReadOnly: isReadOnly } = (0, $4FVrf.useSwitch)(ariaSwitchProps, state, inputRef);
    const { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $k5F2B.useFocusRing)({
        autoFocus: inputProps.autoFocus
    });
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $b6W9a.useHover)({
        isDisabled: inputProps.disabled
    });
    const isInteractionDisabled = ariaSwitchProps.isDisabled || isReadOnly;
    const [isPressed, setPressed] = (0, $exYeM.useState)(false);
    const { pressProps: pressProps } = (0, $b6W9a.usePress)({
        isDisabled: isInteractionDisabled,
        onPressStart (e) {
            if (e.pointerType !== "keyboard") setPressed(true);
        },
        onPressEnd (e) {
            if (e.pointerType !== "keyboard") setPressed(false);
        }
    });
    const pressed = isInteractionDisabled ? false : isPressed || isPressedKeyboard;
    const isSelected = inputProps.checked;
    const isDisabled = inputProps.disabled;
    const slots = (0, $exYeM.useMemo)(()=>(0, $frbz0.toggle)({
            ...variantProps,
            disableAnimation: disableAnimation
        }), [
        (0, $luNG9.objectToDeps)(variantProps),
        disableAnimation
    ]);
    const baseStyles = (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.base, className);
    const getBaseProps = (props2)=>{
        return {
            ...(0, $8vAG4.mergeProps)(hoverProps, pressProps, otherProps, props2),
            ref: domRef,
            className: slots.base({
                class: (0, $6pmNA.clsx)(baseStyles, props2 == null ? void 0 : props2.className)
            }),
            "data-disabled": (0, $jj4Oc.dataAttr)(isDisabled),
            "data-selected": (0, $jj4Oc.dataAttr)(isSelected),
            "data-readonly": (0, $jj4Oc.dataAttr)(isReadOnly),
            "data-focus": (0, $jj4Oc.dataAttr)(isFocused),
            "data-focus-visible": (0, $jj4Oc.dataAttr)(isFocusVisible),
            "data-hover": (0, $jj4Oc.dataAttr)(isHovered),
            "data-pressed": (0, $jj4Oc.dataAttr)(pressed)
        };
    };
    const getWrapperProps = (0, $exYeM.useCallback)((props2 = {})=>{
        return {
            ...props2,
            "aria-hidden": true,
            className: (0, $6pmNA.clsx)(slots.wrapper({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.wrapper, props2 == null ? void 0 : props2.className)
            }))
        };
    }, [
        slots,
        classNames == null ? void 0 : classNames.wrapper
    ]);
    const getInputProps = (props2 = {})=>{
        return {
            ...(0, $8vAG4.mergeProps)(inputProps, focusProps, props2),
            ref: (0, $3XCHN.mergeRefs)(inputRef, ref),
            id: inputProps.id,
            onChange: (0, $kdWpA.chain)(onChange, inputProps.onChange)
        };
    };
    const getThumbProps = (0, $exYeM.useCallback)((props2 = {})=>({
            ...props2,
            className: slots.thumb({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.thumb, props2 == null ? void 0 : props2.className)
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.thumb
    ]);
    const getLabelProps = (0, $exYeM.useCallback)((props2 = {})=>({
            ...props2,
            id: labelId,
            className: slots.label({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.label, props2 == null ? void 0 : props2.className)
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.label,
        isDisabled,
        isSelected
    ]);
    const getThumbIconProps = (0, $exYeM.useCallback)((props2 = {
        includeStateProps: false
    })=>(0, $8vAG4.mergeProps)({
            width: "1em",
            height: "1em",
            className: slots.thumbIcon({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.thumbIcon)
            })
        }, props2.includeStateProps ? {
            isSelected: isSelected
        } : {}), [
        slots,
        classNames == null ? void 0 : classNames.thumbIcon,
        isSelected
    ]);
    const getStartContentProps = (0, $exYeM.useCallback)((props2 = {})=>({
            width: "1em",
            height: "1em",
            ...props2,
            className: slots.startContent({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.startContent, props2 == null ? void 0 : props2.className)
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.startContent,
        isSelected
    ]);
    const getEndContentProps = (0, $exYeM.useCallback)((props2 = {})=>({
            width: "1em",
            height: "1em",
            ...props2,
            className: slots.endContent({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.endContent, props2 == null ? void 0 : props2.className)
            })
        }), [
        slots,
        classNames == null ? void 0 : classNames.endContent,
        isSelected
    ]);
    return {
        Component: Component,
        slots: slots,
        classNames: classNames,
        domRef: domRef,
        children: children,
        thumbIcon: thumbIcon,
        startContent: startContent,
        endContent: endContent,
        isHovered: isHovered,
        isSelected: isSelected,
        isPressed: pressed,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        isDisabled: isDisabled,
        getBaseProps: getBaseProps,
        getWrapperProps: getWrapperProps,
        getInputProps: getInputProps,
        getLabelProps: getLabelProps,
        getThumbProps: getThumbProps,
        getThumbIconProps: getThumbIconProps,
        getStartContentProps: getStartContentProps,
        getEndContentProps: getEndContentProps
    };
}

});
parcelRegister("3XCHN", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", function () { return $a874184bbe0fbea4$export$c9058316764c140e; });

var $jj4Oc = parcelRequire("jj4Oc");
"use client";
function $a874184bbe0fbea4$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if ((0, $jj4Oc.isFunction)(ref)) {
        ref(value);
        return;
    }
    try {
        ref.current = value;
    } catch (error) {
        throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
}
function $a874184bbe0fbea4$export$c9058316764c140e(...refs) {
    return (node)=>{
        refs.forEach((ref)=>$a874184bbe0fbea4$export$d734136a7b018efe(ref, node));
    };
}

});

parcelRegister("frbz0", function(module, exports) {

$parcel$export(module.exports, "toggle", function () { return $5f160e6b2e22610b$export$e03c1c3201ee8bb7; });

var $a2Moz = parcelRequire("a2Moz");

var $9dwEN = parcelRequire("9dwEN");
// src/components/toggle.ts
var $5f160e6b2e22610b$export$e03c1c3201ee8bb7 = (0, $a2Moz.tv)({
    slots: {
        base: "group relative max-w-fit inline-flex items-center justify-start cursor-pointer touch-none tap-highlight-transparent",
        wrapper: [
            "px-1",
            "relative",
            "inline-flex",
            "items-center",
            "justify-start",
            "flex-shrink-0",
            "overflow-hidden",
            "bg-default-200",
            "rounded-full",
            ...(0, $9dwEN.groupDataFocusVisibleClasses)
        ],
        thumb: [
            "z-10",
            "flex",
            "items-center",
            "justify-center",
            "bg-white",
            "shadow-small",
            "rounded-full",
            "origin-right"
        ],
        startContent: "z-0 absolute left-1.5 rtl:right-1.5 rtl:left-[unset] text-current",
        endContent: "z-0 absolute right-1.5 rtl:left-1.5 rtl:right-[unset] text-default-600",
        thumbIcon: "text-black",
        label: "relative text-foreground select-none"
    },
    variants: {
        color: {
            default: {
                wrapper: [
                    "group-data-[selected=true]:bg-default-400",
                    "group-data-[selected=true]:text-default-foreground"
                ]
            },
            primary: {
                wrapper: [
                    "group-data-[selected=true]:bg-primary",
                    "group-data-[selected=true]:text-primary-foreground"
                ]
            },
            secondary: {
                wrapper: [
                    "group-data-[selected=true]:bg-secondary",
                    "group-data-[selected=true]:text-secondary-foreground"
                ]
            },
            success: {
                wrapper: [
                    "group-data-[selected=true]:bg-success",
                    "group-data-[selected=true]:text-success-foreground"
                ]
            },
            warning: {
                wrapper: [
                    "group-data-[selected=true]:bg-warning",
                    "group-data-[selected=true]:text-warning-foreground"
                ]
            },
            danger: {
                wrapper: [
                    "group-data-[selected=true]:bg-danger",
                    "data-[selected=true]:text-danger-foreground"
                ]
            }
        },
        size: {
            sm: {
                wrapper: "w-10 h-6 mr-2 rtl:ml-2 rtl:mr-[unset]",
                thumb: [
                    "w-4 h-4 text-tiny",
                    "group-data-[selected=true]:ml-4 rtl:group-data-[selected=true]:ml-0 rtl:group-data-[selected=true]:mr-4"
                ],
                endContent: "text-tiny",
                startContent: "text-tiny",
                label: "text-small"
            },
            md: {
                wrapper: "w-12 h-7 mr-2 rtl:ml-2 rtl:mr-[unset]",
                thumb: [
                    "w-5 h-5 text-small",
                    "group-data-[selected=true]:ml-5 rtl:group-data-[selected=true]:ml-0 rtl:group-data-[selected=true]:mr-5"
                ],
                endContent: "text-small",
                startContent: "text-small",
                label: "text-medium"
            },
            lg: {
                wrapper: "w-14 h-8 mr-2 rtl:ml-2 rtl:mr-[unset]",
                thumb: [
                    "w-6 h-6 text-medium",
                    "group-data-[selected=true]:ml-6 rtl:group-data-[selected=true]:ml-0 rtl:group-data-[selected=true]:mr-6"
                ],
                endContent: "text-medium",
                startContent: "text-medium",
                label: "text-large"
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none"
            }
        },
        disableAnimation: {
            true: {
                wrapper: "transition-none",
                thumb: "transition-none"
            },
            false: {
                wrapper: "transition-background",
                thumb: "transition-all",
                startContent: [
                    "opacity-0",
                    "scale-50",
                    "transition-transform-opacity",
                    "group-data-[selected=true]:scale-100",
                    "group-data-[selected=true]:opacity-100"
                ],
                endContent: [
                    "opacity-100",
                    "transition-transform-opacity",
                    "group-data-[selected=true]:translate-x-3",
                    "group-data-[selected=true]:opacity-0"
                ]
            }
        }
    },
    defaultVariants: {
        color: "primary",
        size: "md",
        isDisabled: false
    },
    compoundVariants: [
        {
            disableAnimation: false,
            size: "sm",
            class: {
                thumb: [
                    "group-data-[pressed=true]:w-5",
                    "group-data-[selected]:group-data-[pressed]:ml-3"
                ]
            }
        },
        {
            disableAnimation: false,
            size: "md",
            class: {
                thumb: [
                    "group-data-[pressed=true]:w-6",
                    "group-data-[selected]:group-data-[pressed]:ml-4"
                ]
            }
        },
        {
            disableAnimation: false,
            size: "lg",
            class: {
                thumb: [
                    "group-data-[pressed=true]:w-7",
                    "group-data-[selected]:group-data-[pressed]:ml-5"
                ]
            }
        }
    ]
});

});

parcelRegister("4FVrf", function(module, exports) {

$parcel$export(module.exports, "useSwitch", function () { return $36778bd31bb782d0$export$d853f7095ae95f88; });

var $4gkvG = parcelRequire("4gkvG");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $36778bd31bb782d0$export$d853f7095ae95f88(props, state, ref) {
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, isPressed: isPressed, isDisabled: isDisabled, isReadOnly: isReadOnly } = (0, $4gkvG.useToggle)(props, state, ref);
    return {
        labelProps: labelProps,
        inputProps: {
            ...inputProps,
            role: "switch",
            checked: isSelected
        },
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly
    };
}

});
parcelRegister("4gkvG", function(module, exports) {

$parcel$export(module.exports, "useToggle", function () { return $31a890eb7a6e4506$export$cbe85ee05b554577; });

var $9cffb = parcelRequire("9cffb");
var $8vAG4 = parcelRequire("8vAG4");
var $bxL7d = parcelRequire("bxL7d");

var $eui8F = parcelRequire("eui8F");

var $889w9 = parcelRequire("889w9");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $31a890eb7a6e4506$export$cbe85ee05b554577(props, state, ref) {
    let { isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, value: value, name: name, children: children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, validationState: validationState = "valid", isInvalid: isInvalid } = props;
    let onChange = (e)=>{
        // since we spread props on label, onChange will end up there as well as in here.
        // so we have to stop propagation at the lowest level that we care about
        e.stopPropagation();
        state.setSelected(e.target.checked);
    };
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    if (!hasChildren && !hasAriaLabel) console.warn("If you do not provide children, you must specify an aria-label for accessibility");
    // This handles focusing the input on pointer down, which Safari does not do by default.
    let { pressProps: pressProps, isPressed: isPressed } = (0, $889w9.usePress)({
        isDisabled: isDisabled
    });
    // iOS does not toggle checkboxes if you drag off and back onto the label, so handle it ourselves.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, $889w9.usePress)({
        isDisabled: isDisabled || isReadOnly,
        onPress () {
            state.toggle();
        }
    });
    let { focusableProps: focusableProps } = (0, $eui8F.useFocusable)(props, ref);
    let interactions = (0, $8vAG4.mergeProps)(pressProps, focusableProps);
    let domProps = (0, $9cffb.filterDOMProps)(props, {
        labelable: true
    });
    (0, $bxL7d.useFormReset)(ref, state.isSelected, state.setSelected);
    return {
        labelProps: (0, $8vAG4.mergeProps)(labelProps, {
            onClick: (e)=>e.preventDefault()
        }),
        inputProps: (0, $8vAG4.mergeProps)(domProps, {
            "aria-invalid": isInvalid || validationState === "invalid" || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-controls": props["aria-controls"],
            "aria-readonly": isReadOnly || undefined,
            onChange: onChange,
            disabled: isDisabled,
            ...value == null ? {} : {
                value: value
            },
            name: name,
            type: "checkbox",
            ...interactions
        }),
        isSelected: state.isSelected,
        isPressed: isPressed || isLabelPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isInvalid: isInvalid || validationState === "invalid"
    };
}

});
parcelRegister("eui8F", function(module, exports) {

$parcel$export(module.exports, "useFocusable", function () { return $a8c1f0059d9f892d$export$4c014de7c8940b4c; });

var $6eqXm = parcelRequire("6eqXm");

var $8vAG4 = parcelRequire("8vAG4");
var $4g3pq = parcelRequire("4g3pq");
var $hbWr9 = parcelRequire("hbWr9");

var $exYeM = parcelRequire("exYeM");

var $24guv = parcelRequire("24guv");
var $eSgSE = parcelRequire("eSgSE");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $a8c1f0059d9f892d$var$$e6afbd83fe6ebbd2$var$FocusableContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
function $a8c1f0059d9f892d$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $exYeM.useContext)($a8c1f0059d9f892d$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $hbWr9.useSyncRef)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $a8c1f0059d9f892d$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $4g3pq.useObjectRef)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($a8c1f0059d9f892d$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $a8c1f0059d9f892d$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef($a8c1f0059d9f892d$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $a8c1f0059d9f892d$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $24guv.useFocus)(props);
    let { keyboardProps: keyboardProps } = (0, $eSgSE.useKeyboard)(props);
    let interactions = (0, $8vAG4.mergeProps)(focusProps, keyboardProps);
    let domProps = $a8c1f0059d9f892d$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $exYeM.useRef)(props.autoFocus);
    (0, $exYeM.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $6eqXm.focusSafely)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $8vAG4.mergeProps)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}

});
parcelRegister("6eqXm", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $4898f5d8863d5207$export$80f3e147d781571c; });

var $6Qamj = parcelRequire("6Qamj");
var $2ZDqh = parcelRequire("2ZDqh");
var $jgteb = parcelRequire("jgteb");

var $3Qmkm = parcelRequire("3Qmkm");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4898f5d8863d5207$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $2ZDqh.getOwnerDocument)(element);
    if ((0, $3Qmkm.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $jgteb.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $6Qamj.focusWithoutScrolling)(element);
        });
    } else (0, $6Qamj.focusWithoutScrolling)(element);
}

});
parcelRegister("3Qmkm", function(module, exports) {

$parcel$export(module.exports, "getInteractionModality", function () { return $2cc78c2d644900b6$export$630ff653c5ada6a9; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$currentModality = null;
let $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $2cc78c2d644900b6$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $gbqqi.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($2cc78c2d644900b6$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $87CgO.isVirtualClick)(e)) {
        $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$2cc78c2d644900b6$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$2cc78c2d644900b6$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $2cc78c2d644900b6$export$d90243b58daecda7.get((0, $2ZDqh.getOwnerWindow)(element))) return;
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $2cc78c2d644900b6$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$2cc78c2d644900b6$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $2cc78c2d644900b6$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $2cc78c2d644900b6$export$d90243b58daecda7.delete(windowObject);
};
function $2cc78c2d644900b6$export$2f1888112f558a7d(element) {
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$2cc78c2d644900b6$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $2cc78c2d644900b6$export$2f1888112f558a7d();
function $2cc78c2d644900b6$export$b9b3dfddab17db27() {
    return $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $2cc78c2d644900b6$export$630ff653c5ada6a9() {
    return $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$currentModality;
}
function $2cc78c2d644900b6$export$8397ddfc504fdb9a(modality) {
    $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$currentModality = modality;
    $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $2cc78c2d644900b6$export$98e20ec92f614cfe() {
    $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $exYeM.useState)($2cc78c2d644900b6$var$$507fabe10e71c6fb$var$currentModality);
    (0, $exYeM.useEffect)(()=>{
        let handler = ()=>{
            setModality($2cc78c2d644900b6$var$$507fabe10e71c6fb$var$currentModality);
        };
        $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $aVmq3.useIsSSR)() ? null : modality;
}
const $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$2cc78c2d644900b6$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$2cc78c2d644900b6$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $2cc78c2d644900b6$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(autoFocus || $2cc78c2d644900b6$export$b9b3dfddab17db27());
    $2cc78c2d644900b6$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $2cc78c2d644900b6$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $exYeM.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$2cc78c2d644900b6$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($2cc78c2d644900b6$export$b9b3dfddab17db27());
        };
        $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $2cc78c2d644900b6$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("24guv", function(module, exports) {

$parcel$export(module.exports, "useFocus", function () { return $1818bf3fd25805bc$export$f8168d8dd8fd66e6; });

var $gQ9a0 = parcelRequire("gQ9a0");

var $exYeM = parcelRequire("exYeM");

var $2ZDqh = parcelRequire("2ZDqh");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $1818bf3fd25805bc$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $exYeM.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $gQ9a0.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $exYeM.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});
parcelRegister("gQ9a0", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $c4289bb7ab80db60$export$715c682d09d639cc; });

var $exYeM = parcelRequire("exYeM");

var $4sExG = parcelRequire("4sExG");
var $71dP2 = parcelRequire("71dP2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $c4289bb7ab80db60$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $c4289bb7ab80db60$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $exYeM.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $71dP2.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $4sExG.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $exYeM.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $c4289bb7ab80db60$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("eSgSE", function(module, exports) {

$parcel$export(module.exports, "useKeyboard", function () { return $ad4333eb186ebbe7$export$8f71654801c2f7cd; });

var $hQwt6 = parcelRequire("hQwt6");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ad4333eb186ebbe7$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $hQwt6.createEventHandler)(props.onKeyDown),
            onKeyUp: (0, $hQwt6.createEventHandler)(props.onKeyUp)
        }
    };
}

});
parcelRegister("hQwt6", function(module, exports) {

$parcel$export(module.exports, "createEventHandler", function () { return $cfe07a8fb2a19862$export$48d1ea6320830260; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $cfe07a8fb2a19862$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}

});



parcelRegister("889w9", function(module, exports) {

$parcel$export(module.exports, "usePress", function () { return $5eb67411ec768bb8$export$45712eceda6fad21; });

var $jA3GS = parcelRequire("jA3GS");

var $j8t4d = parcelRequire("j8t4d");

var $29jGr = parcelRequire("29jGr");

var $6DVYY = parcelRequire("6DVYY");

var $iAON1 = parcelRequire("iAON1");

var $kdWpA = parcelRequire("kdWpA");
var $6Qamj = parcelRequire("6Qamj");
var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");
var $8vAG4 = parcelRequire("8vAG4");
var $h6krv = parcelRequire("h6krv");
var $4sExG = parcelRequire("4sExG");
var $aGeuR = parcelRequire("aGeuR");
var $hbWr9 = parcelRequire("hbWr9");

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $exYeM.useContext)((0, $j8t4d.PressResponderContext));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $8vAG4.mergeProps)(contextProps, props);
        register();
    }
    (0, $hbWr9.useSyncRef)(context, props.ref);
    return props;
}
var $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $iAON1._)(this, $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $29jGr._)(this, $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $6DVYY._)(this, $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $iAON1._)(this, $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $5eb67411ec768bb8$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $exYeM.useState)(false);
    let ref = (0, $exYeM.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $aGeuR.useGlobalListeners)();
    let triggerPressStart = (0, $4sExG.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $4sExG.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $4sExG.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $4sExG.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $jA3GS.restoreTextSelection)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $4sExG.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $exYeM.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "keyup", (0, $kdWpA.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $gbqqi.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $h6krv.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $87CgO.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$5eb67411ec768bb8$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$5eb67411ec768bb8$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $h6krv.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $87CgO.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $jA3GS.disableTextSelection)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $jA3GS.restoreTextSelection)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $87CgO.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $2ZDqh.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $6Qamj.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $jA3GS.disableTextSelection)(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $2ZDqh.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $jA3GS.restoreTextSelection)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $exYeM.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $jA3GS.restoreTextSelection)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $8vAG4.mergeProps)(domProps, pressProps)
    };
}
function $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $2ZDqh.getOwnerWindow)(element).HTMLInputElement && !$5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $2ZDqh.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $5eb67411ec768bb8$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}

});
parcelRegister("jA3GS", function(module, exports) {

$parcel$export(module.exports, "disableTextSelection", function () { return $e4143dffd207b9ee$export$16a4697467175487; });
$parcel$export(module.exports, "restoreTextSelection", function () { return $e4143dffd207b9ee$export$b0d6fa1ab32e3295; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $jgteb = parcelRequire("jgteb");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $e4143dffd207b9ee$var$$14c0b72509d70225$var$state = "default";
let $e4143dffd207b9ee$var$$14c0b72509d70225$var$savedUserSelect = "";
let $e4143dffd207b9ee$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $e4143dffd207b9ee$export$16a4697467175487(target) {
    if ((0, $gbqqi.isIOS)()) {
        if ($e4143dffd207b9ee$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $2ZDqh.getOwnerDocument)(target);
            $e4143dffd207b9ee$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $e4143dffd207b9ee$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $e4143dffd207b9ee$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $e4143dffd207b9ee$export$b0d6fa1ab32e3295(target) {
    if ((0, $gbqqi.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($e4143dffd207b9ee$var$$14c0b72509d70225$var$state !== "disabled") return;
        $e4143dffd207b9ee$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $jgteb.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($e4143dffd207b9ee$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $2ZDqh.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $e4143dffd207b9ee$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $e4143dffd207b9ee$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $e4143dffd207b9ee$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $e4143dffd207b9ee$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $e4143dffd207b9ee$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $e4143dffd207b9ee$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}

});

parcelRegister("j8t4d", function(module, exports) {

$parcel$export(module.exports, "PressResponderContext", function () { return $dee54fc5eb2db8c7$export$5165eccb35aaadb5; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $dee54fc5eb2db8c7$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({
    register: ()=>{}
});
$dee54fc5eb2db8c7$export$5165eccb35aaadb5.displayName = "PressResponderContext";

});




parcelRegister("cpFiE", function(module, exports) {

$parcel$export(module.exports, "useToggleState", function () { return $9097db1cf7c830e8$export$8042c6c013fd5226; });

var $e0Pl7 = parcelRequire("e0Pl7");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9097db1cf7c830e8$export$8042c6c013fd5226(props = {}) {
    let { isReadOnly: isReadOnly } = props;
    // have to provide an empty function so useControlledState doesn't throw a fit
    // can't use useControlledState's prop calling because we need the event object from the change
    let [isSelected, setSelected] = (0, $e0Pl7.useControlledState)(props.isSelected, props.defaultSelected || false, props.onChange);
    function updateSelected(value) {
        if (!isReadOnly) setSelected(value);
    }
    function toggleState() {
        if (!isReadOnly) setSelected(!isSelected);
    }
    return {
        isSelected: isSelected,
        setSelected: updateSelected,
        toggle: toggleState
    };
}

});



parcelRegister("i9Gb7", function(module, exports) {

$parcel$export(module.exports, "tooltip_default", function () { return $11b8a523db8c5fb7$export$a83543e92aefe46a; });

var $2ukpJ = parcelRequire("2ukpJ");

var $8Oq4a = parcelRequire("8Oq4a");

var $fJq7l = parcelRequire("fJq7l");

var $3kiob = parcelRequire("3kiob");
var $dVYhV = parcelRequire("dVYhV");
var $b0UTF = parcelRequire("b0UTF");
var $gtP8X = parcelRequire("gtP8X");

var $ftZJ0 = parcelRequire("ftZJ0");

var $eyVk0 = parcelRequire("eyVk0");

var $exYeM = parcelRequire("exYeM");

var $KekyV = parcelRequire("KekyV");

var $8vAG4 = parcelRequire("8vAG4");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $11b8a523db8c5fb7$var$Tooltip = (0, $8Oq4a.forwardRef)((props, ref)=>{
    const { Component: Component, children: children, content: content, isOpen: isOpen, portalContainer: portalContainer, placement: placement, disableAnimation: disableAnimation, motionProps: motionProps, getTriggerProps: getTriggerProps, getTooltipProps: getTooltipProps, getTooltipContentProps: getTooltipContentProps } = (0, $2ukpJ.useTooltip)({
        ...props,
        ref: ref
    });
    let trigger;
    try {
        const childrenNum = (0, $exYeM.Children).count(children);
        if (childrenNum !== 1) throw new Error();
        if (!(0, $exYeM.isValidElement)(children)) trigger = /* @__PURE__ */ (0, $aSiaI.jsx)("p", {
            ...getTriggerProps(),
            children: children
        });
        else {
            const child = children;
            trigger = (0, $exYeM.cloneElement)(child, getTriggerProps(child.props, child.ref));
        }
    } catch (error) {
        trigger = /* @__PURE__ */ (0, $aSiaI.jsx)("span", {});
        (0, $eyVk0.warn)("Tooltip must have only one child node. Please, check your code.");
    }
    const { ref: tooltipRef, id: id, style: style, ...otherTooltipProps } = getTooltipProps();
    const animatedContent = /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
        ref: tooltipRef,
        id: id,
        style: style,
        children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $b0UTF.LazyMotion), {
            features: (0, $dVYhV.domAnimation),
            children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $gtP8X.m).div, {
                animate: "enter",
                exit: "exit",
                initial: "exit",
                variants: (0, $ftZJ0.TRANSITION_VARIANTS).scaleSpring,
                ...(0, $8vAG4.mergeProps)(motionProps, otherTooltipProps),
                style: {
                    ...(0, $KekyV.getTransformOrigins)(placement)
                },
                children: /* @__PURE__ */ (0, $aSiaI.jsx)(Component, {
                    ...getTooltipContentProps(),
                    children: content
                })
            })
        })
    });
    return /* @__PURE__ */ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            trigger,
            disableAnimation && isOpen ? /* @__PURE__ */ (0, $aSiaI.jsx)((0, $fJq7l.OverlayContainer), {
                portalContainer: portalContainer,
                children: /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
                    ref: tooltipRef,
                    id: id,
                    style: style,
                    ...otherTooltipProps,
                    children: /* @__PURE__ */ (0, $aSiaI.jsx)(Component, {
                        ...getTooltipContentProps(),
                        children: content
                    })
                })
            }) : /* @__PURE__ */ (0, $aSiaI.jsx)((0, $3kiob.AnimatePresence), {
                children: isOpen ? /* @__PURE__ */ (0, $aSiaI.jsx)((0, $fJq7l.OverlayContainer), {
                    portalContainer: portalContainer,
                    children: animatedContent
                }) : null
            })
        ]
    });
});
$11b8a523db8c5fb7$var$Tooltip.displayName = "NextUI.Tooltip";
var $11b8a523db8c5fb7$export$a83543e92aefe46a = $11b8a523db8c5fb7$var$Tooltip;

});
parcelRegister("2ukpJ", function(module, exports) {

$parcel$export(module.exports, "useTooltip", function () { return $55f9f2ba2b8a240d$export$1c4b08e0eca38426; });

var $exYeM = parcelRequire("exYeM");

var $sUEA9 = parcelRequire("sUEA9");

var $8vAG4 = parcelRequire("8vAG4");

var $hYH4T = parcelRequire("hYH4T");

var $fJq7l = parcelRequire("fJq7l");

var $8Oq4a = parcelRequire("8Oq4a");
var $lJ6o6 = parcelRequire("lJ6o6");

var $fCtGx = parcelRequire("fCtGx");

var $6pmNA = parcelRequire("6pmNA");
var $jj4Oc = parcelRequire("jj4Oc");
var $luNG9 = parcelRequire("luNG9");

var $lfs90 = parcelRequire("lfs90");
var $3XCHN = parcelRequire("3XCHN");

var $KekyV = parcelRequire("KekyV");

var $7Qd7T = parcelRequire("7Qd7T");
"use client";
function $55f9f2ba2b8a240d$export$1c4b08e0eca38426(originalProps) {
    var _a, _b;
    const globalContext = (0, $lJ6o6.useProviderContext)();
    const [props, variantProps] = (0, $8Oq4a.mapPropsVariants)(originalProps, (0, $fCtGx.popover).variantKeys);
    const { ref: ref, as: as, isOpen: isOpenProp, content: content, children: children, defaultOpen: defaultOpen, onOpenChange: onOpenChange, isDisabled: isDisabled, trigger: triggerAction, shouldFlip: shouldFlip = true, containerPadding: containerPadding = 12, placement: placementProp = "top", delay: delay = 0, closeDelay: closeDelay = 500, showArrow: showArrow = false, offset: offset = 7, crossOffset: crossOffset = 0, isDismissable: isDismissable, shouldCloseOnBlur: shouldCloseOnBlur = true, portalContainer: portalContainer, isKeyboardDismissDisabled: isKeyboardDismissDisabled = false, updatePositionDeps: updatePositionDeps = [], shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, className: className, onClose: onClose, motionProps: motionProps, classNames: classNames, ...otherProps } = props;
    const Component = as || "div";
    const disableAnimation = (_b = (_a = originalProps == null ? void 0 : originalProps.disableAnimation) != null ? _a : globalContext == null ? void 0 : globalContext.disableAnimation) != null ? _b : false;
    const state = (0, $sUEA9.useTooltipTriggerState)({
        delay: delay,
        closeDelay: closeDelay,
        isDisabled: isDisabled,
        defaultOpen: defaultOpen,
        isOpen: isOpenProp,
        onOpenChange: (isOpen2)=>{
            onOpenChange == null || onOpenChange(isOpen2);
            if (!isOpen2) onClose == null || onClose();
        }
    });
    const triggerRef = (0, $exYeM.useRef)(null);
    const overlayRef = (0, $exYeM.useRef)(null);
    const tooltipId = (0, $exYeM.useId)();
    const isOpen = state.isOpen && !isDisabled;
    (0, $exYeM.useImperativeHandle)(ref, ()=>(0, $lfs90.createDOMRef)(overlayRef));
    const { triggerProps: triggerProps, tooltipProps: triggerTooltipProps } = (0, $hYH4T.useTooltipTrigger)({
        isDisabled: isDisabled,
        trigger: triggerAction
    }, state, triggerRef);
    const { tooltipProps: tooltipProps } = (0, $hYH4T.useTooltip)({
        isOpen: isOpen,
        ...(0, $8vAG4.mergeProps)(props, triggerTooltipProps)
    }, state);
    const { overlayProps: positionProps, placement: placement, updatePosition: updatePosition } = (0, $fJq7l.useOverlayPosition)({
        isOpen: isOpen,
        targetRef: triggerRef,
        placement: (0, $KekyV.toReactAriaPlacement)(placementProp),
        overlayRef: overlayRef,
        offset: showArrow ? offset + 3 : offset,
        crossOffset: crossOffset,
        shouldFlip: shouldFlip,
        containerPadding: containerPadding
    });
    (0, $7Qd7T.useSafeLayoutEffect)(()=>{
        if (!updatePositionDeps.length) return;
        updatePosition();
    }, updatePositionDeps);
    const { overlayProps: overlayProps } = (0, $fJq7l.useOverlay)({
        isOpen: isOpen,
        onClose: state.close,
        isDismissable: isDismissable,
        shouldCloseOnBlur: shouldCloseOnBlur,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, overlayRef);
    const slots = (0, $exYeM.useMemo)(()=>{
        var _a2, _b2, _c;
        return (0, $fCtGx.popover)({
            ...variantProps,
            disableAnimation: disableAnimation,
            radius: (_a2 = originalProps == null ? void 0 : originalProps.radius) != null ? _a2 : "md",
            size: (_b2 = originalProps == null ? void 0 : originalProps.size) != null ? _b2 : "md",
            shadow: (_c = originalProps == null ? void 0 : originalProps.shadow) != null ? _c : "sm"
        });
    }, [
        (0, $luNG9.objectToDeps)(variantProps),
        disableAnimation,
        originalProps == null ? void 0 : originalProps.radius,
        originalProps == null ? void 0 : originalProps.size,
        originalProps == null ? void 0 : originalProps.shadow
    ]);
    const getTriggerProps = (0, $exYeM.useCallback)((props2 = {}, _ref = null)=>({
            ...(0, $8vAG4.mergeProps)(triggerProps, props2),
            ref: (0, $3XCHN.mergeRefs)(_ref, triggerRef),
            "aria-describedby": isOpen ? tooltipId : void 0
        }), [
        triggerProps,
        isOpen,
        tooltipId,
        state
    ]);
    const getTooltipProps = (0, $exYeM.useCallback)(()=>({
            ref: overlayRef,
            "data-slot": "base",
            "data-open": (0, $jj4Oc.dataAttr)(isOpen),
            "data-arrow": (0, $jj4Oc.dataAttr)(showArrow),
            "data-disabled": (0, $jj4Oc.dataAttr)(isDisabled),
            "data-placement": (0, $KekyV.getArrowPlacement)(placement, placementProp),
            ...(0, $8vAG4.mergeProps)(tooltipProps, overlayProps, otherProps),
            style: (0, $8vAG4.mergeProps)(positionProps.style, otherProps.style, props.style),
            className: slots.base({
                class: classNames == null ? void 0 : classNames.base
            }),
            id: tooltipId
        }), [
        slots,
        isOpen,
        showArrow,
        isDisabled,
        placement,
        placementProp,
        tooltipProps,
        overlayProps,
        otherProps,
        positionProps,
        props,
        tooltipId
    ]);
    const getTooltipContentProps = (0, $exYeM.useCallback)(()=>({
            "data-slot": "content",
            "data-open": (0, $jj4Oc.dataAttr)(isOpen),
            "data-arrow": (0, $jj4Oc.dataAttr)(showArrow),
            "data-disabled": (0, $jj4Oc.dataAttr)(isDisabled),
            "data-placement": (0, $KekyV.getArrowPlacement)(placement, placementProp),
            className: slots.content({
                class: (0, $6pmNA.clsx)(classNames == null ? void 0 : classNames.content, className)
            })
        }), [
        slots,
        isOpen,
        showArrow,
        isDisabled,
        placement,
        placementProp,
        classNames
    ]);
    return {
        Component: Component,
        content: content,
        children: children,
        isOpen: isOpen,
        triggerRef: triggerRef,
        showArrow: showArrow,
        portalContainer: portalContainer,
        placement: placementProp,
        disableAnimation: disableAnimation,
        isDisabled: isDisabled,
        motionProps: motionProps,
        getTooltipContentProps: getTooltipContentProps,
        getTriggerProps: getTriggerProps,
        getTooltipProps: getTooltipProps
    };
}

});
parcelRegister("sUEA9", function(module, exports) {

$parcel$export(module.exports, "useTooltipTriggerState", function () { return $056e8fdaca385397$export$4d40659c25ecb50b; });

var $exYeM = parcelRequire("exYeM");

var $h2hZ0 = parcelRequire("h2hZ0");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $056e8fdaca385397$var$$8796f90736e175cb$var$TOOLTIP_DELAY = 1500; // this seems to be a 1.5 second delay, check with design
const $056e8fdaca385397$var$$8796f90736e175cb$var$TOOLTIP_COOLDOWN = 500;
let $056e8fdaca385397$var$$8796f90736e175cb$var$tooltips = {};
let $056e8fdaca385397$var$$8796f90736e175cb$var$tooltipId = 0;
let $056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmedUp = false;
let $056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmUpTimeout = null;
let $056e8fdaca385397$var$$8796f90736e175cb$var$globalCooldownTimeout = null;
function $056e8fdaca385397$export$4d40659c25ecb50b(props = {}) {
    let { delay: delay = $056e8fdaca385397$var$$8796f90736e175cb$var$TOOLTIP_DELAY, closeDelay: closeDelay = $056e8fdaca385397$var$$8796f90736e175cb$var$TOOLTIP_COOLDOWN } = props;
    let { isOpen: isOpen, open: open, close: close } = (0, $h2hZ0.useOverlayTriggerState)(props);
    let id = (0, $exYeM.useMemo)(()=>`${++$056e8fdaca385397$var$$8796f90736e175cb$var$tooltipId}`, []);
    let closeTimeout = (0, $exYeM.useRef)();
    let ensureTooltipEntry = ()=>{
        $056e8fdaca385397$var$$8796f90736e175cb$var$tooltips[id] = hideTooltip;
    };
    let closeOpenTooltips = ()=>{
        for(let hideTooltipId in $056e8fdaca385397$var$$8796f90736e175cb$var$tooltips)if (hideTooltipId !== id) {
            $056e8fdaca385397$var$$8796f90736e175cb$var$tooltips[hideTooltipId](true);
            delete $056e8fdaca385397$var$$8796f90736e175cb$var$tooltips[hideTooltipId];
        }
    };
    let showTooltip = ()=>{
        clearTimeout(closeTimeout.current);
        closeTimeout.current = null;
        closeOpenTooltips();
        ensureTooltipEntry();
        $056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmedUp = true;
        open();
        if ($056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmUpTimeout) {
            clearTimeout($056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmUpTimeout);
            $056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmUpTimeout = null;
        }
        if ($056e8fdaca385397$var$$8796f90736e175cb$var$globalCooldownTimeout) {
            clearTimeout($056e8fdaca385397$var$$8796f90736e175cb$var$globalCooldownTimeout);
            $056e8fdaca385397$var$$8796f90736e175cb$var$globalCooldownTimeout = null;
        }
    };
    let hideTooltip = (immediate)=>{
        if (immediate || closeDelay <= 0) {
            clearTimeout(closeTimeout.current);
            closeTimeout.current = null;
            close();
        } else if (!closeTimeout.current) closeTimeout.current = setTimeout(()=>{
            closeTimeout.current = null;
            close();
        }, closeDelay);
        if ($056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmUpTimeout) {
            clearTimeout($056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmUpTimeout);
            $056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmUpTimeout = null;
        }
        if ($056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmedUp) {
            if ($056e8fdaca385397$var$$8796f90736e175cb$var$globalCooldownTimeout) clearTimeout($056e8fdaca385397$var$$8796f90736e175cb$var$globalCooldownTimeout);
            $056e8fdaca385397$var$$8796f90736e175cb$var$globalCooldownTimeout = setTimeout(()=>{
                delete $056e8fdaca385397$var$$8796f90736e175cb$var$tooltips[id];
                $056e8fdaca385397$var$$8796f90736e175cb$var$globalCooldownTimeout = null;
                $056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmedUp = false;
            }, Math.max($056e8fdaca385397$var$$8796f90736e175cb$var$TOOLTIP_COOLDOWN, closeDelay));
        }
    };
    let warmupTooltip = ()=>{
        closeOpenTooltips();
        ensureTooltipEntry();
        if (!isOpen && !$056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmUpTimeout && !$056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmedUp) $056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmUpTimeout = setTimeout(()=>{
            $056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmUpTimeout = null;
            $056e8fdaca385397$var$$8796f90736e175cb$var$globalWarmedUp = true;
            showTooltip();
        }, delay);
        else if (!isOpen) showTooltip();
    };
    (0, $exYeM.useEffect)(()=>{
        return ()=>{
            clearTimeout(closeTimeout.current);
            let tooltip = $056e8fdaca385397$var$$8796f90736e175cb$var$tooltips[id];
            if (tooltip) delete $056e8fdaca385397$var$$8796f90736e175cb$var$tooltips[id];
        };
    }, [
        id
    ]);
    return {
        isOpen: isOpen,
        open: (immediate)=>{
            if (!immediate && delay > 0 && !closeTimeout.current) warmupTooltip();
            else showTooltip();
        },
        close: hideTooltip
    };
}

});

parcelRegister("hYH4T", function(module, exports) {

$parcel$export(module.exports, "useTooltip", function () { return $d16974a047ee135a$export$1c4b08e0eca38426; });
$parcel$export(module.exports, "useTooltipTrigger", function () { return $d16974a047ee135a$export$a6da6c504e4bba8b; });

var $9cffb = parcelRequire("9cffb");
var $8vAG4 = parcelRequire("8vAG4");
var $ezzQB = parcelRequire("ezzQB");

var $hUUTb = parcelRequire("hUUTb");
var $1RWOV = parcelRequire("1RWOV");

var $exYeM = parcelRequire("exYeM");

var $66AWY = parcelRequire("66AWY");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d16974a047ee135a$export$1c4b08e0eca38426(props, state) {
    let domProps = (0, $9cffb.filterDOMProps)(props, {
        labelable: true
    });
    let { hoverProps: hoverProps } = (0, $1RWOV.useHover)({
        onHoverStart: ()=>state === null || state === void 0 ? void 0 : state.open(true),
        onHoverEnd: ()=>state === null || state === void 0 ? void 0 : state.close()
    });
    return {
        tooltipProps: (0, $8vAG4.mergeProps)(domProps, hoverProps, {
            role: "tooltip"
        })
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d16974a047ee135a$export$a6da6c504e4bba8b(props, state, ref) {
    let { isDisabled: isDisabled, trigger: trigger } = props;
    let tooltipId = (0, $ezzQB.useId)();
    let isHovered = (0, $exYeM.useRef)(false);
    let isFocused = (0, $exYeM.useRef)(false);
    let handleShow = ()=>{
        if (isHovered.current || isFocused.current) state.open(isFocused.current);
    };
    let handleHide = (immediate)=>{
        if (!isHovered.current && !isFocused.current) state.close(immediate);
    };
    (0, $exYeM.useEffect)(()=>{
        let onKeyDown = (e)=>{
            if (ref && ref.current) {
                if (e.key === "Escape") {
                    e.stopPropagation();
                    state.close(true);
                }
            }
        };
        if (state.isOpen) {
            document.addEventListener("keydown", onKeyDown, true);
            return ()=>{
                document.removeEventListener("keydown", onKeyDown, true);
            };
        }
    }, [
        ref,
        state
    ]);
    let onHoverStart = ()=>{
        if (trigger === "focus") return;
        // In chrome, if you hover a trigger, then another element obscures it, due to keyboard
        // interactions for example, hover will end. When hover is restored after that element disappears,
        // focus moves on for example, then the tooltip will reopen. We check the modality to know if the hover
        // is the result of moving the mouse.
        if ((0, $hUUTb.getInteractionModality)() === "pointer") isHovered.current = true;
        else isHovered.current = false;
        handleShow();
    };
    let onHoverEnd = ()=>{
        if (trigger === "focus") return;
        // no matter how the trigger is left, we should close the tooltip
        isFocused.current = false;
        isHovered.current = false;
        handleHide();
    };
    let onPressStart = ()=>{
        // no matter how the trigger is pressed, we should close the tooltip
        isFocused.current = false;
        isHovered.current = false;
        handleHide(true);
    };
    let onFocus = ()=>{
        let isVisible = (0, $hUUTb.isFocusVisible)();
        if (isVisible) {
            isFocused.current = true;
            handleShow();
        }
    };
    let onBlur = ()=>{
        isFocused.current = false;
        isHovered.current = false;
        handleHide(true);
    };
    let { hoverProps: hoverProps } = (0, $1RWOV.useHover)({
        isDisabled: isDisabled,
        onHoverStart: onHoverStart,
        onHoverEnd: onHoverEnd
    });
    let { focusableProps: focusableProps } = (0, $66AWY.useFocusable)({
        isDisabled: isDisabled,
        onFocus: onFocus,
        onBlur: onBlur
    }, ref);
    return {
        triggerProps: {
            "aria-describedby": state.isOpen ? tooltipId : undefined,
            ...(0, $8vAG4.mergeProps)(focusableProps, hoverProps, {
                onPointerDown: onPressStart,
                onKeyDown: onPressStart
            })
        },
        tooltipProps: {
            id: tooltipId
        }
    };
}

});
parcelRegister("hUUTb", function(module, exports) {

$parcel$export(module.exports, "isFocusVisible", function () { return $d0b3cb99392e5dc3$export$b9b3dfddab17db27; });
$parcel$export(module.exports, "getInteractionModality", function () { return $d0b3cb99392e5dc3$export$630ff653c5ada6a9; });

var $2ZDqh = parcelRequire("2ZDqh");
var $gbqqi = parcelRequire("gbqqi");
var $87CgO = parcelRequire("87CgO");

var $exYeM = parcelRequire("exYeM");

var $aVmq3 = parcelRequire("aVmq3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$currentModality = null;
let $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $d0b3cb99392e5dc3$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $gbqqi.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $87CgO.isVirtualClick)(e)) {
        $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $d0b3cb99392e5dc3$export$d90243b58daecda7.get((0, $2ZDqh.getOwnerWindow)(element))) return;
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $d0b3cb99392e5dc3$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $2ZDqh.getOwnerWindow)(element);
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$d0b3cb99392e5dc3$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $d0b3cb99392e5dc3$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $d0b3cb99392e5dc3$export$d90243b58daecda7.delete(windowObject);
};
function $d0b3cb99392e5dc3$export$2f1888112f558a7d(element) {
    const documentObject = (0, $2ZDqh.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $d0b3cb99392e5dc3$export$2f1888112f558a7d();
function $d0b3cb99392e5dc3$export$b9b3dfddab17db27() {
    return $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $d0b3cb99392e5dc3$export$630ff653c5ada6a9() {
    return $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$currentModality;
}
function $d0b3cb99392e5dc3$export$8397ddfc504fdb9a(modality) {
    $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$currentModality = modality;
    $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $d0b3cb99392e5dc3$export$98e20ec92f614cfe() {
    $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $exYeM.useState)($d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$currentModality);
    (0, $exYeM.useEffect)(()=>{
        let handler = ()=>{
            setModality($d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$currentModality);
        };
        $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $aVmq3.useIsSSR)() ? null : modality;
}
const $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $2ZDqh.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $d0b3cb99392e5dc3$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $exYeM.useState)(autoFocus || $d0b3cb99392e5dc3$export$b9b3dfddab17db27());
    $d0b3cb99392e5dc3$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $d0b3cb99392e5dc3$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $exYeM.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($d0b3cb99392e5dc3$export$b9b3dfddab17db27());
        };
        $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $d0b3cb99392e5dc3$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});

parcelRegister("1RWOV", function(module, exports) {

$parcel$export(module.exports, "useHover", function () { return $15c85e2c3305cdae$export$ae780daf29e6d456; });

var $exYeM = parcelRequire("exYeM");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $15c85e2c3305cdae$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $15c85e2c3305cdae$var$$6179b936705e76d3$var$hoverCount = 0;
function $15c85e2c3305cdae$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $15c85e2c3305cdae$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $15c85e2c3305cdae$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $15c85e2c3305cdae$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $15c85e2c3305cdae$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $15c85e2c3305cdae$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $15c85e2c3305cdae$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $15c85e2c3305cdae$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $15c85e2c3305cdae$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $15c85e2c3305cdae$var$$6179b936705e76d3$var$hoverCount--;
        if ($15c85e2c3305cdae$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $15c85e2c3305cdae$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $15c85e2c3305cdae$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $15c85e2c3305cdae$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $exYeM.useState)(false);
    let state = (0, $exYeM.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, $exYeM.useEffect)($15c85e2c3305cdae$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $exYeM.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($15c85e2c3305cdae$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$15c85e2c3305cdae$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $exYeM.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}

});

parcelRegister("66AWY", function(module, exports) {

$parcel$export(module.exports, "useFocusable", function () { return $471ff721bd96d792$export$4c014de7c8940b4c; });

var $2uGLD = parcelRequire("2uGLD");

var $8vAG4 = parcelRequire("8vAG4");
var $4g3pq = parcelRequire("4g3pq");
var $hbWr9 = parcelRequire("hbWr9");

var $exYeM = parcelRequire("exYeM");

var $2rUsL = parcelRequire("2rUsL");
var $kqKLk = parcelRequire("kqKLk");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $471ff721bd96d792$var$$e6afbd83fe6ebbd2$var$FocusableContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
function $471ff721bd96d792$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $exYeM.useContext)($471ff721bd96d792$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $hbWr9.useSyncRef)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $471ff721bd96d792$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $4g3pq.useObjectRef)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($471ff721bd96d792$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $471ff721bd96d792$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef($471ff721bd96d792$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $471ff721bd96d792$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $2rUsL.useFocus)(props);
    let { keyboardProps: keyboardProps } = (0, $kqKLk.useKeyboard)(props);
    let interactions = (0, $8vAG4.mergeProps)(focusProps, keyboardProps);
    let domProps = $471ff721bd96d792$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $exYeM.useRef)(props.autoFocus);
    (0, $exYeM.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $2uGLD.focusSafely)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $8vAG4.mergeProps)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}

});
parcelRegister("2uGLD", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $1d0f8ed597b0a053$export$80f3e147d781571c; });

var $6Qamj = parcelRequire("6Qamj");
var $2ZDqh = parcelRequire("2ZDqh");
var $jgteb = parcelRequire("jgteb");

var $hUUTb = parcelRequire("hUUTb");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1d0f8ed597b0a053$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $2ZDqh.getOwnerDocument)(element);
    if ((0, $hUUTb.getInteractionModality)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $jgteb.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $6Qamj.focusWithoutScrolling)(element);
        });
    } else (0, $6Qamj.focusWithoutScrolling)(element);
}

});

parcelRegister("2rUsL", function(module, exports) {

$parcel$export(module.exports, "useFocus", function () { return $1c89e6c3df50bbff$export$f8168d8dd8fd66e6; });

var $1mbCW = parcelRequire("1mbCW");

var $exYeM = parcelRequire("exYeM");

var $2ZDqh = parcelRequire("2ZDqh");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $1c89e6c3df50bbff$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $exYeM.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $1mbCW.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $exYeM.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $2ZDqh.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});
parcelRegister("1mbCW", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $0fd0dd7081340118$export$715c682d09d639cc; });

var $exYeM = parcelRequire("exYeM");

var $4sExG = parcelRequire("4sExG");
var $71dP2 = parcelRequire("71dP2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $0fd0dd7081340118$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $0fd0dd7081340118$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $exYeM.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $71dP2.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $4sExG.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $exYeM.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $0fd0dd7081340118$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("kqKLk", function(module, exports) {

$parcel$export(module.exports, "useKeyboard", function () { return $edfa8268a2bd9d7f$export$8f71654801c2f7cd; });

var $a4zzm = parcelRequire("a4zzm");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $edfa8268a2bd9d7f$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $a4zzm.createEventHandler)(props.onKeyDown),
            onKeyUp: (0, $a4zzm.createEventHandler)(props.onKeyUp)
        }
    };
}

});
parcelRegister("a4zzm", function(module, exports) {

$parcel$export(module.exports, "createEventHandler", function () { return $01e47b546c54e4b0$export$48d1ea6320830260; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $01e47b546c54e4b0$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}

});





parcelRegister("eyVk0", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $620be6e5e28b8a50$export$c106dd0671a0fc2d; });
// src/console.ts

var $6qd2L = parcelRequire("6qd2L");
var $620be6e5e28b8a50$var$warningStack = {};
function $620be6e5e28b8a50$export$c106dd0671a0fc2d(message, component, ...args) {
    var _a;
    const tag = component ? ` [${component}]` : " ";
    const log = `[Next UI]${tag}: ${message}`;
    if (typeof console === "undefined") return;
    if ($620be6e5e28b8a50$var$warningStack[log]) return;
    $620be6e5e28b8a50$var$warningStack[log] = true;
    if (((_a = $6qd2L == null ? void 0 : $6qd2L.env) == null ? void 0 : _a.NODE_ENV) !== "production") return console.warn(log, args);
}

});
parcelRegister("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});



parcelRegister("afsmN", function(module, exports) {

$parcel$export(module.exports, "Clipboard", function () { return $3b37888b63902266$export$8b44c43c7d8f0830; });

var $exYeM = parcelRequire("exYeM");

var $ivNTa = parcelRequire("ivNTa");

var $f7vj2 = parcelRequire("f7vj2");
var $3b37888b63902266$var$p = Object.defineProperty, $3b37888b63902266$var$f = Object.defineProperties;
var $3b37888b63902266$var$s = Object.getOwnPropertyDescriptors;
var $3b37888b63902266$var$a = Object.getOwnPropertySymbols;
var $3b37888b63902266$var$c = Object.prototype.hasOwnProperty, $3b37888b63902266$var$d = Object.prototype.propertyIsEnumerable;
var $3b37888b63902266$var$t = (r, o, e)=>o in r ? $3b37888b63902266$var$p(r, o, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : r[o] = e, $3b37888b63902266$var$m = (r, o)=>{
    for(var e in o || (o = {}))$3b37888b63902266$var$c.call(o, e) && $3b37888b63902266$var$t(r, e, o[e]);
    if ($3b37888b63902266$var$a) for (var e of $3b37888b63902266$var$a(o))$3b37888b63902266$var$d.call(o, e) && $3b37888b63902266$var$t(r, e, o[e]);
    return r;
}, $3b37888b63902266$var$i = (r, o)=>$3b37888b63902266$var$f(r, $3b37888b63902266$var$s(o));
const $3b37888b63902266$export$8b44c43c7d8f0830 = (0, $exYeM.forwardRef)((r, o)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ivNTa.default), $3b37888b63902266$var$i($3b37888b63902266$var$m({
        ref: o
    }, r), {
        weights: (0, $f7vj2.default)
    })));
$3b37888b63902266$export$8b44c43c7d8f0830.displayName = "Clipboard";

});
parcelRegister("ivNTa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58a696a9e1b089ac$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");

var $6fvZL = parcelRequire("6fvZL");
var $58a696a9e1b089ac$var$y = Object.defineProperty;
var $58a696a9e1b089ac$var$c = Object.getOwnPropertySymbols;
var $58a696a9e1b089ac$var$f = Object.prototype.hasOwnProperty, $58a696a9e1b089ac$var$g = Object.prototype.propertyIsEnumerable;
var $58a696a9e1b089ac$var$d = (t, o, e)=>o in t ? $58a696a9e1b089ac$var$y(t, o, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : t[o] = e, $58a696a9e1b089ac$var$l = (t, o)=>{
    for(var e in o || (o = {}))$58a696a9e1b089ac$var$f.call(o, e) && $58a696a9e1b089ac$var$d(t, e, o[e]);
    if ($58a696a9e1b089ac$var$c) for (var e of $58a696a9e1b089ac$var$c(o))$58a696a9e1b089ac$var$g.call(o, e) && $58a696a9e1b089ac$var$d(t, e, o[e]);
    return t;
};
var $58a696a9e1b089ac$var$a = (t, o)=>{
    var e = {};
    for(var r in t)$58a696a9e1b089ac$var$f.call(t, r) && o.indexOf(r) < 0 && (e[r] = t[r]);
    if (t != null && $58a696a9e1b089ac$var$c) for (var r of $58a696a9e1b089ac$var$c(t))o.indexOf(r) < 0 && $58a696a9e1b089ac$var$g.call(t, r) && (e[r] = t[r]);
    return e;
};
const $58a696a9e1b089ac$var$h = (0, $exYeM.forwardRef)((t, o)=>{
    const m = t, { alt: e, color: r, size: n, weight: s, mirrored: p, children: u, weights: C } = m, v = $58a696a9e1b089ac$var$a(m, [
        "alt",
        "color",
        "size",
        "weight",
        "mirrored",
        "children",
        "weights"
    ]), x = (0, $exYeM.useContext)((0, $6fvZL.IconContext)), { color: B = "currentColor", size: i, weight: I = "regular", mirrored: E = !1 } = x, R = $58a696a9e1b089ac$var$a(x, [
        "color",
        "size",
        "weight",
        "mirrored"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("svg", $58a696a9e1b089ac$var$l($58a696a9e1b089ac$var$l({
        ref: o,
        xmlns: "http://www.w3.org/2000/svg",
        width: n != null ? n : i,
        height: n != null ? n : i,
        fill: r != null ? r : B,
        viewBox: "0 0 256 256",
        transform: p || E ? "scale(-1, 1)" : void 0
    }, R), v), !!e && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("title", null, e), u, C.get(s != null ? s : I));
});
$58a696a9e1b089ac$var$h.displayName = "IconBase";
const $58a696a9e1b089ac$export$2e2bcd8739ae039 = $58a696a9e1b089ac$var$h;

});
parcelRegister("6fvZL", function(module, exports) {

$parcel$export(module.exports, "IconContext", function () { return $03c6b70f2be4999a$export$a49f528ae1a4d0ed; });

var $exYeM = parcelRequire("exYeM");
const $03c6b70f2be4999a$export$a49f528ae1a4d0ed = (0, $exYeM.createContext)({
    color: "currentColor",
    size: "1em",
    weight: "regular",
    mirrored: !1
});

});


parcelRegister("f7vj2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $034593c58c33241c$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");
const $034593c58c33241c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M200,28H165.47a51.88,51.88,0,0,0-74.94,0H56A20,20,0,0,0,36,48V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V48A20,20,0,0,0,200,28ZM155.71,60H100.29a28,28,0,0,1,55.42,0ZM196,212H60V52H77.41A52.13,52.13,0,0,0,76,64v8A12,12,0,0,0,88,84h80a12,12,0,0,0,12-12V64a52.13,52.13,0,0,0-1.41-12H196Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M208,48V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96a39.83,39.83,0,0,0-8,24v8h80V64a39.83,39.83,0,0,0-8-24h40A8,8,0,0,1,208,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M200,32H163.74a47.92,47.92,0,0,0-71.48,0H56A16,16,0,0,0,40,48V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm-72,0a32,32,0,0,1,32,32H96A32,32,0,0,1,128,32Zm72,184H56V48H82.75A47.93,47.93,0,0,0,80,64v8a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V64a47.93,47.93,0,0,0-2.75-16H200Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M200,32H163.74a47.92,47.92,0,0,0-71.48,0H56A16,16,0,0,0,40,48V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm-72,0a32,32,0,0,1,32,32H96A32,32,0,0,1,128,32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M200,34H162.83a45.91,45.91,0,0,0-69.66,0H56A14,14,0,0,0,42,48V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V48A14,14,0,0,0,200,34Zm-72-4a34,34,0,0,1,34,34v2H94V64A34,34,0,0,1,128,30Zm74,186a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H85.67A45.77,45.77,0,0,0,82,64v8a6,6,0,0,0,6,6h80a6,6,0,0,0,6-6V64a45.77,45.77,0,0,0-3.67-18H200a2,2,0,0,1,2,2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M200,32H163.74a47.92,47.92,0,0,0-71.48,0H56A16,16,0,0,0,40,48V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm-72,0a32,32,0,0,1,32,32H96A32,32,0,0,1,128,32Zm72,184H56V48H82.75A47.93,47.93,0,0,0,80,64v8a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V64a47.93,47.93,0,0,0-2.75-16H200Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M200,36H161.92a44,44,0,0,0-67.84,0H56A12,12,0,0,0,44,48V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V48A12,12,0,0,0,200,36Zm-72-8a36,36,0,0,1,36,36v4H92V64A36,36,0,0,1,128,28Zm76,188a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H88.83A43.71,43.71,0,0,0,84,64v8a4,4,0,0,0,4,4h80a4,4,0,0,0,4-4V64a43.71,43.71,0,0,0-4.83-20H200a4,4,0,0,1,4,4Z"
        }))
    ]
]);

});


parcelRegister("glhfa", function(module, exports) {

$parcel$export(module.exports, "Percent", function () { return $347f46f704e5a5bb$export$cbc348af47898b5e; });

var $exYeM = parcelRequire("exYeM");

var $ivNTa = parcelRequire("ivNTa");

var $g6NKH = parcelRequire("g6NKH");
var $347f46f704e5a5bb$var$f = Object.defineProperty, $347f46f704e5a5bb$var$i = Object.defineProperties;
var $347f46f704e5a5bb$var$n = Object.getOwnPropertyDescriptors;
var $347f46f704e5a5bb$var$o = Object.getOwnPropertySymbols;
var $347f46f704e5a5bb$var$p = Object.prototype.hasOwnProperty, $347f46f704e5a5bb$var$s = Object.prototype.propertyIsEnumerable;
var $347f46f704e5a5bb$var$m = (r, e, t)=>e in r ? $347f46f704e5a5bb$var$f(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $347f46f704e5a5bb$var$a = (r, e)=>{
    for(var t in e || (e = {}))$347f46f704e5a5bb$var$p.call(e, t) && $347f46f704e5a5bb$var$m(r, t, e[t]);
    if ($347f46f704e5a5bb$var$o) for (var t of $347f46f704e5a5bb$var$o(e))$347f46f704e5a5bb$var$s.call(e, t) && $347f46f704e5a5bb$var$m(r, t, e[t]);
    return r;
}, $347f46f704e5a5bb$var$c = (r, e)=>$347f46f704e5a5bb$var$i(r, $347f46f704e5a5bb$var$n(e));
const $347f46f704e5a5bb$export$cbc348af47898b5e = (0, $exYeM.forwardRef)((r, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ivNTa.default), $347f46f704e5a5bb$var$c($347f46f704e5a5bb$var$a({
        ref: e
    }, r), {
        weights: (0, $g6NKH.default)
    })));
$347f46f704e5a5bb$export$cbc348af47898b5e.displayName = "Percent";

});
parcelRegister("g6NKH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $951ba9a104607a5b$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");
const $951ba9a104607a5b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M208.49,64.47l-144,144a12,12,0,1,1-17-17l144-144a12,12,0,0,1,17,17ZM47.72,104.27A40,40,0,1,1,76,116,39.72,39.72,0,0,1,47.72,104.27ZM60,76a16,16,0,1,0,4.69-11.31A15.87,15.87,0,0,0,60,76ZM220,180a40,40,0,1,1-11.72-28.29A39.71,39.71,0,0,1,220,180Zm-24,0a15.87,15.87,0,0,0-4.69-11.32h0A16,16,0,1,0,196,180Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M95.8,56.2a28,28,0,1,1-39.6,0A28,28,0,0,1,95.8,56.2Zm104,104a28,28,0,1,0,0,39.6A28,28,0,0,0,199.8,160.2Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M205.66,61.64l-144,144a8,8,0,0,1-11.32-11.32l144-144a8,8,0,0,1,11.32,11.31ZM50.54,101.44a36,36,0,0,1,50.92-50.91h0a36,36,0,0,1-50.92,50.91ZM56,76A20,20,0,1,0,90.14,61.84h0A20,20,0,0,0,56,76ZM216,180a36,36,0,1,1-10.54-25.46h0A35.76,35.76,0,0,1,216,180Zm-16,0a20,20,0,1,0-5.86,14.14A19.87,19.87,0,0,0,200,180Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M176,172a12,12,0,1,1-12-12A12,12,0,0,1,176,172ZM92,96A12,12,0,1,0,80,84,12,12,0,0,0,92,96ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM64,84A28,28,0,1,0,92,56,28,28,0,0,0,64,84Zm128,88a28,28,0,1,0-28,28A28,28,0,0,0,192,172ZM189.66,66.34a8,8,0,0,0-11.32,0l-112,112a8,8,0,0,0,11.32,11.32l112-112A8,8,0,0,0,189.66,66.34Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M204.24,60.23l-144,144a6,6,0,0,1-8.48-8.48l144-144a6,6,0,1,1,8.48,8.49ZM52,100A34,34,0,1,1,76,110,33.78,33.78,0,0,1,52,100Zm2-24a22,22,0,1,0,6.44-15.56A21.86,21.86,0,0,0,54,76ZM214,180A34,34,0,1,1,204,156,33.78,33.78,0,0,1,214,180Zm-12,0a21.87,21.87,0,0,0-6.44-15.56h0A22,22,0,1,0,202,180Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M205.66,61.64l-144,144a8,8,0,0,1-11.32-11.32l144-144a8,8,0,0,1,11.32,11.31ZM50.54,101.44a36,36,0,0,1,50.92-50.91h0a36,36,0,0,1-50.92,50.91ZM56,76A20,20,0,1,0,90.14,61.84h0A20,20,0,0,0,56,76ZM216,180a36,36,0,1,1-10.54-25.46h0A35.76,35.76,0,0,1,216,180Zm-16,0a20,20,0,1,0-5.86,14.14A19.87,19.87,0,0,0,200,180Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M202.83,58.81l-144,144a4,4,0,0,1-5.66-5.66l144-144a4,4,0,1,1,5.66,5.65ZM53.37,98.62A32,32,0,1,1,76,108,31.82,31.82,0,0,1,53.37,98.62ZM52,76a24,24,0,1,0,7-17A23.85,23.85,0,0,0,52,76ZM212,180a32,32,0,1,1-9.37-22.63A31.82,31.82,0,0,1,212,180Zm-8,0a24,24,0,1,0-7,17A23.89,23.89,0,0,0,204,180Z"
        }))
    ]
]);

});


parcelRegister("bU8KF", function(module, exports) {

$parcel$export(module.exports, "PlusCircle", function () { return $4b7ef14b2e12bb96$export$d8dd5a6f368a4f30; });

var $exYeM = parcelRequire("exYeM");

var $ivNTa = parcelRequire("ivNTa");

var $5QIlD = parcelRequire("5QIlD");
var $4b7ef14b2e12bb96$var$s = Object.defineProperty, $4b7ef14b2e12bb96$var$c = Object.defineProperties;
var $4b7ef14b2e12bb96$var$l = Object.getOwnPropertyDescriptors;
var $4b7ef14b2e12bb96$var$t = Object.getOwnPropertySymbols;
var $4b7ef14b2e12bb96$var$f = Object.prototype.hasOwnProperty, $4b7ef14b2e12bb96$var$p = Object.prototype.propertyIsEnumerable;
var $4b7ef14b2e12bb96$var$m = (r, e, o)=>e in r ? $4b7ef14b2e12bb96$var$s(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }) : r[e] = o, $4b7ef14b2e12bb96$var$a = (r, e)=>{
    for(var o in e || (e = {}))$4b7ef14b2e12bb96$var$f.call(e, o) && $4b7ef14b2e12bb96$var$m(r, o, e[o]);
    if ($4b7ef14b2e12bb96$var$t) for (var o of $4b7ef14b2e12bb96$var$t(e))$4b7ef14b2e12bb96$var$p.call(e, o) && $4b7ef14b2e12bb96$var$m(r, o, e[o]);
    return r;
}, $4b7ef14b2e12bb96$var$i = (r, e)=>$4b7ef14b2e12bb96$var$c(r, $4b7ef14b2e12bb96$var$l(e));
const $4b7ef14b2e12bb96$export$d8dd5a6f368a4f30 = (0, $exYeM.forwardRef)((r, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ivNTa.default), $4b7ef14b2e12bb96$var$i($4b7ef14b2e12bb96$var$a({
        ref: e
    }, r), {
        weights: (0, $5QIlD.default)
    })));
$4b7ef14b2e12bb96$export$d8dd5a6f368a4f30.displayName = "PlusCircle";

});
parcelRegister("5QIlD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ffe8805caffedb2$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");
const $9ffe8805caffedb2$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm52-84a12,12,0,0,1-12,12H140v28a12,12,0,0,1-24,0V140H88a12,12,0,0,1,0-24h28V88a12,12,0,0,1,24,0v28h28A12,12,0,0,1,180,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.13,104.13,0,0,0,128,24Zm40,112H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm46-90a6,6,0,0,1-6,6H134v34a6,6,0,0,1-12,0V134H88a6,6,0,0,1,0-12h34V88a6,6,0,0,1,12,0v34h34A6,6,0,0,1,174,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm44-92a4,4,0,0,1-4,4H132v36a4,4,0,0,1-8,0V132H88a4,4,0,0,1,0-8h36V88a4,4,0,0,1,8,0v36h36A4,4,0,0,1,172,128Z"
        }))
    ]
]);

});


parcelRegister("7nTfy", function(module, exports) {

$parcel$export(module.exports, "Question", function () { return $a40434d47068bdb9$export$38435c7d2fecd2f; });

var $exYeM = parcelRequire("exYeM");

var $ivNTa = parcelRequire("ivNTa");

var $hlfXY = parcelRequire("hlfXY");
var $a40434d47068bdb9$var$s = Object.defineProperty, $a40434d47068bdb9$var$f = Object.defineProperties;
var $a40434d47068bdb9$var$n = Object.getOwnPropertyDescriptors;
var $a40434d47068bdb9$var$r = Object.getOwnPropertySymbols;
var $a40434d47068bdb9$var$p = Object.prototype.hasOwnProperty, $a40434d47068bdb9$var$c = Object.prototype.propertyIsEnumerable;
var $a40434d47068bdb9$var$m = (o, e, t)=>e in o ? $a40434d47068bdb9$var$s(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $a40434d47068bdb9$var$a = (o, e)=>{
    for(var t in e || (e = {}))$a40434d47068bdb9$var$p.call(e, t) && $a40434d47068bdb9$var$m(o, t, e[t]);
    if ($a40434d47068bdb9$var$r) for (var t of $a40434d47068bdb9$var$r(e))$a40434d47068bdb9$var$c.call(e, t) && $a40434d47068bdb9$var$m(o, t, e[t]);
    return o;
}, $a40434d47068bdb9$var$i = (o, e)=>$a40434d47068bdb9$var$f(o, $a40434d47068bdb9$var$n(e));
const $a40434d47068bdb9$export$38435c7d2fecd2f = (0, $exYeM.forwardRef)((o, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ivNTa.default), $a40434d47068bdb9$var$i($a40434d47068bdb9$var$a({
        ref: e
    }, o), {
        weights: (0, $hlfXY.default)
    })));
$a40434d47068bdb9$export$38435c7d2fecd2f.displayName = "Question";

});
parcelRegister("hlfXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69ca3818049725c2$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");
const $69ca3818049725c2$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M144,180a16,16,0,1,1-16-16A16,16,0,0,1,144,180Zm92-52A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128ZM128,64c-24.26,0-44,17.94-44,40v4a12,12,0,0,0,24,0v-4c0-8.82,9-16,20-16s20,7.18,20,16-9,16-20,16a12,12,0,0,0-12,12v8a12,12,0,0,0,23.73,2.56C158.31,137.88,172,122.37,172,104,172,81.94,152.26,64,128,64Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,168a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm8-48.72V144a8,8,0,0,1-16,0v-8a8,8,0,0,1,8-8c13.23,0,24-9,24-20s-10.77-20-24-20-24,9-24,20v4a8,8,0,0,1-16,0v-4c0-19.85,17.94-36,40-36s40,16.15,40,36C168,125.38,154.24,139.93,136,143.28Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M138,180a10,10,0,1,1-10-10A10,10,0,0,1,138,180ZM128,74c-21,0-38,15.25-38,34v4a6,6,0,0,0,12,0v-4c0-12.13,11.66-22,26-22s26,9.87,26,22-11.66,22-26,22a6,6,0,0,0-6,6v8a6,6,0,0,0,12,0v-2.42c18.11-2.58,32-16.66,32-33.58C166,89.25,149,74,128,74Zm102,54A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M136,180a8,8,0,1,1-8-8A8,8,0,0,1,136,180ZM128,76c-19.85,0-36,14.36-36,32v4a4,4,0,0,0,8,0v-4c0-13.23,12.56-24,28-24s28,10.77,28,24-12.56,24-28,24a4,4,0,0,0-4,4v8a4,4,0,0,0,8,0v-4.2c18-1.77,32-15.36,32-31.8C164,90.36,147.85,76,128,76Zm100,52A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z"
        }))
    ]
]);

});


parcelRegister("hS8Na", function(module, exports) {

$parcel$export(module.exports, "User", function () { return $6ae06c6fa3fcc78d$export$1f44aaf2ec115b54; });

var $exYeM = parcelRequire("exYeM");

var $ivNTa = parcelRequire("ivNTa");

var $8RrHM = parcelRequire("8RrHM");
var $6ae06c6fa3fcc78d$var$f = Object.defineProperty, $6ae06c6fa3fcc78d$var$i = Object.defineProperties;
var $6ae06c6fa3fcc78d$var$p = Object.getOwnPropertyDescriptors;
var $6ae06c6fa3fcc78d$var$t = Object.getOwnPropertySymbols;
var $6ae06c6fa3fcc78d$var$c = Object.prototype.hasOwnProperty, $6ae06c6fa3fcc78d$var$n = Object.prototype.propertyIsEnumerable;
var $6ae06c6fa3fcc78d$var$m = (r, e, o)=>e in r ? $6ae06c6fa3fcc78d$var$f(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }) : r[e] = o, $6ae06c6fa3fcc78d$var$a = (r, e)=>{
    for(var o in e || (e = {}))$6ae06c6fa3fcc78d$var$c.call(e, o) && $6ae06c6fa3fcc78d$var$m(r, o, e[o]);
    if ($6ae06c6fa3fcc78d$var$t) for (var o of $6ae06c6fa3fcc78d$var$t(e))$6ae06c6fa3fcc78d$var$n.call(e, o) && $6ae06c6fa3fcc78d$var$m(r, o, e[o]);
    return r;
}, $6ae06c6fa3fcc78d$var$s = (r, e)=>$6ae06c6fa3fcc78d$var$i(r, $6ae06c6fa3fcc78d$var$p(e));
const $6ae06c6fa3fcc78d$export$1f44aaf2ec115b54 = (0, $exYeM.forwardRef)((r, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ivNTa.default), $6ae06c6fa3fcc78d$var$s($6ae06c6fa3fcc78d$var$a({
        ref: e
    }, r), {
        weights: (0, $8RrHM.default)
    })));
$6ae06c6fa3fcc78d$export$1f44aaf2ec115b54.displayName = "User";

});
parcelRegister("8RrHM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4711d6346023db58$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");
const $4711d6346023db58$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M234.38,210a123.36,123.36,0,0,0-60.78-53.23,76,76,0,1,0-91.2,0A123.36,123.36,0,0,0,21.62,210a12,12,0,1,0,20.77,12c18.12-31.32,50.12-50,85.61-50s67.49,18.69,85.61,50a12,12,0,0,0,20.77-12ZM76,96a52,52,0,1,1,52,52A52.06,52.06,0,0,1,76,96Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M192,96a64,64,0,1,1-64-64A64,64,0,0,1,192,96Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M230.93,220a8,8,0,0,1-6.93,4H32a8,8,0,0,1-6.92-12c15.23-26.33,38.7-45.21,66.09-54.16a72,72,0,1,1,73.66,0c27.39,8.95,50.86,27.83,66.09,54.16A8,8,0,0,1,230.93,220Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M229.19,213c-15.81-27.32-40.63-46.49-69.47-54.62a70,70,0,1,0-63.44,0C67.44,166.5,42.62,185.67,26.81,213a6,6,0,1,0,10.38,6C56.4,185.81,90.34,166,128,166s71.6,19.81,90.81,53a6,6,0,1,0,10.38-6ZM70,96a58,58,0,1,1,58,58A58.07,58.07,0,0,1,70,96Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M227.46,214c-16.52-28.56-43-48.06-73.68-55.09a68,68,0,1,0-51.56,0c-30.64,7-57.16,26.53-73.68,55.09a4,4,0,0,0,6.92,4C55,184.19,89.62,164,128,164s73,20.19,92.54,54a4,4,0,0,0,3.46,2,3.93,3.93,0,0,0,2-.54A4,4,0,0,0,227.46,214ZM68,96a60,60,0,1,1,60,60A60.07,60.07,0,0,1,68,96Z"
        }))
    ]
]);

});


parcelRegister("kFp87", function(module, exports) {

$parcel$export(module.exports, "X", function () { return $a4887325fc36182e$export$78acf4525d8a74c4; });

var $exYeM = parcelRequire("exYeM");

var $ivNTa = parcelRequire("ivNTa");

var $aqJI7 = parcelRequire("aqJI7");
var $a4887325fc36182e$var$i = Object.defineProperty, $a4887325fc36182e$var$p = Object.defineProperties;
var $a4887325fc36182e$var$s = Object.getOwnPropertyDescriptors;
var $a4887325fc36182e$var$t = Object.getOwnPropertySymbols;
var $a4887325fc36182e$var$c = Object.prototype.hasOwnProperty, $a4887325fc36182e$var$n = Object.prototype.propertyIsEnumerable;
var $a4887325fc36182e$var$m = (o, e, r)=>e in o ? $a4887325fc36182e$var$i(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : o[e] = r, $a4887325fc36182e$var$a = (o, e)=>{
    for(var r in e || (e = {}))$a4887325fc36182e$var$c.call(e, r) && $a4887325fc36182e$var$m(o, r, e[r]);
    if ($a4887325fc36182e$var$t) for (var r of $a4887325fc36182e$var$t(e))$a4887325fc36182e$var$n.call(e, r) && $a4887325fc36182e$var$m(o, r, e[r]);
    return o;
}, $a4887325fc36182e$var$f = (o, e)=>$a4887325fc36182e$var$p(o, $a4887325fc36182e$var$s(e));
const $a4887325fc36182e$export$78acf4525d8a74c4 = (0, $exYeM.forwardRef)((o, e)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ivNTa.default), $a4887325fc36182e$var$f($a4887325fc36182e$var$a({
        ref: e
    }, o), {
        weights: (0, $aqJI7.default)
    })));
$a4887325fc36182e$export$78acf4525d8a74c4.displayName = "X";

});
parcelRegister("aqJI7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cefc4a8ce60bb5f$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");
const $0cefc4a8ce60bb5f$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z"
        }))
    ]
]);

});


parcelRegister("eH0la", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("jQkMW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e722ffcc03cb6ca8$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");
/**
 * Hook to load external script.
 * @param src - Source url to load.
 * @param onLoad - Success callback.
 * @param onError - Error callback.
 */ function $e722ffcc03cb6ca8$var$useLoadScript(src, onLoad, onError) {
    (0, $exYeM.useEffect)(()=>{
        if (!document) return;
        // Find script tag with same src in DOM.
        const foundScript = document.querySelector('script[src="'.concat(src, '"]'));
        // Call onLoad if script marked as loaded.
        if (foundScript === null || foundScript === void 0 ? void 0 : foundScript.dataset.loaded) {
            onLoad === null || onLoad === void 0 || onLoad();
            return;
        }
        // Create or get existed tag.
        const script = foundScript || document.createElement("script");
        // Set src if no script was found.
        if (!foundScript) script.src = src;
        // Mark script as loaded on load event.
        const onLoadWithMarker = ()=>{
            script.dataset.loaded = "1";
            onLoad === null || onLoad === void 0 || onLoad();
        };
        script.addEventListener("load", onLoadWithMarker);
        if (onError) script.addEventListener("error", onError);
        // Add to DOM if not yet added.
        if (!foundScript) document.head.append(script);
        return ()=>{
            script.removeEventListener("load", onLoadWithMarker);
            if (onError) script.removeEventListener("error", onError);
        };
    }, []);
}
/**
 * Hook to load Google Charts JS API.
 * @param params - Load parameters.
 * @param [params.chartVersion] - Chart version to load.
 * @param [params.chartPackages] - Packages to load.
 * @param [params.chartLanguage] - Languages to load.
 * @param [params.mapsApiKey] - Google Maps api key.
 * @returns
 */ function $e722ffcc03cb6ca8$var$useLoadGoogleCharts(param) {
    let { chartVersion: chartVersion = "current", chartPackages: chartPackages = [
        "corechart",
        "controls"
    ], chartLanguage: chartLanguage = "en", mapsApiKey: mapsApiKey } = param;
    const [googleCharts, setGoogleCharts] = (0, $exYeM.useState)(null);
    const [failed, setFailed] = (0, $exYeM.useState)(false);
    $e722ffcc03cb6ca8$var$useLoadScript("https://www.gstatic.com/charts/loader.js", ()=>{
        // @ts-expect-error Getting object from global namespace.
        const google = window === null || window === void 0 ? void 0 : window.google;
        if (!google) return;
        google.charts.load(chartVersion, {
            packages: chartPackages,
            language: chartLanguage,
            mapsApiKey: mapsApiKey
        });
        google.charts.setOnLoadCallback(()=>{
            setGoogleCharts(google);
        });
    }, ()=>{
        setFailed(true);
    });
    return [
        googleCharts,
        failed
    ];
}
/**
 * Wrapper around useLoadGoogleCharts to use in legacy components.
 */ function $e722ffcc03cb6ca8$var$LoadGoogleCharts(param) {
    let { onLoad: onLoad, onError: onError, ...params } = param;
    const [googleCharts, failed] = $e722ffcc03cb6ca8$var$useLoadGoogleCharts(params);
    (0, $exYeM.useEffect)(()=>{
        if (googleCharts && onLoad) onLoad(googleCharts);
    }, [
        googleCharts
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (failed && onError) onError();
    }, [
        failed
    ]);
    return null;
}
const $e722ffcc03cb6ca8$var$chartDefaultProps = {
    // <DEPRECATED_PROPS>
    legend_toggle: false,
    // </DEPRECATED_PROPS>
    options: {},
    legendToggle: false,
    getChartWrapper: ()=>{},
    spreadSheetQueryParameters: {
        headers: 1,
        gid: 1
    },
    rootProps: {},
    chartWrapperParams: {}
};
let $e722ffcc03cb6ca8$var$uniqueID = 0;
const $e722ffcc03cb6ca8$var$generateUniqueID = ()=>{
    $e722ffcc03cb6ca8$var$uniqueID += 1;
    return "reactgooglegraph-".concat($e722ffcc03cb6ca8$var$uniqueID);
};
const $e722ffcc03cb6ca8$var$DEFAULT_CHART_COLORS = [
    "#3366CC",
    "#DC3912",
    "#FF9900",
    "#109618",
    "#990099",
    "#3B3EAC",
    "#0099C6",
    "#DD4477",
    "#66AA00",
    "#B82E2E",
    "#316395",
    "#994499",
    "#22AA99",
    "#AAAA11",
    "#6633CC",
    "#E67300",
    "#8B0707",
    "#329262",
    "#5574A6",
    "#3B3EAC"
];
const $e722ffcc03cb6ca8$var$loadDataTableFromSpreadSheet = async function(googleViz, spreadSheetUrl) {
    let urlParams = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return new Promise((resolve, reject)=>{
        const headers = "".concat(urlParams.headers ? "headers=".concat(urlParams.headers) : "headers=0");
        const queryString = "".concat(urlParams.query ? "&tq=".concat(encodeURIComponent(urlParams.query)) : "");
        const gid = "".concat(urlParams.gid ? "&gid=".concat(urlParams.gid) : "");
        const sheet = "".concat(urlParams.sheet ? "&sheet=".concat(urlParams.sheet) : "");
        const access_token = "".concat(urlParams.access_token ? "&access_token=".concat(urlParams.access_token) : "");
        const urlQueryString = "".concat(headers).concat(gid).concat(sheet).concat(queryString).concat(access_token);
        const urlToSpreadSheet = "".concat(spreadSheetUrl, "/gviz/tq?").concat(urlQueryString); //&tq=${queryString}`;
        const query = new googleViz.visualization.Query(urlToSpreadSheet);
        query.send((response)=>{
            if (response.isError()) reject("Error in query:  ".concat(response.getMessage(), " ").concat(response.getDetailedMessage()));
            else resolve(response.getDataTable());
        });
    });
};
const { Provider: $e722ffcc03cb6ca8$var$Provider, Consumer: $e722ffcc03cb6ca8$var$Consumer } = /*#__PURE__*/ $exYeM.createContext($e722ffcc03cb6ca8$var$chartDefaultProps);
const $e722ffcc03cb6ca8$var$ContextProvider = (param)=>{
    let { children: children, value: value } = param;
    return /*#__PURE__*/ $exYeM.createElement($e722ffcc03cb6ca8$var$Provider, {
        value: value
    }, children);
};
const $e722ffcc03cb6ca8$var$ContextConsumer = (param)=>{
    let { render: render } = param;
    return /*#__PURE__*/ $exYeM.createElement($e722ffcc03cb6ca8$var$Consumer, null, (context)=>{
        return render(context);
    });
};
const $e722ffcc03cb6ca8$var$GRAY_COLOR = "#CCCCCC";
class $e722ffcc03cb6ca8$var$GoogleChartDataTableInner extends $exYeM.Component {
    componentDidMount() {
        this.draw(this.props);
        window.addEventListener("resize", this.onResize);
        if (this.props.legend_toggle || this.props.legendToggle) this.listenToLegendToggle();
    }
    componentWillUnmount() {
        const { google: google, googleChartWrapper: googleChartWrapper } = this.props;
        window.removeEventListener("resize", this.onResize);
        google.visualization.events.removeAllListeners(googleChartWrapper);
        if (googleChartWrapper.getChartType() === "Timeline") googleChartWrapper.getChart() && googleChartWrapper.getChart().clearChart();
    }
    componentDidUpdate() {
        this.draw(this.props);
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hiddenColumns: []
        };
        this.listenToLegendToggle = ()=>{
            const { google: google, googleChartWrapper: googleChartWrapper } = this.props;
            google.visualization.events.addListener(googleChartWrapper, "select", ()=>{
                const chart = googleChartWrapper.getChart();
                const selection = chart.getSelection();
                const dataTable = googleChartWrapper.getDataTable();
                if (selection.length === 0 || // We want to listen to when a whole row is selected. This is the case only when row === null
                selection[0].row || !dataTable) return;
                const columnIndex = selection[0].column;
                const columnID = this.getColumnID(dataTable, columnIndex);
                if (this.state.hiddenColumns.includes(columnID)) this.setState((state)=>({
                        ...state,
                        hiddenColumns: [
                            ...state.hiddenColumns.filter((colID)=>colID !== columnID)
                        ]
                    }));
                else this.setState((state)=>({
                        ...state,
                        hiddenColumns: [
                            ...state.hiddenColumns,
                            columnID
                        ]
                    }));
            });
        };
        this.applyFormatters = (dataTable, formatters)=>{
            const { google: google } = this.props;
            for (let formatter of formatters)switch(formatter.type){
                case "ArrowFormat":
                    {
                        const vizFormatter = new google.visualization.ArrowFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                case "BarFormat":
                    {
                        const vizFormatter = new google.visualization.BarFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                case "ColorFormat":
                    {
                        const vizFormatter = new google.visualization.ColorFormat(formatter.options);
                        const { ranges: ranges } = formatter;
                        for (let range of ranges)vizFormatter.addRange(...range);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                case "DateFormat":
                    {
                        const vizFormatter = new google.visualization.DateFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                case "NumberFormat":
                    {
                        const vizFormatter = new google.visualization.NumberFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                case "PatternFormat":
                    {
                        const vizFormatter = new google.visualization.PatternFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
            }
        };
        this.getColumnID = (dataTable, columnIndex)=>{
            return dataTable.getColumnId(columnIndex) || dataTable.getColumnLabel(columnIndex);
        };
        this.draw = async (param)=>{
            let { data: data, diffdata: diffdata, rows: rows, columns: columns, options: options, legend_toggle: legend_toggle, legendToggle: legendToggle, chartType: chartType, formatters: formatters, spreadSheetUrl: spreadSheetUrl, spreadSheetQueryParameters: spreadSheetQueryParameters } = param;
            const { google: google, googleChartWrapper: googleChartWrapper } = this.props;
            let dataTable;
            let chartDiff = null;
            if (diffdata) {
                const oldData = google.visualization.arrayToDataTable(diffdata.old);
                const newData = google.visualization.arrayToDataTable(diffdata.new);
                chartDiff = google.visualization[chartType].prototype.computeDiff(oldData, newData);
            }
            if (data !== null) {
                if (Array.isArray(data)) dataTable = google.visualization.arrayToDataTable(data);
                else dataTable = new google.visualization.DataTable(data);
            } else if (rows && columns) dataTable = google.visualization.arrayToDataTable([
                columns,
                ...rows
            ]);
            else if (spreadSheetUrl) dataTable = await $e722ffcc03cb6ca8$var$loadDataTableFromSpreadSheet(google, spreadSheetUrl, spreadSheetQueryParameters);
            else dataTable = google.visualization.arrayToDataTable([]);
            const columnCount = dataTable.getNumberOfColumns();
            for(let i = 0; i < columnCount; i += 1){
                const columnID = this.getColumnID(dataTable, i);
                if (this.state.hiddenColumns.includes(columnID)) {
                    const previousColumnLabel = dataTable.getColumnLabel(i);
                    const previousColumnID = dataTable.getColumnId(i);
                    const previousColumnType = dataTable.getColumnType(i);
                    dataTable.removeColumn(i);
                    dataTable.addColumn({
                        label: previousColumnLabel,
                        id: previousColumnID,
                        type: previousColumnType
                    });
                }
            }
            const chart = googleChartWrapper.getChart();
            if (googleChartWrapper.getChartType() === "Timeline") chart && chart.clearChart();
            googleChartWrapper.setChartType(chartType);
            googleChartWrapper.setOptions(options || {});
            googleChartWrapper.setDataTable(dataTable);
            googleChartWrapper.draw();
            if (this.props.googleChartDashboard !== null) this.props.googleChartDashboard.draw(dataTable);
            if (chartDiff) {
                googleChartWrapper.setDataTable(chartDiff);
                googleChartWrapper.draw();
            }
            if (formatters) {
                this.applyFormatters(dataTable, formatters);
                googleChartWrapper.setDataTable(dataTable);
                googleChartWrapper.draw();
            }
            if (legendToggle === true || legend_toggle === true) this.grayOutHiddenColumns({
                options: options
            });
            return;
        };
        this.grayOutHiddenColumns = (param)=>{
            let { options: options } = param;
            const { googleChartWrapper: googleChartWrapper } = this.props;
            const dataTable = googleChartWrapper.getDataTable();
            if (!dataTable) return;
            const columnCount = dataTable.getNumberOfColumns();
            const hasAHiddenColumn = this.state.hiddenColumns.length > 0;
            if (hasAHiddenColumn === false) return;
            const colors = Array.from({
                length: columnCount - 1
            }).map((dontcare, i)=>{
                const columnID = this.getColumnID(dataTable, i + 1);
                if (this.state.hiddenColumns.includes(columnID)) return $e722ffcc03cb6ca8$var$GRAY_COLOR;
                else if (options && options.colors) return options.colors[i];
                else return $e722ffcc03cb6ca8$var$DEFAULT_CHART_COLORS[i];
            });
            googleChartWrapper.setOptions({
                ...options,
                colors: colors
            });
            googleChartWrapper.draw();
        };
        this.onResize = ()=>{
            const { googleChartWrapper: googleChartWrapper } = this.props;
            googleChartWrapper.draw();
        };
    }
}
class $e722ffcc03cb6ca8$var$GoogleChartDataTable extends $exYeM.Component {
    componentDidMount() {}
    componentWillUnmount() {}
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { google: google, googleChartWrapper: googleChartWrapper, googleChartDashboard: googleChartDashboard } = this.props;
        return /*#__PURE__*/ $exYeM.createElement($e722ffcc03cb6ca8$var$ContextConsumer, {
            render: (props)=>{
                return /*#__PURE__*/ $exYeM.createElement($e722ffcc03cb6ca8$var$GoogleChartDataTableInner, Object.assign({}, props, {
                    google: google,
                    googleChartWrapper: googleChartWrapper,
                    googleChartDashboard: googleChartDashboard
                }));
            }
        });
    }
}
class $e722ffcc03cb6ca8$var$GoogleChartEvents extends $exYeM.Component {
    shouldComponentUpdate() {
        return false;
    }
    listenToEvents(param) {
        let { chartEvents: chartEvents, google: google, googleChartWrapper: googleChartWrapper } = param;
        if (!chartEvents) return;
        google.visualization.events.removeAllListeners(googleChartWrapper);
        for (let event of chartEvents){
            var _this = this;
            const { eventName: eventName, callback: callback } = event;
            google.visualization.events.addListener(googleChartWrapper, eventName, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                callback({
                    chartWrapper: googleChartWrapper,
                    props: _this.props,
                    google: google,
                    eventArgs: args
                });
            });
        }
    }
    componentDidMount() {
        var ref;
        const { google: google, googleChartWrapper: googleChartWrapper } = this.props;
        this.listenToEvents({
            chartEvents: ((ref = this.propsFromContext) === null || ref === void 0 ? void 0 : ref.chartEvents) || null,
            google: google,
            googleChartWrapper: googleChartWrapper
        });
    }
    render() {
        this.props;
        return /*#__PURE__*/ $exYeM.createElement($e722ffcc03cb6ca8$var$ContextConsumer, {
            render: (propsFromContext)=>{
                this.propsFromContext = propsFromContext;
                return null;
            }
        });
    }
    constructor(props){
        super(props);
        this.propsFromContext = null;
    }
}
let $e722ffcc03cb6ca8$var$controlCounter = 0;
class $e722ffcc03cb6ca8$var$GoogleChart extends $exYeM.Component {
    componentDidMount() {
        const { options: options, google: google, chartType: chartType, chartWrapperParams: chartWrapperParams, toolbarItems: toolbarItems, getChartEditor: getChartEditor, getChartWrapper: getChartWrapper } = this.props;
        const chartConfig = {
            chartType: chartType,
            options: options,
            containerId: this.getGraphID(),
            ...chartWrapperParams
        };
        const googleChartWrapper = new google.visualization.ChartWrapper(chartConfig);
        googleChartWrapper.setOptions(options || {});
        if (getChartWrapper) getChartWrapper(googleChartWrapper, google);
        const googleChartDashboard = new google.visualization.Dashboard(this.dashboard_ref);
        const googleChartControls = this.addControls(googleChartWrapper, googleChartDashboard);
        if (toolbarItems) google.visualization.drawToolbar(this.toolbar_ref.current, toolbarItems);
        let googleChartEditor = null;
        if (getChartEditor) {
            googleChartEditor = new google.visualization.ChartEditor();
            getChartEditor({
                chartEditor: googleChartEditor,
                chartWrapper: googleChartWrapper,
                google: google
            });
        }
        this.setState({
            googleChartEditor: googleChartEditor,
            googleChartControls: googleChartControls,
            googleChartDashboard: googleChartDashboard,
            googleChartWrapper: googleChartWrapper,
            isReady: true
        });
    }
    componentDidUpdate() {
        if (!this.state.googleChartWrapper) return;
        if (!this.state.googleChartDashboard) return;
        if (!this.state.googleChartControls) return;
        const { controls: controls } = this.props;
        if (controls) for(let i = 0; i < controls.length; i += 1){
            const { controlType: controlType, options: options, controlWrapperParams: controlWrapperParams } = controls[i];
            if (controlWrapperParams && "state" in controlWrapperParams) this.state.googleChartControls[i].control.setState(controlWrapperParams["state"]);
            this.state.googleChartControls[i].control.setOptions(options);
            this.state.googleChartControls[i].control.setControlType(controlType);
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.state.isReady !== nextState.isReady || nextProps.controls !== this.props.controls;
    }
    render() {
        const { width: width, height: height, options: options, style: style } = this.props;
        const divStyle = {
            height: height || options && options.height,
            width: width || options && options.width,
            ...style
        };
        if (this.props.render) return /*#__PURE__*/ $exYeM.createElement("div", {
            ref: this.dashboard_ref,
            style: divStyle
        }, /*#__PURE__*/ $exYeM.createElement("div", {
            ref: this.toolbar_ref,
            id: "toolbar"
        }), this.props.render({
            renderChart: this.renderChart,
            renderControl: this.renderControl,
            renderToolbar: this.renderToolBar
        }));
        else return /*#__PURE__*/ $exYeM.createElement("div", {
            ref: this.dashboard_ref,
            style: divStyle
        }, this.renderControl((param)=>{
            let { controlProp: controlProp } = param;
            return controlProp.controlPosition !== "bottom";
        }), this.renderChart(), this.renderControl((param)=>{
            let { controlProp: controlProp } = param;
            return controlProp.controlPosition === "bottom";
        }), this.renderToolBar());
    }
    constructor(...args1){
        var _this1;
        super(...args1), _this1 = this;
        this.state = {
            googleChartWrapper: null,
            googleChartDashboard: null,
            googleChartControls: null,
            googleChartEditor: null,
            isReady: false
        };
        this.graphID = null;
        this.dashboard_ref = /*#__PURE__*/ $exYeM.createRef();
        this.toolbar_ref = /*#__PURE__*/ $exYeM.createRef();
        this.getGraphID = ()=>{
            const { graphID: graphID, graph_id: graph_id } = this.props;
            let instanceGraphID;
            if (!graphID && !graph_id) {
                if (!this.graphID) instanceGraphID = $e722ffcc03cb6ca8$var$generateUniqueID();
                else instanceGraphID = this.graphID;
            } else if (graphID && !graph_id) instanceGraphID = graphID;
            else if (graph_id && !graphID) instanceGraphID = graph_id;
            else instanceGraphID = graphID;
            this.graphID = instanceGraphID;
            return this.graphID;
        };
        this.getControlID = (id, index)=>{
            $e722ffcc03cb6ca8$var$controlCounter += 1;
            let controlID;
            if (typeof id === "undefined") controlID = "googlechart-control-".concat(index, "-").concat($e722ffcc03cb6ca8$var$controlCounter);
            else controlID = id;
            return controlID;
        };
        this.addControls = (googleChartWrapper, googleChartDashboard)=>{
            const { google: google, controls: controls } = this.props;
            const googleChartControls = !controls ? null : controls.map((control, i)=>{
                const { controlID: controlIDMaybe, controlType: controlType, options: controlOptions, controlWrapperParams: controlWrapperParams } = control;
                const controlID = this.getControlID(controlIDMaybe, i);
                return {
                    controlProp: control,
                    control: new google.visualization.ControlWrapper({
                        containerId: controlID,
                        controlType: controlType,
                        options: controlOptions,
                        ...controlWrapperParams
                    })
                };
            });
            if (!googleChartControls) return null;
            googleChartDashboard.bind(googleChartControls.map((param)=>{
                let { control: control } = param;
                return control;
            }), googleChartWrapper);
            for (let chartControl of googleChartControls){
                const { control: control, controlProp: controlProp } = chartControl;
                const { controlEvents: controlEvents = [] } = controlProp;
                for (let event of controlEvents){
                    var _this = this;
                    const { callback: callback, eventName: eventName } = event;
                    google.visualization.events.removeListener(control, eventName, callback);
                    google.visualization.events.addListener(control, eventName, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        callback({
                            chartWrapper: googleChartWrapper,
                            controlWrapper: control,
                            props: _this.props,
                            google: google,
                            eventArgs: args
                        });
                    });
                }
            }
            return googleChartControls;
        };
        this.renderChart = ()=>{
            const { width: width, height: height, options: options, style: style, className: className, rootProps: rootProps, google: google } = this.props;
            const divStyle = {
                height: height || options && options.height,
                width: width || options && options.width,
                ...style
            };
            return /*#__PURE__*/ $exYeM.createElement("div", Object.assign({
                id: this.getGraphID(),
                style: divStyle,
                className: className
            }, rootProps), this.state.isReady && this.state.googleChartWrapper !== null ? /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement($e722ffcc03cb6ca8$var$GoogleChartDataTable, {
                googleChartWrapper: this.state.googleChartWrapper,
                google: google,
                googleChartDashboard: this.state.googleChartDashboard
            }), /*#__PURE__*/ $exYeM.createElement($e722ffcc03cb6ca8$var$GoogleChartEvents, {
                googleChartWrapper: this.state.googleChartWrapper,
                google: google
            })) : null);
        };
        this.renderControl = function() {
            let filter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (param)=>{
                return true;
            };
            return _this1.state.isReady && _this1.state.googleChartControls !== null ? /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, _this1.state.googleChartControls.filter((param)=>{
                let { controlProp: controlProp, control: control } = param;
                return filter({
                    control: control,
                    controlProp: controlProp
                });
            }).map((param)=>{
                let { control: control, controlProp: controlProp } = param;
                return /*#__PURE__*/ $exYeM.createElement("div", {
                    key: control.getContainerId(),
                    id: control.getContainerId()
                });
            })) : null;
        };
        this.renderToolBar = ()=>{
            if (!this.props.toolbarItems) return null;
            return /*#__PURE__*/ $exYeM.createElement("div", {
                ref: this.toolbar_ref
            });
        };
    }
}
class $e722ffcc03cb6ca8$export$acaa6426d77a227e extends $exYeM.Component {
    render() {
        const { chartLanguage: chartLanguage, chartPackages: chartPackages, chartVersion: chartVersion, mapsApiKey: mapsApiKey, loader: loader, errorElement: errorElement } = this.props;
        return /*#__PURE__*/ $exYeM.createElement($e722ffcc03cb6ca8$var$ContextProvider, {
            value: this.props
        }, this.state.loadingStatus === "ready" && this.state.google !== null ? /*#__PURE__*/ $exYeM.createElement($e722ffcc03cb6ca8$var$GoogleChart, Object.assign({}, this.props, {
            google: this.state.google
        })) : this.state.loadingStatus === "errored" && errorElement ? errorElement : loader, /*#__PURE__*/ $exYeM.createElement($e722ffcc03cb6ca8$var$LoadGoogleCharts, {
            chartLanguage: chartLanguage,
            chartPackages: chartPackages,
            chartVersion: chartVersion,
            mapsApiKey: mapsApiKey,
            onLoad: this.onLoad,
            onError: this.onError
        }));
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    isFullyLoaded(google) {
        const { controls: controls, toolbarItems: toolbarItems, getChartEditor: getChartEditor } = this.props;
        return google && google.visualization && google.visualization.ChartWrapper && google.visualization.Dashboard && (!controls || google.visualization.ChartWrapper) && (!getChartEditor || google.visualization.ChartEditor) && (!toolbarItems || google.visualization.drawToolbar);
    }
    constructor(...args){
        super(...args);
        this._isMounted = false;
        this.state = {
            loadingStatus: "loading",
            google: null
        };
        this.onLoad = (google1)=>{
            if (this.props.onLoad) this.props.onLoad(google1);
            if (this.isFullyLoaded(google1)) this.onSuccess(google1);
            else {
                // IE11: window.google is not fully set, we have to wait
                const id = setInterval(()=>{
                    const google = window.google;
                    if (this._isMounted) {
                        if (google && this.isFullyLoaded(google)) {
                            clearInterval(id);
                            this.onSuccess(google);
                        }
                    } else clearInterval(id);
                }, 1000);
            }
        };
        this.onSuccess = (google)=>{
            this.setState({
                loadingStatus: "ready",
                google: google
            });
        };
        this.onError = ()=>{
            this.setState({
                loadingStatus: "errored"
            });
        };
    }
}
$e722ffcc03cb6ca8$export$acaa6426d77a227e.defaultProps = $e722ffcc03cb6ca8$var$chartDefaultProps;
var $e722ffcc03cb6ca8$export$81a914879818776c;
(function(GoogleDataTableColumnRoleType) {
    GoogleDataTableColumnRoleType["annotation"] = "annotation";
    GoogleDataTableColumnRoleType["annotationText"] = "annotationText";
    GoogleDataTableColumnRoleType["certainty"] = "certainty";
    GoogleDataTableColumnRoleType["emphasis"] = "emphasis";
    GoogleDataTableColumnRoleType["interval"] = "interval";
    GoogleDataTableColumnRoleType["scope"] = "scope";
    GoogleDataTableColumnRoleType["style"] = "style";
    GoogleDataTableColumnRoleType["tooltip"] = "tooltip";
    GoogleDataTableColumnRoleType["domain"] = "domain";
})($e722ffcc03cb6ca8$export$81a914879818776c || ($e722ffcc03cb6ca8$export$81a914879818776c = {}));
var $e722ffcc03cb6ca8$export$2e2bcd8739ae039 = $e722ffcc03cb6ca8$export$acaa6426d77a227e;

});

parcelRegister("7zbAk", function(module, exports) {
"use client";
"use strict";
var $016bf2bd39825471$var$Y = Object.create;
var $016bf2bd39825471$var$E = Object.defineProperty;
var $016bf2bd39825471$var$q = Object.getOwnPropertyDescriptor;
var $016bf2bd39825471$var$G = Object.getOwnPropertyNames;
var $016bf2bd39825471$var$K = Object.getPrototypeOf, $016bf2bd39825471$var$Z = Object.prototype.hasOwnProperty;
var $016bf2bd39825471$var$ee = (e, t)=>{
    for(var o in t)$016bf2bd39825471$var$E(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $016bf2bd39825471$var$j = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let r of $016bf2bd39825471$var$G(t))!$016bf2bd39825471$var$Z.call(e, r) && r !== o && $016bf2bd39825471$var$E(e, r, {
        get: ()=>t[r],
        enumerable: !(s = $016bf2bd39825471$var$q(t, r)) || s.enumerable
    });
    return e;
};
var $016bf2bd39825471$var$W = (e, t, o)=>(o = e != null ? $016bf2bd39825471$var$Y($016bf2bd39825471$var$K(e)) : {}, $016bf2bd39825471$var$j(t || !e || !e.__esModule ? $016bf2bd39825471$var$E(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), $016bf2bd39825471$var$te = (e)=>$016bf2bd39825471$var$j($016bf2bd39825471$var$E({}, "__esModule", {
        value: !0
    }), e);
var $016bf2bd39825471$var$Ve = {};
$016bf2bd39825471$var$ee($016bf2bd39825471$var$Ve, {
    CheckmarkIcon: ()=>$016bf2bd39825471$var$F,
    ErrorIcon: ()=>$016bf2bd39825471$var$w,
    LoaderIcon: ()=>$016bf2bd39825471$var$M,
    ToastBar: ()=>$016bf2bd39825471$var$$,
    ToastIcon: ()=>$016bf2bd39825471$var$U,
    Toaster: ()=>$016bf2bd39825471$var$J,
    default: ()=>$016bf2bd39825471$var$_e,
    resolveValue: ()=>$016bf2bd39825471$var$u,
    toast: ()=>$016bf2bd39825471$var$n,
    useToaster: ()=>$016bf2bd39825471$var$V,
    useToasterStore: ()=>$016bf2bd39825471$var$_
});
module.exports = $016bf2bd39825471$var$te($016bf2bd39825471$var$Ve);
var $016bf2bd39825471$var$oe = (e)=>typeof e == "function", $016bf2bd39825471$var$u = (e, t)=>$016bf2bd39825471$var$oe(e) ? e(t) : e;
var $016bf2bd39825471$var$Q = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $016bf2bd39825471$var$R = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();

var $016bf2bd39825471$var$re = 20;
var $016bf2bd39825471$var$v = new Map, $016bf2bd39825471$var$se = 1e3, $016bf2bd39825471$var$X = (e)=>{
    if ($016bf2bd39825471$var$v.has(e)) return;
    let t = setTimeout(()=>{
        $016bf2bd39825471$var$v.delete(e), $016bf2bd39825471$var$l({
            type: 4,
            toastId: e
        });
    }, $016bf2bd39825471$var$se);
    $016bf2bd39825471$var$v.set(e, t);
}, $016bf2bd39825471$var$ae = (e)=>{
    let t = $016bf2bd39825471$var$v.get(e);
    t && clearTimeout(t);
}, $016bf2bd39825471$var$H = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, $016bf2bd39825471$var$re)
            };
        case 1:
            return t.toast.id && $016bf2bd39825471$var$ae(t.toast.id), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === t.toast.id ? {
                        ...a,
                        ...t.toast
                    } : a)
            };
        case 2:
            let { toast: o } = t;
            return e.toasts.find((a)=>a.id === o.id) ? $016bf2bd39825471$var$H(e, {
                type: 1,
                toast: o
            }) : $016bf2bd39825471$var$H(e, {
                type: 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return s ? $016bf2bd39825471$var$X(s) : e.toasts.forEach((a)=>{
                $016bf2bd39825471$var$X(a.id);
            }), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === s || s === void 0 ? {
                        ...a,
                        visible: !1
                    } : a)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((a)=>a.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let r = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((a)=>({
                        ...a,
                        pauseDuration: a.pauseDuration + r
                    }))
            };
    }
}, $016bf2bd39825471$var$I = [], $016bf2bd39825471$var$D = {
    toasts: [],
    pausedAt: void 0
}, $016bf2bd39825471$var$l = (e)=>{
    $016bf2bd39825471$var$D = $016bf2bd39825471$var$H($016bf2bd39825471$var$D, e), $016bf2bd39825471$var$I.forEach((t)=>{
        t($016bf2bd39825471$var$D);
    });
}, $016bf2bd39825471$var$ie = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $016bf2bd39825471$var$_ = (e = {})=>{
    let [t, o] = (0, (parcelRequire("exYeM")).useState)($016bf2bd39825471$var$D);
    (0, (parcelRequire("exYeM")).useEffect)(()=>($016bf2bd39825471$var$I.push(o), ()=>{
            let r = $016bf2bd39825471$var$I.indexOf(o);
            r > -1 && $016bf2bd39825471$var$I.splice(r, 1);
        }), [
        t
    ]);
    let s = t.toasts.map((r)=>{
        var a, c;
        return {
            ...e,
            ...e[r.type],
            ...r,
            duration: r.duration || ((a = e[r.type]) == null ? void 0 : a.duration) || (e == null ? void 0 : e.duration) || $016bf2bd39825471$var$ie[r.type],
            style: {
                ...e.style,
                ...(c = e[r.type]) == null ? void 0 : c.style,
                ...r.style
            }
        };
    });
    return {
        ...t,
        toasts: s
    };
};
var $016bf2bd39825471$var$ce = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $016bf2bd39825471$var$Q()
    }), $016bf2bd39825471$var$S = (e)=>(t, o)=>{
        let s = $016bf2bd39825471$var$ce(t, e, o);
        return $016bf2bd39825471$var$l({
            type: 2,
            toast: s
        }), s.id;
    }, $016bf2bd39825471$var$n = (e, t)=>$016bf2bd39825471$var$S("blank")(e, t);
$016bf2bd39825471$var$n.error = $016bf2bd39825471$var$S("error");
$016bf2bd39825471$var$n.success = $016bf2bd39825471$var$S("success");
$016bf2bd39825471$var$n.loading = $016bf2bd39825471$var$S("loading");
$016bf2bd39825471$var$n.custom = $016bf2bd39825471$var$S("custom");
$016bf2bd39825471$var$n.dismiss = (e)=>{
    $016bf2bd39825471$var$l({
        type: 3,
        toastId: e
    });
};
$016bf2bd39825471$var$n.remove = (e)=>$016bf2bd39825471$var$l({
        type: 4,
        toastId: e
    });
$016bf2bd39825471$var$n.promise = (e, t, o)=>{
    let s = $016bf2bd39825471$var$n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return e.then((r)=>($016bf2bd39825471$var$n.success($016bf2bd39825471$var$u(t.success, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }), r)).catch((r)=>{
        $016bf2bd39825471$var$n.error($016bf2bd39825471$var$u(t.error, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        });
    }), e;
};

var $016bf2bd39825471$var$pe = (e, t)=>{
    $016bf2bd39825471$var$l({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, $016bf2bd39825471$var$de = ()=>{
    $016bf2bd39825471$var$l({
        type: 5,
        time: Date.now()
    });
}, $016bf2bd39825471$var$V = (e)=>{
    let { toasts: t, pausedAt: o } = $016bf2bd39825471$var$_(e);
    (0, (parcelRequire("exYeM")).useEffect)(()=>{
        if (o) return;
        let a = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let d = (i.duration || 0) + i.pauseDuration - (a - i.createdAt);
            if (d < 0) {
                i.visible && $016bf2bd39825471$var$n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>$016bf2bd39825471$var$n.dismiss(i.id), d);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, (parcelRequire("exYeM")).useCallback)(()=>{
        o && $016bf2bd39825471$var$l({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), r = (0, (parcelRequire("exYeM")).useCallback)((a, c)=>{
        let { reverseOrder: i = !1, gutter: d = 8, defaultPosition: p } = c || {}, g = t.filter((m)=>(m.position || p) === (a.position || p) && m.height), z = g.findIndex((m)=>m.id === a.id), O = g.filter((m, B)=>B < z && m.visible).length;
        return g.filter((m)=>m.visible).slice(...i ? [
            O + 1
        ] : [
            0,
            O
        ]).reduce((m, B)=>m + (B.height || 0) + d, 0);
    }, [
        t
    ]);
    return {
        toasts: t,
        handlers: {
            updateHeight: $016bf2bd39825471$var$pe,
            startPause: $016bf2bd39825471$var$de,
            endPause: s,
            calculateOffset: r
        }
    };
};

var $016bf2bd39825471$var$T = $016bf2bd39825471$var$W((parcelRequire("exYeM")));

var $2WWjm = parcelRequire("2WWjm");

var $016bf2bd39825471$var$y = $016bf2bd39825471$var$W((parcelRequire("exYeM")));

var $2WWjm = parcelRequire("2WWjm");

var $2WWjm = parcelRequire("2WWjm");
var $016bf2bd39825471$var$me = $2WWjm.keyframes`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $016bf2bd39825471$var$ue = $2WWjm.keyframes`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $016bf2bd39825471$var$le = $2WWjm.keyframes`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $016bf2bd39825471$var$w = (0, $2WWjm.styled)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$016bf2bd39825471$var$me} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$016bf2bd39825471$var$ue} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$016bf2bd39825471$var$le} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;

var $2WWjm = parcelRequire("2WWjm");
var $016bf2bd39825471$var$Te = $2WWjm.keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $016bf2bd39825471$var$M = (0, $2WWjm.styled)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$016bf2bd39825471$var$Te} 1s linear infinite;
`;

var $2WWjm = parcelRequire("2WWjm");
var $016bf2bd39825471$var$fe = $2WWjm.keyframes`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $016bf2bd39825471$var$ye = $2WWjm.keyframes`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $016bf2bd39825471$var$F = (0, $2WWjm.styled)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$016bf2bd39825471$var$fe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$016bf2bd39825471$var$ye} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $016bf2bd39825471$var$ge = (0, $2WWjm.styled)("div")`
  position: absolute;
`, $016bf2bd39825471$var$he = (0, $2WWjm.styled)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $016bf2bd39825471$var$xe = $2WWjm.keyframes`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $016bf2bd39825471$var$be = (0, $2WWjm.styled)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$016bf2bd39825471$var$xe} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $016bf2bd39825471$var$U = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $016bf2bd39825471$var$y.createElement($016bf2bd39825471$var$be, null, t) : t : o === "blank" ? null : $016bf2bd39825471$var$y.createElement($016bf2bd39825471$var$he, null, $016bf2bd39825471$var$y.createElement($016bf2bd39825471$var$M, {
        ...s
    }), o !== "loading" && $016bf2bd39825471$var$y.createElement($016bf2bd39825471$var$ge, null, o === "error" ? $016bf2bd39825471$var$y.createElement($016bf2bd39825471$var$w, {
        ...s
    }) : $016bf2bd39825471$var$y.createElement($016bf2bd39825471$var$F, {
        ...s
    })));
};
var $016bf2bd39825471$var$Se = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $016bf2bd39825471$var$Ae = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $016bf2bd39825471$var$Pe = "0%{opacity:0;} 100%{opacity:1;}", $016bf2bd39825471$var$Oe = "0%{opacity:1;} 100%{opacity:0;}", $016bf2bd39825471$var$Ee = (0, $2WWjm.styled)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $016bf2bd39825471$var$Re = (0, $2WWjm.styled)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $016bf2bd39825471$var$ve = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [r, a] = $016bf2bd39825471$var$R() ? [
        $016bf2bd39825471$var$Pe,
        $016bf2bd39825471$var$Oe
    ] : [
        $016bf2bd39825471$var$Se(s),
        $016bf2bd39825471$var$Ae(s)
    ];
    return {
        animation: t ? `${(0, $2WWjm.keyframes)(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $2WWjm.keyframes)(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $016bf2bd39825471$var$$ = $016bf2bd39825471$var$T.memo(({ toast: e, position: t, style: o, children: s })=>{
    let r = e.height ? $016bf2bd39825471$var$ve(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, a = $016bf2bd39825471$var$T.createElement($016bf2bd39825471$var$U, {
        toast: e
    }), c = $016bf2bd39825471$var$T.createElement($016bf2bd39825471$var$Re, {
        ...e.ariaProps
    }, $016bf2bd39825471$var$u(e.message, e));
    return $016bf2bd39825471$var$T.createElement($016bf2bd39825471$var$Ee, {
        className: e.className,
        style: {
            ...r,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: a,
        message: c
    }) : $016bf2bd39825471$var$T.createElement($016bf2bd39825471$var$T.Fragment, null, a, c));
});

var $2WWjm = parcelRequire("2WWjm");

var $016bf2bd39825471$var$f = $016bf2bd39825471$var$W((parcelRequire("exYeM")));
(0, $2WWjm.setup)($016bf2bd39825471$var$f.createElement);
var $016bf2bd39825471$var$Ie = ({ id: e, className: t, style: o, onHeightUpdate: s, children: r })=>{
    let a = $016bf2bd39825471$var$f.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let d = c.getBoundingClientRect().height;
                s(e, d);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $016bf2bd39825471$var$f.createElement("div", {
        ref: a,
        className: t,
        style: o
    }, r);
}, $016bf2bd39825471$var$De = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, r = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $016bf2bd39825471$var$R() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...r
    };
}, $016bf2bd39825471$var$ke = $2WWjm.css`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $016bf2bd39825471$var$L = 16, $016bf2bd39825471$var$J = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: r, containerStyle: a, containerClassName: c })=>{
    let { toasts: i, handlers: d } = $016bf2bd39825471$var$V(o);
    return $016bf2bd39825471$var$f.createElement("div", {
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $016bf2bd39825471$var$L,
            left: $016bf2bd39825471$var$L,
            right: $016bf2bd39825471$var$L,
            bottom: $016bf2bd39825471$var$L,
            pointerEvents: "none",
            ...a
        },
        className: c,
        onMouseEnter: d.startPause,
        onMouseLeave: d.endPause
    }, i.map((p)=>{
        let g = p.position || t, z = d.calculateOffset(p, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), O = $016bf2bd39825471$var$De(g, z);
        return $016bf2bd39825471$var$f.createElement($016bf2bd39825471$var$Ie, {
            id: p.id,
            key: p.id,
            onHeightUpdate: d.updateHeight,
            className: p.visible ? $016bf2bd39825471$var$ke : "",
            style: O
        }, p.type === "custom" ? $016bf2bd39825471$var$u(p.message, p) : r ? r(p) : $016bf2bd39825471$var$f.createElement($016bf2bd39825471$var$$, {
            toast: p,
            position: g
        }));
    }));
};
var $016bf2bd39825471$var$_e = $016bf2bd39825471$var$n;

});
parcelRegister("2WWjm", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $225e3aedd577446a$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $225e3aedd577446a$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "setup", function () { return $225e3aedd577446a$export$de27182ff8187d6c; });
$parcel$export(module.exports, "styled", function () { return $225e3aedd577446a$export$3817b7a54a07cec7; });
let $225e3aedd577446a$var$e = {
    data: ""
}, $225e3aedd577446a$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $225e3aedd577446a$var$e, $225e3aedd577446a$export$54aba348a7896325 = (e)=>{
    let r = $225e3aedd577446a$var$t(e), l = r.data;
    return r.data = "", l;
}, $225e3aedd577446a$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $225e3aedd577446a$var$a = /\/\*[^]*?\*\/|  +/g, $225e3aedd577446a$var$n = /\n+/g, $225e3aedd577446a$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $225e3aedd577446a$var$o(c, n) : n + "{" + $225e3aedd577446a$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $225e3aedd577446a$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $225e3aedd577446a$var$o.p ? $225e3aedd577446a$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $225e3aedd577446a$var$c = {}, $225e3aedd577446a$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $225e3aedd577446a$var$s(e[r]);
        return t;
    }
    return e;
}, $225e3aedd577446a$var$i = (e, t, r, i, p)=>{
    let u = $225e3aedd577446a$var$s(e), d = $225e3aedd577446a$var$c[u] || ($225e3aedd577446a$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$225e3aedd577446a$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $225e3aedd577446a$var$l.exec(e.replace($225e3aedd577446a$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($225e3aedd577446a$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($225e3aedd577446a$var$n, " ").trim();
            return o[0];
        })(e);
        $225e3aedd577446a$var$c[d] = $225e3aedd577446a$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $225e3aedd577446a$var$c.g ? $225e3aedd577446a$var$c.g : null;
    return r && ($225e3aedd577446a$var$c.g = $225e3aedd577446a$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($225e3aedd577446a$var$c[d], t, i, f), d;
}, $225e3aedd577446a$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $225e3aedd577446a$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $225e3aedd577446a$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $225e3aedd577446a$var$i(l.unshift ? l.raw ? $225e3aedd577446a$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $225e3aedd577446a$var$t(r.target), r.g, r.o, r.k);
}
let $225e3aedd577446a$var$d, $225e3aedd577446a$var$f, $225e3aedd577446a$var$g, $225e3aedd577446a$export$442f1a04865e4790 = $225e3aedd577446a$export$dbf350e5966cf602.bind({
    g: 1
}), $225e3aedd577446a$export$d25ddfdf17c3ad3e = $225e3aedd577446a$export$dbf350e5966cf602.bind({
    k: 1
});
function $225e3aedd577446a$export$de27182ff8187d6c(e, t, r, l) {
    $225e3aedd577446a$var$o.p = t, $225e3aedd577446a$var$d = e, $225e3aedd577446a$var$f = r, $225e3aedd577446a$var$g = l;
}
function $225e3aedd577446a$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $225e3aedd577446a$var$f && $225e3aedd577446a$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $225e3aedd577446a$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $225e3aedd577446a$var$g && i[0] && $225e3aedd577446a$var$g(c), $225e3aedd577446a$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}

});


parcelRegister("hTj76", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0666643e2ee88b4$export$2e2bcd8739ae039; });

var $hs40T = parcelRequire("hs40T");

var $eabBn = parcelRequire("eabBn");

var $6evQb = parcelRequire("6evQb");
function $d0666643e2ee88b4$var$v4(options, buf, offset) {
    if ((0, $hs40T.default).randomUUID && !buf && !options) return (0, $hs40T.default).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $eabBn.default)();
    if (rnds.length < 16) throw new Error("Random bytes length must be >= 16");
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $6evQb.unsafeStringify)(rnds);
}
var $d0666643e2ee88b4$export$2e2bcd8739ae039 = $d0666643e2ee88b4$var$v4;

});
parcelRegister("hs40T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb482a25fa64fd81$export$2e2bcd8739ae039; });
const $cb482a25fa64fd81$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $cb482a25fa64fd81$export$2e2bcd8739ae039 = {
    randomUUID: $cb482a25fa64fd81$var$randomUUID
};

});

parcelRegister("eabBn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4faffbfed8ce8b6$export$2e2bcd8739ae039; });
let $a4faffbfed8ce8b6$var$getRandomValues;
const $a4faffbfed8ce8b6$var$rnds8 = new Uint8Array(16);
function $a4faffbfed8ce8b6$export$2e2bcd8739ae039() {
    if (!$a4faffbfed8ce8b6$var$getRandomValues) {
        if (typeof crypto === "undefined" || !crypto.getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
        $a4faffbfed8ce8b6$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $a4faffbfed8ce8b6$var$getRandomValues($a4faffbfed8ce8b6$var$rnds8);
}

});

parcelRegister("6evQb", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", function () { return $489cbfc69d38cb8e$export$8fb373d660548968; });

var $ccUSO = parcelRequire("ccUSO");
const $489cbfc69d38cb8e$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$489cbfc69d38cb8e$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $489cbfc69d38cb8e$export$8fb373d660548968(arr, offset = 0) {
    return ($489cbfc69d38cb8e$var$byteToHex[arr[offset + 0]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 1]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 2]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 3]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 4]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 5]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 6]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 7]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 8]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 9]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 10]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 11]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 12]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 13]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 14]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $489cbfc69d38cb8e$var$stringify(arr, offset = 0) {
    const uuid = $489cbfc69d38cb8e$export$8fb373d660548968(arr, offset);
    if (!(0, $ccUSO.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $489cbfc69d38cb8e$export$2e2bcd8739ae039 = $489cbfc69d38cb8e$var$stringify;

});
parcelRegister("ccUSO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e32bacb71dd477f$export$2e2bcd8739ae039; });

var $l3plK = parcelRequire("l3plK");
function $8e32bacb71dd477f$var$validate(uuid) {
    return typeof uuid === "string" && (0, $l3plK.default).test(uuid);
}
var $8e32bacb71dd477f$export$2e2bcd8739ae039 = $8e32bacb71dd477f$var$validate;

});
parcelRegister("l3plK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f53d8abb4c91ec67$export$2e2bcd8739ae039; });
var $f53d8abb4c91ec67$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});




parcelRegister("codwM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9052383c1c4e5569$export$2e2bcd8739ae039; });
var $9052383c1c4e5569$var$t = "undefined" != typeof window ? window : void 0, $9052383c1c4e5569$var$e = "undefined" != typeof globalThis ? globalThis : $9052383c1c4e5569$var$t;
"undefined" == typeof self && ($9052383c1c4e5569$var$e.self = $9052383c1c4e5569$var$e), "undefined" == typeof File && ($9052383c1c4e5569$var$e.File = function() {});
var $9052383c1c4e5569$var$i = null == $9052383c1c4e5569$var$e ? void 0 : $9052383c1c4e5569$var$e.navigator, $9052383c1c4e5569$var$r = null == $9052383c1c4e5569$var$e ? void 0 : $9052383c1c4e5569$var$e.document, $9052383c1c4e5569$var$s = null == $9052383c1c4e5569$var$e ? void 0 : $9052383c1c4e5569$var$e.location, $9052383c1c4e5569$var$n = null == $9052383c1c4e5569$var$e ? void 0 : $9052383c1c4e5569$var$e.fetch, $9052383c1c4e5569$var$o = null != $9052383c1c4e5569$var$e && $9052383c1c4e5569$var$e.XMLHttpRequest && "withCredentials" in new $9052383c1c4e5569$var$e.XMLHttpRequest ? $9052383c1c4e5569$var$e.XMLHttpRequest : void 0, $9052383c1c4e5569$var$a = null == $9052383c1c4e5569$var$e ? void 0 : $9052383c1c4e5569$var$e.AbortController, $9052383c1c4e5569$var$l = null == $9052383c1c4e5569$var$e ? void 0 : $9052383c1c4e5569$var$e.CompressionStream, $9052383c1c4e5569$var$u = null == $9052383c1c4e5569$var$i ? void 0 : $9052383c1c4e5569$var$i.userAgent, $9052383c1c4e5569$var$h = null != $9052383c1c4e5569$var$t ? $9052383c1c4e5569$var$t : {}, $9052383c1c4e5569$var$d = "1.386.8", $9052383c1c4e5569$var$v = {
    DEBUG: !1,
    LIB_VERSION: $9052383c1c4e5569$var$d,
    LIB_NAME: "web",
    JS_SDK_VERSION: $9052383c1c4e5569$var$d
};
function $9052383c1c4e5569$var$c(t, e, i, r, s, n, o) {
    try {
        var a = t[n](o), l = a.value;
    } catch (t) {
        return void i(t);
    }
    a.done ? e(l) : Promise.resolve(l).then(r, s);
}
function $9052383c1c4e5569$var$p(t) {
    return function() {
        var e = this, i = arguments;
        return new Promise(function(r, s) {
            var n = t.apply(e, i);
            function o(t) {
                $9052383c1c4e5569$var$c(n, r, s, o, a, "next", t);
            }
            function a(t) {
                $9052383c1c4e5569$var$c(n, r, s, o, a, "throw", t);
            }
            o(void 0);
        });
    };
}
function $9052383c1c4e5569$var$f() {
    return $9052383c1c4e5569$var$f = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; arguments.length > e; e++){
            var i = arguments[e];
            for(var r in i)({}).hasOwnProperty.call(i, r) && (t[r] = i[r]);
        }
        return t;
    }, $9052383c1c4e5569$var$f.apply(null, arguments);
}
function $9052383c1c4e5569$var$_(t, e) {
    if (null == t) return {};
    var i = {};
    for(var r in t)if (({}).hasOwnProperty.call(t, r)) {
        if (-1 !== e.indexOf(r)) continue;
        i[r] = t[r];
    }
    return i;
}
var $9052383c1c4e5569$var$g, $9052383c1c4e5569$var$m = function(t) {
    return t.GZipJS = "gzip-js", t.Base64 = "base64", t;
}({}), $9052383c1c4e5569$var$b = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
], $9052383c1c4e5569$var$y = "NativeGzipValidationError", $9052383c1c4e5569$var$w = (t)=>t.length >= 2 && 31 === t[0] && 139 === t[1], $9052383c1c4e5569$var$x = (t)=>!(!t || "object" != typeof t) && "NotReadableError" === ("name" in t ? String(t.name) : ""), $9052383c1c4e5569$var$E = (t)=>{
    var e = new Error("Native gzip produced invalid output: " + t);
    throw e.name = $9052383c1c4e5569$var$y, e;
}, $9052383c1c4e5569$var$S = function() {
    var t = $9052383c1c4e5569$var$p(function*(t, e) {
        18 > t.size && $9052383c1c4e5569$var$E("too-short");
        var i = new Uint8Array((yield t.slice(0, 10).arrayBuffer()));
        $9052383c1c4e5569$var$w(i) && 8 === i[2] || $9052383c1c4e5569$var$E("invalid-header");
        var r = new DataView((yield t.slice(t.size - 8).arrayBuffer()));
        r.getUint32(0, !0) !== ((t)=>{
            for(var e = (()=>{
                if ($9052383c1c4e5569$var$g) return $9052383c1c4e5569$var$g;
                $9052383c1c4e5569$var$g = [];
                for(var t = 0; 256 > t; t++){
                    for(var e = t, i = 0; 8 > i; i++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                    $9052383c1c4e5569$var$g[t] = e >>> 0;
                }
                return $9052383c1c4e5569$var$g;
            })(), i = 4294967295, r = 0; t.length > r; r++)i = e[255 & (i ^ t[r])] ^ i >>> 8;
            return (4294967295 ^ i) >>> 0;
        })(e) && $9052383c1c4e5569$var$E("invalid-crc");
        var s = e.length >>> 0;
        r.getUint32(4, !0) !== s && $9052383c1c4e5569$var$E("invalid-size");
    });
    return function(e, i) {
        return t.apply(this, arguments);
    };
}();
function $9052383c1c4e5569$var$T() {
    return $9052383c1c4e5569$var$T = $9052383c1c4e5569$var$p(function*(t, e, i) {
        void 0 === e && (e = !0);
        try {
            var r = (new TextEncoder).encode(t), s = new CompressionStream("gzip"), n = s.writable.getWriter(), o = n.write(r).then(()=>n.close()).catch(function() {
                var t = $9052383c1c4e5569$var$p(function*(t) {
                    try {
                        yield n.abort(t);
                    } catch (t) {}
                    throw t;
                });
                return function(e) {
                    return t.apply(this, arguments);
                };
            }()), a = new Response(s.readable).blob(), [l] = yield Promise.all([
                a,
                o
            ]);
            return yield $9052383c1c4e5569$var$S(l, r), l;
        } catch (t) {
            if (null != i && i.rethrow) throw t;
            return e && console.error("Failed to gzip compress data", t), null;
        }
    }), $9052383c1c4e5569$var$T.apply(this, arguments);
}
var $9052383c1c4e5569$var$k = [
    "amazonbot",
    "amazonproductbot",
    "app.hypefactors.com",
    "applebot",
    "archive.org_bot",
    "awariobot",
    "backlinksextendedbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "dataforseobot",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "leikibot",
    "linkedinbot",
    "meta-externalagent",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "sebot-wa",
    "sitebulb",
    "slackbot",
    "slurp",
    "trendictionbot",
    "turnitin",
    "twitterbot",
    "vercel-screenshot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "zoombot",
    "bot.htm",
    "bot.php",
    "(bot;",
    "bot/",
    "crawler",
    "ahrefsbot",
    "ahrefssiteaudit",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "gptbot",
    "oai-searchbot",
    "chatgpt-user",
    "perplexitybot",
    "better uptime bot",
    "sentryuptimebot",
    "uptimerobot",
    "headlesschrome",
    "cypress",
    "google-hoteladsverifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleother",
    "google-cloudvertexbot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "google-inspectiontool",
    "bytespider"
], $9052383c1c4e5569$var$R = function(t, e) {
    if (void 0 === e && (e = []), !t) return !1;
    var i = t.toLowerCase();
    return $9052383c1c4e5569$var$k.concat(e).some((t)=>{
        var e = t.toLowerCase();
        return -1 !== i.indexOf(e);
    });
};
function $9052383c1c4e5569$var$P(t, e) {
    return -1 !== t.indexOf(e);
}
var $9052383c1c4e5569$var$O = function(t) {
    return t.trim();
}, $9052383c1c4e5569$var$I = function(t) {
    return t.replace(/^\$/, "");
}, $9052383c1c4e5569$var$C = Object.prototype, $9052383c1c4e5569$var$A = $9052383c1c4e5569$var$C.hasOwnProperty, $9052383c1c4e5569$var$F = $9052383c1c4e5569$var$C.toString, $9052383c1c4e5569$var$M = Array.isArray || function(t) {
    return "[object Array]" === $9052383c1c4e5569$var$F.call(t);
}, $9052383c1c4e5569$var$D = (t)=>"function" == typeof t, $9052383c1c4e5569$var$N = (t)=>t === Object(t) && !$9052383c1c4e5569$var$M(t), $9052383c1c4e5569$var$L = (t)=>{
    if ($9052383c1c4e5569$var$N(t)) {
        for(var e in t)if ($9052383c1c4e5569$var$A.call(t, e)) return !1;
        return !0;
    }
    return !1;
}, $9052383c1c4e5569$var$U = (t)=>void 0 === t, $9052383c1c4e5569$var$j = (t)=>"[object String]" == $9052383c1c4e5569$var$F.call(t), $9052383c1c4e5569$var$z = (t)=>$9052383c1c4e5569$var$j(t) && 0 === t.trim().length, $9052383c1c4e5569$var$B = (t)=>null === t, $9052383c1c4e5569$var$H = (t)=>$9052383c1c4e5569$var$U(t) || $9052383c1c4e5569$var$B(t), $9052383c1c4e5569$var$V = (t)=>"[object Number]" == $9052383c1c4e5569$var$F.call(t) && t == t, $9052383c1c4e5569$var$q = (t)=>$9052383c1c4e5569$var$V(t) && t > 0, $9052383c1c4e5569$var$G = (t)=>"[object Boolean]" === $9052383c1c4e5569$var$F.call(t), $9052383c1c4e5569$var$W = (t)=>t instanceof FormData, $9052383c1c4e5569$var$Y = (t)=>$9052383c1c4e5569$var$P($9052383c1c4e5569$var$b, t);
function $9052383c1c4e5569$var$J(t) {
    return null === t || "object" != typeof t;
}
function $9052383c1c4e5569$var$K(t, e) {
    return ({}).toString.call(t) === "[object " + e + "]";
}
function $9052383c1c4e5569$var$X(t) {
    return "undefined" != typeof Event && function(t, e) {
        try {
            return t instanceof e;
        } catch (t) {
            return !1;
        }
    }(t, Event);
}
var $9052383c1c4e5569$var$Q = [
    !0,
    "true",
    1,
    "1",
    "yes"
], $9052383c1c4e5569$var$Z = (t)=>$9052383c1c4e5569$var$P($9052383c1c4e5569$var$Q, t), $9052383c1c4e5569$var$tt = [
    !1,
    "false",
    0,
    "0",
    "no"
];
function $9052383c1c4e5569$var$et(t, e, i, r, s) {
    return e > i && (r.warn("min cannot be greater than max."), e = i), $9052383c1c4e5569$var$V(t) ? t > i ? (r.warn(" cannot be  greater than max: " + i + ". Using max value instead."), i) : e > t ? (r.warn(" cannot be less than min: " + e + ". Using min value instead."), e) : t : (r.warn(" must be a number. using max or fallback. max: " + i + ", fallback: " + s), $9052383c1c4e5569$var$et(s || i, e, i, r));
}
class $9052383c1c4e5569$var$it {
    constructor(t){
        this.$t = {}, this.zt = t.zt, this.Gt = $9052383c1c4e5569$var$et(t.bucketSize, 0, 100, t.Zt), this.Qt = $9052383c1c4e5569$var$et(t.refillRate, 0, this.Gt, t.Zt), this.Jt = $9052383c1c4e5569$var$et(t.refillInterval, 0, 864e5, t.Zt);
    }
    Kt(t, e) {
        var i = Math.floor((e - t.lastAccess) / this.Jt);
        i > 0 && (t.tokens = Math.min(t.tokens + i * this.Qt, this.Gt), t.lastAccess = t.lastAccess + i * this.Jt);
    }
    consumeRateLimit(t) {
        var e, i = Date.now(), r = String(t), s = this.$t[r];
        return s ? this.Kt(s, i) : this.$t[r] = s = {
            tokens: this.Gt,
            lastAccess: i
        }, 0 === s.tokens || (s.tokens--, 0 === s.tokens && (null == (e = this.zt) || e.call(this, t)), 0 === s.tokens);
    }
    stop() {
        this.$t = {};
    }
}
var $9052383c1c4e5569$var$rt, $9052383c1c4e5569$var$st, $9052383c1c4e5569$var$nt, $9052383c1c4e5569$var$ot = "Mobile", $9052383c1c4e5569$var$at = "iOS", $9052383c1c4e5569$var$lt = "Android", $9052383c1c4e5569$var$ut = "Tablet", $9052383c1c4e5569$var$ht = $9052383c1c4e5569$var$lt + " " + $9052383c1c4e5569$var$ut, $9052383c1c4e5569$var$dt = "iPad", $9052383c1c4e5569$var$vt = "Apple", $9052383c1c4e5569$var$ct = $9052383c1c4e5569$var$vt + " Watch", $9052383c1c4e5569$var$pt = "Safari", $9052383c1c4e5569$var$ft = "BlackBerry", $9052383c1c4e5569$var$_t = "Samsung", $9052383c1c4e5569$var$gt = $9052383c1c4e5569$var$_t + "Browser", $9052383c1c4e5569$var$mt = $9052383c1c4e5569$var$_t + " Internet", $9052383c1c4e5569$var$bt = "Chrome", $9052383c1c4e5569$var$yt = $9052383c1c4e5569$var$bt + " OS", $9052383c1c4e5569$var$wt = $9052383c1c4e5569$var$bt + " " + $9052383c1c4e5569$var$at, $9052383c1c4e5569$var$xt = "Internet Explorer", $9052383c1c4e5569$var$Et = $9052383c1c4e5569$var$xt + " " + $9052383c1c4e5569$var$ot, $9052383c1c4e5569$var$St = "Opera", $9052383c1c4e5569$var$$t = $9052383c1c4e5569$var$St + " Mini", $9052383c1c4e5569$var$Tt = "Edge", $9052383c1c4e5569$var$kt = "Microsoft " + $9052383c1c4e5569$var$Tt, $9052383c1c4e5569$var$Rt = "Firefox", $9052383c1c4e5569$var$Pt = $9052383c1c4e5569$var$Rt + " " + $9052383c1c4e5569$var$at, $9052383c1c4e5569$var$Ot = "Nintendo", $9052383c1c4e5569$var$It = "PlayStation", $9052383c1c4e5569$var$Ct = "Xbox", $9052383c1c4e5569$var$At = $9052383c1c4e5569$var$lt + " " + $9052383c1c4e5569$var$ot, $9052383c1c4e5569$var$Ft = $9052383c1c4e5569$var$ot + " " + $9052383c1c4e5569$var$pt, $9052383c1c4e5569$var$Mt = "Windows", $9052383c1c4e5569$var$Dt = $9052383c1c4e5569$var$Mt + " Phone", $9052383c1c4e5569$var$Nt = "Nokia", $9052383c1c4e5569$var$Lt = "Ouya", $9052383c1c4e5569$var$Ut = "Generic", $9052383c1c4e5569$var$jt = $9052383c1c4e5569$var$Ut + " " + $9052383c1c4e5569$var$ot.toLowerCase(), $9052383c1c4e5569$var$zt = $9052383c1c4e5569$var$Ut + " " + $9052383c1c4e5569$var$ut.toLowerCase(), $9052383c1c4e5569$var$Bt = "Konqueror", $9052383c1c4e5569$var$Ht = "Oculus Browser", $9052383c1c4e5569$var$Vt = "Vivaldi", $9052383c1c4e5569$var$qt = "Yandex", $9052383c1c4e5569$var$Gt = "Whale", $9052383c1c4e5569$var$Wt = "DuckDuckGo", $9052383c1c4e5569$var$Yt = "Pale Moon", $9052383c1c4e5569$var$Jt = "Waterfox", $9052383c1c4e5569$var$Kt = "Brave", $9052383c1c4e5569$var$Xt = "Google Search App", $9052383c1c4e5569$var$Qt = "(\\d+(\\.\\d+)?)", $9052383c1c4e5569$var$Zt = new RegExp("Version/" + $9052383c1c4e5569$var$Qt), $9052383c1c4e5569$var$te = new RegExp($9052383c1c4e5569$var$Ct, "i"), $9052383c1c4e5569$var$ee = new RegExp($9052383c1c4e5569$var$It + " \\w+", "i"), $9052383c1c4e5569$var$ie = new RegExp($9052383c1c4e5569$var$Ot + " \\w+", "i"), $9052383c1c4e5569$var$re = new RegExp($9052383c1c4e5569$var$ft + "|PlayBook|BB10", "i"), $9052383c1c4e5569$var$se = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
}, $9052383c1c4e5569$var$ne = function(t, e, i, r) {
    e = e || "";
    var s = function(t) {
        return null != t && t.brave ? $9052383c1c4e5569$var$Kt : null;
    }(i);
    return s || (null != r && r.detectGoogleSearchApp && $9052383c1c4e5569$var$P(t, "GSA/") ? $9052383c1c4e5569$var$Xt : $9052383c1c4e5569$var$P(t, " OPR/") && $9052383c1c4e5569$var$P(t, "Mini") ? $9052383c1c4e5569$var$$t : $9052383c1c4e5569$var$P(t, " OPR/") ? $9052383c1c4e5569$var$St : $9052383c1c4e5569$var$re.test(t) ? $9052383c1c4e5569$var$ft : $9052383c1c4e5569$var$P(t, "IE" + $9052383c1c4e5569$var$ot) || $9052383c1c4e5569$var$P(t, "WPDesktop") ? $9052383c1c4e5569$var$Et : $9052383c1c4e5569$var$P(t, "OculusBrowser") ? $9052383c1c4e5569$var$Ht : $9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$gt) ? $9052383c1c4e5569$var$mt : $9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$Tt) || $9052383c1c4e5569$var$P(t, "Edg/") ? $9052383c1c4e5569$var$kt : $9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$Vt + "/") ? $9052383c1c4e5569$var$Vt : $9052383c1c4e5569$var$P(t, "YaBrowser/") ? $9052383c1c4e5569$var$qt : $9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$Gt + "/") ? $9052383c1c4e5569$var$Gt : $9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$Wt + "/") || $9052383c1c4e5569$var$P(t, "Ddg/") ? $9052383c1c4e5569$var$Wt : $9052383c1c4e5569$var$P(t, "FBIOS") ? "Facebook " + $9052383c1c4e5569$var$ot : $9052383c1c4e5569$var$P(t, "UCWEB") || $9052383c1c4e5569$var$P(t, "UCBrowser") ? "UC Browser" : $9052383c1c4e5569$var$P(t, "CriOS") ? $9052383c1c4e5569$var$wt : $9052383c1c4e5569$var$P(t, "CrMo") || $9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$bt) ? $9052383c1c4e5569$var$bt : $9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$lt) && $9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$pt) ? $9052383c1c4e5569$var$At : $9052383c1c4e5569$var$P(t, "FxiOS") ? $9052383c1c4e5569$var$Pt : $9052383c1c4e5569$var$P(t.toLowerCase(), $9052383c1c4e5569$var$Bt.toLowerCase()) ? $9052383c1c4e5569$var$Bt : $9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$Kt + "/") ? $9052383c1c4e5569$var$Kt : ((t, e)=>e && $9052383c1c4e5569$var$P(e, $9052383c1c4e5569$var$vt) || function(t) {
            return $9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$pt) && !$9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$bt) && !$9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$lt);
        }(t))(t, e) ? $9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$ot) ? $9052383c1c4e5569$var$Ft : $9052383c1c4e5569$var$pt : $9052383c1c4e5569$var$P(t, "PaleMoon/") ? $9052383c1c4e5569$var$Yt : $9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$Jt + "/") ? $9052383c1c4e5569$var$Jt : $9052383c1c4e5569$var$P(t, $9052383c1c4e5569$var$Rt) ? $9052383c1c4e5569$var$Rt : $9052383c1c4e5569$var$P(t, "MSIE") || $9052383c1c4e5569$var$P(t, "Trident/") ? $9052383c1c4e5569$var$xt : $9052383c1c4e5569$var$P(t, "Gecko") ? $9052383c1c4e5569$var$Rt : "");
}, $9052383c1c4e5569$var$oe = {
    [$9052383c1c4e5569$var$Et]: [
        new RegExp("rv:" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$kt]: [
        new RegExp($9052383c1c4e5569$var$Tt + "?\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$bt]: [
        new RegExp("(" + $9052383c1c4e5569$var$bt + "|CrMo)\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$wt]: [
        new RegExp("CriOS\\/" + $9052383c1c4e5569$var$Qt)
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$pt]: [
        $9052383c1c4e5569$var$Zt
    ],
    [$9052383c1c4e5569$var$Ft]: [
        $9052383c1c4e5569$var$Zt
    ],
    [$9052383c1c4e5569$var$St]: [
        new RegExp("(Opera|OPR)\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$Rt]: [
        new RegExp($9052383c1c4e5569$var$Rt + "\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$Pt]: [
        new RegExp("FxiOS\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$Bt]: [
        new RegExp("Konqueror[:/]?" + $9052383c1c4e5569$var$Qt, "i")
    ],
    [$9052383c1c4e5569$var$ft]: [
        new RegExp($9052383c1c4e5569$var$ft + " " + $9052383c1c4e5569$var$Qt),
        $9052383c1c4e5569$var$Zt
    ],
    [$9052383c1c4e5569$var$At]: [
        new RegExp("android\\s" + $9052383c1c4e5569$var$Qt, "i")
    ],
    [$9052383c1c4e5569$var$mt]: [
        new RegExp($9052383c1c4e5569$var$gt + "\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$Ht]: [
        new RegExp("OculusBrowser\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$Vt]: [
        new RegExp($9052383c1c4e5569$var$Vt + "\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$qt]: [
        new RegExp("YaBrowser\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$Gt]: [
        new RegExp($9052383c1c4e5569$var$Gt + "\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$Kt]: [
        new RegExp($9052383c1c4e5569$var$Kt + "\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$Wt]: [
        new RegExp("(DuckDuckGo|Ddg)\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$Yt]: [
        new RegExp("PaleMoon\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$Jt]: [
        new RegExp($9052383c1c4e5569$var$Jt + "\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$Xt]: [
        new RegExp("GSA\\/" + $9052383c1c4e5569$var$Qt)
    ],
    [$9052383c1c4e5569$var$xt]: [
        new RegExp("(rv:|MSIE )" + $9052383c1c4e5569$var$Qt)
    ],
    Mozilla: [
        new RegExp("rv:" + $9052383c1c4e5569$var$Qt)
    ]
}, $9052383c1c4e5569$var$ae = function(t, e, i, r) {
    var s = $9052383c1c4e5569$var$ne(t, e, i, r), n = $9052383c1c4e5569$var$oe[s];
    if ($9052383c1c4e5569$var$U(n)) return null;
    for(var o = 0; n.length > o; o++){
        var a = t.match(n[o]);
        if (a) return parseFloat(a[a.length - 2]);
    }
    return null;
}, $9052383c1c4e5569$var$le = [
    [
        new RegExp($9052383c1c4e5569$var$Ct + "; " + $9052383c1c4e5569$var$Ct + " (.*?)[);]", "i"),
        (t)=>[
                $9052383c1c4e5569$var$Ct,
                t && t[1] || ""
            ]
    ],
    [
        new RegExp($9052383c1c4e5569$var$Ot, "i"),
        [
            $9052383c1c4e5569$var$Ot,
            ""
        ]
    ],
    [
        new RegExp($9052383c1c4e5569$var$It, "i"),
        [
            $9052383c1c4e5569$var$It,
            ""
        ]
    ],
    [
        $9052383c1c4e5569$var$re,
        [
            $9052383c1c4e5569$var$ft,
            ""
        ]
    ],
    [
        new RegExp($9052383c1c4e5569$var$Mt, "i"),
        (t, e)=>{
            if (/Phone/.test(e) || /WPDesktop/.test(e)) return [
                $9052383c1c4e5569$var$Dt,
                ""
            ];
            if (new RegExp($9052383c1c4e5569$var$ot).test(e) && !/IEMobile\b/.test(e)) return [
                $9052383c1c4e5569$var$Mt + " " + $9052383c1c4e5569$var$ot,
                ""
            ];
            var i = /Windows NT ([0-9.]+)/i.exec(e);
            if (i && i[1]) {
                var r = $9052383c1c4e5569$var$se[i[1]] || "";
                return /arm/i.test(e) && (r = "RT"), [
                    $9052383c1c4e5569$var$Mt,
                    r
                ];
            }
            return [
                $9052383c1c4e5569$var$Mt,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (t)=>t && t[3] ? [
                $9052383c1c4e5569$var$at,
                [
                    t[3],
                    t[4],
                    t[5] || "0"
                ].join(".")
            ] : [
                $9052383c1c4e5569$var$at,
                ""
            ]
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (t)=>{
            var e = "";
            return t && t.length >= 3 && (e = $9052383c1c4e5569$var$U(t[2]) ? t[3] : t[2]), [
                "watchOS",
                e
            ];
        }
    ],
    [
        new RegExp("(" + $9052383c1c4e5569$var$lt + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $9052383c1c4e5569$var$lt + ")", "i"),
        (t)=>t && t[2] ? [
                $9052383c1c4e5569$var$lt,
                [
                    t[2],
                    t[3],
                    t[4] || "0"
                ].join(".")
            ] : [
                $9052383c1c4e5569$var$lt,
                ""
            ]
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (t)=>{
            var e = [
                "Mac OS X",
                ""
            ];
            return t && t[1] && (e[1] = [
                t[1],
                t[2],
                t[3] || "0"
            ].join(".")), e;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $9052383c1c4e5569$var$yt,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $9052383c1c4e5569$var$ue = function(t) {
    return $9052383c1c4e5569$var$ie.test(t) ? $9052383c1c4e5569$var$Ot : $9052383c1c4e5569$var$ee.test(t) ? $9052383c1c4e5569$var$It : $9052383c1c4e5569$var$te.test(t) ? $9052383c1c4e5569$var$Ct : new RegExp($9052383c1c4e5569$var$Lt, "i").test(t) ? $9052383c1c4e5569$var$Lt : new RegExp("(" + $9052383c1c4e5569$var$Dt + "|WPDesktop)", "i").test(t) ? $9052383c1c4e5569$var$Dt : /iPad/.test(t) ? $9052383c1c4e5569$var$dt : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? $9052383c1c4e5569$var$ct : $9052383c1c4e5569$var$re.test(t) ? $9052383c1c4e5569$var$ft : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp($9052383c1c4e5569$var$Nt, "i").test(t) ? $9052383c1c4e5569$var$Nt : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? new RegExp($9052383c1c4e5569$var$ot).test(t) && !/(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) || /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? $9052383c1c4e5569$var$lt : $9052383c1c4e5569$var$ht : new RegExp("(pda|" + $9052383c1c4e5569$var$ot + ")", "i").test(t) ? $9052383c1c4e5569$var$jt : new RegExp($9052383c1c4e5569$var$ut, "i").test(t) && !new RegExp($9052383c1c4e5569$var$ut + " pc", "i").test(t) ? $9052383c1c4e5569$var$zt : "";
}, $9052383c1c4e5569$var$he = (t)=>t instanceof Error, $9052383c1c4e5569$var$de = {
    trace: {
        text: "TRACE",
        number: 1
    },
    debug: {
        text: "DEBUG",
        number: 5
    },
    info: {
        text: "INFO",
        number: 9
    },
    warn: {
        text: "WARN",
        number: 13
    },
    error: {
        text: "ERROR",
        number: 17
    },
    fatal: {
        text: "FATAL",
        number: 21
    }
}, $9052383c1c4e5569$var$ve = $9052383c1c4e5569$var$de.info;
function $9052383c1c4e5569$var$ce(t) {
    if ($9052383c1c4e5569$var$G(t)) return {
        boolValue: t
    };
    if ("number" == typeof t) return Number.isFinite(t) ? Number.isInteger(t) ? {
        intValue: t
    } : {
        doubleValue: t
    } : {
        stringValue: String(t)
    };
    if ("string" == typeof t) return {
        stringValue: t
    };
    if ($9052383c1c4e5569$var$M(t)) return {
        arrayValue: {
            values: t.map((t)=>$9052383c1c4e5569$var$ce(t))
        }
    };
    try {
        return {
            stringValue: JSON.stringify(t)
        };
    } catch (e) {
        return {
            stringValue: String(t)
        };
    }
}
function $9052383c1c4e5569$var$pe(t) {
    var e = [];
    for(var i in t){
        var r = t[i];
        $9052383c1c4e5569$var$B(r) || $9052383c1c4e5569$var$U(r) || e.push({
            key: i,
            value: $9052383c1c4e5569$var$ce(r)
        });
    }
    return e;
}
function $9052383c1c4e5569$var$fe(t) {
    var e = globalThis._posthogChunkIds;
    if (e) {
        var i = Object.keys(e);
        return $9052383c1c4e5569$var$nt && i.length === $9052383c1c4e5569$var$st || ($9052383c1c4e5569$var$st = i.length, $9052383c1c4e5569$var$nt = i.reduce((i, r)=>{
            $9052383c1c4e5569$var$rt || ($9052383c1c4e5569$var$rt = {});
            var s = $9052383c1c4e5569$var$rt[r];
            if (s) i[s[0]] = s[1];
            else for(var n = t(r), o = n.length - 1; o >= 0; o--){
                var a = n[o], l = null == a ? void 0 : a.filename, u = e[r];
                if (l && u) {
                    i[l] = u, $9052383c1c4e5569$var$rt[r] = [
                        l,
                        u
                    ];
                    break;
                }
            }
            return i;
        }, {})), $9052383c1c4e5569$var$nt;
    }
}
class $9052383c1c4e5569$var$_e {
    constructor(t, e, i){
        void 0 === i && (i = []), this.coercers = t, this.stackParser = e, this.modifiers = i;
    }
    buildFromUnknown(t, e) {
        void 0 === e && (e = {});
        var i = e && e.mechanism || {
            handled: !0,
            type: "generic"
        }, r = this.buildCoercingContext(i, e, 0).apply(t), s = this.buildParsingContext(e), n = this.parseStacktrace(r, s);
        return {
            $exception_list: this.convertToExceptionList(n, i),
            $exception_level: "error"
        };
    }
    modifyFrames(t) {
        var e = this;
        return $9052383c1c4e5569$var$p(function*() {
            for (var i of t)i.stacktrace && i.stacktrace.frames && $9052383c1c4e5569$var$M(i.stacktrace.frames) && (i.stacktrace.frames = yield e.applyModifiers(i.stacktrace.frames));
            return t;
        })();
    }
    coerceFallback(t) {
        var e;
        return {
            type: "Error",
            value: "Unknown error",
            stack: null == (e = t.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
    parseStacktrace(t, e) {
        var i, r;
        return null != t.cause && (i = this.parseStacktrace(t.cause, e)), "" != t.stack && null != t.stack && (r = this.applyChunkIds(this.stackParser(t.stack, t.synthetic ? e.skipFirstLines : 0), e.chunkIdMap)), $9052383c1c4e5569$var$f({}, t, {
            cause: i,
            stack: r
        });
    }
    applyChunkIds(t, e) {
        return t.map((t)=>(t.filename && e && (t.chunk_id = e[t.filename]), t));
    }
    applyCoercers(t, e) {
        for (var i of this.coercers)if (i.match(t)) return i.coerce(t, e);
        return this.coerceFallback(e);
    }
    applyModifiers(t) {
        var e = this;
        return $9052383c1c4e5569$var$p(function*() {
            var i = t;
            for (var r of e.modifiers)i = yield r(i);
            return i;
        })();
    }
    convertToExceptionList(t, e) {
        var i, r, s, n = {
            type: t.type,
            value: t.value,
            mechanism: {
                type: null !== (i = e.type) && void 0 !== i ? i : "generic",
                handled: null === (r = e.handled) || void 0 === r || r,
                synthetic: null !== (s = t.synthetic) && void 0 !== s && s
            }
        };
        t.stack && (n.stacktrace = {
            type: "raw",
            frames: t.stack
        });
        var o = [
            n
        ];
        return null != t.cause && o.push(...this.convertToExceptionList(t.cause, $9052383c1c4e5569$var$f({}, e, {
            handled: !0
        }))), o;
    }
    buildParsingContext(t) {
        var e;
        return {
            chunkIdMap: $9052383c1c4e5569$var$fe(this.stackParser),
            skipFirstLines: null !== (e = t.skipFirstLines) && void 0 !== e ? e : 1
        };
    }
    buildCoercingContext(t, e, i) {
        void 0 === i && (i = 0);
        var r = (i, r)=>{
            if (4 >= r) {
                var s = this.buildCoercingContext(t, e, r);
                return this.applyCoercers(i, s);
            }
        };
        return $9052383c1c4e5569$var$f({}, e, {
            syntheticException: 0 == i ? e.syntheticException : void 0,
            mechanism: t,
            apply: (t)=>r(t, i),
            next: (t)=>r(t, i + 1)
        });
    }
}
var $9052383c1c4e5569$var$ge = "?";
function $9052383c1c4e5569$var$me(t, e, i, r, s) {
    var n = {
        platform: t,
        filename: e,
        function: "<anonymous>" === i ? $9052383c1c4e5569$var$ge : i,
        in_app: !0
    };
    return $9052383c1c4e5569$var$U(r) || (n.lineno = r), $9052383c1c4e5569$var$U(s) || (n.colno = s), n;
}
var $9052383c1c4e5569$var$be = (t, e)=>{
    var i = -1 !== t.indexOf("safari-extension"), r = -1 !== t.indexOf("safari-web-extension");
    return i || r ? [
        -1 !== t.indexOf("@") ? t.split("@")[0] : $9052383c1c4e5569$var$ge,
        i ? "safari-extension:" + e : "safari-web-extension:" + e
    ] : [
        t,
        e
    ];
}, $9052383c1c4e5569$var$ye = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, $9052383c1c4e5569$var$we = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $9052383c1c4e5569$var$xe = /\((\S*)(?::(\d+))(?::(\d+))\)/, $9052383c1c4e5569$var$Ee = (t, e)=>{
    var i = $9052383c1c4e5569$var$ye.exec(t);
    if (i) {
        var [, r, s, n] = i;
        return $9052383c1c4e5569$var$me(e, r, $9052383c1c4e5569$var$ge, +s, +n);
    }
    var o = $9052383c1c4e5569$var$we.exec(t);
    if (o) {
        if (o[2] && 0 === o[2].indexOf("eval")) {
            var a = $9052383c1c4e5569$var$xe.exec(o[2]);
            a && (o[2] = a[1], o[3] = a[2], o[4] = a[3]);
        }
        var [l, u] = $9052383c1c4e5569$var$be(o[1] || $9052383c1c4e5569$var$ge, o[2]);
        return $9052383c1c4e5569$var$me(e, u, l, o[3] ? +o[3] : void 0, o[4] ? +o[4] : void 0);
    }
}, $9052383c1c4e5569$var$Se = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, $9052383c1c4e5569$var$$e = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, $9052383c1c4e5569$var$Te = (t, e)=>{
    var i = $9052383c1c4e5569$var$Se.exec(t);
    if (i) {
        if (i[3] && i[3].indexOf(" > eval") > -1) {
            var r = $9052383c1c4e5569$var$$e.exec(i[3]);
            r && (i[1] = i[1] || "eval", i[3] = r[1], i[4] = r[2], i[5] = "");
        }
        var s = i[3], n = i[1] || $9052383c1c4e5569$var$ge;
        return [n, s] = $9052383c1c4e5569$var$be(n, s), $9052383c1c4e5569$var$me(e, s, n, i[4] ? +i[4] : void 0, i[5] ? +i[5] : void 0);
    }
}, $9052383c1c4e5569$var$ke = /\(error: (.*)\)/;
class $9052383c1c4e5569$var$Re {
    match(t) {
        return this.isDOMException(t) || this.isDOMError(t);
    }
    coerce(t, e) {
        var i = $9052383c1c4e5569$var$j(t.stack);
        return {
            type: this.getType(t),
            value: this.getValue(t),
            stack: i ? t.stack : void 0,
            cause: t.cause ? e.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return this.isDOMError(t) ? "DOMError" : "DOMException";
    }
    getValue(t) {
        var e = t.name || (this.isDOMError(t) ? "DOMError" : "DOMException");
        return t.message ? e + ": " + t.message : e;
    }
    isDOMException(t) {
        return $9052383c1c4e5569$var$K(t, "DOMException");
    }
    isDOMError(t) {
        return $9052383c1c4e5569$var$K(t, "DOMError");
    }
}
class $9052383c1c4e5569$var$Pe {
    match(t) {
        return ((t)=>t instanceof Error)(t);
    }
    coerce(t, e) {
        return {
            type: this.getType(t),
            value: this.getMessage(t, e),
            stack: this.getStack(t),
            cause: t.cause ? e.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return t.name || t.constructor.name;
    }
    getMessage(t, e) {
        var i = t.message;
        return String(i.error && "string" == typeof i.error.message ? i.error.message : i);
    }
    getStack(t) {
        return t.stacktrace || t.stack || void 0;
    }
}
class $9052383c1c4e5569$var$Oe {
    constructor(){}
    match(t) {
        return $9052383c1c4e5569$var$K(t, "ErrorEvent") && null != t.error;
    }
    coerce(t, e) {
        var i;
        return e.apply(t.error) || {
            type: "ErrorEvent",
            value: t.message,
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
}
var $9052383c1c4e5569$var$Ie = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
class $9052383c1c4e5569$var$Ce {
    match(t) {
        return "string" == typeof t;
    }
    coerce(t, e) {
        var i, [r, s] = this.getInfos(t);
        return {
            type: null != r ? r : "Error",
            value: null != s ? s : t,
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
    getInfos(t) {
        var e = "Error", i = t, r = t.match($9052383c1c4e5569$var$Ie);
        return r && (e = r[1], i = r[2]), [
            e,
            i
        ];
    }
}
var $9052383c1c4e5569$var$Ae = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function $9052383c1c4e5569$var$Fe(t, e) {
    void 0 === e && (e = 40);
    var i = Object.keys(t);
    if (i.sort(), !i.length) return "[object has no keys]";
    for(var r = i.length; r > 0; r--){
        var s = i.slice(0, r).join(", ");
        if (e >= s.length) return r === i.length ? s : s.length > e ? s.slice(0, e) + "..." : s;
    }
    return "";
}
class $9052383c1c4e5569$var$Me {
    match(t) {
        return "object" == typeof t && null !== t;
    }
    coerce(t, e) {
        var i, r = this.getErrorPropertyFromObject(t);
        return r ? e.apply(r) : {
            type: this.getType(t),
            value: this.getValue(t),
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            level: this.isSeverityLevel(t.level) ? t.level : "error",
            synthetic: !0
        };
    }
    getType(t) {
        return $9052383c1c4e5569$var$X(t) ? t.constructor.name : "Error";
    }
    getValue(t) {
        if ("name" in t && "string" == typeof t.name) {
            var e = "'" + t.name + "' captured as exception";
            return "message" in t && "string" == typeof t.message && (e += " with message: '" + t.message + "'"), e;
        }
        if ("message" in t && "string" == typeof t.message) return t.message;
        var i = this.getObjectClassName(t);
        return (i && "Object" !== i ? "'" + i + "'" : "Object") + " captured as exception with keys: " + $9052383c1c4e5569$var$Fe(t);
    }
    isSeverityLevel(t) {
        return $9052383c1c4e5569$var$j(t) && !$9052383c1c4e5569$var$z(t) && $9052383c1c4e5569$var$Ae.indexOf(t) >= 0;
    }
    getErrorPropertyFromObject(t) {
        for(var e in t)if (({}).hasOwnProperty.call(t, e)) {
            var i = t[e];
            if ($9052383c1c4e5569$var$he(i)) return i;
        }
    }
    getObjectClassName(t) {
        try {
            var e = Object.getPrototypeOf(t);
            return e ? e.constructor.name : void 0;
        } catch (t) {
            return;
        }
    }
}
class $9052383c1c4e5569$var$De {
    match(t) {
        return $9052383c1c4e5569$var$X(t);
    }
    coerce(t, e) {
        var i, r = t.constructor.name;
        return {
            type: r,
            value: r + " captured as exception with keys: " + $9052383c1c4e5569$var$Fe(t),
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
}
class $9052383c1c4e5569$var$Ne {
    match(t) {
        return $9052383c1c4e5569$var$J(t);
    }
    coerce(t, e) {
        var i;
        return {
            type: "Error",
            value: "Primitive value captured as exception: " + String(t),
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
}
class $9052383c1c4e5569$var$Le {
    match(t) {
        return $9052383c1c4e5569$var$K(t, "PromiseRejectionEvent") || this.isCustomEventWrappingRejection(t);
    }
    isCustomEventWrappingRejection(t) {
        if (!$9052383c1c4e5569$var$X(t)) return !1;
        try {
            var e = t.detail;
            return null != e && "object" == typeof e && "reason" in e;
        } catch (t) {
            return !1;
        }
    }
    coerce(t, e) {
        var i, r = this.getUnhandledRejectionReason(t);
        return $9052383c1c4e5569$var$J(r) ? {
            type: "UnhandledRejection",
            value: "Non-Error promise rejection captured with value: " + String(r),
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        } : e.apply(r);
    }
    getUnhandledRejectionReason(t) {
        try {
            if ("reason" in t) return t.reason;
            if ("detail" in t && null != t.detail && "object" == typeof t.detail && "reason" in t.detail) return t.detail.reason;
        } catch (t) {}
        return t;
    }
}
var $9052383c1c4e5569$var$Ue = "$message", $9052383c1c4e5569$var$je = "$timestamp", $9052383c1c4e5569$var$ze = new Set([
    $9052383c1c4e5569$var$Ue,
    $9052383c1c4e5569$var$je
]), $9052383c1c4e5569$var$Be = {
    enabled: !0,
    max_bytes: 32768
};
function $9052383c1c4e5569$var$He(t) {
    var e;
    return t ? {
        enabled: null !== (e = t.enabled) && void 0 !== e ? e : $9052383c1c4e5569$var$Be.enabled,
        max_bytes: $9052383c1c4e5569$var$qe(t.max_bytes, $9052383c1c4e5569$var$Be.max_bytes)
    } : $9052383c1c4e5569$var$f({}, $9052383c1c4e5569$var$Be);
}
class $9052383c1c4e5569$var$Ve {
    constructor(t){
        this.Yt = [], this.Xt = 0, this.qt = $9052383c1c4e5569$var$He(t);
    }
    setConfig(t) {
        this.qt = $9052383c1c4e5569$var$He(t), this.er();
    }
    add(t) {
        var e = function(t) {
            var e = function(t) {
                var e = new WeakSet;
                try {
                    return JSON.stringify(t, (t, i)=>{
                        if ("bigint" == typeof i) return i.toString();
                        if ("function" != typeof i && "symbol" != typeof i) {
                            if (i instanceof Date) return i.toISOString();
                            if (i instanceof Error) return {
                                name: i.name,
                                message: i.message,
                                stack: i.stack
                            };
                            if (i && "object" == typeof i) {
                                if (e.has(i)) return "[Circular]";
                                e.add(i);
                            }
                            return i;
                        }
                    });
                } catch (t) {
                    return;
                }
            }(t);
            if (e) try {
                var i = JSON.parse(e);
                if (!$9052383c1c4e5569$var$N(i)) return;
                var r = i, s = r[$9052383c1c4e5569$var$Ue], n = r[$9052383c1c4e5569$var$je];
                if (!$9052383c1c4e5569$var$j(s) || 0 === s.trim().length) return;
                if (!$9052383c1c4e5569$var$j(n) && !$9052383c1c4e5569$var$V(n)) return;
                return {
                    step: r,
                    json: e
                };
            } catch (t) {
                return;
            }
        }(t);
        if (e) {
            var i = function(t) {
                if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t).length;
                for(var e = encodeURIComponent(t), i = 0, r = 0; e.length > r; r++)"%" === e[r] ? (i += 1, r += 2) : i += 1;
                return i;
            }(e.json);
            i > this.qt.max_bytes || (this.Yt.push({
                step: e.step,
                bytes: i
            }), this.Xt += i, this.er());
        }
    }
    getAttachable() {
        return this.Yt.map((t)=>t.step);
    }
    clear() {
        this.Yt = [], this.Xt = 0;
    }
    size() {
        return this.Yt.length;
    }
    er() {
        for(; this.Xt > this.qt.max_bytes && this.Yt.length > 0;){
            var t = this.Yt.shift();
            t && (this.Xt -= t.bytes);
        }
    }
}
function $9052383c1c4e5569$var$qe(t, e) {
    if (!$9052383c1c4e5569$var$V(t) || t === 1 / 0 || t === -1 / 0) return e;
    var i = Math.floor(t);
    return 0 > i ? e : i;
}
var $9052383c1c4e5569$var$Ge = function(e, i) {
    var { debugEnabled: r } = void 0 === i ? {} : i, s = {
        k (i) {
            if ($9052383c1c4e5569$var$t && ($9052383c1c4e5569$var$v.DEBUG || $9052383c1c4e5569$var$h.POSTHOG_DEBUG || r) && !$9052383c1c4e5569$var$U($9052383c1c4e5569$var$t.console) && $9052383c1c4e5569$var$t.console) {
                for(var s = ("__rrweb_original__" in $9052383c1c4e5569$var$t.console[i]) ? $9052383c1c4e5569$var$t.console[i].__rrweb_original__ : $9052383c1c4e5569$var$t.console[i], n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), a = 1; n > a; a++)o[a - 1] = arguments[a];
                s(e, ...o);
            }
        },
        debug () {
            for(var t = arguments.length, e = new Array(t), i = 0; t > i; i++)e[i] = arguments[i];
            s.k("debug", ...e);
        },
        info () {
            for(var t = arguments.length, e = new Array(t), i = 0; t > i; i++)e[i] = arguments[i];
            s.k("log", ...e);
        },
        warn () {
            for(var t = arguments.length, e = new Array(t), i = 0; t > i; i++)e[i] = arguments[i];
            s.k("warn", ...e);
        },
        error () {
            for(var t = arguments.length, e = new Array(t), i = 0; t > i; i++)e[i] = arguments[i];
            s.k("error", ...e);
        },
        critical () {
            for(var t = arguments.length, i = new Array(t), r = 0; t > r; r++)i[r] = arguments[r];
            console.error(e, ...i);
        },
        uninitializedWarning (t) {
            s.error("You must initialize PostHog before calling " + t);
        },
        createLogger: (t, i)=>$9052383c1c4e5569$var$Ge(e + " " + t, i)
    };
    return s;
}, $9052383c1c4e5569$var$We = $9052383c1c4e5569$var$Ge("[PostHog.js]"), $9052383c1c4e5569$var$Ye = $9052383c1c4e5569$var$We.createLogger, $9052383c1c4e5569$var$Je = $9052383c1c4e5569$var$Ye("[ExternalScriptsLoader]"), $9052383c1c4e5569$var$Ke = (t, e, i)=>{
    if (t.config.disable_external_dependency_loading) return $9052383c1c4e5569$var$Je.warn(e + " was requested but loading of external scripts is disabled."), i("Loading of external scripts is disabled");
    var s = null == $9052383c1c4e5569$var$r ? void 0 : $9052383c1c4e5569$var$r.querySelectorAll("script");
    if (s) {
        for(var n, o = function() {
            if (s[a].src === e) {
                var t = s[a];
                return t.__posthog_loading_callback_fired ? {
                    v: i()
                } : (t.addEventListener("load", (e)=>{
                    t.__posthog_loading_callback_fired = !0, i(void 0, e);
                }), t.onerror = (t)=>i(t), {
                    v: void 0
                });
            }
        }, a = 0; s.length > a; a++)if (n = o()) return n.v;
    }
    var l = ()=>{
        if (!$9052383c1c4e5569$var$r) return i("document not found");
        var s = $9052383c1c4e5569$var$r.createElement("script");
        if (s.type = "text/javascript", s.crossOrigin = "anonymous", s.src = e, s.onload = (t)=>{
            s.__posthog_loading_callback_fired = !0, i(void 0, t);
        }, s.onerror = (t)=>i(t), t.config.prepare_external_dependency_script && (s = t.config.prepare_external_dependency_script(s)), !s) return i("prepare_external_dependency_script returned null");
        if ("head" === t.config.external_scripts_inject_target) $9052383c1c4e5569$var$r.head.appendChild(s);
        else {
            var n, o = $9052383c1c4e5569$var$r.querySelectorAll("body > script");
            o.length > 0 ? null == (n = o[0].parentNode) || n.insertBefore(s, o[0]) : $9052383c1c4e5569$var$r.body.appendChild(s);
        }
    };
    null != $9052383c1c4e5569$var$r && $9052383c1c4e5569$var$r.body ? l() : null == $9052383c1c4e5569$var$r || $9052383c1c4e5569$var$r.addEventListener("DOMContentLoaded", l);
};
$9052383c1c4e5569$var$h.__PosthogExtensions__ = $9052383c1c4e5569$var$h.__PosthogExtensions__ || {}, $9052383c1c4e5569$var$h.__PosthogExtensions__.loadExternalDependency = (t, e, i)=>{
    if ("remote-config" !== e) {
        var r;
        if (t.config.strict_script_versioning) r = t.requestRouter.endpointFor("assets", "/static/" + t.version + "/" + e + ".js");
        else {
            var s = "/static/" + e + ".js?v=" + t.version;
            if ("toolbar" === e) {
                var n = 3e5;
                s = s + "&t=" + Math.floor(Date.now() / n) * n;
            }
            r = t.requestRouter.endpointFor("assets", s);
        }
        $9052383c1c4e5569$var$Ke(t, r, i);
    } else {
        var o = t.requestRouter.endpointFor("assets", "/array/" + t.config.token + "/config.js");
        $9052383c1c4e5569$var$Ke(t, o, i);
    }
}, $9052383c1c4e5569$var$h.__PosthogExtensions__.loadSiteApp = (t, e, i)=>{
    var r = t.requestRouter.endpointFor("api", e);
    $9052383c1c4e5569$var$Ke(t, r, i);
};
var $9052383c1c4e5569$var$Xe = "$people_distinct_id", $9052383c1c4e5569$var$Qe = "$device_id", $9052383c1c4e5569$var$Ze = "__alias", $9052383c1c4e5569$var$ti = "__timers", $9052383c1c4e5569$var$ei = "$autocapture_disabled_server_side", $9052383c1c4e5569$var$ii = "$heatmaps_enabled_server_side", $9052383c1c4e5569$var$ri = "$exception_capture_enabled_server_side", $9052383c1c4e5569$var$si = "$error_tracking_suppression_rules", $9052383c1c4e5569$var$ni = "$error_tracking_capture_extension_exceptions", $9052383c1c4e5569$var$oi = "$web_vitals_enabled_server_side", $9052383c1c4e5569$var$ai = "$dead_clicks_enabled_server_side", $9052383c1c4e5569$var$li = "$product_tours_enabled_server_side", $9052383c1c4e5569$var$ui = "$web_vitals_allowed_metrics", $9052383c1c4e5569$var$hi = "$session_recording_remote_config", $9052383c1c4e5569$var$di = "$replay_sample_rate", $9052383c1c4e5569$var$vi = "$replay_override_sampling", $9052383c1c4e5569$var$ci = "$replay_override_linked_flag", $9052383c1c4e5569$var$pi = "$replay_override_url_trigger", $9052383c1c4e5569$var$fi = "$replay_override_event_trigger", $9052383c1c4e5569$var$_i = "$sesid", $9052383c1c4e5569$var$gi = "$session_is_sampled", $9052383c1c4e5569$var$mi = "$enabled_feature_flags", $9052383c1c4e5569$var$bi = "$active_feature_flags", $9052383c1c4e5569$var$yi = "$early_access_features", $9052383c1c4e5569$var$wi = "$feature_flag_details", $9052383c1c4e5569$var$xi = "$feature_flag_payloads", $9052383c1c4e5569$var$Ei = "$feature_flag_request_id", $9052383c1c4e5569$var$Si = "$override_feature_flags", $9052383c1c4e5569$var$$i = "$override_feature_flag_payloads", $9052383c1c4e5569$var$Ti = "$stored_person_properties", $9052383c1c4e5569$var$ki = "$stored_group_properties", $9052383c1c4e5569$var$Ri = "$surveys", $9052383c1c4e5569$var$Pi = "$surveys_loaded_at", $9052383c1c4e5569$var$Oi = "$surveys_activated", $9052383c1c4e5569$var$Ii = "ph_product_tours", $9052383c1c4e5569$var$Ci = "$flag_call_reported", $9052383c1c4e5569$var$Ai = "$flag_call_reported_session_id", $9052383c1c4e5569$var$Fi = "$feature_flag_errors", $9052383c1c4e5569$var$Mi = "$feature_flag_evaluated_at", $9052383c1c4e5569$var$Di = "$user_state", $9052383c1c4e5569$var$Ni = "$client_session_props", $9052383c1c4e5569$var$Li = "$capture_rate_limit", $9052383c1c4e5569$var$Ui = "$initial_campaign_params", $9052383c1c4e5569$var$ji = "$initial_referrer_info", $9052383c1c4e5569$var$zi = "$initial_person_info", $9052383c1c4e5569$var$Bi = "$epp", $9052383c1c4e5569$var$Hi = "__POSTHOG_TOOLBAR__", $9052383c1c4e5569$var$Vi = "$posthog_cookieless", $9052383c1c4e5569$var$qi = "$sdk_debug_extensions_init_method", $9052383c1c4e5569$var$Gi = "$sdk_debug_extensions_init_time_ms", $9052383c1c4e5569$var$Wi = "$sdk_debug_recording_script_not_loaded", $9052383c1c4e5569$var$Yi = "PostHog loadExternalDependency extension not found.", $9052383c1c4e5569$var$Ji = "on_reject", $9052383c1c4e5569$var$Ki = "always", $9052383c1c4e5569$var$Xi = "anonymous", $9052383c1c4e5569$var$Qi = "identified", $9052383c1c4e5569$var$Zi = "identified_only", $9052383c1c4e5569$var$tr = "visibilitychange", $9052383c1c4e5569$var$er = "beforeunload", $9052383c1c4e5569$var$ir = "$pageview", $9052383c1c4e5569$var$rr = "$pageleave", $9052383c1c4e5569$var$sr = "$identify", $9052383c1c4e5569$var$nr = "$groupidentify";
function $9052383c1c4e5569$var$or(t, e) {
    $9052383c1c4e5569$var$M(t) && t.forEach(e);
}
function $9052383c1c4e5569$var$ar(t, e) {
    if (!$9052383c1c4e5569$var$H(t)) {
        if ($9052383c1c4e5569$var$M(t)) t.forEach(e);
        else if ($9052383c1c4e5569$var$W(t)) t.forEach((t, i)=>e(t, i));
        else for(var i in t)$9052383c1c4e5569$var$A.call(t, i) && e(t[i], i);
    }
}
var $9052383c1c4e5569$var$lr = function(t) {
    for(var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), r = 1; e > r; r++)i[r - 1] = arguments[r];
    for (var s of i)for(var n in s)void 0 !== s[n] && (t[n] = s[n]);
    return t;
};
function $9052383c1c4e5569$var$ur(t) {
    for(var e = Object.keys(t), i = e.length, r = new Array(i); i--;)r[i] = [
        e[i],
        t[e[i]]
    ];
    return r;
}
var $9052383c1c4e5569$var$hr = function(t) {
    try {
        return t();
    } catch (t) {
        return;
    }
}, $9052383c1c4e5569$var$dr = function(t) {
    return function() {
        try {
            for(var e = arguments.length, i = new Array(e), r = 0; e > r; r++)i[r] = arguments[r];
            return t.apply(this, i);
        } catch (t) {
            $9052383c1c4e5569$var$We.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $9052383c1c4e5569$var$We.critical(t);
        }
    };
}, $9052383c1c4e5569$var$vr = function(t) {
    var e = {};
    return $9052383c1c4e5569$var$ar(t, function(t, i) {
        ($9052383c1c4e5569$var$j(t) && t.length > 0 || $9052383c1c4e5569$var$V(t)) && (e[i] = t);
    }), e;
};
var $9052383c1c4e5569$var$cr = [
    "herokuapp.com",
    "vercel.app",
    "netlify.app"
];
function $9052383c1c4e5569$var$pr(t) {
    var e = null == t ? void 0 : t.hostname;
    if (!$9052383c1c4e5569$var$j(e)) return !1;
    var i = e.split(".").slice(-2).join(".");
    for (var r of $9052383c1c4e5569$var$cr)if (i === r) return !1;
    return !0;
}
function $9052383c1c4e5569$var$fr(t, e, i, r) {
    var { capture: s = !1, passive: n = !0 } = null != r ? r : {};
    null == t || t.addEventListener(e, i, {
        capture: s,
        passive: n
    });
}
function $9052383c1c4e5569$var$_r(t) {
    return "ph_toolbar_internal" === t.name;
}
Math.trunc || (Math.trunc = function(t) {
    return 0 > t ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
    return $9052383c1c4e5569$var$V(t) && isFinite(t) && Math.floor(t) === t;
});
class $9052383c1c4e5569$var$gr {
    constructor(t){
        if (this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(t, e, i, r) {
        if (!Number.isInteger(t) || !Number.isInteger(e) || !Number.isInteger(i) || !Number.isInteger(r) || 0 > t || 0 > e || 0 > i || 0 > r || t > 0xffffffffffff || e > 4095 || i > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
        var s = new Uint8Array(16);
        return s[0] = t / Math.pow(2, 40), s[1] = t / Math.pow(2, 32), s[2] = t / Math.pow(2, 24), s[3] = t / Math.pow(2, 16), s[4] = t / Math.pow(2, 8), s[5] = t, s[6] = 112 | e >>> 8, s[7] = e, s[8] = 128 | i >>> 24, s[9] = i >>> 16, s[10] = i >>> 8, s[11] = i, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new $9052383c1c4e5569$var$gr(s);
    }
    toString() {
        for(var t = "", e = 0; this.bytes.length > e; e++)t = t + (this.bytes[e] >>> 4).toString(16) + (15 & this.bytes[e]).toString(16), 3 !== e && 5 !== e && 7 !== e && 9 !== e || (t += "-");
        if (36 !== t.length) throw new Error("Invalid UUIDv7 was generated");
        return t;
    }
    clone() {
        return new $9052383c1c4e5569$var$gr(this.bytes.slice(0));
    }
    equals(t) {
        return 0 === this.compareTo(t);
    }
    compareTo(t) {
        for(var e = 0; 16 > e; e++){
            var i = this.bytes[e] - t.bytes[e];
            if (0 !== i) return Math.sign(i);
        }
        return 0;
    }
}
class $9052383c1c4e5569$var$mr {
    constructor(){
        this.S = 0, this.C = 0, this.I = new $9052383c1c4e5569$var$wr;
    }
    generate() {
        var t = this.generateOrAbort();
        if ($9052383c1c4e5569$var$U(t)) {
            this.S = 0;
            var e = this.generateOrAbort();
            if ($9052383c1c4e5569$var$U(e)) throw new Error("Could not generate UUID after timestamp reset");
            return e;
        }
        return t;
    }
    generateOrAbort() {
        var t = Date.now();
        if (t > this.S) this.S = t, this.T();
        else {
            if (this.S >= t + 1e4) return;
            this.C++, this.C > 4398046511103 && (this.S++, this.T());
        }
        return $9052383c1c4e5569$var$gr.fromFieldsV7(this.S, Math.trunc(this.C / Math.pow(2, 30)), this.C & Math.pow(2, 30) - 1, this.I.nextUint32());
    }
    T() {
        this.C = 1024 * this.I.nextUint32() + (1023 & this.I.nextUint32());
    }
}
var $9052383c1c4e5569$var$br, $9052383c1c4e5569$var$yr = (t)=>{
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var e = 0; t.length > e; e++)t[e] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return t;
};
$9052383c1c4e5569$var$t && !$9052383c1c4e5569$var$U($9052383c1c4e5569$var$t.crypto) && crypto.getRandomValues && ($9052383c1c4e5569$var$yr = (t)=>crypto.getRandomValues(t));
class $9052383c1c4e5569$var$wr {
    constructor(){
        this.M = new Uint32Array(8), this.R = 1 / 0;
    }
    nextUint32() {
        return this.M.length > this.R || ($9052383c1c4e5569$var$yr(this.M), this.R = 0), this.M[this.R++];
    }
}
var $9052383c1c4e5569$var$xr = ()=>$9052383c1c4e5569$var$Er().toString(), $9052383c1c4e5569$var$Er = ()=>($9052383c1c4e5569$var$br || ($9052383c1c4e5569$var$br = new $9052383c1c4e5569$var$mr)).generate(), $9052383c1c4e5569$var$Sr = "", $9052383c1c4e5569$var$$r = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
var $9052383c1c4e5569$var$Tr = {
    O: ()=>!!$9052383c1c4e5569$var$r,
    D (t) {
        $9052383c1c4e5569$var$We.error("cookieStore error: " + t);
    },
    A (t) {
        if ($9052383c1c4e5569$var$r) {
            try {
                for(var e = t + "=", i = $9052383c1c4e5569$var$r.cookie.split(";").filter((t)=>t.length), s = 0; i.length > s; s++){
                    for(var n = i[s]; " " == n.charAt(0);)n = n.substring(1, n.length);
                    if (0 === n.indexOf(e)) return decodeURIComponent(n.substring(e.length, n.length));
                }
            } catch (t) {}
            return null;
        }
    },
    F (t) {
        var e;
        try {
            e = JSON.parse($9052383c1c4e5569$var$Tr.A(t)) || {};
        } catch (t) {}
        return e;
    },
    N (t, e, i, s, n) {
        if (!$9052383c1c4e5569$var$r) return !1;
        try {
            var o = "", a = "", l = function(t, e) {
                if (e) {
                    var i = function(t, e) {
                        if (void 0 === e && (e = $9052383c1c4e5569$var$r), $9052383c1c4e5569$var$Sr) return $9052383c1c4e5569$var$Sr;
                        if (!e) return "";
                        if ([
                            "localhost",
                            "127.0.0.1"
                        ].includes(t)) return "";
                        for(var i = t.split("."), s = Math.min(i.length, 8), n = "dmn_chk_" + $9052383c1c4e5569$var$xr(); !$9052383c1c4e5569$var$Sr && s--;){
                            var o = i.slice(s).join("."), a = n + "=1;domain=." + o + ";path=/";
                            e.cookie = a + ";max-age=3", e.cookie.includes(n) && (e.cookie = a + ";max-age=0", $9052383c1c4e5569$var$Sr = o);
                        }
                        return $9052383c1c4e5569$var$Sr;
                    }(t);
                    if (!i) {
                        var s = ((t)=>{
                            var e = t.match($9052383c1c4e5569$var$$r);
                            return e ? e[0] : "";
                        })(t);
                        s !== i && $9052383c1c4e5569$var$We.info("Warning: cookie subdomain discovery mismatch", s, i), i = s;
                    }
                    return i ? "; domain=." + i : "";
                }
                return "";
            }($9052383c1c4e5569$var$r.location.hostname, s);
            if (i) {
                var u = new Date;
                u.setTime(u.getTime() + 864e5 * i), o = "; expires=" + u.toUTCString();
            }
            n && (a = "; secure");
            var h = t + "=" + encodeURIComponent(JSON.stringify(e)) + o + "; SameSite=Lax; path=/" + l + a;
            return h.length > 3686.4 && $9052383c1c4e5569$var$We.warn("cookieStore warning: large cookie, len=" + h.length), $9052383c1c4e5569$var$r.cookie = h, !0;
        } catch (t) {
            return !1;
        }
    },
    q (t, e) {
        if (null != $9052383c1c4e5569$var$r && $9052383c1c4e5569$var$r.cookie) try {
            $9052383c1c4e5569$var$Tr.N(t, "", -1, e);
        } catch (t) {
            return;
        }
    }
}, $9052383c1c4e5569$var$kr = null, $9052383c1c4e5569$var$Rr = {
    O () {
        if (!$9052383c1c4e5569$var$B($9052383c1c4e5569$var$kr)) return $9052383c1c4e5569$var$kr;
        var e = !0;
        if ($9052383c1c4e5569$var$U($9052383c1c4e5569$var$t)) e = !1;
        else try {
            var i = "__mplssupport__";
            $9052383c1c4e5569$var$Rr.N(i, "xyz"), '"xyz"' !== $9052383c1c4e5569$var$Rr.A(i) && (e = !1), $9052383c1c4e5569$var$Rr.q(i);
        } catch (t) {
            e = !1;
        }
        return e || $9052383c1c4e5569$var$We.error("localStorage unsupported; falling back to cookie store"), $9052383c1c4e5569$var$kr = e, e;
    },
    D (t) {
        $9052383c1c4e5569$var$We.error("localStorage error: " + t);
    },
    A (e) {
        try {
            return null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.localStorage.getItem(e);
        } catch (t) {
            $9052383c1c4e5569$var$Rr.D(t);
        }
        return null;
    },
    F (t) {
        try {
            return JSON.parse($9052383c1c4e5569$var$Rr.A(t)) || {};
        } catch (t) {}
        return null;
    },
    N (e, i) {
        try {
            return null == $9052383c1c4e5569$var$t || $9052383c1c4e5569$var$t.localStorage.setItem(e, JSON.stringify(i)), !0;
        } catch (t) {
            $9052383c1c4e5569$var$Rr.D(t);
        }
        return !1;
    },
    q (e) {
        try {
            null == $9052383c1c4e5569$var$t || $9052383c1c4e5569$var$t.localStorage.removeItem(e);
        } catch (t) {
            $9052383c1c4e5569$var$Rr.D(t);
        }
    }
}, $9052383c1c4e5569$var$Pr = [
    $9052383c1c4e5569$var$Qe,
    "distinct_id",
    $9052383c1c4e5569$var$_i,
    $9052383c1c4e5569$var$gi,
    $9052383c1c4e5569$var$Bi,
    $9052383c1c4e5569$var$zi,
    $9052383c1c4e5569$var$Di
], $9052383c1c4e5569$var$Or = {}, $9052383c1c4e5569$var$Ir = {
    O: ()=>!0,
    D (t) {
        $9052383c1c4e5569$var$We.error("memoryStorage error: " + t);
    },
    A: (t)=>$9052383c1c4e5569$var$Or[t] || null,
    F: (t)=>$9052383c1c4e5569$var$Or[t] || null,
    N: (t, e)=>($9052383c1c4e5569$var$Or[t] = e, !0),
    q (t) {
        delete $9052383c1c4e5569$var$Or[t];
    }
}, $9052383c1c4e5569$var$Cr = null, $9052383c1c4e5569$var$Ar = {
    O () {
        if (!$9052383c1c4e5569$var$B($9052383c1c4e5569$var$Cr)) return $9052383c1c4e5569$var$Cr;
        if ($9052383c1c4e5569$var$Cr = !0, $9052383c1c4e5569$var$U($9052383c1c4e5569$var$t)) $9052383c1c4e5569$var$Cr = !1;
        else try {
            var e = "__support__";
            $9052383c1c4e5569$var$Ar.N(e, "xyz"), '"xyz"' !== $9052383c1c4e5569$var$Ar.A(e) && ($9052383c1c4e5569$var$Cr = !1), $9052383c1c4e5569$var$Ar.q(e);
        } catch (t) {
            $9052383c1c4e5569$var$Cr = !1;
        }
        return $9052383c1c4e5569$var$Cr;
    },
    D (t) {
        $9052383c1c4e5569$var$We.error("sessionStorage error: ", t);
    },
    A (e) {
        try {
            return null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.sessionStorage.getItem(e);
        } catch (t) {
            $9052383c1c4e5569$var$Ar.D(t);
        }
        return null;
    },
    F (t) {
        try {
            return JSON.parse($9052383c1c4e5569$var$Ar.A(t)) || null;
        } catch (t) {}
        return null;
    },
    N (e, i) {
        try {
            return null == $9052383c1c4e5569$var$t || $9052383c1c4e5569$var$t.sessionStorage.setItem(e, JSON.stringify(i)), !0;
        } catch (t) {
            $9052383c1c4e5569$var$Ar.D(t);
        }
        return !1;
    },
    q (e) {
        try {
            null == $9052383c1c4e5569$var$t || $9052383c1c4e5569$var$t.sessionStorage.removeItem(e);
        } catch (t) {
            $9052383c1c4e5569$var$Ar.D(t);
        }
    }
};
class $9052383c1c4e5569$var$Fr {
    constructor(t){
        this._instance = t;
    }
    get qt() {
        return this._instance.config;
    }
    get consent() {
        return this.rr() ? 0 : this.ir;
    }
    isOptedOut() {
        return this.qt.cookieless_mode === $9052383c1c4e5569$var$Ki || this.isRejected() || -1 === this.consent && this.qt.cookieless_mode === $9052383c1c4e5569$var$Ji;
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    isExplicitlyOptedOut() {
        return 0 === this.consent;
    }
    isRejected() {
        return 0 === this.consent || -1 === this.consent && this.qt.opt_out_capturing_by_default;
    }
    optInOut(t) {
        this.nr.N(this.sr, t ? 1 : 0, this.qt.cookie_expiration, this.qt.cross_subdomain_cookie, this.qt.secure_cookie);
    }
    reset() {
        this.nr.q(this.sr, this.qt.cross_subdomain_cookie);
    }
    get sr() {
        var { token: t, opt_out_capturing_cookie_prefix: e, consent_persistence_name: i } = this._instance.config;
        return i || (e ? e + t : "__ph_opt_in_out_" + t);
    }
    get ir() {
        var t = this.nr.A(this.sr);
        return $9052383c1c4e5569$var$Z(t) ? 1 : $9052383c1c4e5569$var$P($9052383c1c4e5569$var$tt, t) ? 0 : -1;
    }
    get nr() {
        var t = this.qt.opt_out_capturing_persistence_type, e = "localStorage" === t ? $9052383c1c4e5569$var$Rr : $9052383c1c4e5569$var$Tr;
        if (!this.ar || this.ar !== e) {
            this.ar = e;
            var i = "localStorage" === t ? $9052383c1c4e5569$var$Tr : $9052383c1c4e5569$var$Rr;
            i.A(this.sr) && (this.ar.A(this.sr) || this.optInOut($9052383c1c4e5569$var$Z(i.A(this.sr))), i.q(this.sr, this.qt.cross_subdomain_cookie));
        }
        return this.ar;
    }
    rr() {
        return !!this.qt.respect_dnt && [
            null == $9052383c1c4e5569$var$i ? void 0 : $9052383c1c4e5569$var$i.doNotTrack,
            null == $9052383c1c4e5569$var$i ? void 0 : $9052383c1c4e5569$var$i.msDoNotTrack,
            $9052383c1c4e5569$var$h.doNotTrack
        ].some((t)=>$9052383c1c4e5569$var$Z(t));
    }
}
var $9052383c1c4e5569$var$Mr = 1, $9052383c1c4e5569$var$Dr = 3, $9052383c1c4e5569$var$Nr = 11;
function $9052383c1c4e5569$var$Lr(t) {
    return t instanceof Element && (t.id === $9052383c1c4e5569$var$Hi || !(null == t.closest || !t.closest(".toolbar-global-fade-container")));
}
function $9052383c1c4e5569$var$Ur(t) {
    return !!t && t.nodeType === $9052383c1c4e5569$var$Mr;
}
function $9052383c1c4e5569$var$jr(t, e) {
    return !!t && !!t.tagName && t.tagName.toLowerCase() === e.toLowerCase();
}
function $9052383c1c4e5569$var$zr(t) {
    return !!t && t.nodeType === $9052383c1c4e5569$var$Dr;
}
function $9052383c1c4e5569$var$Br(t) {
    return !!t && t.nodeType === $9052383c1c4e5569$var$Nr && $9052383c1c4e5569$var$Ur(t.host);
}
function $9052383c1c4e5569$var$Hr(t) {
    return t ? $9052383c1c4e5569$var$O(t).split(/\s+/) : [];
}
function $9052383c1c4e5569$var$Vr(e) {
    var i = null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.location.href;
    return !!(i && e && e.some((t)=>i.match(t)));
}
function $9052383c1c4e5569$var$qr(t) {
    var e = "";
    switch(typeof t.className){
        case "string":
            e = t.className;
            break;
        case "object":
            e = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
            break;
        default:
            e = "";
    }
    return $9052383c1c4e5569$var$Hr(e);
}
function $9052383c1c4e5569$var$Gr(t) {
    return $9052383c1c4e5569$var$H(t) ? null : $9052383c1c4e5569$var$O(t).split(/(\s+)/).filter((t)=>$9052383c1c4e5569$var$ps(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $9052383c1c4e5569$var$Wr(t) {
    var e = "";
    return $9052383c1c4e5569$var$os(t) && !$9052383c1c4e5569$var$as(t) && t.childNodes && t.childNodes.length && $9052383c1c4e5569$var$ar(t.childNodes, function(t) {
        var i;
        $9052383c1c4e5569$var$zr(t) && t.textContent && (e += null !== (i = $9052383c1c4e5569$var$Gr(t.textContent)) && void 0 !== i ? i : "");
    }), $9052383c1c4e5569$var$O(e);
}
function $9052383c1c4e5569$var$Yr(t) {
    var e;
    return $9052383c1c4e5569$var$U(t.target) ? t.srcElement || null : null != (e = t.target) && e.shadowRoot ? t.composedPath()[0] || null : t.target || null;
}
var $9052383c1c4e5569$var$Jr = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $9052383c1c4e5569$var$Kr(t, e) {
    if ($9052383c1c4e5569$var$U(e)) return !0;
    var i, r = function(t) {
        if (e.some((e)=>t.matches(e))) return {
            v: !0
        };
    };
    for (var s of t)if (i = r(s)) return i.v;
    return !1;
}
function $9052383c1c4e5569$var$Xr(t) {
    var e = t.parentNode;
    return !(!e || !$9052383c1c4e5569$var$Ur(e)) && e;
}
var $9052383c1c4e5569$var$Qr = [
    "next",
    "previous",
    "prev",
    ">",
    "<"
], $9052383c1c4e5569$var$Zr = [
    ...$9052383c1c4e5569$var$Qr,
    "+",
    "-",
    "\u2212",
    "\u2013"
], $9052383c1c4e5569$var$ts = (t, e)=>/[a-z0-9]/i.test(e) ? t.includes(e) : t === e, $9052383c1c4e5569$var$es = [
    ".ph-no-rageclick",
    ".ph-no-capture"
], $9052383c1c4e5569$var$is = [
    "",
    "text",
    "search",
    "email",
    "password",
    "url",
    "tel",
    "number"
];
function $9052383c1c4e5569$var$rs(e, i) {
    if (!$9052383c1c4e5569$var$t || $9052383c1c4e5569$var$ss(e)) return !1;
    var r, s, n, o, a;
    if ($9052383c1c4e5569$var$G(i) ? (r = !!i && $9052383c1c4e5569$var$es, s = void 0, n = !1) : (r = null !== (o = null == i ? void 0 : i.css_selector_ignorelist) && void 0 !== o ? o : $9052383c1c4e5569$var$es, s = null == i ? void 0 : i.content_ignorelist, n = null !== (a = null == i ? void 0 : i.ignore_text_selection) && void 0 !== a && a), !1 === r) return !1;
    if (n && function(t) {
        return !(!t || !$9052383c1c4e5569$var$Ur(t)) && (!!$9052383c1c4e5569$var$jr(t, "textarea") || ($9052383c1c4e5569$var$jr(t, "input") ? $9052383c1c4e5569$var$P($9052383c1c4e5569$var$is, (t.getAttribute("type") || "").toLowerCase()) : function(t) {
            if (t.isContentEditable) return !0;
            var e = null == t.getAttribute ? void 0 : t.getAttribute("contenteditable");
            return "true" === e || "" === e;
        }(t)));
    }(e)) return !1;
    var { targetElementList: l } = $9052383c1c4e5569$var$ns(e, !1);
    return !function(t, e) {
        if (!1 === t || $9052383c1c4e5569$var$U(t)) return !1;
        var i;
        if (!0 === t) i = $9052383c1c4e5569$var$Qr;
        else {
            if (!$9052383c1c4e5569$var$M(t)) return !1;
            if (t.length > 10) return $9052383c1c4e5569$var$We.error("[PostHog] content_ignorelist array cannot exceed 10 items. Use css_selector_ignorelist for more complex matching."), !1;
            i = t.map((t)=>t.toLowerCase());
        }
        return e.some((t)=>{
            var { safeText: e, ariaLabel: r } = t;
            return i.some((t)=>$9052383c1c4e5569$var$ts(e, t) || $9052383c1c4e5569$var$ts(r, t));
        });
    }(s, l.map((t)=>{
        var e;
        return {
            safeText: $9052383c1c4e5569$var$Wr(t).toLowerCase(),
            ariaLabel: (null == (e = t.getAttribute("aria-label")) ? void 0 : e.toLowerCase().trim()) || ""
        };
    })) && !$9052383c1c4e5569$var$Kr(l, r);
}
var $9052383c1c4e5569$var$ss = (t)=>!t || $9052383c1c4e5569$var$jr(t, "html") || !$9052383c1c4e5569$var$Ur(t), $9052383c1c4e5569$var$ns = (e, i)=>{
    if (!$9052383c1c4e5569$var$t || $9052383c1c4e5569$var$ss(e)) return {
        parentIsUsefulElement: !1,
        targetElementList: []
    };
    for(var r = !1, s = [
        e
    ], n = e; n.parentNode && !$9052383c1c4e5569$var$jr(n, "body");)if ($9052383c1c4e5569$var$Br(n.parentNode)) s.push(n.parentNode.host), n = n.parentNode.host;
    else {
        var o = $9052383c1c4e5569$var$Xr(n);
        if (!o) break;
        if (i || $9052383c1c4e5569$var$Jr.indexOf(o.tagName.toLowerCase()) > -1) r = !0;
        else {
            var a = $9052383c1c4e5569$var$t.getComputedStyle(o);
            a && "pointer" === a.getPropertyValue("cursor") && (r = !0);
        }
        s.push(o), n = o;
    }
    return {
        parentIsUsefulElement: r,
        targetElementList: s
    };
};
function $9052383c1c4e5569$var$os(t) {
    for(var e = t; e.parentNode && !$9052383c1c4e5569$var$jr(e, "body"); e = e.parentNode){
        var i = $9052383c1c4e5569$var$qr(e);
        if ($9052383c1c4e5569$var$P(i, "ph-sensitive") || $9052383c1c4e5569$var$P(i, "ph-no-capture")) return !1;
    }
    if ($9052383c1c4e5569$var$P($9052383c1c4e5569$var$qr(t), "ph-include")) return !0;
    var r = t.type || "";
    if ($9052383c1c4e5569$var$j(r)) switch(r.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var s = t.name || t.id || "";
    return !$9052383c1c4e5569$var$j(s) || !/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(s.replace(/[^a-zA-Z0-9]/g, ""));
}
function $9052383c1c4e5569$var$as(t) {
    return !!($9052383c1c4e5569$var$jr(t, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(t.type) || $9052383c1c4e5569$var$jr(t, "select") || $9052383c1c4e5569$var$jr(t, "textarea") || "true" === t.getAttribute("contenteditable"));
}
var $9052383c1c4e5569$var$ls = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", $9052383c1c4e5569$var$us = new RegExp("^(?:" + $9052383c1c4e5569$var$ls + ")$"), $9052383c1c4e5569$var$hs = new RegExp($9052383c1c4e5569$var$ls), $9052383c1c4e5569$var$ds = "\\d{3}-?\\d{2}-?\\d{4}", $9052383c1c4e5569$var$vs = new RegExp("^(" + $9052383c1c4e5569$var$ds + ")$"), $9052383c1c4e5569$var$cs = new RegExp("(" + $9052383c1c4e5569$var$ds + ")");
function $9052383c1c4e5569$var$ps(t, e) {
    if (void 0 === e && (e = !0), $9052383c1c4e5569$var$H(t)) return !1;
    if ($9052383c1c4e5569$var$j(t)) {
        if (t = $9052383c1c4e5569$var$O(t), (e ? $9052383c1c4e5569$var$us : $9052383c1c4e5569$var$hs).test((t || "").replace(/[- ]/g, ""))) return !1;
        if ((e ? $9052383c1c4e5569$var$vs : $9052383c1c4e5569$var$cs).test(t)) return !1;
    }
    return !0;
}
function $9052383c1c4e5569$var$fs(t) {
    var e = $9052383c1c4e5569$var$Wr(t);
    return $9052383c1c4e5569$var$ps(e = (e + " " + $9052383c1c4e5569$var$_s(t)).trim()) ? e : "";
}
function $9052383c1c4e5569$var$_s(t) {
    var e = "";
    return t && t.childNodes && t.childNodes.length && $9052383c1c4e5569$var$ar(t.childNodes, function(t) {
        var i;
        if (t && "span" === (null == (i = t.tagName) ? void 0 : i.toLowerCase())) try {
            var r = $9052383c1c4e5569$var$Wr(t);
            e = (e + " " + r).trim(), t.childNodes && t.childNodes.length && (e = (e + " " + $9052383c1c4e5569$var$_s(t)).trim());
        } catch (t) {
            $9052383c1c4e5569$var$We.error("[AutoCapture]", t);
        }
    }), e;
}
function $9052383c1c4e5569$var$gs(t) {
    return t.replace(/"|\\"/g, '\\"');
}
function $9052383c1c4e5569$var$ms(t) {
    var e = t.attr__class;
    return e ? $9052383c1c4e5569$var$M(e) ? e : $9052383c1c4e5569$var$Hr(e) : void 0;
}
var $9052383c1c4e5569$var$bs = $9052383c1c4e5569$var$Ye("[Dead Clicks]"), $9052383c1c4e5569$var$ys = ()=>!0, $9052383c1c4e5569$var$ws = (t)=>{
    var e, i = !(null == (e = t.instance.persistence) || !e.get_property($9052383c1c4e5569$var$ai)), r = t.instance.config.capture_dead_clicks;
    return $9052383c1c4e5569$var$G(r) ? r : !!$9052383c1c4e5569$var$N(r) || i;
};
class $9052383c1c4e5569$var$xs {
    get lazyLoadedDeadClicksAutocapture() {
        return this.lr;
    }
    constructor(t, e, i){
        this.instance = t, this.isEnabled = e, this.onCapture = i, this.startIfEnabledOrStop();
    }
    onRemoteConfig(t) {
        "captureDeadClicks" in t && (this.instance.persistence && this.instance.persistence.register({
            [$9052383c1c4e5569$var$ai]: t.captureDeadClicks
        }), this.startIfEnabledOrStop());
    }
    startIfEnabledOrStop() {
        this.isEnabled(this) ? this.ur(()=>{
            this.hr();
        }) : this.stop();
    }
    ur(t) {
        var e, i;
        null != (e = $9052383c1c4e5569$var$h.__PosthogExtensions__) && e.initDeadClicksAutocapture && t(), null == (i = $9052383c1c4e5569$var$h.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this.instance, "dead-clicks-autocapture", (e)=>{
            e ? $9052383c1c4e5569$var$bs.error("failed to load script", e) : t();
        });
    }
    hr() {
        var t;
        if ($9052383c1c4e5569$var$r) {
            if (!this.lr && null != (t = $9052383c1c4e5569$var$h.__PosthogExtensions__) && t.initDeadClicksAutocapture) {
                var e = $9052383c1c4e5569$var$N(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
                e.__onCapture = this.onCapture, this.lr = $9052383c1c4e5569$var$h.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, e), this.lr.start($9052383c1c4e5569$var$r), $9052383c1c4e5569$var$bs.info("starting...");
            }
        } else $9052383c1c4e5569$var$bs.error("`document` not found. Cannot start.");
    }
    stop() {
        this.lr && (this.lr.stop(), this.lr = void 0, $9052383c1c4e5569$var$bs.info("stopping..."));
    }
}
var $9052383c1c4e5569$var$Es = $9052383c1c4e5569$var$Ye("[SegmentIntegration]");
var $9052383c1c4e5569$var$Ss = "posthog-js";
function $9052383c1c4e5569$var$$s(t, e) {
    var { organization: i, projectId: r, prefix: s, severityAllowList: n = [
        "error"
    ], sendExceptionsToPostHog: o = !0 } = void 0 === e ? {} : e;
    return (e)=>{
        var a, l, u, h, d;
        if ("*" !== n && !n.includes(e.level) || !t.__loaded) return e;
        e.tags || (e.tags = {});
        var v = t.requestRouter.endpointFor("ui", "/project/" + t.config.token + "/person/" + t.get_distinct_id());
        e.tags["PostHog Person URL"] = v, t.sessionRecordingStarted() && (e.tags["PostHog Recording URL"] = t.get_session_replay_url({
            withTimestamp: !0
        }));
        var c, p = (null == (a = e.exception) ? void 0 : a.values) || [], _ = p.map((t)=>$9052383c1c4e5569$var$f({}, t, {
                stacktrace: t.stacktrace ? $9052383c1c4e5569$var$f({}, t.stacktrace, {
                    type: "raw",
                    frames: (t.stacktrace.frames || []).map((t)=>$9052383c1c4e5569$var$f({}, t, {
                            platform: "web:javascript"
                        }))
                }) : void 0
            })), g = {
            $exception_message: (null == (l = p[0]) ? void 0 : l.value) || e.message,
            $exception_type: null == (u = p[0]) ? void 0 : u.type,
            $exception_level: e.level,
            $exception_list: _,
            $sentry_event_id: e.event_id,
            $sentry_exception: e.exception,
            $sentry_exception_message: (null == (h = p[0]) ? void 0 : h.value) || e.message,
            $sentry_exception_type: null == (d = p[0]) ? void 0 : d.type,
            $sentry_tags: e.tags
        };
        return i && r && (g.$sentry_url = (s || "https://sentry.io/organizations/") + i + "/issues/?project=" + r + "&query=" + e.event_id), o && (null == (c = t.exceptions) || c.sendExceptionEvent(g)), e;
    };
}
class $9052383c1c4e5569$var$Ts {
    constructor(t, e, i, r, s, n){
        this.name = $9052383c1c4e5569$var$Ss, this.setupOnce = function(o) {
            o($9052383c1c4e5569$var$$s(t, {
                organization: e,
                projectId: i,
                prefix: r,
                severityAllowList: s,
                sendExceptionsToPostHog: null == n || n
            }));
        };
    }
}
class $9052383c1c4e5569$var$ks {
    constructor(t){
        this.cr = (t, e, i)=>{
            i && (i.noSessionId || i.activityTimeout || i.sessionPastMaximumLength || i.crossTabAdoption) && ($9052383c1c4e5569$var$We.info("[PageViewManager] Session rotated, clearing pageview state", {
                sessionId: t,
                changeReason: i
            }), this.dr = void 0, this._instance.scrollManager.resetContext());
        }, this._instance = t, this.vr();
    }
    vr() {
        var t;
        this.pr = null == (t = this._instance.sessionManager) ? void 0 : t.onSessionId(this.cr);
    }
    destroy() {
        var t;
        null == (t = this.pr) || t.call(this), this.pr = void 0;
    }
    doPageView(e, i) {
        var r, s = this.gr(e, i);
        return this.dr = {
            pathname: null !== (r = null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.location.pathname) && void 0 !== r ? r : "",
            pageViewId: i,
            timestamp: e
        }, this._instance.scrollManager.resetContext(), s;
    }
    doPageLeave(t) {
        var e;
        return this.gr(t, null == (e = this.dr) ? void 0 : e.pageViewId);
    }
    doEvent() {
        var t;
        return {
            $pageview_id: null == (t = this.dr) ? void 0 : t.pageViewId
        };
    }
    gr(t, e) {
        var i = this.dr;
        if (!i) return {
            $pageview_id: e
        };
        var r = {
            $pageview_id: e,
            $prev_pageview_id: i.pageViewId
        }, s = this._instance.scrollManager.getContext();
        if (s && !this._instance.config.disable_scroll_properties) {
            var { maxScrollHeight: n, lastScrollY: o, maxScrollY: a, maxContentHeight: l, lastContentY: u, maxContentY: h } = s;
            if (!($9052383c1c4e5569$var$U(n) || $9052383c1c4e5569$var$U(o) || $9052383c1c4e5569$var$U(a) || $9052383c1c4e5569$var$U(l) || $9052383c1c4e5569$var$U(u) || $9052383c1c4e5569$var$U(h))) {
                n = Math.ceil(n), o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), u = Math.ceil(u), h = Math.ceil(h);
                var d = n > 1 ? $9052383c1c4e5569$var$et(o / n, 0, 1, $9052383c1c4e5569$var$We) : 1, v = n > 1 ? $9052383c1c4e5569$var$et(a / n, 0, 1, $9052383c1c4e5569$var$We) : 1, c = l > 1 ? $9052383c1c4e5569$var$et(u / l, 0, 1, $9052383c1c4e5569$var$We) : 1, p = l > 1 ? $9052383c1c4e5569$var$et(h / l, 0, 1, $9052383c1c4e5569$var$We) : 1;
                r = $9052383c1c4e5569$var$lr(r, {
                    $prev_pageview_last_scroll: o,
                    $prev_pageview_last_scroll_percentage: d,
                    $prev_pageview_max_scroll: a,
                    $prev_pageview_max_scroll_percentage: v,
                    $prev_pageview_last_content: u,
                    $prev_pageview_last_content_percentage: c,
                    $prev_pageview_max_content: h,
                    $prev_pageview_max_content_percentage: p
                });
            }
        }
        return i.pathname && (r.$prev_pageview_pathname = i.pathname), i.timestamp && (r.$prev_pageview_duration = (t.getTime() - i.timestamp.getTime()) / 1e3), r;
    }
}
var $9052383c1c4e5569$var$Rs = [
    "flags",
    "surveys"
], $9052383c1c4e5569$var$Ps = {
    [$9052383c1c4e5569$var$Xe]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$Ze]: {
        exposure: "hidden"
    },
    __cmpns: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$ti]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$ei]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$ii]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$ri]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$si]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$ni]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$oi]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$ai]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$li]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$ui]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$hi]: {
        exposure: "hidden"
    },
    $session_recording_enabled_server_side: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$_i]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$gi]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$di]: {
        exposure: "event",
        shouldSkipFromEventProperties: (t)=>$9052383c1c4e5569$var$B(t)
    },
    $session_past_minimum_duration: {
        exposure: "event"
    },
    $session_recording_url_trigger_activated_session: {
        exposure: "event"
    },
    $session_recording_event_trigger_activated_session: {
        exposure: "event"
    },
    $debug_first_full_snapshot_timestamp: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$mi]: {
        exposure: "derived",
        storageGroup: "flags",
        shouldSkipFromEventProperties: (t, e)=>e(),
        transformToEventProperties (t) {
            if (!$9052383c1c4e5569$var$N(t)) return {};
            for(var e = {}, i = Object.keys(t), r = 0; i.length > r; r++)e["$feature/" + i[r]] = t[i[r]];
            return e;
        }
    },
    [$9052383c1c4e5569$var$bi]: {
        exposure: "event",
        storageGroup: "flags"
    },
    [$9052383c1c4e5569$var$yi]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$wi]: {
        exposure: "hidden",
        storageGroup: "flags"
    },
    [$9052383c1c4e5569$var$xi]: {
        exposure: "event",
        storageGroup: "flags"
    },
    [$9052383c1c4e5569$var$Ei]: {
        exposure: "event",
        storageGroup: "flags",
        volatile: !0
    },
    [$9052383c1c4e5569$var$Si]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$$i]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$Ti]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$ki]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$Ri]: {
        exposure: "hidden",
        storageGroup: "surveys"
    },
    [$9052383c1c4e5569$var$Pi]: {
        exposure: "hidden",
        storageGroup: "surveys",
        volatile: !0
    },
    [$9052383c1c4e5569$var$Oi]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$Ii]: {
        exposure: "hidden"
    },
    $product_tours_activated: {
        exposure: "hidden"
    },
    $conversations_widget_session_id: {
        exposure: "event"
    },
    $conversations_ticket_id: {
        exposure: "event"
    },
    $conversations_widget_state: {
        exposure: "event"
    },
    $conversations_user_traits: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$Ci]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$Ai]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$Fi]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$Mi]: {
        exposure: "hidden",
        storageGroup: "flags",
        volatile: !0
    },
    [$9052383c1c4e5569$var$Di]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$Ni]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$Li]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$Ui]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$ji]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$zi]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$Bi]: {
        exposure: "hidden"
    },
    [$9052383c1c4e5569$var$vi]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$ci]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$pi]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$fi]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$qi]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$Gi]: {
        exposure: "event"
    },
    [$9052383c1c4e5569$var$Wi]: {
        exposure: "event"
    },
    $sdk_debug_replay_event_trigger_status: {
        exposure: "event"
    },
    $sdk_debug_replay_linked_flag_trigger_status: {
        exposure: "event"
    },
    $sdk_debug_replay_matched_recording_trigger_groups: {
        exposure: "event"
    },
    $sdk_debug_replay_remote_trigger_matching_config: {
        exposure: "event"
    },
    $sdk_debug_replay_trigger_groups_count: {
        exposure: "event"
    },
    $sdk_debug_replay_url_trigger_status: {
        exposure: "event"
    },
    $session_recording_start_reason: {
        exposure: "event"
    }
}, $9052383c1c4e5569$var$Os = [
    [
        "$posthog_sr_group_event_trigger_",
        {
            exposure: "hidden"
        }
    ],
    [
        "$posthog_sr_group_url_trigger_",
        {
            exposure: "hidden"
        }
    ],
    [
        "$posthog_sr_group_sampling_",
        {
            exposure: "hidden"
        }
    ]
], $9052383c1c4e5569$var$Is = (t)=>{
    var e = $9052383c1c4e5569$var$Ps[t];
    if (e) return e;
    for (var [i, r] of $9052383c1c4e5569$var$Os)if (0 === t.indexOf(i)) return r;
}, $9052383c1c4e5569$var$Cs = (t)=>{
    var e = null == $9052383c1c4e5569$var$r ? void 0 : $9052383c1c4e5569$var$r.createElement("a");
    return $9052383c1c4e5569$var$U(e) ? null : (e.href = t, e);
}, $9052383c1c4e5569$var$As = function(t, e) {
    for(var i, r = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), s = 0; r.length > s; s++){
        var n = r[s].split("=");
        if (n[0] === e) {
            i = n;
            break;
        }
    }
    if (!$9052383c1c4e5569$var$M(i) || 2 > i.length) return "";
    var o = i[1];
    try {
        o = decodeURIComponent(o);
    } catch (t) {
        $9052383c1c4e5569$var$We.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, $9052383c1c4e5569$var$Fs = function(t, e, i) {
    if (!t || !e || !e.length) return t;
    for(var r = t.split("#"), s = r[1], n = (r[0] || "").split("?"), o = n[1], a = n[0], l = (o || "").split("&"), u = [], h = 0; l.length > h; h++){
        var d = l[h].split("=");
        $9052383c1c4e5569$var$M(d) && (e.includes(d[0]) ? u.push(d[0] + "=" + i) : u.push(l[h]));
    }
    var v = a;
    return null != o && (v += "?" + u.join("&")), null != s && (v += "#" + s), v;
}, $9052383c1c4e5569$var$Ms = function(t, e) {
    var i = t.match(new RegExp(e + "=([^&]*)"));
    return i ? i[1] : null;
}, $9052383c1c4e5569$var$Ds = "https?://(.*)", $9052383c1c4e5569$var$Ns = [
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx"
], $9052383c1c4e5569$var$Ls = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid",
    ...$9052383c1c4e5569$var$Ns
], $9052383c1c4e5569$var$Us = "<masked>", $9052383c1c4e5569$var$js = [
    "li_fat_id"
];
function $9052383c1c4e5569$var$zs(t, e, i) {
    if (!$9052383c1c4e5569$var$r) return {};
    var s, n = e ? [
        ...$9052383c1c4e5569$var$Ns,
        ...i || []
    ] : [], o = $9052383c1c4e5569$var$Bs($9052383c1c4e5569$var$Fs($9052383c1c4e5569$var$r.URL, n, $9052383c1c4e5569$var$Us), t), a = (s = {}, $9052383c1c4e5569$var$ar($9052383c1c4e5569$var$js, function(t) {
        var e = $9052383c1c4e5569$var$Tr.A(t);
        s[t] = e || null;
    }), s);
    return $9052383c1c4e5569$var$lr(a, o);
}
function $9052383c1c4e5569$var$Bs(t, e) {
    var i = $9052383c1c4e5569$var$Ls.concat(e || []), r = {};
    return $9052383c1c4e5569$var$ar(i, function(e) {
        var i = $9052383c1c4e5569$var$As(t, e);
        r[e] = i || null;
    }), r;
}
function $9052383c1c4e5569$var$Hs(t) {
    var e = function(t) {
        return t ? 0 === t.search($9052383c1c4e5569$var$Ds + "google.([^/?]*)") ? "google" : 0 === t.search($9052383c1c4e5569$var$Ds + "bing.com") ? "bing" : 0 === t.search($9052383c1c4e5569$var$Ds + "yahoo.com") ? "yahoo" : 0 === t.search($9052383c1c4e5569$var$Ds + "duckduckgo.com") ? "duckduckgo" : null : null;
    }(t), i = "yahoo" != e ? "q" : "p", s = {};
    if (!$9052383c1c4e5569$var$B(e)) {
        s.$search_engine = e;
        var n = $9052383c1c4e5569$var$r ? $9052383c1c4e5569$var$As($9052383c1c4e5569$var$r.referrer, i) : "";
        n.length && (s.ph_keyword = n);
    }
    return s;
}
function $9052383c1c4e5569$var$Vs() {
    return navigator.language || navigator.userLanguage;
}
var $9052383c1c4e5569$var$qs = "$direct";
function $9052383c1c4e5569$var$Gs() {
    return (null == $9052383c1c4e5569$var$r ? void 0 : $9052383c1c4e5569$var$r.referrer) || $9052383c1c4e5569$var$qs;
}
function $9052383c1c4e5569$var$Ws(t, e) {
    var i = t ? [
        ...$9052383c1c4e5569$var$Ns,
        ...e || []
    ] : [], r = null == $9052383c1c4e5569$var$s ? void 0 : $9052383c1c4e5569$var$s.href.substring(0, 1e3);
    return {
        r: $9052383c1c4e5569$var$Gs().substring(0, 1e3),
        u: r ? $9052383c1c4e5569$var$Fs(r, i, $9052383c1c4e5569$var$Us) : void 0
    };
}
function $9052383c1c4e5569$var$Ys(t) {
    var e, { r: i, u: r } = t, s = {
        $referrer: i,
        $referring_domain: null == i ? void 0 : i == $9052383c1c4e5569$var$qs ? $9052383c1c4e5569$var$qs : null == (e = $9052383c1c4e5569$var$Cs(i)) ? void 0 : e.host
    };
    if (r) {
        s.$current_url = r;
        var n = $9052383c1c4e5569$var$Cs(r);
        s.$host = null == n ? void 0 : n.host, s.$pathname = null == n ? void 0 : n.pathname;
        var o = $9052383c1c4e5569$var$Bs(r);
        $9052383c1c4e5569$var$lr(s, o);
    }
    if (i) {
        var a = $9052383c1c4e5569$var$Hs(i);
        $9052383c1c4e5569$var$lr(s, a);
    }
    return s;
}
function $9052383c1c4e5569$var$Js() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (t) {
        return;
    }
}
function $9052383c1c4e5569$var$Ks() {
    try {
        return (new Date).getTimezoneOffset();
    } catch (t) {
        return;
    }
}
var $9052383c1c4e5569$var$Xs = {
    flags: $9052383c1c4e5569$var$Mi,
    surveys: $9052383c1c4e5569$var$Pi
}, $9052383c1c4e5569$var$Qs = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
], $9052383c1c4e5569$var$Zs = "main";
class $9052383c1c4e5569$var$tn {
    constructor(e, i, r){
        if (void 0 === r && (r = !0), this.mr = {}, this.yr = !1, this.br = !1, this.qt = e, this._r = r, this.props = {}, this.wr = !1, this.kr = ((t)=>{
            var e = "";
            return t.token && (e = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), t.persistence_name ? "ph_" + t.persistence_name : "ph_" + e + "_posthog";
        })(e), this.nr = this.Sr(e), this.br = this.Cr(e), this.load(), e.debug && $9052383c1c4e5569$var$We.info("Persistence loaded", e.persistence, $9052383c1c4e5569$var$f({}, this.props)), this.update_config(e, e, i), this.save(), $9052383c1c4e5569$var$t) {
            var s = ()=>this.flush();
            $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$t, "beforeunload", s, {
                capture: !1
            }), $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$t, "pagehide", s, {
                capture: !1
            });
        }
    }
    Ir() {
        var t, e = null == (t = this.qt) ? void 0 : t.persistence_save_debounce_ms;
        return $9052383c1c4e5569$var$V(e) && e > 0 ? e : 0;
    }
    isDisabled() {
        return !!this.Tr;
    }
    Sr(e) {
        -1 === $9052383c1c4e5569$var$Qs.indexOf(e.persistence.toLowerCase()) && ($9052383c1c4e5569$var$We.critical("Unknown persistence type " + e.persistence + "; falling back to localStorage+cookie"), e.persistence = "localStorage+cookie");
        var i, r = function(e, i) {
            void 0 === e && (e = []), void 0 === i && (i = !1);
            var r = [
                ...$9052383c1c4e5569$var$Pr,
                ...e
            ];
            return $9052383c1c4e5569$var$f({}, $9052383c1c4e5569$var$Rr, {
                F (t) {
                    try {
                        var e = {};
                        try {
                            e = $9052383c1c4e5569$var$Tr.F(t) || {};
                        } catch (t) {}
                        var r, s = JSON.parse($9052383c1c4e5569$var$Rr.A(t) || "{}");
                        if (i) {
                            var n = {};
                            for(var o in e){
                                var a = e[o];
                                $9052383c1c4e5569$var$B(a) || "" === a || (n[o] = a);
                            }
                            r = $9052383c1c4e5569$var$lr(s, n);
                        } else r = $9052383c1c4e5569$var$lr(e, s);
                        return $9052383c1c4e5569$var$Rr.N(t, r), r;
                    } catch (t) {}
                    return null;
                },
                N (t, e, i, s, n, o) {
                    var a = $9052383c1c4e5569$var$Rr.N(t, e, void 0, void 0, o);
                    try {
                        var l = {};
                        r.forEach((t)=>{
                            e[t] && (l[t] = e[t]);
                        }), Object.keys(l).length && $9052383c1c4e5569$var$Tr.N(t, l, i, s, n, o);
                    } catch (t) {
                        $9052383c1c4e5569$var$Rr.D(t);
                    }
                    return a;
                },
                q (e, i) {
                    try {
                        null == $9052383c1c4e5569$var$t || $9052383c1c4e5569$var$t.localStorage.removeItem(e), $9052383c1c4e5569$var$Tr.q(e, i);
                    } catch (t) {
                        $9052383c1c4e5569$var$Rr.D(t);
                    }
                }
            });
        }(e.cookie_persisted_properties || [], e.__preview_cookie_wins_on_conflict || !1), s = !1, n = e.persistence.toLowerCase();
        return "localstorage" === n && $9052383c1c4e5569$var$Rr.O() ? (i = $9052383c1c4e5569$var$Rr, s = !0) : "localstorage+cookie" === n && r.O() ? (i = r, s = !0) : "sessionstorage" === n && $9052383c1c4e5569$var$Ar.O() ? i = $9052383c1c4e5569$var$Ar : "memory" === n ? i = $9052383c1c4e5569$var$Ir : "cookie" === n ? i = $9052383c1c4e5569$var$Tr : r.O() ? (i = r, s = !0) : i = $9052383c1c4e5569$var$Tr, this.yr = s, i;
    }
    Er(t) {
        return this.kr + "__" + t;
    }
    Cr(t) {
        return this.yr && !!t.split_storage;
    }
    Mr(t) {
        var e = null != t ? t : this.qt.feature_flag_cache_ttl_ms;
        if (!e || 0 >= e) return !1;
        var i = this.props[$9052383c1c4e5569$var$Mi];
        return !i || "number" != typeof i || Date.now() - i > e;
    }
    properties() {
        var t = {};
        return $9052383c1c4e5569$var$ar(this.props, (e, i)=>{
            var r = $9052383c1c4e5569$var$Is(i);
            if ("derived" === (null == r ? void 0 : r.exposure)) {
                if (null != r.shouldSkipFromEventProperties && r.shouldSkipFromEventProperties(e, i === $9052383c1c4e5569$var$mi ? ()=>this.Mr() : ()=>!1)) return;
                r.transformToEventProperties && $9052383c1c4e5569$var$lr(t, r.transformToEventProperties(e));
            } else if (!r || "event" === r.exposure) {
                if (null != r && null != r.shouldSkipFromEventProperties && r.shouldSkipFromEventProperties(e, ()=>!1)) return;
                t[i] = e;
            }
        }), t;
    }
    load() {
        if (!this.Tr) {
            var t = this.nr.F(this.kr);
            t && (this.props = $9052383c1c4e5569$var$lr({}, t)), this.br && this.Rr();
        }
    }
    Rr() {
        for (var t of $9052383c1c4e5569$var$Rs){
            var e = $9052383c1c4e5569$var$Rr.F(this.Er(t));
            if (e && !$9052383c1c4e5569$var$L(e)) {
                var i = this.Pr(t);
                i.persisted = !0, this.Or(t) || (i.fingerprint = this.Lr(e, t)), this.Ar(t, e) || $9052383c1c4e5569$var$lr(this.props, e);
            }
        }
    }
    Or(t) {
        return Object.keys(this.props).some((e)=>{
            var i;
            return (null == (i = $9052383c1c4e5569$var$Is(e)) ? void 0 : i.storageGroup) === t;
        });
    }
    Ar(t, e) {
        var i = $9052383c1c4e5569$var$Xs[t];
        if (!i) return !1;
        var r = e[i], s = this.props[i];
        return $9052383c1c4e5569$var$V(r) && $9052383c1c4e5569$var$V(s) && s > r;
    }
    refreshKey(t) {
        var e;
        if (!this.Tr) {
            var i = this.br ? null == (e = $9052383c1c4e5569$var$Is(t)) ? void 0 : e.storageGroup : void 0, r = i ? $9052383c1c4e5569$var$Rr.F(this.Er(i)) : this.nr.F(this.kr);
            if (r && t in r) this.Fr(t, r[t]);
            else {
                if (i) {
                    var s = this.nr.F(this.kr);
                    if (s && t in s) return void this.Fr(t, s[t]);
                }
                this.Nr(t);
            }
        }
    }
    save() {
        if (!this.Tr) {
            var t = this.Ir();
            t > 0 ? $9052383c1c4e5569$var$U(this.Dr) && (this.Dr = setTimeout(()=>{
                this.Dr = void 0, this.$r();
            }, t)) : this.$r();
        }
    }
    flush() {
        $9052383c1c4e5569$var$U(this.Dr) || (clearTimeout(this.Dr), this.Dr = void 0, this.$r());
    }
    $r() {
        this.Tr || (this.br ? this.qr() : this.jr(this.nr, this.kr, this.props, $9052383c1c4e5569$var$Zs));
    }
    qr() {
        var { main: t, groups: e } = this.Br();
        for (var i of (this.jr(this.nr, this.kr, t, $9052383c1c4e5569$var$Zs), $9052383c1c4e5569$var$Rs)){
            var r, s = e[i];
            (!$9052383c1c4e5569$var$L(s) || null != (r = this.mr[i]) && r.persisted) && this.jr($9052383c1c4e5569$var$Rr, this.Er(i), s, i);
        }
    }
    Br() {
        var t = {}, e = {};
        for (var i of $9052383c1c4e5569$var$Rs)e[i] = {};
        return $9052383c1c4e5569$var$ar(this.props, (i, r)=>{
            var s, n = null == (s = $9052383c1c4e5569$var$Is(r)) ? void 0 : s.storageGroup;
            n ? e[n][r] = i : t[r] = i;
        }), {
            main: t,
            groups: e
        };
    }
    Lr(t, e) {
        if (e === $9052383c1c4e5569$var$Zs) return JSON.stringify(t) + "|" + this.Hr + "|" + this.Ur + "|" + this.zr;
        var i = {};
        return $9052383c1c4e5569$var$ar(t, (t, e)=>{
            var r;
            i[e] = null != (r = $9052383c1c4e5569$var$Is(e)) && r.volatile ? "__volatile__" : t;
        }), JSON.stringify(i);
    }
    jr(t, e, i, r) {
        var s = this.Pr(r);
        if (r === $9052383c1c4e5569$var$Zs || s.dirty || $9052383c1c4e5569$var$U(s.fingerprint)) {
            var n;
            try {
                if ((n = this.Lr(i, r)) === s.fingerprint) return void (s.dirty = !1);
            } catch (t) {
                n = void 0;
            }
            t.N(e, i, this.Hr, this.Ur, this.zr, this.qt.debug) ? (s.dirty = !1, r !== $9052383c1c4e5569$var$Zs && (s.persisted = !0), $9052383c1c4e5569$var$U(n) || (s.fingerprint = n)) : this.qt.debug && $9052383c1c4e5569$var$We.warn('failed to persist storage entry "' + e + '"; will retry on next save');
        }
    }
    remove(t) {
        var { keepGroupEntries: e = !1 } = void 0 === t ? {} : t;
        if ($9052383c1c4e5569$var$U(this.Dr) || (clearTimeout(this.Dr), this.Dr = void 0), this.nr.q(this.kr, !1), this.nr.q(this.kr, !0), !e && this._r) for (var i of $9052383c1c4e5569$var$Rs)$9052383c1c4e5569$var$Rr.q(this.Er(i));
        e ? delete this.mr[$9052383c1c4e5569$var$Zs] : this.mr = {};
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(t, e, i) {
        if ($9052383c1c4e5569$var$N(t)) {
            $9052383c1c4e5569$var$U(e) && (e = "None"), this.Hr = $9052383c1c4e5569$var$U(i) ? this.Vr : i;
            var r = !1;
            if ($9052383c1c4e5569$var$ar(t, (t, i)=>{
                this.props.hasOwnProperty(i) && this.props[i] !== e || (this.Fr(i, t), r = !0);
            }), r) return this.save(), !0;
        }
        return !1;
    }
    register(t, e) {
        if ($9052383c1c4e5569$var$N(t)) {
            this.Hr = $9052383c1c4e5569$var$U(e) ? this.Vr : e;
            var i = !1;
            if ($9052383c1c4e5569$var$ar(t, (e, r)=>{
                t.hasOwnProperty(r) && this.props[r] !== e && (this.Fr(r, e), i = !0);
            }), i) return this.save(), !0;
        }
        return !1;
    }
    unregister(t) {
        t in this.props && (this.Nr(t), this.save());
    }
    update_campaign_params() {
        if (!this.wr) {
            var t = $9052383c1c4e5569$var$zs(this.qt.custom_campaign_params, this.qt.mask_personal_data_properties, this.qt.custom_personal_data_properties);
            $9052383c1c4e5569$var$L($9052383c1c4e5569$var$vr(t)) || this.register(t), this.wr = !0;
        }
    }
    update_search_keyword() {
        var t;
        this.register((t = null == $9052383c1c4e5569$var$r ? void 0 : $9052383c1c4e5569$var$r.referrer) ? $9052383c1c4e5569$var$Hs(t) : {});
    }
    update_referrer_info() {
        var t;
        this.register_once({
            $referrer: $9052383c1c4e5569$var$Gs(),
            $referring_domain: null != $9052383c1c4e5569$var$r && $9052383c1c4e5569$var$r.referrer && (null == (t = $9052383c1c4e5569$var$Cs($9052383c1c4e5569$var$r.referrer)) ? void 0 : t.host) || $9052383c1c4e5569$var$qs
        }, void 0);
    }
    set_initial_person_info() {
        this.props[$9052383c1c4e5569$var$Ui] || this.props[$9052383c1c4e5569$var$ji] || this.register_once({
            [$9052383c1c4e5569$var$zi]: $9052383c1c4e5569$var$Ws(this.qt.mask_personal_data_properties, this.qt.custom_personal_data_properties)
        }, void 0);
    }
    get_initial_props() {
        var t = {};
        $9052383c1c4e5569$var$ar([
            $9052383c1c4e5569$var$ji,
            $9052383c1c4e5569$var$Ui
        ], (e)=>{
            var i = this.props[e];
            i && $9052383c1c4e5569$var$ar(i, function(e, i) {
                t["$initial_" + $9052383c1c4e5569$var$I(i)] = e;
            });
        });
        var e, i, r = this.props[$9052383c1c4e5569$var$zi];
        if (r) {
            var s = (e = $9052383c1c4e5569$var$Ys(r), i = {}, $9052383c1c4e5569$var$ar(e, function(t, e) {
                i["$initial_" + $9052383c1c4e5569$var$I(e)] = t;
            }), i);
            $9052383c1c4e5569$var$lr(t, s);
        }
        return t;
    }
    safe_merge(t) {
        return $9052383c1c4e5569$var$ar(this.props, function(e, i) {
            i in t || (t[i] = e);
        }), t;
    }
    update_config(t, e, i) {
        this.Vr = this.Hr = t.cookie_expiration, this.set_disabled(t.disable_persistence || !!i), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie);
        var r = t.persistence !== e.persistence || !((t, e)=>{
            if (t.length !== e.length) return !1;
            var i = [
                ...t
            ].sort(), r = [
                ...e
            ].sort();
            return i.every((t, e)=>t === r[e]);
        })(t.cookie_persisted_properties || [], e.cookie_persisted_properties || []), s = r ? this.Sr(t) : this.nr, n = this.Cr(t);
        if (r || n !== this.br) {
            var o = this.props;
            this.clear(), this.nr = s, this.br = n, this.props = o, this.save();
        }
    }
    set_disabled(t) {
        this.Tr = t, this.Tr ? this.remove() : this.save();
    }
    set_cross_subdomain(t) {
        t !== this.Ur && (this.Ur = t, this.remove({
            keepGroupEntries: !0
        }), this.save());
    }
    set_secure(t) {
        t !== this.zr && (this.zr = t, this.remove({
            keepGroupEntries: !0
        }), this.save());
    }
    set_event_timer(t, e) {
        var i = this.props[$9052383c1c4e5569$var$ti] || {};
        i[t] = e, this.Fr($9052383c1c4e5569$var$ti, i), this.save();
    }
    remove_event_timer(t) {
        var e = this.props[$9052383c1c4e5569$var$ti] || {}, i = e[t];
        return $9052383c1c4e5569$var$U(i) || (delete e[t], this.Fr($9052383c1c4e5569$var$ti, e), this.save()), i;
    }
    get_property(t) {
        return this.props[t];
    }
    set_property(t, e) {
        this.Fr(t, e), this.save();
    }
    Fr(t, e) {
        var i;
        this.props[t] = e, null != (i = $9052383c1c4e5569$var$Is(t)) && i.volatile || this.Wr(t);
    }
    Nr(t) {
        delete this.props[t], this.Wr(t);
    }
    Wr(t) {
        var e, i = null == (e = $9052383c1c4e5569$var$Is(t)) ? void 0 : e.storageGroup;
        i && (this.Pr(i).dirty = !0);
    }
    Pr(t) {
        return this.mr[t] || (this.mr[t] = {});
    }
}
var $9052383c1c4e5569$export$352273f853caad57 = {
    Activation: "events",
    Cancellation: "cancelEvents"
}, $9052383c1c4e5569$export$87f1e68f1b904cbb = {
    Button: "button",
    Tab: "tab",
    Selector: "selector"
}, $9052383c1c4e5569$export$8c0ce98316e43193 = {
    TopLeft: "top_left",
    TopRight: "top_right",
    TopCenter: "top_center",
    MiddleLeft: "middle_left",
    MiddleRight: "middle_right",
    MiddleCenter: "middle_center",
    Left: "left",
    Center: "center",
    Right: "right",
    NextToTrigger: "next_to_trigger"
}, $9052383c1c4e5569$export$3693bed37a847924 = {
    Top: "top",
    Left: "left",
    Right: "right",
    Bottom: "bottom"
}, $9052383c1c4e5569$export$22779822dd24228f = {
    Popover: "popover",
    API: "api",
    Widget: "widget",
    ExternalSurvey: "external_survey"
}, $9052383c1c4e5569$export$9c2ac61661d417f8 = {
    Open: "open",
    MultipleChoice: "multiple_choice",
    SingleChoice: "single_choice",
    Rating: "rating",
    Link: "link"
}, $9052383c1c4e5569$export$bbed2da3bd3bb001 = {
    NextQuestion: "next_question",
    End: "end",
    ResponseBased: "response_based",
    SpecificQuestion: "specific_question"
}, $9052383c1c4e5569$export$407ee791fe918359 = {
    Once: "once",
    Recurring: "recurring",
    Always: "always"
}, $9052383c1c4e5569$export$9d7ec1793ca1658e = {
    SHOWN: "survey shown",
    DISMISSED: "survey dismissed",
    SENT: "survey sent",
    ABANDONED: "survey abandoned"
}, $9052383c1c4e5569$export$fe4c9af525341543 = {
    SURVEY_ID: "$survey_id",
    SURVEY_NAME: "$survey_name",
    SURVEY_RESPONSE: "$survey_response",
    SURVEY_ITERATION: "$survey_iteration",
    SURVEY_ITERATION_START_DATE: "$survey_iteration_start_date",
    SURVEY_PARTIALLY_COMPLETED: "$survey_partially_completed",
    SURVEY_SUBMISSION_ID: "$survey_submission_id",
    SURVEY_QUESTIONS: "$survey_questions",
    SURVEY_COMPLETED: "$survey_completed",
    PRODUCT_TOUR_ID: "$product_tour_id",
    SURVEY_LAST_SEEN_DATE: "$survey_last_seen_date",
    SURVEY_LANGUAGE: "$survey_language"
}, $9052383c1c4e5569$export$a8a66d9d1b857494 = {
    Popover: "popover",
    Inline: "inline"
}, $9052383c1c4e5569$export$8f14e1a0dc415d5d = {
    backgroundColor: "#ffffff",
    textColor: "#1d1f27",
    buttonColor: "#1d1f27",
    borderRadius: 8,
    buttonBorderRadius: 6,
    borderColor: "#e5e7eb",
    fontFamily: "system-ui",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    showOverlay: !0,
    whiteLabel: !1,
    dismissOnClickOutside: !0,
    zIndex: 2147483646
}, $9052383c1c4e5569$export$e5d0052c1e47bfda = {
    SHOWN: "product tour shown",
    DISMISSED: "product tour dismissed",
    COMPLETED: "product tour completed",
    STEP_SHOWN: "product tour step shown",
    STEP_COMPLETED: "product tour step completed",
    BUTTON_CLICKED: "product tour button clicked",
    STEP_SELECTOR_FAILED: "product tour step selector failed",
    BANNER_CONTAINER_SELECTOR_FAILED: "product tour banner container selector failed",
    BANNER_ACTION_CLICKED: "product tour banner action clicked"
}, $9052383c1c4e5569$export$eedf6d13bc23d767 = {
    TOUR_ID: "$product_tour_id",
    TOUR_NAME: "$product_tour_name",
    TOUR_ITERATION: "$product_tour_iteration",
    TOUR_RENDER_REASON: "$product_tour_render_reason",
    TOUR_STEP_ID: "$product_tour_step_id",
    TOUR_STEP_ORDER: "$product_tour_step_order",
    TOUR_STEP_TYPE: "$product_tour_step_type",
    TOUR_DISMISS_REASON: "$product_tour_dismiss_reason",
    TOUR_BUTTON_TEXT: "$product_tour_button_text",
    TOUR_BUTTON_ACTION: "$product_tour_button_action",
    TOUR_BUTTON_LINK: "$product_tour_button_link",
    TOUR_BUTTON_TOUR_ID: "$product_tour_button_tour_id",
    TOUR_STEPS_COUNT: "$product_tour_steps_count",
    TOUR_STEP_SELECTOR: "$product_tour_step_selector",
    TOUR_STEP_SELECTOR_FOUND: "$product_tour_step_selector_found",
    TOUR_STEP_ELEMENT_TAG: "$product_tour_step_element_tag",
    TOUR_STEP_ELEMENT_ID: "$product_tour_step_element_id",
    TOUR_STEP_ELEMENT_CLASSES: "$product_tour_step_element_classes",
    TOUR_STEP_ELEMENT_TEXT: "$product_tour_step_element_text",
    TOUR_ERROR: "$product_tour_error",
    TOUR_MATCHES_COUNT: "$product_tour_matches_count",
    TOUR_FAILURE_PHASE: "$product_tour_failure_phase",
    TOUR_WAITED_FOR_ELEMENT: "$product_tour_waited_for_element",
    TOUR_WAIT_DURATION_MS: "$product_tour_wait_duration_ms",
    TOUR_BANNER_SELECTOR: "$product_tour_banner_selector",
    TOUR_LINKED_SURVEY_ID: "$product_tour_linked_survey_id",
    USE_MANUAL_SELECTOR: "$use_manual_selector",
    INFERENCE_DATA_PRESENT: "$inference_data_present",
    TOUR_LAST_SEEN_DATE: "$product_tour_last_seen_date",
    TOUR_TYPE: "$product_tour_type"
}, $9052383c1c4e5569$var$_n = $9052383c1c4e5569$var$Ye("[RateLimiter]");
class $9052383c1c4e5569$var$gn {
    constructor(t){
        this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t)=>{
            var e = t.text;
            if (e && e.length) try {
                (JSON.parse(e).quota_limited || []).forEach((t)=>{
                    $9052383c1c4e5569$var$_n.info((t || "events") + " is quota limited."), this.serverLimits[t] = (new Date).getTime() + 6e4;
                });
            } catch (t) {
                return void $9052383c1c4e5569$var$_n.warn('could not rate limit - continuing. Error: "' + (null == t ? void 0 : t.message) + '"', {
                    text: e
                });
            }
        }, this.instance = t, this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    get captureEventsPerSecond() {
        var t;
        return (null == (t = this.instance.config.rate_limiting) ? void 0 : t.events_per_second) || 10;
    }
    get captureEventsBurstLimit() {
        var t;
        return Math.max((null == (t = this.instance.config.rate_limiting) ? void 0 : t.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond);
    }
    clientRateLimitContext(t) {
        var e, i, r;
        void 0 === t && (t = !1);
        var { captureEventsBurstLimit: s, captureEventsPerSecond: n } = this, o = (new Date).getTime(), a = null !== (e = null == (i = this.instance.persistence) ? void 0 : i.get_property($9052383c1c4e5569$var$Li)) && void 0 !== e ? e : {
            tokens: s,
            last: o
        };
        a.tokens += (o - a.last) / 1e3 * n, a.last = o, a.tokens > s && (a.tokens = s);
        var l = 1 > a.tokens;
        return l || t || (a.tokens = Math.max(0, a.tokens - 1)), !l || this.lastEventRateLimited || t || this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to " + n + " events per second and " + s + " events burst limit."
        }, {
            skip_client_rate_limiting: !0
        }), this.lastEventRateLimited = l, null == (r = this.instance.persistence) || r.set_property($9052383c1c4e5569$var$Li, a), {
            isRateLimited: l,
            remainingTokens: a.tokens
        };
    }
    isServerRateLimited(t) {
        var e = this.serverLimits[t || "events"] || !1;
        return !1 !== e && (new Date).getTime() < e;
    }
}
var $9052383c1c4e5569$var$mn = $9052383c1c4e5569$var$Ye("[RemoteConfig]");
class $9052383c1c4e5569$var$bn {
    constructor(t){
        this._instance = t;
    }
    get remoteConfig() {
        var t;
        return null == (t = $9052383c1c4e5569$var$h._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.config;
    }
    Gr(t) {
        var e, i;
        null != (e = $9052383c1c4e5569$var$h.__PosthogExtensions__) && e.loadExternalDependency ? null == (i = $9052383c1c4e5569$var$h.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, "remote-config", ()=>t(this.remoteConfig)) : t();
    }
    Zr(t) {
        this._instance._send_request({
            method: "GET",
            url: this._instance.requestRouter.endpointFor("assets", "/array/" + this._instance.config.token + "/config"),
            callback (e) {
                t(e.json);
            }
        });
    }
    load() {
        try {
            if (this.remoteConfig) return $9052383c1c4e5569$var$mn.info("Using preloaded remote config", this.remoteConfig), this.Qr(this.remoteConfig), void this.Jr();
            if (this._instance.Kr()) return void $9052383c1c4e5569$var$mn.warn("Remote config is disabled. Falling back to local config.");
            this.Gr((t)=>{
                if (!t) return $9052383c1c4e5569$var$mn.info("No config found after loading remote JS config. Falling back to JSON."), void this.Zr((t)=>{
                    this.Qr(t), this.Jr();
                });
                this.Qr(t), this.Jr();
            });
        } catch (t) {
            $9052383c1c4e5569$var$mn.error("Error loading remote config", t);
        }
    }
    stop() {
        this.Yr && (clearInterval(this.Yr), this.Yr = void 0);
    }
    refresh() {
        !this._instance.Kr() && $9052383c1c4e5569$var$r && "hidden" !== $9052383c1c4e5569$var$r.visibilityState && this._instance.reloadFeatureFlags();
    }
    Jr() {
        var t;
        if (!this.Yr) {
            var e = null !== (t = this._instance.config.remote_config_refresh_interval_ms) && void 0 !== t ? t : 3e5;
            0 !== e && (this.Yr = setInterval(()=>{
                this.refresh();
            }, e));
        }
    }
    Qr(t) {
        var e;
        t || $9052383c1c4e5569$var$mn.error("Failed to fetch remote config from PostHog."), this._instance.Qr(null != t ? t : {}), !1 !== (null == t ? void 0 : t.hasFeatureFlags) && (this._instance.config.advanced_disable_feature_flags_on_first_load || null == (e = this._instance.featureFlags) || e.ensureFlagsLoaded());
    }
}
var $9052383c1c4e5569$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
], $9052383c1c4e5569$export$6a00d17b5aff0af = {
    GZipJS: "gzip-js",
    Base64: "base64"
}, $9052383c1c4e5569$var$xn = Uint8Array, $9052383c1c4e5569$var$En = Uint16Array, $9052383c1c4e5569$var$Sn = Uint32Array, $9052383c1c4e5569$var$$n = new $9052383c1c4e5569$var$xn([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $9052383c1c4e5569$var$Tn = new $9052383c1c4e5569$var$xn([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $9052383c1c4e5569$var$kn = new $9052383c1c4e5569$var$xn([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $9052383c1c4e5569$var$Rn = function(t, e) {
    for(var i = new $9052383c1c4e5569$var$En(31), r = 0; 31 > r; ++r)i[r] = e += 1 << t[r - 1];
    var s = new $9052383c1c4e5569$var$Sn(i[30]);
    for(r = 1; 30 > r; ++r)for(var n = i[r]; i[r + 1] > n; ++n)s[n] = n - i[r] << 5 | r;
    return [
        i,
        s
    ];
}, $9052383c1c4e5569$var$Pn = $9052383c1c4e5569$var$Rn($9052383c1c4e5569$var$$n, 2), $9052383c1c4e5569$var$On = $9052383c1c4e5569$var$Pn[1];
$9052383c1c4e5569$var$Pn[0][28] = 258, $9052383c1c4e5569$var$On[258] = 28;
for(var $9052383c1c4e5569$var$In = $9052383c1c4e5569$var$Rn($9052383c1c4e5569$var$Tn, 0)[1], $9052383c1c4e5569$var$Cn = new $9052383c1c4e5569$var$En(32768), $9052383c1c4e5569$var$An = 0; 32768 > $9052383c1c4e5569$var$An; ++$9052383c1c4e5569$var$An){
    var $9052383c1c4e5569$var$Fn = (43690 & $9052383c1c4e5569$var$An) >>> 1 | (21845 & $9052383c1c4e5569$var$An) << 1;
    $9052383c1c4e5569$var$Cn[$9052383c1c4e5569$var$An] = ((65280 & ($9052383c1c4e5569$var$Fn = (61680 & ($9052383c1c4e5569$var$Fn = (52428 & $9052383c1c4e5569$var$Fn) >>> 2 | (13107 & $9052383c1c4e5569$var$Fn) << 2)) >>> 4 | (3855 & $9052383c1c4e5569$var$Fn) << 4)) >>> 8 | (255 & $9052383c1c4e5569$var$Fn) << 8) >>> 1;
}
var $9052383c1c4e5569$var$Mn = function(t, e, i) {
    for(var r = t.length, s = 0, n = new $9052383c1c4e5569$var$En(e); r > s; ++s)++n[t[s] - 1];
    var o, a = new $9052383c1c4e5569$var$En(e);
    for(s = 0; e > s; ++s)a[s] = a[s - 1] + n[s - 1] << 1;
    if (i) {
        o = new $9052383c1c4e5569$var$En(1 << e);
        var l = 15 - e;
        for(s = 0; r > s; ++s)if (t[s]) for(var u = s << 4 | t[s], h = e - t[s], d = a[t[s] - 1]++ << h, v = d | (1 << h) - 1; v >= d; ++d)o[$9052383c1c4e5569$var$Cn[d] >>> l] = u;
    } else for(o = new $9052383c1c4e5569$var$En(r), s = 0; r > s; ++s)o[s] = $9052383c1c4e5569$var$Cn[a[t[s] - 1]++] >>> 15 - t[s];
    return o;
}, $9052383c1c4e5569$var$Dn = new $9052383c1c4e5569$var$xn(288);
for($9052383c1c4e5569$var$An = 0; 144 > $9052383c1c4e5569$var$An; ++$9052383c1c4e5569$var$An)$9052383c1c4e5569$var$Dn[$9052383c1c4e5569$var$An] = 8;
for($9052383c1c4e5569$var$An = 144; 256 > $9052383c1c4e5569$var$An; ++$9052383c1c4e5569$var$An)$9052383c1c4e5569$var$Dn[$9052383c1c4e5569$var$An] = 9;
for($9052383c1c4e5569$var$An = 256; 280 > $9052383c1c4e5569$var$An; ++$9052383c1c4e5569$var$An)$9052383c1c4e5569$var$Dn[$9052383c1c4e5569$var$An] = 7;
for($9052383c1c4e5569$var$An = 280; 288 > $9052383c1c4e5569$var$An; ++$9052383c1c4e5569$var$An)$9052383c1c4e5569$var$Dn[$9052383c1c4e5569$var$An] = 8;
var $9052383c1c4e5569$var$Nn = new $9052383c1c4e5569$var$xn(32);
for($9052383c1c4e5569$var$An = 0; 32 > $9052383c1c4e5569$var$An; ++$9052383c1c4e5569$var$An)$9052383c1c4e5569$var$Nn[$9052383c1c4e5569$var$An] = 5;
var $9052383c1c4e5569$var$Ln = $9052383c1c4e5569$var$Mn($9052383c1c4e5569$var$Dn, 9, 0), $9052383c1c4e5569$var$Un = $9052383c1c4e5569$var$Mn($9052383c1c4e5569$var$Nn, 5, 0), $9052383c1c4e5569$var$jn = function(t) {
    return (t / 8 >> 0) + (7 & t && 1);
}, $9052383c1c4e5569$var$zn = function(t, e, i) {
    (null == i || i > t.length) && (i = t.length);
    var r = new (t instanceof $9052383c1c4e5569$var$En ? $9052383c1c4e5569$var$En : t instanceof $9052383c1c4e5569$var$Sn ? $9052383c1c4e5569$var$Sn : $9052383c1c4e5569$var$xn)(i - e);
    return r.set(t.subarray(e, i)), r;
}, $9052383c1c4e5569$var$Bn = function(t, e, i) {
    var r = e / 8 >> 0;
    t[r] |= i <<= 7 & e, t[r + 1] |= i >>> 8;
}, $9052383c1c4e5569$var$Hn = function(t, e, i) {
    var r = e / 8 >> 0;
    t[r] |= i <<= 7 & e, t[r + 1] |= i >>> 8, t[r + 2] |= i >>> 16;
}, $9052383c1c4e5569$var$Vn = function(t, e) {
    for(var i = [], r = 0; t.length > r; ++r)t[r] && i.push({
        s: r,
        f: t[r]
    });
    var s = i.length, n = i.slice();
    if (!s) return [
        new $9052383c1c4e5569$var$xn(0),
        0
    ];
    if (1 == s) {
        var o = new $9052383c1c4e5569$var$xn(i[0].s + 1);
        return o[i[0].s] = 1, [
            o,
            1
        ];
    }
    i.sort(function(t, e) {
        return t.f - e.f;
    }), i.push({
        s: -1,
        f: 25001
    });
    var a = i[0], l = i[1], u = 0, h = 1, d = 2;
    for(i[0] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    }; h != s - 1;)a = i[i[d].f > i[u].f ? u++ : d++], l = i[u != h && i[d].f > i[u].f ? u++ : d++], i[h++] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    };
    var v = n[0].s;
    for(r = 1; s > r; ++r)n[r].s > v && (v = n[r].s);
    var c = new $9052383c1c4e5569$var$En(v + 1), p = $9052383c1c4e5569$var$qn(i[h - 1], c, 0);
    if (p > e) {
        r = 0;
        var f = 0, _ = p - e, g = 1 << _;
        for(n.sort(function(t, e) {
            return c[e.s] - c[t.s] || t.f - e.f;
        }); s > r; ++r){
            var m = n[r].s;
            if (e >= c[m]) break;
            f += g - (1 << p - c[m]), c[m] = e;
        }
        for(f >>>= _; f > 0;){
            var b = n[r].s;
            e > c[b] ? f -= 1 << e - c[b]++ - 1 : ++r;
        }
        for(; r >= 0 && f; --r){
            var y = n[r].s;
            c[y] == e && (--c[y], ++f);
        }
        p = e;
    }
    return [
        new $9052383c1c4e5569$var$xn(c),
        p
    ];
}, $9052383c1c4e5569$var$qn = function(t, e, i) {
    return -1 == t.s ? Math.max($9052383c1c4e5569$var$qn(t.l, e, i + 1), $9052383c1c4e5569$var$qn(t.r, e, i + 1)) : e[t.s] = i;
}, $9052383c1c4e5569$var$Gn = function(t) {
    for(var e = t.length; e && !t[--e];);
    for(var i = new $9052383c1c4e5569$var$En(++e), r = 0, s = t[0], n = 1, o = function(t) {
        i[r++] = t;
    }, a = 1; e >= a; ++a)if (t[a] == s && a != e) ++n;
    else {
        if (!s && n > 2) {
            for(; n > 138; n -= 138)o(32754);
            n > 2 && (o(n > 10 ? n - 11 << 5 | 28690 : n - 3 << 5 | 12305), n = 0);
        } else if (n > 3) {
            for(o(s), --n; n > 6; n -= 6)o(8304);
            n > 2 && (o(n - 3 << 5 | 8208), n = 0);
        }
        for(; n--;)o(s);
        n = 1, s = t[a];
    }
    return [
        i.subarray(0, r),
        e
    ];
}, $9052383c1c4e5569$var$Wn = function(t, e) {
    for(var i = 0, r = 0; e.length > r; ++r)i += t[r] * e[r];
    return i;
}, $9052383c1c4e5569$var$Yn = function(t, e, i) {
    var r = i.length, s = $9052383c1c4e5569$var$jn(e + 2);
    t[s] = 255 & r, t[s + 1] = r >>> 8, t[s + 2] = 255 ^ t[s], t[s + 3] = 255 ^ t[s + 1];
    for(var n = 0; r > n; ++n)t[s + n + 4] = i[n];
    return 8 * (s + 4 + r);
}, $9052383c1c4e5569$var$Jn = function(t, e, i, r, s, n, o, a, l, u, h) {
    $9052383c1c4e5569$var$Bn(e, h++, i), ++s[256];
    for(var d = $9052383c1c4e5569$var$Vn(s, 15), v = d[0], c = d[1], p = $9052383c1c4e5569$var$Vn(n, 15), f = p[0], _ = p[1], g = $9052383c1c4e5569$var$Gn(v), m = g[0], b = g[1], y = $9052383c1c4e5569$var$Gn(f), w = y[0], x = y[1], E = new $9052383c1c4e5569$var$En(19), S = 0; m.length > S; ++S)E[31 & m[S]]++;
    for(S = 0; w.length > S; ++S)E[31 & w[S]]++;
    for(var T = $9052383c1c4e5569$var$Vn(E, 7), k = T[0], R = T[1], P = 19; P > 4 && !k[$9052383c1c4e5569$var$kn[P - 1]]; --P);
    var O, I, C, A, F = u + 5 << 3, M = $9052383c1c4e5569$var$Wn(s, $9052383c1c4e5569$var$Dn) + $9052383c1c4e5569$var$Wn(n, $9052383c1c4e5569$var$Nn) + o, D = $9052383c1c4e5569$var$Wn(s, v) + $9052383c1c4e5569$var$Wn(n, f) + o + 14 + 3 * P + $9052383c1c4e5569$var$Wn(E, k) + (2 * E[16] + 3 * E[17] + 7 * E[18]);
    if (M >= F && D >= F) return $9052383c1c4e5569$var$Yn(e, h, t.subarray(l, l + u));
    if ($9052383c1c4e5569$var$Bn(e, h, 1 + (M > D)), h += 2, M > D) {
        O = $9052383c1c4e5569$var$Mn(v, c, 0), I = v, C = $9052383c1c4e5569$var$Mn(f, _, 0), A = f;
        var N = $9052383c1c4e5569$var$Mn(k, R, 0);
        for($9052383c1c4e5569$var$Bn(e, h, b - 257), $9052383c1c4e5569$var$Bn(e, h + 5, x - 1), $9052383c1c4e5569$var$Bn(e, h + 10, P - 4), h += 14, S = 0; P > S; ++S)$9052383c1c4e5569$var$Bn(e, h + 3 * S, k[$9052383c1c4e5569$var$kn[S]]);
        h += 3 * P;
        for(var L = [
            m,
            w
        ], U = 0; 2 > U; ++U){
            var j = L[U];
            for(S = 0; j.length > S; ++S)$9052383c1c4e5569$var$Bn(e, h, N[z = 31 & j[S]]), h += k[z], z > 15 && ($9052383c1c4e5569$var$Bn(e, h, j[S] >>> 5 & 127), h += j[S] >>> 12);
        }
    } else O = $9052383c1c4e5569$var$Ln, I = $9052383c1c4e5569$var$Dn, C = $9052383c1c4e5569$var$Un, A = $9052383c1c4e5569$var$Nn;
    for(S = 0; a > S; ++S)if (r[S] > 255) {
        var z;
        $9052383c1c4e5569$var$Hn(e, h, O[257 + (z = r[S] >>> 18 & 31)]), h += I[z + 257], z > 7 && ($9052383c1c4e5569$var$Bn(e, h, r[S] >>> 23 & 31), h += $9052383c1c4e5569$var$$n[z]);
        var B = 31 & r[S];
        $9052383c1c4e5569$var$Hn(e, h, C[B]), h += A[B], B > 3 && ($9052383c1c4e5569$var$Hn(e, h, r[S] >>> 5 & 8191), h += $9052383c1c4e5569$var$Tn[B]);
    } else $9052383c1c4e5569$var$Hn(e, h, O[r[S]]), h += I[r[S]];
    return $9052383c1c4e5569$var$Hn(e, h, O[256]), h + I[256];
}, $9052383c1c4e5569$var$Kn = new $9052383c1c4e5569$var$Sn([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $9052383c1c4e5569$var$Xn = function() {
    for(var t = new $9052383c1c4e5569$var$Sn(256), e = 0; 256 > e; ++e){
        for(var i = e, r = 9; --r;)i = (1 & i && 3988292384) ^ i >>> 1;
        t[e] = i;
    }
    return t;
}(), $9052383c1c4e5569$var$Qn = function(t, e, i) {
    for(; i; ++e)t[e] = i, i >>>= 8;
};
function $9052383c1c4e5569$var$Zn(t, e) {
    void 0 === e && (e = {});
    var i = function() {
        var t = 4294967295;
        return {
            p (e) {
                for(var i = t, r = 0; e.length > r; ++r)i = $9052383c1c4e5569$var$Xn[255 & i ^ e[r]] ^ i >>> 8;
                t = i;
            },
            d () {
                return 4294967295 ^ t;
            }
        };
    }(), r = t.length;
    i.p(t);
    var s, n, o, a, l, u = (a = 10 + ((s = e).filename && s.filename.length + 1 || 0), l = 8, function(t, e, i, r, s, n) {
        var o = t.length, a = new $9052383c1c4e5569$var$xn(r + o + 5 * (1 + Math.floor(o / 7e3)) + s), l = a.subarray(r, a.length - s), u = 0;
        if (!e || 8 > o) for(var h = 0; o >= h; h += 65535){
            var d = h + 65535;
            o > d ? u = $9052383c1c4e5569$var$Yn(l, u, t.subarray(h, d)) : (l[h] = !0, u = $9052383c1c4e5569$var$Yn(l, u, t.subarray(h, o)));
        }
        else {
            for(var v = $9052383c1c4e5569$var$Kn[e - 1], c = v >>> 13, p = 8191 & v, f = (1 << i) - 1, _ = new $9052383c1c4e5569$var$En(32768), g = new $9052383c1c4e5569$var$En(f + 1), m = Math.ceil(i / 3), b = 2 * m, y = function(e) {
                return (t[e] ^ t[e + 1] << m ^ t[e + 2] << b) & f;
            }, w = new $9052383c1c4e5569$var$Sn(25e3), x = new $9052383c1c4e5569$var$En(288), E = new $9052383c1c4e5569$var$En(32), S = 0, T = 0, k = (h = 0, 0), R = 0, P = 0; o > h; ++h){
                var O = y(h), I = 32767 & h, C = g[O];
                if (_[I] = C, g[O] = I, h >= R) {
                    var A = o - h;
                    if ((S > 7e3 || k > 24576) && A > 423) {
                        u = $9052383c1c4e5569$var$Jn(t, l, 0, w, x, E, T, k, P, h - P, u), k = S = T = 0, P = h;
                        for(var F = 0; 286 > F; ++F)x[F] = 0;
                        for(F = 0; 30 > F; ++F)E[F] = 0;
                    }
                    var M = 2, D = 0, N = p, L = I - C & 32767;
                    if (A > 2 && O == y(h - L)) for(var U = Math.min(c, A) - 1, j = Math.min(32767, h), z = Math.min(258, A); j >= L && --N && I != C;){
                        if (t[h + M] == t[h + M - L]) {
                            for(var B = 0; z > B && t[h + B] == t[h + B - L]; ++B);
                            if (B > M) {
                                if (M = B, D = L, B > U) break;
                                var H = Math.min(L, B - 2), V = 0;
                                for(F = 0; H > F; ++F){
                                    var q = h - L + F + 32768 & 32767, G = q - _[q] + 32768 & 32767;
                                    G > V && (V = G, C = q);
                                }
                            }
                        }
                        L += (I = C) - (C = _[I]) + 32768 & 32767;
                    }
                    if (D) {
                        w[k++] = 268435456 | $9052383c1c4e5569$var$On[M] << 18 | $9052383c1c4e5569$var$In[D];
                        var W = 31 & $9052383c1c4e5569$var$On[M], Y = 31 & $9052383c1c4e5569$var$In[D];
                        T += $9052383c1c4e5569$var$$n[W] + $9052383c1c4e5569$var$Tn[Y], ++x[257 + W], ++E[Y], R = h + M, ++S;
                    } else w[k++] = t[h], ++x[t[h]];
                }
            }
            u = $9052383c1c4e5569$var$Jn(t, l, !0, w, x, E, T, k, P, h - P, u);
        }
        return $9052383c1c4e5569$var$zn(a, 0, r + $9052383c1c4e5569$var$jn(u) + s);
    }(n = t, null == (o = e).level ? 6 : o.level, null == o.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(n.length)))) : 12 + o.mem, a, l)), h = u.length;
    return function(t, e) {
        var i = e.filename;
        if (t[0] = 31, t[1] = 139, t[2] = 8, t[8] = 2 > e.level ? 4 : 9 == e.level ? 2 : 0, t[9] = 3, 0 != e.mtime && $9052383c1c4e5569$var$Qn(t, 4, Math.floor(new Date(e.mtime || Date.now()) / 1e3)), i) {
            t[3] = 8;
            for(var r = 0; i.length >= r; ++r)t[r + 10] = i.charCodeAt(r);
        }
    }(u, e), $9052383c1c4e5569$var$Qn(u, h - 8, i.d()), $9052383c1c4e5569$var$Qn(u, h - 4, r), u;
}
var $9052383c1c4e5569$var$to = !!$9052383c1c4e5569$var$o || !!$9052383c1c4e5569$var$n, $9052383c1c4e5569$var$eo = "text/plain", $9052383c1c4e5569$var$io = !1, $9052383c1c4e5569$var$ro = (t, e)=>{
    var [i, r] = t.split("#"), [s, n] = i.split("?");
    if (!n) return t;
    var o = n.split("&").filter((t)=>t.split("=")[0] !== e).join("&");
    return s + (o ? "?" + o : "") + (r ? "#" + r : "");
}, $9052383c1c4e5569$var$so = function(t, e, i) {
    var r;
    void 0 === i && (i = !0);
    var [s, n] = t.split("?"), o = $9052383c1c4e5569$var$f({}, e), a = null !== (r = null == n ? void 0 : n.split("&").map((t)=>{
        var e, [r, s] = t.split("="), n = i && null !== (e = o[r]) && void 0 !== e ? e : s;
        return delete o[r], r + "=" + n;
    })) && void 0 !== r ? r : [], l = function(t, e) {
        var i, r;
        void 0 === e && (e = "&");
        var s = [];
        return $9052383c1c4e5569$var$ar(t, function(t, e) {
            $9052383c1c4e5569$var$U(t) || $9052383c1c4e5569$var$U(e) || "undefined" === e || (i = encodeURIComponent(((t)=>t instanceof File)(t) ? t.name : t.toString()), r = encodeURIComponent(e), s[s.length] = r + "=" + i);
        }), s.join(e);
    }(o);
    return l && a.push(l), s + "?" + a.join("&");
}, $9052383c1c4e5569$var$no = (t, e)=>JSON.stringify(t, (t, e)=>"bigint" == typeof e ? e.toString() : e, e), $9052383c1c4e5569$var$oo = (t)=>{
    if (t.tr) return t.tr;
    var { data: e, compression: i } = t;
    if (e) {
        if (i === $9052383c1c4e5569$export$6a00d17b5aff0af.GZipJS) {
            var r = $9052383c1c4e5569$var$Zn(function(t, e) {
                var i = t.length;
                if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t);
                for(var r = new $9052383c1c4e5569$var$xn(t.length + (t.length >>> 1)), s = 0, n = function(t) {
                    r[s++] = t;
                }, o = 0; i > o; ++o){
                    if (s + 5 > r.length) {
                        var a = new $9052383c1c4e5569$var$xn(s + 8 + (i - o << 1));
                        a.set(r), r = a;
                    }
                    var l = t.charCodeAt(o);
                    128 > l ? n(l) : 2048 > l ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && 57344 > l ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & t.charCodeAt(++o)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
                }
                return $9052383c1c4e5569$var$zn(r, 0, s);
            }($9052383c1c4e5569$var$no(e)), {
                mtime: 0
            });
            return {
                contentType: $9052383c1c4e5569$var$eo,
                body: r.buffer.slice(r.byteOffset, r.byteOffset + r.byteLength),
                estimatedSize: r.byteLength
            };
        }
        if (i === $9052383c1c4e5569$export$6a00d17b5aff0af.Base64) {
            var s = function(t) {
                return t ? btoa(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g, (t, e)=>String.fromCharCode(parseInt(e, 16)))) : t;
            }($9052383c1c4e5569$var$no(e)), n = ((t)=>"data=" + encodeURIComponent("string" == typeof t ? t : $9052383c1c4e5569$var$no(t)))(s);
            return {
                contentType: "application/x-www-form-urlencoded",
                body: n,
                estimatedSize: new Blob([
                    n
                ]).size
            };
        }
        var o = $9052383c1c4e5569$var$no(e);
        return {
            contentType: "application/json",
            body: o,
            estimatedSize: new Blob([
                o
            ]).size
        };
    }
}, $9052383c1c4e5569$var$ao = (t)=>{
    var e, i, r, s = $9052383c1c4e5569$var$oo(t);
    return !s || (i = t.compression, r = $9052383c1c4e5569$var$As(t.url, "compression"), i !== $9052383c1c4e5569$var$m.GZipJS && r !== $9052383c1c4e5569$var$m.GZipJS && "gzip" !== r) || ((e = s.body) instanceof ArrayBuffer ? $9052383c1c4e5569$var$w(new Uint8Array(e)) : ArrayBuffer.isView(e) && $9052383c1c4e5569$var$w(new Uint8Array(e.buffer, e.byteOffset, e.byteLength))) ? {
        url: t.url,
        encodedBody: s
    } : ($9052383c1c4e5569$var$io = !0, {
        url: $9052383c1c4e5569$var$ro(t.url, "compression"),
        encodedBody: $9052383c1c4e5569$var$oo($9052383c1c4e5569$var$f({}, t, {
            compression: void 0,
            tr: void 0
        }))
    });
}, $9052383c1c4e5569$var$lo = function() {
    var t = $9052383c1c4e5569$var$p(function*(t) {
        var e = $9052383c1c4e5569$var$no(t.data), i = yield function(t, e, i) {
            return $9052383c1c4e5569$var$T.apply(this, arguments);
        }(e, $9052383c1c4e5569$var$v.DEBUG, {
            rethrow: !0
        });
        if (!i) return t;
        var r = yield i.arrayBuffer();
        return $9052383c1c4e5569$var$f({}, t, {
            tr: {
                contentType: $9052383c1c4e5569$var$eo,
                body: r,
                estimatedSize: r.byteLength
            }
        });
    });
    return function(e) {
        return t.apply(this, arguments);
    };
}(), $9052383c1c4e5569$var$uo = (t, e)=>$9052383c1c4e5569$var$so(t, {
        _: (new Date).getTime().toString(),
        ver: $9052383c1c4e5569$var$v.JS_SDK_VERSION,
        compression: e
    }), $9052383c1c4e5569$var$ho = [];
$9052383c1c4e5569$var$n && $9052383c1c4e5569$var$ho.push({
    transport: "fetch",
    method (t) {
        var e, { url: i, encodedBody: r } = $9052383c1c4e5569$var$ao(t), { contentType: s, body: o, estimatedSize: l } = null != r ? r : {}, u = new Headers;
        $9052383c1c4e5569$var$ar(t.headers, function(t, e) {
            u.append(e, t);
        }), s && u.append("Content-Type", s);
        var h = null;
        if ($9052383c1c4e5569$var$a) {
            var d = new $9052383c1c4e5569$var$a;
            h = {
                signal: d.signal,
                timeout: setTimeout(()=>d.abort(), t.timeout)
            };
        }
        $9052383c1c4e5569$var$n(i, $9052383c1c4e5569$var$f({
            method: (null == t ? void 0 : t.method) || "GET",
            headers: u,
            keepalive: "POST" === t.method && 52428.8 > (l || 0),
            body: o,
            signal: null == (e = h) ? void 0 : e.signal
        }, t.fetchOptions)).then((e)=>e.text().then((i)=>{
                var r = {
                    statusCode: e.status,
                    text: i
                };
                if (200 === e.status) try {
                    r.json = JSON.parse(i);
                } catch (t) {
                    $9052383c1c4e5569$var$We.error(t);
                }
                null == t.callback || t.callback(r);
            })).catch((e)=>{
            $9052383c1c4e5569$var$We.error(e), null == t.callback || t.callback({
                statusCode: 0,
                error: e
            });
        }).finally(()=>h ? clearTimeout(h.timeout) : null);
    }
}), $9052383c1c4e5569$var$o && $9052383c1c4e5569$var$ho.push({
    transport: "XHR",
    method (t) {
        var e = new $9052383c1c4e5569$var$o, { url: i, encodedBody: r } = $9052383c1c4e5569$var$ao(t);
        e.open(t.method || "GET", i, !0);
        var { contentType: s, body: n } = null != r ? r : {};
        $9052383c1c4e5569$var$ar(t.headers, function(t, i) {
            e.setRequestHeader(i, t);
        }), s && e.setRequestHeader("Content-Type", s), t.timeout && (e.timeout = t.timeout), e.onreadystatechange = ()=>{
            if (4 === e.readyState) {
                var i = {
                    statusCode: e.status,
                    text: e.responseText
                };
                if (200 === e.status) try {
                    i.json = JSON.parse(e.responseText);
                } catch (t) {}
                null == t.callback || t.callback(i);
            }
        }, e.send(n);
    }
}), null != $9052383c1c4e5569$var$i && $9052383c1c4e5569$var$i.sendBeacon && $9052383c1c4e5569$var$ho.push({
    transport: "sendBeacon",
    method (t) {
        try {
            var { url: e, encodedBody: r } = $9052383c1c4e5569$var$ao(t), s = $9052383c1c4e5569$var$so(e, {
                beacon: "1"
            }), { contentType: n, body: o } = null != r ? r : {};
            if (!o) return;
            var a = o instanceof Blob ? o : new Blob([
                o
            ], {
                type: n
            });
            $9052383c1c4e5569$var$i.sendBeacon(s, a);
        } catch (t) {}
    }
});
var $9052383c1c4e5569$var$vo = 3e3;
class $9052383c1c4e5569$var$co {
    constructor(t, e){
        this.Xr = !0, this.ei = [], this.ti = $9052383c1c4e5569$var$et((null == e ? void 0 : e.flush_interval_ms) || $9052383c1c4e5569$var$vo, 250, 5e3, $9052383c1c4e5569$var$We.createLogger("flush interval"), $9052383c1c4e5569$var$vo), this.ri = t;
    }
    enqueue(t) {
        this.ei.push(t), this.ii || this.ni();
    }
    unload() {
        this.si();
        var t = this.ei.length > 0 ? this.oi() : {}, e = Object.values(t);
        [
            ...e.filter((t)=>0 === t.url.indexOf("/e")),
            ...e.filter((t)=>0 !== t.url.indexOf("/e"))
        ].map((t)=>{
            this.ri($9052383c1c4e5569$var$f({}, t, {
                transport: "sendBeacon"
            }));
        });
    }
    enable() {
        this.Xr = !1, this.ni();
    }
    ni() {
        var t = this;
        this.Xr || (this.ii = setTimeout(()=>{
            if (this.si(), this.ei.length > 0) {
                var e = this.oi(), i = function() {
                    var i = e[r], s = (new Date).getTime();
                    i.data && $9052383c1c4e5569$var$M(i.data) && $9052383c1c4e5569$var$ar(i.data, (t)=>{
                        t.offset = Math.abs(t.timestamp - s), delete t.timestamp;
                    }), t.ri(i);
                };
                for(var r in e)i();
            }
        }, this.ti));
    }
    si() {
        clearTimeout(this.ii), this.ii = void 0;
    }
    oi() {
        var t = {};
        return $9052383c1c4e5569$var$ar(this.ei, (e)=>{
            var i, r = e, s = (r ? r.batchKey : null) || r.url;
            $9052383c1c4e5569$var$U(t[s]) && (t[s] = $9052383c1c4e5569$var$f({}, r, {
                data: []
            })), null == (i = t[s].data) || i.push(r.data);
        }), this.ei = [], t;
    }
}
var $9052383c1c4e5569$var$po = [
    "retriesPerformedSoFar"
];
class $9052383c1c4e5569$var$fo {
    constructor(e){
        this.ai = !1, this.li = 3e3, this.ei = [], this._instance = e, this.ei = [], this.ui = !0, !$9052383c1c4e5569$var$U($9052383c1c4e5569$var$t) && "onLine" in $9052383c1c4e5569$var$t.navigator && (this.ui = $9052383c1c4e5569$var$t.navigator.onLine, this.hi = ()=>{
            this.ui = !0, this.ci();
        }, this.di = ()=>{
            this.ui = !1;
        }, $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$t, "online", this.hi), $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$t, "offline", this.di));
    }
    get length() {
        return this.ei.length;
    }
    retriableRequest(t) {
        var { retriesPerformedSoFar: e } = t, i = $9052383c1c4e5569$var$_(t, $9052383c1c4e5569$var$po);
        $9052383c1c4e5569$var$q(e) && (i.url = $9052383c1c4e5569$var$so(i.url, {
            retry_count: e
        })), this._instance._send_request($9052383c1c4e5569$var$f({}, i, {
            callback: (t)=>{
                200 === t.statusCode || t.statusCode >= 400 && 500 > t.statusCode || (null != e ? e : 0) >= 10 ? null == i.callback || i.callback(t) : this.vi($9052383c1c4e5569$var$f({
                    retriesPerformedSoFar: e
                }, i));
            }
        }));
    }
    vi(t) {
        var e = t.retriesPerformedSoFar || 0;
        t.retriesPerformedSoFar = e + 1;
        var i = function(t) {
            var e = 3e3 * Math.pow(2, t), i = e / 2, r = Math.min(18e5, e), s = Math.random() - .5;
            return Math.ceil(r + s * (r - i));
        }(e), r = Date.now() + i;
        this.ei.push({
            retryAt: r,
            requestOptions: t
        });
        var s = "Enqueued failed request for retry in " + i;
        navigator.onLine || (s += " (Browser is offline)"), $9052383c1c4e5569$var$We.warn(s), this.ai || (this.ai = !0, this.fi());
    }
    fi() {
        if (this.pi && clearTimeout(this.pi), 0 === this.ei.length) return this.ai = !1, void (this.pi = void 0);
        this.pi = setTimeout(()=>{
            this.ui && this.ei.length > 0 && this.ci(), this.fi();
        }, this.li);
    }
    ci() {
        var t = Date.now(), e = [], i = this.ei.filter((i)=>t > i.retryAt || (e.push(i), !1));
        if (this.ei = e, i.length > 0) for (var { requestOptions: r } of i)this.retriableRequest(r);
    }
    unload() {
        for (var { requestOptions: e } of (this.pi && (clearTimeout(this.pi), this.pi = void 0), this.ai = !1, $9052383c1c4e5569$var$U($9052383c1c4e5569$var$t) || (this.hi && ($9052383c1c4e5569$var$t.removeEventListener("online", this.hi), this.hi = void 0), this.di && ($9052383c1c4e5569$var$t.removeEventListener("offline", this.di), this.di = void 0)), this.ei))try {
            this._instance._send_request($9052383c1c4e5569$var$f({}, e, {
                transport: "sendBeacon"
            }));
        } catch (t) {
            $9052383c1c4e5569$var$We.error(t);
        }
        this.ei = [];
    }
}
class $9052383c1c4e5569$var$_o {
    constructor(t){
        this.gi = ()=>{
            var t, e, i, r;
            this.mi || (this.mi = {});
            var s = this.scrollElement(), n = this.scrollY(), o = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, a = n + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
            this.mi.lastScrollY = Math.ceil(n), this.mi.maxScrollY = Math.max(n, null !== (t = this.mi.maxScrollY) && void 0 !== t ? t : 0), this.mi.maxScrollHeight = Math.max(o, null !== (e = this.mi.maxScrollHeight) && void 0 !== e ? e : 0), this.mi.lastContentY = a, this.mi.maxContentY = Math.max(a, null !== (i = this.mi.maxContentY) && void 0 !== i ? i : 0), this.mi.maxContentHeight = Math.max(l, null !== (r = this.mi.maxContentHeight) && void 0 !== r ? r : 0);
        }, this._instance = t;
    }
    get yi() {
        return this._instance.config.scroll_root_selector;
    }
    getContext() {
        return this.mi;
    }
    resetContext() {
        var t = this.mi;
        return setTimeout(this.gi, 0), t;
    }
    startMeasuringScrollPosition() {
        $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$t, "scroll", this.gi, {
            capture: !0
        }), $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$t, "scrollend", this.gi, {
            capture: !0
        }), $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$t, "resize", this.gi);
    }
    scrollElement() {
        if (!this.yi) return null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.document.documentElement;
        var e = $9052383c1c4e5569$var$M(this.yi) ? this.yi : [
            this.yi
        ];
        for (var i of e){
            var r = null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.document.querySelector(i);
            if (r) return r;
        }
    }
    bi(e) {
        var i = "y" === e ? "scrollTop" : "scrollLeft";
        if (this.yi) {
            var r = this.scrollElement();
            return r && r[i] || 0;
        }
        return $9052383c1c4e5569$var$t ? "y" === e ? $9052383c1c4e5569$var$t.scrollY || $9052383c1c4e5569$var$t.pageYOffset || $9052383c1c4e5569$var$t.document.documentElement.scrollTop || 0 : $9052383c1c4e5569$var$t.scrollX || $9052383c1c4e5569$var$t.pageXOffset || $9052383c1c4e5569$var$t.document.documentElement.scrollLeft || 0 : 0;
    }
    scrollY() {
        return this.bi("y");
    }
    scrollX() {
        return this.bi("x");
    }
}
var $9052383c1c4e5569$var$go = (t)=>$9052383c1c4e5569$var$Ws(null == t ? void 0 : t.config.mask_personal_data_properties, null == t ? void 0 : t.config.custom_personal_data_properties);
class $9052383c1c4e5569$var$mo {
    constructor(t, e, i, r){
        this.wi = (t)=>{
            var e = this.xi();
            if (!e || e.sessionId !== t) {
                var i = {
                    sessionId: t,
                    props: this.ki(this._instance)
                };
                this.Si.register({
                    [$9052383c1c4e5569$var$Ni]: i
                });
            }
        }, this._instance = t, this.Ci = e, this.Si = i, this.ki = r || $9052383c1c4e5569$var$go, this.Ci.onSessionId(this.wi);
    }
    xi() {
        return this.Si.props[$9052383c1c4e5569$var$Ni];
    }
    getSetOnceProps() {
        var t, e = null == (t = this.xi()) ? void 0 : t.props;
        return e ? "r" in e ? $9052383c1c4e5569$var$Ys(e) : {
            $referring_domain: e.referringDomain,
            $pathname: e.initialPathName,
            utm_source: e.utm_source,
            utm_campaign: e.utm_campaign,
            utm_medium: e.utm_medium,
            utm_content: e.utm_content,
            utm_term: e.utm_term
        } : {};
    }
    getSessionProps() {
        var t = {};
        return $9052383c1c4e5569$var$ar($9052383c1c4e5569$var$vr(this.getSetOnceProps()), (e, i)=>{
            "$current_url" === i && (i = "url"), t["$session_entry_" + $9052383c1c4e5569$var$I(i)] = e;
        }), t;
    }
}
class $9052383c1c4e5569$var$bo {
    constructor(){
        this.Ii = {};
    }
    on(t, e) {
        return this.Ii[t] || (this.Ii[t] = []), this.Ii[t].push(e), ()=>{
            this.Ii[t] = this.Ii[t].filter((t)=>t !== e);
        };
    }
    emit(t, e) {
        for (var i of this.Ii[t] || [])i(e);
        for (var r of this.Ii["*"] || [])r(t, e);
    }
}
var $9052383c1c4e5569$var$yo = $9052383c1c4e5569$var$Ye("[SessionId]");
class $9052383c1c4e5569$var$wo {
    on(t, e) {
        return this.Ti.on(t, e);
    }
    constructor(t, e, i){
        var r;
        if (this.Ei = null, this.Mi = [], this.Ri = void 0, this.Pi = !1, this.Ti = new $9052383c1c4e5569$var$bo, this.Oi = (t, e)=>!(!$9052383c1c4e5569$var$q(t) || !$9052383c1c4e5569$var$q(e)) && Math.abs(t - e) > this.sessionTimeoutMs, !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if (t.config.cookieless_mode === $9052383c1c4e5569$var$Ki) throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
        this.qt = t.config, this.Si = t.persistence, this.Li = void 0, this.Ai = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.Fi = e || $9052383c1c4e5569$var$xr, this.Ni = i || $9052383c1c4e5569$var$xr;
        var s = this.qt.persistence_name || this.qt.token;
        if (this._sessionTimeoutMs = 1e3 * $9052383c1c4e5569$var$et(this.qt.session_idle_timeout_seconds || 1800, 60, 36e3, $9052383c1c4e5569$var$yo.createLogger("session_idle_timeout_seconds"), 1800), t.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.Di(), this.$i = "ph_" + s + "_window_id", this.qi = "ph_" + s + "_primary_window_exists", this.ji()) {
            var n = $9052383c1c4e5569$var$Ar.F(this.$i), o = $9052383c1c4e5569$var$Ar.F(this.qi);
            n && !o ? this.Li = n : $9052383c1c4e5569$var$Ar.q(this.$i), $9052383c1c4e5569$var$Ar.N(this.qi, !0);
        }
        if (null != (r = this.qt.bootstrap) && r.sessionID) try {
            var a = ((t)=>{
                var e = this.qt.bootstrap.sessionID.replace(/-/g, "");
                if (32 !== e.length) throw new Error("Not a valid UUID");
                if ("7" !== e[12]) throw new Error("Not a UUIDv7");
                return parseInt(e.substring(0, 12), 16);
            })();
            this.Bi(this.qt.bootstrap.sessionID, (new Date).getTime(), a);
        } catch (t) {
            $9052383c1c4e5569$var$yo.error("Invalid sessionID in bootstrap", t);
        }
        this.Hi();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(t) {
        return $9052383c1c4e5569$var$U(this.Mi) && (this.Mi = []), this.Mi.push(t), this.Ai && t(this.Ai, this.Li), ()=>{
            this.Mi = this.Mi.filter((e)=>e !== t);
        };
    }
    ji() {
        return "memory" !== this.qt.persistence && !this.Si.Tr && $9052383c1c4e5569$var$Ar.O();
    }
    Ui(t) {
        t !== this.Li && (this.Li = t, this.ji() && $9052383c1c4e5569$var$Ar.N(this.$i, t));
    }
    zi() {
        return this.Li ? this.Li : this.ji() ? $9052383c1c4e5569$var$Ar.F(this.$i) : null;
    }
    Vi(t) {
        var e = this.Ei;
        return !$9052383c1c4e5569$var$B(e) && !$9052383c1c4e5569$var$B(t) && 5e3 > Math.abs(t - e);
    }
    Bi(t, e, i) {
        var r = e !== this._sessionActivityTimestamp, s = !(t !== this.Ai || i !== this._sessionStartTimestamp);
        this._sessionStartTimestamp = i, this._sessionActivityTimestamp = e, this.Ai = t, s && !r || s && this.Vi(e) || (this.Ei = e, this.Si.register({
            [$9052383c1c4e5569$var$_i]: [
                e,
                t,
                i
            ]
        }));
    }
    Wi() {
        var t, e = null == (t = this.qt) ? void 0 : t.persistence_save_debounce_ms;
        return $9052383c1c4e5569$var$q(e) && e > 0;
    }
    Gi() {
        this.Wi() ? this.Si.refreshKey($9052383c1c4e5569$var$_i) : (this.Si.flush(), this.Si.load());
    }
    Zi() {
        var t;
        if (!$9052383c1c4e5569$var$B(this._sessionActivityTimestamp) && this._sessionActivityTimestamp !== this.Ei) {
            this.Gi();
            var [, e, i] = this.Qi();
            e === this.Ai && i === this._sessionStartTimestamp && (this.Ei = this._sessionActivityTimestamp, this.Si.register({
                [$9052383c1c4e5569$var$_i]: [
                    this._sessionActivityTimestamp,
                    null !== (t = this.Ai) && void 0 !== t ? t : null,
                    this._sessionStartTimestamp
                ]
            }), this.Si.flush());
        }
    }
    Ji() {
        var [t] = this.Qi(), e = $9052383c1c4e5569$var$q(t) ? t : 0, i = $9052383c1c4e5569$var$q(this._sessionActivityTimestamp) ? this._sessionActivityTimestamp : 0;
        return Math.max(e, i);
    }
    Ki(t) {
        return this.Gi(), this.Oi(t, this.Ji());
    }
    Qi() {
        var t = this.Si.props[$9052383c1c4e5569$var$_i];
        return $9052383c1c4e5569$var$M(t) && 2 === t.length && t.push(t[0]), t || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this.Ei = null, clearTimeout(this.Yi), this.Yi = void 0, this.Bi(null, null, null);
    }
    destroy() {
        this.Pi = !0, this.Zi(), clearTimeout(this.Yi), this.Yi = void 0, this.Ri && $9052383c1c4e5569$var$t && ($9052383c1c4e5569$var$t.removeEventListener($9052383c1c4e5569$var$er, this.Ri, {
            capture: !1
        }), this.Ri = void 0), this.Mi = [];
    }
    Hi() {
        this.Ri = ()=>{
            this.Zi(), this.ji() && $9052383c1c4e5569$var$Ar.q(this.qi);
        }, $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$t, $9052383c1c4e5569$var$er, this.Ri, {
            capture: !1
        });
    }
    checkAndGetSessionAndWindowId(t, e) {
        if (void 0 === t && (t = !1), void 0 === e && (e = null), this.qt.cookieless_mode === $9052383c1c4e5569$var$Ki) throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
        var i = e || (new Date).getTime(), [, r, s] = this.Qi(), n = this.Ji(), o = this.zi(), a = $9052383c1c4e5569$var$q(s) && Math.abs(i - s) > 864e5, l = !1, u = !1, h = !r, d = r, v = !h && !t && this.Oi(i, n);
        v && ((v = this.Ki(i)) || $9052383c1c4e5569$var$yo.info("cross-tab refresh kept the session alive", {
            sessionId: r
        }), [, r, s] = this.Qi()), h || v || a ? (r = this.Fi(), o = this.Ni(), $9052383c1c4e5569$var$yo.info("new session ID generated", {
            sessionId: r,
            windowId: o,
            changeReason: {
                noSessionId: h,
                activityTimeout: v,
                sessionPastMaximumLength: a
            }
        }), s = i, l = !0) : (o || (o = this.Ni(), l = !0), (u = r !== d) && ($9052383c1c4e5569$var$yo.info("adopted cross-tab session id", {
            sessionId: r,
            windowId: o
        }), l = !0));
        var c = $9052383c1c4e5569$var$q(n) && t && !a ? n : i, p = $9052383c1c4e5569$var$q(s) ? s : (new Date).getTime();
        this.Ui(o), this.Bi(r, c, p), t || this.Di();
        var f = {
            noSessionId: h,
            activityTimeout: v,
            sessionPastMaximumLength: a,
            crossTabAdoption: u
        };
        return l && this.Mi.forEach((t)=>t(r, o, f)), {
            sessionId: r,
            windowId: o,
            sessionStartTimestamp: p,
            changeReason: l ? f : void 0,
            lastActivityTimestamp: n
        };
    }
    Di() {
        this.Pi || (clearTimeout(this.Yi), this.Yi = setTimeout(()=>{
            if (!this.Pi) {
                if (this.Ki((new Date).getTime())) {
                    var t = this.Ai;
                    this.resetSessionId(), this.Ti.emit("forcedIdleReset", {
                        idleSessionId: t
                    });
                } else this.Di();
            }
        }, 1.1 * this.sessionTimeoutMs));
    }
}
var $9052383c1c4e5569$var$xo = function(t, e) {
    if (!t) return !1;
    var i = t.userAgent;
    if (i && $9052383c1c4e5569$var$R(i, e)) return !0;
    try {
        var r = null == t ? void 0 : t.userAgentData;
        if (null != r && r.brands && r.brands.some((t)=>$9052383c1c4e5569$var$R(null == t ? void 0 : t.brand, e))) return !0;
    } catch (t) {}
    return !!t.webdriver;
}, $9052383c1c4e5569$var$Eo = function(t, e) {
    if (!function(t) {
        try {
            new RegExp(t);
        } catch (t) {
            return !1;
        }
        return !0;
    }(e)) return !1;
    try {
        return new RegExp(e).test(t);
    } catch (t) {
        return !1;
    }
};
function $9052383c1c4e5569$var$So(t, e, i) {
    return $9052383c1c4e5569$var$no({
        distinct_id: t,
        userPropertiesToSet: e,
        userPropertiesToSetOnce: i
    });
}
var $9052383c1c4e5569$var$$o = {
    exact: (t, e)=>e.some((e)=>t.some((t)=>e === t)),
    is_not: (t, e)=>e.every((e)=>t.every((t)=>e !== t)),
    regex: (t, e)=>e.some((e)=>t.some((t)=>$9052383c1c4e5569$var$Eo(e, t))),
    not_regex: (t, e)=>e.every((e)=>t.every((t)=>!$9052383c1c4e5569$var$Eo(e, t))),
    icontains: (t, e)=>e.map($9052383c1c4e5569$var$To).some((e)=>t.map($9052383c1c4e5569$var$To).some((t)=>e.includes(t))),
    not_icontains: (t, e)=>e.map($9052383c1c4e5569$var$To).every((e)=>t.map($9052383c1c4e5569$var$To).every((t)=>!e.includes(t))),
    gt: (t, e)=>e.some((e)=>{
            var i = parseFloat(e);
            return !isNaN(i) && t.some((t)=>i > parseFloat(t));
        }),
    lt: (t, e)=>e.some((e)=>{
            var i = parseFloat(e);
            return !isNaN(i) && t.some((t)=>i < parseFloat(t));
        })
}, $9052383c1c4e5569$var$To = (t)=>t.toLowerCase();
function $9052383c1c4e5569$var$ko(t, e) {
    return !t || Object.entries(t).every((t)=>{
        var [i, r] = t, s = null == e ? void 0 : e[i];
        if ($9052383c1c4e5569$var$U(s) || $9052383c1c4e5569$var$B(s)) return !1;
        var n = [
            String(s)
        ], o = $9052383c1c4e5569$var$$o[r.operator];
        return !!o && o(r.values, n);
    });
}
var $9052383c1c4e5569$var$Ro = "custom", $9052383c1c4e5569$var$Po = "i.posthog.com", $9052383c1c4e5569$var$Oo = /^\/static\//;
class $9052383c1c4e5569$var$Io {
    constructor(t){
        this.Xi = {}, this.instance = t;
    }
    get apiHost() {
        var t = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === t ? "https://us.i.posthog.com" : t;
    }
    get flagsApiHost() {
        var t = this.instance.config.flags_api_host;
        return t ? t.trim().replace(/\/$/, "") : this.apiHost;
    }
    get uiHost() {
        var t, e = null == (t = this.instance.config.ui_host) ? void 0 : t.replace(/\/$/, "");
        return e || (e = this.apiHost.replace("." + $9052383c1c4e5569$var$Po, ".posthog.com")), "https://app.posthog.com" === e ? "https://us.posthog.com" : e;
    }
    get region() {
        return this.Xi[this.apiHost] || (this.Xi[this.apiHost] = /https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? "us" : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? "eu" : $9052383c1c4e5569$var$Ro), this.Xi[this.apiHost];
    }
    en(t) {
        if ($9052383c1c4e5569$var$Oo.test(t)) {
            var e = this.instance.config.asset_host;
            if ("string" == typeof e) return e.trim().replace(/\/$/, "") || void 0;
        }
    }
    endpointFor(t, e) {
        if (void 0 === e && (e = ""), e && (e = "/" === e[0] ? e : "/" + e), "ui" === t) return this.uiHost + e;
        if ("flags" === t) return this.flagsApiHost + e;
        if ("assets" === t) {
            var i = this.en(e);
            if (i) return "" + i + e;
        }
        if (this.region === $9052383c1c4e5569$var$Ro) return this.apiHost + e;
        var r = $9052383c1c4e5569$var$Po + e;
        switch(t){
            case "assets":
                return "https://" + this.region + "-assets." + r;
            case "api":
                return "https://" + this.region + "." + r;
        }
    }
}
var $9052383c1c4e5569$var$Co = $9052383c1c4e5569$var$Ye("[Surveys]"), $9052383c1c4e5569$var$Ao = "seenSurvey_", $9052383c1c4e5569$var$Fo = [
    $9052383c1c4e5569$export$22779822dd24228f.Popover,
    $9052383c1c4e5569$export$22779822dd24228f.Widget,
    $9052383c1c4e5569$export$22779822dd24228f.API
], $9052383c1c4e5569$var$Mo = {
    ignoreConditions: !1,
    ignoreDelay: !1,
    displayType: $9052383c1c4e5569$export$a8a66d9d1b857494.Popover
}, $9052383c1c4e5569$var$Do = $9052383c1c4e5569$var$Ye("[PostHog ExternalIntegrations]"), $9052383c1c4e5569$var$No = {
    intercom: "intercom-integration",
    crispChat: "crisp-chat-integration"
};
class $9052383c1c4e5569$var$Lo {
    constructor(t){
        this._instance = t;
    }
    ur(t, e) {
        var i;
        null == (i = $9052383c1c4e5569$var$h.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, t, (t)=>{
            if (t) return $9052383c1c4e5569$var$Do.error("failed to load script", t);
            e();
        });
    }
    startIfEnabledOrStop() {
        var t = this, e = function(e) {
            var i, s, n;
            !r || null != (i = $9052383c1c4e5569$var$h.__PosthogExtensions__) && null != (i = i.integrations) && i[e] || t.ur($9052383c1c4e5569$var$No[e], ()=>{
                var i;
                null == (i = $9052383c1c4e5569$var$h.__PosthogExtensions__) || null == (i = i.integrations) || null == (i = i[e]) || i.start(t._instance);
            }), !r && null != (s = $9052383c1c4e5569$var$h.__PosthogExtensions__) && null != (s = s.integrations) && s[e] && (null == (n = $9052383c1c4e5569$var$h.__PosthogExtensions__) || null == (n = n.integrations) || null == (n = n[e]) || n.stop());
        };
        for (var [i, r] of Object.entries(null !== (s = this._instance.config.integrations) && void 0 !== s ? s : {})){
            var s;
            e(i);
        }
    }
}
var $9052383c1c4e5569$var$Uo, $9052383c1c4e5569$var$jo = {}, $9052383c1c4e5569$var$zo = 0, $9052383c1c4e5569$var$Bo = ()=>{}, $9052383c1c4e5569$var$Ho = 'Consent opt in/out is not valid with cookieless_mode="always" and will be ignored', $9052383c1c4e5569$var$Vo = "Surveys module not available", $9052383c1c4e5569$var$qo = "sanitize_properties is deprecated. Use before_send instead", $9052383c1c4e5569$var$Go = "Invalid value for property_denylist config: ", $9052383c1c4e5569$var$Wo = "posthog", $9052383c1c4e5569$var$Yo = !$9052383c1c4e5569$var$to && -1 === (null == $9052383c1c4e5569$var$u ? void 0 : $9052383c1c4e5569$var$u.indexOf("MSIE")) && -1 === (null == $9052383c1c4e5569$var$u ? void 0 : $9052383c1c4e5569$var$u.indexOf("Mozilla")), $9052383c1c4e5569$var$Jo = (e)=>{
    var i;
    return $9052383c1c4e5569$var$f({
        api_host: "https://us.i.posthog.com",
        flags_api_host: null,
        ui_host: null,
        asset_host: null,
        token: "",
        autocapture: !0,
        cross_subdomain_cookie: $9052383c1c4e5569$var$pr(null == $9052383c1c4e5569$var$r ? void 0 : $9052383c1c4e5569$var$r.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        cookie_persisted_properties: [],
        loaded: $9052383c1c4e5569$var$Bo,
        save_campaign_params: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageleave: "if_capture_pageview",
        defaults: null != e ? e : "unset",
        __preview_deferred_init_extensions: !1,
        __preview_external_dependency_versioned_paths: !1,
        __preview_cookie_wins_on_conflict: !1,
        debug: $9052383c1c4e5569$var$s && $9052383c1c4e5569$var$j(null == $9052383c1c4e5569$var$s ? void 0 : $9052383c1c4e5569$var$s.search) && -1 !== $9052383c1c4e5569$var$s.search.indexOf("__posthog_debug=true") || !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        disable_surveys_automatic_display: !1,
        disable_conversations: !1,
        disable_product_tours: !1,
        disable_external_dependency_loading: !1,
        strict_script_versioning: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $9052383c1c4e5569$var$t || null == (i = $9052383c1c4e5569$var$t.location) ? void 0 : i.protocol),
        ip: !1,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        consent_persistence_name: null,
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        request_batching: !0,
        properties_string_max_length: 65535,
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        mask_personal_data_properties: !1,
        custom_personal_data_properties: [],
        advanced_disable_flags: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_only_evaluate_survey_feature_flags: !1,
        advanced_feature_flags_dedup_per_session: !1,
        advanced_enable_surveys: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        surveys_request_timeout_ms: 1e4,
        on_request_error (t) {
            $9052383c1c4e5569$var$We.error("Bad HTTP status: " + t.statusCode + " " + t.text);
        },
        get_device_id: (t)=>t,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: $9052383c1c4e5569$var$Zi,
        before_send: void 0,
        request_queue_config: {
            flush_interval_ms: $9052383c1c4e5569$var$vo
        },
        error_tracking: {},
        _onCapture: $9052383c1c4e5569$var$Bo
    }, ((t)=>({
            rageclick: t && t >= "2026-05-30" ? {
                content_ignorelist: $9052383c1c4e5569$var$Zr,
                ignore_text_selection: !0
            } : !t || "2025-11-30" > t || {
                content_ignorelist: !0
            },
            capture_pageview: !t || "2025-05-24" > t || "history_change",
            session_recording: t && t >= "2025-11-30" ? {
                strictMinimumDuration: !0
            } : {},
            external_scripts_inject_target: t && t >= "2026-01-30" ? "head" : "body",
            internal_or_test_user_hostname: t && t >= "2026-01-30" ? /^(localhost|127\.0\.0\.1)$/ : void 0,
            persistence_save_debounce_ms: t && t >= "2026-05-30" ? 250 : 0,
            split_storage: !(!t || "2026-05-30" > t),
            detect_google_search_app: !(!t || "2026-05-30" > t)
        }))(e));
}, $9052383c1c4e5569$var$Ko = [
    [
        "process_person",
        "person_profiles"
    ],
    [
        "xhr_headers",
        "request_headers"
    ],
    [
        "cookie_name",
        "persistence_name"
    ],
    [
        "disable_cookie",
        "disable_persistence"
    ],
    [
        "__preview_disable_beacon",
        "disable_beacon"
    ],
    [
        "store_google",
        "save_campaign_params"
    ],
    [
        "verbose",
        "debug"
    ]
], $9052383c1c4e5569$var$Xo = (t)=>{
    var e = {};
    for (var [i, r] of $9052383c1c4e5569$var$Ko)$9052383c1c4e5569$var$U(t[i]) || (e[r] = t[i]);
    var s = $9052383c1c4e5569$var$lr({}, e, t), n = t.__preview_external_dependency_versioned_paths;
    return $9052383c1c4e5569$var$U(n) || ($9052383c1c4e5569$var$U(t.strict_script_versioning) && (s.strict_script_versioning = !!n), $9052383c1c4e5569$var$j(n) && $9052383c1c4e5569$var$U(t.asset_host) && (s.asset_host = n)), $9052383c1c4e5569$var$M(t.property_blacklist) && ($9052383c1c4e5569$var$U(t.property_denylist) ? s.property_denylist = t.property_blacklist : $9052383c1c4e5569$var$M(t.property_denylist) ? s.property_denylist = [
        ...t.property_blacklist,
        ...t.property_denylist
    ] : $9052383c1c4e5569$var$We.error($9052383c1c4e5569$var$Go + t.property_denylist)), s;
};
class $9052383c1c4e5569$var$Qo {
    constructor(){
        this.__forceAllowLocalhost = !1;
    }
    get tn() {
        return this.__forceAllowLocalhost;
    }
    set tn(t) {
        $9052383c1c4e5569$var$We.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
    }
}
class $9052383c1c4e5569$export$a9d6b9cbf49b8241 {
    rn(t, e) {
        if (t) {
            var i = this.nn.indexOf(t);
            -1 !== i && this.nn.splice(i, 1);
        }
        return this.nn.push(e), null == e.initialize || e.initialize(), e;
    }
    sn() {
        return this.config.cookieless_mode === $9052383c1c4e5569$var$Ki || this.config.cookieless_mode === $9052383c1c4e5569$var$Ji && this.consent.isRejected();
    }
    get decideEndpointWasHit() {
        var t, e;
        return null !== (t = null == (e = this.featureFlags) ? void 0 : e.hasLoadedFlags) && void 0 !== t && t;
    }
    get flagsEndpointWasHit() {
        var t, e;
        return null !== (t = null == (e = this.featureFlags) ? void 0 : e.hasLoadedFlags) && void 0 !== t && t;
    }
    constructor(){
        var t;
        this.webPerformance = new $9052383c1c4e5569$var$Qo, this.an = !1, this.version = $9052383c1c4e5569$var$v.LIB_VERSION, this.ln = new $9052383c1c4e5569$var$bo, this.nn = [], this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = $9052383c1c4e5569$var$Jo(), this.SentryIntegration = $9052383c1c4e5569$var$Ts, this.sentryIntegration = (t)=>(function(t, e) {
                var i = $9052383c1c4e5569$var$$s(t, e);
                return {
                    name: $9052383c1c4e5569$var$Ss,
                    processEvent: (t)=>i(t)
                };
            })(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.un = !1, this.hn = null, this.cn = null, this.dn = null, this.scrollManager = new $9052383c1c4e5569$var$_o(this), this.pageViewManager = new $9052383c1c4e5569$var$ks(this), this.rateLimiter = new $9052383c1c4e5569$var$gn(this), this.requestRouter = new $9052383c1c4e5569$var$Io(this), this.consent = new $9052383c1c4e5569$var$Fr(this), this.externalIntegrations = new $9052383c1c4e5569$var$Lo(this);
        var e = null !== (t = $9052383c1c4e5569$export$a9d6b9cbf49b8241.__defaultExtensionClasses) && void 0 !== t ? t : {};
        this.featureFlags = e.featureFlags && new e.featureFlags(this), this.toolbar = e.toolbar && new e.toolbar(this), this.surveys = e.surveys && new e.surveys(this), this.conversations = e.conversations && new e.conversations(this), this.logs = e.logs && new e.logs(this), this.experiments = e.experiments && new e.experiments(this), this.exceptions = e.exceptions && new e.exceptions(this), this.people = {
            set: (t, e, i)=>{
                var r = $9052383c1c4e5569$var$j(t) ? {
                    [t]: e
                } : t;
                this.setPersonProperties(r), null == i || i({});
            },
            set_once: (t, e, i)=>{
                var r = $9052383c1c4e5569$var$j(t) ? {
                    [t]: e
                } : t;
                this.setPersonProperties(void 0, r), null == i || i({});
            }
        }, this.on("eventCaptured", (t)=>$9052383c1c4e5569$var$We.info('send "' + (null == t ? void 0 : t.event) + '"', t));
    }
    init(t, e, i) {
        if (i && i !== $9052383c1c4e5569$var$Wo) {
            var r, s = null !== (r = $9052383c1c4e5569$var$jo[i]) && void 0 !== r ? r : new $9052383c1c4e5569$export$a9d6b9cbf49b8241;
            return s._init(t, e, i), $9052383c1c4e5569$var$jo[i] = s, $9052383c1c4e5569$var$jo[$9052383c1c4e5569$var$Wo][i] = s, s;
        }
        return this._init(t, e, i);
    }
    _init(e, i, r) {
        var s, n;
        void 0 === i && (i = {});
        var o = $9052383c1c4e5569$var$j(e) ? e.trim() : "";
        if (!o) return $9052383c1c4e5569$var$We.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        if (this.__loaded) return console.warn("[PostHog.js]", "You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = {}, i.debug = this.vn(i.debug), this.fn = i, this.pn = [], i.person_profiles ? this.cn = i.person_profiles : i.process_person && (this.cn = i.process_person);
        var a = $9052383c1c4e5569$var$Jo(i.defaults), l = $9052383c1c4e5569$var$Xo(i), u = $9052383c1c4e5569$var$lr({}, a, l, {
            name: r,
            token: o
        });
        $9052383c1c4e5569$var$N(a.rageclick) && $9052383c1c4e5569$var$N(l.rageclick) && (u.rageclick = $9052383c1c4e5569$var$lr({}, a.rageclick, l.rageclick)), this.set_config(u), this.config.on_xhr_error && $9052383c1c4e5569$var$We.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = i.disable_compression ? void 0 : $9052383c1c4e5569$export$6a00d17b5aff0af.GZipJS;
        var h = this.gn();
        this.persistence = new $9052383c1c4e5569$var$tn(this.config, h), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $9052383c1c4e5569$var$tn($9052383c1c4e5569$var$f({}, this.config, {
            persistence: "sessionStorage"
        }), h, !1);
        var d = $9052383c1c4e5569$var$f({}, this.persistence.props), c = $9052383c1c4e5569$var$f({}, this.sessionPersistence.props);
        this.register({
            $initialization_time: (new Date).toISOString()
        }), this.mn = new $9052383c1c4e5569$var$co((t)=>this.yn(t), this.config.request_queue_config), this.bn = new $9052383c1c4e5569$var$fo(this), this.__request_queue = [];
        var p = this.sn();
        if (p || (this.sessionManager = new $9052383c1c4e5569$var$wo(this), this.sessionPropsManager = new $9052383c1c4e5569$var$mo(this, this.sessionManager, this.persistence)), this.config.__preview_deferred_init_extensions ? ($9052383c1c4e5569$var$We.info("Deferring extension initialization to improve startup performance"), setTimeout(()=>{
            this._n(p);
        }, 0)) : ($9052383c1c4e5569$var$We.info("Initializing extensions synchronously"), this._n(p)), $9052383c1c4e5569$var$v.DEBUG = $9052383c1c4e5569$var$v.DEBUG || this.config.debug, $9052383c1c4e5569$var$v.DEBUG && $9052383c1c4e5569$var$We.info("Starting in debug mode", {
            this: this,
            config: i,
            thisC: $9052383c1c4e5569$var$f({}, this.config),
            p: d,
            s: c
        }), !this.config.identity_distinct_id || null != (s = i.bootstrap) && s.distinctID || (i.bootstrap = $9052383c1c4e5569$var$f({}, i.bootstrap, {
            distinctID: this.config.identity_distinct_id,
            isIdentifiedID: !0
        })), void 0 !== (null == (n = i.bootstrap) ? void 0 : n.distinctID)) {
            var _ = i.bootstrap.distinctID, g = this.get_distinct_id(), m = this.persistence.get_property($9052383c1c4e5569$var$Di);
            if (i.bootstrap.isIdentifiedID && null != g && g !== _ && m === $9052383c1c4e5569$var$Xi) this.identify(_);
            else if (i.bootstrap.isIdentifiedID && null != g && g !== _ && m === $9052383c1c4e5569$var$Qi) $9052383c1c4e5569$var$We.warn("Bootstrap distinctID differs from an already-identified user. The existing identity is preserved. Call reset() before reinitializing if you intend to switch users.");
            else {
                var b = this.config.get_device_id($9052383c1c4e5569$var$xr()), y = i.bootstrap.isIdentifiedID ? b : _;
                this.persistence.set_property($9052383c1c4e5569$var$Di, i.bootstrap.isIdentifiedID ? $9052383c1c4e5569$var$Qi : $9052383c1c4e5569$var$Xi), this.register({
                    distinct_id: _,
                    $device_id: y
                });
            }
        }
        if (p) this.register_once({
            distinct_id: $9052383c1c4e5569$var$Vi,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            var w = this.config.get_device_id($9052383c1c4e5569$var$xr());
            this.register_once({
                distinct_id: w,
                $device_id: w
            }, ""), this.persistence.set_property($9052383c1c4e5569$var$Di, $9052383c1c4e5569$var$Xi);
        }
        return $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$t, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), {
            passive: !1
        }), i.segment ? function(t, e) {
            var i = t.config.segment;
            if (!i) return e();
            !function(t, e) {
                var i = t.config.segment;
                if (!i) return e();
                var r = (i)=>{
                    var r = ()=>i.anonymousId() || $9052383c1c4e5569$var$xr();
                    t.config.get_device_id = r, i.id() && (t.register({
                        distinct_id: i.id(),
                        $device_id: r()
                    }), t.persistence.set_property($9052383c1c4e5569$var$Di, $9052383c1c4e5569$var$Qi)), e();
                }, s = i.user();
                "then" in s && $9052383c1c4e5569$var$D(s.then) ? s.then(r) : r(s);
            }(t, ()=>{
                i.register(((t)=>{
                    Promise && Promise.resolve || $9052383c1c4e5569$var$Es.warn("This browser does not have Promise support, and can not use the segment integration");
                    var e = (e, i)=>{
                        if (!i) return e;
                        e.event.userId || e.event.anonymousId === t.get_distinct_id() || ($9052383c1c4e5569$var$Es.info("No userId set, resetting PostHog"), t.reset()), e.event.userId && e.event.userId !== t.get_distinct_id() && ($9052383c1c4e5569$var$Es.info("UserId set, identifying with PostHog"), t.identify(e.event.userId));
                        var r = t.calculateEventProperties(i, e.event.properties);
                        return e.event.properties = Object.assign({}, r, e.event.properties), e;
                    };
                    return {
                        name: "PostHog JS",
                        type: "enrichment",
                        version: "1.0.0",
                        isLoaded: ()=>!0,
                        load: ()=>Promise.resolve(),
                        track: (t)=>e(t, t.event.event),
                        page: (t)=>e(t, $9052383c1c4e5569$var$ir),
                        identify: (t)=>e(t, $9052383c1c4e5569$var$sr),
                        screen: (t)=>e(t, "$screen")
                    };
                })(t)).then(()=>{
                    e();
                });
            });
        }(this, ()=>this.wn()) : this.wn(), $9052383c1c4e5569$var$D(this.config._onCapture) && this.config._onCapture !== $9052383c1c4e5569$var$Bo && ($9052383c1c4e5569$var$We.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (t)=>this.config._onCapture(t.event, t))), this.config.ip && $9052383c1c4e5569$var$We.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this;
    }
    _n(t) {
        var e, i, r, s, n, o, a, l = performance.now(), u = $9052383c1c4e5569$var$f({}, $9052383c1c4e5569$export$a9d6b9cbf49b8241.__defaultExtensionClasses, this.config.__extensionClasses), h = [];
        u.featureFlags && this.nn.push(this.featureFlags = null !== (e = this.featureFlags) && void 0 !== e ? e : new u.featureFlags(this)), u.exceptions && this.nn.push(this.exceptions = null !== (i = this.exceptions) && void 0 !== i ? i : new u.exceptions(this)), u.historyAutocapture && this.nn.push(this.historyAutocapture = new u.historyAutocapture(this)), u.tracingHeaders && this.nn.push(this.tracingHeaders = new u.tracingHeaders(this)), u.siteApps && this.nn.push(this.siteApps = new u.siteApps(this)), u.sessionRecording && !t && this.nn.push(this.sessionRecording = new u.sessionRecording(this)), this.config.disable_scroll_properties || h.push(()=>{
            this.scrollManager.startMeasuringScrollPosition();
        }), u.autocapture && this.nn.push(this.autocapture = new u.autocapture(this)), u.surveys && this.nn.push(this.surveys = null !== (r = this.surveys) && void 0 !== r ? r : new u.surveys(this)), u.logs && this.nn.push(this.logs = null !== (s = this.logs) && void 0 !== s ? s : new u.logs(this)), u.conversations && this.nn.push(this.conversations = null !== (n = this.conversations) && void 0 !== n ? n : new u.conversations(this)), u.productTours && this.nn.push(this.productTours = new u.productTours(this)), u.heatmaps && this.nn.push(this.heatmaps = new u.heatmaps(this)), u.webVitalsAutocapture && this.nn.push(this.webVitalsAutocapture = new u.webVitalsAutocapture(this)), u.exceptionObserver && this.nn.push(this.exceptionObserver = new u.exceptionObserver(this)), u.deadClicksAutocapture && this.nn.push(this.deadClicksAutocapture = new u.deadClicksAutocapture(this, $9052383c1c4e5569$var$ws)), u.toolbar && this.nn.push(this.toolbar = null !== (o = this.toolbar) && void 0 !== o ? o : new u.toolbar(this)), u.experiments && this.nn.push(this.experiments = null !== (a = this.experiments) && void 0 !== a ? a : new u.experiments(this)), this.nn.forEach((t)=>{
            t.initialize && h.push(()=>{
                null == t.initialize || t.initialize();
            });
        }), h.push(()=>{
            if (this.xn) {
                var t = this.xn;
                this.xn = void 0, this.Qr(t);
            }
        }), this.kn(h, l);
    }
    kn(t, e) {
        for(; t.length > 0;){
            if (this.config.__preview_deferred_init_extensions && performance.now() - e >= 30 && t.length > 0) return void setTimeout(()=>{
                this.kn(t, e);
            }, 0);
            var i = t.shift();
            if (i) try {
                i();
            } catch (t) {
                $9052383c1c4e5569$var$We.error("Error initializing extension:", t);
            }
        }
        var r = Math.round(performance.now() - e);
        this.register_for_session({
            [$9052383c1c4e5569$var$qi]: this.config.__preview_deferred_init_extensions ? "deferred" : "synchronous",
            [$9052383c1c4e5569$var$Gi]: r
        }), this.config.__preview_deferred_init_extensions && $9052383c1c4e5569$var$We.info("PostHog extensions initialized (" + r + "ms)");
    }
    Qr(t) {
        var e;
        if (!$9052383c1c4e5569$var$r || !$9052383c1c4e5569$var$r.body) return $9052383c1c4e5569$var$We.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this.Qr(t);
        }, 500);
        this.config.__preview_deferred_init_extensions && (this.xn = t), this.Sn = t, this.compression = void 0, t.supportedCompression && !this.config.disable_compression && (this.compression = $9052383c1c4e5569$var$P(t.supportedCompression, $9052383c1c4e5569$export$6a00d17b5aff0af.GZipJS) ? $9052383c1c4e5569$export$6a00d17b5aff0af.GZipJS : $9052383c1c4e5569$var$P(t.supportedCompression, $9052383c1c4e5569$export$6a00d17b5aff0af.Base64) ? $9052383c1c4e5569$export$6a00d17b5aff0af.Base64 : void 0), null != (e = t.analytics) && e.endpoint && (this.analyticsDefaultEndpoint = t.analytics.endpoint), this.set_config({
            person_profiles: this.cn ? this.cn : $9052383c1c4e5569$var$Zi
        }), this.nn.forEach((e)=>null == e.onRemoteConfig ? void 0 : e.onRemoteConfig(t));
    }
    wn() {
        try {
            this.config.loaded(this);
        } catch (t) {
            $9052383c1c4e5569$var$We.critical("`loaded` function failed", t);
        }
        if (this.Cn(), this.config.internal_or_test_user_hostname && null != $9052383c1c4e5569$var$s && $9052383c1c4e5569$var$s.hostname) {
            var t = $9052383c1c4e5569$var$s.hostname, e = this.config.internal_or_test_user_hostname;
            ("string" == typeof e ? t === e : e.test(t)) && this.setInternalOrTestUser();
        }
        this.config.capture_pageview && setTimeout(()=>{
            (this.consent.isOptedIn() || this.sn()) && this.In();
        }, 1), this.Tn = new $9052383c1c4e5569$var$bn(this), this.Tn.load();
    }
    Cn() {
        var t;
        this.is_capturing() && this.config.request_batching && (null == (t = this.mn) || t.enable());
    }
    _dom_loaded() {
        this.is_capturing() && $9052383c1c4e5569$var$or(this.__request_queue, (t)=>this.yn(t)), this.__request_queue = [], this.Cn();
    }
    _handle_unload() {
        var t, e, i, r;
        null == (t = this.surveys) || t.handlePageUnload(), this.config.request_batching ? (this.En() && this.capture($9052383c1c4e5569$var$rr), null == (e = this.logs) || e.flushLogs("sendBeacon"), null == (i = this.mn) || i.unload(), null == (r = this.bn) || r.unload()) : this.En() && this.capture($9052383c1c4e5569$var$rr, null, {
            transport: "sendBeacon"
        });
    }
    _send_request(t) {
        this.__loaded && ($9052383c1c4e5569$var$Yo ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) || (t.transport = t.transport || this.config.api_transport, t.url = $9052383c1c4e5569$var$so(t.url, {
            ip: this.config.ip ? 1 : 0
        }), t.headers = $9052383c1c4e5569$var$f({}, this.config.request_headers, t.headers), t.compression = "best-available" === t.compression ? this.compression : t.compression, ($9052383c1c4e5569$var$U(this.config.disable_beacon) ? this.config.__preview_disable_beacon : this.config.disable_beacon) && (t.disableTransport = [
            "sendBeacon"
        ]), t.fetchOptions = t.fetchOptions || this.config.fetch_options, ((t)=>{
            var e, i, r, s = $9052383c1c4e5569$var$f({}, t);
            s.timeout = s.timeout || 6e4, s.url = $9052383c1c4e5569$var$uo(s.url, s.compression);
            var n = null !== (e = s.transport) && void 0 !== e ? e : "fetch", o = $9052383c1c4e5569$var$ho.filter((t)=>!s.disableTransport || !t.transport || !s.disableTransport.includes(t.transport)), a = null !== (i = null == (r = function(t, e) {
                for(var i = 0; t.length > i; i++)if (t[i].transport === n) return t[i];
            }(o)) ? void 0 : r.method) && void 0 !== i ? i : o[0].method;
            if (!a) throw new Error("No available transport method");
            "sendBeacon" !== n && s.data && s.compression === $9052383c1c4e5569$export$6a00d17b5aff0af.GZipJS && $9052383c1c4e5569$var$l && !$9052383c1c4e5569$var$io ? $9052383c1c4e5569$var$lo(s).then((t)=>{
                a(t);
            }).catch((e)=>{
                if ($9052383c1c4e5569$var$x(e)) return $9052383c1c4e5569$var$io = !0, void a($9052383c1c4e5569$var$f({}, s, {
                    compression: void 0,
                    url: $9052383c1c4e5569$var$uo(t.url, void 0)
                }));
                ((t)=>{
                    if (!t || "object" != typeof t) return !1;
                    var e = "name" in t ? String(t.name) : "";
                    return $9052383c1c4e5569$var$x(t) || e === $9052383c1c4e5569$var$y;
                })(e) && ($9052383c1c4e5569$var$io = !0), a(s);
            }) : a(s);
        })($9052383c1c4e5569$var$f({}, t, {
            callback: (e)=>{
                var i, r;
                this.rateLimiter.checkForLimiting(e), 400 > e.statusCode || null == (i = (r = this.config).on_request_error) || i.call(r, e), null == t.callback || t.callback(e);
            }
        }))));
    }
    yn(t) {
        this.bn ? this.bn.retriableRequest(t) : this._send_request(t);
    }
    _execute_array(t) {
        $9052383c1c4e5569$var$zo++;
        try {
            var e, i = [], r = [], s = [];
            $9052383c1c4e5569$var$or(t, (t)=>{
                if (t) {
                    if ($9052383c1c4e5569$var$M(e = t[0])) s.push(t);
                    else if ($9052383c1c4e5569$var$D(t)) try {
                        t.call(this);
                    } catch (e) {
                        $9052383c1c4e5569$var$We.error("Error executing queued PostHog call", t, e);
                    }
                    else $9052383c1c4e5569$var$M(t) && "alias" === e ? i.push(t) : $9052383c1c4e5569$var$M(t) && -1 !== e.indexOf("capture") && $9052383c1c4e5569$var$D(this[e]) ? s.push(t) : r.push(t);
                }
            });
            var n = function(t, e) {
                $9052383c1c4e5569$var$or(t, function(t) {
                    try {
                        if ($9052383c1c4e5569$var$M(t[0])) {
                            var i = e;
                            $9052383c1c4e5569$var$ar(t, function(t) {
                                i = i[t[0]].apply(i, t.slice(1));
                            });
                        } else e[t[0]].apply(e, t.slice(1));
                    } catch (e) {
                        $9052383c1c4e5569$var$We.error("Error executing queued PostHog call", t, e);
                    }
                });
            };
            n(i, this), n(r, this), n(s, this);
        } finally{
            $9052383c1c4e5569$var$zo--;
        }
    }
    push(t) {
        if ($9052383c1c4e5569$var$zo > 0 && $9052383c1c4e5569$var$M(t) && $9052383c1c4e5569$var$j(t[0])) {
            var e = $9052383c1c4e5569$export$a9d6b9cbf49b8241.prototype[t[0]];
            $9052383c1c4e5569$var$D(e) && e.apply(this, t.slice(1));
        } else this._execute_array([
            t
        ]);
    }
    capture(t, e, i) {
        var r, s, n, o, a;
        if (this.__loaded && this.persistence && this.sessionPersistence && this.mn) {
            if (this.is_capturing()) {
                if (!$9052383c1c4e5569$var$U(t) && $9052383c1c4e5569$var$j(t)) {
                    var l = !this.config.opt_out_useragent_filter && this._is_bot();
                    if (!l || this.config.__preview_capture_bot_pageviews) {
                        var u = null != i && i.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                        if (null == u || !u.isRateLimited) {
                            null != e && e.$current_url && !$9052383c1c4e5569$var$j(null == e ? void 0 : e.$current_url) && ($9052383c1c4e5569$var$We.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), null == e || delete e.$current_url), "$exception" !== t || null != i && i.Mn || $9052383c1c4e5569$var$We.warn("Using `posthog.capture('$exception')` is unreliable because it does not attach required metadata. Use `posthog.captureException(error)` instead, which attaches required metadata automatically."), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
                            var h = new Date, d = (null == i ? void 0 : i.timestamp) || h, v = (null == i ? void 0 : i.uuid) || $9052383c1c4e5569$var$xr(), c = {
                                uuid: v,
                                event: t,
                                properties: this.calculateEventProperties(t, e || {}, d, v)
                            };
                            t === $9052383c1c4e5569$var$ir && this.config.__preview_capture_bot_pageviews && l && (c.event = "$bot_pageview", c.properties.$browser_type = "bot"), u && (c.properties.$lib_rate_limit_remaining_tokens = u.remainingTokens), (null == i ? void 0 : i.$set) && (c.$set = null == i ? void 0 : i.$set);
                            var p, _, g, m = this.Rn(null == i ? void 0 : i.$set_once, t !== $9052383c1c4e5569$var$nr, t === $9052383c1c4e5569$var$sr);
                            if (m && (c.$set_once = m), null != i && i._noTruncate || (s = this.config.properties_string_max_length, n = c, o = (t)=>$9052383c1c4e5569$var$j(t) ? t.slice(0, s) : t, a = new Set, c = function t(e, i) {
                                var r;
                                return e !== Object(e) ? o ? o(e) : e : a.has(e) ? void 0 : (a.add(e), $9052383c1c4e5569$var$M(e) ? (r = [], $9052383c1c4e5569$var$or(e, (e)=>{
                                    r.push(t(e));
                                })) : (r = {}, $9052383c1c4e5569$var$ar(e, (e, i)=>{
                                    a.has(e) || (r[i] = t(e, i));
                                })), r);
                            }(n)), c.timestamp = d, $9052383c1c4e5569$var$U(null == i ? void 0 : i.timestamp) || (c.properties.$event_time_override_provided = !0, c.properties.$event_time_override_system_time = h), t === $9052383c1c4e5569$export$9d7ec1793ca1658e.DISMISSED || t === $9052383c1c4e5569$export$9d7ec1793ca1658e.SENT) {
                                var b = null == e ? void 0 : e[$9052383c1c4e5569$export$fe4c9af525341543.SURVEY_ID], y = null == e ? void 0 : e[$9052383c1c4e5569$export$fe4c9af525341543.SURVEY_ITERATION];
                                ((t)=>{
                                    try {
                                        var e = ((t)=>((t, e)=>{
                                                var i = "" + $9052383c1c4e5569$var$Ao + e.id;
                                                return e.current_iteration && e.current_iteration > 0 && (i = "" + $9052383c1c4e5569$var$Ao + e.id + "_" + e.current_iteration), i;
                                            })(0, t))(t);
                                        if (localStorage.getItem(e)) return;
                                        localStorage.setItem(e, "true");
                                    } catch (t) {
                                        $9052383c1c4e5569$var$Co.error("Failed to persist survey seen state", t);
                                    }
                                })({
                                    id: b,
                                    current_iteration: y
                                }), c.$set = $9052383c1c4e5569$var$f({}, c.$set, {
                                    [(p = {
                                        id: b,
                                        current_iteration: y
                                    }, _ = t === $9052383c1c4e5569$export$9d7ec1793ca1658e.SENT ? "responded" : "dismissed", g = "$survey_" + _ + "/" + p.id, p.current_iteration && p.current_iteration > 0 && (g = "$survey_" + _ + "/" + p.id + "/" + p.current_iteration), g)]: !0
                                });
                            } else t === $9052383c1c4e5569$export$9d7ec1793ca1658e.SHOWN && (c.$set = $9052383c1c4e5569$var$f({}, c.$set, {
                                [$9052383c1c4e5569$export$fe4c9af525341543.SURVEY_LAST_SEEN_DATE]: (new Date).toISOString()
                            }));
                            if (t === $9052383c1c4e5569$export$e5d0052c1e47bfda.SHOWN) {
                                var w = null == e ? void 0 : e[$9052383c1c4e5569$export$eedf6d13bc23d767.TOUR_TYPE];
                                w && (c.$set = $9052383c1c4e5569$var$f({}, c.$set, {
                                    [$9052383c1c4e5569$export$eedf6d13bc23d767.TOUR_LAST_SEEN_DATE + "/" + w]: (new Date).toISOString()
                                }));
                            }
                            var x = $9052383c1c4e5569$var$f({}, c.properties.$set, c.$set);
                            if ($9052383c1c4e5569$var$L(x) || this.setPersonPropertiesForFlags(x), !$9052383c1c4e5569$var$H(this.config.before_send)) {
                                var E = this.Pn(c);
                                if (!E) return;
                                c = E;
                            }
                            this.ln.emit("eventCaptured", c);
                            var S = {
                                method: "POST",
                                url: null !== (r = null == i ? void 0 : i._url) && void 0 !== r ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
                                data: c,
                                compression: "best-available",
                                batchKey: null == i ? void 0 : i._batchKey,
                                transport: null == i ? void 0 : i.transport
                            };
                            return !this.config.request_batching || i && (null == i || !i._batchKey) || null != i && i.send_instantly ? this.yn(S) : this.mn.enqueue(S), c;
                        }
                        $9052383c1c4e5569$var$We.critical("This capture call is ignored due to client rate limiting.");
                    }
                } else $9052383c1c4e5569$var$We.error("No event name provided to posthog.capture");
            }
        } else $9052383c1c4e5569$var$We.uninitializedWarning("posthog.capture");
    }
    _addCaptureHook(t) {
        return this.on("eventCaptured", (e)=>t(e.event, e));
    }
    calculateEventProperties(e, i, n, o, a) {
        if (n = n || new Date, !this.persistence || !this.sessionPersistence) return i;
        var l = a ? void 0 : this.persistence.remove_event_timer(e), h = $9052383c1c4e5569$var$f({}, i);
        if (h.token = this.config.token, h.$config_defaults = this.config.defaults, this.sn() && (h.$cookieless_mode = !0), "$snapshot" === e) {
            var d = $9052383c1c4e5569$var$f({}, this.persistence.properties(), this.sessionPersistence.properties());
            return h.distinct_id = d.distinct_id, (!$9052383c1c4e5569$var$j(h.distinct_id) && !$9052383c1c4e5569$var$V(h.distinct_id) || $9052383c1c4e5569$var$z(h.distinct_id)) && $9052383c1c4e5569$var$We.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), h;
        }
        var c, p = function(e, i, r) {
            var n, o, a, l;
            if (!$9052383c1c4e5569$var$u) return {};
            var h, d, c, p, f, _, g, m, b, y = e ? [
                ...$9052383c1c4e5569$var$Ns,
                ...i || []
            ] : [], [w, x] = function(t) {
                for(var e = 0; $9052383c1c4e5569$var$le.length > e; e++){
                    var [i, r] = $9052383c1c4e5569$var$le[e], s = i.exec(t), n = s && ($9052383c1c4e5569$var$D(r) ? r(s, t) : r);
                    if (n) return n;
                }
                return [
                    "",
                    ""
                ];
            }($9052383c1c4e5569$var$u), E = null != (h = "undefined" != typeof navigator ? navigator : void 0) && h.brave ? {
                brave: !0
            } : {}, S = {
                detectGoogleSearchApp: r
            }, T = $9052383c1c4e5569$var$lr($9052383c1c4e5569$var$vr({
                $os: w,
                $os_version: x,
                $browser: $9052383c1c4e5569$var$ne($9052383c1c4e5569$var$u, navigator.vendor, E, S),
                $device: $9052383c1c4e5569$var$ue($9052383c1c4e5569$var$u),
                $device_type: (c = $9052383c1c4e5569$var$u, p = {
                    userAgentDataPlatform: null == (n = navigator) || null == (n = n.userAgentData) ? void 0 : n.platform,
                    maxTouchPoints: null == (o = navigator) ? void 0 : o.maxTouchPoints,
                    screenWidth: null == $9052383c1c4e5569$var$t || null == (a = $9052383c1c4e5569$var$t.screen) ? void 0 : a.width,
                    screenHeight: null == $9052383c1c4e5569$var$t || null == (l = $9052383c1c4e5569$var$t.screen) ? void 0 : l.height,
                    devicePixelRatio: null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.devicePixelRatio
                }, b = $9052383c1c4e5569$var$ue(c), b === $9052383c1c4e5569$var$dt || b === $9052383c1c4e5569$var$ht || "Kobo" === b || "Kindle Fire" === b || b === $9052383c1c4e5569$var$zt ? $9052383c1c4e5569$var$ut : b === $9052383c1c4e5569$var$Ot || b === $9052383c1c4e5569$var$Ct || b === $9052383c1c4e5569$var$It || b === $9052383c1c4e5569$var$Lt ? "Console" : b === $9052383c1c4e5569$var$ct ? "Wearable" : b ? $9052383c1c4e5569$var$ot : "Android" === (null == p ? void 0 : p.userAgentDataPlatform) && (null !== (f = null == p ? void 0 : p.maxTouchPoints) && void 0 !== f ? f : 0) > 0 ? 600 > Math.min(null !== (_ = null == p ? void 0 : p.screenWidth) && void 0 !== _ ? _ : 0, null !== (g = null == p ? void 0 : p.screenHeight) && void 0 !== g ? g : 0) / (null !== (m = null == p ? void 0 : p.devicePixelRatio) && void 0 !== m ? m : 1) ? $9052383c1c4e5569$var$ot : $9052383c1c4e5569$var$ut : "Desktop"),
                $timezone: $9052383c1c4e5569$var$Js(),
                $timezone_offset: $9052383c1c4e5569$var$Ks()
            }), {
                $current_url: $9052383c1c4e5569$var$Fs(null == $9052383c1c4e5569$var$s ? void 0 : $9052383c1c4e5569$var$s.href, y, $9052383c1c4e5569$var$Us),
                $host: null == $9052383c1c4e5569$var$s ? void 0 : $9052383c1c4e5569$var$s.host,
                $pathname: null == $9052383c1c4e5569$var$s ? void 0 : $9052383c1c4e5569$var$s.pathname,
                $raw_user_agent: $9052383c1c4e5569$var$u.length > 1e3 ? $9052383c1c4e5569$var$u.substring(0, 997) + "..." : $9052383c1c4e5569$var$u,
                $browser_version: $9052383c1c4e5569$var$ae($9052383c1c4e5569$var$u, navigator.vendor, E, S),
                $browser_language: $9052383c1c4e5569$var$Vs(),
                $browser_language_prefix: (d = $9052383c1c4e5569$var$Vs(), "string" == typeof d ? d.split("-")[0] : void 0),
                $screen_height: null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.screen.height,
                $screen_width: null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.screen.width,
                $viewport_height: null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.innerHeight,
                $viewport_width: null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.innerWidth,
                $lib: $9052383c1c4e5569$var$v.LIB_NAME,
                $lib_version: $9052383c1c4e5569$var$v.LIB_VERSION,
                $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
                $time: Date.now() / 1e3
            });
            return $9052383c1c4e5569$var$v.SDK_DIST_CHANNEL && (T.$sdk_dist_channel = $9052383c1c4e5569$var$v.SDK_DIST_CHANNEL), T;
        }(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties, this.config.detect_google_search_app);
        if (this.sessionManager) {
            var { sessionId: _, windowId: g } = this.sessionManager.checkAndGetSessionAndWindowId(a, n.getTime());
            h.$session_id = _, h.$window_id = g;
        }
        this.sessionPropsManager && $9052383c1c4e5569$var$lr(h, this.sessionPropsManager.getSessionProps());
        try {
            var m;
            this.sessionRecording && $9052383c1c4e5569$var$lr(h, this.sessionRecording.sdkDebugProperties), h.$sdk_debug_retry_queue_size = null == (m = this.bn) ? void 0 : m.length;
        } catch (t) {
            h.$sdk_debug_error_capturing_properties = String(t);
        }
        if (this.requestRouter.region === $9052383c1c4e5569$var$Ro && (h.$lib_custom_api_host = this.config.api_host), c = e !== $9052383c1c4e5569$var$ir || a ? e !== $9052383c1c4e5569$var$rr || a ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(n) : this.pageViewManager.doPageView(n, o), h = $9052383c1c4e5569$var$lr(h, c), e === $9052383c1c4e5569$var$ir && $9052383c1c4e5569$var$r && (h.title = $9052383c1c4e5569$var$r.title), !$9052383c1c4e5569$var$U(l)) {
            var b = n.getTime() - l;
            h.$duration = parseFloat((b / 1e3).toFixed(3));
        }
        $9052383c1c4e5569$var$u && this.config.opt_out_useragent_filter && (h.$browser_type = this._is_bot() ? "bot" : "browser"), (h = $9052383c1c4e5569$var$lr({}, p, this.persistence.properties(), this.sessionPersistence.properties(), h)).$is_identified = this._isIdentified(), $9052383c1c4e5569$var$M(this.config.property_denylist) ? $9052383c1c4e5569$var$ar(this.config.property_denylist, function(t) {
            delete h[t];
        }) : $9052383c1c4e5569$var$We.error($9052383c1c4e5569$var$Go + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        var y = this.config.sanitize_properties;
        y && ($9052383c1c4e5569$var$We.error($9052383c1c4e5569$var$qo), h = y(h, e));
        var w = this.On();
        return h.$process_person_profile = w, w && !a && this.Ln("_calculate_event_properties"), h;
    }
    Rn(t, e, i) {
        var r;
        if (void 0 === e && (e = !0), void 0 === i && (i = !1), !this.persistence || !this.On()) return t;
        if (this.an && !i) return t;
        var s = this.persistence.get_initial_props(), n = null == (r = this.sessionPropsManager) ? void 0 : r.getSetOnceProps(), o = $9052383c1c4e5569$var$lr({}, s, n || {}, t || {}), a = this.config.sanitize_properties;
        return a && ($9052383c1c4e5569$var$We.error($9052383c1c4e5569$var$qo), o = a(o, "$set_once")), e && (this.an = !0), $9052383c1c4e5569$var$L(o) ? void 0 : o;
    }
    register(t, e) {
        var i;
        null == (i = this.persistence) || i.register(t, e);
    }
    register_once(t, e, i) {
        var r;
        null == (r = this.persistence) || r.register_once(t, e, i);
    }
    register_for_session(t) {
        var e;
        null == (e = this.sessionPersistence) || e.register(t);
    }
    unregister(t) {
        var e;
        null == (e = this.persistence) || e.unregister(t);
    }
    unregister_for_session(t) {
        var e;
        null == (e = this.sessionPersistence) || e.unregister(t);
    }
    An(t, e) {
        this.register({
            [t]: e
        });
    }
    getFeatureFlag(t, e) {
        var i;
        return null == (i = this.featureFlags) ? void 0 : i.getFeatureFlag(t, e);
    }
    getFeatureFlagPayload(t) {
        var e;
        return null == (e = this.featureFlags) ? void 0 : e.getFeatureFlagPayload(t);
    }
    getFeatureFlagResult(t, e) {
        var i;
        return null == (i = this.featureFlags) ? void 0 : i.getFeatureFlagResult(t, e);
    }
    isFeatureEnabled(t, e) {
        var i;
        return null == (i = this.featureFlags) ? void 0 : i.isFeatureEnabled(t, e);
    }
    reloadFeatureFlags() {
        var t;
        null == (t = this.featureFlags) || t.reloadFeatureFlags();
    }
    updateFlags(t, e, i) {
        var r;
        null == (r = this.featureFlags) || r.updateFlags(t, e, i);
    }
    updateEarlyAccessFeatureEnrollment(t, e, i) {
        var r;
        null == (r = this.featureFlags) || r.updateEarlyAccessFeatureEnrollment(t, e, i);
    }
    getEarlyAccessFeatures(t, e, i) {
        var r;
        return void 0 === e && (e = !1), null == (r = this.featureFlags) ? void 0 : r.getEarlyAccessFeatures(t, e, i);
    }
    on(t, e) {
        return this.ln.on(t, e);
    }
    onFeatureFlags(t) {
        return this.featureFlags ? this.featureFlags.onFeatureFlags(t) : (t([], {}, {
            errorsLoading: !0
        }), ()=>{});
    }
    onSurveysLoaded(t) {
        return this.surveys ? this.surveys.onSurveysLoaded(t) : (t([], {
            isLoaded: !1,
            error: $9052383c1c4e5569$var$Vo
        }), ()=>{});
    }
    onSessionId(t) {
        var e, i;
        return null !== (e = null == (i = this.sessionManager) ? void 0 : i.onSessionId(t)) && void 0 !== e ? e : ()=>{};
    }
    getSurveys(t, e) {
        void 0 === e && (e = !1), this.surveys ? this.surveys.getSurveys(t, e) : t([], {
            isLoaded: !1,
            error: $9052383c1c4e5569$var$Vo
        });
    }
    getActiveMatchingSurveys(t, e) {
        void 0 === e && (e = !1), this.surveys ? this.surveys.getActiveMatchingSurveys(t, e) : t([], {
            isLoaded: !1,
            error: $9052383c1c4e5569$var$Vo
        });
    }
    renderSurvey(t, e) {
        var i;
        null == (i = this.surveys) || i.renderSurvey(t, e);
    }
    displaySurvey(t, e) {
        var i;
        void 0 === e && (e = $9052383c1c4e5569$var$Mo), null == (i = this.surveys) || i.displaySurvey(t, e);
    }
    cancelPendingSurvey(t) {
        var e;
        null == (e = this.surveys) || e.cancelPendingSurvey(t);
    }
    canRenderSurvey(t) {
        var e, i;
        return null !== (e = null == (i = this.surveys) ? void 0 : i.canRenderSurvey(t)) && void 0 !== e ? e : {
            visible: !1,
            disabledReason: $9052383c1c4e5569$var$Vo
        };
    }
    canRenderSurveyAsync(t, e) {
        var i, r;
        return void 0 === e && (e = !1), null !== (i = null == (r = this.surveys) ? void 0 : r.canRenderSurveyAsync(t, e)) && void 0 !== i ? i : Promise.resolve({
            visible: !1,
            disabledReason: $9052383c1c4e5569$var$Vo
        });
    }
    Fn(t) {
        return !t || $9052383c1c4e5569$var$z(t) ? ($9052383c1c4e5569$var$We.critical("Unique user id has not been set in posthog.identify"), !1) : t === $9052383c1c4e5569$var$Vi ? ($9052383c1c4e5569$var$We.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.'), !1) : ![
            "distinct_id",
            "distinctid"
        ].includes(t.toLowerCase()) && ![
            "undefined",
            "null"
        ].includes(t.toLowerCase()) || ($9052383c1c4e5569$var$We.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.'), !1);
    }
    identify(t, e, i) {
        if (!this.__loaded || !this.persistence) return $9052383c1c4e5569$var$We.uninitializedWarning("posthog.identify");
        if ($9052383c1c4e5569$var$V(t) && (t = t.toString(), $9052383c1c4e5569$var$We.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), this.Fn(t) && this.Ln("posthog.identify")) {
            var r = this.get_distinct_id();
            this.register({
                $user_id: t
            }), this.get_property($9052383c1c4e5569$var$Qe) || this.register_once({
                $had_persisted_distinct_id: !0,
                $device_id: r
            }, ""), t !== r && t !== this.get_property($9052383c1c4e5569$var$Ze) && (this.unregister($9052383c1c4e5569$var$Ze), this.register({
                distinct_id: t
            }));
            var s, n = (this.persistence.get_property($9052383c1c4e5569$var$Di) || $9052383c1c4e5569$var$Xi) === $9052383c1c4e5569$var$Xi;
            t !== r && n ? (this.persistence.set_property($9052383c1c4e5569$var$Di, $9052383c1c4e5569$var$Qi), this.setPersonPropertiesForFlags({
                $set: e || {},
                $set_once: i || {}
            }, !1), this.capture($9052383c1c4e5569$var$sr, {
                distinct_id: t,
                $anon_distinct_id: r
            }, {
                $set: e || {},
                $set_once: i || {}
            }), this.dn = $9052383c1c4e5569$var$So(t, e, i), null == (s = this.featureFlags) || s.setAnonymousDistinctId(r)) : (e || i) && this.setPersonProperties(e, i), t !== r && (this.reloadFeatureFlags(), this.unregister($9052383c1c4e5569$var$Ci));
        }
    }
    setPersonProperties(t, e) {
        if ((t || e) && this.Ln("posthog.setPersonProperties")) {
            var i = $9052383c1c4e5569$var$So(this.get_distinct_id(), t, e);
            this.dn !== i ? (this.setPersonPropertiesForFlags({
                $set: t || {},
                $set_once: e || {}
            }, !0), this.capture("$set", {
                $set: t || {},
                $set_once: e || {}
            }), this.dn = i) : $9052383c1c4e5569$var$We.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
        }
    }
    group(t, e, i) {
        if (t && e) {
            var r = this.getGroups(), s = r[t] !== e;
            if (s && this.resetGroupPropertiesForFlags(t), this.register({
                $groups: $9052383c1c4e5569$var$f({}, r, {
                    [t]: e
                })
            }), s || i) {
                var n = {
                    $group_type: t,
                    $group_key: e
                };
                i && (n.$group_set = i), this.capture($9052383c1c4e5569$var$nr, n);
            }
            i && this.setGroupPropertiesForFlags({
                [t]: i
            }), s && !i && this.reloadFeatureFlags();
        } else $9052383c1c4e5569$var$We.error("posthog.group requires a group type and group key");
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(t, e) {
        var i;
        void 0 === e && (e = !0), null == (i = this.featureFlags) || i.setPersonPropertiesForFlags(t, e);
    }
    resetPersonPropertiesForFlags(t) {
        var e;
        void 0 === t && (t = !0), null == (e = this.featureFlags) || e.resetPersonPropertiesForFlags(t);
    }
    setGroupPropertiesForFlags(t, e) {
        var i;
        void 0 === e && (e = !0), this.Ln("posthog.setGroupPropertiesForFlags") && (null == (i = this.featureFlags) || i.setGroupPropertiesForFlags(t, e));
    }
    resetGroupPropertiesForFlags(t) {
        var e;
        null == (e = this.featureFlags) || e.resetGroupPropertiesForFlags(t);
    }
    reset(t) {
        var e, i, r, s, n, o, a, l;
        if ($9052383c1c4e5569$var$We.info("reset"), !this.__loaded) return $9052383c1c4e5569$var$We.uninitializedWarning("posthog.reset");
        var u, h = this.get_property($9052383c1c4e5569$var$Qe), d = this.get_property($9052383c1c4e5569$var$hi);
        if (this.consent.reset(), null == (e = this.persistence) || e.clear(), null == (i = this.sessionPersistence) || i.clear(), $9052383c1c4e5569$var$U(d) || null == (u = this.persistence) || u.register({
            [$9052383c1c4e5569$var$hi]: d
        }), null == (r = this.surveys) || r.reset(), null == (s = this.Tn) || s.stop(), null == (n = this.featureFlags) || n.reset(), null == (o = this.conversations) || o.reset(), null == (a = this.persistence) || a.set_property($9052383c1c4e5569$var$Di, $9052383c1c4e5569$var$Xi), null == (l = this.sessionManager) || l.resetSessionId(), this.dn = null, this.config.cookieless_mode === $9052383c1c4e5569$var$Ki) this.register_once({
            distinct_id: $9052383c1c4e5569$var$Vi,
            $device_id: null
        }, "");
        else {
            var v = this.config.get_device_id($9052383c1c4e5569$var$xr());
            this.register_once({
                distinct_id: v,
                $device_id: t ? v : h
            }, "");
        }
        this.register({
            $last_posthog_reset: (new Date).toISOString()
        }, 1), delete this.config.identity_distinct_id, delete this.config.identity_hash, this.reloadFeatureFlags();
    }
    setIdentity(t, e) {
        var i;
        this.config.identity_distinct_id = t, this.config.identity_hash = e, this.alias(t), null == (i = this.conversations) || i.Nn();
    }
    clearIdentity() {
        var t;
        delete this.config.identity_distinct_id, delete this.config.identity_hash, null == (t = this.conversations) || t.Dn();
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var t, e;
        return null !== (t = null == (e = this.sessionManager) ? void 0 : e.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== t ? t : "";
    }
    get_session_replay_url(t) {
        if (!this.sessionManager) return "";
        var { sessionId: e, sessionStartTimestamp: i } = this.sessionManager.checkAndGetSessionAndWindowId(!0), r = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + e);
        if (null != t && t.withTimestamp && i) {
            var s, n = null !== (s = t.timestampLookBack) && void 0 !== s ? s : 10;
            if (!i) return r;
            r += "?t=" + Math.max(Math.floor(((new Date).getTime() - i) / 1e3) - n, 0);
        }
        return r;
    }
    alias(t, e) {
        return t === this.get_property($9052383c1c4e5569$var$Xe) ? ($9052383c1c4e5569$var$We.critical("Attempting to create alias for existing People user - aborting."), -2) : this.Ln("posthog.alias") ? ($9052383c1c4e5569$var$U(e) && (e = this.get_distinct_id()), t !== e ? (this.An($9052383c1c4e5569$var$Ze, t), this.capture("$create_alias", {
            alias: t,
            distinct_id: e
        })) : ($9052383c1c4e5569$var$We.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
    }
    set_config(t) {
        var e = $9052383c1c4e5569$var$f({}, this.config);
        if ($9052383c1c4e5569$var$N(t)) {
            var i, r, s, n, o, a, l, u, h, d, c;
            $9052383c1c4e5569$var$lr(this.config, $9052383c1c4e5569$var$Xo(t));
            var p = this.gn();
            null == (i = this.persistence) || i.update_config(this.config, e, p), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $9052383c1c4e5569$var$tn($9052383c1c4e5569$var$f({}, this.config, {
                persistence: "sessionStorage"
            }), p, !1);
            var _ = this.vn(this.config.debug);
            $9052383c1c4e5569$var$G(_) && (this.config.debug = _), $9052383c1c4e5569$var$G(this.config.debug) && (this.config.debug ? ($9052383c1c4e5569$var$v.DEBUG = !0, $9052383c1c4e5569$var$Rr.O() && $9052383c1c4e5569$var$Rr.N("ph_debug", !0), $9052383c1c4e5569$var$We.info("set_config", {
                config: t,
                oldConfig: e,
                newConfig: $9052383c1c4e5569$var$f({}, this.config)
            })) : ($9052383c1c4e5569$var$v.DEBUG = !1, $9052383c1c4e5569$var$Rr.O() && $9052383c1c4e5569$var$Rr.q("ph_debug"))), null == (r = this.exceptionObserver) || r.onConfigChange(), null == (s = this.exceptions) || s.onConfigChange(), null == (n = this.sessionRecording) || n.startIfEnabledOrStop(), null == (o = this.tracingHeaders) || o.startIfEnabledOrStop(), null == (a = this.autocapture) || a.startIfEnabled(), null == (l = this.heatmaps) || l.startIfEnabled(), null == (u = this.exceptionObserver) || u.startIfEnabledOrStop(), null == (h = this.deadClicksAutocapture) || h.startIfEnabledOrStop(), null == (d = this.surveys) || d.loadIfEnabled(), this.$n(), null == (c = this.externalIntegrations) || c.startIfEnabledOrStop();
        }
    }
    _overrideSDKInfo(t, e) {
        $9052383c1c4e5569$var$v.LIB_NAME = t, $9052383c1c4e5569$var$v.LIB_VERSION = e;
    }
    startSessionRecording(t) {
        var e, i, r, s, n, o = !0 === t, a = {
            sampling: o || !(null == t || !t.sampling),
            linked_flag: o || !(null == t || !t.linked_flag),
            url_trigger: o || !(null == t || !t.url_trigger),
            event_trigger: o || !(null == t || !t.event_trigger)
        };
        Object.values(a).some(Boolean) && (null == (e = this.sessionManager) || e.checkAndGetSessionAndWindowId(), a.sampling && (null == (i = this.sessionRecording) || i.overrideSampling()), a.linked_flag && (null == (r = this.sessionRecording) || r.overrideLinkedFlag()), a.url_trigger && (null == (s = this.sessionRecording) || s.overrideTrigger("url")), a.event_trigger && (null == (n = this.sessionRecording) || n.overrideTrigger("event")));
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var t;
        return !(null == (t = this.sessionRecording) || !t.started);
    }
    captureException(t, e) {
        if (this.exceptions) {
            var i = new Error("PostHog syntheticException"), r = this.exceptions.buildProperties(t, {
                handled: !0,
                syntheticException: i
            });
            return this.exceptions.sendExceptionEvent($9052383c1c4e5569$var$f({}, r, e));
        }
    }
    addExceptionStep(t, e) {
        var i;
        null == (i = this.exceptions) || i.addExceptionStep(t, e);
    }
    captureLog(t) {
        var e;
        null == (e = this.logs) || e.captureLog(t);
    }
    get logger() {
        var t, e;
        return null !== (t = null == (e = this.logs) ? void 0 : e.logger) && void 0 !== t ? t : $9052383c1c4e5569$export$a9d6b9cbf49b8241.qn;
    }
    startExceptionAutocapture(t) {
        this.set_config({
            capture_exceptions: null == t || t
        });
    }
    stopExceptionAutocapture() {
        this.set_config({
            capture_exceptions: !1
        });
    }
    loadToolbar(t) {
        var e, i;
        return null !== (e = null == (i = this.toolbar) ? void 0 : i.loadToolbar(t)) && void 0 !== e && e;
    }
    get_property(t) {
        var e;
        return null == (e = this.persistence) ? void 0 : e.props[t];
    }
    getSessionProperty(t) {
        var e;
        return null == (e = this.sessionPersistence) ? void 0 : e.props[t];
    }
    toString() {
        var t, e = null !== (t = this.config.name) && void 0 !== t ? t : $9052383c1c4e5569$var$Wo;
        return e !== $9052383c1c4e5569$var$Wo && (e = $9052383c1c4e5569$var$Wo + "." + e), e;
    }
    _isIdentified() {
        var t, e;
        return (null == (t = this.persistence) ? void 0 : t.get_property($9052383c1c4e5569$var$Di)) === $9052383c1c4e5569$var$Qi || (null == (e = this.sessionPersistence) ? void 0 : e.get_property($9052383c1c4e5569$var$Di)) === $9052383c1c4e5569$var$Qi;
    }
    On() {
        var t, e;
        return !("never" === this.config.person_profiles || this.config.person_profiles === $9052383c1c4e5569$var$Zi && !this._isIdentified() && $9052383c1c4e5569$var$L(this.getGroups()) && (null == (t = this.persistence) || null == (t = t.props) || !t[$9052383c1c4e5569$var$Ze]) && (null == (e = this.persistence) || null == (e = e.props) || !e[$9052383c1c4e5569$var$Bi]));
    }
    En() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && (!0 === this.config.capture_pageview || "history_change" === this.config.capture_pageview);
    }
    createPersonProfile() {
        this.On() || this.Ln("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    setInternalOrTestUser() {
        this.Ln("posthog.setInternalOrTestUser") && this.setPersonProperties({
            $internal_or_test_user: !0
        });
    }
    Ln(t) {
        return "never" === this.config.person_profiles ? ($9052383c1c4e5569$var$We.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.An($9052383c1c4e5569$var$Bi, !0), !0);
    }
    gn() {
        if ("always" === this.config.cookieless_mode) return !0;
        var t = this.consent.isOptedOut();
        return this.config.disable_persistence || t && !(!this.config.opt_out_persistence_by_default && this.config.cookieless_mode !== $9052383c1c4e5569$var$Ji);
    }
    $n() {
        var t, e, i, r, s = this.gn();
        return (null == (t = this.persistence) ? void 0 : t.Tr) !== s && (null == (i = this.persistence) || i.set_disabled(s)), (null == (e = this.sessionPersistence) ? void 0 : e.Tr) !== s && (null == (r = this.sessionPersistence) || r.set_disabled(s)), s;
    }
    opt_in_capturing(t) {
        var e;
        if (this.config.cookieless_mode !== $9052383c1c4e5569$var$Ki) {
            if (this.sn()) {
                var i, r, s, n, o;
                this.reset(!0), null == (i = this.sessionManager) || i.destroy(), null == (r = this.pageViewManager) || r.destroy(), this.sessionManager = new $9052383c1c4e5569$var$wo(this), this.pageViewManager = new $9052383c1c4e5569$var$ks(this), this.persistence && (this.sessionPropsManager = new $9052383c1c4e5569$var$mo(this, this.sessionManager, this.persistence));
                var a, l = null !== (s = null == (n = this.config.__extensionClasses) ? void 0 : n.sessionRecording) && void 0 !== s ? s : null == (o = $9052383c1c4e5569$export$a9d6b9cbf49b8241.__defaultExtensionClasses) ? void 0 : o.sessionRecording;
                l && (this.sessionRecording = this.rn(this.sessionRecording, new l(this)), this.Sn && (null == (a = this.sessionRecording) || null == a.onRemoteConfig || a.onRemoteConfig(this.Sn)));
            }
            var u, h;
            this.consent.optInOut(!0), this.$n(), this.Cn(), null == (e = this.sessionRecording) || e.startIfEnabledOrStop(), this.config.cookieless_mode == $9052383c1c4e5569$var$Ji && (null == (u = this.surveys) || u.loadIfEnabled()), ($9052383c1c4e5569$var$U(null == t ? void 0 : t.captureEventName) || null != t && t.captureEventName) && this.capture(null !== (h = null == t ? void 0 : t.captureEventName) && void 0 !== h ? h : "$opt_in", null == t ? void 0 : t.captureProperties, {
                send_instantly: !0
            }), this.config.capture_pageview && this.In();
        } else $9052383c1c4e5569$var$We.warn($9052383c1c4e5569$var$Ho);
    }
    opt_out_capturing() {
        var t, e, i;
        this.config.cookieless_mode !== $9052383c1c4e5569$var$Ki ? (this.config.cookieless_mode === $9052383c1c4e5569$var$Ji && this.consent.isOptedIn() && this.reset(!0), this.consent.optInOut(!1), this.$n(), this.config.cookieless_mode === $9052383c1c4e5569$var$Ji && (this.register({
            distinct_id: $9052383c1c4e5569$var$Vi,
            $device_id: null
        }), null == (t = this.sessionRecording) || t.stopRecording(), this.sessionRecording = void 0, null == (e = this.sessionManager) || e.destroy(), null == (i = this.pageViewManager) || i.destroy(), this.sessionManager = void 0, this.sessionPropsManager = void 0, this.config.capture_pageview && this.In(), this.Cn())) : $9052383c1c4e5569$var$We.warn($9052383c1c4e5569$var$Ho);
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    get_explicit_consent_status() {
        var t = this.consent.consent;
        return 1 === t ? "granted" : 0 === t ? "denied" : "pending";
    }
    is_capturing() {
        return this.config.cookieless_mode === $9052383c1c4e5569$var$Ki || (this.config.cookieless_mode === $9052383c1c4e5569$var$Ji ? this.consent.isRejected() || this.consent.isOptedIn() : !this.has_opted_out_capturing());
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this.$n();
    }
    _is_bot() {
        return $9052383c1c4e5569$var$i ? $9052383c1c4e5569$var$xo($9052383c1c4e5569$var$i, this.config.custom_blocked_useragents) : void 0;
    }
    In() {
        $9052383c1c4e5569$var$r && ("visible" === $9052383c1c4e5569$var$r.visibilityState ? this.un || (this.un = !0, this.capture($9052383c1c4e5569$var$ir, {
            title: $9052383c1c4e5569$var$r.title
        }, {
            send_instantly: !0
        }), this.hn && ($9052383c1c4e5569$var$r.removeEventListener($9052383c1c4e5569$var$tr, this.hn), this.hn = null)) : this.hn || (this.hn = this.In.bind(this), $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$r, $9052383c1c4e5569$var$tr, this.hn)));
    }
    debug(e) {
        !1 === e ? (null == $9052383c1c4e5569$var$t || $9052383c1c4e5569$var$t.console.log("You've disabled debug mode."), this.set_config({
            debug: !1
        })) : (null == $9052383c1c4e5569$var$t || $9052383c1c4e5569$var$t.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), this.set_config({
            debug: !0
        }));
    }
    Kr() {
        var t, e, i, r, s, n, o = this.fn || {};
        return "advanced_disable_flags" in o ? !!o.advanced_disable_flags : !1 !== this.config.advanced_disable_flags ? !!this.config.advanced_disable_flags : !0 === this.config.advanced_disable_decide ? ($9052383c1c4e5569$var$We.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : (i = "advanced_disable_decide", r = $9052383c1c4e5569$var$We, s = (e = "advanced_disable_flags") in (t = o) && !$9052383c1c4e5569$var$H(t[e]), n = i in t && !$9052383c1c4e5569$var$H(t[i]), s ? t[e] : !!n && (r && r.warn("Config field '" + i + "' is deprecated. Please use '" + e + "' instead. The old field will be removed in a future major version."), t[i]));
    }
    Pn(t) {
        if ($9052383c1c4e5569$var$H(this.config.before_send)) return t;
        var e = $9052383c1c4e5569$var$M(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ], i = t;
        for (var r of e){
            if (i = r(i), $9052383c1c4e5569$var$H(i)) {
                var s = "Event '" + t.event + "' was rejected in beforeSend function";
                return $9052383c1c4e5569$var$Y(t.event) ? $9052383c1c4e5569$var$We.warn(s + ". This can cause unexpected behavior.") : $9052383c1c4e5569$var$We.info(s), null;
            }
            i.properties && !$9052383c1c4e5569$var$L(i.properties) || $9052383c1c4e5569$var$We.warn("Event '" + t.event + "' has no properties after beforeSend function, this is likely an error.");
        }
        return i;
    }
    getPageViewId() {
        var t;
        return null == (t = this.pageViewManager.dr) ? void 0 : t.pageViewId;
    }
    captureTraceFeedback(t, e) {
        this.capture("$ai_feedback", {
            $ai_trace_id: String(t),
            $ai_feedback_text: e
        });
    }
    captureTraceMetric(t, e, i) {
        this.capture("$ai_metric", {
            $ai_trace_id: String(t),
            $ai_metric_name: e,
            $ai_metric_value: String(i)
        });
    }
    vn(t) {
        var e = $9052383c1c4e5569$var$G(t) && !t, i = $9052383c1c4e5569$var$Rr.O() && "true" === $9052383c1c4e5569$var$Rr.A("ph_debug");
        return !e && (!!i || t);
    }
}
$9052383c1c4e5569$export$a9d6b9cbf49b8241.__defaultExtensionClasses = {}, $9052383c1c4e5569$export$a9d6b9cbf49b8241.qn = {
    trace: $9052383c1c4e5569$var$Uo = ()=>{},
    debug: $9052383c1c4e5569$var$Uo,
    info: $9052383c1c4e5569$var$Uo,
    warn: $9052383c1c4e5569$var$Uo,
    error: $9052383c1c4e5569$var$Uo,
    fatal: $9052383c1c4e5569$var$Uo
}, function(t, e) {
    for(var i = 0; e.length > i; i++)t.prototype[e[i]] = $9052383c1c4e5569$var$dr(t.prototype[e[i]]);
}($9052383c1c4e5569$export$a9d6b9cbf49b8241, [
    "identify"
]);
class $9052383c1c4e5569$var$ta {
    constructor(t){
        this.disabled = !1 === t;
        var e = $9052383c1c4e5569$var$N(t) ? t : {};
        this.thresholdPx = e.threshold_px || 30, this.timeoutMs = e.timeout_ms || 1e3, this.clickCount = e.click_count || 3, this.clicks = [];
    }
    isRageClick(t, e, i) {
        if (this.disabled) return !1;
        var r = this.clicks[this.clicks.length - 1];
        if (r && Math.abs(t - r.x) + Math.abs(e - r.y) < this.thresholdPx && this.timeoutMs > i - r.timestamp) {
            if (this.clicks.push({
                x: t,
                y: e,
                timestamp: i
            }), this.clicks.length === this.clickCount) return !0;
        } else this.clicks = [
            {
                x: t,
                y: e,
                timestamp: i
            }
        ];
        return !1;
    }
}
var $9052383c1c4e5569$var$ea = "$copy_autocapture", $9052383c1c4e5569$var$ia = $9052383c1c4e5569$var$Ye("[AutoCapture]");
function $9052383c1c4e5569$var$ra(t, e) {
    return e.length > t ? e.slice(0, t) + "..." : e;
}
function $9052383c1c4e5569$var$sa(t) {
    if (t.previousElementSibling) return t.previousElementSibling;
    var e = t;
    do e = e.previousSibling;
    while (e && !$9052383c1c4e5569$var$Ur(e));
    return e;
}
function $9052383c1c4e5569$var$na(e, i) {
    var r, s, { e: n, maskAllElementAttributes: o, maskAllText: a, elementAttributeIgnoreList: l, elementsChainAsString: u } = i;
    if (!$9052383c1c4e5569$var$Ur(e)) return {
        props: {}
    };
    for(var h = [
        e
    ], d = e; d.parentNode && !$9052383c1c4e5569$var$jr(d, "body");)if ($9052383c1c4e5569$var$Br(d.parentNode)) h.push(d.parentNode.host), d = d.parentNode.host;
    else {
        if (!$9052383c1c4e5569$var$Ur(d.parentNode)) break;
        h.push(d.parentNode), d = d.parentNode;
    }
    var v, c, p = [], _ = {}, g = !1, m = !1;
    if ($9052383c1c4e5569$var$ar(h, (t)=>{
        var e = $9052383c1c4e5569$var$os(t);
        if ($9052383c1c4e5569$var$jr(t, "a")) {
            var i = t.getAttribute("href");
            g = e && !!i && $9052383c1c4e5569$var$ps(i) && i;
        }
        $9052383c1c4e5569$var$P($9052383c1c4e5569$var$qr(t), "ph-no-capture") && (m = !0), p.push(function(t, e, i, r) {
            var s = t.tagName.toLowerCase(), n = {
                tag_name: s
            };
            $9052383c1c4e5569$var$Jr.indexOf(s) > -1 && !i && (n.$el_text = "a" === s.toLowerCase() || "button" === s.toLowerCase() ? $9052383c1c4e5569$var$ra(1024, $9052383c1c4e5569$var$fs(t)) : $9052383c1c4e5569$var$ra(1024, $9052383c1c4e5569$var$Wr(t)));
            var o = $9052383c1c4e5569$var$qr(t);
            o.length > 0 && (n.classes = o.filter(function(t) {
                return "" !== t;
            })), $9052383c1c4e5569$var$ar(t.attributes, function(i) {
                var s;
                if ((!$9052383c1c4e5569$var$as(t) || -1 !== [
                    "name",
                    "id",
                    "class",
                    "aria-label"
                ].indexOf(i.name)) && (null == r || !r.includes(i.name)) && !e && $9052383c1c4e5569$var$ps(i.value) && (!$9052383c1c4e5569$var$j(s = i.name) || "_ngcontent" !== s.substring(0, 10) && "_nghost" !== s.substring(0, 7))) {
                    var o = i.value;
                    "class" === i.name && (o = $9052383c1c4e5569$var$Hr(o).join(" ")), n["attr__" + i.name] = $9052383c1c4e5569$var$ra(1024, o);
                }
            });
            for(var a = 1, l = 1, u = t; u = $9052383c1c4e5569$var$sa(u);)a++, u.tagName === t.tagName && l++;
            return n.nth_child = a, n.nth_of_type = l, n;
        }(t, o, a, l));
        var r = function(t) {
            if (!$9052383c1c4e5569$var$os(t)) return {};
            var e = {};
            return $9052383c1c4e5569$var$ar(t.attributes, function(t) {
                if (t.name && 0 === t.name.indexOf("data-ph-capture-attribute")) {
                    var i = t.name.replace("data-ph-capture-attribute-", ""), r = t.value;
                    i && r && $9052383c1c4e5569$var$ps(r) && (e[i] = r);
                }
            }), e;
        }(t);
        $9052383c1c4e5569$var$lr(_, r);
    }), m) return {
        props: {},
        explicitNoCapture: m
    };
    if (a || (p[0].$el_text = $9052383c1c4e5569$var$jr(e, "a") || $9052383c1c4e5569$var$jr(e, "button") ? $9052383c1c4e5569$var$fs(e) : $9052383c1c4e5569$var$Wr(e)), g) {
        var b, y;
        p[0].attr__href = g;
        var w = null == (b = $9052383c1c4e5569$var$Cs(g)) ? void 0 : b.host, x = null == $9052383c1c4e5569$var$t || null == (y = $9052383c1c4e5569$var$t.location) ? void 0 : y.host;
        w && x && w !== x && (v = g);
    }
    return {
        props: $9052383c1c4e5569$var$lr({
            $event_type: n.type,
            $ce_version: 1
        }, u ? {} : {
            $elements: p
        }, {
            $elements_chain: (c = p, function(t) {
                return t.map((t)=>{
                    var e, i, r = "";
                    if (t.tag_name && (r += t.tag_name), t.attr_class) for (var s of (t.attr_class.sort(), t.attr_class))r += "." + s.replace(/"/g, "");
                    var n = $9052383c1c4e5569$var$f({}, t.text ? {
                        text: t.text
                    } : {}, {
                        "nth-child": null !== (e = t.nth_child) && void 0 !== e ? e : 0,
                        "nth-of-type": null !== (i = t.nth_of_type) && void 0 !== i ? i : 0
                    }, t.href ? {
                        href: t.href
                    } : {}, t.attr_id ? {
                        attr_id: t.attr_id
                    } : {}, t.attributes), o = {};
                    return $9052383c1c4e5569$var$ur(n).sort((t, e)=>{
                        var [i] = t, [r] = e;
                        return i.localeCompare(r);
                    }).forEach((t)=>{
                        var [e, i] = t;
                        return o[$9052383c1c4e5569$var$gs(e.toString())] = $9052383c1c4e5569$var$gs(i.toString());
                    }), (r += ":") + $9052383c1c4e5569$var$ur(o).map((t)=>{
                        var [e, i] = t;
                        return e + '="' + i + '"';
                    }).join("");
                }).join(";");
            }(function(t) {
                return t.map((t)=>{
                    var e, i, r = {
                        text: null == (e = t.$el_text) ? void 0 : e.slice(0, 400),
                        tag_name: t.tag_name,
                        href: null == (i = t.attr__href) ? void 0 : i.slice(0, 2048),
                        attr_class: $9052383c1c4e5569$var$ms(t),
                        attr_id: t.attr__id,
                        nth_child: t.nth_child,
                        nth_of_type: t.nth_of_type,
                        attributes: {}
                    };
                    return $9052383c1c4e5569$var$ur(t).filter((t)=>{
                        var [e] = t;
                        return 0 === e.indexOf("attr__");
                    }).forEach((t)=>{
                        var [e, i] = t;
                        return r.attributes[e] = i;
                    }), r;
                });
            }(c)))
        }, null != (r = p[0]) && r.$el_text ? {
            $el_text: null == (s = p[0]) ? void 0 : s.$el_text
        } : {}, v && "click" === n.type ? {
            $external_click_url: v
        } : {}, _)
    };
}
var $9052383c1c4e5569$var$oa = $9052383c1c4e5569$var$Ye("[ExceptionAutocapture]"), $9052383c1c4e5569$var$aa = $9052383c1c4e5569$var$Ye("[TracingHeaders]"), $9052383c1c4e5569$var$la = $9052383c1c4e5569$var$Ye("[Web Vitals]"), $9052383c1c4e5569$var$ua = 9e5, $9052383c1c4e5569$var$ha = "disabled", $9052383c1c4e5569$var$da = "lazy_loading", $9052383c1c4e5569$var$va = "awaiting_config", $9052383c1c4e5569$var$ca = "missing_config";
$9052383c1c4e5569$var$Ye("[SessionRecording]"), $9052383c1c4e5569$var$Ye("[SessionRecording]");
var $9052383c1c4e5569$var$pa = "[SessionRecording]", $9052383c1c4e5569$var$fa = $9052383c1c4e5569$var$Ye($9052383c1c4e5569$var$pa), $9052383c1c4e5569$var$_a = $9052383c1c4e5569$var$Ye("[Heatmaps]");
function $9052383c1c4e5569$var$ga(t) {
    return $9052383c1c4e5569$var$N(t) && "clientX" in t && "clientY" in t && $9052383c1c4e5569$var$V(t.clientX) && $9052383c1c4e5569$var$V(t.clientY);
}
var $9052383c1c4e5569$var$ma = $9052383c1c4e5569$var$Ye("[Product Tours]"), $9052383c1c4e5569$var$ba = (t)=>{
    var e;
    return !t.config.disable_product_tours && !(null == (e = t.persistence) || !e.get_property($9052383c1c4e5569$var$li));
}, $9052383c1c4e5569$var$ya = [
    "$set_once",
    "$set"
], $9052383c1c4e5569$var$wa = $9052383c1c4e5569$var$Ye("[SiteApps]"), $9052383c1c4e5569$var$xa = "Error while initializing PostHog app with config id ";
function $9052383c1c4e5569$var$Ea(t, e, i) {
    if ($9052383c1c4e5569$var$H(t)) return !1;
    switch(i){
        case "exact":
            return t === e;
        case "contains":
            var r = e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/_/g, ".").replace(/%/g, ".*");
            return new RegExp(r, "i").test(t);
        case "regex":
            try {
                return new RegExp(e).test(t);
            } catch (t) {
                return !1;
            }
        default:
            return !1;
    }
}
class $9052383c1c4e5569$var$Sa {
    constructor(t){
        this.jn = new $9052383c1c4e5569$var$bo, this.Bn = (t, e)=>this.Hn(t, e) && this.Un(t, e) && this.zn(t, e) && this.Vn(t, e), this.Hn = (t, e)=>null == e || !e.event || (null == t ? void 0 : t.event) === (null == e ? void 0 : e.event), this._instance = t, this.Wn = new Set, this.Gn = new Set;
    }
    init() {
        var t, e;
        $9052383c1c4e5569$var$U(null == (t = this._instance) ? void 0 : t._addCaptureHook) || null == (e = this._instance) || e._addCaptureHook((t, e)=>{
            this.on(t, e);
        });
    }
    register(t) {
        var e, i;
        if (!$9052383c1c4e5569$var$U(null == (e = this._instance) ? void 0 : e._addCaptureHook) && (t.forEach((t)=>{
            var e, i;
            null == (e = this.Gn) || e.add(t), null == (i = t.steps) || i.forEach((t)=>{
                var e;
                null == (e = this.Wn) || e.add((null == t ? void 0 : t.event) || "");
            });
        }), null != (i = this._instance) && i.autocapture)) {
            var r, s = new Set;
            t.forEach((t)=>{
                var e;
                null == (e = t.steps) || e.forEach((t)=>{
                    null != t && t.selector && s.add(null == t ? void 0 : t.selector);
                });
            }), null == (r = this._instance) || r.autocapture.setElementSelectors(s);
        }
    }
    on(t, e) {
        var i;
        null != e && 0 != t.length && (this.Wn.has(t) || this.Wn.has(null == e ? void 0 : e.event)) && this.Gn && (null == (i = this.Gn) ? void 0 : i.size) > 0 && this.Gn.forEach((t)=>{
            this.Zn(e, t) && this.jn.emit("actionCaptured", t.name);
        });
    }
    Qn(t) {
        this.onAction("actionCaptured", (e)=>t(e));
    }
    Zn(t, e) {
        if (null == (null == e ? void 0 : e.steps)) return !1;
        for (var i of e.steps)if (this.Bn(t, i)) return !0;
        return !1;
    }
    onAction(t, e) {
        return this.jn.on(t, e);
    }
    Un(t, e) {
        if (null != e && e.url) {
            var i, r = null == t || null == (i = t.properties) ? void 0 : i.$current_url;
            if (!r || "string" != typeof r) return !1;
            if (!$9052383c1c4e5569$var$Ea(r, e.url, e.url_matching || "contains")) return !1;
        }
        return !0;
    }
    zn(t, e) {
        return !!this.Jn(t, e) && !!this.Kn(t, e) && !!this.Yn(t, e);
    }
    Jn(t, e) {
        var i;
        if (null == e || !e.href) return !0;
        var r = this.Xn(t);
        if (r.length > 0) return r.some((t)=>$9052383c1c4e5569$var$Ea(t.href, e.href, e.href_matching || "exact"));
        var s, n = (null == t || null == (i = t.properties) ? void 0 : i.$elements_chain) || "";
        return !!n && $9052383c1c4e5569$var$Ea((s = n.match(/(?::|")href="(.*?)"/)) ? s[1] : "", e.href, e.href_matching || "exact");
    }
    Kn(t, e) {
        var i;
        if (null == e || !e.text) return !0;
        var r = this.Xn(t);
        if (r.length > 0) return r.some((t)=>$9052383c1c4e5569$var$Ea(t.text, e.text, e.text_matching || "exact") || $9052383c1c4e5569$var$Ea(t.$el_text, e.text, e.text_matching || "exact"));
        var s, n, o, a = (null == t || null == (i = t.properties) ? void 0 : i.$elements_chain) || "";
        return !!a && (s = function(t) {
            for(var e, i = [], r = /(?::|")text="(.*?)"/g; !$9052383c1c4e5569$var$H(e = r.exec(t));)i.includes(e[1]) || i.push(e[1]);
            return i;
        }(a), n = e.text, o = e.text_matching || "exact", s.some((t)=>$9052383c1c4e5569$var$Ea(t, n, o)));
    }
    Yn(t, e) {
        var i, r;
        if (null == e || !e.selector) return !0;
        var s = null == t || null == (i = t.properties) ? void 0 : i.$element_selectors;
        if (null != s && s.includes(e.selector)) return !0;
        var n = (null == t || null == (r = t.properties) ? void 0 : r.$elements_chain) || "";
        if (e.selector_regex && n) try {
            return new RegExp(e.selector_regex).test(n);
        } catch (t) {
            return !1;
        }
        return !1;
    }
    Xn(t) {
        var e;
        return null == (null == t || null == (e = t.properties) ? void 0 : e.$elements) ? [] : null == t ? void 0 : t.properties.$elements;
    }
    Vn(t, e) {
        return null == e || !e.properties || 0 === e.properties.length || $9052383c1c4e5569$var$ko(e.properties.reduce((t, e)=>{
            var i = $9052383c1c4e5569$var$M(e.value) ? e.value.map(String) : null != e.value ? [
                String(e.value)
            ] : [];
            return t[e.key] = {
                values: i,
                operator: e.operator || "exact"
            }, t;
        }, {}), null == t ? void 0 : t.properties);
    }
}
class $9052383c1c4e5569$var$$a {
    constructor(t){
        this._instance = t, this.es = new Map, this.ts = new Map, this.rs = new Map;
    }
    ns(t, e) {
        return !!t && $9052383c1c4e5569$var$ko(t.propertyFilters, null == e ? void 0 : e.properties);
    }
    ss(t, e) {
        var i = new Map;
        return t.forEach((t)=>{
            var r;
            null == (r = t.conditions) || null == (r = r[e]) || null == (r = r.values) || r.forEach((e)=>{
                if (null != e && e.name) {
                    var r = i.get(e.name) || [];
                    r.push(t.id), i.set(e.name, r);
                }
            });
        }), i;
    }
    os(t, e, i) {
        var r = (i === $9052383c1c4e5569$export$352273f853caad57.Activation ? this.es : this.ts).get(t), s = [];
        return this.ls((t)=>{
            s = t.filter((t)=>null == r ? void 0 : r.includes(t.id));
        }), s.filter((r)=>{
            var s, n = null == (s = r.conditions) || null == (s = s[i]) || null == (s = s.values) ? void 0 : s.find((e)=>e.name === t);
            return this.ns(n, e);
        });
    }
    register(t) {
        var e;
        $9052383c1c4e5569$var$U(null == (e = this._instance) ? void 0 : e._addCaptureHook) || (this.us(t), this.hs(t));
    }
    hs(t) {
        var e = t.filter((t)=>{
            var e, i;
            return (null == (e = t.conditions) ? void 0 : e.actions) && (null == (i = t.conditions) || null == (i = i.actions) || null == (i = i.values) ? void 0 : i.length) > 0;
        });
        0 !== e.length && (null == this.cs && (this.cs = new $9052383c1c4e5569$var$Sa(this._instance), this.cs.init(), this.cs.Qn((t)=>{
            this.onAction(t);
        })), e.forEach((t)=>{
            var e, i, r, s, n;
            t.conditions && null != (e = t.conditions) && e.actions && null != (i = t.conditions) && null != (i = i.actions) && i.values && (null == (r = t.conditions) || null == (r = r.actions) || null == (r = r.values) ? void 0 : r.length) > 0 && (null == (s = this.cs) || s.register(t.conditions.actions.values), null == (n = t.conditions) || null == (n = n.actions) || null == (n = n.values) || n.forEach((e)=>{
                if (e && e.name) {
                    var i = this.rs.get(e.name);
                    i && i.push(t.id), this.rs.set(e.name, i || [
                        t.id
                    ]);
                }
            }));
        }));
    }
    us(t) {
        var e, i = t.filter((t)=>{
            var e, i;
            return (null == (e = t.conditions) ? void 0 : e.events) && (null == (i = t.conditions) || null == (i = i.events) || null == (i = i.values) ? void 0 : i.length) > 0;
        }), r = t.filter((t)=>{
            var e, i;
            return (null == (e = t.conditions) ? void 0 : e.cancelEvents) && (null == (i = t.conditions) || null == (i = i.cancelEvents) || null == (i = i.values) ? void 0 : i.length) > 0;
        });
        0 === i.length && 0 === r.length || (null == (e = this._instance) || e._addCaptureHook((t, e)=>{
            this.onEvent(t, e);
        }), this.es = this.ss(t, $9052383c1c4e5569$export$352273f853caad57.Activation), this.ts = this.ss(t, $9052383c1c4e5569$export$352273f853caad57.Cancellation));
    }
    onEvent(t, e) {
        var i, r = this.le(), s = this.ds(), n = this.vs(), o = (null == (i = this._instance) || null == (i = i.persistence) ? void 0 : i.props[s]) || [];
        if (n === t && e && o.length > 0) {
            var a, l;
            r.info("event matched, removing item from activated items", {
                event: t,
                eventPayload: e,
                existingActivatedItems: o
            });
            var u = (null == e || null == (a = e.properties) ? void 0 : a.$survey_id) || (null == e || null == (l = e.properties) ? void 0 : l.$product_tour_id);
            if (u) {
                var h = o.indexOf(u);
                0 > h || (o.splice(h, 1), this.fs(o));
            }
        } else {
            if (this.ts.has(t)) {
                var d = this.os(t, e, $9052383c1c4e5569$export$352273f853caad57.Cancellation);
                d.length > 0 && (r.info("cancel event matched, cancelling items", {
                    event: t,
                    itemsToCancel: d.map((t)=>t.id)
                }), d.forEach((t)=>{
                    var e = o.indexOf(t.id);
                    0 > e || o.splice(e, 1), this.ps(t.id);
                }), this.fs(o));
            }
            if (this.es.has(t)) {
                r.info("event name matched", {
                    event: t,
                    eventPayload: e,
                    items: this.es.get(t)
                });
                var v = this.os(t, e, $9052383c1c4e5569$export$352273f853caad57.Activation);
                this.fs(o.concat(v.map((t)=>t.id) || []));
            }
        }
    }
    onAction(t) {
        var e, i = this.ds(), r = (null == (e = this._instance) || null == (e = e.persistence) ? void 0 : e.props[i]) || [];
        this.rs.has(t) && this.fs(r.concat(this.rs.get(t) || []));
    }
    fs(t) {
        var e = this.le(), i = [
            ...new Set(t)
        ].filter((t)=>!this.gs(t));
        e.info("updating activated items", {
            activatedItems: i
        }), this.ys(i);
    }
    getActivatedIds() {
        var t, e = this.ds();
        return (null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.props[e]) || [];
    }
    getEventToItemsMap() {
        return this.es;
    }
    bs() {
        return this.cs;
    }
}
class $9052383c1c4e5569$var$Ta extends $9052383c1c4e5569$var$$a {
    constructor(t){
        super(t);
    }
    ds() {
        return $9052383c1c4e5569$var$Oi;
    }
    vs() {
        return $9052383c1c4e5569$export$9d7ec1793ca1658e.SHOWN;
    }
    ls(t) {
        var e;
        null == (e = this._instance) || e.getSurveys(t);
    }
    ps(t) {
        var e;
        null == (e = this._instance) || e.cancelPendingSurvey(t);
    }
    le() {
        return $9052383c1c4e5569$var$Co;
    }
    ys(t) {
        var e;
        null == (e = this._instance) || null == (e = e.persistence) || e.register({
            [$9052383c1c4e5569$var$Oi]: t
        });
    }
    gs() {
        return !1;
    }
    getSurveys() {
        return this.getActivatedIds();
    }
    getEventToSurveys() {
        return this.getEventToItemsMap();
    }
}
var $9052383c1c4e5569$var$ka = "SDK is not enabled or survey functionality is not yet loaded", $9052383c1c4e5569$var$Ra = "Disabled. Not loading surveys.", $9052383c1c4e5569$var$Pa = null != $9052383c1c4e5569$var$t && $9052383c1c4e5569$var$t.location ? $9052383c1c4e5569$var$Ms($9052383c1c4e5569$var$t.location.hash, "__posthog") || $9052383c1c4e5569$var$Ms(location.hash, "state") : null, $9052383c1c4e5569$var$Oa = "_postHogToolbarParams", $9052383c1c4e5569$var$Ia = $9052383c1c4e5569$var$Ye("[Toolbar]"), $9052383c1c4e5569$var$Ca = $9052383c1c4e5569$var$Ye("[FeatureFlags]"), $9052383c1c4e5569$var$Aa = $9052383c1c4e5569$var$Ye("[FeatureFlags]", {
    debugEnabled: !0
}), $9052383c1c4e5569$var$Fa = "\" failed. Feature flags didn't load in time.", $9052383c1c4e5569$var$Ma = (t)=>{
    for(var e = {}, i = 0; t.length > i; i++)e[t[i]] = !0;
    return e;
}, $9052383c1c4e5569$var$Da = (t)=>{
    var e = {};
    for (var [i, r] of $9052383c1c4e5569$var$ur(t || {}))r && (e[i] = r);
    return e;
}, $9052383c1c4e5569$var$Na = $9052383c1c4e5569$var$Ye("[Error tracking]"), $9052383c1c4e5569$var$La = "Refusing to render web experiment since the viewer is a likely bot", $9052383c1c4e5569$var$Ua = {
    icontains: (e, i)=>!!$9052383c1c4e5569$var$t && i.href.toLowerCase().indexOf(e.toLowerCase()) > -1,
    not_icontains: (e, i)=>!!$9052383c1c4e5569$var$t && -1 === i.href.toLowerCase().indexOf(e.toLowerCase()),
    regex: (e, i)=>!!$9052383c1c4e5569$var$t && $9052383c1c4e5569$var$Eo(i.href, e),
    not_regex: (e, i)=>!!$9052383c1c4e5569$var$t && !$9052383c1c4e5569$var$Eo(i.href, e),
    exact: (t, e)=>e.href === t,
    is_not: (t, e)=>e.href !== t
};
class $9052383c1c4e5569$var$ja {
    get qt() {
        return this._instance.config;
    }
    constructor(t){
        var e = this;
        this.getWebExperimentsAndEvaluateDisplayLogic = function(t) {
            void 0 === t && (t = !1), e.getWebExperiments((t)=>{
                $9052383c1c4e5569$var$ja._s("retrieved web experiments from the server"), e.ws = new Map, t.forEach((t)=>{
                    if (t.feature_flag_key) {
                        var i;
                        e.ws && ($9052383c1c4e5569$var$ja._s("setting flag key ", t.feature_flag_key, " to web experiment ", t), null == (i = e.ws) || i.set(t.feature_flag_key, t));
                        var r = e._instance.getFeatureFlag(t.feature_flag_key);
                        $9052383c1c4e5569$var$j(r) && t.variants[r] && e.xs(t.name, r, t.variants[r].transforms);
                    } else if (t.variants) for(var s in t.variants){
                        var n = t.variants[s];
                        $9052383c1c4e5569$var$ja.ks(n) && e.xs(t.name, s, n.transforms);
                    }
                });
            }, t);
        }, this._instance = t, this._instance.onFeatureFlags((t)=>{
            this.onFeatureFlags(t);
        });
    }
    initialize() {}
    onFeatureFlags(t) {
        if (this._is_bot()) $9052383c1c4e5569$var$ja._s($9052383c1c4e5569$var$La);
        else if (!this.qt.disable_web_experiments) {
            if ($9052383c1c4e5569$var$H(this.ws)) return this.ws = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
            $9052383c1c4e5569$var$ja._s("applying feature flags", t), t.forEach((t)=>{
                var e;
                if (this.ws && null != (e = this.ws) && e.has(t)) {
                    var i, r = this._instance.getFeatureFlag(t), s = null == (i = this.ws) ? void 0 : i.get(t);
                    r && null != s && s.variants[r] && this.xs(s.name, r, s.variants[r].transforms);
                }
            });
        }
    }
    previewWebExperiment() {
        var t = $9052383c1c4e5569$var$ja.getWindowLocation();
        if (null != t && t.search) {
            var e = $9052383c1c4e5569$var$As(null == t ? void 0 : t.search, "__experiment_id"), i = $9052383c1c4e5569$var$As(null == t ? void 0 : t.search, "__experiment_variant");
            e && i && ($9052383c1c4e5569$var$ja._s("previewing web experiments " + e + " && " + i), this.getWebExperiments((t)=>{
                this.Ss(parseInt(e), i, t);
            }, !1, !0));
        }
    }
    loadIfEnabled() {
        this.qt.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
    }
    getWebExperiments(t, e, i) {
        if (this.qt.disable_web_experiments && !i) return t([]);
        var r = this._instance.get_property("$web_experiments");
        if (r && !e) return t(r);
        this._instance._send_request({
            url: this._instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this.qt.token),
            method: "GET",
            callback: (e)=>t(200 === e.statusCode && e.json && e.json.experiments || [])
        });
    }
    Ss(t, e, i) {
        var r = i.filter((e)=>e.id === t);
        r && r.length > 0 && ($9052383c1c4e5569$var$ja._s("Previewing web experiment [" + r[0].name + "] with variant [" + e + "]"), this.xs(r[0].name, e, r[0].variants[e].transforms));
    }
    static ks(t) {
        return !$9052383c1c4e5569$var$H(t.conditions) && $9052383c1c4e5569$var$ja.Cs(t) && $9052383c1c4e5569$var$ja.Is(t);
    }
    static Cs(t) {
        var e;
        if ($9052383c1c4e5569$var$H(t.conditions) || $9052383c1c4e5569$var$H(null == (e = t.conditions) ? void 0 : e.url)) return !0;
        var i, r, s, n = $9052383c1c4e5569$var$ja.getWindowLocation();
        return !!n && (null == (i = t.conditions) || !i.url || $9052383c1c4e5569$var$Ua[null !== (r = null == (s = t.conditions) ? void 0 : s.urlMatchType) && void 0 !== r ? r : "icontains"](t.conditions.url, n));
    }
    static getWindowLocation() {
        return null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.location;
    }
    static Is(t) {
        var e;
        if ($9052383c1c4e5569$var$H(t.conditions) || $9052383c1c4e5569$var$H(null == (e = t.conditions) ? void 0 : e.utm)) return !0;
        var i = $9052383c1c4e5569$var$zs();
        if (i.utm_source) {
            var r, s, n, o, a, l, u, h, d = null == (r = t.conditions) || null == (r = r.utm) || !r.utm_campaign || (null == (s = t.conditions) || null == (s = s.utm) ? void 0 : s.utm_campaign) == i.utm_campaign, v = null == (n = t.conditions) || null == (n = n.utm) || !n.utm_source || (null == (o = t.conditions) || null == (o = o.utm) ? void 0 : o.utm_source) == i.utm_source, c = null == (a = t.conditions) || null == (a = a.utm) || !a.utm_medium || (null == (l = t.conditions) || null == (l = l.utm) ? void 0 : l.utm_medium) == i.utm_medium, p = null == (u = t.conditions) || null == (u = u.utm) || !u.utm_term || (null == (h = t.conditions) || null == (h = h.utm) ? void 0 : h.utm_term) == i.utm_term;
            return d && c && p && v;
        }
        return !1;
    }
    static _s(t) {
        for(var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), r = 1; e > r; r++)i[r - 1] = arguments[r];
        $9052383c1c4e5569$var$We.info("[WebExperiments] " + t, i);
    }
    xs(t, e, i) {
        this._is_bot() ? $9052383c1c4e5569$var$ja._s($9052383c1c4e5569$var$La) : "control" !== e ? i.forEach((i)=>{
            if (i.selector) {
                var r;
                $9052383c1c4e5569$var$ja._s("applying transform of variant " + e + " for experiment " + t + " ", i);
                var s = null == (r = document) ? void 0 : r.querySelectorAll(i.selector);
                null == s || s.forEach((t)=>{
                    var e = t;
                    i.html && (e.innerHTML = i.html), i.css && e.setAttribute("style", i.css);
                });
            }
        }) : $9052383c1c4e5569$var$ja._s("Control variants leave the page unmodified.");
    }
    _is_bot() {
        return $9052383c1c4e5569$var$i && this._instance ? $9052383c1c4e5569$var$xo($9052383c1c4e5569$var$i, this.qt.custom_blocked_useragents) : void 0;
    }
}
var $9052383c1c4e5569$var$za = $9052383c1c4e5569$var$Ye("[Conversations]"), $9052383c1c4e5569$var$Ba = "Conversations not available yet.", $9052383c1c4e5569$var$Ha = {
    featureFlags: class {
        constructor(t){
            this.Ts = !1, this.Es = !1, this.Ms = !1, this.Rs = !1, this.Ps = !1, this.Os = !1, this.Ls = !1, this.As = !1, this._instance = t, this.featureFlagEventHandlers = [];
        }
        get qt() {
            return this._instance.config;
        }
        get Si() {
            return this._instance.persistence;
        }
        Fs(t) {
            return this._instance.get_property(t);
        }
        Ns() {
            var t, e;
            return null !== (t = null == (e = this.Si) ? void 0 : e.Mr(this.qt.feature_flag_cache_ttl_ms)) && void 0 !== t && t;
        }
        Ds() {
            return !!this.Ns() && (this.As || this.Ms || (this.As = !0, $9052383c1c4e5569$var$Ca.warn("Feature flag cache is stale, triggering refresh..."), this.reloadFeatureFlags()), !0);
        }
        $s() {
            var t, e = null !== (t = this.qt.evaluation_contexts) && void 0 !== t ? t : this.qt.evaluation_environments;
            return !this.qt.evaluation_environments || this.qt.evaluation_contexts || this.Ls || ($9052383c1c4e5569$var$Ca.warn("evaluation_environments is deprecated. Use evaluation_contexts instead. evaluation_environments will be removed in a future version."), this.Ls = !0), null != e && e.length ? e.filter((t)=>{
                var e = t && "string" == typeof t && t.trim().length > 0;
                return e || $9052383c1c4e5569$var$Ca.error("Invalid evaluation context found:", t, "Expected non-empty string"), e;
            }) : [];
        }
        qs() {
            return this.$s().length > 0;
        }
        js() {
            var t = this.qt.flag_keys;
            if (!$9052383c1c4e5569$var$U(t)) {
                if ($9052383c1c4e5569$var$M(t)) return t.filter((t)=>{
                    var e = t && "string" == typeof t && t.trim().length > 0;
                    return e || $9052383c1c4e5569$var$Ca.error("Invalid flag key found:", t, "Expected non-empty string"), e;
                });
                $9052383c1c4e5569$var$Ca.error("Invalid flag_keys found:", t, "Expected array of non-empty strings");
            }
        }
        initialize() {
            var t, e, { config: i } = this._instance, r = null !== (t = null == (e = i.bootstrap) ? void 0 : e.featureFlags) && void 0 !== t ? t : {};
            if (Object.keys(r).length) {
                var s, n, o = null !== (s = null == (n = i.bootstrap) ? void 0 : n.featureFlagPayloads) && void 0 !== s ? s : {}, a = Object.keys(r).filter((t)=>!!r[t]).reduce((t, e)=>(t[e] = r[e] || !1, t), {}), l = Object.keys(o).filter((t)=>a[t]).reduce((t, e)=>(o[e] && (t[e] = o[e]), t), {});
                this.receivedFeatureFlags({
                    featureFlags: a,
                    featureFlagPayloads: l
                });
            }
        }
        updateFlags(t, e, i) {
            var r = null != i && i.merge ? this.getFlagVariants() : {}, s = null != i && i.merge ? this.getFlagPayloads() : {}, n = $9052383c1c4e5569$var$f({}, r, t), o = $9052383c1c4e5569$var$f({}, s, e), a = {};
            for (var [l, u] of Object.entries(n)){
                var h = "string" == typeof u;
                a[l] = {
                    key: l,
                    enabled: !!h || Boolean(u),
                    variant: h ? u : void 0,
                    reason: void 0,
                    metadata: $9052383c1c4e5569$var$U(null == o ? void 0 : o[l]) ? void 0 : {
                        id: 0,
                        version: void 0,
                        description: void 0,
                        payload: o[l]
                    }
                };
            }
            this.receivedFeatureFlags({
                flags: a
            });
        }
        get hasLoadedFlags() {
            return this.Es;
        }
        getFlags() {
            return Object.keys(this.getFlagVariants());
        }
        getFlagsWithDetails() {
            var t = this.Fs($9052383c1c4e5569$var$wi), e = this.Fs($9052383c1c4e5569$var$Si), i = this.Fs($9052383c1c4e5569$var$$i);
            if (!i && !e) return t || {};
            var r = $9052383c1c4e5569$var$lr({}, t || {}), s = [
                ...new Set([
                    ...Object.keys(i || {}),
                    ...Object.keys(e || {})
                ])
            ];
            for (var n of s){
                var o, a, l = r[n], u = null == e ? void 0 : e[n], h = $9052383c1c4e5569$var$U(u) ? null !== (o = null == l ? void 0 : l.enabled) && void 0 !== o && o : !!u, d = $9052383c1c4e5569$var$U(u) ? l.variant : "string" == typeof u ? u : void 0, v = null == i ? void 0 : i[n], c = $9052383c1c4e5569$var$f({}, l, {
                    enabled: h,
                    variant: h ? null != d ? d : null == l ? void 0 : l.variant : void 0
                });
                h !== (null == l ? void 0 : l.enabled) && (c.original_enabled = null == l ? void 0 : l.enabled), d !== (null == l ? void 0 : l.variant) && (c.original_variant = null == l ? void 0 : l.variant), v && (c.metadata = $9052383c1c4e5569$var$f({}, null == l ? void 0 : l.metadata, {
                    payload: v,
                    original_payload: null == l || null == (a = l.metadata) ? void 0 : a.payload
                })), r[n] = c;
            }
            return this.Ts || ($9052383c1c4e5569$var$Ca.warn(" Overriding feature flag details!", {
                flagDetails: t,
                overriddenPayloads: i,
                finalDetails: r
            }), this.Ts = !0), r;
        }
        getFlagVariants() {
            var t = this.Fs($9052383c1c4e5569$var$mi), e = this.Fs($9052383c1c4e5569$var$Si);
            if (!e) return t || {};
            for(var i = $9052383c1c4e5569$var$lr({}, t), r = Object.keys(e), s = 0; r.length > s; s++)i[r[s]] = e[r[s]];
            return this.Ts || ($9052383c1c4e5569$var$Ca.warn(" Overriding feature flags!", {
                enabledFlags: t,
                overriddenFlags: e,
                finalFlags: i
            }), this.Ts = !0), i;
        }
        getFlagPayloads() {
            var t = this.Fs($9052383c1c4e5569$var$xi), e = this.Fs($9052383c1c4e5569$var$$i);
            if (!e) return t || {};
            for(var i = $9052383c1c4e5569$var$lr({}, t || {}), r = Object.keys(e), s = 0; r.length > s; s++)i[r[s]] = e[r[s]];
            return this.Ts || ($9052383c1c4e5569$var$Ca.warn(" Overriding feature flag payloads!", {
                flagPayloads: t,
                overriddenPayloads: e,
                finalPayloads: i
            }), this.Ts = !0), i;
        }
        reloadFeatureFlags() {
            this.Rs || this.qt.advanced_disable_feature_flags || this.Bs || (this._instance.ln.emit("featureFlagsReloading", !0), this.Bs = setTimeout(()=>{
                this.Hs();
            }, 5));
        }
        Us() {
            clearTimeout(this.Bs), this.Bs = void 0;
        }
        ensureFlagsLoaded() {
            this.Es || this.Ms || this.Bs || this.reloadFeatureFlags();
        }
        setAnonymousDistinctId(t) {
            this.$anon_distinct_id = t;
        }
        setReloadingPaused(t) {
            this.Rs = t;
        }
        Hs(t) {
            var e;
            if (this.Us(), !this._instance.Kr()) {
                if (this.Ms) this.Ps = !0;
                else {
                    var i = this.qt.token, r = this.Fs($9052383c1c4e5569$var$Qe), s = {
                        token: i,
                        distinct_id: this._instance.get_distinct_id(),
                        groups: this._instance.getGroups(),
                        $anon_distinct_id: this.$anon_distinct_id,
                        person_properties: $9052383c1c4e5569$var$f({}, (null == (e = this.Si) ? void 0 : e.get_initial_props()) || {}, this.Fs($9052383c1c4e5569$var$Ti) || {}),
                        group_properties: this.Fs($9052383c1c4e5569$var$ki),
                        timezone: $9052383c1c4e5569$var$Js()
                    };
                    $9052383c1c4e5569$var$B(r) || $9052383c1c4e5569$var$U(r) || (s.$device_id = r), (null != t && t.disableFlags || this.qt.advanced_disable_feature_flags) && (s.disable_flags = !0), this.qs() && (s.evaluation_contexts = this.$s());
                    var n = this.js();
                    $9052383c1c4e5569$var$U(n) || (s.flag_keys = n);
                    var o = !!this.qt.advanced_only_evaluate_survey_feature_flags, a = this._instance.requestRouter.endpointFor("flags", "/flags/?v=2" + (this.qt.advanced_only_evaluate_survey_feature_flags ? "&only_evaluate_survey_feature_flags=true" : ""));
                    this.Ms = !0, this._instance._send_request({
                        method: "POST",
                        url: a,
                        data: s,
                        compression: this.qt.disable_compression ? void 0 : $9052383c1c4e5569$export$6a00d17b5aff0af.Base64,
                        timeout: this.qt.feature_flag_request_timeout_ms,
                        callback: (t)=>{
                            var e, i, r, n = !0;
                            if (200 === t.statusCode && (this.Ps || (this.$anon_distinct_id = void 0), n = !1), this.Ms = !1, !s.disable_flags || this.Ps) {
                                this.Os = !n;
                                var a = [];
                                t.error ? t.error instanceof Error ? a.push("AbortError" === t.error.name ? "timeout" : "connection_error") : a.push("unknown_error") : 200 !== t.statusCode && a.push("api_error_" + t.statusCode), null != (e = t.json) && e.errorsWhileComputingFlags && a.push("errors_while_computing_flags");
                                var l, u = !(null == (i = t.json) || null == (i = i.quotaLimited) || !i.includes("feature_flags"));
                                if (u && a.push("quota_limited"), null == (r = this.Si) || r.register({
                                    [$9052383c1c4e5569$var$Fi]: a
                                }), u) $9052383c1c4e5569$var$Ca.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.");
                                else s.disable_flags || this.receivedFeatureFlags(null !== (l = t.json) && void 0 !== l ? l : {}, n, {
                                    partialResponse: o
                                }), this.Ps && (this.Ps = !1, this.Hs());
                            }
                        }
                    });
                }
            }
        }
        getFeatureFlag(t, e) {
            var i;
            if (void 0 === e && (e = {}), !e.fresh || this.Os) {
                if (this.Es || this.getFlags() && this.getFlags().length > 0) {
                    if (!this.Ds()) {
                        var r = this.getFeatureFlagResult(t, e);
                        return null !== (i = null == r ? void 0 : r.variant) && void 0 !== i ? i : null == r ? void 0 : r.enabled;
                    }
                } else $9052383c1c4e5569$var$Ca.warn('getFeatureFlag for key "' + t + $9052383c1c4e5569$var$Fa);
            }
        }
        getFeatureFlagDetails(t) {
            return this.getFlagsWithDetails()[t];
        }
        getFeatureFlagPayload(t) {
            var e = this.getFeatureFlagResult(t, {
                send_event: !1
            });
            return null == e ? void 0 : e.payload;
        }
        getFeatureFlagResult(t, e) {
            if (void 0 === e && (e = {}), !e.fresh || this.Os) {
                if (this.Es || this.getFlags() && this.getFlags().length > 0) {
                    if (!this.Ds()) {
                        var i = this.getFlagVariants(), r = t in i, s = i[t], n = this.getFlagPayloads()[t], o = String(s), a = this.Fs($9052383c1c4e5569$var$Ei) || void 0, l = this.Fs($9052383c1c4e5569$var$Mi) || void 0, u = this.Fs($9052383c1c4e5569$var$Ci) || {};
                        if (this.qt.advanced_feature_flags_dedup_per_session) {
                            var h, d = this._instance.get_session_id(), v = this.Fs($9052383c1c4e5569$var$Ai);
                            d && d !== v && (u = {}, null == (h = this.Si) || h.register({
                                [$9052383c1c4e5569$var$Ci]: u,
                                [$9052383c1c4e5569$var$Ai]: d
                            }));
                        }
                        if ((e.send_event || !("send_event" in e)) && (!(t in u) || !u[t].includes(o))) {
                            var c, p, f, _, g, m, b, y, w, x;
                            $9052383c1c4e5569$var$M(u[t]) ? u[t].push(o) : u[t] = [
                                o
                            ], null == (c = this.Si) || c.register({
                                [$9052383c1c4e5569$var$Ci]: u
                            });
                            var E = this.getFeatureFlagDetails(t), S = [
                                ...null !== (p = this.Fs($9052383c1c4e5569$var$Fi)) && void 0 !== p ? p : []
                            ];
                            $9052383c1c4e5569$var$U(s) && S.push("flag_missing");
                            var T = {
                                $feature_flag: t,
                                $feature_flag_response: s,
                                $feature_flag_payload: n || null,
                                $feature_flag_request_id: a,
                                $feature_flag_evaluated_at: l,
                                $feature_flag_bootstrapped_response: (null == (f = this.qt.bootstrap) || null == (f = f.featureFlags) ? void 0 : f[t]) || null,
                                $feature_flag_bootstrapped_payload: (null == (_ = this.qt.bootstrap) || null == (_ = _.featureFlagPayloads) ? void 0 : _[t]) || null,
                                $used_bootstrap_value: !this.Os
                            };
                            $9052383c1c4e5569$var$U(null == E || null == (g = E.metadata) ? void 0 : g.version) || (T.$feature_flag_version = E.metadata.version);
                            var k, R = null !== (m = null == E || null == (b = E.reason) ? void 0 : b.description) && void 0 !== m ? m : null == E || null == (y = E.reason) ? void 0 : y.code;
                            R && (T.$feature_flag_reason = R), null != E && null != (w = E.metadata) && w.id && (T.$feature_flag_id = E.metadata.id), $9052383c1c4e5569$var$U(null == E ? void 0 : E.original_variant) && $9052383c1c4e5569$var$U(null == E ? void 0 : E.original_enabled) || (T.$feature_flag_original_response = $9052383c1c4e5569$var$U(E.original_variant) ? E.original_enabled : E.original_variant), null != E && null != (x = E.metadata) && x.original_payload && (T.$feature_flag_original_payload = null == E || null == (k = E.metadata) ? void 0 : k.original_payload), S.length && (T.$feature_flag_error = S.join(",")), this._instance.capture("$feature_flag_called", T);
                        }
                        if (r) {
                            var P = n;
                            if (!$9052383c1c4e5569$var$U(n)) try {
                                P = JSON.parse(n);
                            } catch (t) {}
                            return {
                                key: t,
                                enabled: !!s,
                                variant: "string" == typeof s ? s : void 0,
                                payload: P
                            };
                        }
                    }
                } else $9052383c1c4e5569$var$Ca.warn('getFeatureFlagResult for key "' + t + $9052383c1c4e5569$var$Fa);
            }
        }
        getRemoteConfigPayload(t, e) {
            var i = this.qt.token, r = {
                distinct_id: this._instance.get_distinct_id(),
                token: i
            };
            this.qs() && (r.evaluation_contexts = this.$s());
            var s = this.js();
            $9052383c1c4e5569$var$U(s) || (r.flag_keys = s), this._instance._send_request({
                method: "POST",
                url: this._instance.requestRouter.endpointFor("flags", "/flags/?v=2"),
                data: r,
                compression: this.qt.disable_compression ? void 0 : $9052383c1c4e5569$export$6a00d17b5aff0af.Base64,
                timeout: this.qt.feature_flag_request_timeout_ms,
                callback (i) {
                    var r, s = null == (r = i.json) ? void 0 : r.featureFlagPayloads;
                    e((null == s ? void 0 : s[t]) || void 0);
                }
            });
        }
        isFeatureEnabled(t, e) {
            if (void 0 === e && (e = {}), !e.fresh || this.Os) {
                if (this.Es || this.getFlags() && this.getFlags().length > 0) {
                    var i = this.getFeatureFlag(t, e);
                    return $9052383c1c4e5569$var$U(i) ? void 0 : !!i;
                }
                $9052383c1c4e5569$var$Ca.warn('isFeatureEnabled for key "' + t + $9052383c1c4e5569$var$Fa);
            }
        }
        addFeatureFlagsHandler(t) {
            this.featureFlagEventHandlers.push(t);
        }
        removeFeatureFlagsHandler(t) {
            this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((e)=>e !== t);
        }
        receivedFeatureFlags(t, e, i) {
            if (this.Si) {
                this.Es = !0;
                var r = this.getFlagVariants(), s = this.getFlagPayloads(), n = this.getFlagsWithDetails();
                !function(t, e, i, r, s, n) {
                    void 0 === i && (i = {}), void 0 === r && (r = {}), void 0 === s && (s = {});
                    var o = ((t)=>{
                        var e = t.flags;
                        return e ? (t.featureFlags = Object.fromEntries(Object.keys(e).map((t)=>{
                            var i;
                            return [
                                t,
                                null !== (i = e[t].variant) && void 0 !== i ? i : e[t].enabled
                            ];
                        })), t.featureFlagPayloads = Object.fromEntries(Object.keys(e).filter((t)=>e[t].enabled).filter((t)=>{
                            var i;
                            return null == (i = e[t].metadata) ? void 0 : i.payload;
                        }).map((t)=>{
                            var i;
                            return [
                                t,
                                null == (i = e[t].metadata) ? void 0 : i.payload
                            ];
                        }))) : $9052383c1c4e5569$var$Ca.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), t;
                    })(t), a = o.flags, l = o.featureFlags, u = o.featureFlagPayloads;
                    if (l) {
                        var h = t.requestId, d = t.evaluatedAt;
                        if ($9052383c1c4e5569$var$M(l)) {
                            $9052383c1c4e5569$var$Ca.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
                            var v = {};
                            if (l) for(var c = 0; l.length > c; c++)v[l[c]] = !0;
                            e && e.register({
                                [$9052383c1c4e5569$var$bi]: l,
                                [$9052383c1c4e5569$var$mi]: v
                            });
                        } else {
                            var p = l, _ = u, g = a;
                            if (null != n && n.partialResponse) p = $9052383c1c4e5569$var$f({}, i, p), _ = $9052383c1c4e5569$var$f({}, r, _), g = $9052383c1c4e5569$var$f({}, s, g);
                            else if (t.errorsWhileComputingFlags) {
                                if (a) {
                                    var m = new Set(Object.keys(a).filter((t)=>{
                                        var e;
                                        return !(null != (e = a[t]) && e.failed);
                                    }));
                                    p = $9052383c1c4e5569$var$f({}, i, Object.fromEntries(Object.entries(p).filter((t)=>{
                                        var [e] = t;
                                        return m.has(e);
                                    }))), _ = $9052383c1c4e5569$var$f({}, r, Object.fromEntries(Object.entries(_ || {}).filter((t)=>{
                                        var [e] = t;
                                        return m.has(e);
                                    }))), g = $9052383c1c4e5569$var$f({}, s, Object.fromEntries(Object.entries(g || {}).filter((t)=>{
                                        var [e] = t;
                                        return m.has(e);
                                    })));
                                } else p = $9052383c1c4e5569$var$f({}, i, p), _ = $9052383c1c4e5569$var$f({}, r, _), g = $9052383c1c4e5569$var$f({}, s, g);
                            }
                            e && e.register($9052383c1c4e5569$var$f({
                                [$9052383c1c4e5569$var$bi]: Object.keys($9052383c1c4e5569$var$Da(p)),
                                [$9052383c1c4e5569$var$mi]: p || {},
                                [$9052383c1c4e5569$var$xi]: _ || {},
                                [$9052383c1c4e5569$var$wi]: g || {}
                            }, h ? {
                                [$9052383c1c4e5569$var$Ei]: h
                            } : {}, d ? {
                                [$9052383c1c4e5569$var$Mi]: d
                            } : {}));
                        }
                    }
                }(t, this.Si, r, s, n, i), e || (this.As = !1), this.zs(e);
            }
        }
        override(t, e) {
            void 0 === e && (e = !1), $9052383c1c4e5569$var$Ca.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({
                flags: t,
                suppressWarning: e
            });
        }
        overrideFeatureFlags(t) {
            if (!this._instance.__loaded || !this.Si) return $9052383c1c4e5569$var$Ca.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
            if (!1 === t) return this.Si.unregister($9052383c1c4e5569$var$Si), this.Si.unregister($9052383c1c4e5569$var$$i), this.zs(), $9052383c1c4e5569$var$Aa.info("All overrides cleared");
            if ($9052383c1c4e5569$var$M(t)) {
                var e = $9052383c1c4e5569$var$Ma(t);
                return this.Si.register({
                    [$9052383c1c4e5569$var$Si]: e
                }), this.zs(), $9052383c1c4e5569$var$Aa.info("Flag overrides set", {
                    flags: t
                });
            }
            if (t && "object" == typeof t && ("flags" in t || "payloads" in t)) {
                var i, r = t;
                if (this.Ts = Boolean(null !== (i = r.suppressWarning) && void 0 !== i && i), "flags" in r) {
                    if (!1 === r.flags) this.Si.unregister($9052383c1c4e5569$var$Si), $9052383c1c4e5569$var$Aa.info("Flag overrides cleared");
                    else if (r.flags) {
                        if ($9052383c1c4e5569$var$M(r.flags)) {
                            var s = $9052383c1c4e5569$var$Ma(r.flags);
                            this.Si.register({
                                [$9052383c1c4e5569$var$Si]: s
                            });
                        } else this.Si.register({
                            [$9052383c1c4e5569$var$Si]: r.flags
                        });
                        $9052383c1c4e5569$var$Aa.info("Flag overrides set", {
                            flags: r.flags
                        });
                    }
                }
                return "payloads" in r && (!1 === r.payloads ? (this.Si.unregister($9052383c1c4e5569$var$$i), $9052383c1c4e5569$var$Aa.info("Payload overrides cleared")) : r.payloads && (this.Si.register({
                    [$9052383c1c4e5569$var$$i]: r.payloads
                }), $9052383c1c4e5569$var$Aa.info("Payload overrides set", {
                    payloads: r.payloads
                }))), void this.zs();
            }
            if (t && "object" == typeof t) return this.Si.register({
                [$9052383c1c4e5569$var$Si]: t
            }), this.zs(), $9052383c1c4e5569$var$Aa.info("Flag overrides set", {
                flags: t
            });
            $9052383c1c4e5569$var$Ca.warn("Invalid overrideOptions provided to overrideFeatureFlags", {
                overrideOptions: t
            });
        }
        onFeatureFlags(t) {
            if (this.addFeatureFlagsHandler(t), this.Es) {
                var { flags: e, flagVariants: i } = this.Vs();
                t(e, i);
            }
            return ()=>this.removeFeatureFlagsHandler(t);
        }
        updateEarlyAccessFeatureEnrollment(t, e, i) {
            var r, s = (this.Fs($9052383c1c4e5569$var$yi) || []).find((e)=>e.flagKey === t), n = {
                ["$feature_enrollment/" + t]: e
            }, o = {
                $feature_flag: t,
                $feature_enrollment: e,
                $set: n
            };
            s && (o.$early_access_feature_name = s.name), i && (o.$feature_enrollment_stage = i), this._instance.capture("$feature_enrollment_update", o), this.setPersonPropertiesForFlags(n, !1);
            var a = $9052383c1c4e5569$var$f({}, this.getFlagVariants(), {
                [t]: e
            });
            null == (r = this.Si) || r.register({
                [$9052383c1c4e5569$var$bi]: Object.keys($9052383c1c4e5569$var$Da(a)),
                [$9052383c1c4e5569$var$mi]: a
            }), this.zs();
        }
        getEarlyAccessFeatures(t, e, i) {
            void 0 === e && (e = !1);
            var r = this.Fs($9052383c1c4e5569$var$yi), s = i ? "&" + i.map((t)=>"stage=" + t).join("&") : "";
            if (r && !e) return t(r);
            this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this.qt.token + s),
                method: "GET",
                callback: (e)=>{
                    var i, r;
                    if (e.json) {
                        var s = e.json.earlyAccessFeatures;
                        return null == (i = this.Si) || i.unregister($9052383c1c4e5569$var$yi), null == (r = this.Si) || r.register({
                            [$9052383c1c4e5569$var$yi]: s
                        }), t(s);
                    }
                }
            });
        }
        Vs() {
            var t = this.getFlags(), e = this.getFlagVariants();
            return {
                flags: t.filter((t)=>e[t]),
                flagVariants: Object.keys(e).filter((t)=>e[t]).reduce((t, i)=>(t[i] = e[i], t), {})
            };
        }
        zs(t) {
            var { flags: e, flagVariants: i } = this.Vs();
            this.featureFlagEventHandlers.forEach((r)=>r(e, i, {
                    errorsLoading: t
                }));
        }
        setPersonPropertiesForFlags(t, e) {
            void 0 === e && (e = !0);
            var i = this.Fs($9052383c1c4e5569$var$Ti) || {}, r = (null == t ? void 0 : t.$set) || (null != t && t.$set_once ? {} : t), s = null == t ? void 0 : t.$set_once, n = {};
            if (s) for(var o in s)({}).hasOwnProperty.call(s, o) && (o in i || (n[o] = s[o]));
            this._instance.register({
                [$9052383c1c4e5569$var$Ti]: $9052383c1c4e5569$var$f({}, i, n, r)
            }), e && this._instance.reloadFeatureFlags();
        }
        resetPersonPropertiesForFlags(t) {
            void 0 === t && (t = !0), this._instance.unregister($9052383c1c4e5569$var$Ti), t && this._instance.reloadFeatureFlags();
        }
        setGroupPropertiesForFlags(t, e) {
            void 0 === e && (e = !0);
            var i = this.Fs($9052383c1c4e5569$var$ki) || {};
            0 !== Object.keys(i).length && Object.keys(i).forEach((e)=>{
                i[e] = $9052383c1c4e5569$var$f({}, i[e], t[e]), delete t[e];
            }), this._instance.register({
                [$9052383c1c4e5569$var$ki]: $9052383c1c4e5569$var$f({}, i, t)
            }), e && this._instance.reloadFeatureFlags();
        }
        resetGroupPropertiesForFlags(t) {
            if (t) {
                var e = this.Fs($9052383c1c4e5569$var$ki) || {};
                this._instance.register({
                    [$9052383c1c4e5569$var$ki]: $9052383c1c4e5569$var$f({}, e, {
                        [t]: {}
                    })
                });
            } else this._instance.unregister($9052383c1c4e5569$var$ki);
        }
        reset() {
            this.Es = !1, this.Ms = !1, this.Rs = !1, this.Ps = !1, this.Os = !1, this.$anon_distinct_id = void 0, this.Us(), this.Ts = !1;
        }
    }
}, $9052383c1c4e5569$var$Va = {
    sessionRecording: class {
        get qt() {
            return this._instance.config;
        }
        get Si() {
            return this._instance.persistence;
        }
        get started() {
            var t;
            return !(null == (t = this.Ws) || !t.isStarted);
        }
        get status() {
            var t, e;
            return this.Gs === $9052383c1c4e5569$var$va || this.Gs === $9052383c1c4e5569$var$ca ? this.Gs : null !== (t = null == (e = this.Ws) ? void 0 : e.status) && void 0 !== t ? t : this.Gs;
        }
        constructor(t){
            if (this._forceAllowLocalhostNetworkCapture = !1, this.Gs = $9052383c1c4e5569$var$ha, this.Zs = void 0, this._instance = t, !this._instance.sessionManager) throw $9052383c1c4e5569$var$fa.error("started without valid sessionManager"), new Error($9052383c1c4e5569$var$pa + " started without valid sessionManager. This is a bug.");
            if (this.qt.cookieless_mode === $9052383c1c4e5569$var$Ki) throw new Error($9052383c1c4e5569$var$pa + ' cannot be used with cookieless_mode="always"');
        }
        initialize() {
            this.startIfEnabledOrStop();
        }
        get Qs() {
            var e, i = !(null == (e = this._instance.get_property($9052383c1c4e5569$var$hi)) || !e.enabled), r = !this.qt.disable_session_recording, s = this.qt.disable_session_recording || this._instance.consent.isOptedOut();
            return $9052383c1c4e5569$var$t && i && r && !s;
        }
        startIfEnabledOrStop(t) {
            var e;
            if (!this.Qs || null == (e = this.Ws) || !e.isStarted) {
                var i = !$9052383c1c4e5569$var$U(Object.assign) && !$9052383c1c4e5569$var$U(Array.from);
                this.Qs && i ? (this.Js(t), $9052383c1c4e5569$var$fa.info("starting")) : (this.Gs = $9052383c1c4e5569$var$ha, this.stopRecording());
            }
        }
        Js(t) {
            var e, i, r;
            this.Qs && (this.Gs !== $9052383c1c4e5569$var$va && this.Gs !== $9052383c1c4e5569$var$ca && (this.Gs = $9052383c1c4e5569$var$da), null != $9052383c1c4e5569$var$h && null != (e = $9052383c1c4e5569$var$h.__PosthogExtensions__) && null != (e = e.rrweb) && e.record && null != (i = $9052383c1c4e5569$var$h.__PosthogExtensions__) && i.initSessionRecording ? this.Ks(t) : null == (r = $9052383c1c4e5569$var$h.__PosthogExtensions__) || null == r.loadExternalDependency || r.loadExternalDependency(this._instance, this.Ys, (e)=>{
                if (e) return $9052383c1c4e5569$var$fa.error("could not load recorder", e);
                this.Ks(t);
            }));
        }
        stopRecording() {
            var t, e;
            null == (t = this.Zs) || t.call(this), this.Zs = void 0, null == (e = this.Ws) || e.stop();
        }
        Xs() {
            var t, e;
            null == (t = this.Zs) || t.call(this), this.Zs = void 0, null == (e = this.Ws) || e.discard();
        }
        eo() {
            var t, e;
            null == (t = this.Si) || t.unregister($9052383c1c4e5569$var$gi), null == (e = this.Si) || e.unregister($9052383c1c4e5569$var$di);
        }
        ro(t, e) {
            if ($9052383c1c4e5569$var$H(t)) return null;
            var i, r = $9052383c1c4e5569$var$V(t) ? t : parseFloat(t);
            return "number" != typeof (i = r) || !Number.isFinite(i) || 0 > i || i > 1 ? ($9052383c1c4e5569$var$fa.warn(e + " must be between 0 and 1. Ignoring invalid value:", t), null) : r;
        }
        io(t) {
            if (this.Si) {
                var e, i, r = this.Si, s = ()=>{
                    var e, i = !1 === t.sessionRecording ? void 0 : t.sessionRecording, s = this.ro(null == (e = this.qt.session_recording) ? void 0 : e.sampleRate, "session_recording.sampleRate"), n = this.ro(null == i ? void 0 : i.sampleRate, "remote config sampleRate"), o = null != s ? s : n;
                    $9052383c1c4e5569$var$H(o) && this.eo();
                    var a = null == i ? void 0 : i.minimumDurationMilliseconds;
                    r.register({
                        [$9052383c1c4e5569$var$hi]: $9052383c1c4e5569$var$f({
                            cache_timestamp: Date.now(),
                            enabled: !!i
                        }, i, {
                            networkPayloadCapture: $9052383c1c4e5569$var$f({
                                capturePerformance: t.capturePerformance
                            }, null == i ? void 0 : i.networkPayloadCapture),
                            canvasRecording: {
                                enabled: null == i ? void 0 : i.recordCanvas,
                                fps: null == i ? void 0 : i.canvasFps,
                                quality: null == i ? void 0 : i.canvasQuality
                            },
                            sampleRate: o,
                            minimumDurationMilliseconds: $9052383c1c4e5569$var$U(a) ? null : a,
                            endpoint: null == i ? void 0 : i.endpoint,
                            triggerMatchType: null == i ? void 0 : i.triggerMatchType,
                            masking: null == i ? void 0 : i.masking,
                            urlTriggers: null == i ? void 0 : i.urlTriggers,
                            version: null == i ? void 0 : i.version,
                            triggerGroups: null == i ? void 0 : i.triggerGroups
                        })
                    });
                };
                s(), null == (e = this.Zs) || e.call(this), this.Zs = null == (i = this._instance.sessionManager) ? void 0 : i.onSessionId(s);
            }
        }
        onRemoteConfig(t) {
            return "sessionRecording" in t ? !1 === t.sessionRecording ? (this.io(t), void this.Xs()) : (this.io(t), void this.startIfEnabledOrStop()) : (this.Gs === $9052383c1c4e5569$var$va && (this.Gs = $9052383c1c4e5569$var$ca, $9052383c1c4e5569$var$fa.warn("config refresh failed, recording will not start until page reload")), void this.startIfEnabledOrStop());
        }
        log(t, e) {
            var i;
            void 0 === e && (e = "log"), null != (i = this.Ws) && i.log ? this.Ws.log(t, e) : $9052383c1c4e5569$var$fa.warn("log called before recorder was ready");
        }
        get Ys() {
            var t, e, i = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.get_property($9052383c1c4e5569$var$hi);
            return (null == i || null == (e = i.scriptConfig) ? void 0 : e.script) || "lazy-recorder";
        }
        no() {
            var t, e, i = this._instance.get_property($9052383c1c4e5569$var$hi);
            if (!i) return !1;
            try {
                e = "object" == typeof i ? i : JSON.parse(i);
            } catch (t) {
                return $9052383c1c4e5569$var$fa.warn("persisted remote config for session recording is invalid and will be ignored", t), !1;
            }
            var r = null !== (t = e.cache_timestamp) && void 0 !== t ? t : Date.now();
            return 36e5 >= Date.now() - r;
        }
        Ks(t) {
            var e, i;
            if (null == (e = $9052383c1c4e5569$var$h.__PosthogExtensions__) || !e.initSessionRecording) return $9052383c1c4e5569$var$fa.warn("Called on script loaded before session recording is available. This can be caused by adblockers."), void this._instance.register_for_session({
                [$9052383c1c4e5569$var$Wi]: !0
            });
            if (this.Ws || (this.Ws = null == (i = $9052383c1c4e5569$var$h.__PosthogExtensions__) ? void 0 : i.initSessionRecording(this._instance), this.Ws._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture), !this.no()) {
                if (this.Gs === $9052383c1c4e5569$var$ca || this.Gs === $9052383c1c4e5569$var$va) return;
                return this.Gs = $9052383c1c4e5569$var$va, $9052383c1c4e5569$var$fa.info("persisted remote config is stale, requesting fresh config before starting"), void new $9052383c1c4e5569$var$bn(this._instance).load();
            }
            this.Gs = $9052383c1c4e5569$var$da, this.Ws.start(t);
        }
        onRRwebEmit(t) {
            var e;
            null == (e = this.Ws) || null == e.onRRwebEmit || e.onRRwebEmit(t);
        }
        overrideLinkedFlag() {
            var t, e;
            this.Ws || null == (e = this.Si) || e.register({
                [$9052383c1c4e5569$var$ci]: !0
            }), null == (t = this.Ws) || t.overrideLinkedFlag();
        }
        overrideSampling() {
            var t, e;
            this.Ws || null == (e = this.Si) || e.register({
                [$9052383c1c4e5569$var$vi]: !0
            }), null == (t = this.Ws) || t.overrideSampling();
        }
        overrideTrigger(t) {
            var e, i;
            this.Ws || null == (i = this.Si) || i.register({
                ["url" === t ? $9052383c1c4e5569$var$pi : $9052383c1c4e5569$var$fi]: !0
            }), null == (e = this.Ws) || e.overrideTrigger(t);
        }
        get sdkDebugProperties() {
            var t;
            return (null == (t = this.Ws) ? void 0 : t.sdkDebugProperties) || {
                $recording_status: this.status
            };
        }
        tryAddCustomEvent(t, e) {
            var i;
            return !(null == (i = this.Ws) || !i.tryAddCustomEvent(t, e));
        }
    }
}, $9052383c1c4e5569$var$qa = {
    autocapture: class {
        constructor(t){
            this.so = !1, this.oo = null, this.ao = !1, this.instance = t, this.rageclicks = new $9052383c1c4e5569$var$ta(t.config.rageclick), this.lo = null;
        }
        initialize() {
            this.startIfEnabled();
        }
        get qt() {
            var t, e, i = $9052383c1c4e5569$var$N(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
            return i.url_allowlist = null == (t = i.url_allowlist) ? void 0 : t.map((t)=>new RegExp(t)), i.url_ignorelist = null == (e = i.url_ignorelist) ? void 0 : e.map((t)=>new RegExp(t)), i;
        }
        uo() {
            if (this.isBrowserSupported()) {
                if ($9052383c1c4e5569$var$t && $9052383c1c4e5569$var$r) {
                    var e = (e)=>{
                        e = e || (null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.event);
                        try {
                            this.ho(e);
                        } catch (t) {
                            $9052383c1c4e5569$var$ia.error("Failed to capture event", t);
                        }
                    };
                    if ($9052383c1c4e5569$var$fr($9052383c1c4e5569$var$r, "submit", e, {
                        capture: !0
                    }), $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$r, "change", e, {
                        capture: !0
                    }), $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$r, "click", e, {
                        capture: !0
                    }), this.qt.capture_copied_text) {
                        var i = (e)=>{
                            e = e || (null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.event);
                            try {
                                this.ho(e, $9052383c1c4e5569$var$ea);
                            } catch (t) {
                                $9052383c1c4e5569$var$ia.error("Failed to capture copy/cut event", t);
                            }
                        };
                        $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$r, "copy", i, {
                            capture: !0
                        }), $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$r, "cut", i, {
                            capture: !0
                        });
                    }
                }
            } else $9052383c1c4e5569$var$ia.info("Disabling Automatic Event Collection because this browser is not supported");
        }
        startIfEnabled() {
            this.isEnabled && !this.so && (this.uo(), this.so = !0);
        }
        onRemoteConfig(t) {
            t.elementsChainAsString && (this.ao = t.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({
                [$9052383c1c4e5569$var$ei]: !!t.autocapture_opt_out
            }), this.oo = !!t.autocapture_opt_out, this.startIfEnabled();
        }
        setElementSelectors(t) {
            this.lo = t;
        }
        getElementSelectors(t) {
            var e, i = [];
            return null == (e = this.lo) || e.forEach((e)=>{
                var s = null == $9052383c1c4e5569$var$r ? void 0 : $9052383c1c4e5569$var$r.querySelectorAll(e);
                null == s || s.forEach((r)=>{
                    t === r && i.push(e);
                });
            }), i;
        }
        get isEnabled() {
            var t, e, i = null == (t = this.instance.persistence) ? void 0 : t.props[$9052383c1c4e5569$var$ei];
            if ($9052383c1c4e5569$var$B(this.oo) && !$9052383c1c4e5569$var$G(i) && !this.instance.Kr()) return !1;
            var r = null !== (e = this.oo) && void 0 !== e ? e : !!i;
            return !!this.instance.config.autocapture && !r;
        }
        ho(e, i) {
            if (void 0 === i && (i = "$autocapture"), this.isEnabled) {
                var r, s = $9052383c1c4e5569$var$Yr(e);
                $9052383c1c4e5569$var$zr(s) && (s = s.parentNode || null), "$autocapture" === i && "click" === e.type && e instanceof MouseEvent && this.instance.config.rageclick && null != (r = this.rageclicks) && r.isRageClick(e.clientX, e.clientY, e.timeStamp || (new Date).getTime()) && $9052383c1c4e5569$var$rs(s, this.instance.config.rageclick) && this.ho(e, "$rageclick");
                var n = i === $9052383c1c4e5569$var$ea;
                if (s && function(e, i, r, s, n) {
                    var o, a, l, u;
                    if (void 0 === r && (r = void 0), !$9052383c1c4e5569$var$t || $9052383c1c4e5569$var$ss(e)) return !1;
                    if (null != (o = r) && o.url_allowlist && !$9052383c1c4e5569$var$Vr(r.url_allowlist)) return !1;
                    if (null != (a = r) && a.url_ignorelist && $9052383c1c4e5569$var$Vr(r.url_ignorelist)) return !1;
                    if (null != (l = r) && l.dom_event_allowlist) {
                        var h = r.dom_event_allowlist;
                        if (h && !h.some((t)=>i.type === t)) return !1;
                    }
                    var { parentIsUsefulElement: d, targetElementList: v } = $9052383c1c4e5569$var$ns(e, s);
                    if (!function(t, e) {
                        var i = null == e ? void 0 : e.element_allowlist;
                        if ($9052383c1c4e5569$var$U(i)) return !0;
                        var r, s = function(t) {
                            if (i.some((e)=>t.tagName.toLowerCase() === e)) return {
                                v: !0
                            };
                        };
                        for (var n of t)if (r = s(n)) return r.v;
                        return !1;
                    }(v, r)) return !1;
                    if (!$9052383c1c4e5569$var$Kr(v, null == (u = r) ? void 0 : u.css_selector_allowlist)) return !1;
                    var c = $9052383c1c4e5569$var$t.getComputedStyle(e);
                    if (c && "pointer" === c.getPropertyValue("cursor") && "click" === i.type) return !0;
                    var p = e.tagName.toLowerCase();
                    switch(p){
                        case "html":
                            return !1;
                        case "form":
                            return (n || [
                                "submit"
                            ]).indexOf(i.type) >= 0;
                        case "input":
                        case "select":
                        case "textarea":
                            return (n || [
                                "change",
                                "click"
                            ]).indexOf(i.type) >= 0;
                        default:
                            return d ? (n || [
                                "click"
                            ]).indexOf(i.type) >= 0 : (n || [
                                "click"
                            ]).indexOf(i.type) >= 0 && ($9052383c1c4e5569$var$Jr.indexOf(p) > -1 || "true" === e.getAttribute("contenteditable"));
                    }
                }(s, e, this.qt, n, n ? [
                    "copy",
                    "cut"
                ] : void 0)) {
                    var { props: o, explicitNoCapture: a } = $9052383c1c4e5569$var$na(s, {
                        e: e,
                        maskAllElementAttributes: this.instance.config.mask_all_element_attributes,
                        maskAllText: this.instance.config.mask_all_text,
                        elementAttributeIgnoreList: this.qt.element_attribute_ignorelist,
                        elementsChainAsString: this.ao
                    });
                    if (a) return !1;
                    var l = this.getElementSelectors(s);
                    if (l && l.length > 0 && (o.$element_selectors = l), i === $9052383c1c4e5569$var$ea) {
                        var u, h = $9052383c1c4e5569$var$Gr(null == $9052383c1c4e5569$var$t || null == (u = $9052383c1c4e5569$var$t.getSelection()) ? void 0 : u.toString()), d = e.type || "clipboard";
                        if (!h) return !1;
                        o.$selected_content = h, o.$copy_type = d;
                    }
                    return this.instance.capture(i, o), !0;
                }
            }
        }
        isBrowserSupported() {
            return $9052383c1c4e5569$var$D(null == $9052383c1c4e5569$var$r ? void 0 : $9052383c1c4e5569$var$r.querySelectorAll);
        }
    },
    historyAutocapture: class {
        constructor(e){
            var i;
            this._instance = e, this.co = (null == $9052383c1c4e5569$var$t || null == (i = $9052383c1c4e5569$var$t.location) ? void 0 : i.pathname) || "";
        }
        initialize() {
            this.startIfEnabled();
        }
        get isEnabled() {
            return "history_change" === this._instance.config.capture_pageview;
        }
        startIfEnabled() {
            this.isEnabled && ($9052383c1c4e5569$var$We.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
        }
        stop() {
            this.do && this.do(), this.do = void 0, $9052383c1c4e5569$var$We.info("History API monitoring stopped");
        }
        monitorHistoryChanges() {
            $9052383c1c4e5569$var$t && $9052383c1c4e5569$var$t.history && (this.vo("pushState"), this.vo("replaceState"), this.fo());
        }
        vo(e) {
            var i;
            if ($9052383c1c4e5569$var$t && (null == (i = $9052383c1c4e5569$var$t.history[e]) || !i.__posthog_wrapped__)) {
                var r = this;
                !function(t, e, i) {
                    try {
                        if (!(e in t)) return ()=>{};
                        var r = t[e], s = i(r);
                        return $9052383c1c4e5569$var$D(s) && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
                            __posthog_wrapped__: {
                                enumerable: !1,
                                value: !0
                            }
                        })), t[e] = s, ()=>{
                            t[e] === s && (t[e] = r);
                        };
                    } catch (t) {
                        return ()=>{};
                    }
                }($9052383c1c4e5569$var$t.history, e, (t)=>function(i, s, n) {
                        t.call(this, i, s, n), r.po(e);
                    });
            }
        }
        po(e) {
            try {
                var i, r = null == $9052383c1c4e5569$var$t || null == (i = $9052383c1c4e5569$var$t.location) ? void 0 : i.pathname;
                if (!r) return;
                r !== this.co && this.isEnabled && this._instance.capture($9052383c1c4e5569$var$ir, {
                    navigation_type: e
                }), this.co = r;
            } catch (t) {
                $9052383c1c4e5569$var$We.error("Error capturing " + e + " pageview", t);
            }
        }
        fo() {
            if (!this.do) {
                var e = ()=>{
                    this.po("popstate");
                };
                $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$t, "popstate", e), this.do = ()=>{
                    $9052383c1c4e5569$var$t && $9052383c1c4e5569$var$t.removeEventListener("popstate", e);
                };
            }
        }
    },
    heatmaps: class {
        get qt() {
            return this.instance.config;
        }
        constructor(t){
            var e;
            this.mo = !1, this.so = !1, this.yo = null, this.instance = t, this.mo = !(null == (e = this.instance.persistence) || !e.props[$9052383c1c4e5569$var$ii]), this.rageclicks = new $9052383c1c4e5569$var$ta(t.config.rageclick);
        }
        initialize() {
            this.startIfEnabled();
        }
        get flushIntervalMilliseconds() {
            var t = 5e3;
            return $9052383c1c4e5569$var$N(this.qt.capture_heatmaps) && this.qt.capture_heatmaps.flush_interval_milliseconds && (t = this.qt.capture_heatmaps.flush_interval_milliseconds), t;
        }
        get isEnabled() {
            return $9052383c1c4e5569$var$H(this.qt.capture_heatmaps) ? $9052383c1c4e5569$var$H(this.qt.enable_heatmaps) ? this.mo : this.qt.enable_heatmaps : !1 !== this.qt.capture_heatmaps;
        }
        startIfEnabled() {
            if (this.isEnabled) {
                if (this.so) return;
                $9052383c1c4e5569$var$_a.info("starting..."), this.bo(), this.At();
            } else {
                var t;
                clearInterval(null !== (t = this.yo) && void 0 !== t ? t : void 0), this._o(), this.getAndClearBuffer();
            }
        }
        onRemoteConfig(t) {
            if ("heatmaps" in t) {
                var e = !!t.heatmaps;
                this.instance.persistence && this.instance.persistence.register({
                    [$9052383c1c4e5569$var$ii]: e
                }), this.mo = e, this.startIfEnabled();
            }
        }
        getAndClearBuffer() {
            var t = this.M;
            return this.M = void 0, t;
        }
        wo(t) {
            this.Mt(t.originalEvent, "deadclick");
        }
        At() {
            this.yo && clearInterval(this.yo), this.yo = "visible" === (null == $9052383c1c4e5569$var$r ? void 0 : $9052383c1c4e5569$var$r.visibilityState) ? setInterval(this.ci.bind(this), this.flushIntervalMilliseconds) : null;
        }
        bo() {
            $9052383c1c4e5569$var$t && $9052383c1c4e5569$var$r && (this.xo = this.ci.bind(this), $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$t, $9052383c1c4e5569$var$er, this.xo), this.ko = (e)=>this.Mt(e || (null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.event)), $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$r, "click", this.ko, {
                capture: !0
            }), this.So = (e)=>this.Co(e || (null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.event)), $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$r, "mousemove", this.So, {
                capture: !0
            }), this.Io = new $9052383c1c4e5569$var$xs(this.instance, $9052383c1c4e5569$var$ys, this.wo.bind(this)), this.Io.startIfEnabledOrStop(), this.To = this.At.bind(this), $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$r, $9052383c1c4e5569$var$tr, this.To), this.so = !0);
        }
        _o() {
            var e;
            $9052383c1c4e5569$var$t && $9052383c1c4e5569$var$r && (this.xo && $9052383c1c4e5569$var$t.removeEventListener($9052383c1c4e5569$var$er, this.xo), this.ko && $9052383c1c4e5569$var$r.removeEventListener("click", this.ko, {
                capture: !0
            }), this.So && $9052383c1c4e5569$var$r.removeEventListener("mousemove", this.So, {
                capture: !0
            }), this.To && $9052383c1c4e5569$var$r.removeEventListener($9052383c1c4e5569$var$tr, this.To), clearTimeout(this.Eo), null == (e = this.Io) || e.stop(), this.so = !1);
        }
        Mo(e, i) {
            var r = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), n = this.instance.scrollManager.scrollElement(), o = function(e, i, r) {
                for(var s = e; s && $9052383c1c4e5569$var$Ur(s) && !$9052383c1c4e5569$var$jr(s, "body");){
                    if (s === r) return !1;
                    if ($9052383c1c4e5569$var$P(i, null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.getComputedStyle(s).position)) return !0;
                    s = $9052383c1c4e5569$var$Xr(s);
                }
                return !1;
            }($9052383c1c4e5569$var$Yr(e), [
                "fixed",
                "sticky"
            ], n);
            return {
                x: e.clientX + (o ? 0 : s),
                y: e.clientY + (o ? 0 : r),
                target_fixed: o,
                type: i
            };
        }
        Mt(t, e) {
            var i;
            if (void 0 === e && (e = "click"), !$9052383c1c4e5569$var$Lr(t.target) && $9052383c1c4e5569$var$ga(t)) {
                var r = this.Mo(t, e);
                null != (i = this.rageclicks) && i.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && $9052383c1c4e5569$var$rs($9052383c1c4e5569$var$Yr(t), this.instance.config.rageclick) && this.Ro($9052383c1c4e5569$var$f({}, r, {
                    type: "rageclick"
                })), this.Ro(r);
            }
        }
        Co(t) {
            !$9052383c1c4e5569$var$Lr(t.target) && $9052383c1c4e5569$var$ga(t) && (clearTimeout(this.Eo), this.Eo = setTimeout(()=>{
                this.Ro(this.Mo(t, "mousemove"));
            }, 500));
        }
        Ro(e) {
            if ($9052383c1c4e5569$var$t) {
                var i = $9052383c1c4e5569$var$t.location.href, r = this.qt.custom_personal_data_properties, s = this.qt.mask_personal_data_properties ? [
                    ...$9052383c1c4e5569$var$Ns,
                    ...r || []
                ] : [], n = $9052383c1c4e5569$var$Fs(i, s, $9052383c1c4e5569$var$Us);
                this.M = this.M || {}, this.M[n] || (this.M[n] = []), this.M[n].push(e);
            }
        }
        ci() {
            this.M && !$9052383c1c4e5569$var$L(this.M) && this.instance.capture("$$heatmap", {
                $heatmap_data: this.getAndClearBuffer()
            });
        }
    },
    deadClicksAutocapture: $9052383c1c4e5569$var$xs,
    webVitalsAutocapture: class {
        constructor(t){
            var e;
            this.mo = !1, this.so = !1, this.M = {
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            }, this.Po = ()=>{
                clearTimeout(this.Oo), 0 !== this.M.metrics.length && (this._instance.capture("$web_vitals", this.M.metrics.reduce((t, e)=>$9052383c1c4e5569$var$f({}, t, {
                        ["$web_vitals_" + e.name + "_event"]: $9052383c1c4e5569$var$f({}, e),
                        ["$web_vitals_" + e.name + "_value"]: e.value
                    }), {})), this.M = {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                });
            }, this.ht = (t)=>{
                var e;
                this.M = this.M || {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                };
                var i = this.Lo();
                if (!$9052383c1c4e5569$var$U(i)) {
                    if ($9052383c1c4e5569$var$H(null == t ? void 0 : t.name) || $9052383c1c4e5569$var$H(null == t ? void 0 : t.value)) $9052383c1c4e5569$var$la.error("Invalid metric received", t);
                    else if (!this.Ao || this.Ao > t.value) {
                        this.M.url !== i && (this.Po(), this.Oo = setTimeout(this.Po, this.flushToCaptureTimeoutMs)), $9052383c1c4e5569$var$U(this.M.url) && (this.M.url = i), this.M.firstMetricTimestamp = $9052383c1c4e5569$var$U(this.M.firstMetricTimestamp) ? Date.now() : this.M.firstMetricTimestamp, t.attribution && t.attribution.interactionTargetElement && (t.attribution.interactionTargetElement = void 0);
                        var r = null == (e = this._instance.sessionManager) ? void 0 : e.checkAndGetSessionAndWindowId(!0), s = $9052383c1c4e5569$var$f({}, t, {
                            $current_url: i,
                            timestamp: Date.now()
                        });
                        $9052383c1c4e5569$var$U(r) || (s.$session_id = r.sessionId, s.$window_id = r.windowId), this.M.metrics.push(s), this.M.metrics.length === this.allowedMetrics.length && this.Po();
                    } else $9052383c1c4e5569$var$la.error("Ignoring metric with value >= " + this.Ao, t);
                }
            }, this.Fo = ()=>{
                if (!this.so) {
                    var t, e, i, r, s = $9052383c1c4e5569$var$h.__PosthogExtensions__;
                    $9052383c1c4e5569$var$U(s) || $9052383c1c4e5569$var$U(s.postHogWebVitalsCallbacks) || ({ onLCP: t, onCLS: e, onFCP: i, onINP: r } = s.postHogWebVitalsCallbacks), t && e && i && r ? (this.allowedMetrics.indexOf("LCP") > -1 && t(this.ht.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && e(this.ht.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && i(this.ht.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && r(this.ht.bind(this)), this.so = !0) : $9052383c1c4e5569$var$la.error("web vitals callbacks not loaded - not starting");
                }
            }, this._instance = t, this.mo = !(null == (e = this._instance.persistence) || !e.props[$9052383c1c4e5569$var$oi]), this.startIfEnabled();
        }
        get No() {
            return this._instance.config.capture_performance;
        }
        get allowedMetrics() {
            var t, e, i = $9052383c1c4e5569$var$N(this.No) ? null == (t = this.No) ? void 0 : t.web_vitals_allowed_metrics : void 0;
            return $9052383c1c4e5569$var$H(i) ? (null == (e = this._instance.persistence) ? void 0 : e.props[$9052383c1c4e5569$var$ui]) || [
                "CLS",
                "FCP",
                "INP",
                "LCP"
            ] : i;
        }
        get flushToCaptureTimeoutMs() {
            return ($9052383c1c4e5569$var$N(this.No) ? this.No.web_vitals_delayed_flush_ms : void 0) || 5e3;
        }
        get useAttribution() {
            var t = $9052383c1c4e5569$var$N(this.No) ? this.No.web_vitals_attribution : void 0;
            return null != t && t;
        }
        get Ao() {
            var t = $9052383c1c4e5569$var$N(this.No) && $9052383c1c4e5569$var$V(this.No.__web_vitals_max_value) ? this.No.__web_vitals_max_value : $9052383c1c4e5569$var$ua;
            return t > 0 && 6e4 >= t ? $9052383c1c4e5569$var$ua : t;
        }
        get isEnabled() {
            var t = null == $9052383c1c4e5569$var$s ? void 0 : $9052383c1c4e5569$var$s.protocol;
            if ("http:" !== t && "https:" !== t) return $9052383c1c4e5569$var$la.info("Web Vitals are disabled on non-http/https protocols"), !1;
            var e = $9052383c1c4e5569$var$N(this.No) ? this.No.web_vitals : $9052383c1c4e5569$var$G(this.No) ? this.No : void 0;
            return $9052383c1c4e5569$var$G(e) ? e : this.mo;
        }
        startIfEnabled() {
            this.isEnabled && !this.so && ($9052383c1c4e5569$var$la.info("enabled, starting..."), this.ur(this.Fo));
        }
        onRemoteConfig(t) {
            if ("capturePerformance" in t) {
                var e = $9052383c1c4e5569$var$N(t.capturePerformance) && !!t.capturePerformance.web_vitals, i = $9052383c1c4e5569$var$N(t.capturePerformance) ? t.capturePerformance.web_vitals_allowed_metrics : void 0;
                this._instance.persistence && (this._instance.persistence.register({
                    [$9052383c1c4e5569$var$oi]: e
                }), this._instance.persistence.register({
                    [$9052383c1c4e5569$var$ui]: i
                })), this.mo = e, this.startIfEnabled();
            }
        }
        ur(t) {
            var e, i;
            null != (e = $9052383c1c4e5569$var$h.__PosthogExtensions__) && e.postHogWebVitalsCallbacks ? t() : null == (i = $9052383c1c4e5569$var$h.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, this.useAttribution ? "web-vitals-with-attribution" : "web-vitals", (e)=>{
                e ? $9052383c1c4e5569$var$la.error("failed to load script", e) : t();
            });
        }
        Lo() {
            var e = $9052383c1c4e5569$var$t ? $9052383c1c4e5569$var$t.location.href : void 0;
            if (e) {
                var i = this._instance.config.custom_personal_data_properties, r = this._instance.config.mask_personal_data_properties ? [
                    ...$9052383c1c4e5569$var$Ns,
                    ...i || []
                ] : [];
                return $9052383c1c4e5569$var$Fs(e, r, $9052383c1c4e5569$var$Us);
            }
            $9052383c1c4e5569$var$la.error("Could not determine current URL");
        }
    }
}, $9052383c1c4e5569$var$Ga = {
    exceptionObserver: class {
        constructor(e){
            var i, r, s;
            this.Fo = ()=>{
                var e;
                if ($9052383c1c4e5569$var$t && this.isEnabled && null != (e = $9052383c1c4e5569$var$h.__PosthogExtensions__) && e.errorWrappingFunctions) {
                    var i = $9052383c1c4e5569$var$h.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, r = $9052383c1c4e5569$var$h.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, s = $9052383c1c4e5569$var$h.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
                    try {
                        !this.Do && this.qt.capture_unhandled_errors && (this.Do = i(this.captureException.bind(this))), !this.$o && this.qt.capture_unhandled_rejections && (this.$o = r(this.captureException.bind(this))), !this.qo && this.qt.capture_console_errors && (this.qo = s(this.captureException.bind(this)));
                    } catch (t) {
                        $9052383c1c4e5569$var$oa.error("failed to start", t), this.jo();
                    }
                }
            }, this._instance = e, this.Bo = !(null == (i = this._instance.persistence) || !i.props[$9052383c1c4e5569$var$ri]), this.Ho = new $9052383c1c4e5569$var$it({
                refillRate: null !== (r = this._instance.config.error_tracking.__exceptionRateLimiterRefillRate) && void 0 !== r ? r : 1,
                bucketSize: null !== (s = this._instance.config.error_tracking.__exceptionRateLimiterBucketSize) && void 0 !== s ? s : 10,
                refillInterval: 1e4,
                Zt: $9052383c1c4e5569$var$oa
            }), this.qt = this.Uo(), this.startIfEnabledOrStop();
        }
        Uo() {
            var t = this._instance.config.capture_exceptions, e = {
                capture_unhandled_errors: !1,
                capture_unhandled_rejections: !1,
                capture_console_errors: !1
            };
            return $9052383c1c4e5569$var$N(t) ? e = $9052383c1c4e5569$var$f({}, e, t) : ($9052383c1c4e5569$var$U(t) ? this.Bo : t) && (e = $9052383c1c4e5569$var$f({}, e, {
                capture_unhandled_errors: !0,
                capture_unhandled_rejections: !0
            })), e;
        }
        get isEnabled() {
            return this.qt.capture_console_errors || this.qt.capture_unhandled_errors || this.qt.capture_unhandled_rejections;
        }
        startIfEnabledOrStop() {
            this.isEnabled ? ($9052383c1c4e5569$var$oa.info("enabled"), this.jo(), this.ur(this.Fo)) : this.jo();
        }
        ur(t) {
            var e, i;
            null != (e = $9052383c1c4e5569$var$h.__PosthogExtensions__) && e.errorWrappingFunctions && t(), null == (i = $9052383c1c4e5569$var$h.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, "exception-autocapture", (e)=>{
                if (e) return $9052383c1c4e5569$var$oa.error("failed to load script", e);
                t();
            });
        }
        jo() {
            var t, e, i;
            null == (t = this.Do) || t.call(this), this.Do = void 0, null == (e = this.$o) || e.call(this), this.$o = void 0, null == (i = this.qo) || i.call(this), this.qo = void 0;
        }
        onRemoteConfig(t) {
            "autocaptureExceptions" in t && (this.Bo = !!t.autocaptureExceptions || !1, this._instance.persistence && this._instance.persistence.register({
                [$9052383c1c4e5569$var$ri]: this.Bo
            }), this.qt = this.Uo(), this.startIfEnabledOrStop());
        }
        onConfigChange() {
            this.qt = this.Uo();
        }
        captureException(t) {
            var e, i, r, s = null !== (e = null == t || null == (i = t.$exception_list) || null == (i = i[0]) ? void 0 : i.type) && void 0 !== e ? e : "Exception";
            this.Ho.consumeRateLimit(s) ? $9052383c1c4e5569$var$oa.info("Skipping exception capture because of client rate limiting.", {
                exception: s
            }) : null == (r = this._instance.exceptions) || r.sendExceptionEvent(t);
        }
    },
    exceptions: class {
        constructor(t){
            var e, i;
            this.zo = [], this.Vo = new $9052383c1c4e5569$var$_e([
                new $9052383c1c4e5569$var$Re,
                new $9052383c1c4e5569$var$Le,
                new $9052383c1c4e5569$var$Oe,
                new $9052383c1c4e5569$var$Pe,
                new $9052383c1c4e5569$var$De,
                new $9052383c1c4e5569$var$Me,
                new $9052383c1c4e5569$var$Ce,
                new $9052383c1c4e5569$var$Ne
            ], function(t) {
                for(var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), r = 1; e > r; r++)i[r - 1] = arguments[r];
                return function(e, r) {
                    void 0 === r && (r = 0);
                    for(var s = [], n = e.split("\n"), o = r; n.length > o; o++){
                        var a = n[o];
                        if (1024 >= a.length) {
                            var l = $9052383c1c4e5569$var$ke.test(a) ? a.replace($9052383c1c4e5569$var$ke, "$1") : a;
                            if (!l.match(/\S*Error: /)) {
                                for (var u of i){
                                    var h = u(l, t);
                                    if (h) {
                                        s.push(h);
                                        break;
                                    }
                                }
                                if (s.length >= 50) break;
                            }
                        }
                    }
                    return function(t) {
                        if (!t.length) return [];
                        var e = Array.from(t);
                        return e.reverse(), e.slice(0, 50).map((t)=>{
                            var i;
                            return $9052383c1c4e5569$var$f({}, t, {
                                filename: t.filename || (i = e, i[i.length - 1] || {}).filename,
                                function: t.function || $9052383c1c4e5569$var$ge
                            });
                        });
                    }(s);
                };
            }("web:javascript", $9052383c1c4e5569$var$Ee, $9052383c1c4e5569$var$Te)), this._instance = t, this.zo = null !== (e = null == (i = this._instance.persistence) ? void 0 : i.get_property($9052383c1c4e5569$var$si)) && void 0 !== e ? e : [], this.Wo = $9052383c1c4e5569$var$He(this.Go()), this.Zo = new $9052383c1c4e5569$var$Ve(this.Wo);
        }
        onConfigChange() {
            this.Wo = $9052383c1c4e5569$var$He(this.Go()), this.Zo.setConfig(this.Wo);
        }
        onRemoteConfig(t) {
            var e, i, r;
            if ("errorTracking" in t) {
                var s = null !== (e = null == (i = t.errorTracking) ? void 0 : i.suppressionRules) && void 0 !== e ? e : [], n = null == (r = t.errorTracking) ? void 0 : r.captureExtensionExceptions;
                this.zo = s, this._instance.persistence && this._instance.persistence.register({
                    [$9052383c1c4e5569$var$si]: this.zo,
                    [$9052383c1c4e5569$var$ni]: n
                });
            }
        }
        get Qo() {
            var t, e = !!this._instance.get_property($9052383c1c4e5569$var$ni), i = this._instance.config.error_tracking.captureExtensionExceptions;
            return null !== (t = null != i ? i : e) && void 0 !== t && t;
        }
        buildProperties(t, e) {
            return this.Vo.buildFromUnknown(t, {
                syntheticException: null == e ? void 0 : e.syntheticException,
                mechanism: {
                    handled: null == e ? void 0 : e.handled
                }
            });
        }
        addExceptionStep(t, e) {
            if (this.Wo.enabled) try {
                if (!$9052383c1c4e5569$var$j(t) || 0 === t.trim().length) return void $9052383c1c4e5569$var$Na.warn("Ignoring exception step because message must be a non-empty string");
                var i = this.Jo(e), { sanitizedProperties: r, droppedKeys: s } = function(t) {
                    if (!t) return {
                        sanitizedProperties: {},
                        droppedKeys: []
                    };
                    var e = [];
                    return {
                        sanitizedProperties: Object.keys(t).reduce((i, r)=>$9052383c1c4e5569$var$ze.has(r) ? (e.push(r), i) : (i[r] = t[r], i), {}),
                        droppedKeys: e
                    };
                }(i);
                s.length > 0 && $9052383c1c4e5569$var$Na.warn("Ignoring reserved exception step fields", {
                    droppedKeys: s
                }), this.Zo.add($9052383c1c4e5569$var$f({
                    [$9052383c1c4e5569$var$Ue]: t,
                    [$9052383c1c4e5569$var$je]: (new Date).toISOString()
                }, r));
            } catch (t) {
                $9052383c1c4e5569$var$Na.error("Failed to add exception step. Ignoring breadcrumb.", t);
            }
        }
        sendExceptionEvent(t) {
            try {
                var e = t.$exception_list;
                if (this.Ko(e)) {
                    if (this.Yo(e)) return this.Xo("Exception dropped: matched a suppression rule"), void $9052383c1c4e5569$var$Na.info("Skipping exception capture because a suppression rule matched");
                    if (!this.Qo && this.ea(e)) return this.Xo("Exception dropped: thrown by a browser extension"), void $9052383c1c4e5569$var$Na.info("Skipping exception capture because it was thrown by an extension");
                    if (!this._instance.config.error_tracking.__capturePostHogExceptions && this.ta(e)) return this.Xo("Exception dropped: thrown by the PostHog SDK"), void $9052383c1c4e5569$var$Na.info("Skipping exception capture because it was thrown by the PostHog SDK");
                }
                var i = this.Wo.enabled && $9052383c1c4e5569$var$H(t.$exception_steps) ? this.ra(t) : t;
                try {
                    var r = this._instance.capture("$exception", i, {
                        _noTruncate: !0,
                        _batchKey: "exceptionEvent",
                        Mn: !0
                    });
                    return r && this.Zo.clear(), r;
                } catch (t) {
                    return $9052383c1c4e5569$var$Na.error("Failed to capture exception event. Dropping this exception.", t), void this.Zo.clear();
                }
            } catch (t) {
                return void $9052383c1c4e5569$var$Na.error("Failed to process exception event. Ignoring this exception.", t);
            }
        }
        ra(t) {
            try {
                var e = this.Zo.getAttachable();
                return 0 === e.length ? t : $9052383c1c4e5569$var$f({}, t, {
                    $exception_steps: e
                });
            } catch (e) {
                return $9052383c1c4e5569$var$Na.error("Failed to read buffered exception steps. Capturing exception without steps.", e), t;
            }
        }
        Xo(t) {
            this.Wo.enabled && this.Zo.add({
                [$9052383c1c4e5569$var$Ue]: t,
                [$9052383c1c4e5569$var$je]: (new Date).toISOString()
            });
        }
        Jo(t) {
            return $9052383c1c4e5569$var$N(t) ? $9052383c1c4e5569$var$f({}, t) : {};
        }
        Go() {
            var t, e;
            return null !== (t = null == (e = this._instance.config.error_tracking) ? void 0 : e.exception_steps) && void 0 !== t ? t : {};
        }
        Yo(t) {
            if (0 === t.length) return !1;
            var e = t.reduce((t, e)=>{
                var { type: i, value: r } = e;
                return $9052383c1c4e5569$var$j(i) && i.length > 0 && t.$exception_types.push(i), $9052383c1c4e5569$var$j(r) && r.length > 0 && t.$exception_values.push(r), t;
            }, {
                $exception_types: [],
                $exception_values: []
            });
            return this.zo.some((t)=>{
                var i = t.values.map((t)=>{
                    var i, r = $9052383c1c4e5569$var$$o[t.operator], s = $9052383c1c4e5569$var$M(t.value) ? t.value : [
                        t.value
                    ], n = null !== (i = e[t.key]) && void 0 !== i ? i : [];
                    return s.length > 0 && r(s, n);
                });
                return "OR" === t.type ? i.some(Boolean) : i.every(Boolean);
            });
        }
        ea(t) {
            return t.flatMap((t)=>{
                var e, i;
                return null !== (e = null == (i = t.stacktrace) ? void 0 : i.frames) && void 0 !== e ? e : [];
            }).some((t)=>t.filename && t.filename.startsWith("chrome-extension://"));
        }
        ta(t) {
            if (t.length > 0) {
                var e, i, r, s, n = null !== (e = null == (i = t[0].stacktrace) ? void 0 : i.frames) && void 0 !== e ? e : [], o = n[n.length - 1];
                return null !== (r = null == o || null == (s = o.filename) ? void 0 : s.includes("posthog.com/static")) && void 0 !== r && r;
            }
            return !1;
        }
        Ko(t) {
            return !$9052383c1c4e5569$var$H(t) && $9052383c1c4e5569$var$M(t);
        }
    }
}, $9052383c1c4e5569$var$Wa = $9052383c1c4e5569$var$f({
    productTours: class {
        get Si() {
            return this._instance.persistence;
        }
        constructor(t){
            this.ia = null, this.na = null, this._instance = t;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if ("productTours" in t) {
                var e, i;
                if (this.Si && this.Si.register({
                    [$9052383c1c4e5569$var$li]: !!t.productTours
                }), !$9052383c1c4e5569$var$ba(this._instance)) return !this.ia && $9052383c1c4e5569$var$H(null == (e = this.Si) ? void 0 : e.props[$9052383c1c4e5569$var$Ii]) || $9052383c1c4e5569$var$ma.info("product tours disabled; stopping and clearing cached tours"), null == (i = this.ia) || i.stop(), this.ia = null, void this.clearCache();
                this.loadIfEnabled();
            }
        }
        loadIfEnabled() {
            !this.ia && $9052383c1c4e5569$var$ba(this._instance) && this.ur(()=>this.sa());
        }
        ur(t) {
            var e, i;
            null != (e = $9052383c1c4e5569$var$h.__PosthogExtensions__) && e.generateProductTours ? t() : null == (i = $9052383c1c4e5569$var$h.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, "product-tours", (e)=>{
                e ? $9052383c1c4e5569$var$ma.error("Could not load product tours script", e) : t();
            });
        }
        sa() {
            var t;
            !this.ia && null != (t = $9052383c1c4e5569$var$h.__PosthogExtensions__) && t.generateProductTours && (this.ia = $9052383c1c4e5569$var$h.__PosthogExtensions__.generateProductTours(this._instance, !0));
        }
        getProductTours(t, e) {
            if (void 0 === e && (e = !1), !$9052383c1c4e5569$var$M(this.na) || e) {
                var i = this.Si;
                if (i) {
                    var r = i.props[$9052383c1c4e5569$var$Ii];
                    if ($9052383c1c4e5569$var$M(r) && !e) return this.na = r, void t(r, {
                        isLoaded: !0
                    });
                }
                this._instance._send_request({
                    url: this._instance.requestRouter.endpointFor("api", "/api/product_tours/?token=" + this._instance.config.token),
                    method: "GET",
                    callback: (e)=>{
                        if ($9052383c1c4e5569$var$ba(this._instance)) {
                            var r = e.statusCode;
                            if (200 !== r || !e.json) {
                                var s = "Product Tours API could not be loaded, status: " + r;
                                return $9052383c1c4e5569$var$ma.error(s), void t([], {
                                    isLoaded: !1,
                                    error: s
                                });
                            }
                            var n = $9052383c1c4e5569$var$M(e.json.product_tours) ? e.json.product_tours : [];
                            this.na = n, i && i.register({
                                [$9052383c1c4e5569$var$Ii]: n
                            }), t(n, {
                                isLoaded: !0
                            });
                        } else t([], {
                            isLoaded: !0
                        });
                    }
                });
            } else t(this.na, {
                isLoaded: !0
            });
        }
        getActiveProductTours(t) {
            $9052383c1c4e5569$var$H(this.ia) ? t([], {
                isLoaded: !1,
                error: "Product tours not loaded"
            }) : this.ia.getActiveProductTours(t);
        }
        showProductTour(t) {
            var e;
            null == (e = this.ia) || e.showTourById(t);
        }
        previewTour(t) {
            this.ia ? this.ia.previewTour(t) : this.ur(()=>{
                var e;
                this.sa(), null == (e = this.ia) || e.previewTour(t);
            });
        }
        dismissProductTour() {
            var t;
            null == (t = this.ia) || t.dismissTour("user_clicked_skip");
        }
        nextStep() {
            var t;
            null == (t = this.ia) || t.nextStep();
        }
        previousStep() {
            var t;
            null == (t = this.ia) || t.previousStep();
        }
        clearCache() {
            var t;
            this.na = null, null == (t = this.Si) || t.unregister($9052383c1c4e5569$var$Ii);
        }
        resetTour(t) {
            var e;
            null == (e = this.ia) || e.resetTour(t);
        }
        resetAllTours() {
            var t;
            null == (t = this.ia) || t.resetAllTours();
        }
        cancelPendingTour(t) {
            var e;
            null == (e = this.ia) || e.cancelPendingTour(t);
        }
    }
}, $9052383c1c4e5569$var$Ha), $9052383c1c4e5569$var$Ya = {
    siteApps: class {
        constructor(t){
            this._instance = t, this.oa = [], this.apps = {};
        }
        get isEnabled() {
            return !!this._instance.config.opt_in_site_apps;
        }
        aa(t, e) {
            if (e) {
                var i = this.globalsForEvent(e);
                this.oa.push(i), this.oa.length > 1e3 && (this.oa = this.oa.slice(10));
            }
        }
        get siteAppLoaders() {
            var t;
            return null == (t = $9052383c1c4e5569$var$h._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.siteApps;
        }
        initialize() {
            if (this.isEnabled) {
                var t = this._instance._addCaptureHook(this.aa.bind(this));
                this.la = ()=>{
                    t(), this.oa = [], this.la = void 0;
                };
            }
        }
        globalsForEvent(t) {
            var e, i, r, s, n, o, a;
            if (!t) throw new Error("Event payload is required");
            var l = {}, u = this._instance.get_property("$groups") || [], h = this._instance.get_property("$stored_group_properties") || {};
            for (var [d, v] of Object.entries(h))l[d] = {
                id: u[d],
                type: d,
                properties: v
            };
            var { $set_once: c, $set: p } = t;
            return {
                event: $9052383c1c4e5569$var$f({}, $9052383c1c4e5569$var$_(t, $9052383c1c4e5569$var$ya), {
                    properties: $9052383c1c4e5569$var$f({}, t.properties, p ? {
                        $set: $9052383c1c4e5569$var$f({}, null !== (e = null == (i = t.properties) ? void 0 : i.$set) && void 0 !== e ? e : {}, p)
                    } : {}, c ? {
                        $set_once: $9052383c1c4e5569$var$f({}, null !== (r = null == (s = t.properties) ? void 0 : s.$set_once) && void 0 !== r ? r : {}, c)
                    } : {}),
                    elements_chain: null !== (n = null == (o = t.properties) ? void 0 : o.$elements_chain) && void 0 !== n ? n : "",
                    distinct_id: null == (a = t.properties) ? void 0 : a.distinct_id
                }),
                person: {
                    properties: this._instance.get_property("$stored_person_properties")
                },
                groups: l
            };
        }
        setupSiteApp(t) {
            var e = this.apps[t.id], i = ()=>{
                var i;
                !e.errored && this.oa.length && ($9052383c1c4e5569$var$wa.info("Processing " + this.oa.length + " events for site app with id " + t.id), this.oa.forEach((t)=>null == e.processEvent ? void 0 : e.processEvent(t)), e.processedBuffer = !0), Object.values(this.apps).every((t)=>t.processedBuffer || t.errored) && (null == (i = this.la) || i.call(this));
            }, r = !1, s = (s)=>{
                e.errored = !s, e.loaded = !0, $9052383c1c4e5569$var$wa.info("Site app with id " + t.id + " " + (s ? "loaded" : "errored")), r && i();
            };
            try {
                var { processEvent: n } = t.init({
                    posthog: this._instance,
                    callback (t) {
                        s(t);
                    }
                });
                n && (e.processEvent = n), r = !0;
            } catch (e) {
                $9052383c1c4e5569$var$wa.error($9052383c1c4e5569$var$xa + t.id, e), s(!1);
            }
            if (r && e.loaded) try {
                i();
            } catch (i) {
                $9052383c1c4e5569$var$wa.error("Error while processing buffered events PostHog app with config id " + t.id, i), e.errored = !0;
            }
        }
        ua() {
            var t = this.siteAppLoaders || [];
            for (var e of t)this.apps[e.id] = {
                id: e.id,
                loaded: !1,
                errored: !1,
                processedBuffer: !1
            };
            for (var i of t)this.setupSiteApp(i);
        }
        ha(t) {
            if (0 !== Object.keys(this.apps).length) {
                var e = this.globalsForEvent(t);
                for (var i of Object.values(this.apps))try {
                    null == i.processEvent || i.processEvent(e);
                } catch (e) {
                    $9052383c1c4e5569$var$wa.error("Error while processing event " + t.event + " for site app " + i.id, e);
                }
            }
        }
        onRemoteConfig(t) {
            var e, i, r, s = this;
            if (null != (e = this.siteAppLoaders) && e.length) return this.isEnabled ? (this.ua(), void this._instance.on("eventCaptured", (t)=>this.ha(t))) : void $9052383c1c4e5569$var$wa.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
            if (null == (i = this.la) || i.call(this), null != (r = t.siteApps) && r.length) {
                if (this.isEnabled) {
                    var n = function(t) {
                        var e;
                        $9052383c1c4e5569$var$h["__$$ph_site_app_" + t] = s._instance, null == (e = $9052383c1c4e5569$var$h.__PosthogExtensions__) || null == e.loadSiteApp || e.loadSiteApp(s._instance, a, (e)=>{
                            if (e) return $9052383c1c4e5569$var$wa.error($9052383c1c4e5569$var$xa + t, e);
                        });
                    };
                    for (var { id: o, url: a } of t.siteApps)n(o);
                } else $9052383c1c4e5569$var$wa.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
            }
        }
    }
}, $9052383c1c4e5569$var$Ja = {
    tracingHeaders: class {
        constructor(t){
            this.ca = void 0, this.da = void 0, this.va = void 0, this.Fo = ()=>{
                var t, e, i = this.fa();
                i ? ($9052383c1c4e5569$var$U(this.ca) && (this.ca = null == (t = $9052383c1c4e5569$var$h.__PosthogExtensions__) || null == (t = t.tracingHeadersPatchFns) ? void 0 : t._patchXHR(i, ()=>this._instance.get_distinct_id(), this._instance.sessionManager)), $9052383c1c4e5569$var$U(this.da) && (this.da = null == (e = $9052383c1c4e5569$var$h.__PosthogExtensions__) || null == (e = e.tracingHeadersPatchFns) ? void 0 : e._patchFetch(i, ()=>this._instance.get_distinct_id(), this._instance.sessionManager))) : this.jo();
            }, this._instance = t;
        }
        initialize() {
            this.startIfEnabledOrStop();
        }
        ur(t) {
            var e, i;
            null != (e = $9052383c1c4e5569$var$h.__PosthogExtensions__) && e.tracingHeadersPatchFns ? t() : null == (i = $9052383c1c4e5569$var$h.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, "tracing-headers", (e)=>{
                if (e) return $9052383c1c4e5569$var$aa.error("failed to load script", e);
                t();
            });
        }
        pa() {
            var t, e;
            return null !== (t = null !== (e = this._instance.config.tracing_headers) && void 0 !== e ? e : this._instance.config.addTracingHeaders) && void 0 !== t ? t : this._instance.config.__add_tracing_headers;
        }
        fa() {
            var t = this.pa();
            return $9052383c1c4e5569$var$M(t) ? ($9052383c1c4e5569$var$M(this.va) ? this.va.splice(0, this.va.length, ...t) : this.va = [
                ...t
            ], t.length > 0 ? this.va : void 0) : ($9052383c1c4e5569$var$M(this.va) && this.va.splice(0), this.va = t || void 0, this.va);
        }
        jo() {
            var t, e;
            null == (t = this.ca) || t.call(this), null == (e = this.da) || e.call(this), this.ca = void 0, this.da = void 0;
        }
        startIfEnabledOrStop() {
            this.fa() ? this.ur(this.Fo) : this.jo();
        }
    }
}, $9052383c1c4e5569$var$Ka = $9052383c1c4e5569$var$f({
    surveys: class {
        get qt() {
            return this._instance.config;
        }
        constructor(t){
            this.ga = void 0, this._surveyManager = null, this.ma = !1, this.ya = [], this.ba = null, this._instance = t, this._surveyEventReceiver = null;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if (!this.qt.disable_surveys) {
                var e = t.surveys;
                if ($9052383c1c4e5569$var$H(e)) return $9052383c1c4e5569$var$Co.warn("Flags not loaded yet. Not loading surveys.");
                var i = $9052383c1c4e5569$var$M(e);
                this.ga = i ? e.length > 0 : e, $9052383c1c4e5569$var$Co.info("flags response received, isSurveysEnabled: " + this.ga), this.loadIfEnabled();
            }
        }
        reset() {
            try {
                localStorage.removeItem("lastSeenSurveyDate");
                for(var t = [], e = 0; e < localStorage.length; e++){
                    var i = localStorage.key(e);
                    (null != i && i.startsWith($9052383c1c4e5569$var$Ao) || null != i && i.startsWith("inProgressSurvey_")) && t.push(i);
                }
                t.forEach((t)=>localStorage.removeItem(t));
            } catch (t) {}
        }
        loadIfEnabled() {
            if (!this._surveyManager) {
                if (this.ma) $9052383c1c4e5569$var$Co.info("Already initializing surveys, skipping...");
                else if (this.qt.disable_surveys) $9052383c1c4e5569$var$Co.info($9052383c1c4e5569$var$Ra);
                else if (this.qt.cookieless_mode && this._instance.consent.isOptedOut()) $9052383c1c4e5569$var$Co.info("Not loading surveys in cookieless mode without consent.");
                else {
                    var t = null == $9052383c1c4e5569$var$h ? void 0 : $9052383c1c4e5569$var$h.__PosthogExtensions__;
                    if (t) {
                        if (!$9052383c1c4e5569$var$U(this.ga) || this.qt.advanced_enable_surveys) {
                            var e = this.ga || this.qt.advanced_enable_surveys;
                            this.ma = !0;
                            try {
                                var i = t.generateSurveys;
                                if (i) return void this._a(i, e);
                                var r = t.loadExternalDependency;
                                if (!r) return void this.wa($9052383c1c4e5569$var$Yi);
                                r(this._instance, "surveys", (i)=>{
                                    i || !t.generateSurveys ? this.wa("Could not load surveys script", i) : this._a(t.generateSurveys, e);
                                });
                            } catch (t) {
                                throw this.wa("Error initializing surveys", t), t;
                            } finally{
                                this.ma = !1;
                            }
                        }
                    } else $9052383c1c4e5569$var$Co.error("PostHog Extensions not found.");
                }
            }
        }
        _a(t, e) {
            this._surveyManager = t(this._instance, e), this._surveyEventReceiver = new $9052383c1c4e5569$var$Ta(this._instance), $9052383c1c4e5569$var$Co.info("Surveys loaded successfully"), this.xa({
                isLoaded: !0
            });
        }
        wa(t, e) {
            $9052383c1c4e5569$var$Co.error(t, e), this.xa({
                isLoaded: !1,
                error: t
            });
        }
        onSurveysLoaded(t) {
            return this.ya.push(t), this._surveyManager && this.xa({
                isLoaded: !0
            }), ()=>{
                this.ya = this.ya.filter((e)=>e !== t);
            };
        }
        getSurveys(t, e) {
            if (void 0 === e && (e = !1), this.qt.disable_surveys) return $9052383c1c4e5569$var$Co.info($9052383c1c4e5569$var$Ra), t([]);
            var i, r = this._instance.get_property($9052383c1c4e5569$var$Ri);
            if (r && !e) return t(r, {
                isLoaded: !0
            });
            "undefined" != typeof Promise && this.ba ? this.ba.then((e)=>{
                var { surveys: i, context: r } = e;
                return t(i, r);
            }) : ("undefined" != typeof Promise && (this.ba = new Promise((t)=>{
                i = t;
            })), this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", "/api/surveys/?token=" + this.qt.token),
                method: "GET",
                timeout: this.qt.surveys_request_timeout_ms,
                callback: (e)=>{
                    var r;
                    this.ba = null;
                    var s = e.statusCode;
                    if (200 !== s || !e.json) {
                        var n = "Surveys API could not be loaded, status: " + s;
                        $9052383c1c4e5569$var$Co.error(n);
                        var o = {
                            isLoaded: !1,
                            error: n
                        };
                        return t([], o), void (null == i || i({
                            surveys: [],
                            context: o
                        }));
                    }
                    var a, l = e.json.surveys || [], u = l.filter((t)=>(function(t) {
                            return !(!t.start_date || t.end_date);
                        })(t) && (function(t) {
                            var e;
                            return !(null == (e = t.conditions) || null == (e = e.events) || null == (e = e.values) || !e.length);
                        }(t) || function(t) {
                            var e;
                            return !(null == (e = t.conditions) || null == (e = e.actions) || null == (e = e.values) || !e.length);
                        }(t)));
                    u.length > 0 && (null == (a = this._surveyEventReceiver) || a.register(u)), null == (r = this._instance.persistence) || r.register({
                        [$9052383c1c4e5569$var$Ri]: l,
                        [$9052383c1c4e5569$var$Pi]: Date.now()
                    });
                    var h = {
                        isLoaded: !0
                    };
                    t(l, h), null == i || i({
                        surveys: l,
                        context: h
                    });
                }
            }));
        }
        xa(t) {
            for (var e of this.ya)try {
                if (!t.isLoaded) return e([], t);
                this.getSurveys(e);
            } catch (t) {
                $9052383c1c4e5569$var$Co.error("Error in survey callback", t);
            }
        }
        getActiveMatchingSurveys(t, e) {
            if (void 0 === e && (e = !1), !$9052383c1c4e5569$var$H(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(t, e);
            $9052383c1c4e5569$var$Co.warn("init was not called");
        }
        ka(t) {
            var e = null;
            return this.getSurveys((i)=>{
                var r;
                e = null !== (r = i.find((e)=>e.id === t)) && void 0 !== r ? r : null;
            }), e;
        }
        Sa(t) {
            if ($9052383c1c4e5569$var$H(this._surveyManager)) return {
                eligible: !1,
                reason: $9052383c1c4e5569$var$ka
            };
            var e = "string" == typeof t ? this.ka(t) : t;
            return e ? this._surveyManager.checkSurveyEligibility(e) : {
                eligible: !1,
                reason: "Survey not found"
            };
        }
        canRenderSurvey(t) {
            if ($9052383c1c4e5569$var$H(this._surveyManager)) return $9052383c1c4e5569$var$Co.warn("init was not called"), {
                visible: !1,
                disabledReason: $9052383c1c4e5569$var$ka
            };
            var e = this.Sa(t);
            return {
                visible: e.eligible,
                disabledReason: e.reason
            };
        }
        canRenderSurveyAsync(t, e) {
            return $9052383c1c4e5569$var$H(this._surveyManager) ? ($9052383c1c4e5569$var$Co.warn("init was not called"), Promise.resolve({
                visible: !1,
                disabledReason: $9052383c1c4e5569$var$ka
            })) : new Promise((i)=>{
                this.getSurveys((e)=>{
                    var r, s = null !== (r = e.find((e)=>e.id === t)) && void 0 !== r ? r : null;
                    if (s) {
                        var n = this.Sa(s);
                        i({
                            visible: n.eligible,
                            disabledReason: n.reason
                        });
                    } else i({
                        visible: !1,
                        disabledReason: "Survey not found"
                    });
                }, e);
            });
        }
        renderSurvey(t, e, i) {
            var s;
            if ($9052383c1c4e5569$var$H(this._surveyManager)) $9052383c1c4e5569$var$Co.warn("init was not called");
            else {
                var n = "string" == typeof t ? this.ka(t) : t;
                if (null != n && n.id) {
                    if ($9052383c1c4e5569$var$Fo.includes(n.type)) {
                        var o = null == $9052383c1c4e5569$var$r ? void 0 : $9052383c1c4e5569$var$r.querySelector(e);
                        if (o) return null != (s = n.appearance) && s.surveyPopupDelaySeconds ? ($9052383c1c4e5569$var$Co.info("Rendering survey " + n.id + " with delay of " + n.appearance.surveyPopupDelaySeconds + " seconds"), void setTimeout(()=>{
                            var t, e;
                            $9052383c1c4e5569$var$Co.info("Rendering survey " + n.id + " with delay of " + (null == (t = n.appearance) ? void 0 : t.surveyPopupDelaySeconds) + " seconds"), null == (e = this._surveyManager) || e.renderSurvey(n, o, i), $9052383c1c4e5569$var$Co.info("Survey " + n.id + " rendered");
                        }, 1e3 * n.appearance.surveyPopupDelaySeconds)) : void this._surveyManager.renderSurvey(n, o, i);
                        $9052383c1c4e5569$var$Co.warn("Survey element not found");
                    } else $9052383c1c4e5569$var$Co.warn("Surveys of type " + n.type + " cannot be rendered in the app");
                } else $9052383c1c4e5569$var$Co.warn("Survey not found");
            }
        }
        displaySurvey(t, e) {
            var i;
            if ($9052383c1c4e5569$var$H(this._surveyManager)) $9052383c1c4e5569$var$Co.warn("init was not called");
            else {
                var r = this.ka(t);
                if (r) {
                    var s = r;
                    if (null != (i = r.appearance) && i.surveyPopupDelaySeconds && e.ignoreDelay && (s = $9052383c1c4e5569$var$f({}, r, {
                        appearance: $9052383c1c4e5569$var$f({}, r.appearance, {
                            surveyPopupDelaySeconds: 0
                        })
                    })), e.displayType !== $9052383c1c4e5569$export$a8a66d9d1b857494.Popover && e.initialResponses && $9052383c1c4e5569$var$Co.warn("initialResponses is only supported for popover surveys. prefill will not be applied."), !1 === e.ignoreConditions) {
                        var n = this.canRenderSurvey(r);
                        if (!n.visible) return void $9052383c1c4e5569$var$Co.warn("Survey is not eligible to be displayed: ", n.disabledReason);
                    }
                    e.displayType !== $9052383c1c4e5569$export$a8a66d9d1b857494.Inline ? this._surveyManager.handlePopoverSurvey(s, e) : this.renderSurvey(s, e.selector, e.properties);
                } else $9052383c1c4e5569$var$Co.warn("Survey not found");
            }
        }
        cancelPendingSurvey(t) {
            $9052383c1c4e5569$var$H(this._surveyManager) ? $9052383c1c4e5569$var$Co.warn("init was not called") : this._surveyManager.cancelSurvey(t);
        }
        handlePageUnload() {
            var t;
            null == (t = this._surveyManager) || t.handlePageUnload();
        }
    }
}, $9052383c1c4e5569$var$Ha), $9052383c1c4e5569$var$Xa = {
    toolbar: class {
        constructor(t){
            this.instance = t;
        }
        Ca(t) {
            $9052383c1c4e5569$var$h.ph_toolbar_state = t;
        }
        Ia() {
            var t;
            return null !== (t = $9052383c1c4e5569$var$h.ph_toolbar_state) && void 0 !== t ? t : 0;
        }
        initialize() {
            return this.maybeLoadToolbar();
        }
        maybeLoadToolbar(e, i, s) {
            if (void 0 === e && (e = void 0), void 0 === i && (i = void 0), void 0 === s && (s = void 0), $9052383c1c4e5569$var$_r(this.instance.config)) return !1;
            if (!$9052383c1c4e5569$var$t || !$9052383c1c4e5569$var$r) return !1;
            e = null != e ? e : $9052383c1c4e5569$var$t.location, s = null != s ? s : $9052383c1c4e5569$var$t.history;
            try {
                if (!i) {
                    try {
                        $9052383c1c4e5569$var$t.localStorage.setItem("test", "test"), $9052383c1c4e5569$var$t.localStorage.removeItem("test");
                    } catch (t) {
                        return !1;
                    }
                    i = null == $9052383c1c4e5569$var$t ? void 0 : $9052383c1c4e5569$var$t.localStorage;
                }
                var n, o = $9052383c1c4e5569$var$Pa || $9052383c1c4e5569$var$Ms(e.hash, "__posthog") || $9052383c1c4e5569$var$Ms(e.hash, "state"), a = o ? $9052383c1c4e5569$var$hr(()=>JSON.parse(atob(decodeURIComponent(o)))) || $9052383c1c4e5569$var$hr(()=>JSON.parse(decodeURIComponent(o))) : null;
                return a && "ph_authorize" === a.action ? ((n = a).source = "url", n && Object.keys(n).length > 0 && (a.desiredHash ? e.hash = a.desiredHash : s ? s.replaceState(s.state, "", e.pathname + e.search) : e.hash = "")) : ((n = JSON.parse(i.getItem($9052383c1c4e5569$var$Oa) || "{}")).source = "localstorage", delete n.userIntent), !(!n.token || this.instance.config.token !== n.token || (this.loadToolbar(n), 0));
            } catch (t) {
                return !1;
            }
        }
        Ta(t) {
            var e = $9052383c1c4e5569$var$h.ph_load_toolbar || $9052383c1c4e5569$var$h.ph_load_editor;
            !$9052383c1c4e5569$var$H(e) && $9052383c1c4e5569$var$D(e) ? e(t, this.instance) : $9052383c1c4e5569$var$Ia.warn("No toolbar load function found");
        }
        loadToolbar(e) {
            var i = !(null == $9052383c1c4e5569$var$r || !$9052383c1c4e5569$var$r.getElementById($9052383c1c4e5569$var$Hi));
            if (!$9052383c1c4e5569$var$t || i) return !1;
            var s = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, n = $9052383c1c4e5569$var$f({
                token: this.instance.config.token
            }, e, {
                apiURL: this.instance.requestRouter.endpointFor("ui")
            }, s ? {
                instrument: !1
            } : {});
            if ($9052383c1c4e5569$var$t.localStorage.setItem($9052383c1c4e5569$var$Oa, JSON.stringify($9052383c1c4e5569$var$f({}, n, {
                source: void 0
            }))), 2 === this.Ia()) this.Ta(n);
            else if (0 === this.Ia()) {
                var o;
                this.Ca(1), null == (o = $9052383c1c4e5569$var$h.__PosthogExtensions__) || null == o.loadExternalDependency || o.loadExternalDependency(this.instance, "toolbar", (t)=>{
                    if (t) return $9052383c1c4e5569$var$Ia.error("[Toolbar] Failed to load", t), void this.Ca(0);
                    this.Ca(2), this.Ta(n);
                }), $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$t, "turbolinks:load", ()=>{
                    this.Ca(0), this.loadToolbar(n);
                });
            }
            return !0;
        }
        Ea(t) {
            return this.loadToolbar(t);
        }
        maybeLoadEditor(t, e, i) {
            return void 0 === t && (t = void 0), void 0 === e && (e = void 0), void 0 === i && (i = void 0), this.maybeLoadToolbar(t, e, i);
        }
    }
}, $9052383c1c4e5569$var$Qa = $9052383c1c4e5569$var$f({
    experiments: $9052383c1c4e5569$var$ja
}, $9052383c1c4e5569$var$Ha), $9052383c1c4e5569$var$Za = {
    conversations: class {
        constructor(t){
            this.Ma = void 0, this._conversationsManager = null, this.Ra = !1, this.Pa = null, this._instance = t;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if (!this._instance.config.disable_conversations) {
                var e = t.conversations;
                $9052383c1c4e5569$var$H(e) || ($9052383c1c4e5569$var$G(e) ? this.Ma = e : (this.Ma = e.enabled, this.Pa = e), this.loadIfEnabled());
            }
        }
        reset() {
            var t;
            null == (t = this._conversationsManager) || t.reset(), this._conversationsManager = null, this.Ma = void 0, this.Pa = null;
        }
        loadIfEnabled() {
            if (!(this._conversationsManager || this.Ra || this._instance.config.disable_conversations || $9052383c1c4e5569$var$_r(this._instance.config) || this._instance.config.cookieless_mode && this._instance.consent.isOptedOut())) {
                var t = null == $9052383c1c4e5569$var$h ? void 0 : $9052383c1c4e5569$var$h.__PosthogExtensions__;
                if (t && !$9052383c1c4e5569$var$U(this.Ma) && this.Ma) {
                    if (this.Pa && this.Pa.token) {
                        this.Ra = !0;
                        try {
                            var e = t.initConversations;
                            if (e) return this.Oa(e), void (this.Ra = !1);
                            var i = t.loadExternalDependency;
                            if (!i) return void this.La($9052383c1c4e5569$var$Yi);
                            i(this._instance, "conversations", (e)=>{
                                e || !t.initConversations ? this.La("Could not load conversations script", e) : this.Oa(t.initConversations), this.Ra = !1;
                            });
                        } catch (t) {
                            this.La("Error initializing conversations", t), this.Ra = !1;
                        }
                    } else $9052383c1c4e5569$var$za.error("Conversations enabled but missing token in remote config.");
                }
            }
        }
        Oa(t) {
            if (this.Pa) try {
                this._conversationsManager = t(this.Pa, this._instance), $9052383c1c4e5569$var$za.info("Conversations loaded successfully");
            } catch (t) {
                this.La("Error completing conversations initialization", t);
            }
            else $9052383c1c4e5569$var$za.error("Cannot complete initialization: remote config is null");
        }
        La(t, e) {
            $9052383c1c4e5569$var$za.error(t, e), this._conversationsManager = null, this.Ra = !1;
        }
        show() {
            this._conversationsManager ? this._conversationsManager.show() : $9052383c1c4e5569$var$za.warn("Conversations not loaded yet.");
        }
        hide() {
            this._conversationsManager && this._conversationsManager.hide();
        }
        isAvailable() {
            return !0 === this.Ma && !$9052383c1c4e5569$var$B(this._conversationsManager);
        }
        isVisible() {
            var t, e;
            return null !== (t = null == (e = this._conversationsManager) ? void 0 : e.isVisible()) && void 0 !== t && t;
        }
        sendMessage(t, e, i) {
            var r = this;
            return $9052383c1c4e5569$var$p(function*() {
                return r._conversationsManager ? r._conversationsManager.sendMessage(t, e, i) : ($9052383c1c4e5569$var$za.warn($9052383c1c4e5569$var$Ba), null);
            })();
        }
        getMessages(t, e) {
            var i = this;
            return $9052383c1c4e5569$var$p(function*() {
                return i._conversationsManager ? i._conversationsManager.getMessages(t, e) : ($9052383c1c4e5569$var$za.warn($9052383c1c4e5569$var$Ba), null);
            })();
        }
        markAsRead(t) {
            var e = this;
            return $9052383c1c4e5569$var$p(function*() {
                return e._conversationsManager ? e._conversationsManager.markAsRead(t) : ($9052383c1c4e5569$var$za.warn($9052383c1c4e5569$var$Ba), null);
            })();
        }
        getTickets(t) {
            var e = this;
            return $9052383c1c4e5569$var$p(function*() {
                return e._conversationsManager ? e._conversationsManager.getTickets(t) : ($9052383c1c4e5569$var$za.warn($9052383c1c4e5569$var$Ba), null);
            })();
        }
        requestRestoreLink(t) {
            var e = this;
            return $9052383c1c4e5569$var$p(function*() {
                return e._conversationsManager ? e._conversationsManager.requestRestoreLink(t) : ($9052383c1c4e5569$var$za.warn($9052383c1c4e5569$var$Ba), null);
            })();
        }
        restoreFromToken(t) {
            var e = this;
            return $9052383c1c4e5569$var$p(function*() {
                return e._conversationsManager ? e._conversationsManager.restoreFromToken(t) : ($9052383c1c4e5569$var$za.warn($9052383c1c4e5569$var$Ba), null);
            })();
        }
        restoreFromUrlToken() {
            var t = this;
            return $9052383c1c4e5569$var$p(function*() {
                return t._conversationsManager ? t._conversationsManager.restoreFromUrlToken() : ($9052383c1c4e5569$var$za.warn($9052383c1c4e5569$var$Ba), null);
            })();
        }
        getCurrentTicketId() {
            var t, e;
            return null !== (t = null == (e = this._conversationsManager) ? void 0 : e.getCurrentTicketId()) && void 0 !== t ? t : null;
        }
        getWidgetSessionId() {
            var t, e;
            return null !== (t = null == (e = this._conversationsManager) ? void 0 : e.getWidgetSessionId()) && void 0 !== t ? t : null;
        }
        Nn() {
            var t;
            null == (t = this._conversationsManager) || t.setIdentity();
        }
        Dn() {
            var t;
            null == (t = this._conversationsManager) || t.clearIdentity();
        }
    }
}, $9052383c1c4e5569$var$tl = {
    logs: class {
        constructor(t){
            var e;
            this.Aa = !1, this.Fa = !1, this.Zt = $9052383c1c4e5569$var$Ye("[logs]"), this.Na = [], this.Da = 0, this.$a = 0, this.qa = !1, this._instance = t, this._instance && null != (e = this._instance.config.logs) && e.captureConsoleLogs && (this.Aa = !0);
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            var e, i = null == (e = t.logs) ? void 0 : e.captureConsoleLogs;
            !$9052383c1c4e5569$var$H(i) && i && (this.Aa = !0, this.loadIfEnabled());
        }
        reset() {
            this.Na = [], this.ii && (clearTimeout(this.ii), this.ii = void 0), this.Da = 0, this.$a = 0, this.qa = !1;
        }
        loadIfEnabled() {
            if (this.Aa && !this.Fa) {
                var t = null == $9052383c1c4e5569$var$h ? void 0 : $9052383c1c4e5569$var$h.__PosthogExtensions__;
                if (t) {
                    var e = t.loadExternalDependency;
                    e ? e(this._instance, "logs", (e)=>{
                        var i;
                        e || null == (i = t.logs) || !i.initializeLogs ? this.Zt.error("Could not load logs script", e) : (t.logs.initializeLogs(this._instance), this.Fa = !0);
                    }) : this.Zt.error($9052383c1c4e5569$var$Yi);
                } else this.Zt.error("PostHog Extensions not found.");
            }
        }
        captureLog(t) {
            var e, i, r, s, n, o;
            if (this._instance.is_capturing()) {
                if (t && t.body) {
                    var a = null !== (e = null == (i = this._instance.config.logs) ? void 0 : i.flushIntervalMs) && void 0 !== e ? e : 3e3, l = null !== (r = null == (s = this._instance.config.logs) ? void 0 : s.maxLogsPerInterval) && void 0 !== r ? r : 1e3, u = Date.now();
                    if (a > u - this.$a || (this.$a = u, this.Da = 0, this.qa = !1), l > this.Da) {
                        this.Da++;
                        var h = function(t, e) {
                            var i = t.level || "info", { text: r, number: s } = $9052383c1c4e5569$var$de[i] || $9052383c1c4e5569$var$ve, n = String(Date.now()) + "000000", o = {};
                            e.distinctId && (o.posthogDistinctId = e.distinctId), e.sessionId && (o.sessionId = e.sessionId), e.currentUrl && (o["url.full"] = e.currentUrl), e.screenName && (o["screen.name"] = e.screenName), e.appState && (o["app.state"] = e.appState), e.activeFeatureFlags && e.activeFeatureFlags.length > 0 && (o.feature_flags = e.activeFeatureFlags);
                            var a = $9052383c1c4e5569$var$f({}, o, t.attributes || {}), l = {
                                timeUnixNano: n,
                                observedTimeUnixNano: n,
                                severityNumber: s,
                                severityText: r,
                                body: {
                                    stringValue: t.body
                                },
                                attributes: $9052383c1c4e5569$var$pe(a)
                            };
                            return t.trace_id && (l.traceId = t.trace_id), t.span_id && (l.spanId = t.span_id), $9052383c1c4e5569$var$U(t.trace_flags) || (l.flags = t.trace_flags), l;
                        }(t, this.ja());
                        this.Na.push({
                            record: h
                        }), (null !== (n = null == (o = this._instance.config.logs) ? void 0 : o.maxBufferSize) && void 0 !== n ? n : 100) > this.Na.length ? this.Ba() : this.flushLogs();
                    } else this.qa || (this.Zt.warn("captureLog dropping logs: exceeded " + l + " logs per " + a + "ms"), this.qa = !0);
                } else this.Zt.warn("captureLog requires a body");
            }
        }
        get logger() {
            return this.Ha || (this.Ha = {
                trace: (t, e)=>this.captureLog({
                        body: t,
                        level: "trace",
                        attributes: e
                    }),
                debug: (t, e)=>this.captureLog({
                        body: t,
                        level: "debug",
                        attributes: e
                    }),
                info: (t, e)=>this.captureLog({
                        body: t,
                        level: "info",
                        attributes: e
                    }),
                warn: (t, e)=>this.captureLog({
                        body: t,
                        level: "warn",
                        attributes: e
                    }),
                error: (t, e)=>this.captureLog({
                        body: t,
                        level: "error",
                        attributes: e
                    }),
                fatal: (t, e)=>this.captureLog({
                        body: t,
                        level: "fatal",
                        attributes: e
                    })
            }), this.Ha;
        }
        flushLogs(t) {
            if (this.ii && (clearTimeout(this.ii), this.ii = void 0), 0 !== this.Na.length) {
                var e = this.Na;
                this.Na = [];
                var i = this._instance.config.logs, r = $9052383c1c4e5569$var$f({
                    "service.name": (null == i ? void 0 : i.serviceName) || "unknown_service"
                }, (null == i ? void 0 : i.environment) && {
                    "deployment.environment": i.environment
                }, (null == i ? void 0 : i.serviceVersion) && {
                    "service.version": i.serviceVersion
                }, null == i ? void 0 : i.resourceAttributes), s = function(t, e, i, r) {
                    return {
                        resourceLogs: [
                            {
                                resource: {
                                    attributes: $9052383c1c4e5569$var$pe(e)
                                },
                                scopeLogs: [
                                    {
                                        scope: {
                                            name: i,
                                            version: r
                                        },
                                        logRecords: t
                                    }
                                ]
                            }
                        ]
                    };
                }(e.map((t)=>t.record), r, $9052383c1c4e5569$var$v.LIB_NAME, $9052383c1c4e5569$var$v.LIB_VERSION), n = this._instance.requestRouter.endpointFor("api", "/i/v1/logs") + "?token=" + encodeURIComponent(this._instance.config.token);
                this._instance.yn({
                    method: "POST",
                    url: n,
                    data: s,
                    compression: "best-available",
                    batchKey: "logs",
                    transport: t
                });
            }
        }
        Ba() {
            var t, e;
            this.ii || (this.ii = setTimeout(()=>{
                this.ii = void 0, this.flushLogs();
            }, null !== (t = null == (e = this._instance.config.logs) ? void 0 : e.flushIntervalMs) && void 0 !== t ? t : 3e3));
        }
        ja() {
            var t, e = {};
            if (e.distinctId = this._instance.get_distinct_id(), this._instance.sessionManager) {
                var { sessionId: i } = this._instance.sessionManager.checkAndGetSessionAndWindowId(!0);
                e.sessionId = i;
            }
            if (null != $9052383c1c4e5569$var$h && null != (t = $9052383c1c4e5569$var$h.location) && t.href && (e.currentUrl = $9052383c1c4e5569$var$h.location.href), this._instance.featureFlags) {
                var r = this._instance.featureFlags.getFlags();
                r && r.length > 0 && (e.activeFeatureFlags = r);
            }
            return e;
        }
    }
}, $9052383c1c4e5569$var$el = $9052383c1c4e5569$var$f({}, $9052383c1c4e5569$var$Ha, $9052383c1c4e5569$var$Va, $9052383c1c4e5569$var$qa, $9052383c1c4e5569$var$Ga, $9052383c1c4e5569$var$Wa, $9052383c1c4e5569$var$Ya, $9052383c1c4e5569$var$Ka, $9052383c1c4e5569$var$Ja, $9052383c1c4e5569$var$Xa, $9052383c1c4e5569$var$Qa, $9052383c1c4e5569$var$Za, $9052383c1c4e5569$var$tl);
$9052383c1c4e5569$export$a9d6b9cbf49b8241.__defaultExtensionClasses = $9052383c1c4e5569$var$f({}, $9052383c1c4e5569$var$el);
var $9052383c1c4e5569$export$2e2bcd8739ae039 = function() {
    $9052383c1c4e5569$var$v.SDK_DIST_CHANNEL = "npm";
    var e = $9052383c1c4e5569$var$jo[$9052383c1c4e5569$var$Wo] = new $9052383c1c4e5569$export$a9d6b9cbf49b8241;
    return function() {
        function e() {
            e.done || (e.done = !0, $9052383c1c4e5569$var$Yo = !1, $9052383c1c4e5569$var$ar($9052383c1c4e5569$var$jo, function(t) {
                t._dom_loaded();
            }));
        }
        null != $9052383c1c4e5569$var$r && $9052383c1c4e5569$var$r.addEventListener ? "complete" === $9052383c1c4e5569$var$r.readyState ? e() : $9052383c1c4e5569$var$fr($9052383c1c4e5569$var$r, "DOMContentLoaded", e, {
            capture: !1
        }) : $9052383c1c4e5569$var$t && $9052383c1c4e5569$var$We.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
    }(), e;
}();

});


})();
//# sourceMappingURL=index.f3440bfa.js.map
